import type { GraphQLResolveInfo, GraphQLScalarType, GraphQLScalarTypeConfig } from 'graphql';
import type { ClientContext } from 'graphql/resolvers';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type RequireFields<T, K extends keyof T> = Omit<T, K> & { [P in K]-?: NonNullable<T[P]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** String representation of date/time in UTC zone, conforms to ISO 8601 */
  DateTime: { input: Date; output: Date; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any; }
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: { input: any; output: any; }
  UUID: { input: string; output: string; }
  /** The `Upload` scalar type represents a file upload. */
  Upload: { input: any; output: any; }
};

export type AccessLevel = {
  __typename?: 'AccessLevel';
  description: Scalars['String']['output'];
  level: Scalars['String']['output'];
  order: Scalars['Int']['output'];
};

export type AcknowledgeAuditEntryInput = {
  categoryId: Scalars['String']['input'];
  context: Scalars['ID']['input'];
  external?: InputMaybe<Scalars['Boolean']['input']>;
  modifiedAt: Scalars['DateTime']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  triggeredAt: Scalars['DateTime']['input'];
  witnesses: Array<Scalars['String']['input']>;
};

/** Entry for multiple acknowledge */
export type AcknowledgementEntry = {
  context: Scalars['ID']['input'];
  triggeredAt: Scalars['DateTime']['input'];
};

export type Action = {
  __typename?: 'Action';
  accessLevel: AccessLevel;
  action: Scalars['String']['output'];
  description: Scalars['String']['output'];
  deviceFunctionalAspectTypes: Array<DeviceFunctionalAspectType>;
  resourceTypes: Array<RealmObjectType>;
};

export enum ActivityId {
  About = 'About',
  Access = 'Access',
  Devices = 'Devices',
  Reports = 'Reports',
  Settings = 'Settings'
}

export type AddSharedViewInput = {
  layout?: InputMaybe<Scalars['String']['input']>;
  /**
   * Last known updatedAt timestamp for optimistic concurrency control.
   * Send null when no prior shared views state exists (first write).
   */
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  view: SharedViewInput;
};

export type AodRequest = {
  __typename?: 'AodRequest';
  avatarId: Scalars['ID']['output'];
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deviceId: Scalars['ID']['output'];
  downloaded?: Maybe<Scalars['Int']['output']>;
  endTime: Scalars['DateTime']['output'];
  eta?: Maybe<Scalars['Int']['output']>;
  eventId?: Maybe<Scalars['ID']['output']>;
  expiredAt?: Maybe<Scalars['DateTime']['output']>;
  files?: Maybe<AodRequestFiles>;
  id: Scalars['ID']['output'];
  note?: Maybe<Scalars['String']['output']>;
  realmId: Scalars['ID']['output'];
  size?: Maybe<Scalars['Float']['output']>;
  startTime: Scalars['DateTime']['output'];
  status: AodRequestStatus;
  streamNumber: Scalars['Int']['output'];
  type?: Maybe<AodRequestType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userId: Scalars['ID']['output'];
};

export type AodRequestFiles = {
  __typename?: 'AodRequestFiles';
  expired: Scalars['DateTime']['output'];
  list: Array<AodRequestFilesListEntry>;
};

export type AodRequestFilesListEntry = {
  __typename?: 'AodRequestFilesListEntry';
  endTime: Scalars['DateTime']['output'];
  href: Scalars['String']['output'];
  size: Scalars['Float']['output'];
  startTime: Scalars['DateTime']['output'];
};

export type AodRequestFilter = {
  /**  time interval in hours from the current one for which you need to receive updates  */
  interval: Scalars['Int']['input'];
};

export type AodRequestInput = {
  endTime: Scalars['DateTime']['input'];
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  obj: Scalars['ID']['input'];
  startTime: Scalars['DateTime']['input'];
};

export enum AodRequestStatus {
  Canceled = 'CANCELED',
  Completed = 'COMPLETED',
  Exporting = 'EXPORTING',
  Failed = 'FAILED',
  Paused = 'PAUSED',
  Processing = 'PROCESSING',
  Queued = 'QUEUED'
}

export enum AodRequestType {
  Auto = 'Auto',
  Manual = 'Manual'
}

export type AppStore = {
  __typename?: 'AppStore';
  branding?: Maybe<BrandingAttribute>;
  select?: Maybe<ObjUuid>;
  session: Session;
  socketEvent?: Maybe<SocketEvent>;
  workspace: Workspace;
};

export type AppStoreInput = {
  branding?: InputMaybe<BrandingAttributeInput>;
  select?: InputMaybe<ObjUuidInput>;
  session?: InputMaybe<SessionInput>;
  socketEvent?: InputMaybe<SocketEventInput>;
  workspace?: InputMaybe<WorkspaceInput>;
};

export type ArchiveBoundary = {
  __typename?: 'ArchiveBoundary';
  boundary?: Maybe<Scalars['DateTime']['output']>;
  timeInsideGap: Scalars['Boolean']['output'];
};

export type ArchiveCoverage = {
  __typename?: 'ArchiveCoverage';
  coverage: Array<ArchiveCoverageItem>;
  partialCoverage: Array<ArchiveCoverageItem>;
  ttl: Array<ArchiveCoverageTtl>;
};

export type ArchiveCoverageItem = {
  __typename?: 'ArchiveCoverageItem';
  deviceId: Scalars['ID']['output'];
  streamNumber: Scalars['Int']['output'];
  time: Scalars['Int']['output'];
};

export type ArchiveCoverageTtl = {
  __typename?: 'ArchiveCoverageTTL';
  deviceId: Scalars['ID']['output'];
  ttl: Scalars['Int']['output'];
};

export enum ArchiveLocation {
  Cloud = 'cloud',
  Local = 'local'
}

/** Aspect Health settings and status */
export type AspectHealth = {
  __typename?: 'AspectHealth';
  /** importance of the aspect for the device health (CRITICAL/NORMAL/...) */
  gravity: Fa_HealthGravity;
  /** Status can take values from HealthStatus enum (from "core") */
  healthStatus: HealthStatus;
  /** timeout (seconds) before declaring aspect unhealthy */
  livenessTimeout: Scalars['Int']['output'];
  /** timeout (seconds) after start before aspect is expected to perform normally */
  readinessTimeout: Scalars['Int']['output'];
};

/** Aspect Health settings and status */
export type AspectHealthFilter = {
  /** importance of the aspect for the device health (CRITICAL/NORMAL/...) */
  gravity?: InputMaybe<Fa_HealthGravity>;
  /** Status can take values from HealthStatus enum (from "core") */
  healthStatus?: InputMaybe<HealthStatus>;
};

export enum AspectSensorCategory {
  Door = 'Door',
  Fence = 'Fence',
  None = 'None',
  Radar = 'Radar'
}

export enum AspectSensorModel {
  Axis = 'Axis',
  CoT = 'CoT',
  Elta = 'Elta',
  External = 'External',
  Generic = 'Generic',
  Hikvision = 'Hikvision',
  Pathfinder = 'Pathfinder',
  Qortex = 'Qortex',
  Sintela = 'Sintela'
}

export type AssociatedGatewayDevice = {
  __typename?: 'AssociatedGatewayDevice';
  /**  List of Overcast devices mapped to gateway device id  */
  associatedDevices: Array<Scalars['String']['output']>;
  /**  Gateway device id  */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type AssociatedGatewayDeviceInput = {
  associatedDevices: Array<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/**
 * Audit entries are organized by Categories.
 * This is done in the way where the particular audit message is not reported by the actual message, but by numeric category.
 * One category entry may contain the parameterized message for multiple local languages in 'digest' attribute
 */
export type AuditCategory = {
  __typename?: 'AuditCategory';
  /**  JSON stored in a string, encoding parametrized messages for various localities, i.e. '{"en-us": "%1 stream request"}'  */
  digest: Scalars['String']['output'];
  /**  Numeric ID in underlying implementation  */
  id: Scalars['ID']['output'];
  /**  categories grouped by scope, parent is NULL for the first level category that cannot have events   */
  parent?: Maybe<Scalars['ID']['output']>;
  /**  Field contains the info for generic identification  */
  shortName: Scalars['String']['output'];
};

/** Audit entry provides the information for one audit event */
export type AuditEntry = {
  __typename?: 'AuditEntry';
  /**  The reference to the AuditCategory applicable to this particular entry  */
  category: AuditCategory;
  /**  Unique identifier for the Audit Event, uses UUIDv1 with timestamp part always equal to triggeredAt(!)  */
  context: Scalars['ID']['output'];
  /**  Event Acknowledgement  */
  isAcknowledged: Scalars['Boolean']['output'];
  /**  The audit message, which is properly applies parameters (like client language settings and event parameters) into the audit category message template  */
  message: Scalars['String']['output'];
  /**  Audit Entry may contain zero or more metadata classifiers attached, these contain the normalized metadata categories and can be used for grouping/searching  */
  metadata: Array<MetaEntry>;
  /**  Date/Time when event was last updated, matches to triggeredAt for events never updated  */
  modifiedAt: Scalars['DateTime']['output'];
  /**  Event Note  */
  note?: Maybe<Scalars['String']['output']>;
  /**  Audit Entry may contain one or more attached snapshots, only one of thm will be marked as 'default' and will have a quick access path when retrieving multiple audit entries  */
  snapshots: Array<AuditSnapshot>;
  /**  Date/Time when Event happened, it is not necessarily when it was registered  */
  triggeredAt: Scalars['DateTime']['output'];
  /**  The list of RealmObjects (typically Device entries) witnessing the context of this Audit Event/Entry  */
  witnesses: Array<RealmObject>;
};

export type AuditEntryEvent = AuditEntry | ErrorInfo;

/** Audit entries filter data. */
export type AuditEntryFilter = {
  /**  List of Audit Category IDs. If not specified, entries from all categories are returned  */
  categories?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**  From date-time. If not specified, last hour is assumed  */
  from?: InputMaybe<Scalars['DateTime']['input']>;
  /**  If limit is not specified, 100 is assumed. Limit cannot be more than 100  */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /**  If start is not specified, 0 is assumed  */
  start?: InputMaybe<Scalars['Int']['input']>;
  /**  To date-time. If not specified, current time is assumed  */
  to?: InputMaybe<Scalars['DateTime']['input']>;
  /**  List of Realm Object IDs  */
  witnesses: Array<Scalars['ID']['input']>;
};

/**
 * Audit entry provides the information for one audit event
 * specify context or triggeredAt:
 * - if context is specified then triggeredAt will be getted from context
 * - if context is not specified then it will be generated based on triggeredAt
 * - if context and triggeredAt is not specified then context will be generated with current time
 * - if modifiedAt is not specified then it will set to current time
 */
export type AuditEntryInput = {
  /**  The reference to the AuditCategory applicable to this particular entry  */
  category: Scalars['Int']['input'];
  /**  Unique identifier for the Audit Event, uses UUIDv1 with timestamp part always equal to triggeredAt(!)  */
  context?: InputMaybe<Scalars['ID']['input']>;
  /**  Event type (Alert/Info), by default - Info  */
  eventType?: InputMaybe<EventType>;
  /**  The audit message, which is properly applies parameters (like client language settings and event parameters) into the audit category message template  */
  message: Scalars['String']['input'];
  /**  Audit Entry may contain zero or more metadata classifiers attached, these contain the normalized metadata categories and can be used for grouping/searching  */
  metadata?: InputMaybe<Array<MetaEntryInput>>;
  /**  Date/Time when event was last updated, matches to triggeredAt for events never updated  */
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /**  Audit Entry may contain one or more attached snapshots, only one of them will be marked as 'default' and will have a quick access path when retrieving multiple audit entries  */
  snapshots?: InputMaybe<Array<AuditEntrySnapshotInput>>;
  /**  Date/Time when Event happened, it is not necessarily when it was registered  */
  triggeredAt?: InputMaybe<Scalars['DateTime']['input']>;
  /**  The list of RealmObjects id's (typically Device entries) witnessing the context of this Audit Event/Entry  */
  witnesses: Array<Scalars['String']['input']>;
};

export type AuditEntrySnapshotInput = {
  /**  Snapshot mime type  */
  mime: Scalars['String']['input'];
  /**  Snapshot, base64 encoded into String  */
  snapshot: Scalars['String']['input'];
  /**  RealmObject id (typically Device entries) witnessing the context of this Audit Event/Entry  */
  witness?: InputMaybe<Scalars['String']['input']>;
};

/**
 * AuditEntry can have zero, one or more snapshots attached to it.
 * Snapshot[s] provide the visual queues for the Audit Entry/Event visualization for the end-user.
 * Only one of these snapshots will have 'default' property marked as true, and it will be provided when requesting multiple entries with snapshots included.
 * It is possible to get the remaining snapshots when running query for individual AuditEntry.id.
 */
export type AuditSnapshot = {
  __typename?: 'AuditSnapshot';
  /**  Flag if particular snapshot is a default one to be shown with an Event  */
  default: Scalars['Boolean']['output'];
  /**  Snapshot, base64 encoded into String  */
  snapshot: Scalars['String']['output'];
  /**  Tags allow to keep additional convenience annotations and are stored as Key->Value mappings  */
  tags: Array<KeyValue>;
  /**  Type is provided by VAE and is not intended for end-user consumption, it is ID-like  */
  type: Scalars['String']['output'];
};

export type AuditSnapshotInput = {
  default: Scalars['Boolean']['input'];
  snapshot: Scalars['String']['input'];
  tags: Array<KeyValueInput>;
  type: Scalars['String']['input'];
};

export enum AuthType {
  HttpBasic = 'HTTP_BASIC',
  HttpDigest = 'HTTP_DIGEST',
  NoAuth = 'NO_AUTH'
}

export type AvatarMetric = {
  __typename?: 'AvatarMetric';
  /**  Dimension  */
  dimension: MetricDimension;
  /**  Metric name  */
  key: AvatarMetricName;
  /**  Description of metric  */
  name: Scalars['String']['output'];
};

export enum AvatarMetricName {
  ChannelArchiveScheduledBytes = 'CHANNEL_ARCHIVE_SCHEDULED_BYTES',
  ChannelJitterMs = 'CHANNEL_JITTER_MS',
  /**  Channel statistics  */
  ChannelRttMs = 'CHANNEL_RTT_MS',
  ChannelSentArchiveBps = 'CHANNEL_SENT_ARCHIVE_BPS',
  ChannelSentLiveBps = 'CHANNEL_SENT_LIVE_BPS',
  /**  Channel bandwidth statistics  */
  ChannelTotalInboundBps = 'CHANNEL_TOTAL_INBOUND_BPS',
  CpuIdle = 'CPU_IDLE',
  CpuIowait = 'CPU_IOWAIT',
  /**  Cpu statistics  */
  CpuUsage = 'CPU_USAGE',
  DiskIoPct = 'DISK_IO_PCT',
  LocalStreamingArchiveBps = 'LOCAL_STREAMING_ARCHIVE_BPS',
  LocalStreamingClientsCount = 'LOCAL_STREAMING_CLIENTS_COUNT',
  /**  Local media downloads  */
  LocalStreamingLiveBps = 'LOCAL_STREAMING_LIVE_BPS',
  /**  Memory statistics  */
  MemFreePct = 'MEM_FREE_PCT'
}

export enum BaseDeviceType {
  Avatar = 'AVATAR',
  Camera = 'CAMERA',
  Gateway = 'GATEWAY',
  Sensor = 'SENSOR'
}

export enum BasicAccessConfiguration {
  LimitedAudioSupport = 'limitedAudioSupport',
  LimitedAuditAccess = 'limitedAuditAccess',
  LimitedExportTime = 'limitedExportTime',
  LimitedGisAccess = 'limitedGISAccess',
  LimitedImportCamerasAccess = 'limitedImportCamerasAccess',
  LimitedMonitorCount = 'limitedMonitorCount',
  LimitedRealmAdministration = 'limitedRealmAdministration',
  LimitedReportsAccess = 'limitedReportsAccess',
  LimitedSetsAccess = 'limitedSetsAccess',
  LimitedSpeedList = 'limitedSpeedList',
  LimitedVideoAnalyticsAccess = 'limitedVideoAnalyticsAccess',
  LimitedZonesAccess = 'limitedZonesAccess'
}

export enum BoundaryFind {
  Next = 'NEXT',
  Prev = 'PREV'
}

export type BrandInfo = {
  __typename?: 'BrandInfo';
  iconUrl: Scalars['String']['output'];
  logoUrl: Scalars['String']['output'];
  name: Scalars['String']['output'];
  shortName: Scalars['String']['output'];
  website: Scalars['String']['output'];
};

export type Branding = {
  __typename?: 'Branding';
  crmRegistrationUrl?: Maybe<Scalars['String']['output']>;
  iconPath?: Maybe<Scalars['String']['output']>;
  loginBackgroundPath?: Maybe<Scalars['String']['output']>;
  loginFooterColor?: Maybe<Scalars['String']['output']>;
  logoPath?: Maybe<Scalars['String']['output']>;
  oemBrand?: Maybe<Scalars['String']['output']>;
  oemBrandName?: Maybe<Scalars['String']['output']>;
  oemCompanyLong?: Maybe<Scalars['String']['output']>;
  oemCompanyPhone?: Maybe<Scalars['String']['output']>;
  oemCompanyPhoneInternational?: Maybe<Scalars['String']['output']>;
  oemCompanyQuickstart?: Maybe<Scalars['String']['output']>;
  oemCompanyShort?: Maybe<Scalars['String']['output']>;
  oemCompanySupportPhone?: Maybe<Scalars['String']['output']>;
  oemCompanySupportUrl?: Maybe<Scalars['String']['output']>;
  oemCompanyUrl?: Maybe<Scalars['String']['output']>;
  oemCopyright?: Maybe<Scalars['String']['output']>;
  oemCopyrightMatrix?: Maybe<Scalars['String']['output']>;
  oemStyle?: Maybe<Scalars['String']['output']>;
  oemSupportEmail?: Maybe<Scalars['String']['output']>;
  oemTrademarks?: Maybe<Scalars['String']['output']>;
  quickStartGuidePath?: Maybe<Scalars['String']['output']>;
};

export type BrandingAttribute = {
  __typename?: 'BrandingAttribute';
  CRM_REGISTRATION_URL: Scalars['String']['output'];
  ICON_PATH: Scalars['String']['output'];
  LOGIN_BACKGROUND_PATH?: Maybe<Scalars['String']['output']>;
  LOGIN_BANNER_TEXT_PATH?: Maybe<Scalars['String']['output']>;
  LOGIN_FOOTER_COLOR?: Maybe<Scalars['String']['output']>;
  LOGIN_HEADER_COLOR?: Maybe<Scalars['String']['output']>;
  LOGO_PATH?: Maybe<Scalars['String']['output']>;
  OEM_BRAND: Scalars['String']['output'];
  OEM_BRAND_NAME: Scalars['String']['output'];
  OEM_COMPANY_LONG: Scalars['String']['output'];
  OEM_COMPANY_PHONE: Scalars['String']['output'];
  OEM_COMPANY_PHONE_INTERNATIONAL: Scalars['String']['output'];
  OEM_COMPANY_QUICKSTART: Scalars['String']['output'];
  OEM_COMPANY_SHORT: Scalars['String']['output'];
  OEM_COMPANY_SUPPORT_PHONE: Scalars['String']['output'];
  OEM_COMPANY_SUPPORT_URL: Scalars['String']['output'];
  OEM_COMPANY_URL: Scalars['String']['output'];
  OEM_COPYRIGHT: Scalars['String']['output'];
  OEM_COPYRIGHT_MATRIX: Scalars['String']['output'];
  OEM_STYLE: Scalars['String']['output'];
  OEM_SUPPORT_EMAIL: Scalars['String']['output'];
  OEM_TRADEMARKS: Scalars['String']['output'];
  QUICK_START_GUIDE_PATH: Scalars['String']['output'];
  SOLID_LOGO_VISIBLE?: Maybe<Scalars['String']['output']>;
};

export type BrandingAttributeInput = {
  CRM_REGISTRATION_URL: Scalars['String']['input'];
  ICON_PATH: Scalars['String']['input'];
  LOGIN_BACKGROUND_PATH?: InputMaybe<Scalars['String']['input']>;
  LOGIN_BANNER_TEXT_PATH?: InputMaybe<Scalars['String']['input']>;
  LOGIN_FOOTER_COLOR?: InputMaybe<Scalars['String']['input']>;
  LOGIN_HEADER_COLOR?: InputMaybe<Scalars['String']['input']>;
  LOGO_PATH?: InputMaybe<Scalars['String']['input']>;
  OEM_BRAND: Scalars['String']['input'];
  OEM_BRAND_NAME: Scalars['String']['input'];
  OEM_COMPANY_LONG: Scalars['String']['input'];
  OEM_COMPANY_PHONE: Scalars['String']['input'];
  OEM_COMPANY_PHONE_INTERNATIONAL: Scalars['String']['input'];
  OEM_COMPANY_QUICKSTART: Scalars['String']['input'];
  OEM_COMPANY_SHORT: Scalars['String']['input'];
  OEM_COMPANY_SUPPORT_PHONE: Scalars['String']['input'];
  OEM_COMPANY_SUPPORT_URL: Scalars['String']['input'];
  OEM_COMPANY_URL: Scalars['String']['input'];
  OEM_COPYRIGHT: Scalars['String']['input'];
  OEM_COPYRIGHT_MATRIX: Scalars['String']['input'];
  OEM_STYLE: Scalars['String']['input'];
  OEM_SUPPORT_EMAIL: Scalars['String']['input'];
  OEM_TRADEMARKS: Scalars['String']['input'];
  QUICK_START_GUIDE_PATH: Scalars['String']['input'];
  SOLID_LOGO_VISIBLE?: InputMaybe<Scalars['String']['input']>;
};

export type BulkDeviceInput = {
  configType: DeviceBaseConfigType;
  /**  Device id  */
  id: Scalars['ID']['input'];
  /**  Optional location as specified by user  */
  location?: InputMaybe<Scalars['String']['input']>;
  /**  Device name  */
  name?: InputMaybe<Scalars['String']['input']>;
  /**  Force RTP over TCP  */
  rtpOverTcp?: InputMaybe<Scalars['Boolean']['input']>;
  /**  Follow RTP time  */
  rtpTime?: InputMaybe<Scalars['Boolean']['input']>;
  /**  Device state (enabled/disabled)  */
  state?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CameraLog = {
  __typename?: 'CameraLog';
  message: Scalars['String']['output'];
  severity: LogSeverity;
  time: Scalars['DateTime']['output'];
};

export type CameraMetric = {
  __typename?: 'CameraMetric';
  /**  FA id  */
  dfaId: Scalars['Int']['output'];
  /**  Dimension  */
  dimension: MetricDimension;
  /**  Metric name  */
  key: CameraMetricName;
  /**  Description of metric  */
  name: Scalars['String']['output'];
};

export enum CameraMetricName {
  /**  Camera media bit-rate, per stream. History on camera media streams bitrate  */
  Bitrate = 'BITRATE',
  /**  Percentage of LINK storage utilized by devices and streams. History on scheduled and on-demand media requested to be delivered to the cloud  */
  CloudArchiveBps = 'CLOUD_ARCHIVE_BPS',
  CloudArchiveModBps = 'CLOUD_ARCHIVE_MOD_BPS',
  CloudLiveBps = 'CLOUD_LIVE_BPS',
  CloudLiveModBps = 'CLOUD_LIVE_MOD_BPS',
  /**  History on camera media streams utilizing LINK local storage  */
  LinkStoragePct = 'LINK_STORAGE_PCT',
  LocalArchiveModBps = 'LOCAL_ARCHIVE_MOD_BPS',
  LocalLiveModBps = 'LOCAL_LIVE_MOD_BPS',
  /**  Status, Errors and Warnings. History on processors status changes (count) */
  Status = 'STATUS',
  StreamFps = 'STREAM_FPS',
  /**  Percentage of media requested for on-demand and scheduled delivery. Media stream statistics  */
  StreamGop = 'STREAM_GOP',
  StreamJitter = 'STREAM_JITTER',
  StreamRestarts = 'STREAM_RESTARTS',
  StreamRtpPckLoss = 'STREAM_RTP_PCK_LOSS'
}

export type CameraTour = RealmObject & {
  __typename?: 'CameraTour';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  steps?: Maybe<Array<CameraTourStep>>;
  type: RealmObjectType;
};

export type CameraTourInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  steps?: InputMaybe<Array<CameraTourStepInput>>;
};

export type CameraTourStep = {
  __typename?: 'CameraTourStep';
  cameraId: Scalars['ID']['output'];
  cameraPreset?: Maybe<Scalars['Int']['output']>;
  delay: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type CameraTourStepInput = {
  cameraId: Scalars['ID']['input'];
  cameraPreset?: InputMaybe<Scalars['Int']['input']>;
  delay: Scalars['Int']['input'];
  name: Scalars['String']['input'];
};

export enum CameraType {
  Thermal = 'Thermal',
  ThermalMwir = 'Thermal_MWIR',
  ThermalSwir = 'Thermal_SWIR',
  Visible = 'Visible',
  None = 'none'
}

export type CameraView = {
  __typename?: 'CameraView';
  /**  Camera field of view angle (degree)  */
  fieldOfView?: Maybe<Scalars['Float']['output']>;
  /**  Camera north offset angle  */
  northOffsetAngle?: Maybe<Scalars['Float']['output']>;
  /**  Info for prolongation camera lock  */
  ptzLockProlongation?: Maybe<PtzLockProlongation>;
  /**  Last camera Ptz commands and status (pan, tilt, zoom, locked, etc)  */
  ptzStatus?: Maybe<PtzStatus>;
  /**  Camera view distance (length of vector from camera point in meters)  */
  viewDistance?: Maybe<Scalars['Float']['output']>;
};

export type CameraViewInput = {
  /**  Camera field of view angle (degree)  */
  fieldOfView?: InputMaybe<Scalars['Float']['input']>;
  /**  Camera north offset angle  */
  northOffsetAngle?: InputMaybe<Scalars['Float']['input']>;
  /**  Camera view distance (length of vector from camera point in meters)  */
  viewDistance?: InputMaybe<Scalars['Float']['input']>;
};

export type ChangeCurrentPasswordInput = {
  currentPassword: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
};

export type ChangePasswordInput = {
  currentPassword: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};

export type ChannelBenchmark = {
  __typename?: 'ChannelBenchmark';
  error?: Maybe<Scalars['String']['output']>;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  tcpDown?: Maybe<ChannelStatistics>;
  tcpUp?: Maybe<ChannelStatistics>;
};

export type ChannelStatistics = {
  __typename?: 'ChannelStatistics';
  bitsPerSecond?: Maybe<Scalars['Float']['output']>;
  bytes?: Maybe<Scalars['Int']['output']>;
  maxRtt?: Maybe<Scalars['Int']['output']>;
  maxSndCwnd?: Maybe<Scalars['Int']['output']>;
  meanRtt?: Maybe<Scalars['Int']['output']>;
  minRtt?: Maybe<Scalars['Int']['output']>;
  retransmits?: Maybe<Scalars['Int']['output']>;
};

export enum ChannelStatus {
  DelayedCatchup = 'DELAYED_CATCHUP',
  DelayedDegraded = 'DELAYED_DEGRADED',
  Ontime = 'ONTIME'
}

/** Entry for create event by user */
export type CreateEventEntry = {
  /**  Date/Time when Event happened  */
  createdAt: Scalars['DateTime']['input'];
  /**  Event type (Alert/Info), by default - Info  */
  eventType?: InputMaybe<EventType>;
  /**  Event action  */
  message?: InputMaybe<Scalars['String']['input']>;
  /**  Camera ID where event happened  */
  obj: Scalars['String']['input'];
  /**  Snapshot, base64 encoded into String  */
  snapshot?: InputMaybe<Scalars['String']['input']>;
};

export type CreateResult = {
  __typename?: 'CreateResult';
  id: Scalars['ID']['output'];
  warning?: Maybe<Scalars['String']['output']>;
  warningFields?: Maybe<Array<WarningField>>;
};

export type CreatingView = {
  __typename?: 'CreatingView';
  layout?: Maybe<Scalars['String']['output']>;
  layoutJSON?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  selectedWidget?: Maybe<WidgetInfo>;
  template?: Maybe<Scalars['String']['output']>;
  viewId: Scalars['String']['output'];
  widgets?: Maybe<Array<WidgetInfo>>;
};

export type CreatingViewInput = {
  layout?: InputMaybe<Scalars['String']['input']>;
  layoutJSON?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  selectedWidget?: InputMaybe<WidgetInfoInput>;
  template?: InputMaybe<Scalars['String']['input']>;
  viewId: Scalars['String']['input'];
  widgets?: InputMaybe<Array<WidgetInfoInput>>;
};

export type Credentials = {
  __typename?: 'Credentials';
  certificate: Scalars['String']['output'];
  privatekey: Scalars['String']['output'];
};

export type CredentialsInput = {
  certificate: Scalars['String']['input'];
  privatekey: Scalars['String']['input'];
};

/** Current Realm */
export type CurrentRealm = RealmObject & {
  __typename?: 'CurrentRealm';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Object ID (UUID) */
  id: Scalars['ID']['output'];
  imageMapConfig?: Maybe<Scalars['String']['output']>;
  /** Max duration of the video to upload in minutes */
  maxDownloadLength?: Maybe<Scalars['Int']['output']>;
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Object name */
  name: Scalars['String']['output'];
  sharedViews?: Maybe<Scalars['String']['output']>;
  type: RealmObjectType;
};

export type CurrentRealmInput = {
  imageMapConfig?: InputMaybe<Scalars['String']['input']>;
};

/** Functional Aspect descriptor for "Avatar" aspect. */
export type Dfa_Avatar = DeviceFunctionalAspect & {
  __typename?: 'DFA_Avatar';
  apiKey?: Maybe<Scalars['String']['output']>;
  avatarLoad?: Maybe<Scalars['Int']['output']>;
  channelBenchmark?: Maybe<ChannelBenchmark>;
  channelStatus?: Maybe<ChannelStatus>;
  channelTurnaroundTime?: Maybe<StatTime>;
  deliveryQueue?: Maybe<Scalars['Int']['output']>;
  deliveryQueueUploadTime?: Maybe<Scalars['Int']['output']>;
  /**  Device where aspect is connected  */
  device?: Maybe<Device>;
  dsConfiguredState?: Maybe<DsConfiguredState>;
  dsRunningState?: Maybe<DsRunningState>;
  /**  True if aspect is enabled for the device  */
  enabled: Scalars['Boolean']['output'];
  /** @deprecated unused */
  encryptionKey?: Maybe<EncryptionKeyInfo>;
  /**  internal use only  */
  extended?: Maybe<Scalars['JSONObject']['output']>;
  /**  Aspect Health settings and status  */
  health: AspectHealth;
  id: Scalars['ID']['output'];
  /**  Actual instances of aspects on the same device which produce inputs for the aspect.  */
  inputAspects: Array<DeviceFunctionalAspect>;
  isLink?: Maybe<Scalars['Boolean']['output']>;
  lastStatusUpdate?: Maybe<Scalars['DateTime']['output']>;
  localStorage?: Maybe<LocalStorage>;
  /**  Aspect name, suitable for GUI presentation  */
  name: Scalars['String']['output'];
  onvifServiceConf: OnvifServiceConfig;
  packetArrivalJitterTime?: Maybe<StatTime>;
  platform?: Maybe<Scalars['String']['output']>;
  /** @deprecated unused */
  pushEventEndPoint?: Maybe<Scalars['String']['output']>;
  software?: Maybe<SoftwareInfo>;
  /** @deprecated unused */
  statusUpdateInterval?: Maybe<Scalars['Int']['output']>;
  storageUsage?: Maybe<StorageUsage>;
  supportsReboot?: Maybe<Scalars['Boolean']['output']>;
  /**  Source template from which aspect was created. Can act as a 'subtype' of aspect, specifying for example an exact kind of analytics.  */
  template: FunctionalAspectTemplate;
  turnaroundTime?: Maybe<Scalars['Int']['output']>;
  /**  Aspect type (video/analytic/etc..), exactly corresponds to the type specified by template  */
  type: DeviceFunctionalAspectType;
  upTime?: Maybe<Scalars['Int']['output']>;
  uploadBandwidthCap?: Maybe<Scalars['Float']['output']>;
  vaeImageUpdate?: Maybe<Scalars['Boolean']['output']>;
  vaeUpdates?: Maybe<Array<VaeUpdate>>;
  vmxVideoStreamingMode?: Maybe<VmxVideoStreamingMode>;
  webRtcEnabled?: Maybe<Scalars['Boolean']['output']>;
};

export type Dfa_Gateway = DeviceFunctionalAspect & {
  __typename?: 'DFA_Gateway';
  /**  Associated devices  */
  associatedGatewayDevices: Array<AssociatedGatewayDevice>;
  /**  Device where aspect is connected  */
  device?: Maybe<Device>;
  /**  Full list of Lenel devices  */
  devices: Array<GatewayProbeDevice>;
  /**  Full list of Lenel directories  */
  directories: Array<GatewayDirectory>;
  /**  Current Lenel directory  */
  directory: GatewayDirectory;
  /**  True if aspect is enabled for the device  */
  enabled: Scalars['Boolean']['output'];
  /**  Full list of Lenel events  */
  events: Array<GatewayProbeEvent>;
  /**  Aspect Health settings and status  */
  health: AspectHealth;
  id: Scalars['ID']['output'];
  /**  Actual instances of aspects on the same device which produce inputs for the aspect.  */
  inputAspects: Array<DeviceFunctionalAspect>;
  /**  Lenel version  */
  lenelVersion: Scalars['String']['output'];
  /**  Aspect name, suitable for GUI presentation  */
  name: Scalars['String']['output'];
  /**  OpenID Connect token  */
  oidcToken?: Maybe<Scalars['String']['output']>;
  /**  Associated events  */
  subscribedEvents: Array<GatewayEvent>;
  /**  Source template from which aspect was created. Can act as a 'subtype' of aspect, specifying for example an exact kind of analytics.  */
  template: FunctionalAspectTemplate;
  /**  Aspect type (video/analytic/etc..), exactly corresponds to the type specified by template  */
  type: DeviceFunctionalAspectType;
};

/**
 * Functional Aspect descriptor for "Live Media" aspects.
 * Each media stream (video/audio) receives a separate DFA descriptor.
 */
export type Dfa_Media = DeviceFunctionalAspect & {
  __typename?: 'DFA_Media';
  FPS?: Maybe<Scalars['Float']['output']>;
  URL?: Maybe<Scalars['String']['output']>;
  audioCodec?: Maybe<Scalars['String']['output']>;
  averageFPS?: Maybe<Scalars['Float']['output']>;
  averageGOP?: Maybe<Scalars['Float']['output']>;
  averageInterArrivalJitter?: Maybe<Scalars['Float']['output']>;
  cloudArchive: MediaArchiveOption;
  codec?: Maybe<Scalars['String']['output']>;
  /**  Statistic  */
  consumedSpace?: Maybe<Scalars['Float']['output']>;
  /**  Device where aspect is connected  */
  device?: Maybe<Device>;
  /**
   *  Archive settings
   * @deprecated unused
   */
  edgeArchive: MediaArchiveOption;
  /**  True if aspect is enabled for the device  */
  enabled: Scalars['Boolean']['output'];
  frameRate?: Maybe<Scalars['Float']['output']>;
  /**  Aspect Health settings and status  */
  health: AspectHealth;
  id: Scalars['ID']['output'];
  /**  Actual instances of aspects on the same device which produce inputs for the aspect.  */
  inputAspects: Array<DeviceFunctionalAspect>;
  liveBitrate?: Maybe<Scalars['Float']['output']>;
  /**  Aspect name, suitable for GUI presentation  */
  name: Scalars['String']['output'];
  onvifProfile?: Maybe<Scalars['String']['output']>;
  onvifProfiles?: Maybe<Scalars['JSONObject']['output']>;
  recordingArchive: RecordingArchive;
  rtpPacketLost?: Maybe<Scalars['Int']['output']>;
  /**
   *  Streams in social networks - deprecated (use sharedStream from Device)
   * @deprecated use sharedStream from Device
   */
  sharedStream?: Maybe<Array<StreamShare>>;
  spaceUsageDay?: Maybe<Scalars['Float']['output']>;
  spaceUsageHour?: Maybe<Scalars['Float']['output']>;
  /**  Stream properties  */
  streamSize?: Maybe<MediaStreamSize>;
  streamType: MediaStreamType;
  /**  Source template from which aspect was created. Can act as a 'subtype' of aspect, specifying for example an exact kind of analytics.  */
  template: FunctionalAspectTemplate;
  /**  Aspect type (video/analytic/etc..), exactly corresponds to the type specified by template  */
  type: DeviceFunctionalAspectType;
  uptime?: Maybe<Scalars['Int']['output']>;
  videoCodec?: Maybe<Scalars['String']['output']>;
  videoHeight?: Maybe<Scalars['Int']['output']>;
  videoSize?: Maybe<Scalars['String']['output']>;
  videoWidth?: Maybe<Scalars['Int']['output']>;
};

/** Functional Aspect descriptor for "PTZ" aspect. */
export type Dfa_Ptz = DeviceFunctionalAspect & {
  __typename?: 'DFA_PTZ';
  /**  Camera Type  */
  cameraType: CameraType;
  /**  Set of supported command classes (for future, currently is not used)  */
  cmdClassSupport?: Maybe<Array<Ptz_Class>>;
  /**  Device where aspect is connected  */
  device?: Maybe<Device>;
  /**  True if aspect is enabled for the device  */
  enabled: Scalars['Boolean']['output'];
  /**  Aspect Health settings and status  */
  health: AspectHealth;
  id: Scalars['ID']['output'];
  /**  Actual instances of aspects on the same device which produce inputs for the aspect.  */
  inputAspects: Array<DeviceFunctionalAspect>;
  /**  Aspect name, suitable for GUI presentation  */
  name: Scalars['String']['output'];
  /**  Attached PTZ Camera 1 Address [0..255] (PtzType.Moog)  */
  ptzAttachedCamera1Address?: Maybe<Scalars['Int']['output']>;
  /**  Attached PTZ Camera 1 BaudRate (PtzType.Moog)  */
  ptzAttachedCamera1BaudRate?: Maybe<PtzAttachedBaudRate>;
  /**  Attached PTZ Camera 1 Model (PtzType.Moog)  */
  ptzAttachedCamera1Model?: Maybe<PtzAttachedCameraModel>;
  /**  Attached PTZ Camera 1 Serial Mode (PtzType.Moog)  */
  ptzAttachedCamera1SerialMode?: Maybe<PtzAttachedSerialMode>;
  /**  Attached PTZ Camera 2 Address [0..255] (PtzType.Moog)  */
  ptzAttachedCamera2Address?: Maybe<Scalars['Int']['output']>;
  /**  Attached PTZ Camera 2 BaudRate (PtzType.Moog)  */
  ptzAttachedCamera2BaudRate?: Maybe<PtzAttachedBaudRate>;
  /**  Attached PTZ Camera 2 Model (PtzType.Moog)  */
  ptzAttachedCamera2Model?: Maybe<PtzAttachedCameraModel>;
  /**  Attached PTZ Camera 2 Serial Mode (PtzType.Moog)  */
  ptzAttachedCamera2SerialMode?: Maybe<PtzAttachedSerialMode>;
  ptzConfig?: Maybe<Scalars['String']['output']>;
  /**  PTZ ID (PtzType.Moog)  */
  ptzId?: Maybe<Scalars['ID']['output']>;
  ptzPanInverted?: Maybe<Scalars['Boolean']['output']>;
  /**  PTZ TCP Address (PtzType.Moog)  */
  ptzTcpAddress?: Maybe<PtzTcpAddress>;
  ptzTiltInverted?: Maybe<Scalars['Boolean']['output']>;
  /**  PTZ Type  */
  ptzType: PtzType;
  /**  Source template from which aspect was created. Can act as a 'subtype' of aspect, specifying for example an exact kind of analytics.  */
  template: FunctionalAspectTemplate;
  /**  Aspect type (video/analytic/etc..), exactly corresponds to the type specified by template  */
  type: DeviceFunctionalAspectType;
};

/** Functional Aspect descriptor for Sensors aspects. */
export type Dfa_Sensor = DeviceFunctionalAspect & {
  __typename?: 'DFA_Sensor';
  /**  Device ids which assigned to sensor  */
  associatedDevices?: Maybe<Array<Scalars['String']['output']>>;
  /**  Sensor category (like Door, Fence)  */
  category?: Maybe<AspectSensorCategory>;
  /**  Device where aspect is connected  */
  device?: Maybe<Device>;
  /**  Elta frequency control center (accepted range: 1-7)  */
  eltaFrequencyControlCenter?: Maybe<Scalars['Int']['output']>;
  /**  Elta north offset  */
  eltaNorthOffset?: Maybe<Scalars['Float']['output']>;
  /**  True if aspect is enabled for the device  */
  enabled: Scalars['Boolean']['output'];
  /**  Aspect Health settings and status  */
  health: AspectHealth;
  id: Scalars['ID']['output'];
  /**  Actual instances of aspects on the same device which produce inputs for the aspect.  */
  inputAspects: Array<DeviceFunctionalAspect>;
  /**  Sensor model  */
  model?: Maybe<Scalars['String']['output']>;
  /**  Aspect name, suitable for GUI presentation  */
  name: Scalars['String']['output'];
  /**  Qortex Mapped zones with assigned cameras  */
  qortexMappedZones?: Maybe<Array<QortexMappedZone>>;
  /**  Qortex Zones  */
  qortexZones?: Maybe<Array<QortexZone>>;
  /**  Sensor events with description  */
  sensorEvents?: Maybe<Array<SensorEvent>>;
  /**  Sensor serial number  */
  serial?: Maybe<Scalars['String']['output']>;
  /**  Source template from which aspect was created. Can act as a 'subtype' of aspect, specifying for example an exact kind of analytics.  */
  template: FunctionalAspectTemplate;
  /**  Aspect type (video/analytic/etc..), exactly corresponds to the type specified by template  */
  type: DeviceFunctionalAspectType;
  /**  Selected types of sensor events  */
  userEvents?: Maybe<Array<Scalars['String']['output']>>;
};

/**
 * Functional Aspect descriptor for Analytics aspects.
 * Typically, these Aspects are Analytics performed by VAE.
 */
export type Dfa_Vae = DeviceFunctionalAspect & {
  __typename?: 'DFA_VAE';
  /**  Device where aspect is connected  */
  device?: Maybe<Device>;
  /**  True if aspect is enabled for the device  */
  enabled: Scalars['Boolean']['output'];
  /**  Type of created by engine event  */
  eventType?: Maybe<DeviceEventType>;
  /**  Aspect Health settings and status  */
  health: AspectHealth;
  id: Scalars['ID']['output'];
  /**  Actual instances of aspects on the same device which produce inputs for the aspect.  */
  inputAspects: Array<DeviceFunctionalAspect>;
  /**  Aspect name, suitable for GUI presentation  */
  name: Scalars['String']['output'];
  /**  Stream size for engine  */
  streamSize?: Maybe<MediaStreamSize>;
  /**  Source template from which aspect was created. Can act as a 'subtype' of aspect, specifying for example an exact kind of analytics.  */
  template: FunctionalAspectTemplate;
  /**  Aspect type (video/analytic/etc..), exactly corresponds to the type specified by template  */
  type: DeviceFunctionalAspectType;
  /**  Active VAE config  */
  vaeConfig?: Maybe<VaeConfigFull>;
  /**  VAE features for VAE configurator  */
  vaeFeatures?: Maybe<Array<Scalars['String']['output']>>;
  /**  Number of frames for processing per second  */
  vaeFps?: Maybe<VaeFps>;
  /**  VAE statistic for enabled engine  */
  vaeStatistic?: Maybe<VaeStatistic>;
};

export enum DsConfiguredState {
  Off = 'OFF',
  On = 'ON'
}

export enum DsRunningState {
  Running = 'RUNNING',
  Stopped = 'STOPPED'
}

export type DefaultGeoPosition = {
  __typename?: 'DefaultGeoPosition';
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
};

export type DeleteSharedViewInput = {
  /**
   * Last known updatedAt timestamp for optimistic concurrency control.
   * Send null when no prior shared views state exists (first write).
   */
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  viewId: Scalars['ID']['input'];
};

export type DeliveryPriorityInput = {
  deliveryPriority: Scalars['Int']['input'];
  deviceId: Scalars['ID']['input'];
};

/**
 * Device descriptor.
 * Device always belongs to a Realm and has some base configuration shared to device functional aspects.
 */
export type Device = RealmObject & {
  __typename?: 'Device';
  /**  Acknowledging for event witch detected by analytic modules  */
  acknowledgeRequired?: Maybe<Scalars['Boolean']['output']>;
  /** Alarm point GEO position */
  alarmPointPosition?: Maybe<LatLng>;
  /** Functional aspects (like "media", "events", ...) */
  aspects: Array<DeviceFunctionalAspect>;
  /** Camera view parameters */
  cameraView?: Maybe<CameraView>;
  /**  Cloud direct  */
  cloudDirect: Scalars['Boolean']['output'];
  /** General device settings */
  config: DeviceBaseConfig;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Strategies for content delivery */
  delivery?: Maybe<Scalars['String']['output']>;
  deliveryPriority?: Maybe<Scalars['Int']['output']>;
  /** Do not use, for internal use only */
  deviceType?: Maybe<BaseDeviceType>;
  enabled: Scalars['Boolean']['output'];
  /**  Use pre-event time and post-event time values for whole realm in cameras  */
  eventTimeFromRealm?: Maybe<Scalars['Boolean']['output']>;
  /** Advanced Camera Settings */
  eventType?: Maybe<DeviceEventType>;
  /**  GeoJsonObject (default FeatureCollection) to display the zone on geo map and identify the target in this zone  */
  geoZone?: Maybe<Scalars['JSONObject']['output']>;
  healthStatus: HealthStatus;
  /** Device ID (UUID) */
  id: Scalars['ID']['output'];
  /** Optional location as specified by user */
  location?: Maybe<Scalars['String']['output']>;
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Device name */
  name: Scalars['String']['output'];
  /** Avatar, DVR, external system */
  platform?: Maybe<Device>;
  /** GEO position */
  position?: Maybe<LatLng>;
  /**  Record a minimum post-event time, seconds  */
  postEventTime?: Maybe<Scalars['Int']['output']>;
  /**  Record a minimum pre-event time, seconds  */
  preEventTime?: Maybe<Scalars['Int']['output']>;
  /** Camera Stream Settings */
  rtpOverTcp?: Maybe<Scalars['Boolean']['output']>;
  rtpTime?: Maybe<Scalars['Boolean']['output']>;
  /** Optional set for authorization policy definition simplification */
  set?: Maybe<Array<ObjectDescriptor>>;
  /**  Streams in social networks  */
  sharedStream?: Maybe<Array<StreamShare>>;
  storageConfig?: Maybe<DeviceStorageConfig>;
  type: RealmObjectType;
  version: Scalars['String']['output'];
  /** Optional zone for authorization policy definition simplification */
  zone?: Maybe<ObjectDescriptor>;
};

/**
 * Generic device configuration settings.
 * These are shared between multiple DeviceFunctionalAspect entries device may have.
 */
export type DeviceBaseConfig = {
  __typename?: 'DeviceBaseConfig';
  cameraType?: Maybe<Scalars['String']['output']>;
  configType: DeviceBaseConfigType;
  connect: NetworkConnectDescriptor;
  firmware?: Maybe<Scalars['String']['output']>;
  make?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  onvifServices?: Maybe<Scalars['String']['output']>;
  stratusObjId?: Maybe<Scalars['ID']['output']>;
};

export type DeviceBaseConfigInput = {
  cameraType?: InputMaybe<Scalars['String']['input']>;
  configType: DeviceBaseConfigType;
  connect: NetworkConnectDescriptorInput;
  firmware?: InputMaybe<Scalars['String']['input']>;
  make?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  onvifServices?: InputMaybe<Scalars['String']['input']>;
  stratusObjId?: InputMaybe<Scalars['ID']['input']>;
};

/** The paradigm in which device is managed. */
export enum DeviceBaseConfigType {
  /**  Using ClearAlign  */
  ClearAlign = 'ClearAlign',
  /** Demo */
  Demo = 'DEMO',
  /** Gateway */
  Gateway = 'GATEWAY',
  /** On-board */
  Onboard = 'ONBOARD',
  /** Using ONVIF standard */
  Onvif = 'ONVIF',
  /** Sensor */
  Sensor = 'SENSOR',
  /** Camera from Stratus */
  Stratus = 'STRATUS',
  /** Using URI */
  Url = 'URL'
}

export enum DeviceCommand {
  AvatarChannelBenchmark = 'AVATAR_CHANNEL_BENCHMARK',
  AvatarDsActivate = 'AVATAR_DS_ACTIVATE',
  AvatarDsDeactivate = 'AVATAR_DS_DEACTIVATE',
  AvatarDsStart = 'AVATAR_DS_START',
  AvatarDsStop = 'AVATAR_DS_STOP',
  AvatarReboot = 'AVATAR_REBOOT',
  AvatarUpdateKey = 'AVATAR_UPDATE_KEY',
  AvatarUpdateSoftware = 'AVATAR_UPDATE_SOFTWARE',
  AvatarUpgradeSoftware = 'AVATAR_UPGRADE_SOFTWARE'
}

export enum DeviceEventType {
  Alert = 'alert',
  Information = 'information'
}

/**
 * Functional Aspect is a descriptor of the abstract functionality.
 * Zero, one or more Aspects may be attached to the Device.
 * Aspects are presented for the easy reasoning what kind of functionality particular device
 * can provide and description of what particular Aspect is and if it is operational.
 */
export type DeviceFunctionalAspect = {
  /**  Device where aspect is connected  */
  device?: Maybe<Device>;
  /**  True if aspect is enabled for the device  */
  enabled: Scalars['Boolean']['output'];
  /**  Aspect Health settings and status  */
  health: AspectHealth;
  id: Scalars['ID']['output'];
  /**  Actual instances of aspects on the same device which produce inputs for the aspect.  */
  inputAspects: Array<DeviceFunctionalAspect>;
  /**  Aspect name, suitable for GUI presentation. In most cases derived from the template name.  */
  name: Scalars['String']['output'];
  /**  Source template from which aspect was created. Can act as a 'subtype' of aspect, specifying for example an exact kind of analytics.  */
  template: FunctionalAspectTemplate;
  /**  Aspect type (video/analytic/etc..), exactly corresponds to the type specified by template  */
  type: DeviceFunctionalAspectType;
};

/**
 * Functional Aspect is a descriptor of the abstract functionality.
 * Zero, one or more Aspects may be attached to the Device.
 * Aspects are presented for the easy reasoning what kind of functionality particular device
 * can provide and description of what particular Aspect is and if it is operational.
 */
export type DeviceFunctionalAspectFilter = {
  /** True if aspect is enabled for the device */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Aspect Health settings and status */
  health?: InputMaybe<AspectHealthFilter>;
  /** Aspect name, suitable for GUI presentation */
  name?: InputMaybe<Scalars['String']['input']>;
  /** ID of source template from which aspect was created. */
  templateId?: InputMaybe<Scalars['String']['input']>;
  /** Aspect type (video/analytic/etc..) */
  type?: InputMaybe<DeviceFunctionalAspectType>;
};

export type DeviceFunctionalAspectInput = {
  URL?: InputMaybe<Scalars['String']['input']>;
  /**  Device ids which assigned Sensor  */
  associatedDevices?: InputMaybe<Array<Scalars['String']['input']>>;
  /**  Associated devices  */
  associatedGatewayDevices?: InputMaybe<Array<AssociatedGatewayDeviceInput>>;
  /**  Add extra camera information  */
  cameraType?: InputMaybe<CameraType>;
  /**  Sensor category (like Door, Fence)  */
  category?: InputMaybe<AspectSensorCategory>;
  cloudArchive?: InputMaybe<MediaArchiveOption>;
  /**  Set of supported command classes (for future, currently is not used)  */
  cmdClassSupport?: InputMaybe<Array<Ptz_Class>>;
  codec?: InputMaybe<Scalars['String']['input']>;
  /**  Lenel devices list  */
  devices?: InputMaybe<Array<GatewayDeviceInput>>;
  /**  Lenel directories list  */
  directories?: InputMaybe<Array<GatewayDirectoryInput>>;
  /**  Current Lenel directory id  */
  directoryId?: InputMaybe<Scalars['String']['input']>;
  /**  Elta frequency control center (accepted range: 1-7)  */
  eltaFrequencyControlCenter?: InputMaybe<Scalars['Int']['input']>;
  /**  Elta north offset  */
  eltaNorthOffset?: InputMaybe<Scalars['Float']['input']>;
  /** True if aspect is enabled for the device */
  enabled: Scalars['Boolean']['input'];
  /**  Type of created by engine event  */
  eventType?: InputMaybe<DeviceEventType>;
  /**  Lenel events list  */
  events?: InputMaybe<Array<GatewayEventInput>>;
  frameRate?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['ID']['input'];
  /** Actual instances of aspects on the same device which produce inputs for the aspect. */
  inputAspectIDs: Array<Scalars['ID']['input']>;
  lenelVersion?: InputMaybe<Scalars['String']['input']>;
  /**  Sensor model  */
  model?: InputMaybe<Scalars['String']['input']>;
  /** Aspect name, suitable for GUI presentation. In most cases derived from the template name. */
  name: Scalars['String']['input'];
  /**  OpenID Connect token  */
  oidcToken?: InputMaybe<Scalars['String']['input']>;
  onvifProfile?: InputMaybe<Scalars['String']['input']>;
  onvifProfiles?: InputMaybe<Scalars['JSONObject']['input']>;
  onvifServiceConf?: InputMaybe<OnvifServiceConfigInput>;
  /**  Attached PTZ Camera 1 Address [0..255] (PtzType.Moog), Default: 1  */
  ptzAttachedCamera1Address?: InputMaybe<Scalars['Int']['input']>;
  /**  Attached PTZ Camera 1 BaudRate (PtzType.Moog), Default: Baud9600  */
  ptzAttachedCamera1BaudRate?: InputMaybe<PtzAttachedBaudRate>;
  /**  Attached PTZ Camera 1 Model (PtzType.Moog), Default: Other  */
  ptzAttachedCamera1Model?: InputMaybe<PtzAttachedCameraModel>;
  /**  Attached PTZ Camera 1 Serial Mode (PtzType.Moog), Default: RS422  */
  ptzAttachedCamera1SerialMode?: InputMaybe<PtzAttachedSerialMode>;
  /**  Attached PTZ Camera 2 Address [0..255] (PtzType.Moog), Default: 1  */
  ptzAttachedCamera2Address?: InputMaybe<Scalars['Int']['input']>;
  /**  Attached PTZ Camera 2 BaudRate (PtzType.Moog), Default: Baud9600  */
  ptzAttachedCamera2BaudRate?: InputMaybe<PtzAttachedBaudRate>;
  /**  Attached PTZ Camera 2 Model (PtzType.Moog), Default: Other  */
  ptzAttachedCamera2Model?: InputMaybe<PtzAttachedCameraModel>;
  /**  Attached PTZ Camera 2 Serial Mode (PtzType.Moog), Default: RS422  */
  ptzAttachedCamera2SerialMode?: InputMaybe<PtzAttachedSerialMode>;
  ptzConfig?: InputMaybe<Scalars['String']['input']>;
  /**  PTZ ID, [1, 255] (PtzType.Moog)  */
  ptzId?: InputMaybe<Scalars['ID']['input']>;
  ptzPanInverted?: InputMaybe<Scalars['Boolean']['input']>;
  /**  PTZ TCP Address (PtzType.Moog)  */
  ptzTcpAddress?: InputMaybe<PtzTcpAddressInput>;
  ptzTiltInverted?: InputMaybe<Scalars['Boolean']['input']>;
  ptzType?: InputMaybe<PtzType>;
  /**  Qortex Mapped zones with assigned cameras  */
  qortexMappedZones?: InputMaybe<Array<QortexMappedZoneInput>>;
  /**  Qortex Zones  */
  qortexZones?: InputMaybe<Array<QortexZoneInput>>;
  recordingArchive?: InputMaybe<RecordingArchive>;
  /**  Sensor events with description  */
  sensorEvents?: InputMaybe<Array<SensorEventInput>>;
  /**  Sensor serial number  */
  serial?: InputMaybe<Scalars['String']['input']>;
  /**  Stream size for engine  */
  streamSize?: InputMaybe<MediaStreamSize>;
  /**  Stream properties  */
  streamType?: InputMaybe<MediaStreamType>;
  /**  Associated events  */
  subscribedEvents?: InputMaybe<Array<SubscribedGatewayEventInput>>;
  /**
   *  Source template from which aspect was created.
   * Can act as a 'subtype' of aspect, specifying for example an exact kind of analytics.
   */
  templateId: Scalars['String']['input'];
  uploadBandwidthCap?: InputMaybe<Scalars['Float']['input']>;
  /**  Selected types of sensor events  */
  userEvents?: InputMaybe<Array<Scalars['String']['input']>>;
  /**  Changed configurations names  */
  vaeConfigChangedNames?: InputMaybe<Array<Scalars['String']['input']>>;
  /**  Active VAE config name  */
  vaeConfigName?: InputMaybe<Scalars['String']['input']>;
  /**  Subscribed VAE features  */
  vaeFeatures?: InputMaybe<Array<Scalars['String']['input']>>;
  /**  Configured min and max FPS  */
  vaeFps?: InputMaybe<VaeFpsInput>;
  vaeImageUpdate?: InputMaybe<Scalars['Boolean']['input']>;
  videoHeight?: InputMaybe<Scalars['Int']['input']>;
  videoWidth?: InputMaybe<Scalars['Int']['input']>;
  vmxVideoStreamingMode?: InputMaybe<VmxVideoStreamingMode>;
  webRtcEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Functional Aspect types */
export enum DeviceFunctionalAspectType {
  Avatar = 'AVATAR',
  Gateway = 'GATEWAY',
  Media = 'MEDIA',
  Ptz = 'PTZ',
  Sensor = 'SENSOR',
  Vae = 'VAE'
}

export type DeviceInput = {
  /** Acknowledging for event witch detected by analytic modules */
  acknowledgeRequired?: InputMaybe<Scalars['Boolean']['input']>;
  /** Alarm point GEO position */
  alarmPointPosition?: InputMaybe<LatLngInput>;
  /** Functional aspects (like "media", "events", ...) */
  aspects?: InputMaybe<Array<DeviceFunctionalAspectInput>>;
  /** Camera calibrator view parameters */
  cameraView?: InputMaybe<CameraViewInput>;
  /** General device settings */
  config: DeviceBaseConfigInput;
  deliveryPriority?: InputMaybe<Scalars['Int']['input']>;
  enabled: Scalars['Boolean']['input'];
  /**  Use pre-event time and post-event time values for whole realm  */
  eventTimeFromRealm?: InputMaybe<Scalars['Boolean']['input']>;
  /** Camera Setting */
  eventType?: InputMaybe<DeviceEventType>;
  /**  GeoJsonObject (e.g. FeatureCollection) to display the zone on geo map and identify the target in this zone  */
  geoZone?: InputMaybe<Scalars['JSONObject']['input']>;
  /** Optional location as specified by user */
  location?: InputMaybe<Scalars['String']['input']>;
  /** Device name */
  name: Scalars['String']['input'];
  /** Avatar, DVR, external system */
  platformId?: InputMaybe<Scalars['ID']['input']>;
  /** GEO position */
  position?: InputMaybe<LatLngInput>;
  /**  Record a minimum post-event time  */
  postEventTime?: InputMaybe<Scalars['Int']['input']>;
  /**  Record a minimum pre-event time  */
  preEventTime?: InputMaybe<Scalars['Int']['input']>;
  rtpOverTcp?: InputMaybe<Scalars['Boolean']['input']>;
  rtpTime?: InputMaybe<Scalars['Boolean']['input']>;
  /** Optional set for authorization policy definition simplification */
  setId?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**  RTMP urls for sharing stream in social networks  */
  sharedStream?: InputMaybe<Array<StreamShareInput>>;
  storageConfig?: InputMaybe<DeviceStorageConfigInput>;
  /** Optional zone for authorization policy definition simplification */
  zoneId?: InputMaybe<Scalars['ID']['input']>;
};

export type DeviceProbe = {
  __typename?: 'DeviceProbe';
  /** Functional aspects (like "media", "events", ...) */
  aspects: Array<DeviceFunctionalAspect>;
  config: DeviceBaseConfig;
  name?: Maybe<Scalars['String']['output']>;
  /** Default value for follow rtp time */
  rtpTime?: Maybe<Scalars['Boolean']['output']>;
  /** Video snapshots for Video aspects */
  snapshots: Array<Scalars['String']['output']>;
};

export type DeviceProbeInput = {
  cameraType?: InputMaybe<Scalars['String']['input']>;
  configType: DeviceBaseConfigType;
  connect: NetworkConnectDescriptorInput;
  optional?: InputMaybe<Scalars['Boolean']['input']>;
  platformId?: InputMaybe<Scalars['ID']['input']>;
  sensorModel?: InputMaybe<Scalars['String']['input']>;
  stratusObjId?: InputMaybe<Scalars['ID']['input']>;
};

export type DeviceStorageConfig = {
  __typename?: 'DeviceStorageConfig';
  storagePool: StoragePool;
};

export type DeviceStorageConfigInput = {
  storagePool?: InputMaybe<Scalars['ID']['input']>;
};

export type DeviceTemplate = {
  __typename?: 'DeviceTemplate';
  make: Scalars['String']['output'];
  models: Array<DeviceTemplateModel>;
};

export type DeviceTemplateModel = {
  __typename?: 'DeviceTemplateModel';
  model: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type EmailAddresses = {
  from?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['String']['input']>;
};

export enum EmailAuth {
  No = 'NO',
  Pass = 'PASS'
}

export type EncryptionKeyInfo = {
  __typename?: 'EncryptionKeyInfo';
  isValid?: Maybe<Scalars['Boolean']['output']>;
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ErrorInfo = {
  __typename?: 'ErrorInfo';
  createdAt: Scalars['DateTime']['output'];
  error: Scalars['String']['output'];
};

export type EventInfo = {
  __typename?: 'EventInfo';
  entry: AuditEntry;
  hasSnapshots: Scalars['Boolean']['output'];
};

export enum EventSource {
  Onvif = 'Onvif',
  Sensor = 'Sensor'
}

export enum EventType {
  Alert = 'alert',
  Information = 'information'
}

/**
 * Health Gravity defines how aspect health is reflected on device health (how to roll health statuses up).
 * Each individual Aspect operation status can take values from HealthStatus enum (from "core").
 */
export enum Fa_HealthGravity {
  /** If aspect with BEST_EFFORT gravity is DEAD, it is rolling up as NORMAL (not DEGRADED or BROKEN) */
  BestEffort = 'BEST_EFFORT',
  /** If aspect with CRITICAL gravity is DEAD, entire device is considered to be BROKEN */
  Critical = 'CRITICAL',
  /** If aspect with NORMAL gravity is DEAD, it is rolling up as DEGRADED (not BROKEN) */
  Normal = 'NORMAL'
}

export type Feature = {
  __typename?: 'Feature';
  desc: FeatureDesc;
  name: Scalars['String']['output'];
  unitsSubscribed: Scalars['Float']['output'];
  unitsUsed: Scalars['Float']['output'];
};

/** Used to list available features */
export type FeatureDesc = {
  __typename?: 'FeatureDesc';
  displayName: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type: FeatureType;
  unitType: Scalars['String']['output'];
};

export type FeatureInput = {
  name: Scalars['String']['input'];
  unitsSubscribed: Scalars['Float']['input'];
};

export enum FeatureType {
  Default = 'DEFAULT',
  Storagepool = 'STORAGEPOOL'
}

export type FileInfo = {
  __typename?: 'FileInfo';
  id: Scalars['ID']['output'];
  mime: Scalars['String']['output'];
  name: Scalars['String']['output'];
  path: Scalars['String']['output'];
  uploadDate: Scalars['DateTime']['output'];
};

export type Filter = {
  /** Features names we should filter */
  features?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Realm IDs we should filter */
  realms?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Array of two DateTime: From - To */
  streamUsagePeriod?: InputMaybe<StreamUsagePeriod>;
  /** If we should return usage. Increases response time greatly! */
  usage?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * System-defined templates to instantiate device functional aspects.
 * A template must be created for each aspect kind used in the system.
 * For example, every kind of analytics aspect must have a registered template.
 */
export type FunctionalAspectTemplate = {
  __typename?: 'FunctionalAspectTemplate';
  baseFeature?: Maybe<Scalars['String']['output']>;
  defaultFeature?: Maybe<Scalars['String']['output']>;
  engine?: Maybe<Scalars['String']['output']>;
  features?: Maybe<Array<VaeFeature>>;
  /** Unique template ID, a readable constant for machine interpretation, like 'video', 'audio', etc. */
  id: Scalars['String']['output'];
  /** Aspect name, suitable for GUI presentation */
  name: Scalars['String']['output'];
  /** Display order of the aspect */
  order: Scalars['Int']['output'];
  /** Aspect type (video/analytic/etc..) */
  type: DeviceFunctionalAspectType;
};

export type GeoLayer = {
  __typename?: 'GEOLayer';
  /** @deprecated unused */
  data: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  mime: Scalars['String']['output'];
  name: Scalars['String']['output'];
  path: Scalars['String']['output'];
  uploadDate: Scalars['DateTime']['output'];
};

export type GeoLayerInput = {
  data?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  mime: Scalars['String']['input'];
  name: Scalars['String']['input'];
  path?: InputMaybe<Scalars['String']['input']>;
  upload?: InputMaybe<Scalars['Upload']['input']>;
  uploadDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type GeoLayers = {
  __typename?: 'GEOLayers';
  geoLayers: Array<GeoLayer>;
};

export type GeoLayersInput = {
  geoLayers: Array<GeoLayerInput>;
};

export type GatewayDeviceInput = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type GatewayDirectoriesProbe = {
  __typename?: 'GatewayDirectoriesProbe';
  deviceProbe: DeviceProbe;
  directories: Array<GatewayDirectory>;
};

export type GatewayDirectoriesProbeInput = {
  connect: NetworkConnectDescriptorInput;
  model: GatewayModel;
  platformId: Scalars['String']['input'];
};

export type GatewayDirectory = {
  __typename?: 'GatewayDirectory';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type GatewayDirectoryInput = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type GatewayEvent = {
  __typename?: 'GatewayEvent';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type GatewayEventInput = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export enum GatewayModel {
  Lenel = 'Lenel'
}

export type GatewayProbe = {
  __typename?: 'GatewayProbe';
  devices: Array<GatewayProbeDevice>;
  events: Array<GatewayProbeEvent>;
};

export type GatewayProbeDevice = {
  __typename?: 'GatewayProbeDevice';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type GatewayProbeEvent = {
  __typename?: 'GatewayProbeEvent';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type GatewayProbeInput = {
  connect: NetworkConnectDescriptorInput;
  directoryId: Scalars['String']['input'];
  model: GatewayModel;
  platformId: Scalars['String']['input'];
  token?: InputMaybe<Scalars['String']['input']>;
  version: Scalars['String']['input'];
};

/** Generic Realm object */
export type GenericObject = RealmObject & {
  __typename?: 'GenericObject';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Object ID (UUID) */
  id: Scalars['ID']['output'];
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Object name */
  name: Scalars['String']['output'];
  type: RealmObjectType;
};

export type GenericObjectInput = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  type: RealmObjectType;
};

export enum GeoIconSet {
  Generic = 'generic',
  Milsymbol = 'milsymbol'
}

export type GeoMarkerClusterConfig = {
  __typename?: 'GeoMarkerClusterConfig';
  disableClusteringAtZoom: Scalars['Int']['output'];
  enabled: Scalars['Boolean']['output'];
  mapType: MapType;
  maxClusterRadius: Scalars['Int']['output'];
};

export type GeoMarkerClusterConfigInput = {
  disableClusteringAtZoom: Scalars['Int']['input'];
  enabled: Scalars['Boolean']['input'];
  mapType: MapType;
  maxClusterRadius: Scalars['Int']['input'];
};

export type GeoTour = RealmObject & {
  __typename?: 'GeoTour';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  devices?: Maybe<Array<Scalars['ID']['output']>>;
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  points?: Maybe<Array<GeoTourPoint>>;
  type: RealmObjectType;
};

export type GeoTourInput = {
  devices?: InputMaybe<Array<Scalars['ID']['input']>>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  points?: InputMaybe<Array<GeoTourPointInput>>;
};

export type GeoTourPoint = {
  __typename?: 'GeoTourPoint';
  duration: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  position: LatLng;
};

export type GeoTourPointInput = {
  duration: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  position: LatLngInput;
};

export type GrafanaDashboard = {
  __typename?: 'GrafanaDashboard';
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type Group = RealmObject & {
  __typename?: 'Group';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  isSystemManaged: Scalars['Boolean']['output'];
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  policies: Array<Policy>;
  type: RealmObjectType;
  users: Array<User>;
};

export type GroupInput = {
  addPolicyIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  addUserIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  removePolicyIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeUserIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type Gui = {
  __typename?: 'Gui';
  description: Scalars['String']['output'];
  /**  GUI ID (UUID)  */
  id: Scalars['ID']['output'];
  /**  GUI name  */
  name: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

/**
 * Individual item health status.
 * If item was not enabled, status is always assumed to be OFF.
 * For enabled items, values are PENDING | NORMAL | DEGRADED | BROKEN
 */
export enum HealthStatus {
  Broken = 'BROKEN',
  Degraded = 'DEGRADED',
  Normal = 'NORMAL',
  Off = 'OFF',
  Pending = 'PENDING'
}

export type Hierarchy = {
  __typename?: 'Hierarchy';
  id: Scalars['ID']['output'];
  level: HierarchyLevel;
  name: Scalars['String']['output'];
};

export type HierarchyInput = {
  id: Scalars['ID']['input'];
  level?: InputMaybe<HierarchyLevelInput>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type HierarchyLevel = {
  __typename?: 'HierarchyLevel';
  id: Scalars['ID']['output'];
  labelIds: Array<Scalars['ID']['output']>;
  levels?: Maybe<Array<HierarchyLevel>>;
  name: Scalars['String']['output'];
};

export type HierarchyLevelInput = {
  id: Scalars['ID']['input'];
  labelIds: Array<Scalars['ID']['input']>;
  levels: Array<HierarchyLevelInput>;
  name: Scalars['String']['input'];
};

export type IdentityAttribute = {
  __typename?: 'IdentityAttribute';
  contactUs: Scalars['String']['output'];
};

export type ImageMap = {
  __typename?: 'ImageMap';
  base64: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  objects: Array<ImageMapObject>;
  order: Scalars['Int']['output'];
};

export type ImageMapConfig = {
  __typename?: 'ImageMapConfig';
  sets: Array<ImageMapSet>;
};

export type ImageMapInput = {
  base64: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  objects: Array<ImageMapObjectInput>;
  order: Scalars['Int']['input'];
};

export type ImageMapLayer = {
  __typename?: 'ImageMapLayer';
  id: Scalars['ID']['output'];
  maps: Array<ImageMap>;
  name: Scalars['String']['output'];
};

export type ImageMapLayerInput = {
  id: Scalars['ID']['input'];
  maps: Array<ImageMapInput>;
  name: Scalars['String']['input'];
};

export type ImageMapObject = {
  __typename?: 'ImageMapObject';
  id: Scalars['ID']['output'];
  objectId: Scalars['ID']['output'];
  position: Position;
};

export type ImageMapObjectInput = {
  id: Scalars['ID']['input'];
  objectId: Scalars['ID']['input'];
  position: PositionInput;
};

export type ImageMapSet = {
  __typename?: 'ImageMapSet';
  id: Scalars['ID']['output'];
  layers: Array<ImageMapLayer>;
  name: Scalars['String']['output'];
};

export type ImageMapSetInput = {
  id: Scalars['ID']['input'];
  layers: Array<ImageMapLayerInput>;
  name: Scalars['String']['input'];
};

export enum ImageMapUpdateAction {
  DeleteLayer = 'DELETE_LAYER',
  DeleteObject = 'DELETE_OBJECT',
  DeleteSet = 'DELETE_SET',
  InsertLayer = 'INSERT_LAYER',
  InsertObject = 'INSERT_OBJECT',
  InsertSet = 'INSERT_SET',
  RenameLayer = 'RENAME_LAYER',
  RenameSet = 'RENAME_SET',
  UpdateLayer = 'UPDATE_LAYER',
  UpdateMap = 'UPDATE_MAP',
  UpdateObject = 'UPDATE_OBJECT',
  UpdateSet = 'UPDATE_SET'
}

export type ImageMapUpdateNotification = {
  __typename?: 'ImageMapUpdateNotification';
  action: ImageMapUpdateAction;
  layer?: Maybe<ImageMapLayer>;
  layerId?: Maybe<Scalars['ID']['output']>;
  layerName?: Maybe<Scalars['String']['output']>;
  map?: Maybe<ImageMap>;
  mapId?: Maybe<Scalars['ID']['output']>;
  object?: Maybe<ImageMapObject>;
  objectId?: Maybe<Scalars['ID']['output']>;
  realmId: Scalars['String']['output'];
  set?: Maybe<ImageMapSet>;
  setId?: Maybe<Scalars['ID']['output']>;
  setName?: Maybe<Scalars['String']['output']>;
  updateId: Scalars['ID']['output'];
  version: Scalars['String']['output'];
};

/** Generic Key->Value data */
export type KeyValue = {
  __typename?: 'KeyValue';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** Generic Key->Value data */
export type KeyValueInput = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type Label = {
  __typename?: 'Label';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  objects: Array<LabelObject>;
  type: LabelType;
};

export type LabelInput = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  objectIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type LabelObject = {
  __typename?: 'LabelObject';
  objectId: Scalars['ID']['output'];
  type: RealmObjectType;
};

export type LabelOrHierarchyUpdate = {
  __typename?: 'LabelOrHierarchyUpdate';
  itemIds: Array<Scalars['ID']['output']>;
  realmId: Scalars['ID']['output'];
  type: LabelOrHierarchyUpdateType;
};

export enum LabelOrHierarchyUpdateType {
  Delete = 'DELETE',
  Insert = 'INSERT',
  Update = 'UPDATE'
}

export enum LabelType {
  Label = 'LABEL',
  Set = 'SET',
  Zone = 'ZONE'
}

export type Language = {
  __typename?: 'Language';
  description: Scalars['String']['output'];
  direction: Scalars['String']['output'];
  tag: Scalars['String']['output'];
};

export type Languages = {
  __typename?: 'Languages';
  languages?: Maybe<Array<Language>>;
};

export type LatLng = {
  __typename?: 'LatLng';
  alt?: Maybe<Scalars['Float']['output']>;
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
};

export type LatLngInput = {
  alt?: InputMaybe<Scalars['Float']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
};

export type License = {
  __typename?: 'License';
  isAccepted: Scalars['Boolean']['output'];
  text: Scalars['String']['output'];
};

export type LocalStorage = {
  __typename?: 'LocalStorage';
  enabled: Scalars['Boolean']['output'];
  pool: PoolLocalStorage;
  strategy: Scalars['String']['output'];
  ver: Scalars['String']['output'];
};

export type LocalStorageInput = {
  enabled: Scalars['Boolean']['input'];
  pool: PoolLocalStorageInput;
  strategy: Scalars['String']['input'];
  ver: Scalars['String']['input'];
};

export enum LogSeverity {
  Debug = 'DEBUG',
  Error = 'ERROR',
  Fatal = 'FATAL',
  Info = 'INFO',
  Warn = 'WARN'
}

export enum MapType {
  EsriTile = 'Esri_tile',
  GoogleHybrid = 'Google_hybrid',
  GoogleRoadmap = 'Google_roadmap',
  GoogleSatellite = 'Google_satellite',
  Osm = 'OSM'
}

export enum MediaArchiveOption {
  Continuous = 'CONTINUOUS',
  Events = 'EVENTS',
  Live = 'LIVE',
  None = 'NONE'
}

export enum MediaStreamSize {
  Full = 'FULL',
  Review = 'REVIEW'
}

export enum MediaStreamType {
  Audio = 'AUDIO',
  Video = 'VIDEO'
}

/** Meta Classifier holds the single 'interpreted' value and may contain additional key-value attributes */
export type MetaClassifier = {
  __typename?: 'MetaClassifier';
  attributes: Array<KeyValue>;
  value: Scalars['String']['output'];
};

/** Meta Classifier holds the single 'interpreted' value and may contain additional key-value attributes */
export type MetaClassifierInput = {
  attributes: Array<KeyValueInput>;
  value: Scalars['String']['input'];
};

/** Metadata entry, identified by Key, holds Classifier */
export type MetaEntry = {
  __typename?: 'MetaEntry';
  key: Scalars['String']['output'];
  metaClass: MetaClassifier;
};

/** Metadata entry, identified by Key, holds Classifier */
export type MetaEntryInput = {
  key: Scalars['String']['input'];
  metaClass: MetaClassifierInput;
};

export enum MetricDimension {
  Bps = 'bps',
  Bytes = 'bytes',
  Fps = 'fps',
  Ms = 'ms',
  Pcs = 'pcs',
  Pct = 'pct',
  Status = 'status'
}

export type MinMax = {
  __typename?: 'MinMax';
  maxFps: Scalars['Int']['output'];
  minFps: Scalars['Int']['output'];
};

export type ModifiedByInfo = {
  __typename?: 'ModifiedByInfo';
  realmId: Scalars['ID']['output'];
  userId: Scalars['ID']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  /**  accept End User License Agreement  */
  acceptLicense: Scalars['Boolean']['output'];
  /**  acknowledge event  */
  acknowledgeAuditEntry: Scalars['Boolean']['output'];
  /**
   *  acknowledge event - deprecated
   * @deprecated use acknowledgeAuditEntry
   */
  acknowledgeEvent: Scalars['Boolean']['output'];
  /**  activate avatar  */
  activateAvatar?: Maybe<Scalars['Boolean']['output']>;
  /**  activate email  */
  activateEmail?: Maybe<Scalars['Boolean']['output']>;
  addSharedView: Scalars['Boolean']['output'];
  /**  add new realm subscription  */
  addSubscription?: Maybe<RealmSubscription>;
  /**  cancel AOD request  */
  aodCancel?: Maybe<Scalars['Boolean']['output']>;
  /**  pause AOD request  */
  aodPause?: Maybe<Scalars['Boolean']['output']>;
  /**  resume AOD request  */
  aodResume?: Maybe<Scalars['Boolean']['output']>;
  /**  add new AOD request  */
  aodSubmit: Array<AodRequest>;
  /**  assign labels to object  */
  assignLabels: Scalars['Boolean']['output'];
  /**  acknowledgement multiple events  */
  auditEntriesAcknowledgment: Scalars['Boolean']['output'];
  /**  block user  */
  blockUser: Scalars['Boolean']['output'];
  /**  change current password  */
  changeCurrentPassword?: Maybe<Scalars['Boolean']['output']>;
  /**  change delivery priority  */
  changeDeliveryPriority: Scalars['Boolean']['output'];
  /**  change config of local storage for avatar  */
  changeLocalStorage: Scalars['Boolean']['output'];
  /**  change user password  */
  changePassword: Scalars['Boolean']['output'];
  /**  SOLID config specific, not public  */
  clearRecentViews: Scalars['Boolean']['output'];
  /**  create event  */
  createAuditEntryEvent: AuditEntryEvent;
  /**  create avatar API key  */
  createAvatarApiKey: Scalars['Boolean']['output'];
  /**  create new camera tour  */
  createCameraTour: CreateResult;
  /**  add new device  */
  createDevice: CreateResult;
  /**  create event by user  */
  createEvent: Scalars['Boolean']['output'];
  /**  add new gateway device  */
  createGatewayDevice: CreateResult;
  /**  create new geo tour  */
  createGeoTour: CreateResult;
  /**  create group  */
  createGroup: CreateResult;
  /**  create new policy  */
  createPolicy: CreateResult;
  /**  create new policy statement  */
  createPolicyStatement: CreateResult;
  /**  create new schedule  */
  createSchedule: CreateResult;
  /**  add new sensor device  */
  createSensorDevice: CreateResult;
  /**  create set  */
  createSet: CreateResult;
  /**  update target properties  */
  createTarget: Target;
  /**  create new user  */
  createUser: CreateResult;
  /**  add new VAE config  */
  createVaeConfig: Scalars['Boolean']['output'];
  /**  create new zone  */
  createZone: CreateResult;
  /**  delete camera tour  */
  deleteCameraTour: Scalars['Boolean']['output'];
  /**  delete device  */
  deleteDevice: Scalars['Boolean']['output'];
  /**  delete devices in bulk  */
  deleteDevices: Scalars['Boolean']['output'];
  /**  delete geo map layer  */
  deleteGeoLayer: Scalars['Boolean']['output'];
  /**  delete geo tour  */
  deleteGeoTour: Scalars['Boolean']['output'];
  /**  delete group  */
  deleteGroup: Scalars['Boolean']['output'];
  /**  delete hierarchy  */
  deleteHierarchy: Scalars['Boolean']['output'];
  /**  delete image map layer  */
  deleteImageMapLayer: Scalars['Boolean']['output'];
  /**  delete image map layer  */
  deleteImageMapObject: Scalars['Boolean']['output'];
  /**  delete image map set  */
  deleteImageMapSet: Scalars['Boolean']['output'];
  /**  delete label  */
  deleteLabel: Scalars['Boolean']['output'];
  /**  delete policy  */
  deletePolicy: Scalars['Boolean']['output'];
  /**  delete policy statement  */
  deletePolicyStatement: Scalars['Boolean']['output'];
  /**  delete schedule  */
  deleteSchedule: Scalars['Boolean']['output'];
  /**  delete set  */
  deleteSet: Scalars['Boolean']['output'];
  deleteSharedView: Scalars['Boolean']['output'];
  /**  delete realm subscription  */
  deleteSubscription?: Maybe<Scalars['Int']['output']>;
  /**  delete user  */
  deleteUser: Scalars['Boolean']['output'];
  /**  delete VAE config  */
  deleteVaeConfig: Scalars['Boolean']['output'];
  /**  delete zone  */
  deleteZone: Scalars['Boolean']['output'];
  /**  perform device command  */
  deviceCommand: Scalars['Boolean']['output'];
  /**
   *  acknowledgement multiple events - deprecated
   * @deprecated use auditEntriesAcknowledgment
   */
  eventsAcknowledgement: Scalars['Boolean']['output'];
  /**  follow target  */
  followTarget?: Maybe<Scalars['Boolean']['output']>;
  /**  add new hierarchy  */
  insertHierarchy: Hierarchy;
  /**  add new layer to image map  */
  insertImageMapLayer: Scalars['Boolean']['output'];
  /**  add new object to image map  */
  insertImageMapObject: Scalars['Boolean']['output'];
  /**  add new image map set  */
  insertImageMapSet: Scalars['Boolean']['output'];
  /**  add new labels  */
  insertLabels: Array<Label>;
  /**  modify realm subscription  */
  modifySubscription?: Maybe<RealmSubscription>;
  /**  Absolute positioning  */
  ptzAbs: Scalars['Boolean']['output'];
  /**  Hardware commands  */
  ptzHardware: Scalars['Boolean']['output'];
  /**  Lock ptz  */
  ptzLock: PtzLockResult;
  /**  Working with preset positions. Preset positions are stored in cameras  */
  ptzPreset: Scalars['Boolean']['output'];
  /**  Center camera to position  */
  ptzRel: Scalars['Boolean']['output'];
  /**  Settings for camera  */
  ptzSettings: Scalars['Boolean']['output'];
  /**  Move (or change zoom, focus, iris, etc.) camera with specific speed  */
  ptzSpeed: Scalars['Boolean']['output'];
  /**  Move (or change zoom, focus, iris, etc.) camera step by step  */
  ptzStep: Scalars['Boolean']['output'];
  /**  Unlock ptz  */
  ptzUnlock: Scalars['Boolean']['output'];
  /**  purge Avatar queue  */
  purgeAvatarQueue: Scalars['Boolean']['output'];
  /**  regenerate avatar API key  */
  regenerateAvatarApiKey: Scalars['Boolean']['output'];
  /**  remove avatar API key  */
  removeAvatarApiKey: Scalars['Boolean']['output'];
  /**  remove labels from object  */
  removeLabels: Scalars['Boolean']['output'];
  /**  rename image map layer  */
  renameImageMapLayer: Scalars['Boolean']['output'];
  /**  rename image map set  */
  renameImageMapSet: Scalars['Boolean']['output'];
  /**  rename VAE config  */
  renameVaeConfig: Scalars['Boolean']['output'];
  /**  restore password  */
  restorePassword?: Maybe<Scalars['Boolean']['output']>;
  /**  SOLID config specific, not public  */
  setCurrentView: Scalars['Boolean']['output'];
  /**  set user password, password will be marked as expired  */
  setPassword: Scalars['Boolean']['output'];
  setStore: Scalars['Boolean']['output'];
  /**  set current user realm  */
  setUserRealm: Scalars['Boolean']['output'];
  /**  slew to point  */
  slewToPoint?: Maybe<Scalars['Boolean']['output']>;
  /**  unblock user  */
  unblockUser: Scalars['Boolean']['output'];
  /**  unfollow target  */
  unfollowTarget?: Maybe<Scalars['Boolean']['output']>;
  /**  update camera tour  */
  updateCameraTour: UpdateResult;
  /**  set current realm parameters  */
  updateCurrentRealm: Scalars['Boolean']['output'];
  /**  update device  */
  updateDevice: UpdateResult;
  /**  bulk update devices with a single batched setAttributes call  */
  updateDevices: Scalars['Boolean']['output'];
  /**  store geo map layers  */
  updateGeoLayers: Scalars['Boolean']['output'];
  /**  update geo tour  */
  updateGeoTour: UpdateResult;
  /**  update group  */
  updateGroup: Scalars['Boolean']['output'];
  /**  update hierarchy  */
  updateHierarchy: Scalars['Boolean']['output'];
  /**  update image map  */
  updateImageMap: Scalars['Boolean']['output'];
  /**  update image map layer  */
  updateImageMapLayer: Scalars['Boolean']['output'];
  /**  update image map layer  */
  updateImageMapObject: Scalars['Boolean']['output'];
  /**  update image map set  */
  updateImageMapSet: Scalars['Boolean']['output'];
  /**  update label  */
  updateLabel: Scalars['Boolean']['output'];
  /**  update policy  */
  updatePolicy: Scalars['Boolean']['output'];
  /**  update policy statement  */
  updatePolicyStatement: Scalars['Boolean']['output'];
  /**  update current realm  */
  updateRealm?: Maybe<Scalars['Boolean']['output']>;
  /**  update schedule  */
  updateSchedule: UpdateResult;
  /**  update set  */
  updateSet: Scalars['Boolean']['output'];
  /**  SOLID config specific, not public  */
  updateSolidConfig: Scalars['Boolean']['output'];
  /**  SOLID config specific, not public  */
  updateSolidConfigCurrentView: Scalars['Boolean']['output'];
  updateStats?: Maybe<Scalars['Boolean']['output']>;
  /**  update user  */
  updateUser: Scalars['Boolean']['output'];
  /**  update zone  */
  updateZone: Scalars['Boolean']['output'];
  /**  validate add realm subscription  */
  validateAddSubscription?: Maybe<Scalars['Int']['output']>;
  /**  validate email  */
  validateEmail?: Maybe<Scalars['Boolean']['output']>;
  /**  validate modify realm subscription  */
  validateModifySubscription?: Maybe<Scalars['Int']['output']>;
  /**  verify code  */
  verifyCode?: Maybe<Scalars['Boolean']['output']>;
};


export type MutationAcknowledgeAuditEntryArgs = {
  entry: AcknowledgeAuditEntryInput;
};


export type MutationAcknowledgeEventArgs = {
  context: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  triggeredAt: Scalars['DateTime']['input'];
};


export type MutationActivateAvatarArgs = {
  avatarId: Scalars['ID']['input'];
};


export type MutationActivateEmailArgs = {
  input: SecretPassword;
};


export type MutationAddSharedViewArgs = {
  input: AddSharedViewInput;
};


export type MutationAddSubscriptionArgs = {
  realmSubscription: RealmSubscriptionInput;
};


export type MutationAodCancelArgs = {
  requestIds: Array<Scalars['ID']['input']>;
};


export type MutationAodPauseArgs = {
  requestId: Scalars['ID']['input'];
};


export type MutationAodResumeArgs = {
  requestId: Scalars['ID']['input'];
};


export type MutationAodSubmitArgs = {
  input: AodRequestInput;
};


export type MutationAssignLabelsArgs = {
  ids: Array<Scalars['ID']['input']>;
  objectId: Scalars['ID']['input'];
};


export type MutationAuditEntriesAcknowledgmentArgs = {
  entries: Array<AcknowledgeAuditEntryInput>;
};


export type MutationBlockUserArgs = {
  id: Scalars['ID']['input'];
};


export type MutationChangeCurrentPasswordArgs = {
  input: ChangeCurrentPasswordInput;
};


export type MutationChangeDeliveryPriorityArgs = {
  devices: Array<DeliveryPriorityInput>;
};


export type MutationChangeLocalStorageArgs = {
  id: Scalars['ID']['input'];
  input: LocalStorageInput;
};


export type MutationChangePasswordArgs = {
  input: ChangePasswordInput;
};


export type MutationCreateAuditEntryEventArgs = {
  entry: AuditEntryInput;
};


export type MutationCreateAvatarApiKeyArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCreateCameraTourArgs = {
  input: CameraTourInput;
};


export type MutationCreateDeviceArgs = {
  device: DeviceInput;
};


export type MutationCreateEventArgs = {
  entry: CreateEventEntry;
};


export type MutationCreateGatewayDeviceArgs = {
  device: DeviceInput;
};


export type MutationCreateGeoTourArgs = {
  input: GeoTourInput;
};


export type MutationCreateGroupArgs = {
  group: GroupInput;
};


export type MutationCreatePolicyArgs = {
  policy: PolicyInput;
};


export type MutationCreatePolicyStatementArgs = {
  policyId: Scalars['ID']['input'];
  statement: PolicyStatementInput;
};


export type MutationCreateScheduleArgs = {
  schedule: ScheduleInput;
};


export type MutationCreateSensorDeviceArgs = {
  device: DeviceInput;
};


export type MutationCreateSetArgs = {
  set: SetInput;
};


export type MutationCreateTargetArgs = {
  input: TargetInput;
};


export type MutationCreateUserArgs = {
  user: UserInput;
};


export type MutationCreateVaeConfigArgs = {
  deviceId: Scalars['ID']['input'];
  engine: Scalars['String']['input'];
  name: Scalars['String']['input'];
};


export type MutationCreateZoneArgs = {
  zone: ZoneInput;
};


export type MutationDeleteCameraTourArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteDeviceArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteDevicesArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteGeoLayerArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteGeoTourArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteGroupArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteHierarchyArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteImageMapLayerArgs = {
  layerId: Scalars['ID']['input'];
  updateId: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type MutationDeleteImageMapObjectArgs = {
  objectId: Scalars['ID']['input'];
  updateId: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type MutationDeleteImageMapSetArgs = {
  setId: Scalars['ID']['input'];
  updateId: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type MutationDeleteLabelArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePolicyArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePolicyStatementArgs = {
  statementId: Scalars['ID']['input'];
};


export type MutationDeleteScheduleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSetArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSharedViewArgs = {
  input: DeleteSharedViewInput;
};


export type MutationDeleteSubscriptionArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteUserArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteVaeConfigArgs = {
  deviceId: Scalars['ID']['input'];
  engine: Scalars['String']['input'];
  name: Scalars['String']['input'];
};


export type MutationDeleteZoneArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeviceCommandArgs = {
  command: DeviceCommand;
  id: Scalars['ID']['input'];
};


export type MutationEventsAcknowledgementArgs = {
  entries: Array<AcknowledgementEntry>;
};


export type MutationFollowTargetArgs = {
  targetId: Scalars['ID']['input'];
};


export type MutationInsertHierarchyArgs = {
  hierarchy: HierarchyInput;
};


export type MutationInsertImageMapLayerArgs = {
  layer: ImageMapLayerInput;
  setId: Scalars['ID']['input'];
  updateId: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type MutationInsertImageMapObjectArgs = {
  mapId: Scalars['ID']['input'];
  object: ImageMapObjectInput;
  updateId: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type MutationInsertImageMapSetArgs = {
  set: ImageMapSetInput;
  updateId: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type MutationInsertLabelsArgs = {
  labels: Array<LabelInput>;
};


export type MutationModifySubscriptionArgs = {
  realmSubscription: RealmSubscriptionInput;
};


export type MutationPtzAbsArgs = {
  id: Scalars['ID']['input'];
  input: Ptz_AbsInput;
  priority?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationPtzHardwareArgs = {
  id: Scalars['ID']['input'];
  input: Ptz_HardwareInput;
  priority?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationPtzLockArgs = {
  id: Scalars['ID']['input'];
  token?: InputMaybe<Scalars['String']['input']>;
};


export type MutationPtzPresetArgs = {
  id: Scalars['ID']['input'];
  input: Ptz_PresetInput;
  priority?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationPtzRelArgs = {
  id: Scalars['ID']['input'];
  input: Ptz_RelInput;
  priority?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationPtzSettingsArgs = {
  id: Scalars['ID']['input'];
  input: Ptz_SettingsInput;
  priority?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationPtzSpeedArgs = {
  id: Scalars['ID']['input'];
  input: Ptz_SpeedInput;
  priority?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationPtzStepArgs = {
  id: Scalars['ID']['input'];
  input: Ptz_StepInput;
  priority?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationPtzUnlockArgs = {
  explicit?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationPurgeAvatarQueueArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRegenerateAvatarApiKeyArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveAvatarApiKeyArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveLabelsArgs = {
  ids: Array<Scalars['ID']['input']>;
  objectId: Scalars['ID']['input'];
};


export type MutationRenameImageMapLayerArgs = {
  layerId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  updateId: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type MutationRenameImageMapSetArgs = {
  name: Scalars['String']['input'];
  setId: Scalars['ID']['input'];
  updateId: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type MutationRenameVaeConfigArgs = {
  deviceId: Scalars['ID']['input'];
  engine: Scalars['String']['input'];
  name: Scalars['String']['input'];
  newName: Scalars['String']['input'];
};


export type MutationRestorePasswordArgs = {
  input: SecretPassword;
};


export type MutationSetCurrentViewArgs = {
  viewId: Scalars['ID']['input'];
};


export type MutationSetPasswordArgs = {
  input: SetPasswordInput;
};


export type MutationSetStoreArgs = {
  store: AppStoreInput;
};


export type MutationSetUserRealmArgs = {
  realmId: Scalars['ID']['input'];
  userName: Scalars['String']['input'];
};


export type MutationSlewToPointArgs = {
  latLng: LatLngInput;
};


export type MutationUnblockUserArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUnfollowTargetArgs = {
  targetId: Scalars['ID']['input'];
};


export type MutationUpdateCameraTourArgs = {
  id: Scalars['ID']['input'];
  input: CameraTourInput;
};


export type MutationUpdateCurrentRealmArgs = {
  realm: CurrentRealmInput;
};


export type MutationUpdateDeviceArgs = {
  device: DeviceInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateDevicesArgs = {
  list: Array<BulkDeviceInput>;
};


export type MutationUpdateGeoLayersArgs = {
  input: GeoLayersInput;
};


export type MutationUpdateGeoTourArgs = {
  id: Scalars['ID']['input'];
  input: GeoTourInput;
};


export type MutationUpdateGroupArgs = {
  group: GroupInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateHierarchyArgs = {
  hierarchy: HierarchyInput;
};


export type MutationUpdateImageMapArgs = {
  map: ImageMapInput;
  updateId: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type MutationUpdateImageMapLayerArgs = {
  layer: ImageMapLayerInput;
  updateId: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type MutationUpdateImageMapObjectArgs = {
  object: ImageMapObjectInput;
  updateId: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type MutationUpdateImageMapSetArgs = {
  set: ImageMapSetInput;
  updateId: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type MutationUpdateLabelArgs = {
  label: LabelInput;
};


export type MutationUpdatePolicyArgs = {
  id: Scalars['ID']['input'];
  policy: PolicyInput;
};


export type MutationUpdatePolicyStatementArgs = {
  statement: PolicyStatementInput;
  statementId: Scalars['ID']['input'];
};


export type MutationUpdateRealmArgs = {
  realmInput: RealmInput;
};


export type MutationUpdateScheduleArgs = {
  id: Scalars['ID']['input'];
  schedule: ScheduleUpdateInput;
};


export type MutationUpdateSetArgs = {
  id: Scalars['ID']['input'];
  set: SetInput;
};


export type MutationUpdateSolidConfigArgs = {
  solidConfig?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateSolidConfigCurrentViewArgs = {
  input: SolidConfigCurrentViewInput;
};


export type MutationUpdateStatsArgs = {
  id: Scalars['ID']['input'];
  stats: StatsInput;
};


export type MutationUpdateUserArgs = {
  id: Scalars['ID']['input'];
  user: UserInput;
};


export type MutationUpdateZoneArgs = {
  id: Scalars['ID']['input'];
  zone: ZoneInput;
};


export type MutationValidateAddSubscriptionArgs = {
  realmSubscription: RealmSubscriptionInput;
};


export type MutationValidateEmailArgs = {
  addresses: EmailAddresses;
};


export type MutationValidateModifySubscriptionArgs = {
  realmSubscription: RealmSubscriptionInput;
};


export type MutationVerifyCodeArgs = {
  code: Scalars['String']['input'];
};

export type NetworkConnectDescriptor = {
  __typename?: 'NetworkConnectDescriptor';
  /** Complete URL to camera stream for URL config type */
  URL?: Maybe<Scalars['String']['output']>;
  authType: AuthType;
  /** Authorization credentials (private key, certificate) */
  credentials?: Maybe<Credentials>;
  /** IP/host for ONVIF config type */
  host?: Maybe<Scalars['String']['output']>;
  /**
   * IPs of Avatar
   * Do not use, for internal use only
   */
  hosts?: Maybe<Array<Scalars['String']['output']>>;
  /** Password for ONVIF config type */
  pass?: Maybe<Scalars['String']['output']>;
  /** HTTP port for ONVIF config type */
  port?: Maybe<Scalars['Int']['output']>;
  /** Protocol for gateway */
  protocol?: Maybe<ProtocolType>;
  /** RTSP port for ONVIF config type */
  rtspPort?: Maybe<Scalars['Int']['output']>;
  /** UDP port for ToC sensor | UDP listening port for Elta sensor */
  udpPort?: Maybe<Scalars['Int']['output']>;
  /** Username for ONVIF config type */
  user?: Maybe<Scalars['String']['output']>;
};

export type NetworkConnectDescriptorInput = {
  URL?: InputMaybe<Scalars['String']['input']>;
  authType: AuthType;
  credentials?: InputMaybe<CredentialsInput>;
  host?: InputMaybe<Scalars['String']['input']>;
  pass?: InputMaybe<Scalars['String']['input']>;
  port?: InputMaybe<Scalars['Int']['input']>;
  protocol?: InputMaybe<ProtocolType>;
  rtspPort?: InputMaybe<Scalars['Int']['input']>;
  udpPort?: InputMaybe<Scalars['Int']['input']>;
  user?: InputMaybe<Scalars['String']['input']>;
};

export type NumericReport = {
  __typename?: 'NumericReport';
  /**  Unix timestamp, sec  */
  time: Scalars['Int']['output'];
  /**  Metric value  */
  value: Scalars['Float']['output'];
};

export type ObjUuid = {
  __typename?: 'ObjUUID';
  obj: Scalars['UUID']['output'];
};

export type ObjUuidAndName = {
  __typename?: 'ObjUUIDAndName';
  isAdmin: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  obj: Scalars['UUID']['output'];
};

export type ObjUuidAndNameInput = {
  name: Scalars['String']['input'];
  obj: Scalars['UUID']['input'];
};

export type ObjUuidInput = {
  obj: Scalars['UUID']['input'];
};

export enum ObjectAction {
  AddLink = 'ADD_LINK',
  Create = 'CREATE',
  Delete = 'DELETE',
  PtzLockProlongation = 'PTZ_LOCK_PROLONGATION',
  PtzStatus = 'PTZ_STATUS',
  RemoveLink = 'REMOVE_LINK',
  Status = 'STATUS',
  Update = 'UPDATE',
  VaeStatus = 'VAE_STATUS'
}

/** Object descriptor to provide access to basic object info only */
export type ObjectDescriptor = {
  __typename?: 'ObjectDescriptor';
  /** Object ID (UUID) */
  id: Scalars['ID']['output'];
  isSystemManaged?: Maybe<Scalars['Boolean']['output']>;
  /** Object name */
  name: Scalars['String']['output'];
  type: RealmObjectType;
};

export type ObjectUpdateEvent = {
  __typename?: 'ObjectUpdateEvent';
  action: ObjectAction;
  childObjects?: Maybe<Array<Scalars['ID']['output']>>;
  healthStatus?: Maybe<HealthStatus>;
  id: Scalars['ID']['output'];
  ptzLockProlongation?: Maybe<PtzLockProlongation>;
  ptzStatus?: Maybe<PtzStatus>;
  realmId: Scalars['ID']['output'];
  systemStatus?: Maybe<SystemStatus>;
  type: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  vaeStatus?: Maybe<Array<VaeReasonStatus>>;
};

export type ObjectUpdateFilter = {
  actions?: InputMaybe<Array<ObjectAction>>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type OnvifServiceConfig = {
  __typename?: 'OnvifServiceConfig';
  /**  Bind address   */
  bindIp: Scalars['String']['output'];
  /**  Enable WS-Discovery multicast  */
  enableDiscovery: Scalars['Boolean']['output'];
  /**  Enable onvif service configuration  */
  enabled: Scalars['Boolean']['output'];
  /**  TCP port for SOAP listener   */
  httpPort: Scalars['Int']['output'];
  /**  Password for ONVIF user  */
  pass: Scalars['String']['output'];
  /**  Status of ONVIF service  */
  status?: Maybe<OnvifServiceStatus>;
  /**  ONVIF user for WS-Security auth   */
  user: Scalars['String']['output'];
};

export type OnvifServiceConfigInput = {
  /**  Bind address   */
  bindIp: Scalars['String']['input'];
  /**  Enable WS-Discovery multicast  */
  enableDiscovery: Scalars['Boolean']['input'];
  /**  Enable onvif service configuration  */
  enabled: Scalars['Boolean']['input'];
  /**  TCP port for SOAP listener   */
  httpPort: Scalars['Int']['input'];
  /**  Password for ONVIF user  */
  pass: Scalars['String']['input'];
  /**  ONVIF user for WS-Security auth   */
  user: Scalars['String']['input'];
};

export type OnvifServiceStatus = {
  __typename?: 'OnvifServiceStatus';
  error?: Maybe<Scalars['String']['output']>;
  running?: Maybe<Scalars['Boolean']['output']>;
};

export type Owner = {
  __typename?: 'Owner';
  createdAt: Scalars['DateTime']['output'];
  displayName: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type OwnerInput = {
  displayName: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
};

export type Ptz_AbsInput = {
  /**  Move camera to center(pt=[0,0])  */
  center?: InputMaybe<Scalars['Boolean']['input']>;
  /**  HFOV, hfovMin...hfovMax  */
  hfov?: InputMaybe<Scalars['Float']['input']>;
  /**  Move to position with pan and tilt degrees, [-180...180, -90...90]. ex: [10, 30]  */
  pt?: InputMaybe<Array<Scalars['Float']['input']>>;
  /**  Zoom in/out, 0...100  */
  z?: InputMaybe<Scalars['Int']['input']>;
};

export enum Ptz_Class {
  /**  Support for absolute positioning in camera-mount-relative system of coordinates  */
  PtzAbsolute = 'PTZ_ABSOLUTE',
  /**  Continuous and speed controls  */
  PtzContinous = 'PTZ_CONTINOUS',
  /**  Click-On-Screen  */
  PtzCos = 'PTZ_COS',
  /**  Support for absolute positioning in geo-coordinates  */
  PtzGeoAbsolute = 'PTZ_GEO_ABSOLUTE',
  /**  PTZ Presents support  */
  PtzPresets = 'PTZ_PRESETS',
  /**  Step controls  */
  PtzStep = 'PTZ_STEP'
}

export enum Ptz_HardwareDo {
  Defaults = 'defaults',
  Reset = 'reset'
}

export type Ptz_HardwareInput = {
  /**
   * 'Hard reset' - reset by moving to absolute 0/0.
   * defaults – set all parameters to default values;
   * reset – hardware reset of the camera
   */
  do?: InputMaybe<Ptz_HardwareDo>;
};

/**  will be executed first method  */
export type Ptz_PresetInput = {
  /**  Delete preset position, 1..100  */
  clear?: InputMaybe<Scalars['Int']['input']>;
  /**  Goto preset position, 1..100  */
  goto?: InputMaybe<Scalars['Int']['input']>;
  /**  Save current position, 1..100  */
  save?: InputMaybe<Scalars['Int']['input']>;
};

export type Ptz_RelInput = {
  /**  Video resolution  */
  size: Ptz_RelSizeInput;
  /**  Center camera to x,y position (based on video resolution)  */
  xy: Array<Scalars['Int']['input']>;
};

export type Ptz_RelSizeInput = {
  height: Scalars['Int']['input'];
  width: Scalars['Int']['input'];
};

export type Ptz_SettingsInput = {
  /**  On/Off auto focus camera parameter */
  autofocus?: InputMaybe<Scalars['Boolean']['input']>;
  /**  Switch polarity - mainly for FLIR IR cameras to switch between White Hot and Black Hot  */
  polarity?: InputMaybe<Ptz_SettingsPolarity>;
  /**  Switch between the IR and Visible cameras  */
  switch?: InputMaybe<Ptz_SettingsSwitch>;
};

export enum Ptz_SettingsPolarity {
  Black = 'black',
  White = 'white'
}

export enum Ptz_SettingsSwitch {
  Ir = 'ir',
  Visible = 'visible'
}

/**  will be executed first method  */
export type Ptz_SpeedInput = {
  /**  Focus with speed, -100...100  */
  focus?: InputMaybe<Scalars['Int']['input']>;
  /**  Gain with speed, -100...100  */
  gain?: InputMaybe<Scalars['Int']['input']>;
  /**  Iris with speed, -100...100  */
  iris?: InputMaybe<Scalars['Int']['input']>;
  /**  Move with speeds for pan and tilt, [-100..100,-100..100]. ex: [10, 30]  */
  pt?: InputMaybe<Array<Scalars['Int']['input']>>;
  /**  Zoom in/out with speed, -100...100  */
  z?: InputMaybe<Scalars['Int']['input']>;
};

export enum Ptz_StepFocus {
  Far = 'far',
  Near = 'near'
}

export enum Ptz_StepGain {
  Down = 'down',
  Up = 'up'
}

/**  will be executed first method  */
export type Ptz_StepInput = {
  focus?: InputMaybe<Ptz_StepFocus>;
  gain?: InputMaybe<Ptz_StepGain>;
  iris?: InputMaybe<Ptz_StepIris>;
  move?: InputMaybe<Ptz_StepMove>;
  zoom?: InputMaybe<Ptz_StepZoom>;
};

export enum Ptz_StepIris {
  Close = 'close',
  Open = 'open'
}

/**  Do one step in specific direction  */
export enum Ptz_StepMove {
  Down = 'down',
  Downleft = 'downleft',
  Downright = 'downright',
  Left = 'left',
  Right = 'right',
  Up = 'up',
  Upleft = 'upleft',
  Upright = 'upright'
}

export enum Ptz_StepZoom {
  In = 'in',
  Out = 'out'
}

export type Policy = RealmObject & {
  __typename?: 'Policy';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  groups: Array<Group>;
  id: Scalars['ID']['output'];
  isSystemManaged: Scalars['Boolean']['output'];
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  statements: Array<PolicyStatement>;
  type: RealmObjectType;
};

export type PolicyInput = {
  addToGroupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  removeFromGroupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type PolicyStatement = {
  __typename?: 'PolicyStatement';
  actions: Array<Scalars['String']['output']>;
  allResources: Scalars['Boolean']['output'];
  effect: StatementEffect;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  resources: Array<ObjectDescriptor>;
};

export type PolicyStatementInput = {
  actions?: InputMaybe<Array<Scalars['String']['input']>>;
  addResourceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  allResources?: InputMaybe<Scalars['Boolean']['input']>;
  effect?: InputMaybe<StatementEffect>;
  name?: InputMaybe<Scalars['String']['input']>;
  removeResourceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type PoolLocalStorage = {
  __typename?: 'PoolLocalStorage';
  enforce: Scalars['String']['output'];
  path: Scalars['String']['output'];
  size: Scalars['String']['output'];
};

export type PoolLocalStorageInput = {
  enforce: Scalars['String']['input'];
  path: Scalars['String']['input'];
  size: Scalars['String']['input'];
};

export type Position = {
  __typename?: 'Position';
  x: Scalars['Int']['output'];
  y: Scalars['Int']['output'];
};

export type PositionInput = {
  x: Scalars['Int']['input'];
  y: Scalars['Int']['input'];
};

export enum ProtocolType {
  Http = 'HTTP',
  Https = 'HTTPS'
}

export type PtzAbsArgs = {
  __typename?: 'PtzAbsArgs';
  pan?: Maybe<Scalars['Float']['output']>;
  tilt?: Maybe<Scalars['Float']['output']>;
  zoom?: Maybe<Scalars['Int']['output']>;
};

export enum PtzAttachedBaudRate {
  Baud9600 = 'Baud9600',
  Baud14400 = 'Baud14400',
  Baud19200 = 'Baud19200',
  Baud28800 = 'Baud28800',
  Baud38400 = 'Baud38400',
  Baud57600 = 'Baud57600',
  Baud115200 = 'Baud115200'
}

export enum PtzAttachedCameraModel {
  FlirFSeries = 'FlirFSeries',
  FlirRanger = 'FlirRanger',
  FlirSr100 = 'FlirSr100',
  Other = 'Other',
  SonyFcbEx980 = 'SonyFcbEx980',
  SonyWithIr = 'SonyWithIr'
}

export enum PtzAttachedSerialMode {
  Auto = 'Auto',
  Rs232 = 'RS232',
  Rs422 = 'RS422',
  Rs485_2Wire = 'RS485_2Wire',
  Rs485_4Wire = 'RS485_4Wire'
}

export type PtzLock = {
  __typename?: 'PtzLock';
  category: PtzLockCategory;
  expire: Scalars['DateTime']['output'];
  explicit?: Maybe<Scalars['Boolean']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
  userName?: Maybe<Scalars['String']['output']>;
};

export enum PtzLockCategory {
  Admin = 'admin',
  Slew = 'slew',
  Tour = 'tour',
  User = 'user'
}

export type PtzLockProlongation = {
  __typename?: 'PtzLockProlongation';
  createdAt: Scalars['DateTime']['output'];
  token: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type PtzLockResult = {
  __typename?: 'PtzLockResult';
  token: Scalars['String']['output'];
};

export enum PtzLockType {
  Slew = 'slew',
  Tour = 'tour',
  User = 'user'
}

export type PtzPosition = {
  __typename?: 'PtzPosition';
  hfov: Scalars['Float']['output'];
  pan: Scalars['Float']['output'];
  tilt: Scalars['Float']['output'];
};

export type PtzStatus = {
  __typename?: 'PtzStatus';
  lock?: Maybe<PtzLock>;
  lockProlongation?: Maybe<PtzLockProlongation>;
  position?: Maybe<PtzPosition>;
};

export type PtzTcpAddress = {
  __typename?: 'PtzTcpAddress';
  ip?: Maybe<Scalars['String']['output']>;
  port?: Maybe<Scalars['Int']['output']>;
};

export type PtzTcpAddressInput = {
  ip?: InputMaybe<Scalars['String']['input']>;
  port?: InputMaybe<Scalars['Int']['input']>;
};

export enum PtzType {
  ClearAlign = 'ClearAlign',
  Moog = 'Moog',
  Onvif = 'Onvif',
  None = 'none'
}

export enum PtzUpdateAction {
  Abs = 'abs',
  Lock = 'lock',
  Unlock = 'unlock'
}

export type QortexMappedZone = {
  __typename?: 'QortexMappedZone';
  name: Scalars['String']['output'];
  witness: Array<Scalars['String']['output']>;
};

export type QortexMappedZoneInput = {
  name: Scalars['String']['input'];
  witness: Array<Scalars['String']['input']>;
};

export type QortexZone = {
  __typename?: 'QortexZone';
  name: Scalars['String']['output'];
  points: Array<QortexZonePoint>;
  witness?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  zMax: Scalars['Int']['output'];
  zMin: Scalars['Int']['output'];
};

export type QortexZoneInput = {
  name: Scalars['String']['input'];
  points: Array<QortexZonePointInput>;
  witness?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  zMax: Scalars['Int']['input'];
  zMin: Scalars['Int']['input'];
};

export type QortexZonePoint = {
  __typename?: 'QortexZonePoint';
  x: Scalars['Float']['output'];
  y: Scalars['Float']['output'];
};

export type QortexZonePointInput = {
  x: Scalars['Float']['input'];
  y: Scalars['Float']['input'];
};

export type Query = {
  __typename?: 'Query';
  /**  get list of access levels  */
  accessLevels: Array<AccessLevel>;
  /**  get list of actions  */
  actions: Array<Action>;
  /**  get AOD (Archive on Demand) requests by id  */
  aodGet: Array<AodRequest>;
  /**  get list AOD (Archive on Demand) requests  */
  aodGetList: Array<AodRequest>;
  /**  get list of updated AOD (Archive on Demand) requests  */
  aodGetUpdatedList: Array<AodRequest>;
  /**  get information about device archive coverage boundaries  */
  archiveBoundary: ArchiveBoundary;
  /**  get information about device archive coverage  */
  archiveCoverage: ArchiveCoverage;
  /**  get archive merged targets  */
  archiveTargets: Array<Target>;
  /**  get list of aspects templates  */
  aspectTemplates: Array<FunctionalAspectTemplate>;
  /**  get list of audit categories  */
  auditCategories: Array<AuditCategory>;
  /**  get list of audit events  */
  auditEntries: Array<AuditEntry>;
  /**  get audit entry by id  */
  auditEntry?: Maybe<AuditEntry>;
  /**  get list of avalilable features  */
  availableFeatures?: Maybe<Array<FeatureDesc>>;
  /**  Get a description and all possible metrics for avatar/link  */
  avatarMetrics: Array<AvatarMetric>;
  /**  Get the required avatar/link report  */
  avatarReport: Array<NumericReport>;
  /**  get brand information  */
  branding?: Maybe<Branding>;
  /**  get camera log  */
  cameraLog: Array<CameraLog>;
  /**  Get a description and all possible metrics for current camera  */
  cameraMetrics: Array<CameraMetric>;
  /**  Get the required camera report  */
  cameraReport: Array<Report>;
  /**  get camera tour by id  */
  cameraTour?: Maybe<CameraTour>;
  /**  get list of camera tours  */
  cameraTours: Array<CameraTour>;
  /**  get information about current realm  */
  currentRealm: CurrentRealm;
  /**  get device by id  */
  device?: Maybe<Device>;
  /**  get device functional aspects by aspect type  */
  deviceFunctionalAspectsByAspectTypes: Array<DeviceFunctionalAspect>;
  /**  get list of device templates  */
  deviceTemplates: Array<DeviceTemplate>;
  /**  get list of devices  */
  devices: Array<Device>;
  /**  get list of devices by aspect type  */
  devicesByAspectTypes: Array<Device>;
  /**  get list of devices by id  */
  devicesByIds: Array<Device>;
  /**  discover devices  */
  discoverDevices: Array<DeviceProbe>;
  /**  check is email can be send  */
  emailCanBeSend?: Maybe<Scalars['Boolean']['output']>;
  /**
   *  follow target
   * @deprecated use mutation followTarget
   */
  followTarget?: Maybe<Scalars['Boolean']['output']>;
  /**  get stored geo map layers  */
  geoLayers?: Maybe<GeoLayers>;
  /**  get Geo tour by id  */
  geoTour?: Maybe<GeoTour>;
  /**  get list of geo tours  */
  geoTours: Array<GeoTour>;
  /**  get grafana dashboards  */
  grafanaDashboards: Array<GrafanaDashboard>;
  /**  get group by id  */
  group?: Maybe<Group>;
  /**  get list of groups  */
  groups: Array<Group>;
  /**  get list guis  */
  guis: Array<Gui>;
  /**  get list of hierarchies  */
  hierarchies: Array<Hierarchy>;
  /**  get hierarchy by id  */
  hierarchy?: Maybe<Hierarchy>;
  /**  get 'contact us' information  */
  identityAttribute?: Maybe<IdentityAttribute>;
  /**  get image map config  */
  imageMapConfig: ImageMapConfig;
  /**  get image map image  */
  imageMapImage: Scalars['String']['output'];
  /**  get label by id  */
  label?: Maybe<Label>;
  /**  get list of labels  */
  labels: Array<Label>;
  /**  get list of labels for object  */
  labelsForObject: Array<Label>;
  /**  get languages list  */
  languages?: Maybe<Languages>;
  /**  get End User License Agreement  */
  license: License;
  /**  get config of local storage for avatar by id  */
  localStorage?: Maybe<LocalStorage>;
  /**  get list of policies  */
  policies: Array<Policy>;
  /**  get policy by id  */
  policy?: Maybe<Policy>;
  /**  probe device  */
  probeDevice: DeviceProbe;
  /**  get gateway devices and directories  */
  probeGateway: GatewayProbe;
  /**  get gateway directories  */
  probeGatewayDirectories: GatewayDirectoriesProbe;
  /**  probe sensor device  */
  probeSensorDevice: DeviceProbe;
  /**  get current realm  */
  realm?: Maybe<Realm>;
  /**  get realm object by id  */
  realmObject?: Maybe<RealmObject>;
  /**  get list of realm objects  */
  realmObjects: Array<RealmObject>;
  /**  get realm subscription by id  */
  realmSubscription: RealmSubscription;
  /**  get list of realm subscriptions  */
  realmSubscriptions?: Maybe<Array<RealmSubscription>>;
  /**  get list of entries require acknowledge  */
  requireAcknowledgeEntries: Array<AuditEntry>;
  /**  get schedule by id  */
  schedule?: Maybe<Schedule>;
  /**  get list of schedule action templates  */
  scheduleActionTemplates: Array<ScheduleActionTemplate>;
  /**  get list of schedules  */
  schedules: Array<Schedule>;
  /**  get server time  */
  serverTime: Scalars['DateTime']['output'];
  /**  simple call to continue session  */
  sessionInfo?: Maybe<Scalars['Boolean']['output']>;
  /**  get set by id  */
  set?: Maybe<Set>;
  /**  get list of sets  */
  sets: Array<Set>;
  /**
   *  slew to point
   * @deprecated use mutation slewToPoint
   */
  slewToPoint?: Maybe<Scalars['Boolean']['output']>;
  /**  SOLID config specific, not public  */
  solidConfig?: Maybe<Scalars['String']['output']>;
  /**  get list of storage pools  */
  storagePools: Array<StoragePool>;
  /**  get state of used local storage space for avatar by id  */
  storageUsage?: Maybe<StorageUsage>;
  store: AppStore;
  /**  get system parameters (app version, google map keys, etc )  */
  systemParameters?: Maybe<SystemParameters>;
  /**  get system status  */
  systemStatus: SystemStatusInfo;
  /**  get target by id (for the last day)  */
  target?: Maybe<Target>;
  /**  get stored targets  */
  targets: Array<Target>;
  /**
   *  unfollow target
   * @deprecated use mutation unfollowTarget
   */
  unfollowTarget?: Maybe<Scalars['Boolean']['output']>;
  /**  get user by id  */
  user?: Maybe<User>;
  /**  get info about user  */
  userInfo: UserInfo;
  /**  get list of user realms  */
  userRealms: Array<Realm>;
  /**  get list of users  */
  users: Array<User>;
  /**  get list of VAE configs for device with id  */
  vaeConfigs: Array<VaeConfigBrief>;
  /**  get list of VAE templates for device with id  */
  vaeTemplates: Array<FunctionalAspectTemplate>;
  /**  get zone by id  */
  zone?: Maybe<Zone>;
  /**  get list of zones  */
  zones: Array<Zone>;
};


export type QueryAodGetArgs = {
  endTime: Scalars['DateTime']['input'];
  ids: Array<Scalars['ID']['input']>;
  startTime: Scalars['DateTime']['input'];
  streams?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type QueryAodGetListArgs = {
  endTime: Scalars['DateTime']['input'];
  startTime: Scalars['DateTime']['input'];
};


export type QueryAodGetUpdatedListArgs = {
  updatedFrom: Scalars['DateTime']['input'];
};


export type QueryArchiveBoundaryArgs = {
  find: BoundaryFind;
  ids: Array<Scalars['ID']['input']>;
  startTime: Scalars['DateTime']['input'];
  streamNumbers: Array<Scalars['Int']['input']>;
};


export type QueryArchiveCoverageArgs = {
  endTime: Scalars['DateTime']['input'];
  ids: Array<Scalars['ID']['input']>;
  location?: InputMaybe<ArchiveLocation>;
  startTime: Scalars['DateTime']['input'];
  streams?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type QueryArchiveTargetsArgs = {
  filter: TargetFilter;
};


export type QueryAuditEntriesArgs = {
  filter: AuditEntryFilter;
};


export type QueryAuditEntryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAvatarReportArgs = {
  from: Scalars['DateTime']['input'];
  id: Scalars['ID']['input'];
  metricName: AvatarMetricName;
  to: Scalars['DateTime']['input'];
};


export type QueryCameraLogArgs = {
  deviceId: Scalars['ID']['input'];
};


export type QueryCameraMetricsArgs = {
  from?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['ID']['input'];
  to?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryCameraReportArgs = {
  dfaId: Scalars['Int']['input'];
  from: Scalars['DateTime']['input'];
  id: Scalars['ID']['input'];
  metricName: CameraMetricName;
  to: Scalars['DateTime']['input'];
};


export type QueryCameraTourArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDeviceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDeviceFunctionalAspectsByAspectTypesArgs = {
  types: Array<DeviceFunctionalAspectFilter>;
};


export type QueryDevicesByAspectTypesArgs = {
  types: Array<DeviceFunctionalAspectFilter>;
};


export type QueryDevicesByIdsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QueryDiscoverDevicesArgs = {
  platformId: Scalars['ID']['input'];
};


export type QueryFollowTargetArgs = {
  targetId: Scalars['ID']['input'];
};


export type QueryGeoTourArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGrafanaDashboardsArgs = {
  folderId: Scalars['String']['input'];
};


export type QueryGroupArgs = {
  id: Scalars['ID']['input'];
};


export type QueryHierarchyArgs = {
  id: Scalars['ID']['input'];
};


export type QueryImageMapConfigArgs = {
  lazyLoadImages?: InputMaybe<Scalars['Boolean']['input']>;
  version: Scalars['String']['input'];
};


export type QueryImageMapImageArgs = {
  mapId: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryLabelArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLabelsForObjectArgs = {
  objectId: Scalars['ID']['input'];
};


export type QueryLocalStorageArgs = {
  deviceId: Scalars['ID']['input'];
};


export type QueryPolicyArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProbeDeviceArgs = {
  input: DeviceProbeInput;
};


export type QueryProbeGatewayArgs = {
  input: GatewayProbeInput;
};


export type QueryProbeGatewayDirectoriesArgs = {
  input: GatewayDirectoriesProbeInput;
};


export type QueryProbeSensorDeviceArgs = {
  input: DeviceProbeInput;
};


export type QueryRealmObjectArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRealmSubscriptionArgs = {
  adminLogin?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Filter>;
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryRealmSubscriptionsArgs = {
  filter?: InputMaybe<Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryRequireAcknowledgeEntriesArgs = {
  filter: AuditEntryFilter;
};


export type QueryScheduleArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySetArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySlewToPointArgs = {
  latLng: LatLngInput;
};


export type QuerySolidConfigArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryStorageUsageArgs = {
  deviceId: Scalars['ID']['input'];
};


export type QueryTargetArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTargetsArgs = {
  filter: TargetFilter;
};


export type QueryUnfollowTargetArgs = {
  targetId: Scalars['ID']['input'];
};


export type QueryUserArgs = {
  id: Scalars['ID']['input'];
};


export type QueryVaeConfigsArgs = {
  deviceId: Scalars['ID']['input'];
  engine: Scalars['String']['input'];
};


export type QueryVaeTemplatesArgs = {
  deviceId: Scalars['ID']['input'];
};


export type QueryZoneArgs = {
  id: Scalars['ID']['input'];
};

/** Realm base type */
export type Realm = RealmObject & {
  __typename?: 'Realm';
  adminEmail?: Maybe<Scalars['String']['output']>;
  alarmTargetsClear?: Maybe<Scalars['Boolean']['output']>;
  alarmTargetsClearTime?: Maybe<Scalars['Int']['output']>;
  auditTtl?: Maybe<Scalars['String']['output']>;
  avatarLocalStreaming?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  defaultMapLayer?: Maybe<MapType>;
  emailAuth?: Maybe<EmailAuth>;
  emailEnabled?: Maybe<Scalars['Boolean']['output']>;
  emailFrom?: Maybe<Scalars['String']['output']>;
  emailHost?: Maybe<Scalars['String']['output']>;
  emailPass?: Maybe<Scalars['String']['output']>;
  emailPort?: Maybe<Scalars['Int']['output']>;
  emailTls?: Maybe<Scalars['Boolean']['output']>;
  emailUser?: Maybe<Scalars['String']['output']>;
  emailValidated?: Maybe<Scalars['Boolean']['output']>;
  esriAccessToken?: Maybe<Scalars['String']['output']>;
  esriMapTileUrl?: Maybe<Scalars['String']['output']>;
  geoIconSet?: Maybe<GeoIconSet>;
  /**  Geo map marker clustering options(enabled, disabledClusterAtZoom, maxClusterRadius)  */
  geoMarkerClusterConfig?: Maybe<Array<GeoMarkerClusterConfig>>;
  /**  Map monitoring zone configuration  */
  geoZone: Scalars['JSONObject']['output'];
  googleMapsApiKey?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  jitterBufferLength?: Maybe<Scalars['Int']['output']>;
  /**  realm settings  */
  maxDownloadTime?: Maybe<Scalars['Int']['output']>;
  maxScheduledDeliveryDelay?: Maybe<Scalars['Int']['output']>;
  maxVideoPlayers?: Maybe<Scalars['Int']['output']>;
  mfAuth?: Maybe<Scalars['Boolean']['output']>;
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  normalTargetsClearTime?: Maybe<Scalars['Int']['output']>;
  playerIdleTimeout?: Maybe<Scalars['Int']['output']>;
  /**  Record a minimum post-event time  */
  postEventTime: Scalars['Int']['output'];
  /**  Record a minimum pre-event time, seconds  */
  preEventTime: Scalars['Int']['output'];
  realmObjects?: Maybe<Array<RealmObject>>;
  resellerParent?: Maybe<Reseller>;
  trackerMinTrackingTime?: Maybe<Scalars['Int']['output']>;
  trackerStaleTimeout?: Maybe<Scalars['Int']['output']>;
  type: RealmObjectType;
  /** @deprecated use modifiedAt */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  warnVideoPlayers?: Maybe<Scalars['Int']['output']>;
};

export type RealmInput = {
  adminEmail?: InputMaybe<Scalars['String']['input']>;
  alarmTargetsClear?: InputMaybe<Scalars['Boolean']['input']>;
  alarmTargetsClearTime?: InputMaybe<Scalars['Int']['input']>;
  auditTtl?: InputMaybe<Scalars['String']['input']>;
  avatarLocalStreaming?: InputMaybe<Scalars['Boolean']['input']>;
  defaultMapLayer?: InputMaybe<MapType>;
  emailAuth?: InputMaybe<EmailAuth>;
  emailEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  emailFrom?: InputMaybe<Scalars['String']['input']>;
  emailHost?: InputMaybe<Scalars['String']['input']>;
  emailPass?: InputMaybe<Scalars['String']['input']>;
  emailPort?: InputMaybe<Scalars['Int']['input']>;
  emailTls?: InputMaybe<Scalars['Boolean']['input']>;
  emailUser?: InputMaybe<Scalars['String']['input']>;
  emailValidated?: InputMaybe<Scalars['Boolean']['input']>;
  geoIconSet?: InputMaybe<GeoIconSet>;
  /**  Geo map marker clustering options(enabled, disabledClusterAtZoom, maxClusterRadius)  */
  geoMarkerClusterConfig?: InputMaybe<Array<GeoMarkerClusterConfigInput>>;
  /**  Map monitoring zone configuration  */
  geoZone?: InputMaybe<Scalars['JSONObject']['input']>;
  id: Scalars['ID']['input'];
  jitterBufferLength?: InputMaybe<Scalars['Int']['input']>;
  maxDownloadTime?: InputMaybe<Scalars['Int']['input']>;
  maxScheduledDeliveryDelay?: InputMaybe<Scalars['Int']['input']>;
  maxVideoPlayers?: InputMaybe<Scalars['Int']['input']>;
  mfAuth?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  normalTargetsClearTime?: InputMaybe<Scalars['Int']['input']>;
  playerIdleTimeout?: InputMaybe<Scalars['Int']['input']>;
  /**  Record a minimum post-event time  */
  postEventTime?: InputMaybe<Scalars['Int']['input']>;
  /**  Record a minimum pre-event time  */
  preEventTime?: InputMaybe<Scalars['Int']['input']>;
  trackerMinTrackingTime?: InputMaybe<Scalars['Int']['input']>;
  trackerStaleTimeout?: InputMaybe<Scalars['Int']['input']>;
  warnVideoPlayers?: InputMaybe<Scalars['Int']['input']>;
};

export type RealmObject = {
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Object ID (UUID) */
  id: Scalars['ID']['output'];
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Object name */
  name: Scalars['String']['output'];
  type: RealmObjectType;
};

export type RealmObjectInput = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export enum RealmObjectType {
  CameraTour = 'CAMERA_TOUR',
  Device = 'DEVICE',
  GeoTour = 'GEO_TOUR',
  Group = 'GROUP',
  /** Generic Realm object */
  Object = 'OBJECT',
  Policy = 'POLICY',
  /** Realm */
  Realm = 'REALM',
  Schedule = 'SCHEDULE',
  Set = 'SET',
  Statement = 'STATEMENT',
  User = 'USER',
  Zone = 'ZONE'
}

/**
 * This the customer's Subscription object
 *
 * Extracted from the Realm object to its own thing
 */
export type RealmSubscription = {
  __typename?: 'RealmSubscription';
  createdAt: Scalars['DateTime']['output'];
  features: Array<Feature>;
  id: Scalars['ID']['output'];
  owner: Owner;
  periodExpiresAt: Scalars['DateTime']['output'];
  periodStartedAt: Scalars['DateTime']['output'];
  simpleui?: Maybe<Scalars['Boolean']['output']>;
  status: SubscriptionStatus;
  storagePools: Array<SubStoragePool>;
  title: Scalars['String']['output'];
  type?: Maybe<RealmSubscriptionType>;
  updatedAt: Scalars['DateTime']['output'];
};

export type RealmSubscriptionInput = {
  features?: InputMaybe<Array<FeatureInput>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  owner?: InputMaybe<OwnerInput>;
  periodExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  periodStartedAt?: InputMaybe<Scalars['DateTime']['input']>;
  simpleui?: InputMaybe<Scalars['Boolean']['input']>;
  storagePools?: InputMaybe<Array<SubStoragePoolInput>>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<RealmSubscriptionType>;
};

export enum RealmSubscriptionType {
  Production = 'production',
  SelfManaged = 'self_managed'
}

export enum RecordingArchive {
  Continuous = 'CONTINUOUS',
  Onevents = 'ONEVENTS'
}

export type Report = NumericReport | StatusReport;

/**
 * extend type User {
 *     resellerDomains: [Reseller!]!
 * }
 */
export type Reseller = {
  __typename?: 'Reseller';
  brandInfo?: Maybe<BrandInfo>;
  children: Array<Reseller>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  owner?: Maybe<User>;
  parent?: Maybe<Reseller>;
  realms: Array<Realm>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type Schedule = RealmObject & {
  __typename?: 'Schedule';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /**  Collection of Devices which Tasks will be applied  */
  devices?: Maybe<Array<ObjectDescriptor>>;
  /**  State  */
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  /**  Collection of Sets for Devices which will be applied Tasks  */
  sets?: Maybe<Array<ObjectDescriptor>>;
  /**  Collection of Tasks to be applied to Devices and to Devices which bellowed in collections(Sets, Zones)  */
  tasks?: Maybe<Array<ScheduleTask>>;
  /**  Time Zone that applied to the scheduler  */
  timezone: Scalars['String']['output'];
  type: RealmObjectType;
  /**  Collection of Zones for Devices which will be applied Tasks  */
  zones?: Maybe<Array<ObjectDescriptor>>;
};

export type ScheduleAction = {
  __typename?: 'ScheduleAction';
  /**  Id for Action  */
  action: Scalars['String']['output'];
  /**  Short description  */
  description: Scalars['String']['output'];
  /**  Device types which current Action support  */
  deviceTypes: Array<ScheduleDeviceType>;
  /**  Value of Action which will applied  */
  value: Scalars['String']['output'];
};

export type ScheduleActionInput = {
  /**  Id for Action (get from templates)  */
  action: Scalars['String']['input'];
  /**  Value of Action which will applied(get from templates)  */
  value: Scalars['String']['input'];
};

export type ScheduleActionTemplate = {
  __typename?: 'ScheduleActionTemplate';
  /**  Id for Action  */
  action: Scalars['String']['output'];
  /**  Short description  */
  description: Scalars['String']['output'];
  /**  Device types which current Action support  */
  deviceTypes: Array<ScheduleDeviceType>;
  /**  Labels for values  */
  labels: Scalars['JSON']['output'];
  /**  Possible values for current Action which can be applied  */
  values: Array<Scalars['String']['output']>;
};

export enum ScheduleDeviceType {
  Avatar = 'AVATAR',
  Camera = 'CAMERA',
  Gateway = 'GATEWAY',
  Sensor = 'SENSOR'
}

export type ScheduleInput = {
  /**  Collection of Device IDs which Tasks will be applied  */
  deviceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**  State  */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  /**  Collection of Set IDs for Devices which will be applied Tasks  */
  setIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**  Collection of Tasks to be applied to Devices and to Devices which bellowed in collections(Sets, Zones)  */
  tasks?: InputMaybe<Array<ScheduleTaskInput>>;
  /**  Time Zone that will be applied to the scheduler  */
  timezone: Scalars['String']['input'];
  /**  Collection of Zone IDs for Devices which will be applied Tasks  */
  zoneIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type ScheduleTask = {
  __typename?: 'ScheduleTask';
  /**  Collection of Actions which represents a change that Scheduler will be applied to Devices  */
  actions?: Maybe<Array<ScheduleAction>>;
  /**  Days for Task repeating  */
  byDay?: Maybe<Array<WeekDay>>;
  /**  Task end time   */
  endTime: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /**  Time from which Task will be applied  */
  startTime: Scalars['DateTime']['output'];
};

export type ScheduleTaskInput = {
  /**  Collection of Actions which represents a change that Scheduler will be applied to Devices  */
  actions?: InputMaybe<Array<ScheduleActionInput>>;
  /**  Days for Task repeating  */
  byDay?: InputMaybe<Array<WeekDay>>;
  /**  Task end time   */
  endTime: Scalars['DateTime']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  /**  Time from which Task will be applied  */
  startTime: Scalars['DateTime']['input'];
};

export type ScheduleUpdateInput = {
  /**  Collection of Device IDs which need to add to existing which will be applied Tasks  */
  addToDeviceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**  Collection of Set IDs which need to add to existing for Devices which will be applied Tasks  */
  addToSetIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**  Collection of Zone IDs which need to add to existing for Devices which will be applied Tasks  */
  addToZoneIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**  State  */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /**  Collection of Device IDs which need to remove from existing which will be applied Tasks  */
  removeFromDeviceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**  Collection of Set IDs which need to remove from existing for Devices which will be applied Tasks  */
  removeFromSetIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**  Collection of Zone IDs which need to remove from existing for Devices which will be applied Tasks  */
  removeFromZoneIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**  Collection of Tasks to be applied to Devices and to Devices which bellowed in collections(Sets, Zones)  */
  tasks?: InputMaybe<Array<ScheduleTaskInput>>;
  /**  Time from which Task will be applied  */
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type SecretPassword = {
  password: Scalars['String']['input'];
  secret: Scalars['String']['input'];
};

export type SensorEvent = {
  __typename?: 'SensorEvent';
  description: Scalars['String']['output'];
  enabled?: Maybe<Scalars['Boolean']['output']>;
  innerProps?: Maybe<Scalars['JSON']['output']>;
  source?: Maybe<EventSource>;
  type: Scalars['String']['output'];
};

export type SensorEventInput = {
  description: Scalars['String']['input'];
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  innerProps?: InputMaybe<Scalars['JSON']['input']>;
  source?: InputMaybe<EventSource>;
  type: Scalars['String']['input'];
};

export type Session = {
  __typename?: 'Session';
  info?: Maybe<UserInfo>;
  isAdmin: Scalars['Boolean']['output'];
  isLoggedIn: Scalars['Boolean']['output'];
};

export type SessionCloseEvent = {
  __typename?: 'SessionCloseEvent';
  reason: SessionCloseReason;
  sessionId: Scalars['String']['output'];
};

export enum SessionCloseReason {
  SessionExpired = 'SESSION_EXPIRED',
  SessionTerminated = 'SESSION_TERMINATED'
}

export type SessionInfo = {
  __typename?: 'SessionInfo';
  realm: ObjUuidAndName;
  role: ObjUuidAndName;
  user: ObjUuidAndName;
};

export type SessionInfoInput = {
  realm: ObjUuidAndNameInput;
  role: ObjUuidAndNameInput;
  user: ObjUuidAndNameInput;
};

export type SessionInput = {
  info?: InputMaybe<UserInfoInput>;
  isAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  isLoggedIn?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Set = RealmObject & {
  __typename?: 'Set';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  devices: Array<ObjectDescriptor>;
  id: Scalars['ID']['output'];
  isSystemManaged: Scalars['Boolean']['output'];
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  type: RealmObjectType;
};

export type SetInput = {
  addDeviceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  removeDeviceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type SetPasswordInput = {
  newPassword: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};

export type SharedViewInput = {
  hasLayout: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
  isShared: Scalars['Boolean']['input'];
  layout: Array<SharedViewLayoutInput>;
  layoutId: Scalars['String']['input'];
  module: Scalars['String']['input'];
  name: Scalars['String']['input'];
  originalViewId: Scalars['ID']['input'];
  templateId: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
  widgets: Array<SharedViewWidgetInput>;
};

export type SharedViewLayoutCellInput = {
  items?: InputMaybe<Array<SharedViewLayoutLeafInput>>;
  orientation?: InputMaybe<SharedViewLayoutOrientation>;
  size: Scalars['Float']['input'];
  type: SharedViewLayoutType;
};

export type SharedViewLayoutInput = {
  items?: InputMaybe<Array<SharedViewLayoutItemInput>>;
  orientation?: InputMaybe<SharedViewLayoutOrientation>;
  size: Scalars['Float']['input'];
  type: SharedViewLayoutType;
};

export type SharedViewLayoutItemInput = {
  items?: InputMaybe<Array<SharedViewLayoutCellInput>>;
  orientation?: InputMaybe<SharedViewLayoutOrientation>;
  size: Scalars['Float']['input'];
  type: SharedViewLayoutType;
};

export type SharedViewLayoutLeafInput = {
  size: Scalars['Float']['input'];
  type: SharedViewLayoutType;
};

export enum SharedViewLayoutOrientation {
  Horizontal = 'horizontal',
  Vertical = 'vertical'
}

export enum SharedViewLayoutType {
  Cell = 'Cell',
  Split = 'Split'
}

export type SharedViewWidgetInput = {
  id: Scalars['ID']['input'];
  module: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  props?: InputMaybe<Scalars['JSON']['input']>;
  widgetId: Scalars['String']['input'];
};

export type SharedViewsUpdateEvent = {
  __typename?: 'SharedViewsUpdateEvent';
  modifiedBy: ModifiedByInfo;
  sharedViews?: Maybe<Scalars['String']['output']>;
};

export type SocketEvent = {
  __typename?: 'SocketEvent';
  timeStamp: Scalars['Int']['output'];
  type: SocketEventType;
};

export type SocketEventInput = {
  timeStamp: Scalars['Int']['input'];
  type: SocketEventType;
};

export enum SocketEventType {
  Error = 'Error',
  Reconnected = 'Reconnected'
}

export type SoftwareInfo = {
  __typename?: 'SoftwareInfo';
  lastUpdateSucceeded?: Maybe<Scalars['Boolean']['output']>;
  lastUpdateTime?: Maybe<Scalars['DateTime']['output']>;
  updateAvailable?: Maybe<Scalars['Boolean']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

/**  SOLID config specific  */
export type SolidConfigCurrentViewInput = {
  recentViewIds?: InputMaybe<Array<Scalars['String']['input']>>;
  version: Scalars['String']['input'];
  windowProps?: InputMaybe<Scalars['JSON']['input']>;
};

export type SolidConfigUpdateEvent = {
  __typename?: 'SolidConfigUpdateEvent';
  solidConfig?: Maybe<Scalars['String']['output']>;
  userId: Scalars['ID']['output'];
};

/**  If array is empty we should not make any limitation  */
export type SolidConfiguration = {
  __typename?: 'SolidConfiguration';
  activities: Array<ActivityId>;
  config: Scalars['JSON']['output'];
  views: Array<ViewConfig>;
  widgets: Array<WidgetConfig>;
};

export type SolidConfigurationInput = {
  activities?: InputMaybe<Scalars['JSON']['input']>;
  config?: InputMaybe<Scalars['JSON']['input']>;
  views?: InputMaybe<Scalars['JSON']['input']>;
  widgets?: InputMaybe<Scalars['JSON']['input']>;
};

export type SolidVisualConfig = {
  __typename?: 'SolidVisualConfig';
  activities?: Maybe<Scalars['JSON']['output']>;
  config?: Maybe<Scalars['JSON']['output']>;
  views?: Maybe<Scalars['JSON']['output']>;
  widgets?: Maybe<Scalars['JSON']['output']>;
};

export type StatTime = {
  __typename?: 'StatTime';
  avg: Scalars['Float']['output'];
  max: Scalars['Float']['output'];
  min: Scalars['Float']['output'];
};

export enum StatementEffect {
  Allow = 'ALLOW',
  Deny = 'DENY'
}

export type StatsInput = {
  healthStatus?: InputMaybe<HealthStatus>;
};

export enum StatusMetric {
  Degraded = 'DEGRADED',
  Disabled = 'DISABLED',
  Offline = 'OFFLINE',
  Online = 'ONLINE',
  Warnings = 'WARNINGS'
}

export type StatusReport = {
  __typename?: 'StatusReport';
  /**  Status unix timestamp, sec  */
  time: Scalars['Int']['output'];
  /**  Status metric value  */
  value: StatusMetric;
};

export type StoragePool = {
  __typename?: 'StoragePool';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  ttlHours: Scalars['Int']['output'];
};

export type StorageUsage = {
  __typename?: 'StorageUsage';
  free?: Maybe<Scalars['Float']['output']>;
  localStorageVolume?: Maybe<Scalars['Float']['output']>;
  requiredVolume?: Maybe<Scalars['Float']['output']>;
};

export type StreamShare = {
  __typename?: 'StreamShare';
  enabled?: Maybe<Scalars['Boolean']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  status?: Maybe<HealthStatus>;
  streamSize?: Maybe<MediaStreamSize>;
  url: Scalars['String']['output'];
};

export type StreamShareInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  streamSize?: InputMaybe<MediaStreamSize>;
  url: Scalars['String']['input'];
};

export type StreamUsagePeriod = {
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
};

export type SubStoragePool = {
  __typename?: 'SubStoragePool';
  features: Array<Feature>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /** Duration in hours */
  ttlHrs: Scalars['Int']['output'];
};

export type SubStoragePoolInput = {
  features: Array<FeatureInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  /** Duration in hours */
  ttlHrs: Scalars['Int']['input'];
};

export type SubscribedGatewayEventInput = {
  id: Scalars['ID']['input'];
  type: Scalars['String']['input'];
};

export type Subscription = {
  __typename?: 'Subscription';
  aodUpdate?: Maybe<Array<AodRequest>>;
  /**  subscribe to new audit events  */
  auditEntries: AuditEntryEvent;
  /**  subscribe to hierarchies for updates  */
  hierarchyUpdate: LabelOrHierarchyUpdate;
  /**  subscribe to image map for updates  */
  imageMapUpdate: ImageMapUpdateNotification;
  /**  subscribe to labels for updates  */
  labelUpdate: LabelOrHierarchyUpdate;
  /**  internal use only, subscribe to object updates  */
  objectUpdate: ObjectUpdateEvent;
  /**  internal use only, subscribe for session close  */
  sessionClose: SessionCloseEvent;
  /**  internal use only, subscribe to shared view updates  */
  sharedViewsUpdate: SharedViewsUpdateEvent;
  /**  SOLID config specific, not public  */
  solidConfigUpdate: SolidConfigUpdateEvent;
  /**  subscribe to target updates  */
  targetUpdate: TargetNotification;
};


export type SubscriptionAodUpdateArgs = {
  filter: AodRequestFilter;
};


export type SubscriptionAuditEntriesArgs = {
  filter: AuditEntryFilter;
};


export type SubscriptionImageMapUpdateArgs = {
  version: Scalars['String']['input'];
};


export type SubscriptionObjectUpdateArgs = {
  filter?: InputMaybe<ObjectUpdateFilter>;
};


export type SubscriptionTargetUpdateArgs = {
  filter: TargetUpdateFilter;
};

export enum SubscriptionStatus {
  Active = 'ACTIVE',
  Hibernate = 'HIBERNATE'
}

export type SystemParameters = {
  __typename?: 'SystemParameters';
  geoDefaultPosition?: Maybe<DefaultGeoPosition>;
  /** @deprecated use Realm.googleMapsApiKey */
  googleMapsApiKey?: Maybe<Scalars['String']['output']>;
  googleYouTubeApiKey?: Maybe<Scalars['String']['output']>;
  googleYouTubePlaylistId?: Maybe<Scalars['String']['output']>;
  /** @deprecated use Realm.defaultMapLayer */
  mapDefaultLayer?: Maybe<Scalars['String']['output']>;
  solidAppVersion?: Maybe<Scalars['String']['output']>;
  updatesHost?: Maybe<Scalars['String']['output']>;
};

export enum SystemStatus {
  Alert = 'ALERT',
  Broken = 'BROKEN',
  Critical = 'CRITICAL',
  Offline = 'OFFLINE',
  Online = 'ONLINE',
  Starting = 'STARTING',
  Stopping = 'STOPPING'
}

export type SystemStatusInfo = {
  __typename?: 'SystemStatusInfo';
  description?: Maybe<Scalars['String']['output']>;
  reasons: Array<SystemStatusReason>;
  status: SystemStatus;
};

export type SystemStatusReason = {
  __typename?: 'SystemStatusReason';
  message: Scalars['String']['output'];
  object?: Maybe<SystemStatusReasonObject>;
  options?: Maybe<Scalars['JSONObject']['output']>;
};

export type SystemStatusReasonObject = {
  __typename?: 'SystemStatusReasonObject';
  /** Object ID (UUID) */
  id: Scalars['ID']['output'];
  /** Object name */
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type Target = {
  __typename?: 'Target';
  classification?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['JSONObject']['output']>;
  modifiedAt: Scalars['DateTime']['output'];
  position: LatLng;
  realmId: Scalars['ID']['output'];
  risk?: Maybe<TargetRisk>;
  targetId: Scalars['ID']['output'];
  track?: Maybe<Array<LatLng>>;
  type?: Maybe<TargetType>;
  witnesses: Array<Scalars['ID']['output']>;
};

export enum TargetClassification {
  Human = 'human',
  Unknown = 'unknown',
  Vehicle = 'vehicle'
}

export type TargetFilter = {
  classification?: InputMaybe<Array<Scalars['String']['input']>>;
  /**  From date-time. If not specified, last hour is assumed  */
  from?: InputMaybe<Scalars['DateTime']['input']>;
  /**  GeoJsonObject (default FeatureCollection) to display the zone on geo map and identify the target in this zone  */
  geoZone?: InputMaybe<Scalars['JSONObject']['input']>;
  /**  If limit is not specified, 100 is assumed. Limit cannot be more than 100  */
  limit?: InputMaybe<Scalars['Int']['input']>;
  risk?: InputMaybe<Array<TargetRisk>>;
  /**  If start is not specified, 0 is assumed  */
  start?: InputMaybe<Scalars['Int']['input']>;
  targetId?: InputMaybe<Scalars['ID']['input']>;
  /**  To date-time. If not specified, current time is assumed  */
  to?: InputMaybe<Scalars['DateTime']['input']>;
  /**  List of Realm Object IDs  */
  witnesses?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type TargetInput = {
  classification?: InputMaybe<Scalars['String']['input']>;
  createdAt: Scalars['DateTime']['input'];
  description?: InputMaybe<Scalars['JSONObject']['input']>;
  modifiedAt: Scalars['DateTime']['input'];
  position: LatLngInput;
  realmId: Scalars['ID']['input'];
  risk?: InputMaybe<TargetRisk>;
  targetId: Scalars['ID']['input'];
  type?: InputMaybe<TargetType>;
  witnesses: Array<Scalars['ID']['input']>;
};

export type TargetNotification = {
  __typename?: 'TargetNotification';
  classification?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['JSONObject']['output']>;
  modifiedAt: Scalars['DateTime']['output'];
  position: LatLng;
  realmId: Scalars['ID']['output'];
  risk?: Maybe<TargetRisk>;
  targetId: Scalars['ID']['output'];
  type?: Maybe<TargetType>;
  witnesses: Array<Scalars['ID']['output']>;
};

export enum TargetRisk {
  Maintenance = 'MAINTENANCE',
  Other = 'OTHER',
  Threat = 'THREAT',
  Unspecified = 'UNSPECIFIED'
}

export enum TargetType {
  Alarm = 'ALARM',
  Normal = 'NORMAL'
}

export type TargetUpdateFilter = {
  witnesses: Array<Scalars['ID']['input']>;
};

export enum UnitType {
  Gb = 'Gb',
  Unit = 'Unit'
}

export type UpdateResult = {
  __typename?: 'UpdateResult';
  updated: Scalars['Boolean']['output'];
  warning?: Maybe<Scalars['String']['output']>;
  warningFields?: Maybe<Array<WarningField>>;
};

export type User = RealmObject & {
  __typename?: 'User';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  emailConfirmed?: Maybe<Scalars['Boolean']['output']>;
  groups: Array<Group>;
  id: Scalars['ID']['output'];
  loggedOnAt?: Maybe<Scalars['DateTime']['output']>;
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  sendNotification?: Maybe<Scalars['Boolean']['output']>;
  type: RealmObjectType;
};

export type UserData = {
  __typename?: 'UserData';
  id: Scalars['String']['output'];
  isAdmin: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  /** @deprecated use solidVisualConfig */
  solidConfiguration: SolidConfiguration;
  solidVisualConfig: SolidVisualConfig;
};

export type UserDataInput = {
  id: Scalars['String']['input'];
  isAdmin: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  solidConfiguration?: InputMaybe<SolidConfigurationInput>;
};

export type UserInfo = {
  __typename?: 'UserInfo';
  realm: CurrentRealm;
  user: UserData;
};

export type UserInfoInput = {
  realm: GenericObjectInput;
  user: UserDataInput;
};

export type UserInput = {
  addToGroupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  confirmPassword?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  removeFromGroupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  sendNotification?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum VmxVideoStreamingMode {
  Auto = 'AUTO',
  Local = 'LOCAL'
}

export type VaeConfigBrief = {
  __typename?: 'VaeConfigBrief';
  description: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type VaeConfigFull = {
  __typename?: 'VaeConfigFull';
  configuration: Scalars['JSONObject']['output'];
  description: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type VaeFeature = {
  __typename?: 'VaeFeature';
  exclusive?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
};

export type VaeFps = {
  __typename?: 'VaeFps';
  /**  Default engine fps  */
  engineFps: MinMax;
  /**  Configured fps(within engineFps)  */
  requestedFps: MinMax;
};

export type VaeFpsInput = {
  /**  Max number of frames for processing per second  */
  maxFps: Scalars['Int']['input'];
  /**  Min number of frames for processing per second  */
  minFps: Scalars['Int']['input'];
};

export type VaeReasonStatus = {
  __typename?: 'VaeReasonStatus';
  reason: Scalars['String']['output'];
  status: VaeStatus;
  vae: Scalars['String']['output'];
};

export type VaeStatFps = {
  __typename?: 'VaeStatFps';
  avg: Scalars['Float']['output'];
  max: Scalars['Float']['output'];
  min: Scalars['Float']['output'];
  range: Scalars['Int']['output'];
};

export type VaeStatistic = {
  __typename?: 'VaeStatistic';
  avgLatency?: Maybe<Scalars['Float']['output']>;
  eps?: Maybe<Scalars['Float']['output']>;
  fps?: Maybe<Array<VaeStatFps>>;
  metadataBps?: Maybe<Scalars['Float']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  restarts?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<VaeStatus>;
  uptime?: Maybe<Scalars['Int']['output']>;
};

export enum VaeStatus {
  Broken = 'BROKEN',
  Degraded = 'DEGRADED',
  /** @deprecated unused */
  Failed = 'FAILED',
  Freezed = 'FREEZED',
  Off = 'OFF',
  /** @deprecated unused */
  Offline = 'OFFLINE',
  On = 'ON',
  /** @deprecated unused */
  Online = 'ONLINE',
  Stopped = 'STOPPED'
}

export type VaeUpdate = {
  __typename?: 'VaeUpdate';
  log?: Maybe<Array<Scalars['String']['output']>>;
  name: Scalars['String']['output'];
  status: VaeUpdateStatus;
  version?: Maybe<Scalars['String']['output']>;
};

export enum VaeUpdateStatus {
  Error = 'ERROR',
  Ok = 'OK'
}

export type ViewConfig = {
  __typename?: 'ViewConfig';
  config: Scalars['JSON']['output'];
  viewId: ViewId;
};

export type ViewConfigInput = {
  config: Scalars['JSON']['input'];
  viewId: ViewId;
};

export enum ViewId {
  AvatarActivation = 'AvatarActivation',
  Avatars = 'Avatars',
  CameraTours = 'CameraTours',
  Cameras = 'Cameras',
  DeviceAudit = 'DeviceAudit',
  EditMap = 'EditMap',
  Gateways = 'Gateways',
  GeoTours = 'GeoTours',
  Groups = 'Groups',
  Hierarchy = 'Hierarchy',
  Labels = 'Labels',
  LinkProvision = 'LinkProvision',
  ManageAvatars = 'ManageAvatars',
  ManageAvatarsFacial = 'ManageAvatarsFacial',
  ManageAvatarsLpr = 'ManageAvatarsLPR',
  NotificationPolicies = 'NotificationPolicies',
  Policies = 'Policies',
  QuickStart = 'QuickStart',
  RealmSettings = 'RealmSettings',
  Reports = 'Reports',
  Schedules = 'Schedules',
  Sensors = 'Sensors',
  Sets = 'Sets',
  Subscription = 'Subscription',
  TrainingVideos = 'TrainingVideos',
  UserAudit = 'UserAudit',
  Users = 'Users',
  VideoWalls = 'VideoWalls',
  Zones = 'Zones'
}

export type WarningField = {
  __typename?: 'WarningField';
  field?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export enum WeekDay {
  Fr = 'FR',
  Mo = 'MO',
  Sa = 'SA',
  Su = 'SU',
  Th = 'TH',
  Tu = 'TU',
  We = 'WE'
}

export type WidgetConfig = {
  __typename?: 'WidgetConfig';
  config: Scalars['JSON']['output'];
  widgetId: WidgetId;
};

export type WidgetConfigInput = {
  config: Scalars['JSON']['input'];
  widgetId: WidgetId;
};

export enum WidgetId {
  AdminAnalyticsDashboard = 'AdminAnalyticsDashboard',
  AdminAvatars = 'AdminAvatars',
  AdminDevices = 'AdminDevices',
  AdminGateways = 'AdminGateways',
  AdminSensors = 'AdminSensors',
  ArchiveEventList = 'ArchiveEventList',
  ArchiveTargetLog = 'ArchiveTargetLog',
  ArchiveViewer = 'ArchiveViewer',
  AvatarProvision = 'AvatarProvision',
  CameraLive = 'CameraLive',
  CameraLiveDebugger = 'CameraLiveDebugger',
  CameraTours = 'CameraTours',
  DeviceList = 'DeviceList',
  DeviceStatus = 'DeviceStatus',
  DownloadManager = 'DownloadManager',
  EventDetails = 'EventDetails',
  EventList = 'EventList',
  EventVideo = 'EventVideo',
  GeoMap = 'GEOMap',
  GeoTours = 'GeoTours',
  Groups = 'Groups',
  HierarchyEdit = 'HierarchyEdit',
  ImageMap = 'ImageMap',
  LabelEdit = 'LabelEdit',
  LinkProvision = 'LinkProvision',
  LiveTargetLog = 'LiveTargetLog',
  ManageAvatars = 'ManageAvatars',
  NotificationPolicies = 'NotificationPolicies',
  Policies = 'Policies',
  QuickStart = 'QuickStart',
  RealmSettings = 'RealmSettings',
  Reports = 'Reports',
  Schedules = 'Schedules',
  Sets = 'Sets',
  Subscription = 'Subscription',
  Timeline = 'Timeline',
  TrainingVideos = 'TrainingVideos',
  Url = 'URL',
  Users = 'Users',
  VideoTouring = 'VideoTouring',
  VideoWalls = 'VideoWalls',
  Vmx = 'VMX',
  WatchlistFacial = 'WatchlistFacial',
  WatchlistLpr = 'WatchlistLPR',
  Zones = 'Zones'
}

export type WidgetInfo = {
  __typename?: 'WidgetInfo';
  index: Scalars['Int']['output'];
  propsJSON?: Maybe<Scalars['String']['output']>;
  widgetId: Scalars['String']['output'];
};

export type WidgetInfoInput = {
  index: Scalars['Int']['input'];
  propsJSON?: InputMaybe<Scalars['String']['input']>;
  widgetId: Scalars['String']['input'];
};

export type Workspace = {
  __typename?: 'Workspace';
  creatingViews?: Maybe<Array<CreatingView>>;
  localViewsJSON?: Maybe<Scalars['String']['output']>;
  sharedViewsJSON?: Maybe<Scalars['String']['output']>;
  solidConfigJSON?: Maybe<Scalars['String']['output']>;
};

export type WorkspaceInput = {
  creatingViews?: InputMaybe<Array<CreatingViewInput>>;
  localViewsJSON?: InputMaybe<Scalars['String']['input']>;
  sharedViewsJSON?: InputMaybe<Scalars['String']['input']>;
  solidConfigJSON?: InputMaybe<Scalars['String']['input']>;
};

export type Zone = RealmObject & {
  __typename?: 'Zone';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  devices: Array<ObjectDescriptor>;
  id: Scalars['ID']['output'];
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  type: RealmObjectType;
};

export type ZoneInput = {
  addDeviceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  removeDeviceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type AodRequestFieldsFragment_AodRequest_files_AodRequestFiles_list_AodRequestFilesListEntry = {
  __typename?: 'AodRequestFilesListEntry',
  href: string,
  size: number,
  startTime: Date,
  endTime: Date
};

export type AodRequestFieldsFragment_AodRequest_files_AodRequestFiles = {
  __typename?: 'AodRequestFiles',
  expired: Date,
  list: Array<AodRequestFieldsFragment_AodRequest_files_AodRequestFiles_list_AodRequestFilesListEntry>
};

export type AodRequestFieldsFragment = {
  __typename?: 'AodRequest',
  id: string,
  realmId: string,
  avatarId: string,
  deviceId: string,
  userId: string,
  status: AodRequestStatus,
  startTime: Date,
  endTime: Date,
  streamNumber: number,
  createdAt: Date,
  expiredAt?: Date | null,
  size?: number | null,
  downloaded?: number | null,
  type?: AodRequestType | null,
  eta?: number | null,
  note?: string | null,
  files?: AodRequestFieldsFragment_AodRequest_files_AodRequestFiles | null
};

export type AodListQuery_aodGetList_AodRequest = {
  __typename?: 'AodRequest',
  id: string,
  realmId: string,
  avatarId: string,
  deviceId: string,
  userId: string,
  status: AodRequestStatus,
  startTime: Date,
  endTime: Date,
  streamNumber: number,
  createdAt: Date,
  expiredAt?: Date | null,
  size?: number | null,
  downloaded?: number | null,
  type?: AodRequestType | null,
  eta?: number | null,
  note?: string | null,
  files?: AodRequestFieldsFragment_AodRequest_files_AodRequestFiles | null
};

export type AodListQuery_Query = {
  __typename?: 'Query',
  aodGetList: Array<AodListQuery_aodGetList_AodRequest>
};


export type AodListQueryVariables = Exact<{
  startTime: Scalars['DateTime']['input'];
  endTime: Scalars['DateTime']['input'];
}>;


export type AodListQuery = AodListQuery_Query;

export type AodUpdatedListQuery_aodGetUpdatedList_AodRequest = {
  __typename?: 'AodRequest',
  id: string,
  realmId: string,
  avatarId: string,
  deviceId: string,
  userId: string,
  status: AodRequestStatus,
  startTime: Date,
  endTime: Date,
  streamNumber: number,
  createdAt: Date,
  expiredAt?: Date | null,
  size?: number | null,
  downloaded?: number | null,
  type?: AodRequestType | null,
  eta?: number | null,
  note?: string | null,
  files?: AodRequestFieldsFragment_AodRequest_files_AodRequestFiles | null
};

export type AodUpdatedListQuery_Query = {
  __typename?: 'Query',
  aodGetUpdatedList: Array<AodUpdatedListQuery_aodGetUpdatedList_AodRequest>
};


export type AodUpdatedListQueryVariables = Exact<{
  updatedFrom: Scalars['DateTime']['input'];
}>;


export type AodUpdatedListQuery = AodUpdatedListQuery_Query;

export type AodSubmitMutation_aodSubmit_AodRequest = {
  __typename?: 'AodRequest',
  id: string,
  realmId: string,
  avatarId: string,
  deviceId: string,
  userId: string,
  status: AodRequestStatus,
  startTime: Date,
  endTime: Date,
  streamNumber: number,
  createdAt: Date,
  expiredAt?: Date | null,
  size?: number | null,
  downloaded?: number | null,
  type?: AodRequestType | null,
  eta?: number | null,
  note?: string | null,
  files?: AodRequestFieldsFragment_AodRequest_files_AodRequestFiles | null
};

export type AodSubmitMutation_Mutation = {
  __typename?: 'Mutation',
  aodSubmit: Array<AodSubmitMutation_aodSubmit_AodRequest>
};


export type AodSubmitMutationVariables = Exact<{
  input: AodRequestInput;
}>;


export type AodSubmitMutation = AodSubmitMutation_Mutation;

export type AodPauseMutation_Mutation = {
  __typename?: 'Mutation',
  aodPause?: boolean | null
};


export type AodPauseMutationVariables = Exact<{
  requestId: Scalars['ID']['input'];
}>;


export type AodPauseMutation = AodPauseMutation_Mutation;

export type AodResumeMutation_Mutation = {
  __typename?: 'Mutation',
  aodResume?: boolean | null
};


export type AodResumeMutationVariables = Exact<{
  requestId: Scalars['ID']['input'];
}>;


export type AodResumeMutation = AodResumeMutation_Mutation;

export type AodCancelMutation_Mutation = {
  __typename?: 'Mutation',
  aodCancel?: boolean | null
};


export type AodCancelMutationVariables = Exact<{
  requestIds: Array<Scalars['ID']['input']>;
}>;


export type AodCancelMutation = AodCancelMutation_Mutation;

export type AodUpdateSubscription_aodUpdate_AodRequest = {
  __typename?: 'AodRequest',
  id: string,
  realmId: string,
  avatarId: string,
  deviceId: string,
  userId: string,
  status: AodRequestStatus,
  startTime: Date,
  endTime: Date,
  streamNumber: number,
  createdAt: Date,
  expiredAt?: Date | null,
  size?: number | null,
  downloaded?: number | null,
  type?: AodRequestType | null,
  eta?: number | null,
  note?: string | null,
  files?: AodRequestFieldsFragment_AodRequest_files_AodRequestFiles | null
};

export type AodUpdateSubscription_Subscription = {
  __typename?: 'Subscription',
  aodUpdate?: Array<AodUpdateSubscription_aodUpdate_AodRequest> | null
};


export type AodUpdateSubscriptionVariables = Exact<{
  filter: AodRequestFilter;
}>;


export type AodUpdateSubscription = AodUpdateSubscription_Subscription;

export type AuditEntryFieldsFragment_AuditEntry_category_AuditCategory = {
  __typename?: 'AuditCategory',
  id: string,
  shortName: string,
  digest: string
};

export type AuditEntryFieldsFragment_AuditEntry_witnesses_CameraTour = {
  __typename?: 'CameraTour',
  id: string,
  name: string,
  type: RealmObjectType
};

export type AuditEntryFieldsFragment_AuditEntry_witnesses_CurrentRealm = {
  __typename?: 'CurrentRealm',
  id: string,
  name: string,
  type: RealmObjectType
};

export type AuditEntryFieldsFragment_AuditEntry_witnesses_Device = {
  __typename?: 'Device',
  id: string,
  name: string,
  type: RealmObjectType
};

export type AuditEntryFieldsFragment_AuditEntry_witnesses_GenericObject = {
  __typename?: 'GenericObject',
  id: string,
  name: string,
  type: RealmObjectType
};

export type AuditEntryFieldsFragment_AuditEntry_witnesses_GeoTour = {
  __typename?: 'GeoTour',
  id: string,
  name: string,
  type: RealmObjectType
};

export type AuditEntryFieldsFragment_AuditEntry_witnesses_Group = {
  __typename?: 'Group',
  id: string,
  name: string,
  type: RealmObjectType
};

export type AuditEntryFieldsFragment_AuditEntry_witnesses_Policy = {
  __typename?: 'Policy',
  id: string,
  name: string,
  type: RealmObjectType
};

export type AuditEntryFieldsFragment_AuditEntry_witnesses_Realm = {
  __typename?: 'Realm',
  id: string,
  name: string,
  type: RealmObjectType
};

export type AuditEntryFieldsFragment_AuditEntry_witnesses_Schedule = {
  __typename?: 'Schedule',
  id: string,
  name: string,
  type: RealmObjectType
};

export type AuditEntryFieldsFragment_AuditEntry_witnesses_Set = {
  __typename?: 'Set',
  id: string,
  name: string,
  type: RealmObjectType
};

export type AuditEntryFieldsFragment_AuditEntry_witnesses_User = {
  __typename?: 'User',
  id: string,
  name: string,
  type: RealmObjectType
};

export type AuditEntryFieldsFragment_AuditEntry_witnesses_Zone = {
  __typename?: 'Zone',
  id: string,
  name: string,
  type: RealmObjectType
};

export type AuditEntryFieldsFragment_AuditEntry_witnesses =
  | AuditEntryFieldsFragment_AuditEntry_witnesses_CameraTour
  | AuditEntryFieldsFragment_AuditEntry_witnesses_CurrentRealm
  | AuditEntryFieldsFragment_AuditEntry_witnesses_Device
  | AuditEntryFieldsFragment_AuditEntry_witnesses_GenericObject
  | AuditEntryFieldsFragment_AuditEntry_witnesses_GeoTour
  | AuditEntryFieldsFragment_AuditEntry_witnesses_Group
  | AuditEntryFieldsFragment_AuditEntry_witnesses_Policy
  | AuditEntryFieldsFragment_AuditEntry_witnesses_Realm
  | AuditEntryFieldsFragment_AuditEntry_witnesses_Schedule
  | AuditEntryFieldsFragment_AuditEntry_witnesses_Set
  | AuditEntryFieldsFragment_AuditEntry_witnesses_User
  | AuditEntryFieldsFragment_AuditEntry_witnesses_Zone
;

export type AuditEntryFieldsFragment_AuditEntry_metadata_MetaEntry_metaClass_MetaClassifier_attributes_KeyValue = {
  __typename?: 'KeyValue',
  key: string,
  value: string
};

export type AuditEntryFieldsFragment_AuditEntry_metadata_MetaEntry_metaClass_MetaClassifier = {
  __typename?: 'MetaClassifier',
  value: string,
  attributes: Array<AuditEntryFieldsFragment_AuditEntry_metadata_MetaEntry_metaClass_MetaClassifier_attributes_KeyValue>
};

export type AuditEntryFieldsFragment_AuditEntry_metadata_MetaEntry = {
  __typename?: 'MetaEntry',
  key: string,
  metaClass: AuditEntryFieldsFragment_AuditEntry_metadata_MetaEntry_metaClass_MetaClassifier
};

export type AuditEntryFieldsFragment = {
  __typename?: 'AuditEntry',
  context: string,
  message: string,
  triggeredAt: Date,
  modifiedAt: Date,
  isAcknowledged: boolean,
  note?: string | null,
  category: AuditEntryFieldsFragment_AuditEntry_category_AuditCategory,
  witnesses: Array<AuditEntryFieldsFragment_AuditEntry_witnesses>,
  metadata: Array<AuditEntryFieldsFragment_AuditEntry_metadata_MetaEntry>
};

export type AuditEntryMetadataFieldsFragment = {
  __typename?: 'AuditEntry',
  metadata: Array<AuditEntryFieldsFragment_AuditEntry_metadata_MetaEntry>
};

export type AuditEntrySnapshotFieldsFragment_AuditEntry_snapshots_AuditSnapshot_tags_KeyValue = {
  __typename?: 'KeyValue',
  key: string,
  value: string
};

export type AuditEntrySnapshotFieldsFragment_AuditEntry_snapshots_AuditSnapshot = {
  __typename?: 'AuditSnapshot',
  type: string,
  default: boolean,
  snapshot: string,
  tags: Array<AuditEntrySnapshotFieldsFragment_AuditEntry_snapshots_AuditSnapshot_tags_KeyValue>
};

export type AuditEntrySnapshotFieldsFragment = {
  __typename?: 'AuditEntry',
  snapshots: Array<AuditEntrySnapshotFieldsFragment_AuditEntry_snapshots_AuditSnapshot>
};

export type AuditCategoriesQuery_auditCategories_AuditCategory = {
  __typename?: 'AuditCategory',
  id: string,
  parent?: string | null,
  shortName: string
};

export type AuditCategoriesQuery_Query = {
  __typename?: 'Query',
  auditCategories: Array<AuditCategoriesQuery_auditCategories_AuditCategory>
};


export type AuditCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type AuditCategoriesQuery = AuditCategoriesQuery_Query;

export type AuditEntryQuery_auditEntry_AuditEntry = {
  __typename?: 'AuditEntry',
  context: string,
  message: string,
  triggeredAt: Date,
  modifiedAt: Date,
  isAcknowledged: boolean,
  note?: string | null,
  category: AuditEntryFieldsFragment_AuditEntry_category_AuditCategory,
  witnesses: Array<AuditEntryFieldsFragment_AuditEntry_witnesses>,
  metadata: Array<AuditEntryFieldsFragment_AuditEntry_metadata_MetaEntry>
};

export type AuditEntryQuery_Query = {
  __typename?: 'Query',
  auditEntry?: AuditEntryQuery_auditEntry_AuditEntry | null
};


export type AuditEntryQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AuditEntryQuery = AuditEntryQuery_Query;

export type AuditEntriesQuery_auditEntries_AuditEntry = {
  __typename?: 'AuditEntry',
  context: string,
  message: string,
  triggeredAt: Date,
  modifiedAt: Date,
  isAcknowledged: boolean,
  note?: string | null,
  category: AuditEntryFieldsFragment_AuditEntry_category_AuditCategory,
  witnesses: Array<AuditEntryFieldsFragment_AuditEntry_witnesses>,
  metadata: Array<AuditEntryFieldsFragment_AuditEntry_metadata_MetaEntry>
};

export type AuditEntriesQuery_Query = {
  __typename?: 'Query',
  auditEntries: Array<AuditEntriesQuery_auditEntries_AuditEntry>
};


export type AuditEntriesQueryVariables = Exact<{
  filter: AuditEntryFilter;
}>;


export type AuditEntriesQuery = AuditEntriesQuery_Query;

export type RequireAcknowledgeWithSnapshotsEntriesQuery_requireAcknowledgeEntries_AuditEntry = {
  __typename?: 'AuditEntry',
  context: string,
  message: string,
  triggeredAt: Date,
  modifiedAt: Date,
  isAcknowledged: boolean,
  note?: string | null,
  category: AuditEntryFieldsFragment_AuditEntry_category_AuditCategory,
  witnesses: Array<AuditEntryFieldsFragment_AuditEntry_witnesses>,
  snapshots: Array<AuditEntrySnapshotFieldsFragment_AuditEntry_snapshots_AuditSnapshot>,
  metadata: Array<AuditEntryFieldsFragment_AuditEntry_metadata_MetaEntry>
};

export type RequireAcknowledgeWithSnapshotsEntriesQuery_Query = {
  __typename?: 'Query',
  requireAcknowledgeEntries: Array<RequireAcknowledgeWithSnapshotsEntriesQuery_requireAcknowledgeEntries_AuditEntry>
};


export type RequireAcknowledgeWithSnapshotsEntriesQueryVariables = Exact<{
  filter: AuditEntryFilter;
}>;


export type RequireAcknowledgeWithSnapshotsEntriesQuery = RequireAcknowledgeWithSnapshotsEntriesQuery_Query;

export type RequireAcknowledgeEntriesQuery_requireAcknowledgeEntries_AuditEntry = {
  __typename?: 'AuditEntry',
  context: string,
  message: string,
  triggeredAt: Date,
  modifiedAt: Date,
  isAcknowledged: boolean,
  note?: string | null,
  category: AuditEntryFieldsFragment_AuditEntry_category_AuditCategory,
  witnesses: Array<AuditEntryFieldsFragment_AuditEntry_witnesses>,
  metadata: Array<AuditEntryFieldsFragment_AuditEntry_metadata_MetaEntry>
};

export type RequireAcknowledgeEntriesQuery_Query = {
  __typename?: 'Query',
  requireAcknowledgeEntries: Array<RequireAcknowledgeEntriesQuery_requireAcknowledgeEntries_AuditEntry>
};


export type RequireAcknowledgeEntriesQueryVariables = Exact<{
  filter: AuditEntryFilter;
}>;


export type RequireAcknowledgeEntriesQuery = RequireAcknowledgeEntriesQuery_Query;

export type AuditEntriesWithSnapshotsQuery_auditEntries_AuditEntry = {
  __typename?: 'AuditEntry',
  context: string,
  message: string,
  triggeredAt: Date,
  modifiedAt: Date,
  isAcknowledged: boolean,
  note?: string | null,
  category: AuditEntryFieldsFragment_AuditEntry_category_AuditCategory,
  witnesses: Array<AuditEntryFieldsFragment_AuditEntry_witnesses>,
  snapshots: Array<AuditEntrySnapshotFieldsFragment_AuditEntry_snapshots_AuditSnapshot>,
  metadata: Array<AuditEntryFieldsFragment_AuditEntry_metadata_MetaEntry>
};

export type AuditEntriesWithSnapshotsQuery_Query = {
  __typename?: 'Query',
  auditEntries: Array<AuditEntriesWithSnapshotsQuery_auditEntries_AuditEntry>
};


export type AuditEntriesWithSnapshotsQueryVariables = Exact<{
  filter: AuditEntryFilter;
}>;


export type AuditEntriesWithSnapshotsQuery = AuditEntriesWithSnapshotsQuery_Query;

export type AuditEntriesTimeQuery_auditEntries_AuditEntry_witnesses_CameraTour = {
  __typename?: 'CameraTour',
  id: string
};

export type AuditEntriesTimeQuery_auditEntries_AuditEntry_witnesses_CurrentRealm = {
  __typename?: 'CurrentRealm',
  id: string
};

export type AuditEntriesTimeQuery_auditEntries_AuditEntry_witnesses_Device = {
  __typename?: 'Device',
  id: string
};

export type AuditEntriesTimeQuery_auditEntries_AuditEntry_witnesses_GenericObject = {
  __typename?: 'GenericObject',
  id: string
};

export type AuditEntriesTimeQuery_auditEntries_AuditEntry_witnesses_GeoTour = {
  __typename?: 'GeoTour',
  id: string
};

export type AuditEntriesTimeQuery_auditEntries_AuditEntry_witnesses_Group = {
  __typename?: 'Group',
  id: string
};

export type AuditEntriesTimeQuery_auditEntries_AuditEntry_witnesses_Policy = {
  __typename?: 'Policy',
  id: string
};

export type AuditEntriesTimeQuery_auditEntries_AuditEntry_witnesses_Realm = {
  __typename?: 'Realm',
  id: string
};

export type AuditEntriesTimeQuery_auditEntries_AuditEntry_witnesses_Schedule = {
  __typename?: 'Schedule',
  id: string
};

export type AuditEntriesTimeQuery_auditEntries_AuditEntry_witnesses_Set = {
  __typename?: 'Set',
  id: string
};

export type AuditEntriesTimeQuery_auditEntries_AuditEntry_witnesses_User = {
  __typename?: 'User',
  id: string
};

export type AuditEntriesTimeQuery_auditEntries_AuditEntry_witnesses_Zone = {
  __typename?: 'Zone',
  id: string
};

export type AuditEntriesTimeQuery_auditEntries_AuditEntry_witnesses =
  | AuditEntriesTimeQuery_auditEntries_AuditEntry_witnesses_CameraTour
  | AuditEntriesTimeQuery_auditEntries_AuditEntry_witnesses_CurrentRealm
  | AuditEntriesTimeQuery_auditEntries_AuditEntry_witnesses_Device
  | AuditEntriesTimeQuery_auditEntries_AuditEntry_witnesses_GenericObject
  | AuditEntriesTimeQuery_auditEntries_AuditEntry_witnesses_GeoTour
  | AuditEntriesTimeQuery_auditEntries_AuditEntry_witnesses_Group
  | AuditEntriesTimeQuery_auditEntries_AuditEntry_witnesses_Policy
  | AuditEntriesTimeQuery_auditEntries_AuditEntry_witnesses_Realm
  | AuditEntriesTimeQuery_auditEntries_AuditEntry_witnesses_Schedule
  | AuditEntriesTimeQuery_auditEntries_AuditEntry_witnesses_Set
  | AuditEntriesTimeQuery_auditEntries_AuditEntry_witnesses_User
  | AuditEntriesTimeQuery_auditEntries_AuditEntry_witnesses_Zone
;

export type AuditEntriesTimeQuery_auditEntries_AuditEntry = {
  __typename?: 'AuditEntry',
  context: string,
  triggeredAt: Date,
  witnesses: Array<AuditEntriesTimeQuery_auditEntries_AuditEntry_witnesses>
};

export type AuditEntriesTimeQuery_Query = {
  __typename?: 'Query',
  auditEntries: Array<AuditEntriesTimeQuery_auditEntries_AuditEntry>
};


export type AuditEntriesTimeQueryVariables = Exact<{
  filter: AuditEntryFilter;
}>;


export type AuditEntriesTimeQuery = AuditEntriesTimeQuery_Query;

export type AuditEntriesSubscriptionSubscription_auditEntries_AuditEntry = {
  __typename?: 'AuditEntry',
  context: string,
  message: string,
  triggeredAt: Date,
  modifiedAt: Date,
  isAcknowledged: boolean,
  note?: string | null,
  category: AuditEntryFieldsFragment_AuditEntry_category_AuditCategory,
  witnesses: Array<AuditEntryFieldsFragment_AuditEntry_witnesses>,
  snapshots: Array<AuditEntrySnapshotFieldsFragment_AuditEntry_snapshots_AuditSnapshot>,
  metadata: Array<AuditEntryFieldsFragment_AuditEntry_metadata_MetaEntry>
};

export type AuditEntriesSubscriptionSubscription_auditEntries_ErrorInfo = {
  __typename?: 'ErrorInfo',
  error: string,
  createdAt: Date
};

export type AuditEntriesSubscriptionSubscription_auditEntries =
  | AuditEntriesSubscriptionSubscription_auditEntries_AuditEntry
  | AuditEntriesSubscriptionSubscription_auditEntries_ErrorInfo
;

export type AuditEntriesSubscriptionSubscription_Subscription = {
  __typename?: 'Subscription',
  auditEntries: AuditEntriesSubscriptionSubscription_auditEntries
};


export type AuditEntriesSubscriptionSubscriptionVariables = Exact<{
  filter: AuditEntryFilter;
}>;


export type AuditEntriesSubscriptionSubscription = AuditEntriesSubscriptionSubscription_Subscription;

export type AcknowledgeEventMutation_Mutation = {
  __typename?: 'Mutation',
  acknowledgeAuditEntry: boolean
};


export type AcknowledgeEventMutationVariables = Exact<{
  entry: AcknowledgeAuditEntryInput;
}>;


export type AcknowledgeEventMutation = AcknowledgeEventMutation_Mutation;

export type EventsAcknowledgementMutation_Mutation = {
  __typename?: 'Mutation',
  auditEntriesAcknowledgment: boolean
};


export type EventsAcknowledgementMutationVariables = Exact<{
  entries: Array<AcknowledgeAuditEntryInput>;
}>;


export type EventsAcknowledgementMutation = EventsAcknowledgementMutation_Mutation;

export type CreateEventMutation_Mutation = {
  __typename?: 'Mutation',
  createEvent: boolean
};


export type CreateEventMutationVariables = Exact<{
  entry: CreateEventEntry;
}>;


export type CreateEventMutation = CreateEventMutation_Mutation;

export type AdminCameraTourListFieldsFragment_CameraTour_steps_CameraTourStep = {
  __typename?: 'CameraTourStep',
  cameraId: string,
  cameraPreset?: number | null,
  delay: number,
  name: string
};

export type AdminCameraTourListFieldsFragment = {
  __typename?: 'CameraTour',
  type: RealmObjectType,
  id: string,
  name: string,
  enabled: boolean,
  steps?: Array<AdminCameraTourListFieldsFragment_CameraTour_steps_CameraTourStep> | null
};

export type CameraTourFragment_CameraTour_steps_CameraTourStep = {
  __typename?: 'CameraTourStep',
  cameraId: string,
  cameraPreset?: number | null,
  delay: number,
  name: string
};

export type CameraTourFragment = {
  __typename?: 'CameraTour',
  type: RealmObjectType,
  id: string,
  name: string,
  enabled: boolean,
  steps?: Array<CameraTourFragment_CameraTour_steps_CameraTourStep> | null
};

export type AdminCameraTourListQuery_cameraTours_CameraTour = {
  __typename?: 'CameraTour',
  type: RealmObjectType,
  id: string,
  name: string,
  enabled: boolean,
  steps?: Array<AdminCameraTourListFieldsFragment_CameraTour_steps_CameraTourStep> | null
};

export type AdminCameraTourListQuery_Query = {
  __typename?: 'Query',
  cameraTours: Array<AdminCameraTourListQuery_cameraTours_CameraTour>
};


export type AdminCameraTourListQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminCameraTourListQuery = AdminCameraTourListQuery_Query;

export type CameraTourQuery_cameraTour_CameraTour = {
  __typename?: 'CameraTour',
  type: RealmObjectType,
  id: string,
  name: string,
  enabled: boolean,
  steps?: Array<CameraTourFragment_CameraTour_steps_CameraTourStep> | null
};

export type CameraTourQuery_Query = {
  __typename?: 'Query',
  cameraTour?: CameraTourQuery_cameraTour_CameraTour | null
};


export type CameraTourQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CameraTourQuery = CameraTourQuery_Query;

export type UpdateCameraTourMutation_updateCameraTour_UpdateResult = {
  __typename?: 'UpdateResult',
  updated: boolean
};

export type UpdateCameraTourMutation_Mutation = {
  __typename?: 'Mutation',
  updateCameraTour: UpdateCameraTourMutation_updateCameraTour_UpdateResult
};


export type UpdateCameraTourMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: CameraTourInput;
}>;


export type UpdateCameraTourMutation = UpdateCameraTourMutation_Mutation;

export type CreateCameraTourMutation_createCameraTour_CreateResult = {
  __typename?: 'CreateResult',
  id: string
};

export type CreateCameraTourMutation_Mutation = {
  __typename?: 'Mutation',
  createCameraTour: CreateCameraTourMutation_createCameraTour_CreateResult
};


export type CreateCameraTourMutationVariables = Exact<{
  input: CameraTourInput;
}>;


export type CreateCameraTourMutation = CreateCameraTourMutation_Mutation;

export type DeleteCameraTourMutation_Mutation = {
  __typename?: 'Mutation',
  deleteCameraTour: boolean
};


export type DeleteCameraTourMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteCameraTourMutation = DeleteCameraTourMutation_Mutation;

export type CurrentRealmQuery_currentRealm_CurrentRealm = {
  __typename?: 'CurrentRealm',
  id: string,
  sharedViews?: string | null
};

export type CurrentRealmQuery_Query = {
  __typename?: 'Query',
  currentRealm: CurrentRealmQuery_currentRealm_CurrentRealm
};


export type CurrentRealmQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentRealmQuery = CurrentRealmQuery_Query;

export type SharedViewsUpdateSubscription_sharedViewsUpdate_SharedViewsUpdateEvent = {
  __typename?: 'SharedViewsUpdateEvent',
  sharedViews?: string | null
};

export type SharedViewsUpdateSubscription_Subscription = {
  __typename?: 'Subscription',
  sharedViewsUpdate: SharedViewsUpdateSubscription_sharedViewsUpdate_SharedViewsUpdateEvent
};


export type SharedViewsUpdateSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type SharedViewsUpdateSubscription = SharedViewsUpdateSubscription_Subscription;

export type SessionCloseSubscription_sessionClose_SessionCloseEvent = {
  __typename?: 'SessionCloseEvent',
  sessionId: string,
  reason: SessionCloseReason
};

export type SessionCloseSubscription_Subscription = {
  __typename?: 'Subscription',
  sessionClose: SessionCloseSubscription_sessionClose_SessionCloseEvent
};


export type SessionCloseSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type SessionCloseSubscription = SessionCloseSubscription_Subscription;

export type DeviceFieldsFragment_Device_position_LatLng = {
  __typename?: 'LatLng',
  lat: number,
  lng: number,
  alt?: number | null
};

export type DeviceFieldsFragment_Device_alarmPointPosition_LatLng = {
  __typename?: 'LatLng',
  lat: number,
  lng: number,
  alt?: number | null
};

export type DeviceFieldsFragment_Device_config_DeviceBaseConfig_connect_NetworkConnectDescriptor_credentials_Credentials = {
  __typename?: 'Credentials',
  certificate: string,
  privatekey: string
};

export type DeviceFieldsFragment_Device_config_DeviceBaseConfig_connect_NetworkConnectDescriptor = {
  __typename?: 'NetworkConnectDescriptor',
  authType: AuthType,
  URL?: string | null,
  host?: string | null,
  hosts?: Array<string> | null,
  user?: string | null,
  pass?: string | null,
  port?: number | null,
  rtspPort?: number | null,
  protocol?: ProtocolType | null,
  udpPort?: number | null,
  credentials?: DeviceFieldsFragment_Device_config_DeviceBaseConfig_connect_NetworkConnectDescriptor_credentials_Credentials | null
};

export type DeviceFieldsFragment_Device_config_DeviceBaseConfig = {
  __typename?: 'DeviceBaseConfig',
  configType: DeviceBaseConfigType,
  make?: string | null,
  model?: string | null,
  firmware?: string | null,
  onvifServices?: string | null,
  stratusObjId?: string | null,
  connect: DeviceFieldsFragment_Device_config_DeviceBaseConfig_connect_NetworkConnectDescriptor
};

export type DeviceFieldsFragment_Device_platform_Device_aspects_DFA_Avatar = {
  __typename?: 'DFA_Avatar',
  webRtcEnabled?: boolean | null,
  type: DeviceFunctionalAspectType
};

export type DeviceFieldsFragment_Device_platform_Device_aspects_DFA_Gateway = {
  __typename?: 'DFA_Gateway',
  type: DeviceFunctionalAspectType
};

export type DeviceFieldsFragment_Device_platform_Device_aspects_DFA_Media = {
  __typename?: 'DFA_Media',
  type: DeviceFunctionalAspectType
};

export type DeviceFieldsFragment_Device_platform_Device_aspects_DFA_PTZ = {
  __typename?: 'DFA_PTZ',
  type: DeviceFunctionalAspectType
};

export type DeviceFieldsFragment_Device_platform_Device_aspects_DFA_Sensor = {
  __typename?: 'DFA_Sensor',
  type: DeviceFunctionalAspectType
};

export type DeviceFieldsFragment_Device_platform_Device_aspects_DFA_VAE = {
  __typename?: 'DFA_VAE',
  type: DeviceFunctionalAspectType
};

export type DeviceFieldsFragment_Device_platform_Device_aspects =
  | DeviceFieldsFragment_Device_platform_Device_aspects_DFA_Avatar
  | DeviceFieldsFragment_Device_platform_Device_aspects_DFA_Gateway
  | DeviceFieldsFragment_Device_platform_Device_aspects_DFA_Media
  | DeviceFieldsFragment_Device_platform_Device_aspects_DFA_PTZ
  | DeviceFieldsFragment_Device_platform_Device_aspects_DFA_Sensor
  | DeviceFieldsFragment_Device_platform_Device_aspects_DFA_VAE
;

export type DeviceFieldsFragment_Device_platform_Device = {
  __typename?: 'Device',
  id: string,
  name: string,
  aspects: Array<DeviceFieldsFragment_Device_platform_Device_aspects>
};

export type DeviceFieldsFragment_Device_sharedStream_StreamShare = {
  __typename?: 'StreamShare',
  id: number,
  url: string,
  streamSize?: MediaStreamSize | null,
  enabled?: boolean | null,
  status?: HealthStatus | null,
  error?: string | null
};

export type DeviceFieldsFragment_Device_zone_ObjectDescriptor = {
  __typename?: 'ObjectDescriptor',
  id: string,
  name: string,
  isSystemManaged?: boolean | null,
  type: RealmObjectType
};

export type DeviceFieldsFragment_Device_set_ObjectDescriptor = {
  __typename?: 'ObjectDescriptor',
  id: string,
  name: string,
  isSystemManaged?: boolean | null,
  type: RealmObjectType
};

export type DeviceFieldsFragment_Device_storageConfig_DeviceStorageConfig_storagePool_StoragePool = {
  __typename?: 'StoragePool',
  id: string,
  name: string,
  ttlHours: number
};

export type DeviceFieldsFragment_Device_storageConfig_DeviceStorageConfig = {
  __typename?: 'DeviceStorageConfig',
  storagePool: DeviceFieldsFragment_Device_storageConfig_DeviceStorageConfig_storagePool_StoragePool
};

export type DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_onvifServiceConf_OnvifServiceConfig_status_OnvifServiceStatus = {
  __typename?: 'OnvifServiceStatus',
  error?: string | null,
  running?: boolean | null
};

export type DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_onvifServiceConf_OnvifServiceConfig = {
  __typename?: 'OnvifServiceConfig',
  bindIp: string,
  enableDiscovery: boolean,
  enabled: boolean,
  httpPort: number,
  pass: string,
  user: string,
  status?: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_onvifServiceConf_OnvifServiceConfig_status_OnvifServiceStatus | null
};

export type DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_storageUsage_StorageUsage = {
  __typename?: 'StorageUsage',
  free?: number | null,
  requiredVolume?: number | null,
  localStorageVolume?: number | null
};

export type DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_software_SoftwareInfo = {
  __typename?: 'SoftwareInfo',
  version?: string | null,
  updateAvailable?: boolean | null,
  lastUpdateTime?: Date | null,
  lastUpdateSucceeded?: boolean | null
};

export type DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_channelBenchmark_ChannelBenchmark_tcpDown_ChannelStatistics = {
  __typename?: 'ChannelStatistics',
  bytes?: number | null,
  bitsPerSecond?: number | null
};

export type DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_channelBenchmark_ChannelBenchmark_tcpUp_ChannelStatistics = {
  __typename?: 'ChannelStatistics',
  bytes?: number | null,
  bitsPerSecond?: number | null
};

export type DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_channelBenchmark_ChannelBenchmark = {
  __typename?: 'ChannelBenchmark',
  startedAt?: Date | null,
  error?: string | null,
  tcpDown?: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_channelBenchmark_ChannelBenchmark_tcpDown_ChannelStatistics | null,
  tcpUp?: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_channelBenchmark_ChannelBenchmark_tcpUp_ChannelStatistics | null
};

export type DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_channelTurnaroundTime_StatTime = {
  __typename?: 'StatTime',
  avg: number,
  max: number,
  min: number
};

export type DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_packetArrivalJitterTime_StatTime = {
  __typename?: 'StatTime',
  avg: number,
  max: number,
  min: number
};

export type DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_vaeUpdates_VaeUpdate = {
  __typename?: 'VaeUpdate',
  name: string,
  status: VaeUpdateStatus,
  version?: string | null,
  log?: Array<string> | null
};

export type DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_template_FunctionalAspectTemplate_features_VaeFeature = {
  __typename?: 'VaeFeature',
  id: string,
  name: string,
  order: number,
  exclusive?: boolean | null
};

export type DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_template_FunctionalAspectTemplate = {
  __typename?: 'FunctionalAspectTemplate',
  id: string,
  type: DeviceFunctionalAspectType,
  name: string,
  order: number,
  engine?: string | null,
  features?: Array<DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_template_FunctionalAspectTemplate_features_VaeFeature> | null
};

export type DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_device_Device = {
  __typename?: 'Device',
  id: string,
  name: string
};

export type DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_health_AspectHealth = {
  __typename?: 'AspectHealth',
  gravity: Fa_HealthGravity,
  readinessTimeout: number,
  livenessTimeout: number,
  healthStatus: HealthStatus
};

export type DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_inputAspects_DFA_Avatar = {
  __typename?: 'DFA_Avatar',
  id: string,
  name: string
};

export type DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_inputAspects_DFA_Gateway = {
  __typename?: 'DFA_Gateway',
  id: string,
  name: string
};

export type DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_inputAspects_DFA_Media = {
  __typename?: 'DFA_Media',
  id: string,
  name: string
};

export type DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_inputAspects_DFA_PTZ = {
  __typename?: 'DFA_PTZ',
  id: string,
  name: string
};

export type DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_inputAspects_DFA_Sensor = {
  __typename?: 'DFA_Sensor',
  id: string,
  name: string
};

export type DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_inputAspects_DFA_VAE = {
  __typename?: 'DFA_VAE',
  id: string,
  name: string
};

export type DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_inputAspects =
  | DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_inputAspects_DFA_Avatar
  | DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_inputAspects_DFA_Gateway
  | DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_inputAspects_DFA_Media
  | DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_inputAspects_DFA_PTZ
  | DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_inputAspects_DFA_Sensor
  | DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_inputAspects_DFA_VAE
;

export type DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_directory_GatewayDirectory = {
  __typename?: 'GatewayDirectory',
  id: string,
  name: string
};

export type DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_associatedGatewayDevices_AssociatedGatewayDevice = {
  __typename?: 'AssociatedGatewayDevice',
  id: string,
  associatedDevices: Array<string>
};

export type DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_subscribedEvents_GatewayEvent = {
  __typename?: 'GatewayEvent',
  id: string,
  type: string
};

export type DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_directories_GatewayDirectory = {
  __typename?: 'GatewayDirectory',
  id: string,
  name: string
};

export type DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_devices_GatewayProbeDevice = {
  __typename?: 'GatewayProbeDevice',
  id: string,
  name: string
};

export type DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_events_GatewayProbeEvent = {
  __typename?: 'GatewayProbeEvent',
  id: string,
  name: string
};

export type DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_ptzTcpAddress_PtzTcpAddress = {
  __typename?: 'PtzTcpAddress',
  ip?: string | null,
  port?: number | null
};

export type DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_sensorEvents_SensorEvent = {
  __typename?: 'SensorEvent',
  type: string,
  description: string,
  enabled?: boolean | null,
  source?: EventSource | null,
  innerProps?: any | null
};

export type DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_qortexZones_QortexZone_points_QortexZonePoint = {
  __typename?: 'QortexZonePoint',
  x: number,
  y: number
};

export type DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_qortexZones_QortexZone = {
  __typename?: 'QortexZone',
  name: string,
  zMax: number,
  zMin: number,
  witness?: Array<string | null> | null,
  points: Array<DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_qortexZones_QortexZone_points_QortexZonePoint>
};

export type DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_qortexMappedZones_QortexMappedZone = {
  __typename?: 'QortexMappedZone',
  name: string,
  witness: Array<string>
};

export type DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_vaeConfig_VaeConfigFull = {
  __typename?: 'VaeConfigFull',
  name: string,
  description: string,
  configuration: any
};

export type DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_vaeFps_VaeFps_requestedFps_MinMax = {
  __typename?: 'MinMax',
  minFps: number,
  maxFps: number
};

export type DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_vaeFps_VaeFps_engineFps_MinMax = {
  __typename?: 'MinMax',
  minFps: number,
  maxFps: number
};

export type DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_vaeFps_VaeFps = {
  __typename?: 'VaeFps',
  requestedFps: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_vaeFps_VaeFps_requestedFps_MinMax,
  engineFps: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_vaeFps_VaeFps_engineFps_MinMax
};

export type DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_vaeStatistic_VaeStatistic_fps_VaeStatFps = {
  __typename?: 'VaeStatFps',
  avg: number,
  max: number,
  min: number,
  range: number
};

export type DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_vaeStatistic_VaeStatistic = {
  __typename?: 'VaeStatistic',
  status?: VaeStatus | null,
  uptime?: number | null,
  restarts?: number | null,
  avgLatency?: number | null,
  eps?: number | null,
  metadataBps?: number | null,
  reason?: string | null,
  fps?: Array<DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_vaeStatistic_VaeStatistic_fps_VaeStatFps> | null
};

export type DeviceFieldsFragment_Device_aspects_DFA_Avatar = {
  __typename?: 'DFA_Avatar',
  isLink?: boolean | null,
  channelStatus?: ChannelStatus | null,
  dsConfiguredState?: DsConfiguredState | null,
  dsRunningState?: DsRunningState | null,
  lastStatusUpdate?: Date | null,
  vmxVideoStreamingMode?: VmxVideoStreamingMode | null,
  vaeImageUpdate?: boolean | null,
  webRtcEnabled?: boolean | null,
  uploadBandwidthCap?: number | null,
  platform?: string | null,
  upTime?: number | null,
  avatarLoad?: number | null,
  deliveryQueue?: number | null,
  deliveryQueueUploadTime?: number | null,
  turnaroundTime?: number | null,
  supportsReboot?: boolean | null,
  apiKey?: string | null,
  id: string,
  type: DeviceFunctionalAspectType,
  name: string,
  enabled: boolean,
  onvifServiceConf: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_onvifServiceConf_OnvifServiceConfig,
  storageUsage?: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_storageUsage_StorageUsage | null,
  software?: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_software_SoftwareInfo | null,
  channelBenchmark?: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_channelBenchmark_ChannelBenchmark | null,
  channelTurnaroundTime?: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_channelTurnaroundTime_StatTime | null,
  packetArrivalJitterTime?: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_packetArrivalJitterTime_StatTime | null,
  vaeUpdates?: Array<DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_vaeUpdates_VaeUpdate> | null,
  template: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_template_FunctionalAspectTemplate,
  device?: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_device_Device | null,
  health: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_health_AspectHealth,
  inputAspects: Array<DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_inputAspects>
};

export type DeviceFieldsFragment_Device_aspects_DFA_Gateway = {
  __typename?: 'DFA_Gateway',
  lenelVersion: string,
  oidcToken?: string | null,
  id: string,
  type: DeviceFunctionalAspectType,
  name: string,
  enabled: boolean,
  directory: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_directory_GatewayDirectory,
  associatedGatewayDevices: Array<DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_associatedGatewayDevices_AssociatedGatewayDevice>,
  subscribedEvents: Array<DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_subscribedEvents_GatewayEvent>,
  directories: Array<DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_directories_GatewayDirectory>,
  devices: Array<DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_devices_GatewayProbeDevice>,
  events: Array<DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_events_GatewayProbeEvent>,
  template: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_template_FunctionalAspectTemplate,
  device?: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_device_Device | null,
  health: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_health_AspectHealth,
  inputAspects: Array<DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_inputAspects>
};

export type DeviceFieldsFragment_Device_aspects_DFA_Media = {
  __typename?: 'DFA_Media',
  streamSize?: MediaStreamSize | null,
  streamType: MediaStreamType,
  URL?: string | null,
  videoWidth?: number | null,
  videoHeight?: number | null,
  codec?: string | null,
  frameRate?: number | null,
  onvifProfile?: string | null,
  onvifProfiles?: any | null,
  recordingArchive: RecordingArchive,
  cloudArchive: MediaArchiveOption,
  consumedSpace?: number | null,
  spaceUsageHour?: number | null,
  spaceUsageDay?: number | null,
  FPS?: number | null,
  liveBitrate?: number | null,
  uptime?: number | null,
  averageFPS?: number | null,
  averageGOP?: number | null,
  averageInterArrivalJitter?: number | null,
  rtpPacketLost?: number | null,
  videoCodec?: string | null,
  videoSize?: string | null,
  audioCodec?: string | null,
  id: string,
  type: DeviceFunctionalAspectType,
  name: string,
  enabled: boolean,
  template: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_template_FunctionalAspectTemplate,
  device?: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_device_Device | null,
  health: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_health_AspectHealth,
  inputAspects: Array<DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_inputAspects>
};

export type DeviceFieldsFragment_Device_aspects_DFA_PTZ = {
  __typename?: 'DFA_PTZ',
  ptzType: PtzType,
  ptzPanInverted?: boolean | null,
  ptzTiltInverted?: boolean | null,
  ptzConfig?: string | null,
  id: string,
  type: DeviceFunctionalAspectType,
  name: string,
  enabled: boolean,
  ptzId?: string | null,
  ptzAttachedCamera1Address?: number | null,
  ptzAttachedCamera1BaudRate?: PtzAttachedBaudRate | null,
  ptzAttachedCamera1SerialMode?: PtzAttachedSerialMode | null,
  ptzAttachedCamera1Model?: PtzAttachedCameraModel | null,
  ptzAttachedCamera2Address?: number | null,
  ptzAttachedCamera2BaudRate?: PtzAttachedBaudRate | null,
  ptzAttachedCamera2SerialMode?: PtzAttachedSerialMode | null,
  ptzAttachedCamera2Model?: PtzAttachedCameraModel | null,
  cameraType: CameraType,
  template: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_template_FunctionalAspectTemplate,
  device?: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_device_Device | null,
  health: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_health_AspectHealth,
  inputAspects: Array<DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_inputAspects>,
  ptzTcpAddress?: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_ptzTcpAddress_PtzTcpAddress | null
};

export type DeviceFieldsFragment_Device_aspects_DFA_Sensor = {
  __typename?: 'DFA_Sensor',
  model?: string | null,
  serial?: string | null,
  userEvents?: Array<string> | null,
  associatedDevices?: Array<string> | null,
  category?: AspectSensorCategory | null,
  eltaNorthOffset?: number | null,
  eltaFrequencyControlCenter?: number | null,
  id: string,
  type: DeviceFunctionalAspectType,
  name: string,
  enabled: boolean,
  sensorEvents?: Array<DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_sensorEvents_SensorEvent> | null,
  qortexZones?: Array<DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_qortexZones_QortexZone> | null,
  qortexMappedZones?: Array<DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_qortexMappedZones_QortexMappedZone> | null,
  template: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_template_FunctionalAspectTemplate,
  device?: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_device_Device | null,
  health: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_health_AspectHealth,
  inputAspects: Array<DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_inputAspects>
};

export type DeviceFieldsFragment_Device_aspects_DFA_VAE = {
  __typename?: 'DFA_VAE',
  id: string,
  type: DeviceFunctionalAspectType,
  name: string,
  enabled: boolean,
  streamSize?: MediaStreamSize | null,
  eventType?: DeviceEventType | null,
  vaeFeatures?: Array<string> | null,
  template: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_template_FunctionalAspectTemplate,
  device?: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_device_Device | null,
  health: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_health_AspectHealth,
  inputAspects: Array<DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_inputAspects>,
  vaeConfig?: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_vaeConfig_VaeConfigFull | null,
  vaeFps?: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_vaeFps_VaeFps | null,
  vaeStatistic?: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_vaeStatistic_VaeStatistic | null
};

export type DeviceFieldsFragment_Device_aspects =
  | DeviceFieldsFragment_Device_aspects_DFA_Avatar
  | DeviceFieldsFragment_Device_aspects_DFA_Gateway
  | DeviceFieldsFragment_Device_aspects_DFA_Media
  | DeviceFieldsFragment_Device_aspects_DFA_PTZ
  | DeviceFieldsFragment_Device_aspects_DFA_Sensor
  | DeviceFieldsFragment_Device_aspects_DFA_VAE
;

export type DeviceFieldsFragment_Device_cameraView_CameraView_ptzStatus_PtzStatus_position_PtzPosition = {
  __typename?: 'PtzPosition',
  pan: number,
  tilt: number,
  hfov: number
};

export type DeviceFieldsFragment_Device_cameraView_CameraView_ptzStatus_PtzStatus_lock_PtzLock = {
  __typename?: 'PtzLock',
  category: PtzLockCategory,
  explicit?: boolean | null,
  userId?: string | null,
  expire: Date,
  userName?: string | null
};

export type DeviceFieldsFragment_Device_cameraView_CameraView_ptzStatus_PtzStatus = {
  __typename?: 'PtzStatus',
  position?: DeviceFieldsFragment_Device_cameraView_CameraView_ptzStatus_PtzStatus_position_PtzPosition | null,
  lock?: DeviceFieldsFragment_Device_cameraView_CameraView_ptzStatus_PtzStatus_lock_PtzLock | null
};

export type DeviceFieldsFragment_Device_cameraView_CameraView = {
  __typename?: 'CameraView',
  fieldOfView?: number | null,
  northOffsetAngle?: number | null,
  viewDistance?: number | null,
  ptzStatus?: DeviceFieldsFragment_Device_cameraView_CameraView_ptzStatus_PtzStatus | null
};

export type DeviceFieldsFragment = {
  __typename?: 'Device',
  id: string,
  name: string,
  createdAt?: Date | null,
  modifiedAt?: Date | null,
  enabled: boolean,
  cloudDirect: boolean,
  healthStatus: HealthStatus,
  version: string,
  location?: string | null,
  deliveryPriority?: number | null,
  eventType?: DeviceEventType | null,
  rtpOverTcp?: boolean | null,
  rtpTime?: boolean | null,
  deviceType?: BaseDeviceType | null,
  acknowledgeRequired?: boolean | null,
  geoZone?: any | null,
  eventTimeFromRealm?: boolean | null,
  preEventTime?: number | null,
  postEventTime?: number | null,
  position?: DeviceFieldsFragment_Device_position_LatLng | null,
  alarmPointPosition?: DeviceFieldsFragment_Device_alarmPointPosition_LatLng | null,
  config: DeviceFieldsFragment_Device_config_DeviceBaseConfig,
  platform?: DeviceFieldsFragment_Device_platform_Device | null,
  sharedStream?: Array<DeviceFieldsFragment_Device_sharedStream_StreamShare> | null,
  zone?: DeviceFieldsFragment_Device_zone_ObjectDescriptor | null,
  set?: Array<DeviceFieldsFragment_Device_set_ObjectDescriptor> | null,
  storageConfig?: DeviceFieldsFragment_Device_storageConfig_DeviceStorageConfig | null,
  aspects: Array<DeviceFieldsFragment_Device_aspects>,
  cameraView?: DeviceFieldsFragment_Device_cameraView_CameraView | null
};

export type DeviceGeoFieldsFragment_Device_position_LatLng = {
  __typename?: 'LatLng',
  lat: number,
  lng: number,
  alt?: number | null
};

export type DeviceGeoFieldsFragment_Device_alarmPointPosition_LatLng = {
  __typename?: 'LatLng',
  lat: number,
  lng: number,
  alt?: number | null
};

export type DeviceGeoFieldsFragment_Device_cameraView_CameraView_ptzStatus_PtzStatus = {
  __typename?: 'PtzStatus',
  position?: DeviceFieldsFragment_Device_cameraView_CameraView_ptzStatus_PtzStatus_position_PtzPosition | null,
  lock?: DeviceFieldsFragment_Device_cameraView_CameraView_ptzStatus_PtzStatus_lock_PtzLock | null
};

export type DeviceGeoFieldsFragment_Device_cameraView_CameraView_ptzLockProlongation_PtzLockProlongation = {
  __typename?: 'PtzLockProlongation',
  createdAt: Date,
  token: string,
  userId: string
};

export type DeviceGeoFieldsFragment_Device_cameraView_CameraView = {
  __typename?: 'CameraView',
  northOffsetAngle?: number | null,
  ptzStatus?: DeviceGeoFieldsFragment_Device_cameraView_CameraView_ptzStatus_PtzStatus | null,
  ptzLockProlongation?: DeviceGeoFieldsFragment_Device_cameraView_CameraView_ptzLockProlongation_PtzLockProlongation | null
};

export type DeviceGeoFieldsFragment_Device_aspects_DFA_Avatar = {
  __typename?: 'DFA_Avatar',
  type: DeviceFunctionalAspectType,
  enabled: boolean
};

export type DeviceGeoFieldsFragment_Device_aspects_DFA_Gateway = {
  __typename?: 'DFA_Gateway',
  type: DeviceFunctionalAspectType,
  enabled: boolean
};

export type DeviceGeoFieldsFragment_Device_aspects_DFA_Media = {
  __typename?: 'DFA_Media',
  type: DeviceFunctionalAspectType,
  enabled: boolean
};

export type DeviceGeoFieldsFragment_Device_aspects_DFA_PTZ = {
  __typename?: 'DFA_PTZ',
  type: DeviceFunctionalAspectType,
  enabled: boolean
};

export type DeviceGeoFieldsFragment_Device_aspects_DFA_Sensor = {
  __typename?: 'DFA_Sensor',
  type: DeviceFunctionalAspectType,
  enabled: boolean
};

export type DeviceGeoFieldsFragment_Device_aspects_DFA_VAE = {
  __typename?: 'DFA_VAE',
  type: DeviceFunctionalAspectType,
  enabled: boolean
};

export type DeviceGeoFieldsFragment_Device_aspects =
  | DeviceGeoFieldsFragment_Device_aspects_DFA_Avatar
  | DeviceGeoFieldsFragment_Device_aspects_DFA_Gateway
  | DeviceGeoFieldsFragment_Device_aspects_DFA_Media
  | DeviceGeoFieldsFragment_Device_aspects_DFA_PTZ
  | DeviceGeoFieldsFragment_Device_aspects_DFA_Sensor
  | DeviceGeoFieldsFragment_Device_aspects_DFA_VAE
;

export type DeviceGeoFieldsFragment = {
  __typename?: 'Device',
  id: string,
  name: string,
  enabled: boolean,
  healthStatus: HealthStatus,
  geoZone?: any | null,
  position?: DeviceGeoFieldsFragment_Device_position_LatLng | null,
  alarmPointPosition?: DeviceGeoFieldsFragment_Device_alarmPointPosition_LatLng | null,
  cameraView?: DeviceGeoFieldsFragment_Device_cameraView_CameraView | null,
  aspects: Array<DeviceGeoFieldsFragment_Device_aspects>
};

export type PtzStatusFieldsFragment = {
  __typename?: 'PtzStatus',
  position?: DeviceFieldsFragment_Device_cameraView_CameraView_ptzStatus_PtzStatus_position_PtzPosition | null,
  lock?: DeviceFieldsFragment_Device_cameraView_CameraView_ptzStatus_PtzStatus_lock_PtzLock | null
};

export type CameraViewFieldsFragment = {
  __typename?: 'CameraView',
  fieldOfView?: number | null,
  northOffsetAngle?: number | null,
  viewDistance?: number | null,
  ptzStatus?: DeviceFieldsFragment_Device_cameraView_CameraView_ptzStatus_PtzStatus | null
};

export type StatTimeFieldsFragment = {
  __typename?: 'StatTime',
  avg: number,
  max: number,
  min: number
};

export type AdminCameraFieldsFragment_Device_config_DeviceBaseConfig_connect_NetworkConnectDescriptor = {
  __typename?: 'NetworkConnectDescriptor',
  host?: string | null,
  hosts?: Array<string> | null,
  port?: number | null,
  URL?: string | null
};

export type AdminCameraFieldsFragment_Device_config_DeviceBaseConfig = {
  __typename?: 'DeviceBaseConfig',
  configType: DeviceBaseConfigType,
  connect: AdminCameraFieldsFragment_Device_config_DeviceBaseConfig_connect_NetworkConnectDescriptor
};

export type AdminCameraFieldsFragment_Device_zone_ObjectDescriptor = {
  __typename?: 'ObjectDescriptor',
  id: string,
  name: string,
  isSystemManaged?: boolean | null,
  type: RealmObjectType
};

export type AdminCameraFieldsFragment_Device_platform_Device = {
  __typename?: 'Device',
  name: string,
  id: string
};

export type AdminCameraFieldsFragment_Device_aspects_DFA_VAE_health_AspectHealth = {
  __typename?: 'AspectHealth',
  healthStatus: HealthStatus
};

export type AdminCameraFieldsFragment_Device_aspects_DFA_VAE_vaeStatistic_VaeStatistic = {
  __typename?: 'VaeStatistic',
  reason?: string | null
};

export type AdminCameraFieldsFragment_Device_aspects_DFA_Avatar = {
  __typename?: 'DFA_Avatar',
  id: string,
  enabled: boolean,
  type: DeviceFunctionalAspectType
};

export type AdminCameraFieldsFragment_Device_aspects_DFA_Gateway = {
  __typename?: 'DFA_Gateway',
  id: string,
  enabled: boolean,
  type: DeviceFunctionalAspectType
};

export type AdminCameraFieldsFragment_Device_aspects_DFA_Media = {
  __typename?: 'DFA_Media',
  streamType: MediaStreamType,
  streamSize?: MediaStreamSize | null,
  videoCodec?: string | null,
  videoSize?: string | null,
  audioCodec?: string | null,
  FPS?: number | null,
  averageGOP?: number | null,
  liveBitrate?: number | null,
  id: string,
  enabled: boolean,
  type: DeviceFunctionalAspectType
};

export type AdminCameraFieldsFragment_Device_aspects_DFA_PTZ = {
  __typename?: 'DFA_PTZ',
  id: string,
  enabled: boolean,
  type: DeviceFunctionalAspectType
};

export type AdminCameraFieldsFragment_Device_aspects_DFA_Sensor = {
  __typename?: 'DFA_Sensor',
  id: string,
  enabled: boolean,
  type: DeviceFunctionalAspectType
};

export type AdminCameraFieldsFragment_Device_aspects_DFA_VAE = {
  __typename?: 'DFA_VAE',
  name: string,
  id: string,
  enabled: boolean,
  type: DeviceFunctionalAspectType,
  health: AdminCameraFieldsFragment_Device_aspects_DFA_VAE_health_AspectHealth,
  vaeStatistic?: AdminCameraFieldsFragment_Device_aspects_DFA_VAE_vaeStatistic_VaeStatistic | null
};

export type AdminCameraFieldsFragment_Device_aspects =
  | AdminCameraFieldsFragment_Device_aspects_DFA_Avatar
  | AdminCameraFieldsFragment_Device_aspects_DFA_Gateway
  | AdminCameraFieldsFragment_Device_aspects_DFA_Media
  | AdminCameraFieldsFragment_Device_aspects_DFA_PTZ
  | AdminCameraFieldsFragment_Device_aspects_DFA_Sensor
  | AdminCameraFieldsFragment_Device_aspects_DFA_VAE
;

export type AdminCameraFieldsFragment = {
  __typename?: 'Device',
  id: string,
  name: string,
  location?: string | null,
  enabled: boolean,
  healthStatus: HealthStatus,
  deviceType?: BaseDeviceType | null,
  config: AdminCameraFieldsFragment_Device_config_DeviceBaseConfig,
  zone?: AdminCameraFieldsFragment_Device_zone_ObjectDescriptor | null,
  platform?: AdminCameraFieldsFragment_Device_platform_Device | null,
  aspects: Array<AdminCameraFieldsFragment_Device_aspects>
};

export type DevicePlayerFieldsFragment_Device_aspects_DFA_Avatar = {
  __typename?: 'DFA_Avatar',
  enabled: boolean
};

export type DevicePlayerFieldsFragment_Device_aspects_DFA_Gateway = {
  __typename?: 'DFA_Gateway',
  enabled: boolean
};

export type DevicePlayerFieldsFragment_Device_aspects_DFA_Media = {
  __typename?: 'DFA_Media',
  enabled: boolean,
  streamSize?: MediaStreamSize | null,
  streamType: MediaStreamType,
  videoWidth?: number | null,
  videoHeight?: number | null
};

export type DevicePlayerFieldsFragment_Device_aspects_DFA_PTZ = {
  __typename?: 'DFA_PTZ',
  enabled: boolean
};

export type DevicePlayerFieldsFragment_Device_aspects_DFA_Sensor = {
  __typename?: 'DFA_Sensor',
  enabled: boolean
};

export type DevicePlayerFieldsFragment_Device_aspects_DFA_VAE = {
  __typename?: 'DFA_VAE',
  enabled: boolean
};

export type DevicePlayerFieldsFragment_Device_aspects =
  | DevicePlayerFieldsFragment_Device_aspects_DFA_Avatar
  | DevicePlayerFieldsFragment_Device_aspects_DFA_Gateway
  | DevicePlayerFieldsFragment_Device_aspects_DFA_Media
  | DevicePlayerFieldsFragment_Device_aspects_DFA_PTZ
  | DevicePlayerFieldsFragment_Device_aspects_DFA_Sensor
  | DevicePlayerFieldsFragment_Device_aspects_DFA_VAE
;

export type DevicePlayerFieldsFragment_Device_platform_Device_aspects_DFA_Avatar = {
  __typename?: 'DFA_Avatar',
  webRtcEnabled?: boolean | null
};

export type DevicePlayerFieldsFragment_Device_platform_Device_aspects_DFA_Gateway = {
  __typename?: 'DFA_Gateway'
};

export type DevicePlayerFieldsFragment_Device_platform_Device_aspects_DFA_Media = {
  __typename?: 'DFA_Media'
};

export type DevicePlayerFieldsFragment_Device_platform_Device_aspects_DFA_PTZ = {
  __typename?: 'DFA_PTZ'
};

export type DevicePlayerFieldsFragment_Device_platform_Device_aspects_DFA_Sensor = {
  __typename?: 'DFA_Sensor'
};

export type DevicePlayerFieldsFragment_Device_platform_Device_aspects_DFA_VAE = {
  __typename?: 'DFA_VAE'
};

export type DevicePlayerFieldsFragment_Device_platform_Device_aspects =
  | DevicePlayerFieldsFragment_Device_platform_Device_aspects_DFA_Avatar
  | DevicePlayerFieldsFragment_Device_platform_Device_aspects_DFA_Gateway
  | DevicePlayerFieldsFragment_Device_platform_Device_aspects_DFA_Media
  | DevicePlayerFieldsFragment_Device_platform_Device_aspects_DFA_PTZ
  | DevicePlayerFieldsFragment_Device_platform_Device_aspects_DFA_Sensor
  | DevicePlayerFieldsFragment_Device_platform_Device_aspects_DFA_VAE
;

export type DevicePlayerFieldsFragment_Device_platform_Device = {
  __typename?: 'Device',
  aspects: Array<DevicePlayerFieldsFragment_Device_platform_Device_aspects>
};

export type DevicePlayerFieldsFragment_Device_cameraView_CameraView_ptzStatus_PtzStatus = {
  __typename?: 'PtzStatus',
  position?: DeviceFieldsFragment_Device_cameraView_CameraView_ptzStatus_PtzStatus_position_PtzPosition | null,
  lock?: DeviceFieldsFragment_Device_cameraView_CameraView_ptzStatus_PtzStatus_lock_PtzLock | null
};

export type DevicePlayerFieldsFragment_Device_cameraView_CameraView = {
  __typename?: 'CameraView',
  ptzStatus?: DevicePlayerFieldsFragment_Device_cameraView_CameraView_ptzStatus_PtzStatus | null
};

export type DevicePlayerFieldsFragment = {
  __typename?: 'Device',
  id: string,
  name: string,
  cloudDirect: boolean,
  preEventTime?: number | null,
  postEventTime?: number | null,
  aspects: Array<DevicePlayerFieldsFragment_Device_aspects>,
  platform?: DevicePlayerFieldsFragment_Device_platform_Device | null,
  cameraView?: DevicePlayerFieldsFragment_Device_cameraView_CameraView | null
};

export type DeviceListFieldsFragment = {
  __typename?: 'Device',
  id: string,
  name: string,
  enabled: boolean,
  healthStatus: HealthStatus,
  deviceType?: BaseDeviceType | null
};

export type DeviceReportFieldsFragment_Device_config_DeviceBaseConfig_connect_NetworkConnectDescriptor = {
  __typename?: 'NetworkConnectDescriptor',
  host?: string | null,
  hosts?: Array<string> | null,
  user?: string | null
};

export type DeviceReportFieldsFragment_Device_config_DeviceBaseConfig = {
  __typename?: 'DeviceBaseConfig',
  model?: string | null,
  configType: DeviceBaseConfigType,
  connect: DeviceReportFieldsFragment_Device_config_DeviceBaseConfig_connect_NetworkConnectDescriptor
};

export type DeviceReportFieldsFragment_Device_aspects_DFA_Avatar_software_SoftwareInfo = {
  __typename?: 'SoftwareInfo',
  lastUpdateTime?: Date | null
};

export type DeviceReportFieldsFragment_Device_aspects_DFA_Avatar = {
  __typename?: 'DFA_Avatar',
  channelStatus?: ChannelStatus | null,
  lastStatusUpdate?: Date | null,
  deliveryQueue?: number | null,
  deliveryQueueUploadTime?: number | null,
  turnaroundTime?: number | null,
  type: DeviceFunctionalAspectType,
  enabled: boolean,
  software?: DeviceReportFieldsFragment_Device_aspects_DFA_Avatar_software_SoftwareInfo | null
};

export type DeviceReportFieldsFragment_Device_aspects_DFA_Gateway = {
  __typename?: 'DFA_Gateway',
  type: DeviceFunctionalAspectType,
  enabled: boolean
};

export type DeviceReportFieldsFragment_Device_aspects_DFA_Media = {
  __typename?: 'DFA_Media',
  codec?: string | null,
  cloudArchive: MediaArchiveOption,
  consumedSpace?: number | null,
  spaceUsageDay?: number | null,
  FPS?: number | null,
  liveBitrate?: number | null,
  streamSize?: MediaStreamSize | null,
  type: DeviceFunctionalAspectType,
  enabled: boolean
};

export type DeviceReportFieldsFragment_Device_aspects_DFA_PTZ = {
  __typename?: 'DFA_PTZ',
  type: DeviceFunctionalAspectType,
  enabled: boolean
};

export type DeviceReportFieldsFragment_Device_aspects_DFA_Sensor = {
  __typename?: 'DFA_Sensor',
  type: DeviceFunctionalAspectType,
  enabled: boolean
};

export type DeviceReportFieldsFragment_Device_aspects_DFA_VAE = {
  __typename?: 'DFA_VAE',
  type: DeviceFunctionalAspectType,
  enabled: boolean
};

export type DeviceReportFieldsFragment_Device_aspects =
  | DeviceReportFieldsFragment_Device_aspects_DFA_Avatar
  | DeviceReportFieldsFragment_Device_aspects_DFA_Gateway
  | DeviceReportFieldsFragment_Device_aspects_DFA_Media
  | DeviceReportFieldsFragment_Device_aspects_DFA_PTZ
  | DeviceReportFieldsFragment_Device_aspects_DFA_Sensor
  | DeviceReportFieldsFragment_Device_aspects_DFA_VAE
;

export type DeviceReportFieldsFragment_Device_platform_Device = {
  __typename?: 'Device',
  name: string
};

export type DeviceReportFieldsFragment = {
  __typename?: 'Device',
  id: string,
  name: string,
  healthStatus: HealthStatus,
  config: DeviceReportFieldsFragment_Device_config_DeviceBaseConfig,
  aspects: Array<DeviceReportFieldsFragment_Device_aspects>,
  platform?: DeviceReportFieldsFragment_Device_platform_Device | null
};

export type DeviceShortFieldsFragment_Device_config_DeviceBaseConfig_connect_NetworkConnectDescriptor = {
  __typename?: 'NetworkConnectDescriptor',
  host?: string | null,
  hosts?: Array<string> | null,
  port?: number | null,
  URL?: string | null
};

export type DeviceShortFieldsFragment_Device_config_DeviceBaseConfig = {
  __typename?: 'DeviceBaseConfig',
  connect: DeviceShortFieldsFragment_Device_config_DeviceBaseConfig_connect_NetworkConnectDescriptor
};

export type DeviceShortFieldsFragment_Device_aspects_DFA_Avatar_software_SoftwareInfo = {
  __typename?: 'SoftwareInfo',
  version?: string | null,
  updateAvailable?: boolean | null
};

export type DeviceShortFieldsFragment_Device_aspects_DFA_Avatar = {
  __typename?: 'DFA_Avatar',
  isLink?: boolean | null,
  channelStatus?: ChannelStatus | null,
  lastStatusUpdate?: Date | null,
  upTime?: number | null,
  type: DeviceFunctionalAspectType,
  software?: DeviceShortFieldsFragment_Device_aspects_DFA_Avatar_software_SoftwareInfo | null
};

export type DeviceShortFieldsFragment_Device_aspects_DFA_Gateway = {
  __typename?: 'DFA_Gateway',
  type: DeviceFunctionalAspectType
};

export type DeviceShortFieldsFragment_Device_aspects_DFA_Media = {
  __typename?: 'DFA_Media',
  enabled: boolean,
  cloudArchive: MediaArchiveOption,
  FPS?: number | null,
  liveBitrate?: number | null,
  averageGOP?: number | null,
  videoCodec?: string | null,
  audioCodec?: string | null,
  videoSize?: string | null,
  streamSize?: MediaStreamSize | null,
  streamType: MediaStreamType,
  type: DeviceFunctionalAspectType
};

export type DeviceShortFieldsFragment_Device_aspects_DFA_PTZ = {
  __typename?: 'DFA_PTZ',
  type: DeviceFunctionalAspectType
};

export type DeviceShortFieldsFragment_Device_aspects_DFA_Sensor = {
  __typename?: 'DFA_Sensor',
  type: DeviceFunctionalAspectType
};

export type DeviceShortFieldsFragment_Device_aspects_DFA_VAE = {
  __typename?: 'DFA_VAE',
  type: DeviceFunctionalAspectType
};

export type DeviceShortFieldsFragment_Device_aspects =
  | DeviceShortFieldsFragment_Device_aspects_DFA_Avatar
  | DeviceShortFieldsFragment_Device_aspects_DFA_Gateway
  | DeviceShortFieldsFragment_Device_aspects_DFA_Media
  | DeviceShortFieldsFragment_Device_aspects_DFA_PTZ
  | DeviceShortFieldsFragment_Device_aspects_DFA_Sensor
  | DeviceShortFieldsFragment_Device_aspects_DFA_VAE
;

export type DeviceShortFieldsFragment_Device_position_LatLng = {
  __typename?: 'LatLng',
  lat: number,
  lng: number,
  alt?: number | null
};

export type DeviceShortFieldsFragment_Device_platform_Device = {
  __typename?: 'Device',
  id: string,
  name: string
};

export type DeviceShortFieldsFragment_Device_zone_ObjectDescriptor = {
  __typename?: 'ObjectDescriptor',
  id: string,
  name: string,
  isSystemManaged?: boolean | null,
  type: RealmObjectType
};

export type DeviceShortFieldsFragment = {
  __typename?: 'Device',
  id: string,
  name: string,
  location?: string | null,
  enabled: boolean,
  healthStatus: HealthStatus,
  deliveryPriority?: number | null,
  deviceType?: BaseDeviceType | null,
  config: DeviceShortFieldsFragment_Device_config_DeviceBaseConfig,
  aspects: Array<DeviceShortFieldsFragment_Device_aspects>,
  position?: DeviceShortFieldsFragment_Device_position_LatLng | null,
  platform?: DeviceShortFieldsFragment_Device_platform_Device | null,
  zone?: DeviceShortFieldsFragment_Device_zone_ObjectDescriptor | null
};

export type SensorListFieldsFragment_Device_zone_ObjectDescriptor = {
  __typename?: 'ObjectDescriptor',
  id: string,
  name: string,
  isSystemManaged?: boolean | null,
  type: RealmObjectType
};

export type SensorListFieldsFragment_Device_platform_Device = {
  __typename?: 'Device',
  id: string,
  name: string
};

export type SensorListFieldsFragment_Device_config_DeviceBaseConfig_connect_NetworkConnectDescriptor = {
  __typename?: 'NetworkConnectDescriptor',
  host?: string | null,
  port?: number | null
};

export type SensorListFieldsFragment_Device_config_DeviceBaseConfig = {
  __typename?: 'DeviceBaseConfig',
  make?: string | null,
  connect: SensorListFieldsFragment_Device_config_DeviceBaseConfig_connect_NetworkConnectDescriptor
};

export type SensorListFieldsFragment = {
  __typename?: 'Device',
  id: string,
  name: string,
  enabled: boolean,
  location?: string | null,
  healthStatus: HealthStatus,
  zone?: SensorListFieldsFragment_Device_zone_ObjectDescriptor | null,
  platform?: SensorListFieldsFragment_Device_platform_Device | null,
  config: SensorListFieldsFragment_Device_config_DeviceBaseConfig
};

export type GatewayListFieldsFragment_Device_platform_Device = {
  __typename?: 'Device',
  id: string,
  name: string
};

export type GatewayListFieldsFragment_Device_aspects_DFA_Gateway_associatedGatewayDevices_AssociatedGatewayDevice = {
  __typename?: 'AssociatedGatewayDevice',
  id: string,
  name: string,
  associatedDevices: Array<string>
};

export type GatewayListFieldsFragment_Device_aspects_DFA_Avatar = {
  __typename?: 'DFA_Avatar',
  type: DeviceFunctionalAspectType
};

export type GatewayListFieldsFragment_Device_aspects_DFA_Gateway = {
  __typename?: 'DFA_Gateway',
  type: DeviceFunctionalAspectType,
  associatedGatewayDevices: Array<GatewayListFieldsFragment_Device_aspects_DFA_Gateway_associatedGatewayDevices_AssociatedGatewayDevice>
};

export type GatewayListFieldsFragment_Device_aspects_DFA_Media = {
  __typename?: 'DFA_Media',
  type: DeviceFunctionalAspectType
};

export type GatewayListFieldsFragment_Device_aspects_DFA_PTZ = {
  __typename?: 'DFA_PTZ',
  type: DeviceFunctionalAspectType
};

export type GatewayListFieldsFragment_Device_aspects_DFA_Sensor = {
  __typename?: 'DFA_Sensor',
  type: DeviceFunctionalAspectType
};

export type GatewayListFieldsFragment_Device_aspects_DFA_VAE = {
  __typename?: 'DFA_VAE',
  type: DeviceFunctionalAspectType
};

export type GatewayListFieldsFragment_Device_aspects =
  | GatewayListFieldsFragment_Device_aspects_DFA_Avatar
  | GatewayListFieldsFragment_Device_aspects_DFA_Gateway
  | GatewayListFieldsFragment_Device_aspects_DFA_Media
  | GatewayListFieldsFragment_Device_aspects_DFA_PTZ
  | GatewayListFieldsFragment_Device_aspects_DFA_Sensor
  | GatewayListFieldsFragment_Device_aspects_DFA_VAE
;

export type GatewayListFieldsFragment_Device_config_DeviceBaseConfig = {
  __typename?: 'DeviceBaseConfig',
  model?: string | null
};

export type GatewayListFieldsFragment = {
  __typename?: 'Device',
  id: string,
  name: string,
  enabled: boolean,
  healthStatus: HealthStatus,
  platform?: GatewayListFieldsFragment_Device_platform_Device | null,
  aspects: Array<GatewayListFieldsFragment_Device_aspects>,
  config: GatewayListFieldsFragment_Device_config_DeviceBaseConfig
};

export type DeviceWitnessFieldsFragment_Device_platform_Device = {
  __typename?: 'Device',
  id: string
};

export type DeviceWitnessFieldsFragment_Device_position_LatLng = {
  __typename?: 'LatLng',
  lat: number,
  lng: number
};

export type DeviceWitnessFieldsFragment_Device_aspects_DFA_Avatar = {
  __typename?: 'DFA_Avatar',
  enabled: boolean
};

export type DeviceWitnessFieldsFragment_Device_aspects_DFA_Gateway = {
  __typename?: 'DFA_Gateway',
  enabled: boolean
};

export type DeviceWitnessFieldsFragment_Device_aspects_DFA_Media = {
  __typename?: 'DFA_Media',
  enabled: boolean
};

export type DeviceWitnessFieldsFragment_Device_aspects_DFA_PTZ = {
  __typename?: 'DFA_PTZ',
  enabled: boolean
};

export type DeviceWitnessFieldsFragment_Device_aspects_DFA_Sensor = {
  __typename?: 'DFA_Sensor',
  enabled: boolean
};

export type DeviceWitnessFieldsFragment_Device_aspects_DFA_VAE = {
  __typename?: 'DFA_VAE',
  enabled: boolean
};

export type DeviceWitnessFieldsFragment_Device_aspects =
  | DeviceWitnessFieldsFragment_Device_aspects_DFA_Avatar
  | DeviceWitnessFieldsFragment_Device_aspects_DFA_Gateway
  | DeviceWitnessFieldsFragment_Device_aspects_DFA_Media
  | DeviceWitnessFieldsFragment_Device_aspects_DFA_PTZ
  | DeviceWitnessFieldsFragment_Device_aspects_DFA_Sensor
  | DeviceWitnessFieldsFragment_Device_aspects_DFA_VAE
;

export type DeviceWitnessFieldsFragment = {
  __typename?: 'Device',
  id: string,
  name: string,
  enabled: boolean,
  healthStatus: HealthStatus,
  deviceType?: BaseDeviceType | null,
  platform?: DeviceWitnessFieldsFragment_Device_platform_Device | null,
  position?: DeviceWitnessFieldsFragment_Device_position_LatLng | null,
  aspects: Array<DeviceWitnessFieldsFragment_Device_aspects>
};

export type ObjectDescriptorFieldsFragment = {
  __typename?: 'ObjectDescriptor',
  id: string,
  name: string,
  isSystemManaged?: boolean | null,
  type: RealmObjectType
};

export type ConnectFieldsFragment = {
  __typename?: 'NetworkConnectDescriptor',
  authType: AuthType,
  URL?: string | null,
  host?: string | null,
  hosts?: Array<string> | null,
  user?: string | null,
  pass?: string | null,
  port?: number | null,
  rtspPort?: number | null,
  protocol?: ProtocolType | null,
  udpPort?: number | null,
  credentials?: DeviceFieldsFragment_Device_config_DeviceBaseConfig_connect_NetworkConnectDescriptor_credentials_Credentials | null
};

export type DeviceConfigFieldsFragment = {
  __typename?: 'DeviceBaseConfig',
  configType: DeviceBaseConfigType,
  make?: string | null,
  model?: string | null,
  firmware?: string | null,
  onvifServices?: string | null,
  stratusObjId?: string | null,
  connect: DeviceFieldsFragment_Device_config_DeviceBaseConfig_connect_NetworkConnectDescriptor
};

export type StorageConfigFieldsFragment = {
  __typename?: 'DeviceStorageConfig',
  storagePool: DeviceFieldsFragment_Device_storageConfig_DeviceStorageConfig_storagePool_StoragePool
};

export type StoragePoolFieldsFragment = {
  __typename?: 'StoragePool',
  id: string,
  name: string,
  ttlHours: number
};

export type Ptz_Moog_ConfigFragment = {
  __typename?: 'DFA_PTZ',
  ptzId?: string | null,
  ptzAttachedCamera1Address?: number | null,
  ptzAttachedCamera1BaudRate?: PtzAttachedBaudRate | null,
  ptzAttachedCamera1SerialMode?: PtzAttachedSerialMode | null,
  ptzAttachedCamera1Model?: PtzAttachedCameraModel | null,
  ptzAttachedCamera2Address?: number | null,
  ptzAttachedCamera2BaudRate?: PtzAttachedBaudRate | null,
  ptzAttachedCamera2SerialMode?: PtzAttachedSerialMode | null,
  ptzAttachedCamera2Model?: PtzAttachedCameraModel | null,
  ptzTcpAddress?: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_ptzTcpAddress_PtzTcpAddress | null
};

export type Ptz_ClearAlign_ConfigFragment = {
  __typename?: 'DFA_PTZ',
  cameraType: CameraType
};

type AspectFields_Dfa_Avatar_Fragment = {
  __typename?: 'DFA_Avatar',
  isLink?: boolean | null,
  channelStatus?: ChannelStatus | null,
  dsConfiguredState?: DsConfiguredState | null,
  dsRunningState?: DsRunningState | null,
  lastStatusUpdate?: Date | null,
  vmxVideoStreamingMode?: VmxVideoStreamingMode | null,
  vaeImageUpdate?: boolean | null,
  webRtcEnabled?: boolean | null,
  uploadBandwidthCap?: number | null,
  platform?: string | null,
  upTime?: number | null,
  avatarLoad?: number | null,
  deliveryQueue?: number | null,
  deliveryQueueUploadTime?: number | null,
  turnaroundTime?: number | null,
  supportsReboot?: boolean | null,
  apiKey?: string | null,
  id: string,
  type: DeviceFunctionalAspectType,
  name: string,
  enabled: boolean,
  onvifServiceConf: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_onvifServiceConf_OnvifServiceConfig,
  storageUsage?: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_storageUsage_StorageUsage | null,
  software?: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_software_SoftwareInfo | null,
  channelBenchmark?: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_channelBenchmark_ChannelBenchmark | null,
  channelTurnaroundTime?: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_channelTurnaroundTime_StatTime | null,
  packetArrivalJitterTime?: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_packetArrivalJitterTime_StatTime | null,
  vaeUpdates?: Array<DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_vaeUpdates_VaeUpdate> | null,
  template: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_template_FunctionalAspectTemplate,
  device?: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_device_Device | null,
  health: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_health_AspectHealth,
  inputAspects: Array<DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_inputAspects>
};

type AspectFields_Dfa_Gateway_Fragment = {
  __typename?: 'DFA_Gateway',
  lenelVersion: string,
  oidcToken?: string | null,
  id: string,
  type: DeviceFunctionalAspectType,
  name: string,
  enabled: boolean,
  directory: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_directory_GatewayDirectory,
  associatedGatewayDevices: Array<DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_associatedGatewayDevices_AssociatedGatewayDevice>,
  subscribedEvents: Array<DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_subscribedEvents_GatewayEvent>,
  directories: Array<DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_directories_GatewayDirectory>,
  devices: Array<DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_devices_GatewayProbeDevice>,
  events: Array<DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_events_GatewayProbeEvent>,
  template: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_template_FunctionalAspectTemplate,
  device?: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_device_Device | null,
  health: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_health_AspectHealth,
  inputAspects: Array<DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_inputAspects>
};

type AspectFields_Dfa_Media_Fragment = {
  __typename?: 'DFA_Media',
  streamSize?: MediaStreamSize | null,
  streamType: MediaStreamType,
  URL?: string | null,
  videoWidth?: number | null,
  videoHeight?: number | null,
  codec?: string | null,
  frameRate?: number | null,
  onvifProfile?: string | null,
  onvifProfiles?: any | null,
  recordingArchive: RecordingArchive,
  cloudArchive: MediaArchiveOption,
  consumedSpace?: number | null,
  spaceUsageHour?: number | null,
  spaceUsageDay?: number | null,
  FPS?: number | null,
  liveBitrate?: number | null,
  uptime?: number | null,
  averageFPS?: number | null,
  averageGOP?: number | null,
  averageInterArrivalJitter?: number | null,
  rtpPacketLost?: number | null,
  videoCodec?: string | null,
  videoSize?: string | null,
  audioCodec?: string | null,
  id: string,
  type: DeviceFunctionalAspectType,
  name: string,
  enabled: boolean,
  template: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_template_FunctionalAspectTemplate,
  device?: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_device_Device | null,
  health: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_health_AspectHealth,
  inputAspects: Array<DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_inputAspects>
};

type AspectFields_Dfa_Ptz_Fragment = {
  __typename?: 'DFA_PTZ',
  ptzType: PtzType,
  ptzPanInverted?: boolean | null,
  ptzTiltInverted?: boolean | null,
  ptzConfig?: string | null,
  id: string,
  type: DeviceFunctionalAspectType,
  name: string,
  enabled: boolean,
  ptzId?: string | null,
  ptzAttachedCamera1Address?: number | null,
  ptzAttachedCamera1BaudRate?: PtzAttachedBaudRate | null,
  ptzAttachedCamera1SerialMode?: PtzAttachedSerialMode | null,
  ptzAttachedCamera1Model?: PtzAttachedCameraModel | null,
  ptzAttachedCamera2Address?: number | null,
  ptzAttachedCamera2BaudRate?: PtzAttachedBaudRate | null,
  ptzAttachedCamera2SerialMode?: PtzAttachedSerialMode | null,
  ptzAttachedCamera2Model?: PtzAttachedCameraModel | null,
  cameraType: CameraType,
  template: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_template_FunctionalAspectTemplate,
  device?: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_device_Device | null,
  health: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_health_AspectHealth,
  inputAspects: Array<DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_inputAspects>,
  ptzTcpAddress?: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_ptzTcpAddress_PtzTcpAddress | null
};

type AspectFields_Dfa_Sensor_Fragment = {
  __typename?: 'DFA_Sensor',
  model?: string | null,
  serial?: string | null,
  userEvents?: Array<string> | null,
  associatedDevices?: Array<string> | null,
  category?: AspectSensorCategory | null,
  eltaNorthOffset?: number | null,
  eltaFrequencyControlCenter?: number | null,
  id: string,
  type: DeviceFunctionalAspectType,
  name: string,
  enabled: boolean,
  sensorEvents?: Array<DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_sensorEvents_SensorEvent> | null,
  qortexZones?: Array<DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_qortexZones_QortexZone> | null,
  qortexMappedZones?: Array<DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_qortexMappedZones_QortexMappedZone> | null,
  template: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_template_FunctionalAspectTemplate,
  device?: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_device_Device | null,
  health: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_health_AspectHealth,
  inputAspects: Array<DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_inputAspects>
};

type AspectFields_Dfa_Vae_Fragment = {
  __typename?: 'DFA_VAE',
  id: string,
  type: DeviceFunctionalAspectType,
  name: string,
  enabled: boolean,
  streamSize?: MediaStreamSize | null,
  eventType?: DeviceEventType | null,
  vaeFeatures?: Array<string> | null,
  template: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_template_FunctionalAspectTemplate,
  device?: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_device_Device | null,
  health: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_health_AspectHealth,
  inputAspects: Array<DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_inputAspects>,
  vaeConfig?: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_vaeConfig_VaeConfigFull | null,
  vaeFps?: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_vaeFps_VaeFps | null,
  vaeStatistic?: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_vaeStatistic_VaeStatistic | null
};

export type AspectFieldsFragment =
  | AspectFields_Dfa_Avatar_Fragment
  | AspectFields_Dfa_Gateway_Fragment
  | AspectFields_Dfa_Media_Fragment
  | AspectFields_Dfa_Ptz_Fragment
  | AspectFields_Dfa_Sensor_Fragment
  | AspectFields_Dfa_Vae_Fragment
;

export type VaeAspectFieldsFragment = {
  __typename?: 'DFA_VAE',
  streamSize?: MediaStreamSize | null,
  eventType?: DeviceEventType | null,
  vaeFeatures?: Array<string> | null,
  vaeConfig?: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_vaeConfig_VaeConfigFull | null,
  vaeFps?: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_vaeFps_VaeFps | null,
  vaeStatistic?: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_vaeStatistic_VaeStatistic | null
};

export type AspectHealthFieldsFragment = {
  __typename?: 'AspectHealth',
  gravity: Fa_HealthGravity,
  readinessTimeout: number,
  livenessTimeout: number,
  healthStatus: HealthStatus
};

export type AspectTemplateFieldsFragment = {
  __typename?: 'FunctionalAspectTemplate',
  id: string,
  type: DeviceFunctionalAspectType,
  name: string,
  order: number,
  engine?: string | null,
  features?: Array<DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_template_FunctionalAspectTemplate_features_VaeFeature> | null
};

export type DeviceProbeFieldsFragment_DeviceProbe_config_DeviceBaseConfig = {
  __typename?: 'DeviceBaseConfig',
  configType: DeviceBaseConfigType,
  make?: string | null,
  model?: string | null,
  firmware?: string | null,
  onvifServices?: string | null,
  stratusObjId?: string | null,
  connect: DeviceFieldsFragment_Device_config_DeviceBaseConfig_connect_NetworkConnectDescriptor
};

export type DeviceProbeFieldsFragment_DeviceProbe_aspects_DFA_Avatar = {
  __typename?: 'DFA_Avatar',
  isLink?: boolean | null,
  channelStatus?: ChannelStatus | null,
  dsConfiguredState?: DsConfiguredState | null,
  dsRunningState?: DsRunningState | null,
  lastStatusUpdate?: Date | null,
  vmxVideoStreamingMode?: VmxVideoStreamingMode | null,
  vaeImageUpdate?: boolean | null,
  webRtcEnabled?: boolean | null,
  uploadBandwidthCap?: number | null,
  platform?: string | null,
  upTime?: number | null,
  avatarLoad?: number | null,
  deliveryQueue?: number | null,
  deliveryQueueUploadTime?: number | null,
  turnaroundTime?: number | null,
  supportsReboot?: boolean | null,
  apiKey?: string | null,
  id: string,
  type: DeviceFunctionalAspectType,
  name: string,
  enabled: boolean,
  onvifServiceConf: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_onvifServiceConf_OnvifServiceConfig,
  storageUsage?: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_storageUsage_StorageUsage | null,
  software?: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_software_SoftwareInfo | null,
  channelBenchmark?: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_channelBenchmark_ChannelBenchmark | null,
  channelTurnaroundTime?: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_channelTurnaroundTime_StatTime | null,
  packetArrivalJitterTime?: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_packetArrivalJitterTime_StatTime | null,
  vaeUpdates?: Array<DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_vaeUpdates_VaeUpdate> | null,
  template: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_template_FunctionalAspectTemplate,
  device?: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_device_Device | null,
  health: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_health_AspectHealth,
  inputAspects: Array<DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_inputAspects>
};

export type DeviceProbeFieldsFragment_DeviceProbe_aspects_DFA_Gateway = {
  __typename?: 'DFA_Gateway',
  lenelVersion: string,
  oidcToken?: string | null,
  id: string,
  type: DeviceFunctionalAspectType,
  name: string,
  enabled: boolean,
  directory: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_directory_GatewayDirectory,
  associatedGatewayDevices: Array<DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_associatedGatewayDevices_AssociatedGatewayDevice>,
  subscribedEvents: Array<DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_subscribedEvents_GatewayEvent>,
  directories: Array<DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_directories_GatewayDirectory>,
  devices: Array<DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_devices_GatewayProbeDevice>,
  events: Array<DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_events_GatewayProbeEvent>,
  template: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_template_FunctionalAspectTemplate,
  device?: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_device_Device | null,
  health: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_health_AspectHealth,
  inputAspects: Array<DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_inputAspects>
};

export type DeviceProbeFieldsFragment_DeviceProbe_aspects_DFA_Media = {
  __typename?: 'DFA_Media',
  streamSize?: MediaStreamSize | null,
  streamType: MediaStreamType,
  URL?: string | null,
  videoWidth?: number | null,
  videoHeight?: number | null,
  codec?: string | null,
  frameRate?: number | null,
  onvifProfile?: string | null,
  onvifProfiles?: any | null,
  recordingArchive: RecordingArchive,
  cloudArchive: MediaArchiveOption,
  consumedSpace?: number | null,
  spaceUsageHour?: number | null,
  spaceUsageDay?: number | null,
  FPS?: number | null,
  liveBitrate?: number | null,
  uptime?: number | null,
  averageFPS?: number | null,
  averageGOP?: number | null,
  averageInterArrivalJitter?: number | null,
  rtpPacketLost?: number | null,
  videoCodec?: string | null,
  videoSize?: string | null,
  audioCodec?: string | null,
  id: string,
  type: DeviceFunctionalAspectType,
  name: string,
  enabled: boolean,
  template: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_template_FunctionalAspectTemplate,
  device?: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_device_Device | null,
  health: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_health_AspectHealth,
  inputAspects: Array<DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_inputAspects>
};

export type DeviceProbeFieldsFragment_DeviceProbe_aspects_DFA_PTZ = {
  __typename?: 'DFA_PTZ',
  ptzType: PtzType,
  ptzPanInverted?: boolean | null,
  ptzTiltInverted?: boolean | null,
  ptzConfig?: string | null,
  id: string,
  type: DeviceFunctionalAspectType,
  name: string,
  enabled: boolean,
  ptzId?: string | null,
  ptzAttachedCamera1Address?: number | null,
  ptzAttachedCamera1BaudRate?: PtzAttachedBaudRate | null,
  ptzAttachedCamera1SerialMode?: PtzAttachedSerialMode | null,
  ptzAttachedCamera1Model?: PtzAttachedCameraModel | null,
  ptzAttachedCamera2Address?: number | null,
  ptzAttachedCamera2BaudRate?: PtzAttachedBaudRate | null,
  ptzAttachedCamera2SerialMode?: PtzAttachedSerialMode | null,
  ptzAttachedCamera2Model?: PtzAttachedCameraModel | null,
  cameraType: CameraType,
  template: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_template_FunctionalAspectTemplate,
  device?: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_device_Device | null,
  health: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_health_AspectHealth,
  inputAspects: Array<DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_inputAspects>,
  ptzTcpAddress?: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_ptzTcpAddress_PtzTcpAddress | null
};

export type DeviceProbeFieldsFragment_DeviceProbe_aspects_DFA_Sensor = {
  __typename?: 'DFA_Sensor',
  model?: string | null,
  serial?: string | null,
  userEvents?: Array<string> | null,
  associatedDevices?: Array<string> | null,
  category?: AspectSensorCategory | null,
  eltaNorthOffset?: number | null,
  eltaFrequencyControlCenter?: number | null,
  id: string,
  type: DeviceFunctionalAspectType,
  name: string,
  enabled: boolean,
  sensorEvents?: Array<DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_sensorEvents_SensorEvent> | null,
  qortexZones?: Array<DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_qortexZones_QortexZone> | null,
  qortexMappedZones?: Array<DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_qortexMappedZones_QortexMappedZone> | null,
  template: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_template_FunctionalAspectTemplate,
  device?: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_device_Device | null,
  health: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_health_AspectHealth,
  inputAspects: Array<DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_inputAspects>
};

export type DeviceProbeFieldsFragment_DeviceProbe_aspects_DFA_VAE = {
  __typename?: 'DFA_VAE',
  id: string,
  type: DeviceFunctionalAspectType,
  name: string,
  enabled: boolean,
  streamSize?: MediaStreamSize | null,
  eventType?: DeviceEventType | null,
  vaeFeatures?: Array<string> | null,
  template: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_template_FunctionalAspectTemplate,
  device?: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_device_Device | null,
  health: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_health_AspectHealth,
  inputAspects: Array<DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_inputAspects>,
  vaeConfig?: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_vaeConfig_VaeConfigFull | null,
  vaeFps?: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_vaeFps_VaeFps | null,
  vaeStatistic?: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_vaeStatistic_VaeStatistic | null
};

export type DeviceProbeFieldsFragment_DeviceProbe_aspects =
  | DeviceProbeFieldsFragment_DeviceProbe_aspects_DFA_Avatar
  | DeviceProbeFieldsFragment_DeviceProbe_aspects_DFA_Gateway
  | DeviceProbeFieldsFragment_DeviceProbe_aspects_DFA_Media
  | DeviceProbeFieldsFragment_DeviceProbe_aspects_DFA_PTZ
  | DeviceProbeFieldsFragment_DeviceProbe_aspects_DFA_Sensor
  | DeviceProbeFieldsFragment_DeviceProbe_aspects_DFA_VAE
;

export type DeviceProbeFieldsFragment = {
  __typename?: 'DeviceProbe',
  name?: string | null,
  snapshots: Array<string>,
  rtpTime?: boolean | null,
  config: DeviceProbeFieldsFragment_DeviceProbe_config_DeviceBaseConfig,
  aspects: Array<DeviceProbeFieldsFragment_DeviceProbe_aspects>
};

export type LocalStorageFieldsFragment_LocalStorage_pool_PoolLocalStorage = {
  __typename?: 'PoolLocalStorage',
  path: string,
  size: string,
  enforce: string
};

export type LocalStorageFieldsFragment = {
  __typename?: 'LocalStorage',
  enabled: boolean,
  strategy: string,
  ver: string,
  pool: LocalStorageFieldsFragment_LocalStorage_pool_PoolLocalStorage
};

export type SharedStreamFieldsFragment = {
  __typename?: 'StreamShare',
  id: number,
  url: string,
  streamSize?: MediaStreamSize | null,
  enabled?: boolean | null,
  status?: HealthStatus | null,
  error?: string | null
};

export type DeviceCacheFieldsFragment = {
  __typename?: 'Device',
  id: string,
  healthStatus: HealthStatus,
  enabled: boolean
};

export type DeviceEnabledAspectsFragment_Device_aspects_DFA_Avatar = {
  __typename?: 'DFA_Avatar',
  enabled: boolean
};

export type DeviceEnabledAspectsFragment_Device_aspects_DFA_Gateway = {
  __typename?: 'DFA_Gateway',
  enabled: boolean
};

export type DeviceEnabledAspectsFragment_Device_aspects_DFA_Media = {
  __typename?: 'DFA_Media',
  enabled: boolean
};

export type DeviceEnabledAspectsFragment_Device_aspects_DFA_PTZ = {
  __typename?: 'DFA_PTZ',
  enabled: boolean
};

export type DeviceEnabledAspectsFragment_Device_aspects_DFA_Sensor = {
  __typename?: 'DFA_Sensor',
  enabled: boolean
};

export type DeviceEnabledAspectsFragment_Device_aspects_DFA_VAE = {
  __typename?: 'DFA_VAE',
  enabled: boolean
};

export type DeviceEnabledAspectsFragment_Device_aspects =
  | DeviceEnabledAspectsFragment_Device_aspects_DFA_Avatar
  | DeviceEnabledAspectsFragment_Device_aspects_DFA_Gateway
  | DeviceEnabledAspectsFragment_Device_aspects_DFA_Media
  | DeviceEnabledAspectsFragment_Device_aspects_DFA_PTZ
  | DeviceEnabledAspectsFragment_Device_aspects_DFA_Sensor
  | DeviceEnabledAspectsFragment_Device_aspects_DFA_VAE
;

export type DeviceEnabledAspectsFragment = {
  __typename?: 'Device',
  aspects: Array<DeviceEnabledAspectsFragment_Device_aspects>
};

export type DeviceVaeManagementFieldsFragment_Device_platform_Device = {
  __typename?: 'Device',
  id: string,
  name: string
};

export type DeviceVaeManagementFieldsFragment_Device_config_DeviceBaseConfig = {
  __typename?: 'DeviceBaseConfig',
  configType: DeviceBaseConfigType,
  make?: string | null,
  model?: string | null,
  firmware?: string | null,
  onvifServices?: string | null,
  stratusObjId?: string | null,
  connect: DeviceFieldsFragment_Device_config_DeviceBaseConfig_connect_NetworkConnectDescriptor
};

export type DeviceVaeManagementFieldsFragment_Device_aspects_DFA_Avatar = {
  __typename?: 'DFA_Avatar',
  isLink?: boolean | null,
  channelStatus?: ChannelStatus | null,
  dsConfiguredState?: DsConfiguredState | null,
  dsRunningState?: DsRunningState | null,
  lastStatusUpdate?: Date | null,
  vmxVideoStreamingMode?: VmxVideoStreamingMode | null,
  vaeImageUpdate?: boolean | null,
  webRtcEnabled?: boolean | null,
  uploadBandwidthCap?: number | null,
  platform?: string | null,
  upTime?: number | null,
  avatarLoad?: number | null,
  deliveryQueue?: number | null,
  deliveryQueueUploadTime?: number | null,
  turnaroundTime?: number | null,
  supportsReboot?: boolean | null,
  apiKey?: string | null,
  id: string,
  type: DeviceFunctionalAspectType,
  name: string,
  enabled: boolean,
  onvifServiceConf: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_onvifServiceConf_OnvifServiceConfig,
  storageUsage?: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_storageUsage_StorageUsage | null,
  software?: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_software_SoftwareInfo | null,
  channelBenchmark?: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_channelBenchmark_ChannelBenchmark | null,
  channelTurnaroundTime?: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_channelTurnaroundTime_StatTime | null,
  packetArrivalJitterTime?: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_packetArrivalJitterTime_StatTime | null,
  vaeUpdates?: Array<DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_vaeUpdates_VaeUpdate> | null,
  template: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_template_FunctionalAspectTemplate,
  device?: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_device_Device | null,
  health: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_health_AspectHealth,
  inputAspects: Array<DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_inputAspects>
};

export type DeviceVaeManagementFieldsFragment_Device_aspects_DFA_Gateway = {
  __typename?: 'DFA_Gateway',
  lenelVersion: string,
  oidcToken?: string | null,
  id: string,
  type: DeviceFunctionalAspectType,
  name: string,
  enabled: boolean,
  directory: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_directory_GatewayDirectory,
  associatedGatewayDevices: Array<DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_associatedGatewayDevices_AssociatedGatewayDevice>,
  subscribedEvents: Array<DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_subscribedEvents_GatewayEvent>,
  directories: Array<DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_directories_GatewayDirectory>,
  devices: Array<DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_devices_GatewayProbeDevice>,
  events: Array<DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_events_GatewayProbeEvent>,
  template: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_template_FunctionalAspectTemplate,
  device?: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_device_Device | null,
  health: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_health_AspectHealth,
  inputAspects: Array<DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_inputAspects>
};

export type DeviceVaeManagementFieldsFragment_Device_aspects_DFA_Media = {
  __typename?: 'DFA_Media',
  streamSize?: MediaStreamSize | null,
  streamType: MediaStreamType,
  URL?: string | null,
  videoWidth?: number | null,
  videoHeight?: number | null,
  codec?: string | null,
  frameRate?: number | null,
  onvifProfile?: string | null,
  onvifProfiles?: any | null,
  recordingArchive: RecordingArchive,
  cloudArchive: MediaArchiveOption,
  consumedSpace?: number | null,
  spaceUsageHour?: number | null,
  spaceUsageDay?: number | null,
  FPS?: number | null,
  liveBitrate?: number | null,
  uptime?: number | null,
  averageFPS?: number | null,
  averageGOP?: number | null,
  averageInterArrivalJitter?: number | null,
  rtpPacketLost?: number | null,
  videoCodec?: string | null,
  videoSize?: string | null,
  audioCodec?: string | null,
  id: string,
  type: DeviceFunctionalAspectType,
  name: string,
  enabled: boolean,
  template: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_template_FunctionalAspectTemplate,
  device?: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_device_Device | null,
  health: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_health_AspectHealth,
  inputAspects: Array<DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_inputAspects>
};

export type DeviceVaeManagementFieldsFragment_Device_aspects_DFA_PTZ = {
  __typename?: 'DFA_PTZ',
  ptzType: PtzType,
  ptzPanInverted?: boolean | null,
  ptzTiltInverted?: boolean | null,
  ptzConfig?: string | null,
  id: string,
  type: DeviceFunctionalAspectType,
  name: string,
  enabled: boolean,
  ptzId?: string | null,
  ptzAttachedCamera1Address?: number | null,
  ptzAttachedCamera1BaudRate?: PtzAttachedBaudRate | null,
  ptzAttachedCamera1SerialMode?: PtzAttachedSerialMode | null,
  ptzAttachedCamera1Model?: PtzAttachedCameraModel | null,
  ptzAttachedCamera2Address?: number | null,
  ptzAttachedCamera2BaudRate?: PtzAttachedBaudRate | null,
  ptzAttachedCamera2SerialMode?: PtzAttachedSerialMode | null,
  ptzAttachedCamera2Model?: PtzAttachedCameraModel | null,
  cameraType: CameraType,
  template: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_template_FunctionalAspectTemplate,
  device?: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_device_Device | null,
  health: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_health_AspectHealth,
  inputAspects: Array<DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_inputAspects>,
  ptzTcpAddress?: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_ptzTcpAddress_PtzTcpAddress | null
};

export type DeviceVaeManagementFieldsFragment_Device_aspects_DFA_Sensor = {
  __typename?: 'DFA_Sensor',
  model?: string | null,
  serial?: string | null,
  userEvents?: Array<string> | null,
  associatedDevices?: Array<string> | null,
  category?: AspectSensorCategory | null,
  eltaNorthOffset?: number | null,
  eltaFrequencyControlCenter?: number | null,
  id: string,
  type: DeviceFunctionalAspectType,
  name: string,
  enabled: boolean,
  sensorEvents?: Array<DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_sensorEvents_SensorEvent> | null,
  qortexZones?: Array<DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_qortexZones_QortexZone> | null,
  qortexMappedZones?: Array<DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_qortexMappedZones_QortexMappedZone> | null,
  template: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_template_FunctionalAspectTemplate,
  device?: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_device_Device | null,
  health: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_health_AspectHealth,
  inputAspects: Array<DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_inputAspects>
};

export type DeviceVaeManagementFieldsFragment_Device_aspects_DFA_VAE = {
  __typename?: 'DFA_VAE',
  id: string,
  type: DeviceFunctionalAspectType,
  name: string,
  enabled: boolean,
  streamSize?: MediaStreamSize | null,
  eventType?: DeviceEventType | null,
  vaeFeatures?: Array<string> | null,
  template: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_template_FunctionalAspectTemplate,
  device?: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_device_Device | null,
  health: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_health_AspectHealth,
  inputAspects: Array<DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_inputAspects>,
  vaeConfig?: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_vaeConfig_VaeConfigFull | null,
  vaeFps?: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_vaeFps_VaeFps | null,
  vaeStatistic?: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_vaeStatistic_VaeStatistic | null
};

export type DeviceVaeManagementFieldsFragment_Device_aspects =
  | DeviceVaeManagementFieldsFragment_Device_aspects_DFA_Avatar
  | DeviceVaeManagementFieldsFragment_Device_aspects_DFA_Gateway
  | DeviceVaeManagementFieldsFragment_Device_aspects_DFA_Media
  | DeviceVaeManagementFieldsFragment_Device_aspects_DFA_PTZ
  | DeviceVaeManagementFieldsFragment_Device_aspects_DFA_Sensor
  | DeviceVaeManagementFieldsFragment_Device_aspects_DFA_VAE
;

export type DeviceVaeManagementFieldsFragment = {
  __typename?: 'Device',
  name: string,
  enabled: boolean,
  healthStatus: HealthStatus,
  id: string,
  acknowledgeRequired?: boolean | null,
  platform?: DeviceVaeManagementFieldsFragment_Device_platform_Device | null,
  config: DeviceVaeManagementFieldsFragment_Device_config_DeviceBaseConfig,
  aspects: Array<DeviceVaeManagementFieldsFragment_Device_aspects>
};

export type DeviceVaeManagementQuery_device_Device = {
  __typename?: 'Device',
  name: string,
  enabled: boolean,
  healthStatus: HealthStatus,
  id: string,
  acknowledgeRequired?: boolean | null,
  platform?: DeviceVaeManagementFieldsFragment_Device_platform_Device | null,
  config: DeviceVaeManagementFieldsFragment_Device_config_DeviceBaseConfig,
  aspects: Array<DeviceVaeManagementFieldsFragment_Device_aspects>
};

export type DeviceVaeManagementQuery_Query = {
  __typename?: 'Query',
  device?: DeviceVaeManagementQuery_device_Device | null
};


export type DeviceVaeManagementQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeviceVaeManagementQuery = DeviceVaeManagementQuery_Query;

export type DeviceCacheByAspectTypesQuery_devicesByAspectTypes_Device = {
  __typename?: 'Device',
  id: string,
  healthStatus: HealthStatus,
  enabled: boolean
};

export type DeviceCacheByAspectTypesQuery_Query = {
  __typename?: 'Query',
  devicesByAspectTypes: Array<DeviceCacheByAspectTypesQuery_devicesByAspectTypes_Device>
};


export type DeviceCacheByAspectTypesQueryVariables = Exact<{
  types: Array<DeviceFunctionalAspectFilter>;
}>;


export type DeviceCacheByAspectTypesQuery = DeviceCacheByAspectTypesQuery_Query;

export type AdminCameraListByAspectTypesQuery_devicesByAspectTypes_Device = {
  __typename?: 'Device',
  id: string,
  name: string,
  location?: string | null,
  enabled: boolean,
  healthStatus: HealthStatus,
  deviceType?: BaseDeviceType | null,
  config: AdminCameraFieldsFragment_Device_config_DeviceBaseConfig,
  zone?: AdminCameraFieldsFragment_Device_zone_ObjectDescriptor | null,
  platform?: AdminCameraFieldsFragment_Device_platform_Device | null,
  aspects: Array<AdminCameraFieldsFragment_Device_aspects>
};

export type AdminCameraListByAspectTypesQuery_Query = {
  __typename?: 'Query',
  devicesByAspectTypes: Array<AdminCameraListByAspectTypesQuery_devicesByAspectTypes_Device>
};


export type AdminCameraListByAspectTypesQueryVariables = Exact<{
  types: Array<DeviceFunctionalAspectFilter>;
}>;


export type AdminCameraListByAspectTypesQuery = AdminCameraListByAspectTypesQuery_Query;

export type GetDeviceSharedStreamQuery_device_Device_sharedStream_StreamShare = {
  __typename?: 'StreamShare',
  id: number,
  url: string,
  streamSize?: MediaStreamSize | null,
  enabled?: boolean | null,
  status?: HealthStatus | null,
  error?: string | null
};

export type GetDeviceSharedStreamQuery_device_Device = {
  __typename?: 'Device',
  sharedStream?: Array<GetDeviceSharedStreamQuery_device_Device_sharedStream_StreamShare> | null
};

export type GetDeviceSharedStreamQuery_Query = {
  __typename?: 'Query',
  device?: GetDeviceSharedStreamQuery_device_Device | null
};


export type GetDeviceSharedStreamQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetDeviceSharedStreamQuery = GetDeviceSharedStreamQuery_Query;

export type GetLocalStorageConfigQuery_localStorage_LocalStorage = {
  __typename?: 'LocalStorage',
  enabled: boolean,
  strategy: string,
  ver: string,
  pool: LocalStorageFieldsFragment_LocalStorage_pool_PoolLocalStorage
};

export type GetLocalStorageConfigQuery_Query = {
  __typename?: 'Query',
  localStorage?: GetLocalStorageConfigQuery_localStorage_LocalStorage | null
};


export type GetLocalStorageConfigQueryVariables = Exact<{
  deviceId: Scalars['ID']['input'];
}>;


export type GetLocalStorageConfigQuery = GetLocalStorageConfigQuery_Query;

export type DeviceStatusQuery_device_Device = {
  __typename?: 'Device',
  id: string,
  name: string,
  enabled: boolean,
  healthStatus: HealthStatus,
  deviceType?: BaseDeviceType | null
};

export type DeviceStatusQuery_Query = {
  __typename?: 'Query',
  device?: DeviceStatusQuery_device_Device | null
};


export type DeviceStatusQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeviceStatusQuery = DeviceStatusQuery_Query;

export type DeviceListByAspectTypesQuery_devicesByAspectTypes_Device = {
  __typename?: 'Device',
  id: string,
  name: string,
  enabled: boolean,
  healthStatus: HealthStatus,
  deviceType?: BaseDeviceType | null
};

export type DeviceListByAspectTypesQuery_Query = {
  __typename?: 'Query',
  devicesByAspectTypes: Array<DeviceListByAspectTypesQuery_devicesByAspectTypes_Device>
};


export type DeviceListByAspectTypesQueryVariables = Exact<{
  types: Array<DeviceFunctionalAspectFilter>;
}>;


export type DeviceListByAspectTypesQuery = DeviceListByAspectTypesQuery_Query;

export type DevicesByAspectTypesQuery_devicesByAspectTypes_Device = {
  __typename?: 'Device',
  id: string,
  name: string,
  createdAt?: Date | null,
  modifiedAt?: Date | null,
  enabled: boolean,
  cloudDirect: boolean,
  healthStatus: HealthStatus,
  version: string,
  location?: string | null,
  deliveryPriority?: number | null,
  eventType?: DeviceEventType | null,
  rtpOverTcp?: boolean | null,
  rtpTime?: boolean | null,
  deviceType?: BaseDeviceType | null,
  acknowledgeRequired?: boolean | null,
  geoZone?: any | null,
  eventTimeFromRealm?: boolean | null,
  preEventTime?: number | null,
  postEventTime?: number | null,
  position?: DeviceFieldsFragment_Device_position_LatLng | null,
  alarmPointPosition?: DeviceFieldsFragment_Device_alarmPointPosition_LatLng | null,
  config: DeviceFieldsFragment_Device_config_DeviceBaseConfig,
  platform?: DeviceFieldsFragment_Device_platform_Device | null,
  sharedStream?: Array<DeviceFieldsFragment_Device_sharedStream_StreamShare> | null,
  zone?: DeviceFieldsFragment_Device_zone_ObjectDescriptor | null,
  set?: Array<DeviceFieldsFragment_Device_set_ObjectDescriptor> | null,
  storageConfig?: DeviceFieldsFragment_Device_storageConfig_DeviceStorageConfig | null,
  aspects: Array<DeviceFieldsFragment_Device_aspects>,
  cameraView?: DeviceFieldsFragment_Device_cameraView_CameraView | null
};

export type DevicesByAspectTypesQuery_Query = {
  __typename?: 'Query',
  devicesByAspectTypes: Array<DevicesByAspectTypesQuery_devicesByAspectTypes_Device>
};


export type DevicesByAspectTypesQueryVariables = Exact<{
  types: Array<DeviceFunctionalAspectFilter>;
}>;


export type DevicesByAspectTypesQuery = DevicesByAspectTypesQuery_Query;

export type DevicesByAspectTypesGeoQuery_devicesByAspectTypes_Device = {
  __typename?: 'Device',
  id: string,
  name: string,
  enabled: boolean,
  healthStatus: HealthStatus,
  geoZone?: any | null,
  position?: DeviceGeoFieldsFragment_Device_position_LatLng | null,
  alarmPointPosition?: DeviceGeoFieldsFragment_Device_alarmPointPosition_LatLng | null,
  cameraView?: DeviceGeoFieldsFragment_Device_cameraView_CameraView | null,
  aspects: Array<DeviceGeoFieldsFragment_Device_aspects>
};

export type DevicesByAspectTypesGeoQuery_Query = {
  __typename?: 'Query',
  devicesByAspectTypes: Array<DevicesByAspectTypesGeoQuery_devicesByAspectTypes_Device>
};


export type DevicesByAspectTypesGeoQueryVariables = Exact<{
  types: Array<DeviceFunctionalAspectFilter>;
}>;


export type DevicesByAspectTypesGeoQuery = DevicesByAspectTypesGeoQuery_Query;

export type DevicesByAspectTypesReportQuery_devicesByAspectTypes_Device = {
  __typename?: 'Device',
  id: string,
  name: string,
  healthStatus: HealthStatus,
  config: DeviceReportFieldsFragment_Device_config_DeviceBaseConfig,
  aspects: Array<DeviceReportFieldsFragment_Device_aspects>,
  platform?: DeviceReportFieldsFragment_Device_platform_Device | null
};

export type DevicesByAspectTypesReportQuery_Query = {
  __typename?: 'Query',
  devicesByAspectTypes: Array<DevicesByAspectTypesReportQuery_devicesByAspectTypes_Device>
};


export type DevicesByAspectTypesReportQueryVariables = Exact<{
  types: Array<DeviceFunctionalAspectFilter>;
}>;


export type DevicesByAspectTypesReportQuery = DevicesByAspectTypesReportQuery_Query;

export type CameraViewDevicesQuery_devicesByAspectTypes_Device_cameraView_CameraView_ptzStatus_PtzStatus_lock_PtzLock = {
  __typename?: 'PtzLock',
  userId?: string | null,
  category: PtzLockCategory,
  expire: Date,
  explicit?: boolean | null,
  userName?: string | null
};

export type CameraViewDevicesQuery_devicesByAspectTypes_Device_cameraView_CameraView_ptzStatus_PtzStatus_position_PtzPosition = {
  __typename?: 'PtzPosition',
  hfov: number,
  pan: number,
  tilt: number
};

export type CameraViewDevicesQuery_devicesByAspectTypes_Device_cameraView_CameraView_ptzStatus_PtzStatus = {
  __typename?: 'PtzStatus',
  lock?: CameraViewDevicesQuery_devicesByAspectTypes_Device_cameraView_CameraView_ptzStatus_PtzStatus_lock_PtzLock | null,
  position?: CameraViewDevicesQuery_devicesByAspectTypes_Device_cameraView_CameraView_ptzStatus_PtzStatus_position_PtzPosition | null
};

export type CameraViewDevicesQuery_devicesByAspectTypes_Device_cameraView_CameraView_ptzLockProlongation_PtzLockProlongation = {
  __typename?: 'PtzLockProlongation',
  userId: string,
  token: string,
  createdAt: Date
};

export type CameraViewDevicesQuery_devicesByAspectTypes_Device_cameraView_CameraView = {
  __typename?: 'CameraView',
  northOffsetAngle?: number | null,
  fieldOfView?: number | null,
  viewDistance?: number | null,
  ptzStatus?: CameraViewDevicesQuery_devicesByAspectTypes_Device_cameraView_CameraView_ptzStatus_PtzStatus | null,
  ptzLockProlongation?: CameraViewDevicesQuery_devicesByAspectTypes_Device_cameraView_CameraView_ptzLockProlongation_PtzLockProlongation | null
};

export type CameraViewDevicesQuery_devicesByAspectTypes_Device = {
  __typename?: 'Device',
  id: string,
  cameraView?: CameraViewDevicesQuery_devicesByAspectTypes_Device_cameraView_CameraView | null
};

export type CameraViewDevicesQuery_Query = {
  __typename?: 'Query',
  devicesByAspectTypes: Array<CameraViewDevicesQuery_devicesByAspectTypes_Device>
};


export type CameraViewDevicesQueryVariables = Exact<{
  types: Array<DeviceFunctionalAspectFilter>;
}>;


export type CameraViewDevicesQuery = CameraViewDevicesQuery_Query;

export type GeoDevicesQuery_devicesByAspectTypes_Device_position_LatLng = {
  __typename?: 'LatLng',
  lat: number,
  lng: number,
  alt?: number | null
};

export type GeoDevicesQuery_devicesByAspectTypes_Device_alarmPointPosition_LatLng = {
  __typename?: 'LatLng',
  lat: number,
  lng: number,
  alt?: number | null
};

export type GeoDevicesQuery_devicesByAspectTypes_Device_cameraView_CameraView_ptzStatus_PtzStatus = {
  __typename?: 'PtzStatus',
  position?: DeviceFieldsFragment_Device_cameraView_CameraView_ptzStatus_PtzStatus_position_PtzPosition | null,
  lock?: DeviceFieldsFragment_Device_cameraView_CameraView_ptzStatus_PtzStatus_lock_PtzLock | null
};

export type GeoDevicesQuery_devicesByAspectTypes_Device_cameraView_CameraView_ptzLockProlongation_PtzLockProlongation = {
  __typename?: 'PtzLockProlongation',
  userId: string,
  token: string,
  createdAt: Date
};

export type GeoDevicesQuery_devicesByAspectTypes_Device_cameraView_CameraView = {
  __typename?: 'CameraView',
  northOffsetAngle?: number | null,
  fieldOfView?: number | null,
  viewDistance?: number | null,
  ptzStatus?: GeoDevicesQuery_devicesByAspectTypes_Device_cameraView_CameraView_ptzStatus_PtzStatus | null,
  ptzLockProlongation?: GeoDevicesQuery_devicesByAspectTypes_Device_cameraView_CameraView_ptzLockProlongation_PtzLockProlongation | null
};

export type GeoDevicesQuery_devicesByAspectTypes_Device_aspects_DFA_Avatar = {
  __typename?: 'DFA_Avatar',
  enabled: boolean
};

export type GeoDevicesQuery_devicesByAspectTypes_Device_aspects_DFA_Gateway = {
  __typename?: 'DFA_Gateway',
  enabled: boolean
};

export type GeoDevicesQuery_devicesByAspectTypes_Device_aspects_DFA_Media = {
  __typename?: 'DFA_Media',
  enabled: boolean
};

export type GeoDevicesQuery_devicesByAspectTypes_Device_aspects_DFA_PTZ = {
  __typename?: 'DFA_PTZ',
  enabled: boolean
};

export type GeoDevicesQuery_devicesByAspectTypes_Device_aspects_DFA_Sensor = {
  __typename?: 'DFA_Sensor',
  category?: AspectSensorCategory | null,
  associatedDevices?: Array<string> | null,
  enabled: boolean
};

export type GeoDevicesQuery_devicesByAspectTypes_Device_aspects_DFA_VAE = {
  __typename?: 'DFA_VAE',
  enabled: boolean
};

export type GeoDevicesQuery_devicesByAspectTypes_Device_aspects =
  | GeoDevicesQuery_devicesByAspectTypes_Device_aspects_DFA_Avatar
  | GeoDevicesQuery_devicesByAspectTypes_Device_aspects_DFA_Gateway
  | GeoDevicesQuery_devicesByAspectTypes_Device_aspects_DFA_Media
  | GeoDevicesQuery_devicesByAspectTypes_Device_aspects_DFA_PTZ
  | GeoDevicesQuery_devicesByAspectTypes_Device_aspects_DFA_Sensor
  | GeoDevicesQuery_devicesByAspectTypes_Device_aspects_DFA_VAE
;

export type GeoDevicesQuery_devicesByAspectTypes_Device = {
  __typename?: 'Device',
  id: string,
  name: string,
  deviceType?: BaseDeviceType | null,
  enabled: boolean,
  healthStatus: HealthStatus,
  geoZone?: any | null,
  position?: GeoDevicesQuery_devicesByAspectTypes_Device_position_LatLng | null,
  alarmPointPosition?: GeoDevicesQuery_devicesByAspectTypes_Device_alarmPointPosition_LatLng | null,
  cameraView?: GeoDevicesQuery_devicesByAspectTypes_Device_cameraView_CameraView | null,
  aspects: Array<GeoDevicesQuery_devicesByAspectTypes_Device_aspects>
};

export type GeoDevicesQuery_Query = {
  __typename?: 'Query',
  devicesByAspectTypes: Array<GeoDevicesQuery_devicesByAspectTypes_Device>
};


export type GeoDevicesQueryVariables = Exact<{
  types: Array<DeviceFunctionalAspectFilter>;
}>;


export type GeoDevicesQuery = GeoDevicesQuery_Query;

export type DeviceVaeQuery_device_Device_aspects_DFA_Avatar_template_FunctionalAspectTemplate = {
  __typename?: 'FunctionalAspectTemplate',
  name: string
};

export type DeviceVaeQuery_device_Device_aspects_DFA_Avatar = {
  __typename?: 'DFA_Avatar',
  type: DeviceFunctionalAspectType,
  enabled: boolean,
  template: DeviceVaeQuery_device_Device_aspects_DFA_Avatar_template_FunctionalAspectTemplate
};

export type DeviceVaeQuery_device_Device_aspects_DFA_Gateway = {
  __typename?: 'DFA_Gateway',
  type: DeviceFunctionalAspectType,
  enabled: boolean,
  template: DeviceVaeQuery_device_Device_aspects_DFA_Avatar_template_FunctionalAspectTemplate
};

export type DeviceVaeQuery_device_Device_aspects_DFA_Media = {
  __typename?: 'DFA_Media',
  type: DeviceFunctionalAspectType,
  enabled: boolean,
  template: DeviceVaeQuery_device_Device_aspects_DFA_Avatar_template_FunctionalAspectTemplate
};

export type DeviceVaeQuery_device_Device_aspects_DFA_PTZ = {
  __typename?: 'DFA_PTZ',
  type: DeviceFunctionalAspectType,
  enabled: boolean,
  template: DeviceVaeQuery_device_Device_aspects_DFA_Avatar_template_FunctionalAspectTemplate
};

export type DeviceVaeQuery_device_Device_aspects_DFA_Sensor = {
  __typename?: 'DFA_Sensor',
  type: DeviceFunctionalAspectType,
  enabled: boolean,
  template: DeviceVaeQuery_device_Device_aspects_DFA_Avatar_template_FunctionalAspectTemplate
};

export type DeviceVaeQuery_device_Device_aspects_DFA_VAE = {
  __typename?: 'DFA_VAE',
  type: DeviceFunctionalAspectType,
  enabled: boolean,
  streamSize?: MediaStreamSize | null,
  eventType?: DeviceEventType | null,
  vaeFeatures?: Array<string> | null,
  template: DeviceVaeQuery_device_Device_aspects_DFA_Avatar_template_FunctionalAspectTemplate,
  vaeConfig?: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_vaeConfig_VaeConfigFull | null,
  vaeFps?: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_vaeFps_VaeFps | null,
  vaeStatistic?: DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_vaeStatistic_VaeStatistic | null
};

export type DeviceVaeQuery_device_Device_aspects =
  | DeviceVaeQuery_device_Device_aspects_DFA_Avatar
  | DeviceVaeQuery_device_Device_aspects_DFA_Gateway
  | DeviceVaeQuery_device_Device_aspects_DFA_Media
  | DeviceVaeQuery_device_Device_aspects_DFA_PTZ
  | DeviceVaeQuery_device_Device_aspects_DFA_Sensor
  | DeviceVaeQuery_device_Device_aspects_DFA_VAE
;

export type DeviceVaeQuery_device_Device = {
  __typename?: 'Device',
  id: string,
  name: string,
  aspects: Array<DeviceVaeQuery_device_Device_aspects>
};

export type DeviceVaeQuery_Query = {
  __typename?: 'Query',
  device?: DeviceVaeQuery_device_Device | null
};


export type DeviceVaeQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeviceVaeQuery = DeviceVaeQuery_Query;

export type SensorListByAspectTypeQuery_devicesByAspectTypes_Device = {
  __typename?: 'Device',
  id: string,
  name: string,
  enabled: boolean,
  location?: string | null,
  healthStatus: HealthStatus,
  zone?: SensorListFieldsFragment_Device_zone_ObjectDescriptor | null,
  platform?: SensorListFieldsFragment_Device_platform_Device | null,
  config: SensorListFieldsFragment_Device_config_DeviceBaseConfig
};

export type SensorListByAspectTypeQuery_Query = {
  __typename?: 'Query',
  devicesByAspectTypes: Array<SensorListByAspectTypeQuery_devicesByAspectTypes_Device>
};


export type SensorListByAspectTypeQueryVariables = Exact<{
  types: Array<DeviceFunctionalAspectFilter>;
}>;


export type SensorListByAspectTypeQuery = SensorListByAspectTypeQuery_Query;

export type GatewayListByAspectTypeQuery_devicesByAspectTypes_Device = {
  __typename?: 'Device',
  id: string,
  name: string,
  enabled: boolean,
  healthStatus: HealthStatus,
  platform?: GatewayListFieldsFragment_Device_platform_Device | null,
  aspects: Array<GatewayListFieldsFragment_Device_aspects>,
  config: GatewayListFieldsFragment_Device_config_DeviceBaseConfig
};

export type GatewayListByAspectTypeQuery_Query = {
  __typename?: 'Query',
  devicesByAspectTypes: Array<GatewayListByAspectTypeQuery_devicesByAspectTypes_Device>
};


export type GatewayListByAspectTypeQueryVariables = Exact<{
  types: Array<DeviceFunctionalAspectFilter>;
}>;


export type GatewayListByAspectTypeQuery = GatewayListByAspectTypeQuery_Query;

export type DeviceWitnessesByAspectTypeQuery_devicesByAspectTypes_Device = {
  __typename?: 'Device',
  id: string,
  name: string,
  enabled: boolean,
  healthStatus: HealthStatus,
  deviceType?: BaseDeviceType | null,
  platform?: DeviceWitnessFieldsFragment_Device_platform_Device | null,
  position?: DeviceWitnessFieldsFragment_Device_position_LatLng | null,
  aspects: Array<DeviceWitnessFieldsFragment_Device_aspects>
};

export type DeviceWitnessesByAspectTypeQuery_Query = {
  __typename?: 'Query',
  devicesByAspectTypes: Array<DeviceWitnessesByAspectTypeQuery_devicesByAspectTypes_Device>
};


export type DeviceWitnessesByAspectTypeQueryVariables = Exact<{
  types: Array<DeviceFunctionalAspectFilter>;
}>;


export type DeviceWitnessesByAspectTypeQuery = DeviceWitnessesByAspectTypeQuery_Query;

export type DevicesByAspectTypesShortQuery_devicesByAspectTypes_Device = {
  __typename?: 'Device',
  id: string,
  name: string,
  location?: string | null,
  enabled: boolean,
  healthStatus: HealthStatus,
  deliveryPriority?: number | null,
  deviceType?: BaseDeviceType | null,
  config: DeviceShortFieldsFragment_Device_config_DeviceBaseConfig,
  aspects: Array<DeviceShortFieldsFragment_Device_aspects>,
  position?: DeviceShortFieldsFragment_Device_position_LatLng | null,
  platform?: DeviceShortFieldsFragment_Device_platform_Device | null,
  zone?: DeviceShortFieldsFragment_Device_zone_ObjectDescriptor | null
};

export type DevicesByAspectTypesShortQuery_Query = {
  __typename?: 'Query',
  devicesByAspectTypes: Array<DevicesByAspectTypesShortQuery_devicesByAspectTypes_Device>
};


export type DevicesByAspectTypesShortQueryVariables = Exact<{
  types: Array<DeviceFunctionalAspectFilter>;
}>;


export type DevicesByAspectTypesShortQuery = DevicesByAspectTypesShortQuery_Query;

export type DevicesByAspectTypesCameraViewQuery_devicesByAspectTypes_Device_cameraView_CameraView_ptzStatus_PtzStatus = {
  __typename?: 'PtzStatus',
  position?: DeviceFieldsFragment_Device_cameraView_CameraView_ptzStatus_PtzStatus_position_PtzPosition | null,
  lock?: DeviceFieldsFragment_Device_cameraView_CameraView_ptzStatus_PtzStatus_lock_PtzLock | null
};

export type DevicesByAspectTypesCameraViewQuery_devicesByAspectTypes_Device_cameraView_CameraView_ptzLockProlongation_PtzLockProlongation = {
  __typename?: 'PtzLockProlongation',
  createdAt: Date,
  token: string,
  userId: string
};

export type DevicesByAspectTypesCameraViewQuery_devicesByAspectTypes_Device_cameraView_CameraView = {
  __typename?: 'CameraView',
  fieldOfView?: number | null,
  northOffsetAngle?: number | null,
  viewDistance?: number | null,
  ptzStatus?: DevicesByAspectTypesCameraViewQuery_devicesByAspectTypes_Device_cameraView_CameraView_ptzStatus_PtzStatus | null,
  ptzLockProlongation?: DevicesByAspectTypesCameraViewQuery_devicesByAspectTypes_Device_cameraView_CameraView_ptzLockProlongation_PtzLockProlongation | null
};

export type DevicesByAspectTypesCameraViewQuery_devicesByAspectTypes_Device = {
  __typename?: 'Device',
  id: string,
  name: string,
  cameraView?: DevicesByAspectTypesCameraViewQuery_devicesByAspectTypes_Device_cameraView_CameraView | null
};

export type DevicesByAspectTypesCameraViewQuery_Query = {
  __typename?: 'Query',
  devicesByAspectTypes: Array<DevicesByAspectTypesCameraViewQuery_devicesByAspectTypes_Device>
};


export type DevicesByAspectTypesCameraViewQueryVariables = Exact<{
  types: Array<DeviceFunctionalAspectFilter>;
}>;


export type DevicesByAspectTypesCameraViewQuery = DevicesByAspectTypesCameraViewQuery_Query;

export type DeviceQuery_device_Device = {
  __typename?: 'Device',
  id: string,
  name: string,
  createdAt?: Date | null,
  modifiedAt?: Date | null,
  enabled: boolean,
  cloudDirect: boolean,
  healthStatus: HealthStatus,
  version: string,
  location?: string | null,
  deliveryPriority?: number | null,
  eventType?: DeviceEventType | null,
  rtpOverTcp?: boolean | null,
  rtpTime?: boolean | null,
  deviceType?: BaseDeviceType | null,
  acknowledgeRequired?: boolean | null,
  geoZone?: any | null,
  eventTimeFromRealm?: boolean | null,
  preEventTime?: number | null,
  postEventTime?: number | null,
  position?: DeviceFieldsFragment_Device_position_LatLng | null,
  alarmPointPosition?: DeviceFieldsFragment_Device_alarmPointPosition_LatLng | null,
  config: DeviceFieldsFragment_Device_config_DeviceBaseConfig,
  platform?: DeviceFieldsFragment_Device_platform_Device | null,
  sharedStream?: Array<DeviceFieldsFragment_Device_sharedStream_StreamShare> | null,
  zone?: DeviceFieldsFragment_Device_zone_ObjectDescriptor | null,
  set?: Array<DeviceFieldsFragment_Device_set_ObjectDescriptor> | null,
  storageConfig?: DeviceFieldsFragment_Device_storageConfig_DeviceStorageConfig | null,
  aspects: Array<DeviceFieldsFragment_Device_aspects>,
  cameraView?: DeviceFieldsFragment_Device_cameraView_CameraView | null
};

export type DeviceQuery_Query = {
  __typename?: 'Query',
  device?: DeviceQuery_device_Device | null
};


export type DeviceQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeviceQuery = DeviceQuery_Query;

export type DeviceForPlayerQuery_device_Device = {
  __typename?: 'Device',
  id: string,
  name: string,
  cloudDirect: boolean,
  preEventTime?: number | null,
  postEventTime?: number | null,
  aspects: Array<DevicePlayerFieldsFragment_Device_aspects>,
  platform?: DevicePlayerFieldsFragment_Device_platform_Device | null,
  cameraView?: DevicePlayerFieldsFragment_Device_cameraView_CameraView | null
};

export type DeviceForPlayerQuery_Query = {
  __typename?: 'Query',
  device?: DeviceForPlayerQuery_device_Device | null
};


export type DeviceForPlayerQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeviceForPlayerQuery = DeviceForPlayerQuery_Query;

export type DevicesByIdsQuery_devicesByIds_Device = {
  __typename?: 'Device',
  id: string,
  name: string,
  createdAt?: Date | null,
  modifiedAt?: Date | null,
  enabled: boolean,
  cloudDirect: boolean,
  healthStatus: HealthStatus,
  version: string,
  location?: string | null,
  deliveryPriority?: number | null,
  eventType?: DeviceEventType | null,
  rtpOverTcp?: boolean | null,
  rtpTime?: boolean | null,
  deviceType?: BaseDeviceType | null,
  acknowledgeRequired?: boolean | null,
  geoZone?: any | null,
  eventTimeFromRealm?: boolean | null,
  preEventTime?: number | null,
  postEventTime?: number | null,
  position?: DeviceFieldsFragment_Device_position_LatLng | null,
  alarmPointPosition?: DeviceFieldsFragment_Device_alarmPointPosition_LatLng | null,
  config: DeviceFieldsFragment_Device_config_DeviceBaseConfig,
  platform?: DeviceFieldsFragment_Device_platform_Device | null,
  sharedStream?: Array<DeviceFieldsFragment_Device_sharedStream_StreamShare> | null,
  zone?: DeviceFieldsFragment_Device_zone_ObjectDescriptor | null,
  set?: Array<DeviceFieldsFragment_Device_set_ObjectDescriptor> | null,
  storageConfig?: DeviceFieldsFragment_Device_storageConfig_DeviceStorageConfig | null,
  aspects: Array<DeviceFieldsFragment_Device_aspects>,
  cameraView?: DeviceFieldsFragment_Device_cameraView_CameraView | null
};

export type DevicesByIdsQuery_Query = {
  __typename?: 'Query',
  devicesByIds: Array<DevicesByIdsQuery_devicesByIds_Device>
};


export type DevicesByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']>;
}>;


export type DevicesByIdsQuery = DevicesByIdsQuery_Query;

export type DeviceNameQuery_device_Device = {
  __typename?: 'Device',
  id: string,
  name: string
};

export type DeviceNameQuery_Query = {
  __typename?: 'Query',
  device?: DeviceNameQuery_device_Device | null
};


export type DeviceNameQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeviceNameQuery = DeviceNameQuery_Query;

export type PtzControllerConfigQuery_device_Device_aspects_DFA_Avatar = {
  __typename?: 'DFA_Avatar',
  type: DeviceFunctionalAspectType
};

export type PtzControllerConfigQuery_device_Device_aspects_DFA_Gateway = {
  __typename?: 'DFA_Gateway',
  type: DeviceFunctionalAspectType
};

export type PtzControllerConfigQuery_device_Device_aspects_DFA_Media = {
  __typename?: 'DFA_Media',
  type: DeviceFunctionalAspectType
};

export type PtzControllerConfigQuery_device_Device_aspects_DFA_PTZ = {
  __typename?: 'DFA_PTZ',
  ptzConfig?: string | null,
  type: DeviceFunctionalAspectType
};

export type PtzControllerConfigQuery_device_Device_aspects_DFA_Sensor = {
  __typename?: 'DFA_Sensor',
  type: DeviceFunctionalAspectType
};

export type PtzControllerConfigQuery_device_Device_aspects_DFA_VAE = {
  __typename?: 'DFA_VAE',
  type: DeviceFunctionalAspectType
};

export type PtzControllerConfigQuery_device_Device_aspects =
  | PtzControllerConfigQuery_device_Device_aspects_DFA_Avatar
  | PtzControllerConfigQuery_device_Device_aspects_DFA_Gateway
  | PtzControllerConfigQuery_device_Device_aspects_DFA_Media
  | PtzControllerConfigQuery_device_Device_aspects_DFA_PTZ
  | PtzControllerConfigQuery_device_Device_aspects_DFA_Sensor
  | PtzControllerConfigQuery_device_Device_aspects_DFA_VAE
;

export type PtzControllerConfigQuery_device_Device = {
  __typename?: 'Device',
  id: string,
  name: string,
  aspects: Array<PtzControllerConfigQuery_device_Device_aspects>
};

export type PtzControllerConfigQuery_Query = {
  __typename?: 'Query',
  device?: PtzControllerConfigQuery_device_Device | null
};


export type PtzControllerConfigQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type PtzControllerConfigQuery = PtzControllerConfigQuery_Query;

export type ArchiveCoverageQuery_archiveCoverage_ArchiveCoverage_coverage_ArchiveCoverageItem = {
  __typename?: 'ArchiveCoverageItem',
  deviceId: string,
  streamNumber: number,
  time: number
};

export type ArchiveCoverageQuery_archiveCoverage_ArchiveCoverage_partialCoverage_ArchiveCoverageItem = {
  __typename?: 'ArchiveCoverageItem',
  deviceId: string,
  streamNumber: number,
  time: number
};

export type ArchiveCoverageQuery_archiveCoverage_ArchiveCoverage_ttl_ArchiveCoverageTTL = {
  __typename?: 'ArchiveCoverageTTL',
  deviceId: string,
  ttl: number
};

export type ArchiveCoverageQuery_archiveCoverage_ArchiveCoverage = {
  __typename?: 'ArchiveCoverage',
  coverage: Array<ArchiveCoverageQuery_archiveCoverage_ArchiveCoverage_coverage_ArchiveCoverageItem>,
  partialCoverage: Array<ArchiveCoverageQuery_archiveCoverage_ArchiveCoverage_partialCoverage_ArchiveCoverageItem>,
  ttl: Array<ArchiveCoverageQuery_archiveCoverage_ArchiveCoverage_ttl_ArchiveCoverageTTL>
};

export type ArchiveCoverageQuery_aodGet_AodRequest = {
  __typename?: 'AodRequest',
  id: string,
  deviceId: string,
  startTime: Date,
  endTime: Date,
  streamNumber: number,
  status: AodRequestStatus
};

export type ArchiveCoverageQuery_Query = {
  __typename?: 'Query',
  archiveCoverage: ArchiveCoverageQuery_archiveCoverage_ArchiveCoverage,
  aodGet: Array<ArchiveCoverageQuery_aodGet_AodRequest>
};


export type ArchiveCoverageQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']>;
  startTime: Scalars['DateTime']['input'];
  endTime: Scalars['DateTime']['input'];
  streams?: InputMaybe<Array<Scalars['Int']['input']>>;
  location?: InputMaybe<ArchiveLocation>;
}>;


export type ArchiveCoverageQuery = ArchiveCoverageQuery_Query;

export type ArchiveBoundaryQuery_archiveBoundary_ArchiveBoundary = {
  __typename?: 'ArchiveBoundary',
  boundary?: Date | null,
  timeInsideGap: boolean
};

export type ArchiveBoundaryQuery_Query = {
  __typename?: 'Query',
  archiveBoundary: ArchiveBoundaryQuery_archiveBoundary_ArchiveBoundary
};


export type ArchiveBoundaryQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']>;
  streamNumbers: Array<Scalars['Int']['input']>;
  startTime: Scalars['DateTime']['input'];
  find: BoundaryFind;
}>;


export type ArchiveBoundaryQuery = ArchiveBoundaryQuery_Query;

export type ProbeDeviceQuery_probeDevice_DeviceProbe = {
  __typename?: 'DeviceProbe',
  name?: string | null,
  snapshots: Array<string>,
  rtpTime?: boolean | null,
  config: DeviceProbeFieldsFragment_DeviceProbe_config_DeviceBaseConfig,
  aspects: Array<DeviceProbeFieldsFragment_DeviceProbe_aspects>
};

export type ProbeDeviceQuery_Query = {
  __typename?: 'Query',
  probeDevice: ProbeDeviceQuery_probeDevice_DeviceProbe
};


export type ProbeDeviceQueryVariables = Exact<{
  input: DeviceProbeInput;
}>;


export type ProbeDeviceQuery = ProbeDeviceQuery_Query;

export type DiscoverDevicesQuery_discoverDevices_DeviceProbe = {
  __typename?: 'DeviceProbe',
  name?: string | null,
  snapshots: Array<string>,
  rtpTime?: boolean | null,
  config: DeviceProbeFieldsFragment_DeviceProbe_config_DeviceBaseConfig,
  aspects: Array<DeviceProbeFieldsFragment_DeviceProbe_aspects>
};

export type DiscoverDevicesQuery_Query = {
  __typename?: 'Query',
  discoverDevices: Array<DiscoverDevicesQuery_discoverDevices_DeviceProbe>
};


export type DiscoverDevicesQueryVariables = Exact<{
  platformId: Scalars['ID']['input'];
}>;


export type DiscoverDevicesQuery = DiscoverDevicesQuery_Query;

export type ProbeSensorQuery_probeSensorDevice_DeviceProbe = {
  __typename?: 'DeviceProbe',
  name?: string | null,
  snapshots: Array<string>,
  rtpTime?: boolean | null,
  config: DeviceProbeFieldsFragment_DeviceProbe_config_DeviceBaseConfig,
  aspects: Array<DeviceProbeFieldsFragment_DeviceProbe_aspects>
};

export type ProbeSensorQuery_Query = {
  __typename?: 'Query',
  probeSensorDevice: ProbeSensorQuery_probeSensorDevice_DeviceProbe
};


export type ProbeSensorQueryVariables = Exact<{
  input: DeviceProbeInput;
}>;


export type ProbeSensorQuery = ProbeSensorQuery_Query;

export type StoragePoolsQuery_storagePools_StoragePool = {
  __typename?: 'StoragePool',
  id: string,
  name: string,
  ttlHours: number
};

export type StoragePoolsQuery_Query = {
  __typename?: 'Query',
  storagePools: Array<StoragePoolsQuery_storagePools_StoragePool>
};


export type StoragePoolsQueryVariables = Exact<{ [key: string]: never; }>;


export type StoragePoolsQuery = StoragePoolsQuery_Query;

export type AspectTemplatesQuery_aspectTemplates_FunctionalAspectTemplate = {
  __typename?: 'FunctionalAspectTemplate',
  id: string,
  type: DeviceFunctionalAspectType,
  name: string,
  order: number,
  engine?: string | null,
  features?: Array<DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_template_FunctionalAspectTemplate_features_VaeFeature> | null
};

export type AspectTemplatesQuery_Query = {
  __typename?: 'Query',
  aspectTemplates: Array<AspectTemplatesQuery_aspectTemplates_FunctionalAspectTemplate>
};


export type AspectTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type AspectTemplatesQuery = AspectTemplatesQuery_Query;

export type DeviceTemplatesQuery_deviceTemplates_DeviceTemplate_models_DeviceTemplateModel = {
  __typename?: 'DeviceTemplateModel',
  model: string,
  url: string
};

export type DeviceTemplatesQuery_deviceTemplates_DeviceTemplate = {
  __typename?: 'DeviceTemplate',
  make: string,
  models: Array<DeviceTemplatesQuery_deviceTemplates_DeviceTemplate_models_DeviceTemplateModel>
};

export type DeviceTemplatesQuery_Query = {
  __typename?: 'Query',
  deviceTemplates: Array<DeviceTemplatesQuery_deviceTemplates_DeviceTemplate>
};


export type DeviceTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type DeviceTemplatesQuery = DeviceTemplatesQuery_Query;

export type VaeTemplatesQuery_vaeTemplates_FunctionalAspectTemplate = {
  __typename?: 'FunctionalAspectTemplate',
  id: string,
  type: DeviceFunctionalAspectType,
  name: string,
  order: number,
  engine?: string | null,
  features?: Array<DeviceFieldsFragment_Device_aspects_DeviceFunctionalAspect_template_FunctionalAspectTemplate_features_VaeFeature> | null
};

export type VaeTemplatesQuery_Query = {
  __typename?: 'Query',
  vaeTemplates: Array<VaeTemplatesQuery_vaeTemplates_FunctionalAspectTemplate>
};


export type VaeTemplatesQueryVariables = Exact<{
  deviceId: Scalars['ID']['input'];
}>;


export type VaeTemplatesQuery = VaeTemplatesQuery_Query;

export type CameraLogQuery_cameraLog_CameraLog = {
  __typename?: 'CameraLog',
  time: Date,
  severity: LogSeverity,
  message: string
};

export type CameraLogQuery_Query = {
  __typename?: 'Query',
  cameraLog: Array<CameraLogQuery_cameraLog_CameraLog>
};


export type CameraLogQueryVariables = Exact<{
  deviceId: Scalars['ID']['input'];
}>;


export type CameraLogQuery = CameraLogQuery_Query;

export type VaeConfigsQuery_vaeConfigs_VaeConfigBrief = {
  __typename?: 'VaeConfigBrief',
  name: string
};

export type VaeConfigsQuery_Query = {
  __typename?: 'Query',
  vaeConfigs: Array<VaeConfigsQuery_vaeConfigs_VaeConfigBrief>
};


export type VaeConfigsQueryVariables = Exact<{
  deviceId: Scalars['ID']['input'];
  engine: Scalars['String']['input'];
}>;


export type VaeConfigsQuery = VaeConfigsQuery_Query;

export type ProbeGatewayDirectoriesQuery_probeGatewayDirectories_GatewayDirectoriesProbe_deviceProbe_DeviceProbe = {
  __typename?: 'DeviceProbe',
  name?: string | null,
  snapshots: Array<string>,
  rtpTime?: boolean | null,
  config: DeviceProbeFieldsFragment_DeviceProbe_config_DeviceBaseConfig,
  aspects: Array<DeviceProbeFieldsFragment_DeviceProbe_aspects>
};

export type ProbeGatewayDirectoriesQuery_probeGatewayDirectories_GatewayDirectoriesProbe_directories_GatewayDirectory = {
  __typename?: 'GatewayDirectory',
  id: string,
  name: string
};

export type ProbeGatewayDirectoriesQuery_probeGatewayDirectories_GatewayDirectoriesProbe = {
  __typename?: 'GatewayDirectoriesProbe',
  deviceProbe: ProbeGatewayDirectoriesQuery_probeGatewayDirectories_GatewayDirectoriesProbe_deviceProbe_DeviceProbe,
  directories: Array<ProbeGatewayDirectoriesQuery_probeGatewayDirectories_GatewayDirectoriesProbe_directories_GatewayDirectory>
};

export type ProbeGatewayDirectoriesQuery_Query = {
  __typename?: 'Query',
  probeGatewayDirectories: ProbeGatewayDirectoriesQuery_probeGatewayDirectories_GatewayDirectoriesProbe
};


export type ProbeGatewayDirectoriesQueryVariables = Exact<{
  input: GatewayDirectoriesProbeInput;
}>;


export type ProbeGatewayDirectoriesQuery = ProbeGatewayDirectoriesQuery_Query;

export type ProbeGatewayQuery_probeGateway_GatewayProbe_devices_GatewayProbeDevice = {
  __typename?: 'GatewayProbeDevice',
  id: string,
  name: string
};

export type ProbeGatewayQuery_probeGateway_GatewayProbe_events_GatewayProbeEvent = {
  __typename?: 'GatewayProbeEvent',
  id: string,
  name: string
};

export type ProbeGatewayQuery_probeGateway_GatewayProbe = {
  __typename?: 'GatewayProbe',
  devices: Array<ProbeGatewayQuery_probeGateway_GatewayProbe_devices_GatewayProbeDevice>,
  events: Array<ProbeGatewayQuery_probeGateway_GatewayProbe_events_GatewayProbeEvent>
};

export type ProbeGatewayQuery_Query = {
  __typename?: 'Query',
  probeGateway: ProbeGatewayQuery_probeGateway_GatewayProbe
};


export type ProbeGatewayQueryVariables = Exact<{
  input: GatewayProbeInput;
}>;


export type ProbeGatewayQuery = ProbeGatewayQuery_Query;

export type CreateGatewayMutation_createGatewayDevice_CreateResult = {
  __typename?: 'CreateResult',
  id: string,
  warning?: string | null
};

export type CreateGatewayMutation_Mutation = {
  __typename?: 'Mutation',
  createGatewayDevice: CreateGatewayMutation_createGatewayDevice_CreateResult
};


export type CreateGatewayMutationVariables = Exact<{
  device: DeviceInput;
}>;


export type CreateGatewayMutation = CreateGatewayMutation_Mutation;

export type CreateSensorMutation_createSensorDevice_CreateResult = {
  __typename?: 'CreateResult',
  id: string,
  warning?: string | null
};

export type CreateSensorMutation_Mutation = {
  __typename?: 'Mutation',
  createSensorDevice: CreateSensorMutation_createSensorDevice_CreateResult
};


export type CreateSensorMutationVariables = Exact<{
  device: DeviceInput;
}>;


export type CreateSensorMutation = CreateSensorMutation_Mutation;

export type CreateDeviceMutation_createDevice_CreateResult = {
  __typename?: 'CreateResult',
  id: string,
  warning?: string | null
};

export type CreateDeviceMutation_Mutation = {
  __typename?: 'Mutation',
  createDevice: CreateDeviceMutation_createDevice_CreateResult
};


export type CreateDeviceMutationVariables = Exact<{
  device: DeviceInput;
}>;


export type CreateDeviceMutation = CreateDeviceMutation_Mutation;

export type UpdateDeviceMutation_updateDevice_UpdateResult_warningFields_WarningField = {
  __typename?: 'WarningField',
  field?: string | null,
  value?: string | null
};

export type UpdateDeviceMutation_updateDevice_UpdateResult = {
  __typename?: 'UpdateResult',
  updated: boolean,
  warning?: string | null,
  warningFields?: Array<UpdateDeviceMutation_updateDevice_UpdateResult_warningFields_WarningField> | null
};

export type UpdateDeviceMutation_Mutation = {
  __typename?: 'Mutation',
  updateDevice: UpdateDeviceMutation_updateDevice_UpdateResult
};


export type UpdateDeviceMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  device: DeviceInput;
}>;


export type UpdateDeviceMutation = UpdateDeviceMutation_Mutation;

export type UpdateDevicesMutation_Mutation = {
  __typename?: 'Mutation',
  updateDevices: boolean
};


export type UpdateDevicesMutationVariables = Exact<{
  list: Array<BulkDeviceInput>;
}>;


export type UpdateDevicesMutation = UpdateDevicesMutation_Mutation;

export type DeleteDeviceMutation_Mutation = {
  __typename?: 'Mutation',
  deleteDevice: boolean
};


export type DeleteDeviceMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteDeviceMutation = DeleteDeviceMutation_Mutation;

export type DeleteDevicesMutation_Mutation = {
  __typename?: 'Mutation',
  deleteDevices: boolean
};


export type DeleteDevicesMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']>;
}>;


export type DeleteDevicesMutation = DeleteDevicesMutation_Mutation;

export type DeviceCommandMutation_Mutation = {
  __typename?: 'Mutation',
  deviceCommand: boolean
};


export type DeviceCommandMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  command: DeviceCommand;
}>;


export type DeviceCommandMutation = DeviceCommandMutation_Mutation;

export type ChangeDeliveryPriorityMutation_Mutation = {
  __typename?: 'Mutation',
  changeDeliveryPriority: boolean
};


export type ChangeDeliveryPriorityMutationVariables = Exact<{
  devices: Array<DeliveryPriorityInput>;
}>;


export type ChangeDeliveryPriorityMutation = ChangeDeliveryPriorityMutation_Mutation;

export type CreateVaeConfigMutation_Mutation = {
  __typename?: 'Mutation',
  createVaeConfig: boolean
};


export type CreateVaeConfigMutationVariables = Exact<{
  deviceId: Scalars['ID']['input'];
  engine: Scalars['String']['input'];
  name: Scalars['String']['input'];
}>;


export type CreateVaeConfigMutation = CreateVaeConfigMutation_Mutation;

export type RenameVaeConfigMutation_Mutation = {
  __typename?: 'Mutation',
  renameVaeConfig: boolean
};


export type RenameVaeConfigMutationVariables = Exact<{
  deviceId: Scalars['ID']['input'];
  engine: Scalars['String']['input'];
  name: Scalars['String']['input'];
  newName: Scalars['String']['input'];
}>;


export type RenameVaeConfigMutation = RenameVaeConfigMutation_Mutation;

export type DeleteVaeConfigMutation_Mutation = {
  __typename?: 'Mutation',
  deleteVaeConfig: boolean
};


export type DeleteVaeConfigMutationVariables = Exact<{
  deviceId: Scalars['ID']['input'];
  engine: Scalars['String']['input'];
  name: Scalars['String']['input'];
}>;


export type DeleteVaeConfigMutation = DeleteVaeConfigMutation_Mutation;

export type PurgeAvatarQueueMutation_Mutation = {
  __typename?: 'Mutation',
  purgeAvatarQueue: boolean
};


export type PurgeAvatarQueueMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type PurgeAvatarQueueMutation = PurgeAvatarQueueMutation_Mutation;

export type PtzAbsMutation_Mutation = {
  __typename?: 'Mutation',
  ptzAbs: boolean
};


export type PtzAbsMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  command: Ptz_AbsInput;
  priority?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PtzAbsMutation = PtzAbsMutation_Mutation;

export type PtzStepMutation_Mutation = {
  __typename?: 'Mutation',
  ptzStep: boolean
};


export type PtzStepMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  command: Ptz_StepInput;
  priority?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PtzStepMutation = PtzStepMutation_Mutation;

export type PtzSpeedMutation_Mutation = {
  __typename?: 'Mutation',
  ptzSpeed: boolean
};


export type PtzSpeedMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  command: Ptz_SpeedInput;
  priority?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PtzSpeedMutation = PtzSpeedMutation_Mutation;

export type PtzPresetMutation_Mutation = {
  __typename?: 'Mutation',
  ptzPreset: boolean
};


export type PtzPresetMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  command: Ptz_PresetInput;
  priority?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PtzPresetMutation = PtzPresetMutation_Mutation;

export type PtzRelMutation_Mutation = {
  __typename?: 'Mutation',
  ptzRel: boolean
};


export type PtzRelMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  command: Ptz_RelInput;
  priority?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PtzRelMutation = PtzRelMutation_Mutation;

export type PtzLockMutation_ptzLock_PtzLockResult = {
  __typename?: 'PtzLockResult',
  token: string
};

export type PtzLockMutation_Mutation = {
  __typename?: 'Mutation',
  ptzLock: PtzLockMutation_ptzLock_PtzLockResult
};


export type PtzLockMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  token?: InputMaybe<Scalars['String']['input']>;
}>;


export type PtzLockMutation = PtzLockMutation_Mutation;

export type PtzUnlockMutation_Mutation = {
  __typename?: 'Mutation',
  ptzUnlock: boolean
};


export type PtzUnlockMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  explicit?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type PtzUnlockMutation = PtzUnlockMutation_Mutation;

export type PtzSettingsMutation_Mutation = {
  __typename?: 'Mutation',
  ptzSettings: boolean
};


export type PtzSettingsMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  command: Ptz_SettingsInput;
  priority?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PtzSettingsMutation = PtzSettingsMutation_Mutation;

export type PtzHardwareMutation_Mutation = {
  __typename?: 'Mutation',
  ptzHardware: boolean
};


export type PtzHardwareMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  command: Ptz_HardwareInput;
  priority?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PtzHardwareMutation = PtzHardwareMutation_Mutation;

export type ChangeLocalStorageConfigMutation_Mutation = {
  __typename?: 'Mutation',
  changeLocalStorage: boolean
};


export type ChangeLocalStorageConfigMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: LocalStorageInput;
}>;


export type ChangeLocalStorageConfigMutation = ChangeLocalStorageConfigMutation_Mutation;

export type CreateAvatarApiKeyMutation_Mutation = {
  __typename?: 'Mutation',
  createAvatarApiKey: boolean
};


export type CreateAvatarApiKeyMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CreateAvatarApiKeyMutation = CreateAvatarApiKeyMutation_Mutation;

export type RegenerateAvatarApiKeyMutation_Mutation = {
  __typename?: 'Mutation',
  regenerateAvatarApiKey: boolean
};


export type RegenerateAvatarApiKeyMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RegenerateAvatarApiKeyMutation = RegenerateAvatarApiKeyMutation_Mutation;

export type RemoveAvatarApiKeyMutation_Mutation = {
  __typename?: 'Mutation',
  removeAvatarApiKey: boolean
};


export type RemoveAvatarApiKeyMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RemoveAvatarApiKeyMutation = RemoveAvatarApiKeyMutation_Mutation;

export type AdminGeoTourListFieldsFragment = {
  __typename?: 'GeoTour',
  type: RealmObjectType,
  id: string,
  name: string,
  enabled: boolean,
  devices?: Array<string> | null
};

export type GeoTourFragment_GeoTour_points_GeoTourPoint_position_LatLng = {
  __typename?: 'LatLng',
  lat: number,
  lng: number
};

export type GeoTourFragment_GeoTour_points_GeoTourPoint = {
  __typename?: 'GeoTourPoint',
  id: string,
  name: string,
  duration: number,
  position: GeoTourFragment_GeoTour_points_GeoTourPoint_position_LatLng
};

export type GeoTourFragment = {
  __typename?: 'GeoTour',
  type: RealmObjectType,
  id: string,
  name: string,
  enabled: boolean,
  devices?: Array<string> | null,
  points?: Array<GeoTourFragment_GeoTour_points_GeoTourPoint> | null
};

export type GeoToursQuery_geoTours_GeoTour = {
  __typename?: 'GeoTour',
  type: RealmObjectType,
  id: string,
  name: string,
  enabled: boolean,
  devices?: Array<string> | null,
  points?: Array<GeoTourFragment_GeoTour_points_GeoTourPoint> | null
};

export type GeoToursQuery_Query = {
  __typename?: 'Query',
  geoTours: Array<GeoToursQuery_geoTours_GeoTour>
};


export type GeoToursQueryVariables = Exact<{ [key: string]: never; }>;


export type GeoToursQuery = GeoToursQuery_Query;

export type AdminGeoTourListQuery_geoTours_GeoTour = {
  __typename?: 'GeoTour',
  type: RealmObjectType,
  id: string,
  name: string,
  enabled: boolean,
  devices?: Array<string> | null
};

export type AdminGeoTourListQuery_Query = {
  __typename?: 'Query',
  geoTours: Array<AdminGeoTourListQuery_geoTours_GeoTour>
};


export type AdminGeoTourListQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminGeoTourListQuery = AdminGeoTourListQuery_Query;

export type GeoTourQuery_geoTour_GeoTour = {
  __typename?: 'GeoTour',
  type: RealmObjectType,
  id: string,
  name: string,
  enabled: boolean,
  devices?: Array<string> | null,
  points?: Array<GeoTourFragment_GeoTour_points_GeoTourPoint> | null
};

export type GeoTourQuery_Query = {
  __typename?: 'Query',
  geoTour?: GeoTourQuery_geoTour_GeoTour | null
};


export type GeoTourQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GeoTourQuery = GeoTourQuery_Query;

export type UpdateGeoTourMutation_updateGeoTour_UpdateResult = {
  __typename?: 'UpdateResult',
  updated: boolean
};

export type UpdateGeoTourMutation_Mutation = {
  __typename?: 'Mutation',
  updateGeoTour: UpdateGeoTourMutation_updateGeoTour_UpdateResult
};


export type UpdateGeoTourMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: GeoTourInput;
}>;


export type UpdateGeoTourMutation = UpdateGeoTourMutation_Mutation;

export type CreateGeoTourMutation_createGeoTour_CreateResult = {
  __typename?: 'CreateResult',
  id: string
};

export type CreateGeoTourMutation_Mutation = {
  __typename?: 'Mutation',
  createGeoTour: CreateGeoTourMutation_createGeoTour_CreateResult
};


export type CreateGeoTourMutationVariables = Exact<{
  input: GeoTourInput;
}>;


export type CreateGeoTourMutation = CreateGeoTourMutation_Mutation;

export type DeleteGeoTourMutation_Mutation = {
  __typename?: 'Mutation',
  deleteGeoTour: boolean
};


export type DeleteGeoTourMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteGeoTourMutation = DeleteGeoTourMutation_Mutation;

export type GetGuisQuery_guis_Gui = {
  __typename?: 'Gui',
  id: string,
  name: string,
  url: string,
  description: string
};

export type GetGuisQuery_Query = {
  __typename?: 'Query',
  guis: Array<GetGuisQuery_guis_Gui>
};


export type GetGuisQueryVariables = Exact<{ [key: string]: never; }>;


export type GetGuisQuery = GetGuisQuery_Query;

export type LabelFieldsFragment_Label_objects_LabelObject = {
  __typename?: 'LabelObject',
  objectId: string,
  type: RealmObjectType
};

export type LabelFieldsFragment = {
  __typename?: 'Label',
  id: string,
  name: string,
  type: LabelType,
  objects: Array<LabelFieldsFragment_Label_objects_LabelObject>
};

export type LabelsQuery_labels_Label = {
  __typename?: 'Label',
  id: string,
  name: string,
  type: LabelType,
  objects: Array<LabelFieldsFragment_Label_objects_LabelObject>
};

export type LabelsQuery_Query = {
  __typename?: 'Query',
  labels: Array<LabelsQuery_labels_Label>
};


export type LabelsQueryVariables = Exact<{ [key: string]: never; }>;


export type LabelsQuery = LabelsQuery_Query;

export type LabelQuery_label_Label = {
  __typename?: 'Label',
  id: string,
  name: string,
  type: LabelType,
  objects: Array<LabelFieldsFragment_Label_objects_LabelObject>
};

export type LabelQuery_Query = {
  __typename?: 'Query',
  label?: LabelQuery_label_Label | null
};


export type LabelQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type LabelQuery = LabelQuery_Query;

export type LabelsForObjectQuery_labelsForObject_Label = {
  __typename?: 'Label',
  id: string,
  name: string,
  type: LabelType,
  objects: Array<LabelFieldsFragment_Label_objects_LabelObject>
};

export type LabelsForObjectQuery_Query = {
  __typename?: 'Query',
  labelsForObject: Array<LabelsForObjectQuery_labelsForObject_Label>
};


export type LabelsForObjectQueryVariables = Exact<{
  objectId: Scalars['ID']['input'];
}>;


export type LabelsForObjectQuery = LabelsForObjectQuery_Query;

export type HierarchyLevelFieldsFragment = {
  __typename?: 'HierarchyLevel',
  id: string,
  name: string,
  labelIds: Array<string>
};

export type HierarchyLevelRecursiveFragment_HierarchyLevel_levels_HierarchyLevel_levels_HierarchyLevel_levels_HierarchyLevel_levels_HierarchyLevel = {
  __typename?: 'HierarchyLevel',
  id: string,
  name: string,
  labelIds: Array<string>
};

export type HierarchyLevelRecursiveFragment_HierarchyLevel_levels_HierarchyLevel_levels_HierarchyLevel_levels_HierarchyLevel = {
  __typename?: 'HierarchyLevel',
  id: string,
  name: string,
  labelIds: Array<string>,
  levels?: Array<HierarchyLevelRecursiveFragment_HierarchyLevel_levels_HierarchyLevel_levels_HierarchyLevel_levels_HierarchyLevel_levels_HierarchyLevel> | null
};

export type HierarchyLevelRecursiveFragment_HierarchyLevel_levels_HierarchyLevel_levels_HierarchyLevel = {
  __typename?: 'HierarchyLevel',
  id: string,
  name: string,
  labelIds: Array<string>,
  levels?: Array<HierarchyLevelRecursiveFragment_HierarchyLevel_levels_HierarchyLevel_levels_HierarchyLevel_levels_HierarchyLevel> | null
};

export type HierarchyLevelRecursiveFragment_HierarchyLevel_levels_HierarchyLevel = {
  __typename?: 'HierarchyLevel',
  id: string,
  name: string,
  labelIds: Array<string>,
  levels?: Array<HierarchyLevelRecursiveFragment_HierarchyLevel_levels_HierarchyLevel_levels_HierarchyLevel> | null
};

export type HierarchyLevelRecursiveFragment = {
  __typename?: 'HierarchyLevel',
  id: string,
  name: string,
  labelIds: Array<string>,
  levels?: Array<HierarchyLevelRecursiveFragment_HierarchyLevel_levels_HierarchyLevel> | null
};

export type HierarchyFieldsFragment_Hierarchy_level_HierarchyLevel = {
  __typename?: 'HierarchyLevel',
  id: string,
  name: string,
  labelIds: Array<string>,
  levels?: Array<HierarchyLevelRecursiveFragment_HierarchyLevel_levels_HierarchyLevel> | null
};

export type HierarchyFieldsFragment = {
  __typename?: 'Hierarchy',
  id: string,
  name: string,
  level: HierarchyFieldsFragment_Hierarchy_level_HierarchyLevel
};

export type HierarchiesQuery_hierarchies_Hierarchy = {
  __typename?: 'Hierarchy',
  id: string,
  name: string,
  level: HierarchyFieldsFragment_Hierarchy_level_HierarchyLevel
};

export type HierarchiesQuery_Query = {
  __typename?: 'Query',
  hierarchies: Array<HierarchiesQuery_hierarchies_Hierarchy>
};


export type HierarchiesQueryVariables = Exact<{ [key: string]: never; }>;


export type HierarchiesQuery = HierarchiesQuery_Query;

export type HierarchyQuery_hierarchy_Hierarchy = {
  __typename?: 'Hierarchy',
  id: string,
  name: string,
  level: HierarchyFieldsFragment_Hierarchy_level_HierarchyLevel
};

export type HierarchyQuery_Query = {
  __typename?: 'Query',
  hierarchy?: HierarchyQuery_hierarchy_Hierarchy | null
};


export type HierarchyQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type HierarchyQuery = HierarchyQuery_Query;

export type InsertLabelsMutation_insertLabels_Label = {
  __typename?: 'Label',
  id: string,
  name: string,
  type: LabelType,
  objects: Array<LabelFieldsFragment_Label_objects_LabelObject>
};

export type InsertLabelsMutation_Mutation = {
  __typename?: 'Mutation',
  insertLabels: Array<InsertLabelsMutation_insertLabels_Label>
};


export type InsertLabelsMutationVariables = Exact<{
  labels: Array<LabelInput>;
}>;


export type InsertLabelsMutation = InsertLabelsMutation_Mutation;

export type UpdateLabelMutation_Mutation = {
  __typename?: 'Mutation',
  updateLabel: boolean
};


export type UpdateLabelMutationVariables = Exact<{
  label: LabelInput;
}>;


export type UpdateLabelMutation = UpdateLabelMutation_Mutation;

export type DeleteLabelMutation_Mutation = {
  __typename?: 'Mutation',
  deleteLabel: boolean
};


export type DeleteLabelMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteLabelMutation = DeleteLabelMutation_Mutation;

export type AssignLabelsMutation_Mutation = {
  __typename?: 'Mutation',
  assignLabels: boolean
};


export type AssignLabelsMutationVariables = Exact<{
  objectId: Scalars['ID']['input'];
  ids: Array<Scalars['ID']['input']>;
}>;


export type AssignLabelsMutation = AssignLabelsMutation_Mutation;

export type RemoveLabelsMutation_Mutation = {
  __typename?: 'Mutation',
  removeLabels: boolean
};


export type RemoveLabelsMutationVariables = Exact<{
  objectId: Scalars['ID']['input'];
  ids: Array<Scalars['ID']['input']>;
}>;


export type RemoveLabelsMutation = RemoveLabelsMutation_Mutation;

export type InsertHierarchyMutation_insertHierarchy_Hierarchy = {
  __typename?: 'Hierarchy',
  id: string,
  name: string,
  level: HierarchyFieldsFragment_Hierarchy_level_HierarchyLevel
};

export type InsertHierarchyMutation_Mutation = {
  __typename?: 'Mutation',
  insertHierarchy: InsertHierarchyMutation_insertHierarchy_Hierarchy
};


export type InsertHierarchyMutationVariables = Exact<{
  hierarchy: HierarchyInput;
}>;


export type InsertHierarchyMutation = InsertHierarchyMutation_Mutation;

export type UpdateHierarchyMutation_Mutation = {
  __typename?: 'Mutation',
  updateHierarchy: boolean
};


export type UpdateHierarchyMutationVariables = Exact<{
  hierarchy: HierarchyInput;
}>;


export type UpdateHierarchyMutation = UpdateHierarchyMutation_Mutation;

export type DeleteHierarchyMutation_Mutation = {
  __typename?: 'Mutation',
  deleteHierarchy: boolean
};


export type DeleteHierarchyMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteHierarchyMutation = DeleteHierarchyMutation_Mutation;

export type LabelOrHierarchyUpdateFieldsFragment = {
  __typename?: 'LabelOrHierarchyUpdate',
  type: LabelOrHierarchyUpdateType,
  itemIds: Array<string>
};

export type LabelUpdateSubscription_labelUpdate_LabelOrHierarchyUpdate = {
  __typename?: 'LabelOrHierarchyUpdate',
  type: LabelOrHierarchyUpdateType,
  itemIds: Array<string>
};

export type LabelUpdateSubscription_Subscription = {
  __typename?: 'Subscription',
  labelUpdate: LabelUpdateSubscription_labelUpdate_LabelOrHierarchyUpdate
};


export type LabelUpdateSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type LabelUpdateSubscription = LabelUpdateSubscription_Subscription;

export type HierarchyUpdateSubscription_hierarchyUpdate_LabelOrHierarchyUpdate = {
  __typename?: 'LabelOrHierarchyUpdate',
  type: LabelOrHierarchyUpdateType,
  itemIds: Array<string>
};

export type HierarchyUpdateSubscription_Subscription = {
  __typename?: 'Subscription',
  hierarchyUpdate: HierarchyUpdateSubscription_hierarchyUpdate_LabelOrHierarchyUpdate
};


export type HierarchyUpdateSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type HierarchyUpdateSubscription = HierarchyUpdateSubscription_Subscription;

export type LicenseTextQuery_license_License = {
  __typename?: 'License',
  text: string
};

export type LicenseTextQuery_Query = {
  __typename?: 'Query',
  license: LicenseTextQuery_license_License
};


export type LicenseTextQueryVariables = Exact<{ [key: string]: never; }>;


export type LicenseTextQuery = LicenseTextQuery_Query;

export type LicenseAcceptedQuery_license_License = {
  __typename?: 'License',
  isAccepted: boolean
};

export type LicenseAcceptedQuery_Query = {
  __typename?: 'Query',
  license: LicenseAcceptedQuery_license_License
};


export type LicenseAcceptedQueryVariables = Exact<{ [key: string]: never; }>;


export type LicenseAcceptedQuery = LicenseAcceptedQuery_Query;

export type AcceptLicenseMutation_Mutation = {
  __typename?: 'Mutation',
  acceptLicense: boolean
};


export type AcceptLicenseMutationVariables = Exact<{ [key: string]: never; }>;


export type AcceptLicenseMutation = AcceptLicenseMutation_Mutation;

export type StoreQuery_store_AppStore_session_Session_info_UserInfo_realm_CurrentRealm = {
  __typename?: 'CurrentRealm',
  id: string,
  name: string,
  type: RealmObjectType,
  maxDownloadLength?: number | null
};

export type StoreQuery_store_AppStore_session_Session_info_UserInfo_user_UserData_solidVisualConfig_SolidVisualConfig = {
  __typename?: 'SolidVisualConfig',
  config?: any | null,
  widgets?: any | null,
  activities?: any | null,
  views?: any | null
};

export type StoreQuery_store_AppStore_session_Session_info_UserInfo_user_UserData = {
  __typename?: 'UserData',
  id: string,
  name: string,
  isAdmin: boolean,
  solidVisualConfig: StoreQuery_store_AppStore_session_Session_info_UserInfo_user_UserData_solidVisualConfig_SolidVisualConfig
};

export type StoreQuery_store_AppStore_session_Session_info_UserInfo = {
  __typename?: 'UserInfo',
  realm: StoreQuery_store_AppStore_session_Session_info_UserInfo_realm_CurrentRealm,
  user: StoreQuery_store_AppStore_session_Session_info_UserInfo_user_UserData
};

export type StoreQuery_store_AppStore_session_Session = {
  __typename?: 'Session',
  isAdmin: boolean,
  isLoggedIn: boolean,
  info?: StoreQuery_store_AppStore_session_Session_info_UserInfo | null
};

export type StoreQuery_store_AppStore_workspace_Workspace_creatingViews_CreatingView_widgets_WidgetInfo = {
  __typename?: 'WidgetInfo',
  widgetId: string,
  index: number,
  propsJSON?: string | null
};

export type StoreQuery_store_AppStore_workspace_Workspace_creatingViews_CreatingView_selectedWidget_WidgetInfo = {
  __typename?: 'WidgetInfo',
  widgetId: string,
  index: number,
  propsJSON?: string | null
};

export type StoreQuery_store_AppStore_workspace_Workspace_creatingViews_CreatingView = {
  __typename?: 'CreatingView',
  viewId: string,
  name: string,
  template?: string | null,
  layout?: string | null,
  layoutJSON?: string | null,
  widgets?: Array<StoreQuery_store_AppStore_workspace_Workspace_creatingViews_CreatingView_widgets_WidgetInfo> | null,
  selectedWidget?: StoreQuery_store_AppStore_workspace_Workspace_creatingViews_CreatingView_selectedWidget_WidgetInfo | null
};

export type StoreQuery_store_AppStore_workspace_Workspace = {
  __typename?: 'Workspace',
  solidConfigJSON?: string | null,
  localViewsJSON?: string | null,
  sharedViewsJSON?: string | null,
  creatingViews?: Array<StoreQuery_store_AppStore_workspace_Workspace_creatingViews_CreatingView> | null
};

export type StoreQuery_store_AppStore_socketEvent_SocketEvent = {
  __typename?: 'SocketEvent',
  type: SocketEventType,
  timeStamp: number
};

export type StoreQuery_store_AppStore_branding_BrandingAttribute = {
  __typename?: 'BrandingAttribute',
  CRM_REGISTRATION_URL: string,
  ICON_PATH: string,
  LOGIN_BACKGROUND_PATH?: string | null,
  LOGIN_HEADER_COLOR?: string | null,
  LOGIN_FOOTER_COLOR?: string | null,
  LOGIN_BANNER_TEXT_PATH?: string | null,
  LOGO_PATH?: string | null,
  SOLID_LOGO_VISIBLE?: string | null,
  OEM_BRAND: string,
  OEM_BRAND_NAME: string,
  OEM_COMPANY_LONG: string,
  OEM_COMPANY_PHONE: string,
  OEM_COMPANY_PHONE_INTERNATIONAL: string,
  OEM_COMPANY_QUICKSTART: string,
  OEM_COMPANY_SHORT: string,
  OEM_COMPANY_SUPPORT_PHONE: string,
  OEM_COMPANY_SUPPORT_URL: string,
  OEM_COMPANY_URL: string,
  OEM_COPYRIGHT: string,
  OEM_COPYRIGHT_MATRIX: string,
  OEM_STYLE: string,
  OEM_SUPPORT_EMAIL: string,
  OEM_TRADEMARKS: string,
  QUICK_START_GUIDE_PATH: string
};

export type StoreQuery_store_AppStore = {
  __typename?: 'AppStore',
  session: StoreQuery_store_AppStore_session_Session,
  workspace: StoreQuery_store_AppStore_workspace_Workspace,
  socketEvent?: StoreQuery_store_AppStore_socketEvent_SocketEvent | null,
  branding?: StoreQuery_store_AppStore_branding_BrandingAttribute | null
};

export type StoreQuery_Query = {
  __typename?: 'Query',
  store: StoreQuery_store_AppStore
};


export type StoreQueryVariables = Exact<{ [key: string]: never; }>;


export type StoreQuery = StoreQuery_Query;

export type SetStoreMutation_Mutation = {
  __typename?: 'Mutation',
  setStore: boolean
};


export type SetStoreMutationVariables = Exact<{
  store: AppStoreInput;
}>;


export type SetStoreMutation = SetStoreMutation_Mutation;

export type ImageMapSetFieldsFragment_ImageMapSet_layers_ImageMapLayer_maps_ImageMap_objects_ImageMapObject_position_Position = {
  __typename?: 'Position',
  x: number,
  y: number
};

export type ImageMapSetFieldsFragment_ImageMapSet_layers_ImageMapLayer_maps_ImageMap_objects_ImageMapObject = {
  __typename?: 'ImageMapObject',
  id: string,
  objectId: string,
  position: ImageMapSetFieldsFragment_ImageMapSet_layers_ImageMapLayer_maps_ImageMap_objects_ImageMapObject_position_Position
};

export type ImageMapSetFieldsFragment_ImageMapSet_layers_ImageMapLayer_maps_ImageMap = {
  __typename?: 'ImageMap',
  id: string,
  name: string,
  order: number,
  base64: string,
  objects: Array<ImageMapSetFieldsFragment_ImageMapSet_layers_ImageMapLayer_maps_ImageMap_objects_ImageMapObject>
};

export type ImageMapSetFieldsFragment_ImageMapSet_layers_ImageMapLayer = {
  __typename?: 'ImageMapLayer',
  id: string,
  name: string,
  maps: Array<ImageMapSetFieldsFragment_ImageMapSet_layers_ImageMapLayer_maps_ImageMap>
};

export type ImageMapSetFieldsFragment = {
  __typename?: 'ImageMapSet',
  id: string,
  name: string,
  layers: Array<ImageMapSetFieldsFragment_ImageMapSet_layers_ImageMapLayer>
};

export type ImageMapLayerFieldsFragment = {
  __typename?: 'ImageMapLayer',
  id: string,
  name: string,
  maps: Array<ImageMapSetFieldsFragment_ImageMapSet_layers_ImageMapLayer_maps_ImageMap>
};

export type ImageMapFieldsFragment = {
  __typename?: 'ImageMap',
  id: string,
  name: string,
  order: number,
  base64: string,
  objects: Array<ImageMapSetFieldsFragment_ImageMapSet_layers_ImageMapLayer_maps_ImageMap_objects_ImageMapObject>
};

export type ImageMapObjectFieldsFragment = {
  __typename?: 'ImageMapObject',
  id: string,
  objectId: string,
  position: ImageMapSetFieldsFragment_ImageMapSet_layers_ImageMapLayer_maps_ImageMap_objects_ImageMapObject_position_Position
};

export type GeoLayersQuery_geoLayers_GEOLayers_geoLayers_GEOLayer = {
  __typename?: 'GEOLayer',
  name: string,
  mime: string,
  id: string,
  path: string,
  uploadDate: Date,
  enabled: boolean
};

export type GeoLayersQuery_geoLayers_GEOLayers = {
  __typename?: 'GEOLayers',
  geoLayers: Array<GeoLayersQuery_geoLayers_GEOLayers_geoLayers_GEOLayer>
};

export type GeoLayersQuery_Query = {
  __typename?: 'Query',
  geoLayers?: GeoLayersQuery_geoLayers_GEOLayers | null
};


export type GeoLayersQueryVariables = Exact<{ [key: string]: never; }>;


export type GeoLayersQuery = GeoLayersQuery_Query;

export type ImageMapConfigQuery_imageMapConfig_ImageMapConfig_sets_ImageMapSet = {
  __typename?: 'ImageMapSet',
  id: string,
  name: string,
  layers: Array<ImageMapSetFieldsFragment_ImageMapSet_layers_ImageMapLayer>
};

export type ImageMapConfigQuery_imageMapConfig_ImageMapConfig = {
  __typename?: 'ImageMapConfig',
  sets: Array<ImageMapConfigQuery_imageMapConfig_ImageMapConfig_sets_ImageMapSet>
};

export type ImageMapConfigQuery_Query = {
  __typename?: 'Query',
  imageMapConfig: ImageMapConfigQuery_imageMapConfig_ImageMapConfig
};


export type ImageMapConfigQueryVariables = Exact<{
  version: Scalars['String']['input'];
  lazyLoadImages?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ImageMapConfigQuery = ImageMapConfigQuery_Query;

export type ImageMapImageQuery_Query = {
  __typename?: 'Query',
  imageMapImage: string
};


export type ImageMapImageQueryVariables = Exact<{
  version: Scalars['String']['input'];
  mapId: Scalars['ID']['input'];
}>;


export type ImageMapImageQuery = ImageMapImageQuery_Query;

export type SlewToPointQuery_Query = {
  __typename?: 'Query',
  slewToPoint?: boolean | null
};


export type SlewToPointQueryVariables = Exact<{
  latLng: LatLngInput;
}>;


export type SlewToPointQuery = SlewToPointQuery_Query;

export type UpdateGeoLayersMutation_Mutation = {
  __typename?: 'Mutation',
  updateGeoLayers: boolean
};


export type UpdateGeoLayersMutationVariables = Exact<{
  input: GeoLayersInput;
}>;


export type UpdateGeoLayersMutation = UpdateGeoLayersMutation_Mutation;

export type InsertImageMapSetMutation_Mutation = {
  __typename?: 'Mutation',
  insertImageMapSet: boolean
};


export type InsertImageMapSetMutationVariables = Exact<{
  version: Scalars['String']['input'];
  set: ImageMapSetInput;
  updateId: Scalars['ID']['input'];
}>;


export type InsertImageMapSetMutation = InsertImageMapSetMutation_Mutation;

export type RenameImageMapSetMutation_Mutation = {
  __typename?: 'Mutation',
  renameImageMapSet: boolean
};


export type RenameImageMapSetMutationVariables = Exact<{
  version: Scalars['String']['input'];
  setId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  updateId: Scalars['ID']['input'];
}>;


export type RenameImageMapSetMutation = RenameImageMapSetMutation_Mutation;

export type DeleteImageMapSetMutation_Mutation = {
  __typename?: 'Mutation',
  deleteImageMapSet: boolean
};


export type DeleteImageMapSetMutationVariables = Exact<{
  version: Scalars['String']['input'];
  setId: Scalars['ID']['input'];
  updateId: Scalars['ID']['input'];
}>;


export type DeleteImageMapSetMutation = DeleteImageMapSetMutation_Mutation;

export type InsertImageMapLayerMutation_Mutation = {
  __typename?: 'Mutation',
  insertImageMapLayer: boolean
};


export type InsertImageMapLayerMutationVariables = Exact<{
  version: Scalars['String']['input'];
  setId: Scalars['ID']['input'];
  layer: ImageMapLayerInput;
  updateId: Scalars['ID']['input'];
}>;


export type InsertImageMapLayerMutation = InsertImageMapLayerMutation_Mutation;

export type RenameImageMapLayerMutation_Mutation = {
  __typename?: 'Mutation',
  renameImageMapLayer: boolean
};


export type RenameImageMapLayerMutationVariables = Exact<{
  version: Scalars['String']['input'];
  layerId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  updateId: Scalars['ID']['input'];
}>;


export type RenameImageMapLayerMutation = RenameImageMapLayerMutation_Mutation;

export type DeleteImageMapLayerMutation_Mutation = {
  __typename?: 'Mutation',
  deleteImageMapLayer: boolean
};


export type DeleteImageMapLayerMutationVariables = Exact<{
  version: Scalars['String']['input'];
  layerId: Scalars['ID']['input'];
  updateId: Scalars['ID']['input'];
}>;


export type DeleteImageMapLayerMutation = DeleteImageMapLayerMutation_Mutation;

export type UpdateImageMapMutation_Mutation = {
  __typename?: 'Mutation',
  updateImageMap: boolean
};


export type UpdateImageMapMutationVariables = Exact<{
  version: Scalars['String']['input'];
  map: ImageMapInput;
  updateId: Scalars['ID']['input'];
}>;


export type UpdateImageMapMutation = UpdateImageMapMutation_Mutation;

export type InsertImageMapObjectMutation_Mutation = {
  __typename?: 'Mutation',
  insertImageMapObject: boolean
};


export type InsertImageMapObjectMutationVariables = Exact<{
  version: Scalars['String']['input'];
  mapId: Scalars['ID']['input'];
  object: ImageMapObjectInput;
  updateId: Scalars['ID']['input'];
}>;


export type InsertImageMapObjectMutation = InsertImageMapObjectMutation_Mutation;

export type UpdateImageMapObjectMutation_Mutation = {
  __typename?: 'Mutation',
  updateImageMapObject: boolean
};


export type UpdateImageMapObjectMutationVariables = Exact<{
  version: Scalars['String']['input'];
  object: ImageMapObjectInput;
  updateId: Scalars['ID']['input'];
}>;


export type UpdateImageMapObjectMutation = UpdateImageMapObjectMutation_Mutation;

export type DeleteImageMapObjectMutation_Mutation = {
  __typename?: 'Mutation',
  deleteImageMapObject: boolean
};


export type DeleteImageMapObjectMutationVariables = Exact<{
  version: Scalars['String']['input'];
  objectId: Scalars['ID']['input'];
  updateId: Scalars['ID']['input'];
}>;


export type DeleteImageMapObjectMutation = DeleteImageMapObjectMutation_Mutation;

export type DeleteGeoLayerMutation_Mutation = {
  __typename?: 'Mutation',
  deleteGeoLayer: boolean
};


export type DeleteGeoLayerMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteGeoLayerMutation = DeleteGeoLayerMutation_Mutation;

export type ImageMapUpdateSubscription_imageMapUpdate_ImageMapUpdateNotification_set_ImageMapSet = {
  __typename?: 'ImageMapSet',
  id: string,
  name: string,
  layers: Array<ImageMapSetFieldsFragment_ImageMapSet_layers_ImageMapLayer>
};

export type ImageMapUpdateSubscription_imageMapUpdate_ImageMapUpdateNotification_layer_ImageMapLayer = {
  __typename?: 'ImageMapLayer',
  id: string,
  name: string,
  maps: Array<ImageMapSetFieldsFragment_ImageMapSet_layers_ImageMapLayer_maps_ImageMap>
};

export type ImageMapUpdateSubscription_imageMapUpdate_ImageMapUpdateNotification_map_ImageMap = {
  __typename?: 'ImageMap',
  id: string,
  name: string,
  order: number,
  base64: string,
  objects: Array<ImageMapSetFieldsFragment_ImageMapSet_layers_ImageMapLayer_maps_ImageMap_objects_ImageMapObject>
};

export type ImageMapUpdateSubscription_imageMapUpdate_ImageMapUpdateNotification_object_ImageMapObject = {
  __typename?: 'ImageMapObject',
  id: string,
  objectId: string,
  position: ImageMapSetFieldsFragment_ImageMapSet_layers_ImageMapLayer_maps_ImageMap_objects_ImageMapObject_position_Position
};

export type ImageMapUpdateSubscription_imageMapUpdate_ImageMapUpdateNotification = {
  __typename?: 'ImageMapUpdateNotification',
  action: ImageMapUpdateAction,
  updateId: string,
  setName?: string | null,
  layerName?: string | null,
  setId?: string | null,
  layerId?: string | null,
  mapId?: string | null,
  objectId?: string | null,
  set?: ImageMapUpdateSubscription_imageMapUpdate_ImageMapUpdateNotification_set_ImageMapSet | null,
  layer?: ImageMapUpdateSubscription_imageMapUpdate_ImageMapUpdateNotification_layer_ImageMapLayer | null,
  map?: ImageMapUpdateSubscription_imageMapUpdate_ImageMapUpdateNotification_map_ImageMap | null,
  object?: ImageMapUpdateSubscription_imageMapUpdate_ImageMapUpdateNotification_object_ImageMapObject | null
};

export type ImageMapUpdateSubscription_Subscription = {
  __typename?: 'Subscription',
  imageMapUpdate: ImageMapUpdateSubscription_imageMapUpdate_ImageMapUpdateNotification
};


export type ImageMapUpdateSubscriptionVariables = Exact<{
  version: Scalars['String']['input'];
}>;


export type ImageMapUpdateSubscription = ImageMapUpdateSubscription_Subscription;

export type RealmQuery_realm_Realm = {
  __typename?: 'Realm',
  name: string,
  id: string,
  maxDownloadTime?: number | null,
  adminEmail?: string | null,
  maxScheduledDeliveryDelay?: number | null,
  auditTtl?: string | null,
  mfAuth?: boolean | null,
  playerIdleTimeout?: number | null,
  emailEnabled?: boolean | null,
  emailHost?: string | null,
  emailPort?: number | null,
  emailTls?: boolean | null,
  emailFrom?: string | null,
  emailAuth?: EmailAuth | null,
  emailUser?: string | null,
  emailPass?: string | null,
  emailValidated?: boolean | null,
  jitterBufferLength?: number | null,
  geoIconSet?: GeoIconSet | null,
  esriMapTileUrl?: string | null,
  esriAccessToken?: string | null,
  defaultMapLayer?: MapType | null,
  googleMapsApiKey?: string | null,
  preEventTime: number,
  postEventTime: number,
  geoZone: any,
  alarmTargetsClear?: boolean | null,
  alarmTargetsClearTime?: number | null,
  normalTargetsClearTime?: number | null,
  trackerStaleTimeout?: number | null,
  trackerMinTrackingTime?: number | null
};

export type RealmQuery_Query = {
  __typename?: 'Query',
  realm?: RealmQuery_realm_Realm | null
};


export type RealmQueryVariables = Exact<{ [key: string]: never; }>;


export type RealmQuery = RealmQuery_Query;

export type RealmForPlayerQuery_realm_Realm = {
  __typename?: 'Realm',
  jitterBufferLength?: number | null,
  playerIdleTimeout?: number | null
};

export type RealmForPlayerQuery_Query = {
  __typename?: 'Query',
  realm?: RealmForPlayerQuery_realm_Realm | null
};


export type RealmForPlayerQueryVariables = Exact<{ [key: string]: never; }>;


export type RealmForPlayerQuery = RealmForPlayerQuery_Query;

export type IdentityAttributeQuery_identityAttribute_IdentityAttribute = {
  __typename?: 'IdentityAttribute',
  contactUs: string
};

export type IdentityAttributeQuery_Query = {
  __typename?: 'Query',
  identityAttribute?: IdentityAttributeQuery_identityAttribute_IdentityAttribute | null
};


export type IdentityAttributeQueryVariables = Exact<{ [key: string]: never; }>;


export type IdentityAttributeQuery = IdentityAttributeQuery_Query;

export type SessionInfoQuery_Query = {
  __typename?: 'Query',
  sessionInfo?: boolean | null
};


export type SessionInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type SessionInfoQuery = SessionInfoQuery_Query;

export type BrandingQuery_branding_Branding = {
  __typename?: 'Branding',
  crmRegistrationUrl?: string | null,
  iconPath?: string | null,
  loginBackgroundPath?: string | null,
  loginFooterColor?: string | null,
  logoPath?: string | null,
  oemBrand?: string | null,
  oemBrandName?: string | null,
  oemCompanyLong?: string | null,
  oemCompanyPhone?: string | null,
  oemCompanyPhoneInternational?: string | null,
  oemCompanyQuickstart?: string | null,
  oemCompanyShort?: string | null,
  oemCompanySupportPhone?: string | null,
  oemCompanySupportUrl?: string | null,
  oemCompanyUrl?: string | null,
  oemCopyright?: string | null,
  oemCopyrightMatrix?: string | null,
  oemStyle?: string | null,
  oemSupportEmail?: string | null,
  oemTrademarks?: string | null,
  quickStartGuidePath?: string | null
};

export type BrandingQuery_Query = {
  __typename?: 'Query',
  branding?: BrandingQuery_branding_Branding | null
};


export type BrandingQueryVariables = Exact<{ [key: string]: never; }>;


export type BrandingQuery = BrandingQuery_Query;

export type LanguagesQuery_languages_Languages_languages_Language = {
  __typename?: 'Language',
  tag: string,
  description: string,
  direction: string
};

export type LanguagesQuery_languages_Languages = {
  __typename?: 'Languages',
  languages?: Array<LanguagesQuery_languages_Languages_languages_Language> | null
};

export type LanguagesQuery_Query = {
  __typename?: 'Query',
  languages?: LanguagesQuery_languages_Languages | null
};


export type LanguagesQueryVariables = Exact<{ [key: string]: never; }>;


export type LanguagesQuery = LanguagesQuery_Query;

export type EmailCanBeSendQuery_Query = {
  __typename?: 'Query',
  emailCanBeSend?: boolean | null
};


export type EmailCanBeSendQueryVariables = Exact<{ [key: string]: never; }>;


export type EmailCanBeSendQuery = EmailCanBeSendQuery_Query;

export type SystemParametersQuery_systemParameters_SystemParameters_geoDefaultPosition_DefaultGeoPosition = {
  __typename?: 'DefaultGeoPosition',
  lat: number,
  lng: number
};

export type SystemParametersQuery_systemParameters_SystemParameters = {
  __typename?: 'SystemParameters',
  updatesHost?: string | null,
  solidAppVersion?: string | null,
  googleYouTubeApiKey?: string | null,
  googleYouTubePlaylistId?: string | null,
  geoDefaultPosition?: SystemParametersQuery_systemParameters_SystemParameters_geoDefaultPosition_DefaultGeoPosition | null
};

export type SystemParametersQuery_Query = {
  __typename?: 'Query',
  systemParameters?: SystemParametersQuery_systemParameters_SystemParameters | null
};


export type SystemParametersQueryVariables = Exact<{ [key: string]: never; }>;


export type SystemParametersQuery = SystemParametersQuery_Query;

export type RealmGeoZoneQuery_realm_Realm = {
  __typename?: 'Realm',
  id: string,
  name: string,
  geoZone: any
};

export type RealmGeoZoneQuery_Query = {
  __typename?: 'Query',
  realm?: RealmGeoZoneQuery_realm_Realm | null
};


export type RealmGeoZoneQueryVariables = Exact<{ [key: string]: never; }>;


export type RealmGeoZoneQuery = RealmGeoZoneQuery_Query;

export type RealmClusterConfigQuery_realm_Realm_geoMarkerClusterConfig_GeoMarkerClusterConfig = {
  __typename?: 'GeoMarkerClusterConfig',
  disableClusteringAtZoom: number,
  enabled: boolean,
  mapType: MapType,
  maxClusterRadius: number
};

export type RealmClusterConfigQuery_realm_Realm = {
  __typename?: 'Realm',
  id: string,
  name: string,
  geoMarkerClusterConfig?: Array<RealmClusterConfigQuery_realm_Realm_geoMarkerClusterConfig_GeoMarkerClusterConfig> | null
};

export type RealmClusterConfigQuery_Query = {
  __typename?: 'Query',
  realm?: RealmClusterConfigQuery_realm_Realm | null
};


export type RealmClusterConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type RealmClusterConfigQuery = RealmClusterConfigQuery_Query;

export type GetGrafanaDashboardsQuery_grafanaDashboards_GrafanaDashboard = {
  __typename?: 'GrafanaDashboard',
  title: string,
  url: string
};

export type GetGrafanaDashboardsQuery_Query = {
  __typename?: 'Query',
  grafanaDashboards: Array<GetGrafanaDashboardsQuery_grafanaDashboards_GrafanaDashboard>
};


export type GetGrafanaDashboardsQueryVariables = Exact<{
  folderId: Scalars['String']['input'];
}>;


export type GetGrafanaDashboardsQuery = GetGrafanaDashboardsQuery_Query;

export type ActivateAvatarMutation_Mutation = {
  __typename?: 'Mutation',
  activateAvatar?: boolean | null
};


export type ActivateAvatarMutationVariables = Exact<{
  avatarId: Scalars['ID']['input'];
}>;


export type ActivateAvatarMutation = ActivateAvatarMutation_Mutation;

export type VerifyCodeMutation_Mutation = {
  __typename?: 'Mutation',
  verifyCode?: boolean | null
};


export type VerifyCodeMutationVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type VerifyCodeMutation = VerifyCodeMutation_Mutation;

export type ActivateEmailMutation_Mutation = {
  __typename?: 'Mutation',
  activateEmail?: boolean | null
};


export type ActivateEmailMutationVariables = Exact<{
  input: SecretPassword;
}>;


export type ActivateEmailMutation = ActivateEmailMutation_Mutation;

export type RestorePasswordMutation_Mutation = {
  __typename?: 'Mutation',
  restorePassword?: boolean | null
};


export type RestorePasswordMutationVariables = Exact<{
  input: SecretPassword;
}>;


export type RestorePasswordMutation = RestorePasswordMutation_Mutation;

export type ChangeCurrentPasswordMutation_Mutation = {
  __typename?: 'Mutation',
  changeCurrentPassword?: boolean | null
};


export type ChangeCurrentPasswordMutationVariables = Exact<{
  input: ChangeCurrentPasswordInput;
}>;


export type ChangeCurrentPasswordMutation = ChangeCurrentPasswordMutation_Mutation;

export type UpdateRealmMutation_Mutation = {
  __typename?: 'Mutation',
  updateRealm?: boolean | null
};


export type UpdateRealmMutationVariables = Exact<{
  realm: RealmInput;
}>;


export type UpdateRealmMutation = UpdateRealmMutation_Mutation;

export type ValidateEmailMutation_Mutation = {
  __typename?: 'Mutation',
  validateEmail?: boolean | null
};


export type ValidateEmailMutationVariables = Exact<{
  addresses: EmailAddresses;
}>;


export type ValidateEmailMutation = ValidateEmailMutation_Mutation;

export type RealmFieldsFragment = {
  __typename?: 'Realm',
  name: string,
  id: string,
  maxDownloadTime?: number | null,
  adminEmail?: string | null,
  maxScheduledDeliveryDelay?: number | null,
  auditTtl?: string | null,
  mfAuth?: boolean | null,
  playerIdleTimeout?: number | null,
  emailEnabled?: boolean | null,
  emailHost?: string | null,
  emailPort?: number | null,
  emailTls?: boolean | null,
  emailFrom?: string | null,
  emailAuth?: EmailAuth | null,
  emailUser?: string | null,
  emailPass?: string | null,
  emailValidated?: boolean | null,
  jitterBufferLength?: number | null,
  geoIconSet?: GeoIconSet | null,
  esriMapTileUrl?: string | null,
  esriAccessToken?: string | null,
  defaultMapLayer?: MapType | null,
  googleMapsApiKey?: string | null,
  preEventTime: number,
  postEventTime: number,
  geoZone: any,
  alarmTargetsClear?: boolean | null,
  alarmTargetsClearTime?: number | null,
  normalTargetsClearTime?: number | null,
  trackerStaleTimeout?: number | null,
  trackerMinTrackingTime?: number | null
};

export type RealmObjectsQuery_realmObjects_CameraTour = {
  __typename?: 'CameraTour',
  id: string,
  name: string
};

export type RealmObjectsQuery_realmObjects_CurrentRealm = {
  __typename?: 'CurrentRealm',
  id: string,
  name: string
};

export type RealmObjectsQuery_realmObjects_Device = {
  __typename?: 'Device',
  id: string,
  name: string
};

export type RealmObjectsQuery_realmObjects_GenericObject = {
  __typename?: 'GenericObject',
  id: string,
  name: string
};

export type RealmObjectsQuery_realmObjects_GeoTour = {
  __typename?: 'GeoTour',
  id: string,
  name: string
};

export type RealmObjectsQuery_realmObjects_Group = {
  __typename?: 'Group',
  id: string,
  name: string
};

export type RealmObjectsQuery_realmObjects_Policy = {
  __typename?: 'Policy',
  id: string,
  name: string
};

export type RealmObjectsQuery_realmObjects_Realm = {
  __typename?: 'Realm',
  id: string,
  name: string
};

export type RealmObjectsQuery_realmObjects_Schedule = {
  __typename?: 'Schedule',
  id: string,
  name: string
};

export type RealmObjectsQuery_realmObjects_Set = {
  __typename?: 'Set',
  id: string,
  name: string
};

export type RealmObjectsQuery_realmObjects_User = {
  __typename?: 'User',
  id: string,
  name: string
};

export type RealmObjectsQuery_realmObjects_Zone = {
  __typename?: 'Zone',
  id: string,
  name: string
};

export type RealmObjectsQuery_realmObjects =
  | RealmObjectsQuery_realmObjects_CameraTour
  | RealmObjectsQuery_realmObjects_CurrentRealm
  | RealmObjectsQuery_realmObjects_Device
  | RealmObjectsQuery_realmObjects_GenericObject
  | RealmObjectsQuery_realmObjects_GeoTour
  | RealmObjectsQuery_realmObjects_Group
  | RealmObjectsQuery_realmObjects_Policy
  | RealmObjectsQuery_realmObjects_Realm
  | RealmObjectsQuery_realmObjects_Schedule
  | RealmObjectsQuery_realmObjects_Set
  | RealmObjectsQuery_realmObjects_User
  | RealmObjectsQuery_realmObjects_Zone
;

export type RealmObjectsQuery_Query = {
  __typename?: 'Query',
  realmObjects: Array<RealmObjectsQuery_realmObjects>
};


export type RealmObjectsQueryVariables = Exact<{ [key: string]: never; }>;


export type RealmObjectsQuery = RealmObjectsQuery_Query;

export type ObjectUpdateSubscription_objectUpdate_ObjectUpdateEvent_ptzStatus_PtzStatus_position_PtzPosition = {
  __typename?: 'PtzPosition',
  pan: number,
  tilt: number,
  hfov: number
};

export type ObjectUpdateSubscription_objectUpdate_ObjectUpdateEvent_ptzStatus_PtzStatus_lock_PtzLock = {
  __typename?: 'PtzLock',
  userId?: string | null,
  userName?: string | null,
  category: PtzLockCategory,
  expire: Date,
  explicit?: boolean | null
};

export type ObjectUpdateSubscription_objectUpdate_ObjectUpdateEvent_ptzStatus_PtzStatus = {
  __typename?: 'PtzStatus',
  position?: ObjectUpdateSubscription_objectUpdate_ObjectUpdateEvent_ptzStatus_PtzStatus_position_PtzPosition | null,
  lock?: ObjectUpdateSubscription_objectUpdate_ObjectUpdateEvent_ptzStatus_PtzStatus_lock_PtzLock | null
};

export type ObjectUpdateSubscription_objectUpdate_ObjectUpdateEvent_ptzLockProlongation_PtzLockProlongation = {
  __typename?: 'PtzLockProlongation',
  userId: string,
  token: string,
  createdAt: Date
};

export type ObjectUpdateSubscription_objectUpdate_ObjectUpdateEvent_vaeStatus_VaeReasonStatus = {
  __typename?: 'VaeReasonStatus',
  reason: string,
  status: VaeStatus,
  vae: string
};

export type ObjectUpdateSubscription_objectUpdate_ObjectUpdateEvent = {
  __typename?: 'ObjectUpdateEvent',
  id: string,
  type: string,
  action: ObjectAction,
  healthStatus?: HealthStatus | null,
  ptzStatus?: ObjectUpdateSubscription_objectUpdate_ObjectUpdateEvent_ptzStatus_PtzStatus | null,
  ptzLockProlongation?: ObjectUpdateSubscription_objectUpdate_ObjectUpdateEvent_ptzLockProlongation_PtzLockProlongation | null,
  vaeStatus?: Array<ObjectUpdateSubscription_objectUpdate_ObjectUpdateEvent_vaeStatus_VaeReasonStatus> | null
};

export type ObjectUpdateSubscription_Subscription = {
  __typename?: 'Subscription',
  objectUpdate: ObjectUpdateSubscription_objectUpdate_ObjectUpdateEvent
};


export type ObjectUpdateSubscriptionVariables = Exact<{
  filter?: InputMaybe<ObjectUpdateFilter>;
}>;


export type ObjectUpdateSubscription = ObjectUpdateSubscription_Subscription;

export type AvatarReportQuery_avatarReport_NumericReport = {
  __typename?: 'NumericReport',
  time: number,
  value: number
};

export type AvatarReportQuery_Query = {
  __typename?: 'Query',
  avatarReport: Array<AvatarReportQuery_avatarReport_NumericReport>
};


export type AvatarReportQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
  metricName: AvatarMetricName;
}>;


export type AvatarReportQuery = AvatarReportQuery_Query;

export type CameraReportQuery_numeric_NumericReport = {
  __typename?: 'NumericReport',
  time: number,
  value: number
};

export type CameraReportQuery_numeric_StatusReport = {
  __typename?: 'StatusReport'
};

export type CameraReportQuery_numeric =
  | CameraReportQuery_numeric_NumericReport
  | CameraReportQuery_numeric_StatusReport
;

export type CameraReportQuery_status_NumericReport = {
  __typename?: 'NumericReport'
};

export type CameraReportQuery_status_StatusReport = {
  __typename?: 'StatusReport',
  time: number,
  value: StatusMetric
};

export type CameraReportQuery_status =
  | CameraReportQuery_status_NumericReport
  | CameraReportQuery_status_StatusReport
;

export type CameraReportQuery_Query = {
  __typename?: 'Query',
  numeric: Array<CameraReportQuery_numeric>,
  status: Array<CameraReportQuery_status>
};


export type CameraReportQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
  metricName: CameraMetricName;
  dfaId: Scalars['Int']['input'];
}>;


export type CameraReportQuery = CameraReportQuery_Query;

export type AvatarMetricsQuery_avatarMetrics_AvatarMetric = {
  __typename?: 'AvatarMetric',
  key: AvatarMetricName,
  name: string,
  dimension: MetricDimension
};

export type AvatarMetricsQuery_Query = {
  __typename?: 'Query',
  avatarMetrics: Array<AvatarMetricsQuery_avatarMetrics_AvatarMetric>
};


export type AvatarMetricsQueryVariables = Exact<{ [key: string]: never; }>;


export type AvatarMetricsQuery = AvatarMetricsQuery_Query;

export type CameraMetricsQuery_cameraMetrics_CameraMetric = {
  __typename?: 'CameraMetric',
  key: CameraMetricName,
  name: string,
  dimension: MetricDimension,
  dfaId: number
};

export type CameraMetricsQuery_Query = {
  __typename?: 'Query',
  cameraMetrics: Array<CameraMetricsQuery_cameraMetrics_CameraMetric>
};


export type CameraMetricsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  from?: InputMaybe<Scalars['DateTime']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type CameraMetricsQuery = CameraMetricsQuery_Query;

export type AdminScheduleListFieldsFragment_Schedule_devices_ObjectDescriptor = {
  __typename?: 'ObjectDescriptor',
  id: string,
  type: RealmObjectType,
  name: string
};

export type AdminScheduleListFieldsFragment_Schedule_sets_ObjectDescriptor = {
  __typename?: 'ObjectDescriptor',
  id: string,
  type: RealmObjectType,
  name: string
};

export type AdminScheduleListFieldsFragment_Schedule_zones_ObjectDescriptor = {
  __typename?: 'ObjectDescriptor',
  id: string,
  type: RealmObjectType,
  name: string
};

export type AdminScheduleListFieldsFragment = {
  __typename?: 'Schedule',
  id: string,
  name: string,
  enabled: boolean,
  devices?: Array<AdminScheduleListFieldsFragment_Schedule_devices_ObjectDescriptor> | null,
  sets?: Array<AdminScheduleListFieldsFragment_Schedule_sets_ObjectDescriptor> | null,
  zones?: Array<AdminScheduleListFieldsFragment_Schedule_zones_ObjectDescriptor> | null
};

export type AdminScheduleListQuery_schedules_Schedule = {
  __typename?: 'Schedule',
  id: string,
  name: string,
  enabled: boolean,
  devices?: Array<AdminScheduleListFieldsFragment_Schedule_devices_ObjectDescriptor> | null,
  sets?: Array<AdminScheduleListFieldsFragment_Schedule_sets_ObjectDescriptor> | null,
  zones?: Array<AdminScheduleListFieldsFragment_Schedule_zones_ObjectDescriptor> | null
};

export type AdminScheduleListQuery_Query = {
  __typename?: 'Query',
  schedules: Array<AdminScheduleListQuery_schedules_Schedule>
};


export type AdminScheduleListQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminScheduleListQuery = AdminScheduleListQuery_Query;

export type ScheduleFieldsFragment_Schedule_devices_ObjectDescriptor = {
  __typename?: 'ObjectDescriptor',
  id: string,
  name: string,
  type: RealmObjectType
};

export type ScheduleFieldsFragment_Schedule_sets_ObjectDescriptor = {
  __typename?: 'ObjectDescriptor',
  id: string,
  name: string,
  type: RealmObjectType
};

export type ScheduleFieldsFragment_Schedule_zones_ObjectDescriptor = {
  __typename?: 'ObjectDescriptor',
  id: string,
  name: string,
  type: RealmObjectType
};

export type ScheduleFieldsFragment_Schedule_tasks_ScheduleTask_actions_ScheduleAction = {
  __typename?: 'ScheduleAction',
  action: string,
  description: string,
  deviceTypes: Array<ScheduleDeviceType>,
  value: string
};

export type ScheduleFieldsFragment_Schedule_tasks_ScheduleTask = {
  __typename?: 'ScheduleTask',
  id: string,
  name: string,
  startTime: Date,
  endTime: Date,
  byDay?: Array<WeekDay> | null,
  actions?: Array<ScheduleFieldsFragment_Schedule_tasks_ScheduleTask_actions_ScheduleAction> | null
};

export type ScheduleFieldsFragment = {
  __typename?: 'Schedule',
  id: string,
  name: string,
  enabled: boolean,
  timezone: string,
  devices?: Array<ScheduleFieldsFragment_Schedule_devices_ObjectDescriptor> | null,
  sets?: Array<ScheduleFieldsFragment_Schedule_sets_ObjectDescriptor> | null,
  zones?: Array<ScheduleFieldsFragment_Schedule_zones_ObjectDescriptor> | null,
  tasks?: Array<ScheduleFieldsFragment_Schedule_tasks_ScheduleTask> | null
};

export type ScheduleByIdQuery_schedule_Schedule = {
  __typename?: 'Schedule',
  id: string,
  name: string,
  enabled: boolean,
  timezone: string,
  devices?: Array<ScheduleFieldsFragment_Schedule_devices_ObjectDescriptor> | null,
  sets?: Array<ScheduleFieldsFragment_Schedule_sets_ObjectDescriptor> | null,
  zones?: Array<ScheduleFieldsFragment_Schedule_zones_ObjectDescriptor> | null,
  tasks?: Array<ScheduleFieldsFragment_Schedule_tasks_ScheduleTask> | null
};

export type ScheduleByIdQuery_Query = {
  __typename?: 'Query',
  schedule?: ScheduleByIdQuery_schedule_Schedule | null
};


export type ScheduleByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ScheduleByIdQuery = ScheduleByIdQuery_Query;

export type ScheduleActionTemplatesQuery_scheduleActionTemplates_ScheduleActionTemplate = {
  __typename?: 'ScheduleActionTemplate',
  action: string,
  description: string,
  deviceTypes: Array<ScheduleDeviceType>,
  values: Array<string>,
  labels: any
};

export type ScheduleActionTemplatesQuery_Query = {
  __typename?: 'Query',
  scheduleActionTemplates: Array<ScheduleActionTemplatesQuery_scheduleActionTemplates_ScheduleActionTemplate>
};


export type ScheduleActionTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type ScheduleActionTemplatesQuery = ScheduleActionTemplatesQuery_Query;

export type CreateScheduleMutation_createSchedule_CreateResult_warningFields_WarningField = {
  __typename?: 'WarningField',
  field?: string | null,
  value?: string | null
};

export type CreateScheduleMutation_createSchedule_CreateResult = {
  __typename?: 'CreateResult',
  id: string,
  warning?: string | null,
  warningFields?: Array<CreateScheduleMutation_createSchedule_CreateResult_warningFields_WarningField> | null
};

export type CreateScheduleMutation_Mutation = {
  __typename?: 'Mutation',
  createSchedule: CreateScheduleMutation_createSchedule_CreateResult
};


export type CreateScheduleMutationVariables = Exact<{
  schedule: ScheduleInput;
}>;


export type CreateScheduleMutation = CreateScheduleMutation_Mutation;

export type UpdateScheduleMutation_updateSchedule_UpdateResult_warningFields_WarningField = {
  __typename?: 'WarningField',
  field?: string | null,
  value?: string | null
};

export type UpdateScheduleMutation_updateSchedule_UpdateResult = {
  __typename?: 'UpdateResult',
  updated: boolean,
  warning?: string | null,
  warningFields?: Array<UpdateScheduleMutation_updateSchedule_UpdateResult_warningFields_WarningField> | null
};

export type UpdateScheduleMutation_Mutation = {
  __typename?: 'Mutation',
  updateSchedule: UpdateScheduleMutation_updateSchedule_UpdateResult
};


export type UpdateScheduleMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  schedule: ScheduleUpdateInput;
}>;


export type UpdateScheduleMutation = UpdateScheduleMutation_Mutation;

export type DeleteScheduleMutation_Mutation = {
  __typename?: 'Mutation',
  deleteSchedule: boolean
};


export type DeleteScheduleMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteScheduleMutation = DeleteScheduleMutation_Mutation;

export type AddSharedViewMutation_Mutation = {
  __typename?: 'Mutation',
  addSharedView: boolean
};


export type AddSharedViewMutationVariables = Exact<{
  input: AddSharedViewInput;
}>;


export type AddSharedViewMutation = AddSharedViewMutation_Mutation;

export type DeleteSharedViewMutation_Mutation = {
  __typename?: 'Mutation',
  deleteSharedView: boolean
};


export type DeleteSharedViewMutationVariables = Exact<{
  input: DeleteSharedViewInput;
}>;


export type DeleteSharedViewMutation = DeleteSharedViewMutation_Mutation;

export type SystemStatusQuery_systemStatus_SystemStatusInfo_reasons_SystemStatusReason_object_SystemStatusReasonObject = {
  __typename?: 'SystemStatusReasonObject',
  id: string,
  name: string,
  type: string
};

export type SystemStatusQuery_systemStatus_SystemStatusInfo_reasons_SystemStatusReason = {
  __typename?: 'SystemStatusReason',
  message: string,
  options?: any | null,
  object?: SystemStatusQuery_systemStatus_SystemStatusInfo_reasons_SystemStatusReason_object_SystemStatusReasonObject | null
};

export type SystemStatusQuery_systemStatus_SystemStatusInfo = {
  __typename?: 'SystemStatusInfo',
  status: SystemStatus,
  description?: string | null,
  reasons: Array<SystemStatusQuery_systemStatus_SystemStatusInfo_reasons_SystemStatusReason>
};

export type SystemStatusQuery_Query = {
  __typename?: 'Query',
  serverTime: Date,
  systemStatus: SystemStatusQuery_systemStatus_SystemStatusInfo
};


export type SystemStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type SystemStatusQuery = SystemStatusQuery_Query;

export type PositionFieldsFragment = {
  __typename?: 'LatLng',
  alt?: number | null,
  lat: number,
  lng: number
};

export type TargetFieldsFragment_Target_position_LatLng = {
  __typename?: 'LatLng',
  alt?: number | null,
  lat: number,
  lng: number
};

export type TargetFieldsFragment_Target_track_LatLng = {
  __typename?: 'LatLng',
  alt?: number | null,
  lat: number,
  lng: number
};

export type TargetFieldsFragment = {
  __typename?: 'Target',
  createdAt: Date,
  modifiedAt: Date,
  witnesses: Array<string>,
  realmId: string,
  targetId: string,
  type?: TargetType | null,
  description?: any | null,
  risk?: TargetRisk | null,
  classification?: string | null,
  position: TargetFieldsFragment_Target_position_LatLng,
  track?: Array<TargetFieldsFragment_Target_track_LatLng> | null
};

export type TargetQuery_target_Target = {
  __typename?: 'Target',
  createdAt: Date,
  modifiedAt: Date,
  witnesses: Array<string>,
  realmId: string,
  targetId: string,
  type?: TargetType | null,
  description?: any | null,
  risk?: TargetRisk | null,
  classification?: string | null,
  position: TargetFieldsFragment_Target_position_LatLng,
  track?: Array<TargetFieldsFragment_Target_track_LatLng> | null
};

export type TargetQuery_Query = {
  __typename?: 'Query',
  target?: TargetQuery_target_Target | null
};


export type TargetQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type TargetQuery = TargetQuery_Query;

export type TargetsQuery_targets_Target = {
  __typename?: 'Target',
  createdAt: Date,
  modifiedAt: Date,
  witnesses: Array<string>,
  realmId: string,
  targetId: string,
  type?: TargetType | null,
  description?: any | null,
  risk?: TargetRisk | null,
  classification?: string | null,
  position: TargetFieldsFragment_Target_position_LatLng,
  track?: Array<TargetFieldsFragment_Target_track_LatLng> | null
};

export type TargetsQuery_Query = {
  __typename?: 'Query',
  targets: Array<TargetsQuery_targets_Target>
};


export type TargetsQueryVariables = Exact<{
  filter: TargetFilter;
}>;


export type TargetsQuery = TargetsQuery_Query;

export type FollowTargetQuery_Query = {
  __typename?: 'Query',
  followTarget?: boolean | null
};


export type FollowTargetQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type FollowTargetQuery = FollowTargetQuery_Query;

export type UnfollowTargetQuery_Query = {
  __typename?: 'Query',
  unfollowTarget?: boolean | null
};


export type UnfollowTargetQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type UnfollowTargetQuery = UnfollowTargetQuery_Query;

export type ArchiveTargetsQuery_archiveTargets_Target = {
  __typename?: 'Target',
  createdAt: Date,
  modifiedAt: Date,
  witnesses: Array<string>,
  realmId: string,
  targetId: string,
  type?: TargetType | null,
  description?: any | null,
  risk?: TargetRisk | null,
  classification?: string | null,
  position: TargetFieldsFragment_Target_position_LatLng,
  track?: Array<TargetFieldsFragment_Target_track_LatLng> | null
};

export type ArchiveTargetsQuery_Query = {
  __typename?: 'Query',
  archiveTargets: Array<ArchiveTargetsQuery_archiveTargets_Target>
};


export type ArchiveTargetsQueryVariables = Exact<{
  filter: TargetFilter;
}>;


export type ArchiveTargetsQuery = ArchiveTargetsQuery_Query;

export type CreateTargetMutation_createTarget_Target = {
  __typename?: 'Target',
  createdAt: Date,
  modifiedAt: Date,
  witnesses: Array<string>,
  realmId: string,
  targetId: string,
  type?: TargetType | null,
  description?: any | null,
  risk?: TargetRisk | null,
  classification?: string | null,
  position: TargetFieldsFragment_Target_position_LatLng,
  track?: Array<TargetFieldsFragment_Target_track_LatLng> | null
};

export type CreateTargetMutation_Mutation = {
  __typename?: 'Mutation',
  createTarget: CreateTargetMutation_createTarget_Target
};


export type CreateTargetMutationVariables = Exact<{
  input: TargetInput;
}>;


export type CreateTargetMutation = CreateTargetMutation_Mutation;

export type TargetUpdateSubscription_targetUpdate_TargetNotification_position_LatLng = {
  __typename?: 'LatLng',
  alt?: number | null,
  lat: number,
  lng: number
};

export type TargetUpdateSubscription_targetUpdate_TargetNotification = {
  __typename?: 'TargetNotification',
  createdAt: Date,
  modifiedAt: Date,
  realmId: string,
  witnesses: Array<string>,
  targetId: string,
  type?: TargetType | null,
  description?: any | null,
  risk?: TargetRisk | null,
  classification?: string | null,
  position: TargetUpdateSubscription_targetUpdate_TargetNotification_position_LatLng
};

export type TargetUpdateSubscription_Subscription = {
  __typename?: 'Subscription',
  targetUpdate: TargetUpdateSubscription_targetUpdate_TargetNotification
};


export type TargetUpdateSubscriptionVariables = Exact<{
  filter: TargetUpdateFilter;
}>;


export type TargetUpdateSubscription = TargetUpdateSubscription_Subscription;

export type SolidConfigQuery_Query = {
  __typename?: 'Query',
  solidConfig?: string | null
};


export type SolidConfigQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type SolidConfigQuery = SolidConfigQuery_Query;

export type UpdateSolidConfigMutation_Mutation = {
  __typename?: 'Mutation',
  updateSolidConfig: boolean
};


export type UpdateSolidConfigMutationVariables = Exact<{
  solidConfig?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateSolidConfigMutation = UpdateSolidConfigMutation_Mutation;

export type UpdateSolidConfigCurrentViewMutation_Mutation = {
  __typename?: 'Mutation',
  updateSolidConfigCurrentView: boolean
};


export type UpdateSolidConfigCurrentViewMutationVariables = Exact<{
  input: SolidConfigCurrentViewInput;
}>;


export type UpdateSolidConfigCurrentViewMutation = UpdateSolidConfigCurrentViewMutation_Mutation;

export type SetCurrentViewMutation_Mutation = {
  __typename?: 'Mutation',
  setCurrentView: boolean
};


export type SetCurrentViewMutationVariables = Exact<{
  viewId: Scalars['ID']['input'];
}>;


export type SetCurrentViewMutation = SetCurrentViewMutation_Mutation;

export type ClearRecentViewsMutation_Mutation = {
  __typename?: 'Mutation',
  clearRecentViews: boolean
};


export type ClearRecentViewsMutationVariables = Exact<{ [key: string]: never; }>;


export type ClearRecentViewsMutation = ClearRecentViewsMutation_Mutation;

export type SolidConfigUpdateSubscription_solidConfigUpdate_SolidConfigUpdateEvent = {
  __typename?: 'SolidConfigUpdateEvent',
  userId: string,
  solidConfig?: string | null
};

export type SolidConfigUpdateSubscription_Subscription = {
  __typename?: 'Subscription',
  solidConfigUpdate: SolidConfigUpdateSubscription_solidConfigUpdate_SolidConfigUpdateEvent
};


export type SolidConfigUpdateSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type SolidConfigUpdateSubscription = SolidConfigUpdateSubscription_Subscription;

export type UserFieldsFragment_User_groups_Group = {
  __typename?: 'Group',
  id: string,
  name: string,
  isSystemManaged: boolean
};

export type UserFieldsFragment = {
  __typename?: 'User',
  id: string,
  name: string,
  email?: string | null,
  emailConfirmed?: boolean | null,
  sendNotification?: boolean | null,
  groups: Array<UserFieldsFragment_User_groups_Group>
};

export type UserInfoFieldsFragment = {
  __typename?: 'UserInfo',
  realm: StoreQuery_store_AppStore_session_Session_info_UserInfo_realm_CurrentRealm,
  user: StoreQuery_store_AppStore_session_Session_info_UserInfo_user_UserData
};

export type UserIdsQuery_users_User = {
  __typename?: 'User',
  id: string
};

export type UserIdsQuery_Query = {
  __typename?: 'Query',
  users: Array<UserIdsQuery_users_User>
};


export type UserIdsQueryVariables = Exact<{ [key: string]: never; }>;


export type UserIdsQuery = UserIdsQuery_Query;

export type UserWitnessesQuery_users_User = {
  __typename?: 'User',
  id: string,
  name: string
};

export type UserWitnessesQuery_Query = {
  __typename?: 'Query',
  users: Array<UserWitnessesQuery_users_User>
};


export type UserWitnessesQueryVariables = Exact<{ [key: string]: never; }>;


export type UserWitnessesQuery = UserWitnessesQuery_Query;

export type UserQuery_user_User = {
  __typename?: 'User',
  id: string,
  name: string,
  email?: string | null,
  emailConfirmed?: boolean | null,
  sendNotification?: boolean | null,
  groups: Array<UserFieldsFragment_User_groups_Group>
};

export type UserQuery_Query = {
  __typename?: 'Query',
  user?: UserQuery_user_User | null
};


export type UserQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type UserQuery = UserQuery_Query;

export type UserInfoQuery_userInfo_UserInfo = {
  __typename?: 'UserInfo',
  realm: StoreQuery_store_AppStore_session_Session_info_UserInfo_realm_CurrentRealm,
  user: StoreQuery_store_AppStore_session_Session_info_UserInfo_user_UserData
};

export type UserInfoQuery_Query = {
  __typename?: 'Query',
  userInfo: UserInfoQuery_userInfo_UserInfo
};


export type UserInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type UserInfoQuery = UserInfoQuery_Query;

export type UsersQuery_users_User = {
  __typename?: 'User',
  id: string,
  name: string,
  email?: string | null,
  emailConfirmed?: boolean | null,
  sendNotification?: boolean | null,
  groups: Array<UserFieldsFragment_User_groups_Group>
};

export type UsersQuery_Query = {
  __typename?: 'Query',
  users: Array<UsersQuery_users_User>
};


export type UsersQueryVariables = Exact<{ [key: string]: never; }>;


export type UsersQuery = UsersQuery_Query;

export type CreateUserMutation_createUser_CreateResult = {
  __typename?: 'CreateResult',
  id: string,
  warning?: string | null
};

export type CreateUserMutation_Mutation = {
  __typename?: 'Mutation',
  createUser: CreateUserMutation_createUser_CreateResult
};


export type CreateUserMutationVariables = Exact<{
  user: UserInput;
}>;


export type CreateUserMutation = CreateUserMutation_Mutation;

export type UpdateUserMutation_Mutation = {
  __typename?: 'Mutation',
  updateUser: boolean
};


export type UpdateUserMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  user: UserInput;
}>;


export type UpdateUserMutation = UpdateUserMutation_Mutation;

export type DeleteUserMutation_Mutation = {
  __typename?: 'Mutation',
  deleteUser: boolean
};


export type DeleteUserMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteUserMutation = DeleteUserMutation_Mutation;

export type BlockUserMutation_Mutation = {
  __typename?: 'Mutation',
  blockUser: boolean
};


export type BlockUserMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type BlockUserMutation = BlockUserMutation_Mutation;

export type UnblockUserMutation_Mutation = {
  __typename?: 'Mutation',
  unblockUser: boolean
};


export type UnblockUserMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type UnblockUserMutation = UnblockUserMutation_Mutation;

export type ChangePasswordMutation_Mutation = {
  __typename?: 'Mutation',
  changePassword: boolean
};


export type ChangePasswordMutationVariables = Exact<{
  input: ChangePasswordInput;
}>;


export type ChangePasswordMutation = ChangePasswordMutation_Mutation;

export type SetPasswordMutation_Mutation = {
  __typename?: 'Mutation',
  setPassword: boolean
};


export type SetPasswordMutationVariables = Exact<{
  input: SetPasswordInput;
}>;


export type SetPasswordMutation = SetPasswordMutation_Mutation;

export type GroupsQuery_groups_Group_users_User = {
  __typename?: 'User',
  id: string,
  name: string
};

export type GroupsQuery_groups_Group_policies_Policy = {
  __typename?: 'Policy',
  id: string,
  name: string,
  isSystemManaged: boolean
};

export type GroupsQuery_groups_Group = {
  __typename?: 'Group',
  id: string,
  name: string,
  isSystemManaged: boolean,
  users: Array<GroupsQuery_groups_Group_users_User>,
  policies: Array<GroupsQuery_groups_Group_policies_Policy>
};

export type GroupsQuery_Query = {
  __typename?: 'Query',
  groups: Array<GroupsQuery_groups_Group>
};


export type GroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type GroupsQuery = GroupsQuery_Query;

export type CreateGroupMutation_createGroup_CreateResult = {
  __typename?: 'CreateResult',
  id: string,
  warning?: string | null
};

export type CreateGroupMutation_Mutation = {
  __typename?: 'Mutation',
  createGroup: CreateGroupMutation_createGroup_CreateResult
};


export type CreateGroupMutationVariables = Exact<{
  group: GroupInput;
}>;


export type CreateGroupMutation = CreateGroupMutation_Mutation;

export type UpdateGroupMutation_Mutation = {
  __typename?: 'Mutation',
  updateGroup: boolean
};


export type UpdateGroupMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  group: GroupInput;
}>;


export type UpdateGroupMutation = UpdateGroupMutation_Mutation;

export type DeleteGroupMutation_Mutation = {
  __typename?: 'Mutation',
  deleteGroup: boolean
};


export type DeleteGroupMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteGroupMutation = DeleteGroupMutation_Mutation;

export type PoliciesQuery_policies_Policy_statements_PolicyStatement_resources_ObjectDescriptor = {
  __typename?: 'ObjectDescriptor',
  id: string,
  name: string,
  type: RealmObjectType
};

export type PoliciesQuery_policies_Policy_statements_PolicyStatement = {
  __typename?: 'PolicyStatement',
  id: string,
  name: string,
  effect: StatementEffect,
  actions: Array<string>,
  allResources: boolean,
  resources: Array<PoliciesQuery_policies_Policy_statements_PolicyStatement_resources_ObjectDescriptor>
};

export type PoliciesQuery_policies_Policy = {
  __typename?: 'Policy',
  id: string,
  name: string,
  isSystemManaged: boolean,
  statements: Array<PoliciesQuery_policies_Policy_statements_PolicyStatement>
};

export type PoliciesQuery_Query = {
  __typename?: 'Query',
  policies: Array<PoliciesQuery_policies_Policy>
};


export type PoliciesQueryVariables = Exact<{ [key: string]: never; }>;


export type PoliciesQuery = PoliciesQuery_Query;

export type CreatePolicyMutation_createPolicy_CreateResult = {
  __typename?: 'CreateResult',
  id: string,
  warning?: string | null
};

export type CreatePolicyMutation_Mutation = {
  __typename?: 'Mutation',
  createPolicy: CreatePolicyMutation_createPolicy_CreateResult
};


export type CreatePolicyMutationVariables = Exact<{
  policy: PolicyInput;
}>;


export type CreatePolicyMutation = CreatePolicyMutation_Mutation;

export type UpdatePolicyMutation_Mutation = {
  __typename?: 'Mutation',
  updatePolicy: boolean
};


export type UpdatePolicyMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  policy: PolicyInput;
}>;


export type UpdatePolicyMutation = UpdatePolicyMutation_Mutation;

export type DeletePolicyMutation_Mutation = {
  __typename?: 'Mutation',
  deletePolicy: boolean
};


export type DeletePolicyMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeletePolicyMutation = DeletePolicyMutation_Mutation;

export type CreatePolicyStatementMutation_createPolicyStatement_CreateResult = {
  __typename?: 'CreateResult',
  id: string,
  warning?: string | null
};

export type CreatePolicyStatementMutation_Mutation = {
  __typename?: 'Mutation',
  createPolicyStatement: CreatePolicyStatementMutation_createPolicyStatement_CreateResult
};


export type CreatePolicyStatementMutationVariables = Exact<{
  policyId: Scalars['ID']['input'];
  statement: PolicyStatementInput;
}>;


export type CreatePolicyStatementMutation = CreatePolicyStatementMutation_Mutation;

export type UpdatePolicyStatementMutation_Mutation = {
  __typename?: 'Mutation',
  updatePolicyStatement: boolean
};


export type UpdatePolicyStatementMutationVariables = Exact<{
  statementId: Scalars['ID']['input'];
  statement: PolicyStatementInput;
}>;


export type UpdatePolicyStatementMutation = UpdatePolicyStatementMutation_Mutation;

export type DeletePolicyStatementMutation_Mutation = {
  __typename?: 'Mutation',
  deletePolicyStatement: boolean
};


export type DeletePolicyStatementMutationVariables = Exact<{
  statementId: Scalars['ID']['input'];
}>;


export type DeletePolicyStatementMutation = DeletePolicyStatementMutation_Mutation;

export type ActionsQuery_actions_Action_accessLevel_AccessLevel = {
  __typename?: 'AccessLevel',
  level: string,
  description: string,
  order: number
};

export type ActionsQuery_actions_Action = {
  __typename?: 'Action',
  action: string,
  description: string,
  resourceTypes: Array<RealmObjectType>,
  deviceFunctionalAspectTypes: Array<DeviceFunctionalAspectType>,
  accessLevel: ActionsQuery_actions_Action_accessLevel_AccessLevel
};

export type ActionsQuery_Query = {
  __typename?: 'Query',
  actions: Array<ActionsQuery_actions_Action>
};


export type ActionsQueryVariables = Exact<{ [key: string]: never; }>;


export type ActionsQuery = ActionsQuery_Query;

export type AccessLevelsQuery_accessLevels_AccessLevel = {
  __typename?: 'AccessLevel',
  level: string,
  description: string,
  order: number
};

export type AccessLevelsQuery_Query = {
  __typename?: 'Query',
  accessLevels: Array<AccessLevelsQuery_accessLevels_AccessLevel>
};


export type AccessLevelsQueryVariables = Exact<{ [key: string]: never; }>;


export type AccessLevelsQuery = AccessLevelsQuery_Query;

export type ZonesQuery_zones_Zone_devices_ObjectDescriptor = {
  __typename?: 'ObjectDescriptor',
  id: string,
  name: string
};

export type ZonesQuery_zones_Zone = {
  __typename?: 'Zone',
  id: string,
  name: string,
  devices: Array<ZonesQuery_zones_Zone_devices_ObjectDescriptor>
};

export type ZonesQuery_Query = {
  __typename?: 'Query',
  zones: Array<ZonesQuery_zones_Zone>
};


export type ZonesQueryVariables = Exact<{ [key: string]: never; }>;


export type ZonesQuery = ZonesQuery_Query;

export type SetsQuery_sets_Set_devices_ObjectDescriptor = {
  __typename?: 'ObjectDescriptor',
  id: string,
  name: string
};

export type SetsQuery_sets_Set = {
  __typename?: 'Set',
  id: string,
  name: string,
  isSystemManaged: boolean,
  devices: Array<SetsQuery_sets_Set_devices_ObjectDescriptor>
};

export type SetsQuery_Query = {
  __typename?: 'Query',
  sets: Array<SetsQuery_sets_Set>
};


export type SetsQueryVariables = Exact<{ [key: string]: never; }>;


export type SetsQuery = SetsQuery_Query;

export type GuisQuery_guis_Gui = {
  __typename?: 'Gui',
  id: string,
  name: string
};

export type GuisQuery_Query = {
  __typename?: 'Query',
  guis: Array<GuisQuery_guis_Gui>
};


export type GuisQueryVariables = Exact<{ [key: string]: never; }>;


export type GuisQuery = GuisQuery_Query;

export type UserRealmsQuery_userRealms_Realm = {
  __typename?: 'Realm',
  id: string,
  name: string,
  type: RealmObjectType
};

export type UserRealmsQuery_Query = {
  __typename?: 'Query',
  userRealms: Array<UserRealmsQuery_userRealms_Realm>
};


export type UserRealmsQueryVariables = Exact<{ [key: string]: never; }>;


export type UserRealmsQuery = UserRealmsQuery_Query;

export type SetUserRealmMutation_Mutation = {
  __typename?: 'Mutation',
  setUserRealm: boolean
};


export type SetUserRealmMutationVariables = Exact<{
  userName: Scalars['String']['input'];
  realmId: Scalars['ID']['input'];
}>;


export type SetUserRealmMutation = SetUserRealmMutation_Mutation;

export type CreateZoneMutation_createZone_CreateResult = {
  __typename?: 'CreateResult',
  id: string,
  warning?: string | null
};

export type CreateZoneMutation_Mutation = {
  __typename?: 'Mutation',
  createZone: CreateZoneMutation_createZone_CreateResult
};


export type CreateZoneMutationVariables = Exact<{
  zone: ZoneInput;
}>;


export type CreateZoneMutation = CreateZoneMutation_Mutation;

export type UpdateZoneMutation_Mutation = {
  __typename?: 'Mutation',
  updateZone: boolean
};


export type UpdateZoneMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  zone: ZoneInput;
}>;


export type UpdateZoneMutation = UpdateZoneMutation_Mutation;

export type DeleteZoneMutation_Mutation = {
  __typename?: 'Mutation',
  deleteZone: boolean
};


export type DeleteZoneMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteZoneMutation = DeleteZoneMutation_Mutation;

export type CreateSetMutation_createSet_CreateResult = {
  __typename?: 'CreateResult',
  id: string,
  warning?: string | null
};

export type CreateSetMutation_Mutation = {
  __typename?: 'Mutation',
  createSet: CreateSetMutation_createSet_CreateResult
};


export type CreateSetMutationVariables = Exact<{
  set: SetInput;
}>;


export type CreateSetMutation = CreateSetMutation_Mutation;

export type UpdateSetMutation_Mutation = {
  __typename?: 'Mutation',
  updateSet: boolean
};


export type UpdateSetMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  set: SetInput;
}>;


export type UpdateSetMutation = UpdateSetMutation_Mutation;

export type DeleteSetMutation_Mutation = {
  __typename?: 'Mutation',
  deleteSet: boolean
};


export type DeleteSetMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteSetMutation = DeleteSetMutation_Mutation;

export const AodRequestFieldsFragmentDoc = gql`
    fragment aodRequestFields on AodRequest {
  id
  realmId
  avatarId
  deviceId
  userId
  status
  startTime
  endTime
  streamNumber
  createdAt
  expiredAt
  size
  downloaded
  type
  eta
  note
  files {
    expired
    list {
      href
      size
      startTime
      endTime
    }
  }
}
    `;
export const AuditEntryMetadataFieldsFragmentDoc = gql`
    fragment auditEntryMetadataFields on AuditEntry {
  metadata {
    key
    metaClass {
      value
      attributes {
        key
        value
      }
    }
  }
}
    `;
export const AuditEntryFieldsFragmentDoc = gql`
    fragment auditEntryFields on AuditEntry {
  context
  message
  triggeredAt
  modifiedAt
  category {
    id
    shortName
    digest
  }
  witnesses {
    id
    name
    type
  }
  isAcknowledged
  note
  ...auditEntryMetadataFields
}
    ${AuditEntryMetadataFieldsFragmentDoc}`;
export const AuditEntrySnapshotFieldsFragmentDoc = gql`
    fragment auditEntrySnapshotFields on AuditEntry {
  snapshots {
    type
    default
    snapshot
    tags {
      key
      value
    }
  }
}
    `;
export const AdminCameraTourListFieldsFragmentDoc = gql`
    fragment adminCameraTourListFields on CameraTour {
  type
  id
  name
  enabled
  steps {
    cameraId
    cameraPreset
    delay
    name
  }
}
    `;
export const CameraTourFragmentDoc = gql`
    fragment cameraTour on CameraTour {
  type
  id
  name
  enabled
  steps {
    cameraId
    cameraPreset
    delay
    name
  }
}
    `;
export const ConnectFieldsFragmentDoc = gql`
    fragment connectFields on NetworkConnectDescriptor {
  authType
  URL
  host
  hosts
  user
  pass
  port
  rtspPort
  protocol
  udpPort
  credentials {
    certificate
    privatekey
  }
}
    `;
export const DeviceConfigFieldsFragmentDoc = gql`
    fragment deviceConfigFields on DeviceBaseConfig {
  configType
  connect {
    ...connectFields
  }
  make
  model
  firmware
  onvifServices
  stratusObjId
}
    ${ConnectFieldsFragmentDoc}`;
export const SharedStreamFieldsFragmentDoc = gql`
    fragment sharedStreamFields on StreamShare {
  id
  url
  streamSize
  enabled
  status
  error
}
    `;
export const ObjectDescriptorFieldsFragmentDoc = gql`
    fragment objectDescriptorFields on ObjectDescriptor {
  id
  name
  isSystemManaged
  type
}
    `;
export const StoragePoolFieldsFragmentDoc = gql`
    fragment storagePoolFields on StoragePool {
  id
  name
  ttlHours
}
    `;
export const StorageConfigFieldsFragmentDoc = gql`
    fragment storageConfigFields on DeviceStorageConfig {
  storagePool {
    ...storagePoolFields
  }
}
    ${StoragePoolFieldsFragmentDoc}`;
export const AspectTemplateFieldsFragmentDoc = gql`
    fragment aspectTemplateFields on FunctionalAspectTemplate {
  id
  type
  name
  order
  engine
  features {
    id
    name
    order
    exclusive
  }
}
    `;
export const AspectHealthFieldsFragmentDoc = gql`
    fragment aspectHealthFields on AspectHealth {
  gravity
  readinessTimeout
  livenessTimeout
  healthStatus
}
    `;
export const Ptz_Moog_ConfigFragmentDoc = gql`
    fragment PTZ_Moog_Config on DFA_PTZ {
  ptzId
  ptzTcpAddress {
    ip
    port
  }
  ptzAttachedCamera1Address
  ptzAttachedCamera1BaudRate
  ptzAttachedCamera1SerialMode
  ptzAttachedCamera1Model
  ptzAttachedCamera2Address
  ptzAttachedCamera2BaudRate
  ptzAttachedCamera2SerialMode
  ptzAttachedCamera2Model
}
    `;
export const Ptz_ClearAlign_ConfigFragmentDoc = gql`
    fragment PTZ_ClearAlign_Config on DFA_PTZ {
  cameraType
}
    `;
export const VaeAspectFieldsFragmentDoc = gql`
    fragment vaeAspectFields on DFA_VAE {
  streamSize
  eventType
  vaeConfig {
    name
    description
    configuration
  }
  vaeFeatures
  vaeFps {
    requestedFps {
      minFps
      maxFps
    }
    engineFps {
      minFps
      maxFps
    }
  }
  vaeStatistic {
    status
    uptime
    restarts
    fps {
      avg
      max
      min
      range
    }
    avgLatency
    eps
    metadataBps
    reason
  }
}
    `;
export const StatTimeFieldsFragmentDoc = gql`
    fragment statTimeFields on StatTime {
  avg
  max
  min
}
    `;
export const AspectFieldsFragmentDoc = gql`
    fragment aspectFields on DeviceFunctionalAspect {
  id
  type
  name
  template {
    ...aspectTemplateFields
  }
  device {
    id
    name
  }
  health {
    ...aspectHealthFields
  }
  inputAspects {
    id
    name
  }
  enabled
  ... on DFA_Media {
    streamSize
    streamType
    URL
    videoWidth
    videoHeight
    codec
    frameRate
    onvifProfile
    onvifProfiles
    recordingArchive
    cloudArchive
    consumedSpace
    spaceUsageHour
    spaceUsageDay
    FPS
    liveBitrate
    uptime
    averageFPS
    averageGOP
    averageInterArrivalJitter
    rtpPacketLost
    videoCodec
    videoSize
    audioCodec
  }
  ... on DFA_PTZ {
    ptzType
    ptzPanInverted
    ptzTiltInverted
    ptzConfig
    ...PTZ_Moog_Config
    ...PTZ_ClearAlign_Config
  }
  ... on DFA_VAE {
    ...vaeAspectFields
  }
  ... on DFA_Avatar {
    onvifServiceConf {
      bindIp
      enableDiscovery
      enabled
      httpPort
      pass
      user
      status {
        error
        running
      }
    }
    storageUsage {
      free
      requiredVolume
      localStorageVolume
    }
    isLink
    channelStatus
    dsConfiguredState
    dsRunningState
    lastStatusUpdate
    vmxVideoStreamingMode
    vaeImageUpdate
    software {
      version
      updateAvailable
      lastUpdateTime
      lastUpdateSucceeded
    }
    webRtcEnabled
    channelBenchmark {
      startedAt
      error
      tcpDown {
        bytes
        bitsPerSecond
      }
      tcpUp {
        bytes
        bitsPerSecond
      }
    }
    uploadBandwidthCap
    platform
    upTime
    avatarLoad
    deliveryQueue
    deliveryQueueUploadTime
    turnaroundTime
    supportsReboot
    channelTurnaroundTime {
      ...statTimeFields
    }
    packetArrivalJitterTime {
      ...statTimeFields
    }
    vaeUpdates {
      name
      status
      version
      log
    }
    apiKey
  }
  ... on DFA_Sensor {
    model
    serial
    userEvents
    sensorEvents {
      type
      description
      enabled
      source
      innerProps
    }
    associatedDevices
    category
    qortexZones {
      name
      points {
        x
        y
      }
      zMax
      zMin
      witness
    }
    qortexMappedZones {
      name
      witness
    }
    eltaNorthOffset
    eltaFrequencyControlCenter
  }
  ... on DFA_Gateway {
    lenelVersion
    directory {
      id
      name
    }
    oidcToken
    associatedGatewayDevices {
      id
      associatedDevices
    }
    subscribedEvents {
      id
      type
    }
    directories {
      id
      name
    }
    devices {
      id
      name
    }
    events {
      id
      name
    }
  }
}
    ${AspectTemplateFieldsFragmentDoc}
${AspectHealthFieldsFragmentDoc}
${Ptz_Moog_ConfigFragmentDoc}
${Ptz_ClearAlign_ConfigFragmentDoc}
${VaeAspectFieldsFragmentDoc}
${StatTimeFieldsFragmentDoc}`;
export const PtzStatusFieldsFragmentDoc = gql`
    fragment ptzStatusFields on PtzStatus {
  position {
    pan
    tilt
    hfov
  }
  lock {
    category
    explicit
    userId
    expire
    userName
  }
}
    `;
export const CameraViewFieldsFragmentDoc = gql`
    fragment cameraViewFields on CameraView {
  fieldOfView
  northOffsetAngle
  viewDistance
  ptzStatus {
    ...ptzStatusFields
  }
}
    ${PtzStatusFieldsFragmentDoc}`;
export const DeviceFieldsFragmentDoc = gql`
    fragment deviceFields on Device {
  id
  name
  createdAt
  modifiedAt
  position {
    lat
    lng
    alt
  }
  alarmPointPosition {
    lat
    lng
    alt
  }
  config {
    ...deviceConfigFields
  }
  platform {
    id
    name
    aspects {
      type
      ... on DFA_Avatar {
        webRtcEnabled
      }
    }
  }
  enabled
  cloudDirect
  healthStatus
  version
  location
  sharedStream {
    ...sharedStreamFields
  }
  zone {
    ...objectDescriptorFields
  }
  set {
    ...objectDescriptorFields
  }
  storageConfig {
    ...storageConfigFields
  }
  deliveryPriority
  aspects {
    ...aspectFields
  }
  eventType
  rtpOverTcp
  rtpTime
  deviceType
  acknowledgeRequired
  geoZone
  cameraView {
    ...cameraViewFields
  }
  eventTimeFromRealm
  preEventTime
  postEventTime
}
    ${DeviceConfigFieldsFragmentDoc}
${SharedStreamFieldsFragmentDoc}
${ObjectDescriptorFieldsFragmentDoc}
${StorageConfigFieldsFragmentDoc}
${AspectFieldsFragmentDoc}
${CameraViewFieldsFragmentDoc}`;
export const DeviceGeoFieldsFragmentDoc = gql`
    fragment deviceGeoFields on Device {
  id
  name
  position {
    lat
    lng
    alt
  }
  alarmPointPosition {
    lat
    lng
    alt
  }
  cameraView {
    northOffsetAngle
    ptzStatus {
      ...ptzStatusFields
    }
    ptzLockProlongation {
      createdAt
      token
      userId
    }
  }
  enabled
  healthStatus
  geoZone
  aspects {
    type
    enabled
  }
}
    ${PtzStatusFieldsFragmentDoc}`;
export const AdminCameraFieldsFragmentDoc = gql`
    fragment adminCameraFields on Device {
  id
  name
  location
  enabled
  healthStatus
  config {
    configType
    connect {
      host
      hosts
      port
      URL
    }
  }
  zone {
    ...objectDescriptorFields
  }
  platform {
    name
    id
  }
  aspects {
    id
    enabled
    type
    ... on DFA_Media {
      streamType
      streamSize
      videoCodec
      videoSize
      audioCodec
      FPS
      averageGOP
      liveBitrate
    }
    ... on DFA_VAE {
      health {
        healthStatus
      }
      name
      vaeStatistic {
        reason
      }
    }
  }
  deviceType
}
    ${ObjectDescriptorFieldsFragmentDoc}`;
export const DevicePlayerFieldsFragmentDoc = gql`
    fragment devicePlayerFields on Device {
  id
  name
  cloudDirect
  preEventTime
  postEventTime
  aspects {
    enabled
    ... on DFA_Media {
      enabled
      streamSize
      streamType
      videoWidth
      videoHeight
    }
  }
  platform {
    aspects {
      ... on DFA_Avatar {
        webRtcEnabled
      }
    }
  }
  cameraView {
    ptzStatus {
      ...ptzStatusFields
    }
  }
}
    ${PtzStatusFieldsFragmentDoc}`;
export const DeviceListFieldsFragmentDoc = gql`
    fragment deviceListFields on Device {
  id
  name
  enabled
  healthStatus
  deviceType
}
    `;
export const DeviceReportFieldsFragmentDoc = gql`
    fragment deviceReportFields on Device {
  id
  name
  healthStatus
  config {
    model
    configType
    connect {
      host
      hosts
      user
    }
  }
  aspects {
    type
    enabled
    ... on DFA_Media {
      codec
      cloudArchive
      consumedSpace
      spaceUsageDay
      FPS
      liveBitrate
      streamSize
    }
    ... on DFA_Avatar {
      channelStatus
      lastStatusUpdate
      deliveryQueue
      deliveryQueueUploadTime
      turnaroundTime
      software {
        lastUpdateTime
      }
    }
  }
  platform {
    name
  }
}
    `;
export const DeviceShortFieldsFragmentDoc = gql`
    fragment deviceShortFields on Device {
  id
  name
  location
  enabled
  healthStatus
  deliveryPriority
  config {
    connect {
      host
      hosts
      port
      URL
    }
  }
  aspects {
    type
    ... on DFA_Avatar {
      isLink
      channelStatus
      lastStatusUpdate
      upTime
      software {
        version
        updateAvailable
      }
    }
    ... on DFA_Media {
      enabled
      cloudArchive
      FPS
      liveBitrate
      averageGOP
      videoCodec
      audioCodec
      videoSize
      streamSize
      streamType
    }
  }
  position {
    lat
    lng
    alt
  }
  platform {
    id
    name
  }
  zone {
    ...objectDescriptorFields
  }
  deviceType
}
    ${ObjectDescriptorFieldsFragmentDoc}`;
export const SensorListFieldsFragmentDoc = gql`
    fragment sensorListFields on Device {
  id
  name
  enabled
  location
  healthStatus
  zone {
    ...objectDescriptorFields
  }
  platform {
    id
    name
  }
  config {
    make
    connect {
      host
      port
    }
  }
}
    ${ObjectDescriptorFieldsFragmentDoc}`;
export const GatewayListFieldsFragmentDoc = gql`
    fragment gatewayListFields on Device {
  id
  name
  enabled
  healthStatus
  platform {
    id
    name
  }
  aspects {
    type
    ... on DFA_Gateway {
      associatedGatewayDevices {
        id
        name
        associatedDevices
      }
    }
  }
  config {
    model
  }
}
    `;
export const DeviceWitnessFieldsFragmentDoc = gql`
    fragment deviceWitnessFields on Device {
  id
  name
  enabled
  healthStatus
  deviceType
  platform {
    id
  }
  position {
    lat
    lng
  }
  aspects {
    enabled
  }
}
    `;
export const DeviceProbeFieldsFragmentDoc = gql`
    fragment deviceProbeFields on DeviceProbe {
  name
  config {
    ...deviceConfigFields
  }
  aspects {
    ...aspectFields
  }
  snapshots
  rtpTime
}
    ${DeviceConfigFieldsFragmentDoc}
${AspectFieldsFragmentDoc}`;
export const LocalStorageFieldsFragmentDoc = gql`
    fragment localStorageFields on LocalStorage {
  enabled
  pool {
    path
    size
    enforce
  }
  strategy
  ver
}
    `;
export const DeviceCacheFieldsFragmentDoc = gql`
    fragment deviceCacheFields on Device {
  id
  healthStatus
  enabled
}
    `;
export const DeviceEnabledAspectsFragmentDoc = gql`
    fragment deviceEnabledAspects on Device {
  aspects {
    enabled
  }
}
    `;
export const DeviceVaeManagementFieldsFragmentDoc = gql`
    fragment deviceVaeManagementFields on Device {
  name
  enabled
  healthStatus
  id
  acknowledgeRequired
  platform {
    id
    name
  }
  config {
    ...deviceConfigFields
  }
  aspects {
    ...aspectFields
  }
}
    ${DeviceConfigFieldsFragmentDoc}
${AspectFieldsFragmentDoc}`;
export const AdminGeoTourListFieldsFragmentDoc = gql`
    fragment adminGeoTourListFields on GeoTour {
  type
  id
  name
  enabled
  devices
}
    `;
export const GeoTourFragmentDoc = gql`
    fragment geoTour on GeoTour {
  type
  id
  name
  enabled
  devices
  points {
    id
    name
    duration
    position {
      lat
      lng
    }
  }
}
    `;
export const LabelFieldsFragmentDoc = gql`
    fragment LabelFields on Label {
  id
  name
  objects {
    objectId
    type
  }
  type
}
    `;
export const HierarchyLevelFieldsFragmentDoc = gql`
    fragment HierarchyLevelFields on HierarchyLevel {
  id
  name
  labelIds
}
    `;
export const HierarchyLevelRecursiveFragmentDoc = gql`
    fragment HierarchyLevelRecursive on HierarchyLevel {
  ...HierarchyLevelFields
  levels {
    ...HierarchyLevelFields
    levels {
      ...HierarchyLevelFields
      levels {
        ...HierarchyLevelFields
        levels {
          ...HierarchyLevelFields
        }
      }
    }
  }
}
    ${HierarchyLevelFieldsFragmentDoc}`;
export const HierarchyFieldsFragmentDoc = gql`
    fragment HierarchyFields on Hierarchy {
  id
  name
  level {
    ...HierarchyLevelRecursive
  }
}
    ${HierarchyLevelRecursiveFragmentDoc}`;
export const LabelOrHierarchyUpdateFieldsFragmentDoc = gql`
    fragment LabelOrHierarchyUpdateFields on LabelOrHierarchyUpdate {
  type
  itemIds
}
    `;
export const ImageMapObjectFieldsFragmentDoc = gql`
    fragment ImageMapObjectFields on ImageMapObject {
  id
  objectId
  position {
    x
    y
  }
}
    `;
export const ImageMapFieldsFragmentDoc = gql`
    fragment ImageMapFields on ImageMap {
  id
  name
  order
  base64
  objects {
    ...ImageMapObjectFields
  }
}
    ${ImageMapObjectFieldsFragmentDoc}`;
export const ImageMapLayerFieldsFragmentDoc = gql`
    fragment ImageMapLayerFields on ImageMapLayer {
  id
  name
  maps {
    ...ImageMapFields
  }
}
    ${ImageMapFieldsFragmentDoc}`;
export const ImageMapSetFieldsFragmentDoc = gql`
    fragment ImageMapSetFields on ImageMapSet {
  id
  name
  layers {
    ...ImageMapLayerFields
  }
}
    ${ImageMapLayerFieldsFragmentDoc}`;
export const RealmFieldsFragmentDoc = gql`
    fragment realmFields on Realm {
  name
  id
  maxDownloadTime
  adminEmail
  maxScheduledDeliveryDelay
  auditTtl
  mfAuth
  playerIdleTimeout
  emailEnabled
  emailHost
  emailPort
  emailTls
  emailFrom
  emailAuth
  emailUser
  emailPass
  emailValidated
  jitterBufferLength
  geoIconSet
  esriMapTileUrl
  esriAccessToken
  defaultMapLayer
  googleMapsApiKey
  preEventTime
  postEventTime
  geoZone
  alarmTargetsClear
  alarmTargetsClearTime
  normalTargetsClearTime
  trackerStaleTimeout
  trackerMinTrackingTime
}
    `;
export const AdminScheduleListFieldsFragmentDoc = gql`
    fragment adminScheduleListFields on Schedule {
  id
  name
  enabled
  devices {
    id
    type
    name
  }
  sets {
    id
    type
    name
  }
  zones {
    id
    type
    name
  }
}
    `;
export const ScheduleFieldsFragmentDoc = gql`
    fragment scheduleFields on Schedule {
  id
  name
  enabled
  timezone
  devices {
    id
    name
    type
  }
  sets {
    id
    name
    type
  }
  zones {
    id
    name
    type
  }
  tasks {
    id
    name
    startTime
    endTime
    byDay
    actions {
      action
      description
      deviceTypes
      value
    }
  }
}
    `;
export const PositionFieldsFragmentDoc = gql`
    fragment positionFields on LatLng {
  alt
  lat
  lng
}
    `;
export const TargetFieldsFragmentDoc = gql`
    fragment targetFields on Target {
  createdAt
  modifiedAt
  witnesses
  realmId
  targetId
  type
  description
  risk
  classification
  position {
    ...positionFields
  }
  classification
  risk
  track {
    ...positionFields
  }
}
    ${PositionFieldsFragmentDoc}`;
export const UserFieldsFragmentDoc = gql`
    fragment userFields on User {
  id
  name
  email
  emailConfirmed
  sendNotification
  groups {
    id
    name
    isSystemManaged
  }
}
    `;
export const UserInfoFieldsFragmentDoc = gql`
    fragment userInfoFields on UserInfo {
  realm {
    id
    name
    type
    maxDownloadLength
  }
  user {
    id
    name
    isAdmin
    solidVisualConfig {
      config
      widgets
      activities
      views
    }
  }
}
    `;
export const AodListDocument = gql`
    query aodList($startTime: DateTime!, $endTime: DateTime!) {
  aodGetList(startTime: $startTime, endTime: $endTime) {
    ...aodRequestFields
  }
}
    ${AodRequestFieldsFragmentDoc}`;

/**
 * __useAodListQuery__
 *
 * To run a query within a React component, call `useAodListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAodListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAodListQuery({
 *   variables: {
 *      startTime: // value for 'startTime'
 *      endTime: // value for 'endTime'
 *   },
 * });
 */
export function useAodListQuery(baseOptions: Apollo.QueryHookOptions<AodListQuery, AodListQueryVariables> & ({ variables: AodListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AodListQuery, AodListQueryVariables>(AodListDocument, options);
      }
export function useAodListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AodListQuery, AodListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AodListQuery, AodListQueryVariables>(AodListDocument, options);
        }
// @ts-ignore
export function useAodListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AodListQuery, AodListQueryVariables>): Apollo.UseSuspenseQueryResult<AodListQuery, AodListQueryVariables>;
export function useAodListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AodListQuery, AodListQueryVariables>): Apollo.UseSuspenseQueryResult<AodListQuery | undefined, AodListQueryVariables>;
export function useAodListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AodListQuery, AodListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AodListQuery, AodListQueryVariables>(AodListDocument, options);
        }
export type AodListQueryHookResult = ReturnType<typeof useAodListQuery>;
export type AodListLazyQueryHookResult = ReturnType<typeof useAodListLazyQuery>;
export type AodListSuspenseQueryHookResult = ReturnType<typeof useAodListSuspenseQuery>;
export type AodListQueryResult = Apollo.QueryResult<AodListQuery, AodListQueryVariables>;
export const AodUpdatedListDocument = gql`
    query aodUpdatedList($updatedFrom: DateTime!) {
  aodGetUpdatedList(updatedFrom: $updatedFrom) {
    ...aodRequestFields
  }
}
    ${AodRequestFieldsFragmentDoc}`;

/**
 * __useAodUpdatedListQuery__
 *
 * To run a query within a React component, call `useAodUpdatedListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAodUpdatedListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAodUpdatedListQuery({
 *   variables: {
 *      updatedFrom: // value for 'updatedFrom'
 *   },
 * });
 */
export function useAodUpdatedListQuery(baseOptions: Apollo.QueryHookOptions<AodUpdatedListQuery, AodUpdatedListQueryVariables> & ({ variables: AodUpdatedListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AodUpdatedListQuery, AodUpdatedListQueryVariables>(AodUpdatedListDocument, options);
      }
export function useAodUpdatedListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AodUpdatedListQuery, AodUpdatedListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AodUpdatedListQuery, AodUpdatedListQueryVariables>(AodUpdatedListDocument, options);
        }
// @ts-ignore
export function useAodUpdatedListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AodUpdatedListQuery, AodUpdatedListQueryVariables>): Apollo.UseSuspenseQueryResult<AodUpdatedListQuery, AodUpdatedListQueryVariables>;
export function useAodUpdatedListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AodUpdatedListQuery, AodUpdatedListQueryVariables>): Apollo.UseSuspenseQueryResult<AodUpdatedListQuery | undefined, AodUpdatedListQueryVariables>;
export function useAodUpdatedListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AodUpdatedListQuery, AodUpdatedListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AodUpdatedListQuery, AodUpdatedListQueryVariables>(AodUpdatedListDocument, options);
        }
export type AodUpdatedListQueryHookResult = ReturnType<typeof useAodUpdatedListQuery>;
export type AodUpdatedListLazyQueryHookResult = ReturnType<typeof useAodUpdatedListLazyQuery>;
export type AodUpdatedListSuspenseQueryHookResult = ReturnType<typeof useAodUpdatedListSuspenseQuery>;
export type AodUpdatedListQueryResult = Apollo.QueryResult<AodUpdatedListQuery, AodUpdatedListQueryVariables>;
export const AodSubmitDocument = gql`
    mutation aodSubmit($input: AodRequestInput!) {
  aodSubmit(input: $input) {
    ...aodRequestFields
  }
}
    ${AodRequestFieldsFragmentDoc}`;
export type AodSubmitMutationFn = Apollo.MutationFunction<AodSubmitMutation, AodSubmitMutationVariables>;

/**
 * __useAodSubmitMutation__
 *
 * To run a mutation, you first call `useAodSubmitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAodSubmitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [aodSubmitMutation, { data, loading, error }] = useAodSubmitMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAodSubmitMutation(baseOptions?: Apollo.MutationHookOptions<AodSubmitMutation, AodSubmitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AodSubmitMutation, AodSubmitMutationVariables>(AodSubmitDocument, options);
      }
export type AodSubmitMutationHookResult = ReturnType<typeof useAodSubmitMutation>;
export type AodSubmitMutationResult = Apollo.MutationResult<AodSubmitMutation>;
export type AodSubmitMutationOptions = Apollo.BaseMutationOptions<AodSubmitMutation, AodSubmitMutationVariables>;
export const AodPauseDocument = gql`
    mutation aodPause($requestId: ID!) {
  aodPause(requestId: $requestId)
}
    `;
export type AodPauseMutationFn = Apollo.MutationFunction<AodPauseMutation, AodPauseMutationVariables>;

/**
 * __useAodPauseMutation__
 *
 * To run a mutation, you first call `useAodPauseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAodPauseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [aodPauseMutation, { data, loading, error }] = useAodPauseMutation({
 *   variables: {
 *      requestId: // value for 'requestId'
 *   },
 * });
 */
export function useAodPauseMutation(baseOptions?: Apollo.MutationHookOptions<AodPauseMutation, AodPauseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AodPauseMutation, AodPauseMutationVariables>(AodPauseDocument, options);
      }
export type AodPauseMutationHookResult = ReturnType<typeof useAodPauseMutation>;
export type AodPauseMutationResult = Apollo.MutationResult<AodPauseMutation>;
export type AodPauseMutationOptions = Apollo.BaseMutationOptions<AodPauseMutation, AodPauseMutationVariables>;
export const AodResumeDocument = gql`
    mutation aodResume($requestId: ID!) {
  aodResume(requestId: $requestId)
}
    `;
export type AodResumeMutationFn = Apollo.MutationFunction<AodResumeMutation, AodResumeMutationVariables>;

/**
 * __useAodResumeMutation__
 *
 * To run a mutation, you first call `useAodResumeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAodResumeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [aodResumeMutation, { data, loading, error }] = useAodResumeMutation({
 *   variables: {
 *      requestId: // value for 'requestId'
 *   },
 * });
 */
export function useAodResumeMutation(baseOptions?: Apollo.MutationHookOptions<AodResumeMutation, AodResumeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AodResumeMutation, AodResumeMutationVariables>(AodResumeDocument, options);
      }
export type AodResumeMutationHookResult = ReturnType<typeof useAodResumeMutation>;
export type AodResumeMutationResult = Apollo.MutationResult<AodResumeMutation>;
export type AodResumeMutationOptions = Apollo.BaseMutationOptions<AodResumeMutation, AodResumeMutationVariables>;
export const AodCancelDocument = gql`
    mutation aodCancel($requestIds: [ID!]!) {
  aodCancel(requestIds: $requestIds)
}
    `;
export type AodCancelMutationFn = Apollo.MutationFunction<AodCancelMutation, AodCancelMutationVariables>;

/**
 * __useAodCancelMutation__
 *
 * To run a mutation, you first call `useAodCancelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAodCancelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [aodCancelMutation, { data, loading, error }] = useAodCancelMutation({
 *   variables: {
 *      requestIds: // value for 'requestIds'
 *   },
 * });
 */
export function useAodCancelMutation(baseOptions?: Apollo.MutationHookOptions<AodCancelMutation, AodCancelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AodCancelMutation, AodCancelMutationVariables>(AodCancelDocument, options);
      }
export type AodCancelMutationHookResult = ReturnType<typeof useAodCancelMutation>;
export type AodCancelMutationResult = Apollo.MutationResult<AodCancelMutation>;
export type AodCancelMutationOptions = Apollo.BaseMutationOptions<AodCancelMutation, AodCancelMutationVariables>;
export const AodUpdateDocument = gql`
    subscription aodUpdate($filter: AodRequestFilter!) {
  aodUpdate(filter: $filter) {
    ...aodRequestFields
  }
}
    ${AodRequestFieldsFragmentDoc}`;

/**
 * __useAodUpdateSubscription__
 *
 * To run a query within a React component, call `useAodUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useAodUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAodUpdateSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAodUpdateSubscription(baseOptions: Apollo.SubscriptionHookOptions<AodUpdateSubscription, AodUpdateSubscriptionVariables> & ({ variables: AodUpdateSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<AodUpdateSubscription, AodUpdateSubscriptionVariables>(AodUpdateDocument, options);
      }
export type AodUpdateSubscriptionHookResult = ReturnType<typeof useAodUpdateSubscription>;
export type AodUpdateSubscriptionResult = Apollo.SubscriptionResult<AodUpdateSubscription>;
export const AuditCategoriesDocument = gql`
    query auditCategories {
  auditCategories {
    id
    parent
    shortName
  }
}
    `;

/**
 * __useAuditCategoriesQuery__
 *
 * To run a query within a React component, call `useAuditCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuditCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuditCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAuditCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<AuditCategoriesQuery, AuditCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AuditCategoriesQuery, AuditCategoriesQueryVariables>(AuditCategoriesDocument, options);
      }
export function useAuditCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AuditCategoriesQuery, AuditCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AuditCategoriesQuery, AuditCategoriesQueryVariables>(AuditCategoriesDocument, options);
        }
// @ts-ignore
export function useAuditCategoriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AuditCategoriesQuery, AuditCategoriesQueryVariables>): Apollo.UseSuspenseQueryResult<AuditCategoriesQuery, AuditCategoriesQueryVariables>;
export function useAuditCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AuditCategoriesQuery, AuditCategoriesQueryVariables>): Apollo.UseSuspenseQueryResult<AuditCategoriesQuery | undefined, AuditCategoriesQueryVariables>;
export function useAuditCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AuditCategoriesQuery, AuditCategoriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AuditCategoriesQuery, AuditCategoriesQueryVariables>(AuditCategoriesDocument, options);
        }
export type AuditCategoriesQueryHookResult = ReturnType<typeof useAuditCategoriesQuery>;
export type AuditCategoriesLazyQueryHookResult = ReturnType<typeof useAuditCategoriesLazyQuery>;
export type AuditCategoriesSuspenseQueryHookResult = ReturnType<typeof useAuditCategoriesSuspenseQuery>;
export type AuditCategoriesQueryResult = Apollo.QueryResult<AuditCategoriesQuery, AuditCategoriesQueryVariables>;
export const AuditEntryDocument = gql`
    query auditEntry($id: ID!) {
  auditEntry(id: $id) {
    ...auditEntryFields
  }
}
    ${AuditEntryFieldsFragmentDoc}`;

/**
 * __useAuditEntryQuery__
 *
 * To run a query within a React component, call `useAuditEntryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuditEntryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuditEntryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAuditEntryQuery(baseOptions: Apollo.QueryHookOptions<AuditEntryQuery, AuditEntryQueryVariables> & ({ variables: AuditEntryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AuditEntryQuery, AuditEntryQueryVariables>(AuditEntryDocument, options);
      }
export function useAuditEntryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AuditEntryQuery, AuditEntryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AuditEntryQuery, AuditEntryQueryVariables>(AuditEntryDocument, options);
        }
// @ts-ignore
export function useAuditEntrySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AuditEntryQuery, AuditEntryQueryVariables>): Apollo.UseSuspenseQueryResult<AuditEntryQuery, AuditEntryQueryVariables>;
export function useAuditEntrySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AuditEntryQuery, AuditEntryQueryVariables>): Apollo.UseSuspenseQueryResult<AuditEntryQuery | undefined, AuditEntryQueryVariables>;
export function useAuditEntrySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AuditEntryQuery, AuditEntryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AuditEntryQuery, AuditEntryQueryVariables>(AuditEntryDocument, options);
        }
export type AuditEntryQueryHookResult = ReturnType<typeof useAuditEntryQuery>;
export type AuditEntryLazyQueryHookResult = ReturnType<typeof useAuditEntryLazyQuery>;
export type AuditEntrySuspenseQueryHookResult = ReturnType<typeof useAuditEntrySuspenseQuery>;
export type AuditEntryQueryResult = Apollo.QueryResult<AuditEntryQuery, AuditEntryQueryVariables>;
export const AuditEntriesDocument = gql`
    query auditEntries($filter: AuditEntryFilter!) {
  auditEntries(filter: $filter) {
    ...auditEntryFields
  }
}
    ${AuditEntryFieldsFragmentDoc}`;

/**
 * __useAuditEntriesQuery__
 *
 * To run a query within a React component, call `useAuditEntriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuditEntriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuditEntriesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAuditEntriesQuery(baseOptions: Apollo.QueryHookOptions<AuditEntriesQuery, AuditEntriesQueryVariables> & ({ variables: AuditEntriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AuditEntriesQuery, AuditEntriesQueryVariables>(AuditEntriesDocument, options);
      }
export function useAuditEntriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AuditEntriesQuery, AuditEntriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AuditEntriesQuery, AuditEntriesQueryVariables>(AuditEntriesDocument, options);
        }
// @ts-ignore
export function useAuditEntriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AuditEntriesQuery, AuditEntriesQueryVariables>): Apollo.UseSuspenseQueryResult<AuditEntriesQuery, AuditEntriesQueryVariables>;
export function useAuditEntriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AuditEntriesQuery, AuditEntriesQueryVariables>): Apollo.UseSuspenseQueryResult<AuditEntriesQuery | undefined, AuditEntriesQueryVariables>;
export function useAuditEntriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AuditEntriesQuery, AuditEntriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AuditEntriesQuery, AuditEntriesQueryVariables>(AuditEntriesDocument, options);
        }
export type AuditEntriesQueryHookResult = ReturnType<typeof useAuditEntriesQuery>;
export type AuditEntriesLazyQueryHookResult = ReturnType<typeof useAuditEntriesLazyQuery>;
export type AuditEntriesSuspenseQueryHookResult = ReturnType<typeof useAuditEntriesSuspenseQuery>;
export type AuditEntriesQueryResult = Apollo.QueryResult<AuditEntriesQuery, AuditEntriesQueryVariables>;
export const RequireAcknowledgeWithSnapshotsEntriesDocument = gql`
    query requireAcknowledgeWithSnapshotsEntries($filter: AuditEntryFilter!) {
  requireAcknowledgeEntries(filter: $filter) {
    ...auditEntryFields
    ...auditEntrySnapshotFields
  }
}
    ${AuditEntryFieldsFragmentDoc}
${AuditEntrySnapshotFieldsFragmentDoc}`;

/**
 * __useRequireAcknowledgeWithSnapshotsEntriesQuery__
 *
 * To run a query within a React component, call `useRequireAcknowledgeWithSnapshotsEntriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRequireAcknowledgeWithSnapshotsEntriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRequireAcknowledgeWithSnapshotsEntriesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useRequireAcknowledgeWithSnapshotsEntriesQuery(baseOptions: Apollo.QueryHookOptions<RequireAcknowledgeWithSnapshotsEntriesQuery, RequireAcknowledgeWithSnapshotsEntriesQueryVariables> & ({ variables: RequireAcknowledgeWithSnapshotsEntriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RequireAcknowledgeWithSnapshotsEntriesQuery, RequireAcknowledgeWithSnapshotsEntriesQueryVariables>(RequireAcknowledgeWithSnapshotsEntriesDocument, options);
      }
export function useRequireAcknowledgeWithSnapshotsEntriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RequireAcknowledgeWithSnapshotsEntriesQuery, RequireAcknowledgeWithSnapshotsEntriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RequireAcknowledgeWithSnapshotsEntriesQuery, RequireAcknowledgeWithSnapshotsEntriesQueryVariables>(RequireAcknowledgeWithSnapshotsEntriesDocument, options);
        }
// @ts-ignore
export function useRequireAcknowledgeWithSnapshotsEntriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RequireAcknowledgeWithSnapshotsEntriesQuery, RequireAcknowledgeWithSnapshotsEntriesQueryVariables>): Apollo.UseSuspenseQueryResult<RequireAcknowledgeWithSnapshotsEntriesQuery, RequireAcknowledgeWithSnapshotsEntriesQueryVariables>;
export function useRequireAcknowledgeWithSnapshotsEntriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RequireAcknowledgeWithSnapshotsEntriesQuery, RequireAcknowledgeWithSnapshotsEntriesQueryVariables>): Apollo.UseSuspenseQueryResult<RequireAcknowledgeWithSnapshotsEntriesQuery | undefined, RequireAcknowledgeWithSnapshotsEntriesQueryVariables>;
export function useRequireAcknowledgeWithSnapshotsEntriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RequireAcknowledgeWithSnapshotsEntriesQuery, RequireAcknowledgeWithSnapshotsEntriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RequireAcknowledgeWithSnapshotsEntriesQuery, RequireAcknowledgeWithSnapshotsEntriesQueryVariables>(RequireAcknowledgeWithSnapshotsEntriesDocument, options);
        }
export type RequireAcknowledgeWithSnapshotsEntriesQueryHookResult = ReturnType<typeof useRequireAcknowledgeWithSnapshotsEntriesQuery>;
export type RequireAcknowledgeWithSnapshotsEntriesLazyQueryHookResult = ReturnType<typeof useRequireAcknowledgeWithSnapshotsEntriesLazyQuery>;
export type RequireAcknowledgeWithSnapshotsEntriesSuspenseQueryHookResult = ReturnType<typeof useRequireAcknowledgeWithSnapshotsEntriesSuspenseQuery>;
export type RequireAcknowledgeWithSnapshotsEntriesQueryResult = Apollo.QueryResult<RequireAcknowledgeWithSnapshotsEntriesQuery, RequireAcknowledgeWithSnapshotsEntriesQueryVariables>;
export const RequireAcknowledgeEntriesDocument = gql`
    query requireAcknowledgeEntries($filter: AuditEntryFilter!) {
  requireAcknowledgeEntries(filter: $filter) {
    ...auditEntryFields
  }
}
    ${AuditEntryFieldsFragmentDoc}`;

/**
 * __useRequireAcknowledgeEntriesQuery__
 *
 * To run a query within a React component, call `useRequireAcknowledgeEntriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRequireAcknowledgeEntriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRequireAcknowledgeEntriesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useRequireAcknowledgeEntriesQuery(baseOptions: Apollo.QueryHookOptions<RequireAcknowledgeEntriesQuery, RequireAcknowledgeEntriesQueryVariables> & ({ variables: RequireAcknowledgeEntriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RequireAcknowledgeEntriesQuery, RequireAcknowledgeEntriesQueryVariables>(RequireAcknowledgeEntriesDocument, options);
      }
export function useRequireAcknowledgeEntriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RequireAcknowledgeEntriesQuery, RequireAcknowledgeEntriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RequireAcknowledgeEntriesQuery, RequireAcknowledgeEntriesQueryVariables>(RequireAcknowledgeEntriesDocument, options);
        }
// @ts-ignore
export function useRequireAcknowledgeEntriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RequireAcknowledgeEntriesQuery, RequireAcknowledgeEntriesQueryVariables>): Apollo.UseSuspenseQueryResult<RequireAcknowledgeEntriesQuery, RequireAcknowledgeEntriesQueryVariables>;
export function useRequireAcknowledgeEntriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RequireAcknowledgeEntriesQuery, RequireAcknowledgeEntriesQueryVariables>): Apollo.UseSuspenseQueryResult<RequireAcknowledgeEntriesQuery | undefined, RequireAcknowledgeEntriesQueryVariables>;
export function useRequireAcknowledgeEntriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RequireAcknowledgeEntriesQuery, RequireAcknowledgeEntriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RequireAcknowledgeEntriesQuery, RequireAcknowledgeEntriesQueryVariables>(RequireAcknowledgeEntriesDocument, options);
        }
export type RequireAcknowledgeEntriesQueryHookResult = ReturnType<typeof useRequireAcknowledgeEntriesQuery>;
export type RequireAcknowledgeEntriesLazyQueryHookResult = ReturnType<typeof useRequireAcknowledgeEntriesLazyQuery>;
export type RequireAcknowledgeEntriesSuspenseQueryHookResult = ReturnType<typeof useRequireAcknowledgeEntriesSuspenseQuery>;
export type RequireAcknowledgeEntriesQueryResult = Apollo.QueryResult<RequireAcknowledgeEntriesQuery, RequireAcknowledgeEntriesQueryVariables>;
export const AuditEntriesWithSnapshotsDocument = gql`
    query auditEntriesWithSnapshots($filter: AuditEntryFilter!) {
  auditEntries(filter: $filter) {
    ...auditEntryFields
    ...auditEntrySnapshotFields
  }
}
    ${AuditEntryFieldsFragmentDoc}
${AuditEntrySnapshotFieldsFragmentDoc}`;

/**
 * __useAuditEntriesWithSnapshotsQuery__
 *
 * To run a query within a React component, call `useAuditEntriesWithSnapshotsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuditEntriesWithSnapshotsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuditEntriesWithSnapshotsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAuditEntriesWithSnapshotsQuery(baseOptions: Apollo.QueryHookOptions<AuditEntriesWithSnapshotsQuery, AuditEntriesWithSnapshotsQueryVariables> & ({ variables: AuditEntriesWithSnapshotsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AuditEntriesWithSnapshotsQuery, AuditEntriesWithSnapshotsQueryVariables>(AuditEntriesWithSnapshotsDocument, options);
      }
export function useAuditEntriesWithSnapshotsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AuditEntriesWithSnapshotsQuery, AuditEntriesWithSnapshotsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AuditEntriesWithSnapshotsQuery, AuditEntriesWithSnapshotsQueryVariables>(AuditEntriesWithSnapshotsDocument, options);
        }
// @ts-ignore
export function useAuditEntriesWithSnapshotsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AuditEntriesWithSnapshotsQuery, AuditEntriesWithSnapshotsQueryVariables>): Apollo.UseSuspenseQueryResult<AuditEntriesWithSnapshotsQuery, AuditEntriesWithSnapshotsQueryVariables>;
export function useAuditEntriesWithSnapshotsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AuditEntriesWithSnapshotsQuery, AuditEntriesWithSnapshotsQueryVariables>): Apollo.UseSuspenseQueryResult<AuditEntriesWithSnapshotsQuery | undefined, AuditEntriesWithSnapshotsQueryVariables>;
export function useAuditEntriesWithSnapshotsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AuditEntriesWithSnapshotsQuery, AuditEntriesWithSnapshotsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AuditEntriesWithSnapshotsQuery, AuditEntriesWithSnapshotsQueryVariables>(AuditEntriesWithSnapshotsDocument, options);
        }
export type AuditEntriesWithSnapshotsQueryHookResult = ReturnType<typeof useAuditEntriesWithSnapshotsQuery>;
export type AuditEntriesWithSnapshotsLazyQueryHookResult = ReturnType<typeof useAuditEntriesWithSnapshotsLazyQuery>;
export type AuditEntriesWithSnapshotsSuspenseQueryHookResult = ReturnType<typeof useAuditEntriesWithSnapshotsSuspenseQuery>;
export type AuditEntriesWithSnapshotsQueryResult = Apollo.QueryResult<AuditEntriesWithSnapshotsQuery, AuditEntriesWithSnapshotsQueryVariables>;
export const AuditEntriesTimeDocument = gql`
    query auditEntriesTime($filter: AuditEntryFilter!) {
  auditEntries(filter: $filter) {
    context
    triggeredAt
    witnesses {
      id
    }
  }
}
    `;

/**
 * __useAuditEntriesTimeQuery__
 *
 * To run a query within a React component, call `useAuditEntriesTimeQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuditEntriesTimeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuditEntriesTimeQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAuditEntriesTimeQuery(baseOptions: Apollo.QueryHookOptions<AuditEntriesTimeQuery, AuditEntriesTimeQueryVariables> & ({ variables: AuditEntriesTimeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AuditEntriesTimeQuery, AuditEntriesTimeQueryVariables>(AuditEntriesTimeDocument, options);
      }
export function useAuditEntriesTimeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AuditEntriesTimeQuery, AuditEntriesTimeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AuditEntriesTimeQuery, AuditEntriesTimeQueryVariables>(AuditEntriesTimeDocument, options);
        }
// @ts-ignore
export function useAuditEntriesTimeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AuditEntriesTimeQuery, AuditEntriesTimeQueryVariables>): Apollo.UseSuspenseQueryResult<AuditEntriesTimeQuery, AuditEntriesTimeQueryVariables>;
export function useAuditEntriesTimeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AuditEntriesTimeQuery, AuditEntriesTimeQueryVariables>): Apollo.UseSuspenseQueryResult<AuditEntriesTimeQuery | undefined, AuditEntriesTimeQueryVariables>;
export function useAuditEntriesTimeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AuditEntriesTimeQuery, AuditEntriesTimeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AuditEntriesTimeQuery, AuditEntriesTimeQueryVariables>(AuditEntriesTimeDocument, options);
        }
export type AuditEntriesTimeQueryHookResult = ReturnType<typeof useAuditEntriesTimeQuery>;
export type AuditEntriesTimeLazyQueryHookResult = ReturnType<typeof useAuditEntriesTimeLazyQuery>;
export type AuditEntriesTimeSuspenseQueryHookResult = ReturnType<typeof useAuditEntriesTimeSuspenseQuery>;
export type AuditEntriesTimeQueryResult = Apollo.QueryResult<AuditEntriesTimeQuery, AuditEntriesTimeQueryVariables>;
export const AuditEntriesSubscriptionDocument = gql`
    subscription auditEntriesSubscription($filter: AuditEntryFilter!) {
  auditEntries(filter: $filter) {
    ... on AuditEntry {
      ...auditEntryFields
      ...auditEntrySnapshotFields
    }
    ... on ErrorInfo {
      error
      createdAt
    }
  }
}
    ${AuditEntryFieldsFragmentDoc}
${AuditEntrySnapshotFieldsFragmentDoc}`;

/**
 * __useAuditEntriesSubscriptionSubscription__
 *
 * To run a query within a React component, call `useAuditEntriesSubscriptionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useAuditEntriesSubscriptionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuditEntriesSubscriptionSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAuditEntriesSubscriptionSubscription(baseOptions: Apollo.SubscriptionHookOptions<AuditEntriesSubscriptionSubscription, AuditEntriesSubscriptionSubscriptionVariables> & ({ variables: AuditEntriesSubscriptionSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<AuditEntriesSubscriptionSubscription, AuditEntriesSubscriptionSubscriptionVariables>(AuditEntriesSubscriptionDocument, options);
      }
export type AuditEntriesSubscriptionSubscriptionHookResult = ReturnType<typeof useAuditEntriesSubscriptionSubscription>;
export type AuditEntriesSubscriptionSubscriptionResult = Apollo.SubscriptionResult<AuditEntriesSubscriptionSubscription>;
export const AcknowledgeEventDocument = gql`
    mutation acknowledgeEvent($entry: AcknowledgeAuditEntryInput!) {
  acknowledgeAuditEntry(entry: $entry)
}
    `;
export type AcknowledgeEventMutationFn = Apollo.MutationFunction<AcknowledgeEventMutation, AcknowledgeEventMutationVariables>;

/**
 * __useAcknowledgeEventMutation__
 *
 * To run a mutation, you first call `useAcknowledgeEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcknowledgeEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acknowledgeEventMutation, { data, loading, error }] = useAcknowledgeEventMutation({
 *   variables: {
 *      entry: // value for 'entry'
 *   },
 * });
 */
export function useAcknowledgeEventMutation(baseOptions?: Apollo.MutationHookOptions<AcknowledgeEventMutation, AcknowledgeEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcknowledgeEventMutation, AcknowledgeEventMutationVariables>(AcknowledgeEventDocument, options);
      }
export type AcknowledgeEventMutationHookResult = ReturnType<typeof useAcknowledgeEventMutation>;
export type AcknowledgeEventMutationResult = Apollo.MutationResult<AcknowledgeEventMutation>;
export type AcknowledgeEventMutationOptions = Apollo.BaseMutationOptions<AcknowledgeEventMutation, AcknowledgeEventMutationVariables>;
export const EventsAcknowledgementDocument = gql`
    mutation eventsAcknowledgement($entries: [AcknowledgeAuditEntryInput!]!) {
  auditEntriesAcknowledgment(entries: $entries)
}
    `;
export type EventsAcknowledgementMutationFn = Apollo.MutationFunction<EventsAcknowledgementMutation, EventsAcknowledgementMutationVariables>;

/**
 * __useEventsAcknowledgementMutation__
 *
 * To run a mutation, you first call `useEventsAcknowledgementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEventsAcknowledgementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [eventsAcknowledgementMutation, { data, loading, error }] = useEventsAcknowledgementMutation({
 *   variables: {
 *      entries: // value for 'entries'
 *   },
 * });
 */
export function useEventsAcknowledgementMutation(baseOptions?: Apollo.MutationHookOptions<EventsAcknowledgementMutation, EventsAcknowledgementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EventsAcknowledgementMutation, EventsAcknowledgementMutationVariables>(EventsAcknowledgementDocument, options);
      }
export type EventsAcknowledgementMutationHookResult = ReturnType<typeof useEventsAcknowledgementMutation>;
export type EventsAcknowledgementMutationResult = Apollo.MutationResult<EventsAcknowledgementMutation>;
export type EventsAcknowledgementMutationOptions = Apollo.BaseMutationOptions<EventsAcknowledgementMutation, EventsAcknowledgementMutationVariables>;
export const CreateEventDocument = gql`
    mutation createEvent($entry: CreateEventEntry!) {
  createEvent(entry: $entry)
}
    `;
export type CreateEventMutationFn = Apollo.MutationFunction<CreateEventMutation, CreateEventMutationVariables>;

/**
 * __useCreateEventMutation__
 *
 * To run a mutation, you first call `useCreateEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEventMutation, { data, loading, error }] = useCreateEventMutation({
 *   variables: {
 *      entry: // value for 'entry'
 *   },
 * });
 */
export function useCreateEventMutation(baseOptions?: Apollo.MutationHookOptions<CreateEventMutation, CreateEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEventMutation, CreateEventMutationVariables>(CreateEventDocument, options);
      }
export type CreateEventMutationHookResult = ReturnType<typeof useCreateEventMutation>;
export type CreateEventMutationResult = Apollo.MutationResult<CreateEventMutation>;
export type CreateEventMutationOptions = Apollo.BaseMutationOptions<CreateEventMutation, CreateEventMutationVariables>;
export const AdminCameraTourListDocument = gql`
    query adminCameraTourList {
  cameraTours {
    ...adminCameraTourListFields
  }
}
    ${AdminCameraTourListFieldsFragmentDoc}`;

/**
 * __useAdminCameraTourListQuery__
 *
 * To run a query within a React component, call `useAdminCameraTourListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminCameraTourListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminCameraTourListQuery({
 *   variables: {
 *   },
 * });
 */
export function useAdminCameraTourListQuery(baseOptions?: Apollo.QueryHookOptions<AdminCameraTourListQuery, AdminCameraTourListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminCameraTourListQuery, AdminCameraTourListQueryVariables>(AdminCameraTourListDocument, options);
      }
export function useAdminCameraTourListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminCameraTourListQuery, AdminCameraTourListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminCameraTourListQuery, AdminCameraTourListQueryVariables>(AdminCameraTourListDocument, options);
        }
// @ts-ignore
export function useAdminCameraTourListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AdminCameraTourListQuery, AdminCameraTourListQueryVariables>): Apollo.UseSuspenseQueryResult<AdminCameraTourListQuery, AdminCameraTourListQueryVariables>;
export function useAdminCameraTourListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminCameraTourListQuery, AdminCameraTourListQueryVariables>): Apollo.UseSuspenseQueryResult<AdminCameraTourListQuery | undefined, AdminCameraTourListQueryVariables>;
export function useAdminCameraTourListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminCameraTourListQuery, AdminCameraTourListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminCameraTourListQuery, AdminCameraTourListQueryVariables>(AdminCameraTourListDocument, options);
        }
export type AdminCameraTourListQueryHookResult = ReturnType<typeof useAdminCameraTourListQuery>;
export type AdminCameraTourListLazyQueryHookResult = ReturnType<typeof useAdminCameraTourListLazyQuery>;
export type AdminCameraTourListSuspenseQueryHookResult = ReturnType<typeof useAdminCameraTourListSuspenseQuery>;
export type AdminCameraTourListQueryResult = Apollo.QueryResult<AdminCameraTourListQuery, AdminCameraTourListQueryVariables>;
export const CameraTourDocument = gql`
    query cameraTour($id: ID!) {
  cameraTour(id: $id) {
    ...cameraTour
  }
}
    ${CameraTourFragmentDoc}`;

/**
 * __useCameraTourQuery__
 *
 * To run a query within a React component, call `useCameraTourQuery` and pass it any options that fit your needs.
 * When your component renders, `useCameraTourQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCameraTourQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCameraTourQuery(baseOptions: Apollo.QueryHookOptions<CameraTourQuery, CameraTourQueryVariables> & ({ variables: CameraTourQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CameraTourQuery, CameraTourQueryVariables>(CameraTourDocument, options);
      }
export function useCameraTourLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CameraTourQuery, CameraTourQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CameraTourQuery, CameraTourQueryVariables>(CameraTourDocument, options);
        }
// @ts-ignore
export function useCameraTourSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CameraTourQuery, CameraTourQueryVariables>): Apollo.UseSuspenseQueryResult<CameraTourQuery, CameraTourQueryVariables>;
export function useCameraTourSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CameraTourQuery, CameraTourQueryVariables>): Apollo.UseSuspenseQueryResult<CameraTourQuery | undefined, CameraTourQueryVariables>;
export function useCameraTourSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CameraTourQuery, CameraTourQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CameraTourQuery, CameraTourQueryVariables>(CameraTourDocument, options);
        }
export type CameraTourQueryHookResult = ReturnType<typeof useCameraTourQuery>;
export type CameraTourLazyQueryHookResult = ReturnType<typeof useCameraTourLazyQuery>;
export type CameraTourSuspenseQueryHookResult = ReturnType<typeof useCameraTourSuspenseQuery>;
export type CameraTourQueryResult = Apollo.QueryResult<CameraTourQuery, CameraTourQueryVariables>;
export const UpdateCameraTourDocument = gql`
    mutation updateCameraTour($id: ID!, $input: CameraTourInput!) {
  updateCameraTour(id: $id, input: $input) {
    updated
  }
}
    `;
export type UpdateCameraTourMutationFn = Apollo.MutationFunction<UpdateCameraTourMutation, UpdateCameraTourMutationVariables>;

/**
 * __useUpdateCameraTourMutation__
 *
 * To run a mutation, you first call `useUpdateCameraTourMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCameraTourMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCameraTourMutation, { data, loading, error }] = useUpdateCameraTourMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCameraTourMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCameraTourMutation, UpdateCameraTourMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCameraTourMutation, UpdateCameraTourMutationVariables>(UpdateCameraTourDocument, options);
      }
export type UpdateCameraTourMutationHookResult = ReturnType<typeof useUpdateCameraTourMutation>;
export type UpdateCameraTourMutationResult = Apollo.MutationResult<UpdateCameraTourMutation>;
export type UpdateCameraTourMutationOptions = Apollo.BaseMutationOptions<UpdateCameraTourMutation, UpdateCameraTourMutationVariables>;
export const CreateCameraTourDocument = gql`
    mutation createCameraTour($input: CameraTourInput!) {
  createCameraTour(input: $input) {
    id
  }
}
    `;
export type CreateCameraTourMutationFn = Apollo.MutationFunction<CreateCameraTourMutation, CreateCameraTourMutationVariables>;

/**
 * __useCreateCameraTourMutation__
 *
 * To run a mutation, you first call `useCreateCameraTourMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCameraTourMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCameraTourMutation, { data, loading, error }] = useCreateCameraTourMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCameraTourMutation(baseOptions?: Apollo.MutationHookOptions<CreateCameraTourMutation, CreateCameraTourMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCameraTourMutation, CreateCameraTourMutationVariables>(CreateCameraTourDocument, options);
      }
export type CreateCameraTourMutationHookResult = ReturnType<typeof useCreateCameraTourMutation>;
export type CreateCameraTourMutationResult = Apollo.MutationResult<CreateCameraTourMutation>;
export type CreateCameraTourMutationOptions = Apollo.BaseMutationOptions<CreateCameraTourMutation, CreateCameraTourMutationVariables>;
export const DeleteCameraTourDocument = gql`
    mutation deleteCameraTour($id: ID!) {
  deleteCameraTour(id: $id)
}
    `;
export type DeleteCameraTourMutationFn = Apollo.MutationFunction<DeleteCameraTourMutation, DeleteCameraTourMutationVariables>;

/**
 * __useDeleteCameraTourMutation__
 *
 * To run a mutation, you first call `useDeleteCameraTourMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCameraTourMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCameraTourMutation, { data, loading, error }] = useDeleteCameraTourMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCameraTourMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCameraTourMutation, DeleteCameraTourMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCameraTourMutation, DeleteCameraTourMutationVariables>(DeleteCameraTourDocument, options);
      }
export type DeleteCameraTourMutationHookResult = ReturnType<typeof useDeleteCameraTourMutation>;
export type DeleteCameraTourMutationResult = Apollo.MutationResult<DeleteCameraTourMutation>;
export type DeleteCameraTourMutationOptions = Apollo.BaseMutationOptions<DeleteCameraTourMutation, DeleteCameraTourMutationVariables>;
export const CurrentRealmDocument = gql`
    query currentRealm {
  currentRealm {
    id
    sharedViews
  }
}
    `;

/**
 * __useCurrentRealmQuery__
 *
 * To run a query within a React component, call `useCurrentRealmQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentRealmQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentRealmQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentRealmQuery(baseOptions?: Apollo.QueryHookOptions<CurrentRealmQuery, CurrentRealmQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentRealmQuery, CurrentRealmQueryVariables>(CurrentRealmDocument, options);
      }
export function useCurrentRealmLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentRealmQuery, CurrentRealmQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentRealmQuery, CurrentRealmQueryVariables>(CurrentRealmDocument, options);
        }
// @ts-ignore
export function useCurrentRealmSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CurrentRealmQuery, CurrentRealmQueryVariables>): Apollo.UseSuspenseQueryResult<CurrentRealmQuery, CurrentRealmQueryVariables>;
export function useCurrentRealmSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentRealmQuery, CurrentRealmQueryVariables>): Apollo.UseSuspenseQueryResult<CurrentRealmQuery | undefined, CurrentRealmQueryVariables>;
export function useCurrentRealmSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentRealmQuery, CurrentRealmQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentRealmQuery, CurrentRealmQueryVariables>(CurrentRealmDocument, options);
        }
export type CurrentRealmQueryHookResult = ReturnType<typeof useCurrentRealmQuery>;
export type CurrentRealmLazyQueryHookResult = ReturnType<typeof useCurrentRealmLazyQuery>;
export type CurrentRealmSuspenseQueryHookResult = ReturnType<typeof useCurrentRealmSuspenseQuery>;
export type CurrentRealmQueryResult = Apollo.QueryResult<CurrentRealmQuery, CurrentRealmQueryVariables>;
export const SharedViewsUpdateDocument = gql`
    subscription sharedViewsUpdate {
  sharedViewsUpdate {
    sharedViews
  }
}
    `;

/**
 * __useSharedViewsUpdateSubscription__
 *
 * To run a query within a React component, call `useSharedViewsUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSharedViewsUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSharedViewsUpdateSubscription({
 *   variables: {
 *   },
 * });
 */
export function useSharedViewsUpdateSubscription(baseOptions?: Apollo.SubscriptionHookOptions<SharedViewsUpdateSubscription, SharedViewsUpdateSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SharedViewsUpdateSubscription, SharedViewsUpdateSubscriptionVariables>(SharedViewsUpdateDocument, options);
      }
export type SharedViewsUpdateSubscriptionHookResult = ReturnType<typeof useSharedViewsUpdateSubscription>;
export type SharedViewsUpdateSubscriptionResult = Apollo.SubscriptionResult<SharedViewsUpdateSubscription>;
export const SessionCloseDocument = gql`
    subscription sessionClose {
  sessionClose {
    sessionId
    reason
  }
}
    `;

/**
 * __useSessionCloseSubscription__
 *
 * To run a query within a React component, call `useSessionCloseSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSessionCloseSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSessionCloseSubscription({
 *   variables: {
 *   },
 * });
 */
export function useSessionCloseSubscription(baseOptions?: Apollo.SubscriptionHookOptions<SessionCloseSubscription, SessionCloseSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SessionCloseSubscription, SessionCloseSubscriptionVariables>(SessionCloseDocument, options);
      }
export type SessionCloseSubscriptionHookResult = ReturnType<typeof useSessionCloseSubscription>;
export type SessionCloseSubscriptionResult = Apollo.SubscriptionResult<SessionCloseSubscription>;
export const DeviceVaeManagementDocument = gql`
    query deviceVaeManagement($id: ID!) {
  device(id: $id) {
    ...deviceVaeManagementFields
  }
}
    ${DeviceVaeManagementFieldsFragmentDoc}`;

/**
 * __useDeviceVaeManagementQuery__
 *
 * To run a query within a React component, call `useDeviceVaeManagementQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeviceVaeManagementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeviceVaeManagementQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeviceVaeManagementQuery(baseOptions: Apollo.QueryHookOptions<DeviceVaeManagementQuery, DeviceVaeManagementQueryVariables> & ({ variables: DeviceVaeManagementQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DeviceVaeManagementQuery, DeviceVaeManagementQueryVariables>(DeviceVaeManagementDocument, options);
      }
export function useDeviceVaeManagementLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DeviceVaeManagementQuery, DeviceVaeManagementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DeviceVaeManagementQuery, DeviceVaeManagementQueryVariables>(DeviceVaeManagementDocument, options);
        }
// @ts-ignore
export function useDeviceVaeManagementSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DeviceVaeManagementQuery, DeviceVaeManagementQueryVariables>): Apollo.UseSuspenseQueryResult<DeviceVaeManagementQuery, DeviceVaeManagementQueryVariables>;
export function useDeviceVaeManagementSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DeviceVaeManagementQuery, DeviceVaeManagementQueryVariables>): Apollo.UseSuspenseQueryResult<DeviceVaeManagementQuery | undefined, DeviceVaeManagementQueryVariables>;
export function useDeviceVaeManagementSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DeviceVaeManagementQuery, DeviceVaeManagementQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DeviceVaeManagementQuery, DeviceVaeManagementQueryVariables>(DeviceVaeManagementDocument, options);
        }
export type DeviceVaeManagementQueryHookResult = ReturnType<typeof useDeviceVaeManagementQuery>;
export type DeviceVaeManagementLazyQueryHookResult = ReturnType<typeof useDeviceVaeManagementLazyQuery>;
export type DeviceVaeManagementSuspenseQueryHookResult = ReturnType<typeof useDeviceVaeManagementSuspenseQuery>;
export type DeviceVaeManagementQueryResult = Apollo.QueryResult<DeviceVaeManagementQuery, DeviceVaeManagementQueryVariables>;
export const DeviceCacheByAspectTypesDocument = gql`
    query deviceCacheByAspectTypes($types: [DeviceFunctionalAspectFilter!]!) {
  devicesByAspectTypes(types: $types) {
    ...deviceCacheFields
  }
}
    ${DeviceCacheFieldsFragmentDoc}`;

/**
 * __useDeviceCacheByAspectTypesQuery__
 *
 * To run a query within a React component, call `useDeviceCacheByAspectTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeviceCacheByAspectTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeviceCacheByAspectTypesQuery({
 *   variables: {
 *      types: // value for 'types'
 *   },
 * });
 */
export function useDeviceCacheByAspectTypesQuery(baseOptions: Apollo.QueryHookOptions<DeviceCacheByAspectTypesQuery, DeviceCacheByAspectTypesQueryVariables> & ({ variables: DeviceCacheByAspectTypesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DeviceCacheByAspectTypesQuery, DeviceCacheByAspectTypesQueryVariables>(DeviceCacheByAspectTypesDocument, options);
      }
export function useDeviceCacheByAspectTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DeviceCacheByAspectTypesQuery, DeviceCacheByAspectTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DeviceCacheByAspectTypesQuery, DeviceCacheByAspectTypesQueryVariables>(DeviceCacheByAspectTypesDocument, options);
        }
// @ts-ignore
export function useDeviceCacheByAspectTypesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DeviceCacheByAspectTypesQuery, DeviceCacheByAspectTypesQueryVariables>): Apollo.UseSuspenseQueryResult<DeviceCacheByAspectTypesQuery, DeviceCacheByAspectTypesQueryVariables>;
export function useDeviceCacheByAspectTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DeviceCacheByAspectTypesQuery, DeviceCacheByAspectTypesQueryVariables>): Apollo.UseSuspenseQueryResult<DeviceCacheByAspectTypesQuery | undefined, DeviceCacheByAspectTypesQueryVariables>;
export function useDeviceCacheByAspectTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DeviceCacheByAspectTypesQuery, DeviceCacheByAspectTypesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DeviceCacheByAspectTypesQuery, DeviceCacheByAspectTypesQueryVariables>(DeviceCacheByAspectTypesDocument, options);
        }
export type DeviceCacheByAspectTypesQueryHookResult = ReturnType<typeof useDeviceCacheByAspectTypesQuery>;
export type DeviceCacheByAspectTypesLazyQueryHookResult = ReturnType<typeof useDeviceCacheByAspectTypesLazyQuery>;
export type DeviceCacheByAspectTypesSuspenseQueryHookResult = ReturnType<typeof useDeviceCacheByAspectTypesSuspenseQuery>;
export type DeviceCacheByAspectTypesQueryResult = Apollo.QueryResult<DeviceCacheByAspectTypesQuery, DeviceCacheByAspectTypesQueryVariables>;
export const AdminCameraListByAspectTypesDocument = gql`
    query adminCameraListByAspectTypes($types: [DeviceFunctionalAspectFilter!]!) {
  devicesByAspectTypes(types: $types) {
    ...adminCameraFields
  }
}
    ${AdminCameraFieldsFragmentDoc}`;

/**
 * __useAdminCameraListByAspectTypesQuery__
 *
 * To run a query within a React component, call `useAdminCameraListByAspectTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminCameraListByAspectTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminCameraListByAspectTypesQuery({
 *   variables: {
 *      types: // value for 'types'
 *   },
 * });
 */
export function useAdminCameraListByAspectTypesQuery(baseOptions: Apollo.QueryHookOptions<AdminCameraListByAspectTypesQuery, AdminCameraListByAspectTypesQueryVariables> & ({ variables: AdminCameraListByAspectTypesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminCameraListByAspectTypesQuery, AdminCameraListByAspectTypesQueryVariables>(AdminCameraListByAspectTypesDocument, options);
      }
export function useAdminCameraListByAspectTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminCameraListByAspectTypesQuery, AdminCameraListByAspectTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminCameraListByAspectTypesQuery, AdminCameraListByAspectTypesQueryVariables>(AdminCameraListByAspectTypesDocument, options);
        }
// @ts-ignore
export function useAdminCameraListByAspectTypesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AdminCameraListByAspectTypesQuery, AdminCameraListByAspectTypesQueryVariables>): Apollo.UseSuspenseQueryResult<AdminCameraListByAspectTypesQuery, AdminCameraListByAspectTypesQueryVariables>;
export function useAdminCameraListByAspectTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminCameraListByAspectTypesQuery, AdminCameraListByAspectTypesQueryVariables>): Apollo.UseSuspenseQueryResult<AdminCameraListByAspectTypesQuery | undefined, AdminCameraListByAspectTypesQueryVariables>;
export function useAdminCameraListByAspectTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminCameraListByAspectTypesQuery, AdminCameraListByAspectTypesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminCameraListByAspectTypesQuery, AdminCameraListByAspectTypesQueryVariables>(AdminCameraListByAspectTypesDocument, options);
        }
export type AdminCameraListByAspectTypesQueryHookResult = ReturnType<typeof useAdminCameraListByAspectTypesQuery>;
export type AdminCameraListByAspectTypesLazyQueryHookResult = ReturnType<typeof useAdminCameraListByAspectTypesLazyQuery>;
export type AdminCameraListByAspectTypesSuspenseQueryHookResult = ReturnType<typeof useAdminCameraListByAspectTypesSuspenseQuery>;
export type AdminCameraListByAspectTypesQueryResult = Apollo.QueryResult<AdminCameraListByAspectTypesQuery, AdminCameraListByAspectTypesQueryVariables>;
export const GetDeviceSharedStreamDocument = gql`
    query getDeviceSharedStream($id: ID!) {
  device(id: $id) {
    sharedStream {
      ...sharedStreamFields
    }
  }
}
    ${SharedStreamFieldsFragmentDoc}`;

/**
 * __useGetDeviceSharedStreamQuery__
 *
 * To run a query within a React component, call `useGetDeviceSharedStreamQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeviceSharedStreamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDeviceSharedStreamQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetDeviceSharedStreamQuery(baseOptions: Apollo.QueryHookOptions<GetDeviceSharedStreamQuery, GetDeviceSharedStreamQueryVariables> & ({ variables: GetDeviceSharedStreamQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDeviceSharedStreamQuery, GetDeviceSharedStreamQueryVariables>(GetDeviceSharedStreamDocument, options);
      }
export function useGetDeviceSharedStreamLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDeviceSharedStreamQuery, GetDeviceSharedStreamQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDeviceSharedStreamQuery, GetDeviceSharedStreamQueryVariables>(GetDeviceSharedStreamDocument, options);
        }
// @ts-ignore
export function useGetDeviceSharedStreamSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDeviceSharedStreamQuery, GetDeviceSharedStreamQueryVariables>): Apollo.UseSuspenseQueryResult<GetDeviceSharedStreamQuery, GetDeviceSharedStreamQueryVariables>;
export function useGetDeviceSharedStreamSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDeviceSharedStreamQuery, GetDeviceSharedStreamQueryVariables>): Apollo.UseSuspenseQueryResult<GetDeviceSharedStreamQuery | undefined, GetDeviceSharedStreamQueryVariables>;
export function useGetDeviceSharedStreamSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDeviceSharedStreamQuery, GetDeviceSharedStreamQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDeviceSharedStreamQuery, GetDeviceSharedStreamQueryVariables>(GetDeviceSharedStreamDocument, options);
        }
export type GetDeviceSharedStreamQueryHookResult = ReturnType<typeof useGetDeviceSharedStreamQuery>;
export type GetDeviceSharedStreamLazyQueryHookResult = ReturnType<typeof useGetDeviceSharedStreamLazyQuery>;
export type GetDeviceSharedStreamSuspenseQueryHookResult = ReturnType<typeof useGetDeviceSharedStreamSuspenseQuery>;
export type GetDeviceSharedStreamQueryResult = Apollo.QueryResult<GetDeviceSharedStreamQuery, GetDeviceSharedStreamQueryVariables>;
export const GetLocalStorageConfigDocument = gql`
    query getLocalStorageConfig($deviceId: ID!) {
  localStorage(deviceId: $deviceId) {
    ...localStorageFields
  }
}
    ${LocalStorageFieldsFragmentDoc}`;

/**
 * __useGetLocalStorageConfigQuery__
 *
 * To run a query within a React component, call `useGetLocalStorageConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocalStorageConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocalStorageConfigQuery({
 *   variables: {
 *      deviceId: // value for 'deviceId'
 *   },
 * });
 */
export function useGetLocalStorageConfigQuery(baseOptions: Apollo.QueryHookOptions<GetLocalStorageConfigQuery, GetLocalStorageConfigQueryVariables> & ({ variables: GetLocalStorageConfigQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocalStorageConfigQuery, GetLocalStorageConfigQueryVariables>(GetLocalStorageConfigDocument, options);
      }
export function useGetLocalStorageConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocalStorageConfigQuery, GetLocalStorageConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocalStorageConfigQuery, GetLocalStorageConfigQueryVariables>(GetLocalStorageConfigDocument, options);
        }
// @ts-ignore
export function useGetLocalStorageConfigSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLocalStorageConfigQuery, GetLocalStorageConfigQueryVariables>): Apollo.UseSuspenseQueryResult<GetLocalStorageConfigQuery, GetLocalStorageConfigQueryVariables>;
export function useGetLocalStorageConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLocalStorageConfigQuery, GetLocalStorageConfigQueryVariables>): Apollo.UseSuspenseQueryResult<GetLocalStorageConfigQuery | undefined, GetLocalStorageConfigQueryVariables>;
export function useGetLocalStorageConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLocalStorageConfigQuery, GetLocalStorageConfigQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLocalStorageConfigQuery, GetLocalStorageConfigQueryVariables>(GetLocalStorageConfigDocument, options);
        }
export type GetLocalStorageConfigQueryHookResult = ReturnType<typeof useGetLocalStorageConfigQuery>;
export type GetLocalStorageConfigLazyQueryHookResult = ReturnType<typeof useGetLocalStorageConfigLazyQuery>;
export type GetLocalStorageConfigSuspenseQueryHookResult = ReturnType<typeof useGetLocalStorageConfigSuspenseQuery>;
export type GetLocalStorageConfigQueryResult = Apollo.QueryResult<GetLocalStorageConfigQuery, GetLocalStorageConfigQueryVariables>;
export const DeviceStatusDocument = gql`
    query deviceStatus($id: ID!) {
  device(id: $id) {
    ...deviceListFields
  }
}
    ${DeviceListFieldsFragmentDoc}`;

/**
 * __useDeviceStatusQuery__
 *
 * To run a query within a React component, call `useDeviceStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeviceStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeviceStatusQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeviceStatusQuery(baseOptions: Apollo.QueryHookOptions<DeviceStatusQuery, DeviceStatusQueryVariables> & ({ variables: DeviceStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DeviceStatusQuery, DeviceStatusQueryVariables>(DeviceStatusDocument, options);
      }
export function useDeviceStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DeviceStatusQuery, DeviceStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DeviceStatusQuery, DeviceStatusQueryVariables>(DeviceStatusDocument, options);
        }
// @ts-ignore
export function useDeviceStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DeviceStatusQuery, DeviceStatusQueryVariables>): Apollo.UseSuspenseQueryResult<DeviceStatusQuery, DeviceStatusQueryVariables>;
export function useDeviceStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DeviceStatusQuery, DeviceStatusQueryVariables>): Apollo.UseSuspenseQueryResult<DeviceStatusQuery | undefined, DeviceStatusQueryVariables>;
export function useDeviceStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DeviceStatusQuery, DeviceStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DeviceStatusQuery, DeviceStatusQueryVariables>(DeviceStatusDocument, options);
        }
export type DeviceStatusQueryHookResult = ReturnType<typeof useDeviceStatusQuery>;
export type DeviceStatusLazyQueryHookResult = ReturnType<typeof useDeviceStatusLazyQuery>;
export type DeviceStatusSuspenseQueryHookResult = ReturnType<typeof useDeviceStatusSuspenseQuery>;
export type DeviceStatusQueryResult = Apollo.QueryResult<DeviceStatusQuery, DeviceStatusQueryVariables>;
export const DeviceListByAspectTypesDocument = gql`
    query deviceListByAspectTypes($types: [DeviceFunctionalAspectFilter!]!) {
  devicesByAspectTypes(types: $types) {
    ...deviceListFields
  }
}
    ${DeviceListFieldsFragmentDoc}`;

/**
 * __useDeviceListByAspectTypesQuery__
 *
 * To run a query within a React component, call `useDeviceListByAspectTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeviceListByAspectTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeviceListByAspectTypesQuery({
 *   variables: {
 *      types: // value for 'types'
 *   },
 * });
 */
export function useDeviceListByAspectTypesQuery(baseOptions: Apollo.QueryHookOptions<DeviceListByAspectTypesQuery, DeviceListByAspectTypesQueryVariables> & ({ variables: DeviceListByAspectTypesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DeviceListByAspectTypesQuery, DeviceListByAspectTypesQueryVariables>(DeviceListByAspectTypesDocument, options);
      }
export function useDeviceListByAspectTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DeviceListByAspectTypesQuery, DeviceListByAspectTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DeviceListByAspectTypesQuery, DeviceListByAspectTypesQueryVariables>(DeviceListByAspectTypesDocument, options);
        }
// @ts-ignore
export function useDeviceListByAspectTypesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DeviceListByAspectTypesQuery, DeviceListByAspectTypesQueryVariables>): Apollo.UseSuspenseQueryResult<DeviceListByAspectTypesQuery, DeviceListByAspectTypesQueryVariables>;
export function useDeviceListByAspectTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DeviceListByAspectTypesQuery, DeviceListByAspectTypesQueryVariables>): Apollo.UseSuspenseQueryResult<DeviceListByAspectTypesQuery | undefined, DeviceListByAspectTypesQueryVariables>;
export function useDeviceListByAspectTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DeviceListByAspectTypesQuery, DeviceListByAspectTypesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DeviceListByAspectTypesQuery, DeviceListByAspectTypesQueryVariables>(DeviceListByAspectTypesDocument, options);
        }
export type DeviceListByAspectTypesQueryHookResult = ReturnType<typeof useDeviceListByAspectTypesQuery>;
export type DeviceListByAspectTypesLazyQueryHookResult = ReturnType<typeof useDeviceListByAspectTypesLazyQuery>;
export type DeviceListByAspectTypesSuspenseQueryHookResult = ReturnType<typeof useDeviceListByAspectTypesSuspenseQuery>;
export type DeviceListByAspectTypesQueryResult = Apollo.QueryResult<DeviceListByAspectTypesQuery, DeviceListByAspectTypesQueryVariables>;
export const DevicesByAspectTypesDocument = gql`
    query devicesByAspectTypes($types: [DeviceFunctionalAspectFilter!]!) {
  devicesByAspectTypes(types: $types) {
    ...deviceFields
  }
}
    ${DeviceFieldsFragmentDoc}`;

/**
 * __useDevicesByAspectTypesQuery__
 *
 * To run a query within a React component, call `useDevicesByAspectTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDevicesByAspectTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDevicesByAspectTypesQuery({
 *   variables: {
 *      types: // value for 'types'
 *   },
 * });
 */
export function useDevicesByAspectTypesQuery(baseOptions: Apollo.QueryHookOptions<DevicesByAspectTypesQuery, DevicesByAspectTypesQueryVariables> & ({ variables: DevicesByAspectTypesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DevicesByAspectTypesQuery, DevicesByAspectTypesQueryVariables>(DevicesByAspectTypesDocument, options);
      }
export function useDevicesByAspectTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DevicesByAspectTypesQuery, DevicesByAspectTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DevicesByAspectTypesQuery, DevicesByAspectTypesQueryVariables>(DevicesByAspectTypesDocument, options);
        }
// @ts-ignore
export function useDevicesByAspectTypesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DevicesByAspectTypesQuery, DevicesByAspectTypesQueryVariables>): Apollo.UseSuspenseQueryResult<DevicesByAspectTypesQuery, DevicesByAspectTypesQueryVariables>;
export function useDevicesByAspectTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DevicesByAspectTypesQuery, DevicesByAspectTypesQueryVariables>): Apollo.UseSuspenseQueryResult<DevicesByAspectTypesQuery | undefined, DevicesByAspectTypesQueryVariables>;
export function useDevicesByAspectTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DevicesByAspectTypesQuery, DevicesByAspectTypesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DevicesByAspectTypesQuery, DevicesByAspectTypesQueryVariables>(DevicesByAspectTypesDocument, options);
        }
export type DevicesByAspectTypesQueryHookResult = ReturnType<typeof useDevicesByAspectTypesQuery>;
export type DevicesByAspectTypesLazyQueryHookResult = ReturnType<typeof useDevicesByAspectTypesLazyQuery>;
export type DevicesByAspectTypesSuspenseQueryHookResult = ReturnType<typeof useDevicesByAspectTypesSuspenseQuery>;
export type DevicesByAspectTypesQueryResult = Apollo.QueryResult<DevicesByAspectTypesQuery, DevicesByAspectTypesQueryVariables>;
export const DevicesByAspectTypesGeoDocument = gql`
    query devicesByAspectTypesGeo($types: [DeviceFunctionalAspectFilter!]!) {
  devicesByAspectTypes(types: $types) {
    ...deviceGeoFields
  }
}
    ${DeviceGeoFieldsFragmentDoc}`;

/**
 * __useDevicesByAspectTypesGeoQuery__
 *
 * To run a query within a React component, call `useDevicesByAspectTypesGeoQuery` and pass it any options that fit your needs.
 * When your component renders, `useDevicesByAspectTypesGeoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDevicesByAspectTypesGeoQuery({
 *   variables: {
 *      types: // value for 'types'
 *   },
 * });
 */
export function useDevicesByAspectTypesGeoQuery(baseOptions: Apollo.QueryHookOptions<DevicesByAspectTypesGeoQuery, DevicesByAspectTypesGeoQueryVariables> & ({ variables: DevicesByAspectTypesGeoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DevicesByAspectTypesGeoQuery, DevicesByAspectTypesGeoQueryVariables>(DevicesByAspectTypesGeoDocument, options);
      }
export function useDevicesByAspectTypesGeoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DevicesByAspectTypesGeoQuery, DevicesByAspectTypesGeoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DevicesByAspectTypesGeoQuery, DevicesByAspectTypesGeoQueryVariables>(DevicesByAspectTypesGeoDocument, options);
        }
// @ts-ignore
export function useDevicesByAspectTypesGeoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DevicesByAspectTypesGeoQuery, DevicesByAspectTypesGeoQueryVariables>): Apollo.UseSuspenseQueryResult<DevicesByAspectTypesGeoQuery, DevicesByAspectTypesGeoQueryVariables>;
export function useDevicesByAspectTypesGeoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DevicesByAspectTypesGeoQuery, DevicesByAspectTypesGeoQueryVariables>): Apollo.UseSuspenseQueryResult<DevicesByAspectTypesGeoQuery | undefined, DevicesByAspectTypesGeoQueryVariables>;
export function useDevicesByAspectTypesGeoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DevicesByAspectTypesGeoQuery, DevicesByAspectTypesGeoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DevicesByAspectTypesGeoQuery, DevicesByAspectTypesGeoQueryVariables>(DevicesByAspectTypesGeoDocument, options);
        }
export type DevicesByAspectTypesGeoQueryHookResult = ReturnType<typeof useDevicesByAspectTypesGeoQuery>;
export type DevicesByAspectTypesGeoLazyQueryHookResult = ReturnType<typeof useDevicesByAspectTypesGeoLazyQuery>;
export type DevicesByAspectTypesGeoSuspenseQueryHookResult = ReturnType<typeof useDevicesByAspectTypesGeoSuspenseQuery>;
export type DevicesByAspectTypesGeoQueryResult = Apollo.QueryResult<DevicesByAspectTypesGeoQuery, DevicesByAspectTypesGeoQueryVariables>;
export const DevicesByAspectTypesReportDocument = gql`
    query devicesByAspectTypesReport($types: [DeviceFunctionalAspectFilter!]!) {
  devicesByAspectTypes(types: $types) {
    ...deviceReportFields
  }
}
    ${DeviceReportFieldsFragmentDoc}`;

/**
 * __useDevicesByAspectTypesReportQuery__
 *
 * To run a query within a React component, call `useDevicesByAspectTypesReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useDevicesByAspectTypesReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDevicesByAspectTypesReportQuery({
 *   variables: {
 *      types: // value for 'types'
 *   },
 * });
 */
export function useDevicesByAspectTypesReportQuery(baseOptions: Apollo.QueryHookOptions<DevicesByAspectTypesReportQuery, DevicesByAspectTypesReportQueryVariables> & ({ variables: DevicesByAspectTypesReportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DevicesByAspectTypesReportQuery, DevicesByAspectTypesReportQueryVariables>(DevicesByAspectTypesReportDocument, options);
      }
export function useDevicesByAspectTypesReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DevicesByAspectTypesReportQuery, DevicesByAspectTypesReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DevicesByAspectTypesReportQuery, DevicesByAspectTypesReportQueryVariables>(DevicesByAspectTypesReportDocument, options);
        }
// @ts-ignore
export function useDevicesByAspectTypesReportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DevicesByAspectTypesReportQuery, DevicesByAspectTypesReportQueryVariables>): Apollo.UseSuspenseQueryResult<DevicesByAspectTypesReportQuery, DevicesByAspectTypesReportQueryVariables>;
export function useDevicesByAspectTypesReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DevicesByAspectTypesReportQuery, DevicesByAspectTypesReportQueryVariables>): Apollo.UseSuspenseQueryResult<DevicesByAspectTypesReportQuery | undefined, DevicesByAspectTypesReportQueryVariables>;
export function useDevicesByAspectTypesReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DevicesByAspectTypesReportQuery, DevicesByAspectTypesReportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DevicesByAspectTypesReportQuery, DevicesByAspectTypesReportQueryVariables>(DevicesByAspectTypesReportDocument, options);
        }
export type DevicesByAspectTypesReportQueryHookResult = ReturnType<typeof useDevicesByAspectTypesReportQuery>;
export type DevicesByAspectTypesReportLazyQueryHookResult = ReturnType<typeof useDevicesByAspectTypesReportLazyQuery>;
export type DevicesByAspectTypesReportSuspenseQueryHookResult = ReturnType<typeof useDevicesByAspectTypesReportSuspenseQuery>;
export type DevicesByAspectTypesReportQueryResult = Apollo.QueryResult<DevicesByAspectTypesReportQuery, DevicesByAspectTypesReportQueryVariables>;
export const CameraViewDevicesDocument = gql`
    query cameraViewDevices($types: [DeviceFunctionalAspectFilter!]!) {
  devicesByAspectTypes(types: $types) {
    id
    cameraView {
      northOffsetAngle
      fieldOfView
      viewDistance
      ptzStatus {
        lock {
          userId
          category
          expire
          explicit
          userName
        }
        position {
          hfov
          pan
          tilt
        }
      }
      ptzLockProlongation {
        userId
        token
        createdAt
      }
    }
  }
}
    `;

/**
 * __useCameraViewDevicesQuery__
 *
 * To run a query within a React component, call `useCameraViewDevicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCameraViewDevicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCameraViewDevicesQuery({
 *   variables: {
 *      types: // value for 'types'
 *   },
 * });
 */
export function useCameraViewDevicesQuery(baseOptions: Apollo.QueryHookOptions<CameraViewDevicesQuery, CameraViewDevicesQueryVariables> & ({ variables: CameraViewDevicesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CameraViewDevicesQuery, CameraViewDevicesQueryVariables>(CameraViewDevicesDocument, options);
      }
export function useCameraViewDevicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CameraViewDevicesQuery, CameraViewDevicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CameraViewDevicesQuery, CameraViewDevicesQueryVariables>(CameraViewDevicesDocument, options);
        }
// @ts-ignore
export function useCameraViewDevicesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CameraViewDevicesQuery, CameraViewDevicesQueryVariables>): Apollo.UseSuspenseQueryResult<CameraViewDevicesQuery, CameraViewDevicesQueryVariables>;
export function useCameraViewDevicesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CameraViewDevicesQuery, CameraViewDevicesQueryVariables>): Apollo.UseSuspenseQueryResult<CameraViewDevicesQuery | undefined, CameraViewDevicesQueryVariables>;
export function useCameraViewDevicesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CameraViewDevicesQuery, CameraViewDevicesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CameraViewDevicesQuery, CameraViewDevicesQueryVariables>(CameraViewDevicesDocument, options);
        }
export type CameraViewDevicesQueryHookResult = ReturnType<typeof useCameraViewDevicesQuery>;
export type CameraViewDevicesLazyQueryHookResult = ReturnType<typeof useCameraViewDevicesLazyQuery>;
export type CameraViewDevicesSuspenseQueryHookResult = ReturnType<typeof useCameraViewDevicesSuspenseQuery>;
export type CameraViewDevicesQueryResult = Apollo.QueryResult<CameraViewDevicesQuery, CameraViewDevicesQueryVariables>;
export const GeoDevicesDocument = gql`
    query geoDevices($types: [DeviceFunctionalAspectFilter!]!) {
  devicesByAspectTypes(types: $types) {
    id
    name
    deviceType
    enabled
    healthStatus
    position {
      lat
      lng
      alt
    }
    geoZone
    alarmPointPosition {
      lat
      lng
      alt
    }
    cameraView {
      northOffsetAngle
      fieldOfView
      viewDistance
      ptzStatus {
        ...ptzStatusFields
      }
      ptzLockProlongation {
        userId
        token
        createdAt
      }
    }
    aspects {
      enabled
      ... on DFA_Sensor {
        category
        associatedDevices
      }
    }
  }
}
    ${PtzStatusFieldsFragmentDoc}`;

/**
 * __useGeoDevicesQuery__
 *
 * To run a query within a React component, call `useGeoDevicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGeoDevicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGeoDevicesQuery({
 *   variables: {
 *      types: // value for 'types'
 *   },
 * });
 */
export function useGeoDevicesQuery(baseOptions: Apollo.QueryHookOptions<GeoDevicesQuery, GeoDevicesQueryVariables> & ({ variables: GeoDevicesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GeoDevicesQuery, GeoDevicesQueryVariables>(GeoDevicesDocument, options);
      }
export function useGeoDevicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GeoDevicesQuery, GeoDevicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GeoDevicesQuery, GeoDevicesQueryVariables>(GeoDevicesDocument, options);
        }
// @ts-ignore
export function useGeoDevicesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GeoDevicesQuery, GeoDevicesQueryVariables>): Apollo.UseSuspenseQueryResult<GeoDevicesQuery, GeoDevicesQueryVariables>;
export function useGeoDevicesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GeoDevicesQuery, GeoDevicesQueryVariables>): Apollo.UseSuspenseQueryResult<GeoDevicesQuery | undefined, GeoDevicesQueryVariables>;
export function useGeoDevicesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GeoDevicesQuery, GeoDevicesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GeoDevicesQuery, GeoDevicesQueryVariables>(GeoDevicesDocument, options);
        }
export type GeoDevicesQueryHookResult = ReturnType<typeof useGeoDevicesQuery>;
export type GeoDevicesLazyQueryHookResult = ReturnType<typeof useGeoDevicesLazyQuery>;
export type GeoDevicesSuspenseQueryHookResult = ReturnType<typeof useGeoDevicesSuspenseQuery>;
export type GeoDevicesQueryResult = Apollo.QueryResult<GeoDevicesQuery, GeoDevicesQueryVariables>;
export const DeviceVaeDocument = gql`
    query deviceVae($id: ID!) {
  device(id: $id) {
    id
    name
    aspects {
      template {
        name
      }
      type
      enabled
      ... on DFA_VAE {
        ...vaeAspectFields
      }
    }
  }
}
    ${VaeAspectFieldsFragmentDoc}`;

/**
 * __useDeviceVaeQuery__
 *
 * To run a query within a React component, call `useDeviceVaeQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeviceVaeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeviceVaeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeviceVaeQuery(baseOptions: Apollo.QueryHookOptions<DeviceVaeQuery, DeviceVaeQueryVariables> & ({ variables: DeviceVaeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DeviceVaeQuery, DeviceVaeQueryVariables>(DeviceVaeDocument, options);
      }
export function useDeviceVaeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DeviceVaeQuery, DeviceVaeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DeviceVaeQuery, DeviceVaeQueryVariables>(DeviceVaeDocument, options);
        }
// @ts-ignore
export function useDeviceVaeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DeviceVaeQuery, DeviceVaeQueryVariables>): Apollo.UseSuspenseQueryResult<DeviceVaeQuery, DeviceVaeQueryVariables>;
export function useDeviceVaeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DeviceVaeQuery, DeviceVaeQueryVariables>): Apollo.UseSuspenseQueryResult<DeviceVaeQuery | undefined, DeviceVaeQueryVariables>;
export function useDeviceVaeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DeviceVaeQuery, DeviceVaeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DeviceVaeQuery, DeviceVaeQueryVariables>(DeviceVaeDocument, options);
        }
export type DeviceVaeQueryHookResult = ReturnType<typeof useDeviceVaeQuery>;
export type DeviceVaeLazyQueryHookResult = ReturnType<typeof useDeviceVaeLazyQuery>;
export type DeviceVaeSuspenseQueryHookResult = ReturnType<typeof useDeviceVaeSuspenseQuery>;
export type DeviceVaeQueryResult = Apollo.QueryResult<DeviceVaeQuery, DeviceVaeQueryVariables>;
export const SensorListByAspectTypeDocument = gql`
    query sensorListByAspectType($types: [DeviceFunctionalAspectFilter!]!) {
  devicesByAspectTypes(types: $types) {
    ...sensorListFields
  }
}
    ${SensorListFieldsFragmentDoc}`;

/**
 * __useSensorListByAspectTypeQuery__
 *
 * To run a query within a React component, call `useSensorListByAspectTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useSensorListByAspectTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSensorListByAspectTypeQuery({
 *   variables: {
 *      types: // value for 'types'
 *   },
 * });
 */
export function useSensorListByAspectTypeQuery(baseOptions: Apollo.QueryHookOptions<SensorListByAspectTypeQuery, SensorListByAspectTypeQueryVariables> & ({ variables: SensorListByAspectTypeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SensorListByAspectTypeQuery, SensorListByAspectTypeQueryVariables>(SensorListByAspectTypeDocument, options);
      }
export function useSensorListByAspectTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SensorListByAspectTypeQuery, SensorListByAspectTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SensorListByAspectTypeQuery, SensorListByAspectTypeQueryVariables>(SensorListByAspectTypeDocument, options);
        }
// @ts-ignore
export function useSensorListByAspectTypeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SensorListByAspectTypeQuery, SensorListByAspectTypeQueryVariables>): Apollo.UseSuspenseQueryResult<SensorListByAspectTypeQuery, SensorListByAspectTypeQueryVariables>;
export function useSensorListByAspectTypeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SensorListByAspectTypeQuery, SensorListByAspectTypeQueryVariables>): Apollo.UseSuspenseQueryResult<SensorListByAspectTypeQuery | undefined, SensorListByAspectTypeQueryVariables>;
export function useSensorListByAspectTypeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SensorListByAspectTypeQuery, SensorListByAspectTypeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SensorListByAspectTypeQuery, SensorListByAspectTypeQueryVariables>(SensorListByAspectTypeDocument, options);
        }
export type SensorListByAspectTypeQueryHookResult = ReturnType<typeof useSensorListByAspectTypeQuery>;
export type SensorListByAspectTypeLazyQueryHookResult = ReturnType<typeof useSensorListByAspectTypeLazyQuery>;
export type SensorListByAspectTypeSuspenseQueryHookResult = ReturnType<typeof useSensorListByAspectTypeSuspenseQuery>;
export type SensorListByAspectTypeQueryResult = Apollo.QueryResult<SensorListByAspectTypeQuery, SensorListByAspectTypeQueryVariables>;
export const GatewayListByAspectTypeDocument = gql`
    query gatewayListByAspectType($types: [DeviceFunctionalAspectFilter!]!) {
  devicesByAspectTypes(types: $types) {
    ...gatewayListFields
  }
}
    ${GatewayListFieldsFragmentDoc}`;

/**
 * __useGatewayListByAspectTypeQuery__
 *
 * To run a query within a React component, call `useGatewayListByAspectTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGatewayListByAspectTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGatewayListByAspectTypeQuery({
 *   variables: {
 *      types: // value for 'types'
 *   },
 * });
 */
export function useGatewayListByAspectTypeQuery(baseOptions: Apollo.QueryHookOptions<GatewayListByAspectTypeQuery, GatewayListByAspectTypeQueryVariables> & ({ variables: GatewayListByAspectTypeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GatewayListByAspectTypeQuery, GatewayListByAspectTypeQueryVariables>(GatewayListByAspectTypeDocument, options);
      }
export function useGatewayListByAspectTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GatewayListByAspectTypeQuery, GatewayListByAspectTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GatewayListByAspectTypeQuery, GatewayListByAspectTypeQueryVariables>(GatewayListByAspectTypeDocument, options);
        }
// @ts-ignore
export function useGatewayListByAspectTypeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GatewayListByAspectTypeQuery, GatewayListByAspectTypeQueryVariables>): Apollo.UseSuspenseQueryResult<GatewayListByAspectTypeQuery, GatewayListByAspectTypeQueryVariables>;
export function useGatewayListByAspectTypeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GatewayListByAspectTypeQuery, GatewayListByAspectTypeQueryVariables>): Apollo.UseSuspenseQueryResult<GatewayListByAspectTypeQuery | undefined, GatewayListByAspectTypeQueryVariables>;
export function useGatewayListByAspectTypeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GatewayListByAspectTypeQuery, GatewayListByAspectTypeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GatewayListByAspectTypeQuery, GatewayListByAspectTypeQueryVariables>(GatewayListByAspectTypeDocument, options);
        }
export type GatewayListByAspectTypeQueryHookResult = ReturnType<typeof useGatewayListByAspectTypeQuery>;
export type GatewayListByAspectTypeLazyQueryHookResult = ReturnType<typeof useGatewayListByAspectTypeLazyQuery>;
export type GatewayListByAspectTypeSuspenseQueryHookResult = ReturnType<typeof useGatewayListByAspectTypeSuspenseQuery>;
export type GatewayListByAspectTypeQueryResult = Apollo.QueryResult<GatewayListByAspectTypeQuery, GatewayListByAspectTypeQueryVariables>;
export const DeviceWitnessesByAspectTypeDocument = gql`
    query deviceWitnessesByAspectType($types: [DeviceFunctionalAspectFilter!]!) {
  devicesByAspectTypes(types: $types) {
    ...deviceWitnessFields
  }
}
    ${DeviceWitnessFieldsFragmentDoc}`;

/**
 * __useDeviceWitnessesByAspectTypeQuery__
 *
 * To run a query within a React component, call `useDeviceWitnessesByAspectTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeviceWitnessesByAspectTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeviceWitnessesByAspectTypeQuery({
 *   variables: {
 *      types: // value for 'types'
 *   },
 * });
 */
export function useDeviceWitnessesByAspectTypeQuery(baseOptions: Apollo.QueryHookOptions<DeviceWitnessesByAspectTypeQuery, DeviceWitnessesByAspectTypeQueryVariables> & ({ variables: DeviceWitnessesByAspectTypeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DeviceWitnessesByAspectTypeQuery, DeviceWitnessesByAspectTypeQueryVariables>(DeviceWitnessesByAspectTypeDocument, options);
      }
export function useDeviceWitnessesByAspectTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DeviceWitnessesByAspectTypeQuery, DeviceWitnessesByAspectTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DeviceWitnessesByAspectTypeQuery, DeviceWitnessesByAspectTypeQueryVariables>(DeviceWitnessesByAspectTypeDocument, options);
        }
// @ts-ignore
export function useDeviceWitnessesByAspectTypeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DeviceWitnessesByAspectTypeQuery, DeviceWitnessesByAspectTypeQueryVariables>): Apollo.UseSuspenseQueryResult<DeviceWitnessesByAspectTypeQuery, DeviceWitnessesByAspectTypeQueryVariables>;
export function useDeviceWitnessesByAspectTypeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DeviceWitnessesByAspectTypeQuery, DeviceWitnessesByAspectTypeQueryVariables>): Apollo.UseSuspenseQueryResult<DeviceWitnessesByAspectTypeQuery | undefined, DeviceWitnessesByAspectTypeQueryVariables>;
export function useDeviceWitnessesByAspectTypeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DeviceWitnessesByAspectTypeQuery, DeviceWitnessesByAspectTypeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DeviceWitnessesByAspectTypeQuery, DeviceWitnessesByAspectTypeQueryVariables>(DeviceWitnessesByAspectTypeDocument, options);
        }
export type DeviceWitnessesByAspectTypeQueryHookResult = ReturnType<typeof useDeviceWitnessesByAspectTypeQuery>;
export type DeviceWitnessesByAspectTypeLazyQueryHookResult = ReturnType<typeof useDeviceWitnessesByAspectTypeLazyQuery>;
export type DeviceWitnessesByAspectTypeSuspenseQueryHookResult = ReturnType<typeof useDeviceWitnessesByAspectTypeSuspenseQuery>;
export type DeviceWitnessesByAspectTypeQueryResult = Apollo.QueryResult<DeviceWitnessesByAspectTypeQuery, DeviceWitnessesByAspectTypeQueryVariables>;
export const DevicesByAspectTypesShortDocument = gql`
    query devicesByAspectTypesShort($types: [DeviceFunctionalAspectFilter!]!) {
  devicesByAspectTypes(types: $types) {
    ...deviceShortFields
  }
}
    ${DeviceShortFieldsFragmentDoc}`;

/**
 * __useDevicesByAspectTypesShortQuery__
 *
 * To run a query within a React component, call `useDevicesByAspectTypesShortQuery` and pass it any options that fit your needs.
 * When your component renders, `useDevicesByAspectTypesShortQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDevicesByAspectTypesShortQuery({
 *   variables: {
 *      types: // value for 'types'
 *   },
 * });
 */
export function useDevicesByAspectTypesShortQuery(baseOptions: Apollo.QueryHookOptions<DevicesByAspectTypesShortQuery, DevicesByAspectTypesShortQueryVariables> & ({ variables: DevicesByAspectTypesShortQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DevicesByAspectTypesShortQuery, DevicesByAspectTypesShortQueryVariables>(DevicesByAspectTypesShortDocument, options);
      }
export function useDevicesByAspectTypesShortLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DevicesByAspectTypesShortQuery, DevicesByAspectTypesShortQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DevicesByAspectTypesShortQuery, DevicesByAspectTypesShortQueryVariables>(DevicesByAspectTypesShortDocument, options);
        }
// @ts-ignore
export function useDevicesByAspectTypesShortSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DevicesByAspectTypesShortQuery, DevicesByAspectTypesShortQueryVariables>): Apollo.UseSuspenseQueryResult<DevicesByAspectTypesShortQuery, DevicesByAspectTypesShortQueryVariables>;
export function useDevicesByAspectTypesShortSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DevicesByAspectTypesShortQuery, DevicesByAspectTypesShortQueryVariables>): Apollo.UseSuspenseQueryResult<DevicesByAspectTypesShortQuery | undefined, DevicesByAspectTypesShortQueryVariables>;
export function useDevicesByAspectTypesShortSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DevicesByAspectTypesShortQuery, DevicesByAspectTypesShortQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DevicesByAspectTypesShortQuery, DevicesByAspectTypesShortQueryVariables>(DevicesByAspectTypesShortDocument, options);
        }
export type DevicesByAspectTypesShortQueryHookResult = ReturnType<typeof useDevicesByAspectTypesShortQuery>;
export type DevicesByAspectTypesShortLazyQueryHookResult = ReturnType<typeof useDevicesByAspectTypesShortLazyQuery>;
export type DevicesByAspectTypesShortSuspenseQueryHookResult = ReturnType<typeof useDevicesByAspectTypesShortSuspenseQuery>;
export type DevicesByAspectTypesShortQueryResult = Apollo.QueryResult<DevicesByAspectTypesShortQuery, DevicesByAspectTypesShortQueryVariables>;
export const DevicesByAspectTypesCameraViewDocument = gql`
    query devicesByAspectTypesCameraView($types: [DeviceFunctionalAspectFilter!]!) {
  devicesByAspectTypes(types: $types) {
    id
    name
    cameraView {
      fieldOfView
      northOffsetAngle
      viewDistance
      ptzStatus {
        ...ptzStatusFields
      }
      ptzLockProlongation {
        createdAt
        token
        userId
      }
    }
  }
}
    ${PtzStatusFieldsFragmentDoc}`;

/**
 * __useDevicesByAspectTypesCameraViewQuery__
 *
 * To run a query within a React component, call `useDevicesByAspectTypesCameraViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useDevicesByAspectTypesCameraViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDevicesByAspectTypesCameraViewQuery({
 *   variables: {
 *      types: // value for 'types'
 *   },
 * });
 */
export function useDevicesByAspectTypesCameraViewQuery(baseOptions: Apollo.QueryHookOptions<DevicesByAspectTypesCameraViewQuery, DevicesByAspectTypesCameraViewQueryVariables> & ({ variables: DevicesByAspectTypesCameraViewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DevicesByAspectTypesCameraViewQuery, DevicesByAspectTypesCameraViewQueryVariables>(DevicesByAspectTypesCameraViewDocument, options);
      }
export function useDevicesByAspectTypesCameraViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DevicesByAspectTypesCameraViewQuery, DevicesByAspectTypesCameraViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DevicesByAspectTypesCameraViewQuery, DevicesByAspectTypesCameraViewQueryVariables>(DevicesByAspectTypesCameraViewDocument, options);
        }
// @ts-ignore
export function useDevicesByAspectTypesCameraViewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DevicesByAspectTypesCameraViewQuery, DevicesByAspectTypesCameraViewQueryVariables>): Apollo.UseSuspenseQueryResult<DevicesByAspectTypesCameraViewQuery, DevicesByAspectTypesCameraViewQueryVariables>;
export function useDevicesByAspectTypesCameraViewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DevicesByAspectTypesCameraViewQuery, DevicesByAspectTypesCameraViewQueryVariables>): Apollo.UseSuspenseQueryResult<DevicesByAspectTypesCameraViewQuery | undefined, DevicesByAspectTypesCameraViewQueryVariables>;
export function useDevicesByAspectTypesCameraViewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DevicesByAspectTypesCameraViewQuery, DevicesByAspectTypesCameraViewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DevicesByAspectTypesCameraViewQuery, DevicesByAspectTypesCameraViewQueryVariables>(DevicesByAspectTypesCameraViewDocument, options);
        }
export type DevicesByAspectTypesCameraViewQueryHookResult = ReturnType<typeof useDevicesByAspectTypesCameraViewQuery>;
export type DevicesByAspectTypesCameraViewLazyQueryHookResult = ReturnType<typeof useDevicesByAspectTypesCameraViewLazyQuery>;
export type DevicesByAspectTypesCameraViewSuspenseQueryHookResult = ReturnType<typeof useDevicesByAspectTypesCameraViewSuspenseQuery>;
export type DevicesByAspectTypesCameraViewQueryResult = Apollo.QueryResult<DevicesByAspectTypesCameraViewQuery, DevicesByAspectTypesCameraViewQueryVariables>;
export const DeviceDocument = gql`
    query device($id: ID!) {
  device(id: $id) {
    ...deviceFields
  }
}
    ${DeviceFieldsFragmentDoc}`;

/**
 * __useDeviceQuery__
 *
 * To run a query within a React component, call `useDeviceQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeviceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeviceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeviceQuery(baseOptions: Apollo.QueryHookOptions<DeviceQuery, DeviceQueryVariables> & ({ variables: DeviceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DeviceQuery, DeviceQueryVariables>(DeviceDocument, options);
      }
export function useDeviceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DeviceQuery, DeviceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DeviceQuery, DeviceQueryVariables>(DeviceDocument, options);
        }
// @ts-ignore
export function useDeviceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DeviceQuery, DeviceQueryVariables>): Apollo.UseSuspenseQueryResult<DeviceQuery, DeviceQueryVariables>;
export function useDeviceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DeviceQuery, DeviceQueryVariables>): Apollo.UseSuspenseQueryResult<DeviceQuery | undefined, DeviceQueryVariables>;
export function useDeviceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DeviceQuery, DeviceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DeviceQuery, DeviceQueryVariables>(DeviceDocument, options);
        }
export type DeviceQueryHookResult = ReturnType<typeof useDeviceQuery>;
export type DeviceLazyQueryHookResult = ReturnType<typeof useDeviceLazyQuery>;
export type DeviceSuspenseQueryHookResult = ReturnType<typeof useDeviceSuspenseQuery>;
export type DeviceQueryResult = Apollo.QueryResult<DeviceQuery, DeviceQueryVariables>;
export const DeviceForPlayerDocument = gql`
    query deviceForPlayer($id: ID!) {
  device(id: $id) {
    ...devicePlayerFields
  }
}
    ${DevicePlayerFieldsFragmentDoc}`;

/**
 * __useDeviceForPlayerQuery__
 *
 * To run a query within a React component, call `useDeviceForPlayerQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeviceForPlayerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeviceForPlayerQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeviceForPlayerQuery(baseOptions: Apollo.QueryHookOptions<DeviceForPlayerQuery, DeviceForPlayerQueryVariables> & ({ variables: DeviceForPlayerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DeviceForPlayerQuery, DeviceForPlayerQueryVariables>(DeviceForPlayerDocument, options);
      }
export function useDeviceForPlayerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DeviceForPlayerQuery, DeviceForPlayerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DeviceForPlayerQuery, DeviceForPlayerQueryVariables>(DeviceForPlayerDocument, options);
        }
// @ts-ignore
export function useDeviceForPlayerSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DeviceForPlayerQuery, DeviceForPlayerQueryVariables>): Apollo.UseSuspenseQueryResult<DeviceForPlayerQuery, DeviceForPlayerQueryVariables>;
export function useDeviceForPlayerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DeviceForPlayerQuery, DeviceForPlayerQueryVariables>): Apollo.UseSuspenseQueryResult<DeviceForPlayerQuery | undefined, DeviceForPlayerQueryVariables>;
export function useDeviceForPlayerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DeviceForPlayerQuery, DeviceForPlayerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DeviceForPlayerQuery, DeviceForPlayerQueryVariables>(DeviceForPlayerDocument, options);
        }
export type DeviceForPlayerQueryHookResult = ReturnType<typeof useDeviceForPlayerQuery>;
export type DeviceForPlayerLazyQueryHookResult = ReturnType<typeof useDeviceForPlayerLazyQuery>;
export type DeviceForPlayerSuspenseQueryHookResult = ReturnType<typeof useDeviceForPlayerSuspenseQuery>;
export type DeviceForPlayerQueryResult = Apollo.QueryResult<DeviceForPlayerQuery, DeviceForPlayerQueryVariables>;
export const DevicesByIdsDocument = gql`
    query devicesByIds($ids: [ID!]!) {
  devicesByIds(ids: $ids) {
    ...deviceFields
  }
}
    ${DeviceFieldsFragmentDoc}`;

/**
 * __useDevicesByIdsQuery__
 *
 * To run a query within a React component, call `useDevicesByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDevicesByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDevicesByIdsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDevicesByIdsQuery(baseOptions: Apollo.QueryHookOptions<DevicesByIdsQuery, DevicesByIdsQueryVariables> & ({ variables: DevicesByIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DevicesByIdsQuery, DevicesByIdsQueryVariables>(DevicesByIdsDocument, options);
      }
export function useDevicesByIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DevicesByIdsQuery, DevicesByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DevicesByIdsQuery, DevicesByIdsQueryVariables>(DevicesByIdsDocument, options);
        }
// @ts-ignore
export function useDevicesByIdsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DevicesByIdsQuery, DevicesByIdsQueryVariables>): Apollo.UseSuspenseQueryResult<DevicesByIdsQuery, DevicesByIdsQueryVariables>;
export function useDevicesByIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DevicesByIdsQuery, DevicesByIdsQueryVariables>): Apollo.UseSuspenseQueryResult<DevicesByIdsQuery | undefined, DevicesByIdsQueryVariables>;
export function useDevicesByIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DevicesByIdsQuery, DevicesByIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DevicesByIdsQuery, DevicesByIdsQueryVariables>(DevicesByIdsDocument, options);
        }
export type DevicesByIdsQueryHookResult = ReturnType<typeof useDevicesByIdsQuery>;
export type DevicesByIdsLazyQueryHookResult = ReturnType<typeof useDevicesByIdsLazyQuery>;
export type DevicesByIdsSuspenseQueryHookResult = ReturnType<typeof useDevicesByIdsSuspenseQuery>;
export type DevicesByIdsQueryResult = Apollo.QueryResult<DevicesByIdsQuery, DevicesByIdsQueryVariables>;
export const DeviceNameDocument = gql`
    query deviceName($id: ID!) {
  device(id: $id) {
    id
    name
  }
}
    `;

/**
 * __useDeviceNameQuery__
 *
 * To run a query within a React component, call `useDeviceNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeviceNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeviceNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeviceNameQuery(baseOptions: Apollo.QueryHookOptions<DeviceNameQuery, DeviceNameQueryVariables> & ({ variables: DeviceNameQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DeviceNameQuery, DeviceNameQueryVariables>(DeviceNameDocument, options);
      }
export function useDeviceNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DeviceNameQuery, DeviceNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DeviceNameQuery, DeviceNameQueryVariables>(DeviceNameDocument, options);
        }
// @ts-ignore
export function useDeviceNameSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DeviceNameQuery, DeviceNameQueryVariables>): Apollo.UseSuspenseQueryResult<DeviceNameQuery, DeviceNameQueryVariables>;
export function useDeviceNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DeviceNameQuery, DeviceNameQueryVariables>): Apollo.UseSuspenseQueryResult<DeviceNameQuery | undefined, DeviceNameQueryVariables>;
export function useDeviceNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DeviceNameQuery, DeviceNameQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DeviceNameQuery, DeviceNameQueryVariables>(DeviceNameDocument, options);
        }
export type DeviceNameQueryHookResult = ReturnType<typeof useDeviceNameQuery>;
export type DeviceNameLazyQueryHookResult = ReturnType<typeof useDeviceNameLazyQuery>;
export type DeviceNameSuspenseQueryHookResult = ReturnType<typeof useDeviceNameSuspenseQuery>;
export type DeviceNameQueryResult = Apollo.QueryResult<DeviceNameQuery, DeviceNameQueryVariables>;
export const PtzControllerConfigDocument = gql`
    query ptzControllerConfig($id: ID!) {
  device(id: $id) {
    id
    name
    aspects {
      type
      ... on DFA_PTZ {
        ptzConfig
      }
    }
  }
}
    `;

/**
 * __usePtzControllerConfigQuery__
 *
 * To run a query within a React component, call `usePtzControllerConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `usePtzControllerConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePtzControllerConfigQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePtzControllerConfigQuery(baseOptions: Apollo.QueryHookOptions<PtzControllerConfigQuery, PtzControllerConfigQueryVariables> & ({ variables: PtzControllerConfigQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PtzControllerConfigQuery, PtzControllerConfigQueryVariables>(PtzControllerConfigDocument, options);
      }
export function usePtzControllerConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PtzControllerConfigQuery, PtzControllerConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PtzControllerConfigQuery, PtzControllerConfigQueryVariables>(PtzControllerConfigDocument, options);
        }
// @ts-ignore
export function usePtzControllerConfigSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PtzControllerConfigQuery, PtzControllerConfigQueryVariables>): Apollo.UseSuspenseQueryResult<PtzControllerConfigQuery, PtzControllerConfigQueryVariables>;
export function usePtzControllerConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PtzControllerConfigQuery, PtzControllerConfigQueryVariables>): Apollo.UseSuspenseQueryResult<PtzControllerConfigQuery | undefined, PtzControllerConfigQueryVariables>;
export function usePtzControllerConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PtzControllerConfigQuery, PtzControllerConfigQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PtzControllerConfigQuery, PtzControllerConfigQueryVariables>(PtzControllerConfigDocument, options);
        }
export type PtzControllerConfigQueryHookResult = ReturnType<typeof usePtzControllerConfigQuery>;
export type PtzControllerConfigLazyQueryHookResult = ReturnType<typeof usePtzControllerConfigLazyQuery>;
export type PtzControllerConfigSuspenseQueryHookResult = ReturnType<typeof usePtzControllerConfigSuspenseQuery>;
export type PtzControllerConfigQueryResult = Apollo.QueryResult<PtzControllerConfigQuery, PtzControllerConfigQueryVariables>;
export const ArchiveCoverageDocument = gql`
    query archiveCoverage($ids: [ID!]!, $startTime: DateTime!, $endTime: DateTime!, $streams: [Int!], $location: ArchiveLocation) {
  archiveCoverage(
    ids: $ids
    startTime: $startTime
    endTime: $endTime
    streams: $streams
    location: $location
  ) {
    coverage {
      deviceId
      streamNumber
      time
    }
    partialCoverage {
      deviceId
      streamNumber
      time
    }
    ttl {
      deviceId
      ttl
    }
  }
  aodGet(ids: $ids, startTime: $startTime, endTime: $endTime, streams: $streams) {
    id
    deviceId
    startTime
    endTime
    streamNumber
    status
  }
}
    `;

/**
 * __useArchiveCoverageQuery__
 *
 * To run a query within a React component, call `useArchiveCoverageQuery` and pass it any options that fit your needs.
 * When your component renders, `useArchiveCoverageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArchiveCoverageQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *      startTime: // value for 'startTime'
 *      endTime: // value for 'endTime'
 *      streams: // value for 'streams'
 *      location: // value for 'location'
 *   },
 * });
 */
export function useArchiveCoverageQuery(baseOptions: Apollo.QueryHookOptions<ArchiveCoverageQuery, ArchiveCoverageQueryVariables> & ({ variables: ArchiveCoverageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ArchiveCoverageQuery, ArchiveCoverageQueryVariables>(ArchiveCoverageDocument, options);
      }
export function useArchiveCoverageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ArchiveCoverageQuery, ArchiveCoverageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ArchiveCoverageQuery, ArchiveCoverageQueryVariables>(ArchiveCoverageDocument, options);
        }
// @ts-ignore
export function useArchiveCoverageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ArchiveCoverageQuery, ArchiveCoverageQueryVariables>): Apollo.UseSuspenseQueryResult<ArchiveCoverageQuery, ArchiveCoverageQueryVariables>;
export function useArchiveCoverageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ArchiveCoverageQuery, ArchiveCoverageQueryVariables>): Apollo.UseSuspenseQueryResult<ArchiveCoverageQuery | undefined, ArchiveCoverageQueryVariables>;
export function useArchiveCoverageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ArchiveCoverageQuery, ArchiveCoverageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ArchiveCoverageQuery, ArchiveCoverageQueryVariables>(ArchiveCoverageDocument, options);
        }
export type ArchiveCoverageQueryHookResult = ReturnType<typeof useArchiveCoverageQuery>;
export type ArchiveCoverageLazyQueryHookResult = ReturnType<typeof useArchiveCoverageLazyQuery>;
export type ArchiveCoverageSuspenseQueryHookResult = ReturnType<typeof useArchiveCoverageSuspenseQuery>;
export type ArchiveCoverageQueryResult = Apollo.QueryResult<ArchiveCoverageQuery, ArchiveCoverageQueryVariables>;
export const ArchiveBoundaryDocument = gql`
    query archiveBoundary($ids: [ID!]!, $streamNumbers: [Int!]!, $startTime: DateTime!, $find: BoundaryFind!) {
  archiveBoundary(
    ids: $ids
    streamNumbers: $streamNumbers
    startTime: $startTime
    find: $find
  ) {
    boundary
    timeInsideGap
  }
}
    `;

/**
 * __useArchiveBoundaryQuery__
 *
 * To run a query within a React component, call `useArchiveBoundaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useArchiveBoundaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArchiveBoundaryQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *      streamNumbers: // value for 'streamNumbers'
 *      startTime: // value for 'startTime'
 *      find: // value for 'find'
 *   },
 * });
 */
export function useArchiveBoundaryQuery(baseOptions: Apollo.QueryHookOptions<ArchiveBoundaryQuery, ArchiveBoundaryQueryVariables> & ({ variables: ArchiveBoundaryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ArchiveBoundaryQuery, ArchiveBoundaryQueryVariables>(ArchiveBoundaryDocument, options);
      }
export function useArchiveBoundaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ArchiveBoundaryQuery, ArchiveBoundaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ArchiveBoundaryQuery, ArchiveBoundaryQueryVariables>(ArchiveBoundaryDocument, options);
        }
// @ts-ignore
export function useArchiveBoundarySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ArchiveBoundaryQuery, ArchiveBoundaryQueryVariables>): Apollo.UseSuspenseQueryResult<ArchiveBoundaryQuery, ArchiveBoundaryQueryVariables>;
export function useArchiveBoundarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ArchiveBoundaryQuery, ArchiveBoundaryQueryVariables>): Apollo.UseSuspenseQueryResult<ArchiveBoundaryQuery | undefined, ArchiveBoundaryQueryVariables>;
export function useArchiveBoundarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ArchiveBoundaryQuery, ArchiveBoundaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ArchiveBoundaryQuery, ArchiveBoundaryQueryVariables>(ArchiveBoundaryDocument, options);
        }
export type ArchiveBoundaryQueryHookResult = ReturnType<typeof useArchiveBoundaryQuery>;
export type ArchiveBoundaryLazyQueryHookResult = ReturnType<typeof useArchiveBoundaryLazyQuery>;
export type ArchiveBoundarySuspenseQueryHookResult = ReturnType<typeof useArchiveBoundarySuspenseQuery>;
export type ArchiveBoundaryQueryResult = Apollo.QueryResult<ArchiveBoundaryQuery, ArchiveBoundaryQueryVariables>;
export const ProbeDeviceDocument = gql`
    query probeDevice($input: DeviceProbeInput!) {
  probeDevice(input: $input) {
    ...deviceProbeFields
  }
}
    ${DeviceProbeFieldsFragmentDoc}`;

/**
 * __useProbeDeviceQuery__
 *
 * To run a query within a React component, call `useProbeDeviceQuery` and pass it any options that fit your needs.
 * When your component renders, `useProbeDeviceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProbeDeviceQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProbeDeviceQuery(baseOptions: Apollo.QueryHookOptions<ProbeDeviceQuery, ProbeDeviceQueryVariables> & ({ variables: ProbeDeviceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProbeDeviceQuery, ProbeDeviceQueryVariables>(ProbeDeviceDocument, options);
      }
export function useProbeDeviceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProbeDeviceQuery, ProbeDeviceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProbeDeviceQuery, ProbeDeviceQueryVariables>(ProbeDeviceDocument, options);
        }
// @ts-ignore
export function useProbeDeviceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProbeDeviceQuery, ProbeDeviceQueryVariables>): Apollo.UseSuspenseQueryResult<ProbeDeviceQuery, ProbeDeviceQueryVariables>;
export function useProbeDeviceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProbeDeviceQuery, ProbeDeviceQueryVariables>): Apollo.UseSuspenseQueryResult<ProbeDeviceQuery | undefined, ProbeDeviceQueryVariables>;
export function useProbeDeviceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProbeDeviceQuery, ProbeDeviceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProbeDeviceQuery, ProbeDeviceQueryVariables>(ProbeDeviceDocument, options);
        }
export type ProbeDeviceQueryHookResult = ReturnType<typeof useProbeDeviceQuery>;
export type ProbeDeviceLazyQueryHookResult = ReturnType<typeof useProbeDeviceLazyQuery>;
export type ProbeDeviceSuspenseQueryHookResult = ReturnType<typeof useProbeDeviceSuspenseQuery>;
export type ProbeDeviceQueryResult = Apollo.QueryResult<ProbeDeviceQuery, ProbeDeviceQueryVariables>;
export const DiscoverDevicesDocument = gql`
    query discoverDevices($platformId: ID!) {
  discoverDevices(platformId: $platformId) {
    ...deviceProbeFields
  }
}
    ${DeviceProbeFieldsFragmentDoc}`;

/**
 * __useDiscoverDevicesQuery__
 *
 * To run a query within a React component, call `useDiscoverDevicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDiscoverDevicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDiscoverDevicesQuery({
 *   variables: {
 *      platformId: // value for 'platformId'
 *   },
 * });
 */
export function useDiscoverDevicesQuery(baseOptions: Apollo.QueryHookOptions<DiscoverDevicesQuery, DiscoverDevicesQueryVariables> & ({ variables: DiscoverDevicesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DiscoverDevicesQuery, DiscoverDevicesQueryVariables>(DiscoverDevicesDocument, options);
      }
export function useDiscoverDevicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DiscoverDevicesQuery, DiscoverDevicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DiscoverDevicesQuery, DiscoverDevicesQueryVariables>(DiscoverDevicesDocument, options);
        }
// @ts-ignore
export function useDiscoverDevicesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DiscoverDevicesQuery, DiscoverDevicesQueryVariables>): Apollo.UseSuspenseQueryResult<DiscoverDevicesQuery, DiscoverDevicesQueryVariables>;
export function useDiscoverDevicesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DiscoverDevicesQuery, DiscoverDevicesQueryVariables>): Apollo.UseSuspenseQueryResult<DiscoverDevicesQuery | undefined, DiscoverDevicesQueryVariables>;
export function useDiscoverDevicesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DiscoverDevicesQuery, DiscoverDevicesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DiscoverDevicesQuery, DiscoverDevicesQueryVariables>(DiscoverDevicesDocument, options);
        }
export type DiscoverDevicesQueryHookResult = ReturnType<typeof useDiscoverDevicesQuery>;
export type DiscoverDevicesLazyQueryHookResult = ReturnType<typeof useDiscoverDevicesLazyQuery>;
export type DiscoverDevicesSuspenseQueryHookResult = ReturnType<typeof useDiscoverDevicesSuspenseQuery>;
export type DiscoverDevicesQueryResult = Apollo.QueryResult<DiscoverDevicesQuery, DiscoverDevicesQueryVariables>;
export const ProbeSensorDocument = gql`
    query probeSensor($input: DeviceProbeInput!) {
  probeSensorDevice(input: $input) {
    ...deviceProbeFields
  }
}
    ${DeviceProbeFieldsFragmentDoc}`;

/**
 * __useProbeSensorQuery__
 *
 * To run a query within a React component, call `useProbeSensorQuery` and pass it any options that fit your needs.
 * When your component renders, `useProbeSensorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProbeSensorQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProbeSensorQuery(baseOptions: Apollo.QueryHookOptions<ProbeSensorQuery, ProbeSensorQueryVariables> & ({ variables: ProbeSensorQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProbeSensorQuery, ProbeSensorQueryVariables>(ProbeSensorDocument, options);
      }
export function useProbeSensorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProbeSensorQuery, ProbeSensorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProbeSensorQuery, ProbeSensorQueryVariables>(ProbeSensorDocument, options);
        }
// @ts-ignore
export function useProbeSensorSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProbeSensorQuery, ProbeSensorQueryVariables>): Apollo.UseSuspenseQueryResult<ProbeSensorQuery, ProbeSensorQueryVariables>;
export function useProbeSensorSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProbeSensorQuery, ProbeSensorQueryVariables>): Apollo.UseSuspenseQueryResult<ProbeSensorQuery | undefined, ProbeSensorQueryVariables>;
export function useProbeSensorSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProbeSensorQuery, ProbeSensorQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProbeSensorQuery, ProbeSensorQueryVariables>(ProbeSensorDocument, options);
        }
export type ProbeSensorQueryHookResult = ReturnType<typeof useProbeSensorQuery>;
export type ProbeSensorLazyQueryHookResult = ReturnType<typeof useProbeSensorLazyQuery>;
export type ProbeSensorSuspenseQueryHookResult = ReturnType<typeof useProbeSensorSuspenseQuery>;
export type ProbeSensorQueryResult = Apollo.QueryResult<ProbeSensorQuery, ProbeSensorQueryVariables>;
export const StoragePoolsDocument = gql`
    query storagePools {
  storagePools {
    ...storagePoolFields
  }
}
    ${StoragePoolFieldsFragmentDoc}`;

/**
 * __useStoragePoolsQuery__
 *
 * To run a query within a React component, call `useStoragePoolsQuery` and pass it any options that fit your needs.
 * When your component renders, `useStoragePoolsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStoragePoolsQuery({
 *   variables: {
 *   },
 * });
 */
export function useStoragePoolsQuery(baseOptions?: Apollo.QueryHookOptions<StoragePoolsQuery, StoragePoolsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StoragePoolsQuery, StoragePoolsQueryVariables>(StoragePoolsDocument, options);
      }
export function useStoragePoolsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StoragePoolsQuery, StoragePoolsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StoragePoolsQuery, StoragePoolsQueryVariables>(StoragePoolsDocument, options);
        }
// @ts-ignore
export function useStoragePoolsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<StoragePoolsQuery, StoragePoolsQueryVariables>): Apollo.UseSuspenseQueryResult<StoragePoolsQuery, StoragePoolsQueryVariables>;
export function useStoragePoolsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StoragePoolsQuery, StoragePoolsQueryVariables>): Apollo.UseSuspenseQueryResult<StoragePoolsQuery | undefined, StoragePoolsQueryVariables>;
export function useStoragePoolsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StoragePoolsQuery, StoragePoolsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StoragePoolsQuery, StoragePoolsQueryVariables>(StoragePoolsDocument, options);
        }
export type StoragePoolsQueryHookResult = ReturnType<typeof useStoragePoolsQuery>;
export type StoragePoolsLazyQueryHookResult = ReturnType<typeof useStoragePoolsLazyQuery>;
export type StoragePoolsSuspenseQueryHookResult = ReturnType<typeof useStoragePoolsSuspenseQuery>;
export type StoragePoolsQueryResult = Apollo.QueryResult<StoragePoolsQuery, StoragePoolsQueryVariables>;
export const AspectTemplatesDocument = gql`
    query aspectTemplates {
  aspectTemplates {
    ...aspectTemplateFields
  }
}
    ${AspectTemplateFieldsFragmentDoc}`;

/**
 * __useAspectTemplatesQuery__
 *
 * To run a query within a React component, call `useAspectTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAspectTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAspectTemplatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAspectTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<AspectTemplatesQuery, AspectTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AspectTemplatesQuery, AspectTemplatesQueryVariables>(AspectTemplatesDocument, options);
      }
export function useAspectTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AspectTemplatesQuery, AspectTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AspectTemplatesQuery, AspectTemplatesQueryVariables>(AspectTemplatesDocument, options);
        }
// @ts-ignore
export function useAspectTemplatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AspectTemplatesQuery, AspectTemplatesQueryVariables>): Apollo.UseSuspenseQueryResult<AspectTemplatesQuery, AspectTemplatesQueryVariables>;
export function useAspectTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AspectTemplatesQuery, AspectTemplatesQueryVariables>): Apollo.UseSuspenseQueryResult<AspectTemplatesQuery | undefined, AspectTemplatesQueryVariables>;
export function useAspectTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AspectTemplatesQuery, AspectTemplatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AspectTemplatesQuery, AspectTemplatesQueryVariables>(AspectTemplatesDocument, options);
        }
export type AspectTemplatesQueryHookResult = ReturnType<typeof useAspectTemplatesQuery>;
export type AspectTemplatesLazyQueryHookResult = ReturnType<typeof useAspectTemplatesLazyQuery>;
export type AspectTemplatesSuspenseQueryHookResult = ReturnType<typeof useAspectTemplatesSuspenseQuery>;
export type AspectTemplatesQueryResult = Apollo.QueryResult<AspectTemplatesQuery, AspectTemplatesQueryVariables>;
export const DeviceTemplatesDocument = gql`
    query deviceTemplates {
  deviceTemplates {
    make
    models {
      model
      url
    }
  }
}
    `;

/**
 * __useDeviceTemplatesQuery__
 *
 * To run a query within a React component, call `useDeviceTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeviceTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeviceTemplatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useDeviceTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<DeviceTemplatesQuery, DeviceTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DeviceTemplatesQuery, DeviceTemplatesQueryVariables>(DeviceTemplatesDocument, options);
      }
export function useDeviceTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DeviceTemplatesQuery, DeviceTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DeviceTemplatesQuery, DeviceTemplatesQueryVariables>(DeviceTemplatesDocument, options);
        }
// @ts-ignore
export function useDeviceTemplatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DeviceTemplatesQuery, DeviceTemplatesQueryVariables>): Apollo.UseSuspenseQueryResult<DeviceTemplatesQuery, DeviceTemplatesQueryVariables>;
export function useDeviceTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DeviceTemplatesQuery, DeviceTemplatesQueryVariables>): Apollo.UseSuspenseQueryResult<DeviceTemplatesQuery | undefined, DeviceTemplatesQueryVariables>;
export function useDeviceTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DeviceTemplatesQuery, DeviceTemplatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DeviceTemplatesQuery, DeviceTemplatesQueryVariables>(DeviceTemplatesDocument, options);
        }
export type DeviceTemplatesQueryHookResult = ReturnType<typeof useDeviceTemplatesQuery>;
export type DeviceTemplatesLazyQueryHookResult = ReturnType<typeof useDeviceTemplatesLazyQuery>;
export type DeviceTemplatesSuspenseQueryHookResult = ReturnType<typeof useDeviceTemplatesSuspenseQuery>;
export type DeviceTemplatesQueryResult = Apollo.QueryResult<DeviceTemplatesQuery, DeviceTemplatesQueryVariables>;
export const VaeTemplatesDocument = gql`
    query vaeTemplates($deviceId: ID!) {
  vaeTemplates(deviceId: $deviceId) {
    ...aspectTemplateFields
  }
}
    ${AspectTemplateFieldsFragmentDoc}`;

/**
 * __useVaeTemplatesQuery__
 *
 * To run a query within a React component, call `useVaeTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useVaeTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVaeTemplatesQuery({
 *   variables: {
 *      deviceId: // value for 'deviceId'
 *   },
 * });
 */
export function useVaeTemplatesQuery(baseOptions: Apollo.QueryHookOptions<VaeTemplatesQuery, VaeTemplatesQueryVariables> & ({ variables: VaeTemplatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VaeTemplatesQuery, VaeTemplatesQueryVariables>(VaeTemplatesDocument, options);
      }
export function useVaeTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VaeTemplatesQuery, VaeTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VaeTemplatesQuery, VaeTemplatesQueryVariables>(VaeTemplatesDocument, options);
        }
// @ts-ignore
export function useVaeTemplatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<VaeTemplatesQuery, VaeTemplatesQueryVariables>): Apollo.UseSuspenseQueryResult<VaeTemplatesQuery, VaeTemplatesQueryVariables>;
export function useVaeTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VaeTemplatesQuery, VaeTemplatesQueryVariables>): Apollo.UseSuspenseQueryResult<VaeTemplatesQuery | undefined, VaeTemplatesQueryVariables>;
export function useVaeTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VaeTemplatesQuery, VaeTemplatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<VaeTemplatesQuery, VaeTemplatesQueryVariables>(VaeTemplatesDocument, options);
        }
export type VaeTemplatesQueryHookResult = ReturnType<typeof useVaeTemplatesQuery>;
export type VaeTemplatesLazyQueryHookResult = ReturnType<typeof useVaeTemplatesLazyQuery>;
export type VaeTemplatesSuspenseQueryHookResult = ReturnType<typeof useVaeTemplatesSuspenseQuery>;
export type VaeTemplatesQueryResult = Apollo.QueryResult<VaeTemplatesQuery, VaeTemplatesQueryVariables>;
export const CameraLogDocument = gql`
    query cameraLog($deviceId: ID!) {
  cameraLog(deviceId: $deviceId) {
    time
    severity
    message
  }
}
    `;

/**
 * __useCameraLogQuery__
 *
 * To run a query within a React component, call `useCameraLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useCameraLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCameraLogQuery({
 *   variables: {
 *      deviceId: // value for 'deviceId'
 *   },
 * });
 */
export function useCameraLogQuery(baseOptions: Apollo.QueryHookOptions<CameraLogQuery, CameraLogQueryVariables> & ({ variables: CameraLogQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CameraLogQuery, CameraLogQueryVariables>(CameraLogDocument, options);
      }
export function useCameraLogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CameraLogQuery, CameraLogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CameraLogQuery, CameraLogQueryVariables>(CameraLogDocument, options);
        }
// @ts-ignore
export function useCameraLogSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CameraLogQuery, CameraLogQueryVariables>): Apollo.UseSuspenseQueryResult<CameraLogQuery, CameraLogQueryVariables>;
export function useCameraLogSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CameraLogQuery, CameraLogQueryVariables>): Apollo.UseSuspenseQueryResult<CameraLogQuery | undefined, CameraLogQueryVariables>;
export function useCameraLogSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CameraLogQuery, CameraLogQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CameraLogQuery, CameraLogQueryVariables>(CameraLogDocument, options);
        }
export type CameraLogQueryHookResult = ReturnType<typeof useCameraLogQuery>;
export type CameraLogLazyQueryHookResult = ReturnType<typeof useCameraLogLazyQuery>;
export type CameraLogSuspenseQueryHookResult = ReturnType<typeof useCameraLogSuspenseQuery>;
export type CameraLogQueryResult = Apollo.QueryResult<CameraLogQuery, CameraLogQueryVariables>;
export const VaeConfigsDocument = gql`
    query vaeConfigs($deviceId: ID!, $engine: String!) {
  vaeConfigs(deviceId: $deviceId, engine: $engine) {
    name
  }
}
    `;

/**
 * __useVaeConfigsQuery__
 *
 * To run a query within a React component, call `useVaeConfigsQuery` and pass it any options that fit your needs.
 * When your component renders, `useVaeConfigsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVaeConfigsQuery({
 *   variables: {
 *      deviceId: // value for 'deviceId'
 *      engine: // value for 'engine'
 *   },
 * });
 */
export function useVaeConfigsQuery(baseOptions: Apollo.QueryHookOptions<VaeConfigsQuery, VaeConfigsQueryVariables> & ({ variables: VaeConfigsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VaeConfigsQuery, VaeConfigsQueryVariables>(VaeConfigsDocument, options);
      }
export function useVaeConfigsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VaeConfigsQuery, VaeConfigsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VaeConfigsQuery, VaeConfigsQueryVariables>(VaeConfigsDocument, options);
        }
// @ts-ignore
export function useVaeConfigsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<VaeConfigsQuery, VaeConfigsQueryVariables>): Apollo.UseSuspenseQueryResult<VaeConfigsQuery, VaeConfigsQueryVariables>;
export function useVaeConfigsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VaeConfigsQuery, VaeConfigsQueryVariables>): Apollo.UseSuspenseQueryResult<VaeConfigsQuery | undefined, VaeConfigsQueryVariables>;
export function useVaeConfigsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VaeConfigsQuery, VaeConfigsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<VaeConfigsQuery, VaeConfigsQueryVariables>(VaeConfigsDocument, options);
        }
export type VaeConfigsQueryHookResult = ReturnType<typeof useVaeConfigsQuery>;
export type VaeConfigsLazyQueryHookResult = ReturnType<typeof useVaeConfigsLazyQuery>;
export type VaeConfigsSuspenseQueryHookResult = ReturnType<typeof useVaeConfigsSuspenseQuery>;
export type VaeConfigsQueryResult = Apollo.QueryResult<VaeConfigsQuery, VaeConfigsQueryVariables>;
export const ProbeGatewayDirectoriesDocument = gql`
    query probeGatewayDirectories($input: GatewayDirectoriesProbeInput!) {
  probeGatewayDirectories(input: $input) {
    deviceProbe {
      ...deviceProbeFields
    }
    directories {
      id
      name
    }
  }
}
    ${DeviceProbeFieldsFragmentDoc}`;

/**
 * __useProbeGatewayDirectoriesQuery__
 *
 * To run a query within a React component, call `useProbeGatewayDirectoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProbeGatewayDirectoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProbeGatewayDirectoriesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProbeGatewayDirectoriesQuery(baseOptions: Apollo.QueryHookOptions<ProbeGatewayDirectoriesQuery, ProbeGatewayDirectoriesQueryVariables> & ({ variables: ProbeGatewayDirectoriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProbeGatewayDirectoriesQuery, ProbeGatewayDirectoriesQueryVariables>(ProbeGatewayDirectoriesDocument, options);
      }
export function useProbeGatewayDirectoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProbeGatewayDirectoriesQuery, ProbeGatewayDirectoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProbeGatewayDirectoriesQuery, ProbeGatewayDirectoriesQueryVariables>(ProbeGatewayDirectoriesDocument, options);
        }
// @ts-ignore
export function useProbeGatewayDirectoriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProbeGatewayDirectoriesQuery, ProbeGatewayDirectoriesQueryVariables>): Apollo.UseSuspenseQueryResult<ProbeGatewayDirectoriesQuery, ProbeGatewayDirectoriesQueryVariables>;
export function useProbeGatewayDirectoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProbeGatewayDirectoriesQuery, ProbeGatewayDirectoriesQueryVariables>): Apollo.UseSuspenseQueryResult<ProbeGatewayDirectoriesQuery | undefined, ProbeGatewayDirectoriesQueryVariables>;
export function useProbeGatewayDirectoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProbeGatewayDirectoriesQuery, ProbeGatewayDirectoriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProbeGatewayDirectoriesQuery, ProbeGatewayDirectoriesQueryVariables>(ProbeGatewayDirectoriesDocument, options);
        }
export type ProbeGatewayDirectoriesQueryHookResult = ReturnType<typeof useProbeGatewayDirectoriesQuery>;
export type ProbeGatewayDirectoriesLazyQueryHookResult = ReturnType<typeof useProbeGatewayDirectoriesLazyQuery>;
export type ProbeGatewayDirectoriesSuspenseQueryHookResult = ReturnType<typeof useProbeGatewayDirectoriesSuspenseQuery>;
export type ProbeGatewayDirectoriesQueryResult = Apollo.QueryResult<ProbeGatewayDirectoriesQuery, ProbeGatewayDirectoriesQueryVariables>;
export const ProbeGatewayDocument = gql`
    query probeGateway($input: GatewayProbeInput!) {
  probeGateway(input: $input) {
    devices {
      id
      name
    }
    events {
      id
      name
    }
  }
}
    `;

/**
 * __useProbeGatewayQuery__
 *
 * To run a query within a React component, call `useProbeGatewayQuery` and pass it any options that fit your needs.
 * When your component renders, `useProbeGatewayQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProbeGatewayQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProbeGatewayQuery(baseOptions: Apollo.QueryHookOptions<ProbeGatewayQuery, ProbeGatewayQueryVariables> & ({ variables: ProbeGatewayQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProbeGatewayQuery, ProbeGatewayQueryVariables>(ProbeGatewayDocument, options);
      }
export function useProbeGatewayLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProbeGatewayQuery, ProbeGatewayQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProbeGatewayQuery, ProbeGatewayQueryVariables>(ProbeGatewayDocument, options);
        }
// @ts-ignore
export function useProbeGatewaySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProbeGatewayQuery, ProbeGatewayQueryVariables>): Apollo.UseSuspenseQueryResult<ProbeGatewayQuery, ProbeGatewayQueryVariables>;
export function useProbeGatewaySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProbeGatewayQuery, ProbeGatewayQueryVariables>): Apollo.UseSuspenseQueryResult<ProbeGatewayQuery | undefined, ProbeGatewayQueryVariables>;
export function useProbeGatewaySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProbeGatewayQuery, ProbeGatewayQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProbeGatewayQuery, ProbeGatewayQueryVariables>(ProbeGatewayDocument, options);
        }
export type ProbeGatewayQueryHookResult = ReturnType<typeof useProbeGatewayQuery>;
export type ProbeGatewayLazyQueryHookResult = ReturnType<typeof useProbeGatewayLazyQuery>;
export type ProbeGatewaySuspenseQueryHookResult = ReturnType<typeof useProbeGatewaySuspenseQuery>;
export type ProbeGatewayQueryResult = Apollo.QueryResult<ProbeGatewayQuery, ProbeGatewayQueryVariables>;
export const CreateGatewayDocument = gql`
    mutation createGateway($device: DeviceInput!) {
  createGatewayDevice(device: $device) {
    id
    warning
  }
}
    `;
export type CreateGatewayMutationFn = Apollo.MutationFunction<CreateGatewayMutation, CreateGatewayMutationVariables>;

/**
 * __useCreateGatewayMutation__
 *
 * To run a mutation, you first call `useCreateGatewayMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGatewayMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGatewayMutation, { data, loading, error }] = useCreateGatewayMutation({
 *   variables: {
 *      device: // value for 'device'
 *   },
 * });
 */
export function useCreateGatewayMutation(baseOptions?: Apollo.MutationHookOptions<CreateGatewayMutation, CreateGatewayMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateGatewayMutation, CreateGatewayMutationVariables>(CreateGatewayDocument, options);
      }
export type CreateGatewayMutationHookResult = ReturnType<typeof useCreateGatewayMutation>;
export type CreateGatewayMutationResult = Apollo.MutationResult<CreateGatewayMutation>;
export type CreateGatewayMutationOptions = Apollo.BaseMutationOptions<CreateGatewayMutation, CreateGatewayMutationVariables>;
export const CreateSensorDocument = gql`
    mutation createSensor($device: DeviceInput!) {
  createSensorDevice(device: $device) {
    id
    warning
  }
}
    `;
export type CreateSensorMutationFn = Apollo.MutationFunction<CreateSensorMutation, CreateSensorMutationVariables>;

/**
 * __useCreateSensorMutation__
 *
 * To run a mutation, you first call `useCreateSensorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSensorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSensorMutation, { data, loading, error }] = useCreateSensorMutation({
 *   variables: {
 *      device: // value for 'device'
 *   },
 * });
 */
export function useCreateSensorMutation(baseOptions?: Apollo.MutationHookOptions<CreateSensorMutation, CreateSensorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSensorMutation, CreateSensorMutationVariables>(CreateSensorDocument, options);
      }
export type CreateSensorMutationHookResult = ReturnType<typeof useCreateSensorMutation>;
export type CreateSensorMutationResult = Apollo.MutationResult<CreateSensorMutation>;
export type CreateSensorMutationOptions = Apollo.BaseMutationOptions<CreateSensorMutation, CreateSensorMutationVariables>;
export const CreateDeviceDocument = gql`
    mutation createDevice($device: DeviceInput!) {
  createDevice(device: $device) {
    id
    warning
  }
}
    `;
export type CreateDeviceMutationFn = Apollo.MutationFunction<CreateDeviceMutation, CreateDeviceMutationVariables>;

/**
 * __useCreateDeviceMutation__
 *
 * To run a mutation, you first call `useCreateDeviceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDeviceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDeviceMutation, { data, loading, error }] = useCreateDeviceMutation({
 *   variables: {
 *      device: // value for 'device'
 *   },
 * });
 */
export function useCreateDeviceMutation(baseOptions?: Apollo.MutationHookOptions<CreateDeviceMutation, CreateDeviceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDeviceMutation, CreateDeviceMutationVariables>(CreateDeviceDocument, options);
      }
export type CreateDeviceMutationHookResult = ReturnType<typeof useCreateDeviceMutation>;
export type CreateDeviceMutationResult = Apollo.MutationResult<CreateDeviceMutation>;
export type CreateDeviceMutationOptions = Apollo.BaseMutationOptions<CreateDeviceMutation, CreateDeviceMutationVariables>;
export const UpdateDeviceDocument = gql`
    mutation updateDevice($id: ID!, $device: DeviceInput!) {
  updateDevice(id: $id, device: $device) {
    updated
    warning
    warningFields {
      field
      value
    }
  }
}
    `;
export type UpdateDeviceMutationFn = Apollo.MutationFunction<UpdateDeviceMutation, UpdateDeviceMutationVariables>;

/**
 * __useUpdateDeviceMutation__
 *
 * To run a mutation, you first call `useUpdateDeviceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDeviceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDeviceMutation, { data, loading, error }] = useUpdateDeviceMutation({
 *   variables: {
 *      id: // value for 'id'
 *      device: // value for 'device'
 *   },
 * });
 */
export function useUpdateDeviceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDeviceMutation, UpdateDeviceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDeviceMutation, UpdateDeviceMutationVariables>(UpdateDeviceDocument, options);
      }
export type UpdateDeviceMutationHookResult = ReturnType<typeof useUpdateDeviceMutation>;
export type UpdateDeviceMutationResult = Apollo.MutationResult<UpdateDeviceMutation>;
export type UpdateDeviceMutationOptions = Apollo.BaseMutationOptions<UpdateDeviceMutation, UpdateDeviceMutationVariables>;
export const UpdateDevicesDocument = gql`
    mutation updateDevices($list: [BulkDeviceInput!]!) {
  updateDevices(list: $list)
}
    `;
export type UpdateDevicesMutationFn = Apollo.MutationFunction<UpdateDevicesMutation, UpdateDevicesMutationVariables>;

/**
 * __useUpdateDevicesMutation__
 *
 * To run a mutation, you first call `useUpdateDevicesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDevicesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDevicesMutation, { data, loading, error }] = useUpdateDevicesMutation({
 *   variables: {
 *      list: // value for 'list'
 *   },
 * });
 */
export function useUpdateDevicesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDevicesMutation, UpdateDevicesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDevicesMutation, UpdateDevicesMutationVariables>(UpdateDevicesDocument, options);
      }
export type UpdateDevicesMutationHookResult = ReturnType<typeof useUpdateDevicesMutation>;
export type UpdateDevicesMutationResult = Apollo.MutationResult<UpdateDevicesMutation>;
export type UpdateDevicesMutationOptions = Apollo.BaseMutationOptions<UpdateDevicesMutation, UpdateDevicesMutationVariables>;
export const DeleteDeviceDocument = gql`
    mutation deleteDevice($id: ID!) {
  deleteDevice(id: $id)
}
    `;
export type DeleteDeviceMutationFn = Apollo.MutationFunction<DeleteDeviceMutation, DeleteDeviceMutationVariables>;

/**
 * __useDeleteDeviceMutation__
 *
 * To run a mutation, you first call `useDeleteDeviceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDeviceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDeviceMutation, { data, loading, error }] = useDeleteDeviceMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteDeviceMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDeviceMutation, DeleteDeviceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDeviceMutation, DeleteDeviceMutationVariables>(DeleteDeviceDocument, options);
      }
export type DeleteDeviceMutationHookResult = ReturnType<typeof useDeleteDeviceMutation>;
export type DeleteDeviceMutationResult = Apollo.MutationResult<DeleteDeviceMutation>;
export type DeleteDeviceMutationOptions = Apollo.BaseMutationOptions<DeleteDeviceMutation, DeleteDeviceMutationVariables>;
export const DeleteDevicesDocument = gql`
    mutation deleteDevices($ids: [ID!]!) {
  deleteDevices(ids: $ids)
}
    `;
export type DeleteDevicesMutationFn = Apollo.MutationFunction<DeleteDevicesMutation, DeleteDevicesMutationVariables>;

/**
 * __useDeleteDevicesMutation__
 *
 * To run a mutation, you first call `useDeleteDevicesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDevicesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDevicesMutation, { data, loading, error }] = useDeleteDevicesMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteDevicesMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDevicesMutation, DeleteDevicesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDevicesMutation, DeleteDevicesMutationVariables>(DeleteDevicesDocument, options);
      }
export type DeleteDevicesMutationHookResult = ReturnType<typeof useDeleteDevicesMutation>;
export type DeleteDevicesMutationResult = Apollo.MutationResult<DeleteDevicesMutation>;
export type DeleteDevicesMutationOptions = Apollo.BaseMutationOptions<DeleteDevicesMutation, DeleteDevicesMutationVariables>;
export const DeviceCommandDocument = gql`
    mutation deviceCommand($id: ID!, $command: DeviceCommand!) {
  deviceCommand(id: $id, command: $command)
}
    `;
export type DeviceCommandMutationFn = Apollo.MutationFunction<DeviceCommandMutation, DeviceCommandMutationVariables>;

/**
 * __useDeviceCommandMutation__
 *
 * To run a mutation, you first call `useDeviceCommandMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeviceCommandMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deviceCommandMutation, { data, loading, error }] = useDeviceCommandMutation({
 *   variables: {
 *      id: // value for 'id'
 *      command: // value for 'command'
 *   },
 * });
 */
export function useDeviceCommandMutation(baseOptions?: Apollo.MutationHookOptions<DeviceCommandMutation, DeviceCommandMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeviceCommandMutation, DeviceCommandMutationVariables>(DeviceCommandDocument, options);
      }
export type DeviceCommandMutationHookResult = ReturnType<typeof useDeviceCommandMutation>;
export type DeviceCommandMutationResult = Apollo.MutationResult<DeviceCommandMutation>;
export type DeviceCommandMutationOptions = Apollo.BaseMutationOptions<DeviceCommandMutation, DeviceCommandMutationVariables>;
export const ChangeDeliveryPriorityDocument = gql`
    mutation changeDeliveryPriority($devices: [DeliveryPriorityInput!]!) {
  changeDeliveryPriority(devices: $devices)
}
    `;
export type ChangeDeliveryPriorityMutationFn = Apollo.MutationFunction<ChangeDeliveryPriorityMutation, ChangeDeliveryPriorityMutationVariables>;

/**
 * __useChangeDeliveryPriorityMutation__
 *
 * To run a mutation, you first call `useChangeDeliveryPriorityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeDeliveryPriorityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeDeliveryPriorityMutation, { data, loading, error }] = useChangeDeliveryPriorityMutation({
 *   variables: {
 *      devices: // value for 'devices'
 *   },
 * });
 */
export function useChangeDeliveryPriorityMutation(baseOptions?: Apollo.MutationHookOptions<ChangeDeliveryPriorityMutation, ChangeDeliveryPriorityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeDeliveryPriorityMutation, ChangeDeliveryPriorityMutationVariables>(ChangeDeliveryPriorityDocument, options);
      }
export type ChangeDeliveryPriorityMutationHookResult = ReturnType<typeof useChangeDeliveryPriorityMutation>;
export type ChangeDeliveryPriorityMutationResult = Apollo.MutationResult<ChangeDeliveryPriorityMutation>;
export type ChangeDeliveryPriorityMutationOptions = Apollo.BaseMutationOptions<ChangeDeliveryPriorityMutation, ChangeDeliveryPriorityMutationVariables>;
export const CreateVaeConfigDocument = gql`
    mutation createVaeConfig($deviceId: ID!, $engine: String!, $name: String!) {
  createVaeConfig(deviceId: $deviceId, engine: $engine, name: $name)
}
    `;
export type CreateVaeConfigMutationFn = Apollo.MutationFunction<CreateVaeConfigMutation, CreateVaeConfigMutationVariables>;

/**
 * __useCreateVaeConfigMutation__
 *
 * To run a mutation, you first call `useCreateVaeConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVaeConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVaeConfigMutation, { data, loading, error }] = useCreateVaeConfigMutation({
 *   variables: {
 *      deviceId: // value for 'deviceId'
 *      engine: // value for 'engine'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreateVaeConfigMutation(baseOptions?: Apollo.MutationHookOptions<CreateVaeConfigMutation, CreateVaeConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateVaeConfigMutation, CreateVaeConfigMutationVariables>(CreateVaeConfigDocument, options);
      }
export type CreateVaeConfigMutationHookResult = ReturnType<typeof useCreateVaeConfigMutation>;
export type CreateVaeConfigMutationResult = Apollo.MutationResult<CreateVaeConfigMutation>;
export type CreateVaeConfigMutationOptions = Apollo.BaseMutationOptions<CreateVaeConfigMutation, CreateVaeConfigMutationVariables>;
export const RenameVaeConfigDocument = gql`
    mutation renameVaeConfig($deviceId: ID!, $engine: String!, $name: String!, $newName: String!) {
  renameVaeConfig(
    deviceId: $deviceId
    engine: $engine
    name: $name
    newName: $newName
  )
}
    `;
export type RenameVaeConfigMutationFn = Apollo.MutationFunction<RenameVaeConfigMutation, RenameVaeConfigMutationVariables>;

/**
 * __useRenameVaeConfigMutation__
 *
 * To run a mutation, you first call `useRenameVaeConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenameVaeConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renameVaeConfigMutation, { data, loading, error }] = useRenameVaeConfigMutation({
 *   variables: {
 *      deviceId: // value for 'deviceId'
 *      engine: // value for 'engine'
 *      name: // value for 'name'
 *      newName: // value for 'newName'
 *   },
 * });
 */
export function useRenameVaeConfigMutation(baseOptions?: Apollo.MutationHookOptions<RenameVaeConfigMutation, RenameVaeConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RenameVaeConfigMutation, RenameVaeConfigMutationVariables>(RenameVaeConfigDocument, options);
      }
export type RenameVaeConfigMutationHookResult = ReturnType<typeof useRenameVaeConfigMutation>;
export type RenameVaeConfigMutationResult = Apollo.MutationResult<RenameVaeConfigMutation>;
export type RenameVaeConfigMutationOptions = Apollo.BaseMutationOptions<RenameVaeConfigMutation, RenameVaeConfigMutationVariables>;
export const DeleteVaeConfigDocument = gql`
    mutation deleteVaeConfig($deviceId: ID!, $engine: String!, $name: String!) {
  deleteVaeConfig(deviceId: $deviceId, engine: $engine, name: $name)
}
    `;
export type DeleteVaeConfigMutationFn = Apollo.MutationFunction<DeleteVaeConfigMutation, DeleteVaeConfigMutationVariables>;

/**
 * __useDeleteVaeConfigMutation__
 *
 * To run a mutation, you first call `useDeleteVaeConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteVaeConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteVaeConfigMutation, { data, loading, error }] = useDeleteVaeConfigMutation({
 *   variables: {
 *      deviceId: // value for 'deviceId'
 *      engine: // value for 'engine'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useDeleteVaeConfigMutation(baseOptions?: Apollo.MutationHookOptions<DeleteVaeConfigMutation, DeleteVaeConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteVaeConfigMutation, DeleteVaeConfigMutationVariables>(DeleteVaeConfigDocument, options);
      }
export type DeleteVaeConfigMutationHookResult = ReturnType<typeof useDeleteVaeConfigMutation>;
export type DeleteVaeConfigMutationResult = Apollo.MutationResult<DeleteVaeConfigMutation>;
export type DeleteVaeConfigMutationOptions = Apollo.BaseMutationOptions<DeleteVaeConfigMutation, DeleteVaeConfigMutationVariables>;
export const PurgeAvatarQueueDocument = gql`
    mutation purgeAvatarQueue($id: ID!) {
  purgeAvatarQueue(id: $id)
}
    `;
export type PurgeAvatarQueueMutationFn = Apollo.MutationFunction<PurgeAvatarQueueMutation, PurgeAvatarQueueMutationVariables>;

/**
 * __usePurgeAvatarQueueMutation__
 *
 * To run a mutation, you first call `usePurgeAvatarQueueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePurgeAvatarQueueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [purgeAvatarQueueMutation, { data, loading, error }] = usePurgeAvatarQueueMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePurgeAvatarQueueMutation(baseOptions?: Apollo.MutationHookOptions<PurgeAvatarQueueMutation, PurgeAvatarQueueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PurgeAvatarQueueMutation, PurgeAvatarQueueMutationVariables>(PurgeAvatarQueueDocument, options);
      }
export type PurgeAvatarQueueMutationHookResult = ReturnType<typeof usePurgeAvatarQueueMutation>;
export type PurgeAvatarQueueMutationResult = Apollo.MutationResult<PurgeAvatarQueueMutation>;
export type PurgeAvatarQueueMutationOptions = Apollo.BaseMutationOptions<PurgeAvatarQueueMutation, PurgeAvatarQueueMutationVariables>;
export const PtzAbsDocument = gql`
    mutation ptzAbs($id: ID!, $command: PTZ_AbsInput!, $priority: Int) {
  ptzAbs(id: $id, input: $command, priority: $priority)
}
    `;
export type PtzAbsMutationFn = Apollo.MutationFunction<PtzAbsMutation, PtzAbsMutationVariables>;

/**
 * __usePtzAbsMutation__
 *
 * To run a mutation, you first call `usePtzAbsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePtzAbsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ptzAbsMutation, { data, loading, error }] = usePtzAbsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      command: // value for 'command'
 *      priority: // value for 'priority'
 *   },
 * });
 */
export function usePtzAbsMutation(baseOptions?: Apollo.MutationHookOptions<PtzAbsMutation, PtzAbsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PtzAbsMutation, PtzAbsMutationVariables>(PtzAbsDocument, options);
      }
export type PtzAbsMutationHookResult = ReturnType<typeof usePtzAbsMutation>;
export type PtzAbsMutationResult = Apollo.MutationResult<PtzAbsMutation>;
export type PtzAbsMutationOptions = Apollo.BaseMutationOptions<PtzAbsMutation, PtzAbsMutationVariables>;
export const PtzStepDocument = gql`
    mutation ptzStep($id: ID!, $command: PTZ_StepInput!, $priority: Int) {
  ptzStep(id: $id, input: $command, priority: $priority)
}
    `;
export type PtzStepMutationFn = Apollo.MutationFunction<PtzStepMutation, PtzStepMutationVariables>;

/**
 * __usePtzStepMutation__
 *
 * To run a mutation, you first call `usePtzStepMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePtzStepMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ptzStepMutation, { data, loading, error }] = usePtzStepMutation({
 *   variables: {
 *      id: // value for 'id'
 *      command: // value for 'command'
 *      priority: // value for 'priority'
 *   },
 * });
 */
export function usePtzStepMutation(baseOptions?: Apollo.MutationHookOptions<PtzStepMutation, PtzStepMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PtzStepMutation, PtzStepMutationVariables>(PtzStepDocument, options);
      }
export type PtzStepMutationHookResult = ReturnType<typeof usePtzStepMutation>;
export type PtzStepMutationResult = Apollo.MutationResult<PtzStepMutation>;
export type PtzStepMutationOptions = Apollo.BaseMutationOptions<PtzStepMutation, PtzStepMutationVariables>;
export const PtzSpeedDocument = gql`
    mutation ptzSpeed($id: ID!, $command: PTZ_SpeedInput!, $priority: Int) {
  ptzSpeed(id: $id, input: $command, priority: $priority)
}
    `;
export type PtzSpeedMutationFn = Apollo.MutationFunction<PtzSpeedMutation, PtzSpeedMutationVariables>;

/**
 * __usePtzSpeedMutation__
 *
 * To run a mutation, you first call `usePtzSpeedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePtzSpeedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ptzSpeedMutation, { data, loading, error }] = usePtzSpeedMutation({
 *   variables: {
 *      id: // value for 'id'
 *      command: // value for 'command'
 *      priority: // value for 'priority'
 *   },
 * });
 */
export function usePtzSpeedMutation(baseOptions?: Apollo.MutationHookOptions<PtzSpeedMutation, PtzSpeedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PtzSpeedMutation, PtzSpeedMutationVariables>(PtzSpeedDocument, options);
      }
export type PtzSpeedMutationHookResult = ReturnType<typeof usePtzSpeedMutation>;
export type PtzSpeedMutationResult = Apollo.MutationResult<PtzSpeedMutation>;
export type PtzSpeedMutationOptions = Apollo.BaseMutationOptions<PtzSpeedMutation, PtzSpeedMutationVariables>;
export const PtzPresetDocument = gql`
    mutation ptzPreset($id: ID!, $command: PTZ_PresetInput!, $priority: Int) {
  ptzPreset(id: $id, input: $command, priority: $priority)
}
    `;
export type PtzPresetMutationFn = Apollo.MutationFunction<PtzPresetMutation, PtzPresetMutationVariables>;

/**
 * __usePtzPresetMutation__
 *
 * To run a mutation, you first call `usePtzPresetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePtzPresetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ptzPresetMutation, { data, loading, error }] = usePtzPresetMutation({
 *   variables: {
 *      id: // value for 'id'
 *      command: // value for 'command'
 *      priority: // value for 'priority'
 *   },
 * });
 */
export function usePtzPresetMutation(baseOptions?: Apollo.MutationHookOptions<PtzPresetMutation, PtzPresetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PtzPresetMutation, PtzPresetMutationVariables>(PtzPresetDocument, options);
      }
export type PtzPresetMutationHookResult = ReturnType<typeof usePtzPresetMutation>;
export type PtzPresetMutationResult = Apollo.MutationResult<PtzPresetMutation>;
export type PtzPresetMutationOptions = Apollo.BaseMutationOptions<PtzPresetMutation, PtzPresetMutationVariables>;
export const PtzRelDocument = gql`
    mutation ptzRel($id: ID!, $command: PTZ_RelInput!, $priority: Int) {
  ptzRel(id: $id, input: $command, priority: $priority)
}
    `;
export type PtzRelMutationFn = Apollo.MutationFunction<PtzRelMutation, PtzRelMutationVariables>;

/**
 * __usePtzRelMutation__
 *
 * To run a mutation, you first call `usePtzRelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePtzRelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ptzRelMutation, { data, loading, error }] = usePtzRelMutation({
 *   variables: {
 *      id: // value for 'id'
 *      command: // value for 'command'
 *      priority: // value for 'priority'
 *   },
 * });
 */
export function usePtzRelMutation(baseOptions?: Apollo.MutationHookOptions<PtzRelMutation, PtzRelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PtzRelMutation, PtzRelMutationVariables>(PtzRelDocument, options);
      }
export type PtzRelMutationHookResult = ReturnType<typeof usePtzRelMutation>;
export type PtzRelMutationResult = Apollo.MutationResult<PtzRelMutation>;
export type PtzRelMutationOptions = Apollo.BaseMutationOptions<PtzRelMutation, PtzRelMutationVariables>;
export const PtzLockDocument = gql`
    mutation ptzLock($id: ID!, $token: String) {
  ptzLock(id: $id, token: $token) {
    token
  }
}
    `;
export type PtzLockMutationFn = Apollo.MutationFunction<PtzLockMutation, PtzLockMutationVariables>;

/**
 * __usePtzLockMutation__
 *
 * To run a mutation, you first call `usePtzLockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePtzLockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ptzLockMutation, { data, loading, error }] = usePtzLockMutation({
 *   variables: {
 *      id: // value for 'id'
 *      token: // value for 'token'
 *   },
 * });
 */
export function usePtzLockMutation(baseOptions?: Apollo.MutationHookOptions<PtzLockMutation, PtzLockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PtzLockMutation, PtzLockMutationVariables>(PtzLockDocument, options);
      }
export type PtzLockMutationHookResult = ReturnType<typeof usePtzLockMutation>;
export type PtzLockMutationResult = Apollo.MutationResult<PtzLockMutation>;
export type PtzLockMutationOptions = Apollo.BaseMutationOptions<PtzLockMutation, PtzLockMutationVariables>;
export const PtzUnlockDocument = gql`
    mutation ptzUnlock($id: ID!, $explicit: Boolean) {
  ptzUnlock(id: $id, explicit: $explicit)
}
    `;
export type PtzUnlockMutationFn = Apollo.MutationFunction<PtzUnlockMutation, PtzUnlockMutationVariables>;

/**
 * __usePtzUnlockMutation__
 *
 * To run a mutation, you first call `usePtzUnlockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePtzUnlockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ptzUnlockMutation, { data, loading, error }] = usePtzUnlockMutation({
 *   variables: {
 *      id: // value for 'id'
 *      explicit: // value for 'explicit'
 *   },
 * });
 */
export function usePtzUnlockMutation(baseOptions?: Apollo.MutationHookOptions<PtzUnlockMutation, PtzUnlockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PtzUnlockMutation, PtzUnlockMutationVariables>(PtzUnlockDocument, options);
      }
export type PtzUnlockMutationHookResult = ReturnType<typeof usePtzUnlockMutation>;
export type PtzUnlockMutationResult = Apollo.MutationResult<PtzUnlockMutation>;
export type PtzUnlockMutationOptions = Apollo.BaseMutationOptions<PtzUnlockMutation, PtzUnlockMutationVariables>;
export const PtzSettingsDocument = gql`
    mutation ptzSettings($id: ID!, $command: PTZ_SettingsInput!, $priority: Int) {
  ptzSettings(id: $id, input: $command, priority: $priority)
}
    `;
export type PtzSettingsMutationFn = Apollo.MutationFunction<PtzSettingsMutation, PtzSettingsMutationVariables>;

/**
 * __usePtzSettingsMutation__
 *
 * To run a mutation, you first call `usePtzSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePtzSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ptzSettingsMutation, { data, loading, error }] = usePtzSettingsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      command: // value for 'command'
 *      priority: // value for 'priority'
 *   },
 * });
 */
export function usePtzSettingsMutation(baseOptions?: Apollo.MutationHookOptions<PtzSettingsMutation, PtzSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PtzSettingsMutation, PtzSettingsMutationVariables>(PtzSettingsDocument, options);
      }
export type PtzSettingsMutationHookResult = ReturnType<typeof usePtzSettingsMutation>;
export type PtzSettingsMutationResult = Apollo.MutationResult<PtzSettingsMutation>;
export type PtzSettingsMutationOptions = Apollo.BaseMutationOptions<PtzSettingsMutation, PtzSettingsMutationVariables>;
export const PtzHardwareDocument = gql`
    mutation ptzHardware($id: ID!, $command: PTZ_HardwareInput!, $priority: Int) {
  ptzHardware(id: $id, input: $command, priority: $priority)
}
    `;
export type PtzHardwareMutationFn = Apollo.MutationFunction<PtzHardwareMutation, PtzHardwareMutationVariables>;

/**
 * __usePtzHardwareMutation__
 *
 * To run a mutation, you first call `usePtzHardwareMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePtzHardwareMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ptzHardwareMutation, { data, loading, error }] = usePtzHardwareMutation({
 *   variables: {
 *      id: // value for 'id'
 *      command: // value for 'command'
 *      priority: // value for 'priority'
 *   },
 * });
 */
export function usePtzHardwareMutation(baseOptions?: Apollo.MutationHookOptions<PtzHardwareMutation, PtzHardwareMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PtzHardwareMutation, PtzHardwareMutationVariables>(PtzHardwareDocument, options);
      }
export type PtzHardwareMutationHookResult = ReturnType<typeof usePtzHardwareMutation>;
export type PtzHardwareMutationResult = Apollo.MutationResult<PtzHardwareMutation>;
export type PtzHardwareMutationOptions = Apollo.BaseMutationOptions<PtzHardwareMutation, PtzHardwareMutationVariables>;
export const ChangeLocalStorageConfigDocument = gql`
    mutation changeLocalStorageConfig($id: ID!, $input: LocalStorageInput!) {
  changeLocalStorage(id: $id, input: $input)
}
    `;
export type ChangeLocalStorageConfigMutationFn = Apollo.MutationFunction<ChangeLocalStorageConfigMutation, ChangeLocalStorageConfigMutationVariables>;

/**
 * __useChangeLocalStorageConfigMutation__
 *
 * To run a mutation, you first call `useChangeLocalStorageConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeLocalStorageConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeLocalStorageConfigMutation, { data, loading, error }] = useChangeLocalStorageConfigMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangeLocalStorageConfigMutation(baseOptions?: Apollo.MutationHookOptions<ChangeLocalStorageConfigMutation, ChangeLocalStorageConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeLocalStorageConfigMutation, ChangeLocalStorageConfigMutationVariables>(ChangeLocalStorageConfigDocument, options);
      }
export type ChangeLocalStorageConfigMutationHookResult = ReturnType<typeof useChangeLocalStorageConfigMutation>;
export type ChangeLocalStorageConfigMutationResult = Apollo.MutationResult<ChangeLocalStorageConfigMutation>;
export type ChangeLocalStorageConfigMutationOptions = Apollo.BaseMutationOptions<ChangeLocalStorageConfigMutation, ChangeLocalStorageConfigMutationVariables>;
export const CreateAvatarApiKeyDocument = gql`
    mutation createAvatarApiKey($id: ID!) {
  createAvatarApiKey(id: $id)
}
    `;
export type CreateAvatarApiKeyMutationFn = Apollo.MutationFunction<CreateAvatarApiKeyMutation, CreateAvatarApiKeyMutationVariables>;

/**
 * __useCreateAvatarApiKeyMutation__
 *
 * To run a mutation, you first call `useCreateAvatarApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAvatarApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAvatarApiKeyMutation, { data, loading, error }] = useCreateAvatarApiKeyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCreateAvatarApiKeyMutation(baseOptions?: Apollo.MutationHookOptions<CreateAvatarApiKeyMutation, CreateAvatarApiKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAvatarApiKeyMutation, CreateAvatarApiKeyMutationVariables>(CreateAvatarApiKeyDocument, options);
      }
export type CreateAvatarApiKeyMutationHookResult = ReturnType<typeof useCreateAvatarApiKeyMutation>;
export type CreateAvatarApiKeyMutationResult = Apollo.MutationResult<CreateAvatarApiKeyMutation>;
export type CreateAvatarApiKeyMutationOptions = Apollo.BaseMutationOptions<CreateAvatarApiKeyMutation, CreateAvatarApiKeyMutationVariables>;
export const RegenerateAvatarApiKeyDocument = gql`
    mutation regenerateAvatarApiKey($id: ID!) {
  regenerateAvatarApiKey(id: $id)
}
    `;
export type RegenerateAvatarApiKeyMutationFn = Apollo.MutationFunction<RegenerateAvatarApiKeyMutation, RegenerateAvatarApiKeyMutationVariables>;

/**
 * __useRegenerateAvatarApiKeyMutation__
 *
 * To run a mutation, you first call `useRegenerateAvatarApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegenerateAvatarApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [regenerateAvatarApiKeyMutation, { data, loading, error }] = useRegenerateAvatarApiKeyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRegenerateAvatarApiKeyMutation(baseOptions?: Apollo.MutationHookOptions<RegenerateAvatarApiKeyMutation, RegenerateAvatarApiKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegenerateAvatarApiKeyMutation, RegenerateAvatarApiKeyMutationVariables>(RegenerateAvatarApiKeyDocument, options);
      }
export type RegenerateAvatarApiKeyMutationHookResult = ReturnType<typeof useRegenerateAvatarApiKeyMutation>;
export type RegenerateAvatarApiKeyMutationResult = Apollo.MutationResult<RegenerateAvatarApiKeyMutation>;
export type RegenerateAvatarApiKeyMutationOptions = Apollo.BaseMutationOptions<RegenerateAvatarApiKeyMutation, RegenerateAvatarApiKeyMutationVariables>;
export const RemoveAvatarApiKeyDocument = gql`
    mutation removeAvatarApiKey($id: ID!) {
  removeAvatarApiKey(id: $id)
}
    `;
export type RemoveAvatarApiKeyMutationFn = Apollo.MutationFunction<RemoveAvatarApiKeyMutation, RemoveAvatarApiKeyMutationVariables>;

/**
 * __useRemoveAvatarApiKeyMutation__
 *
 * To run a mutation, you first call `useRemoveAvatarApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveAvatarApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeAvatarApiKeyMutation, { data, loading, error }] = useRemoveAvatarApiKeyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveAvatarApiKeyMutation(baseOptions?: Apollo.MutationHookOptions<RemoveAvatarApiKeyMutation, RemoveAvatarApiKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveAvatarApiKeyMutation, RemoveAvatarApiKeyMutationVariables>(RemoveAvatarApiKeyDocument, options);
      }
export type RemoveAvatarApiKeyMutationHookResult = ReturnType<typeof useRemoveAvatarApiKeyMutation>;
export type RemoveAvatarApiKeyMutationResult = Apollo.MutationResult<RemoveAvatarApiKeyMutation>;
export type RemoveAvatarApiKeyMutationOptions = Apollo.BaseMutationOptions<RemoveAvatarApiKeyMutation, RemoveAvatarApiKeyMutationVariables>;
export const GeoToursDocument = gql`
    query geoTours {
  geoTours {
    ...geoTour
  }
}
    ${GeoTourFragmentDoc}`;

/**
 * __useGeoToursQuery__
 *
 * To run a query within a React component, call `useGeoToursQuery` and pass it any options that fit your needs.
 * When your component renders, `useGeoToursQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGeoToursQuery({
 *   variables: {
 *   },
 * });
 */
export function useGeoToursQuery(baseOptions?: Apollo.QueryHookOptions<GeoToursQuery, GeoToursQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GeoToursQuery, GeoToursQueryVariables>(GeoToursDocument, options);
      }
export function useGeoToursLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GeoToursQuery, GeoToursQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GeoToursQuery, GeoToursQueryVariables>(GeoToursDocument, options);
        }
// @ts-ignore
export function useGeoToursSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GeoToursQuery, GeoToursQueryVariables>): Apollo.UseSuspenseQueryResult<GeoToursQuery, GeoToursQueryVariables>;
export function useGeoToursSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GeoToursQuery, GeoToursQueryVariables>): Apollo.UseSuspenseQueryResult<GeoToursQuery | undefined, GeoToursQueryVariables>;
export function useGeoToursSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GeoToursQuery, GeoToursQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GeoToursQuery, GeoToursQueryVariables>(GeoToursDocument, options);
        }
export type GeoToursQueryHookResult = ReturnType<typeof useGeoToursQuery>;
export type GeoToursLazyQueryHookResult = ReturnType<typeof useGeoToursLazyQuery>;
export type GeoToursSuspenseQueryHookResult = ReturnType<typeof useGeoToursSuspenseQuery>;
export type GeoToursQueryResult = Apollo.QueryResult<GeoToursQuery, GeoToursQueryVariables>;
export const AdminGeoTourListDocument = gql`
    query adminGeoTourList {
  geoTours {
    ...adminGeoTourListFields
  }
}
    ${AdminGeoTourListFieldsFragmentDoc}`;

/**
 * __useAdminGeoTourListQuery__
 *
 * To run a query within a React component, call `useAdminGeoTourListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGeoTourListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGeoTourListQuery({
 *   variables: {
 *   },
 * });
 */
export function useAdminGeoTourListQuery(baseOptions?: Apollo.QueryHookOptions<AdminGeoTourListQuery, AdminGeoTourListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGeoTourListQuery, AdminGeoTourListQueryVariables>(AdminGeoTourListDocument, options);
      }
export function useAdminGeoTourListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminGeoTourListQuery, AdminGeoTourListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGeoTourListQuery, AdminGeoTourListQueryVariables>(AdminGeoTourListDocument, options);
        }
// @ts-ignore
export function useAdminGeoTourListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AdminGeoTourListQuery, AdminGeoTourListQueryVariables>): Apollo.UseSuspenseQueryResult<AdminGeoTourListQuery, AdminGeoTourListQueryVariables>;
export function useAdminGeoTourListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGeoTourListQuery, AdminGeoTourListQueryVariables>): Apollo.UseSuspenseQueryResult<AdminGeoTourListQuery | undefined, AdminGeoTourListQueryVariables>;
export function useAdminGeoTourListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGeoTourListQuery, AdminGeoTourListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGeoTourListQuery, AdminGeoTourListQueryVariables>(AdminGeoTourListDocument, options);
        }
export type AdminGeoTourListQueryHookResult = ReturnType<typeof useAdminGeoTourListQuery>;
export type AdminGeoTourListLazyQueryHookResult = ReturnType<typeof useAdminGeoTourListLazyQuery>;
export type AdminGeoTourListSuspenseQueryHookResult = ReturnType<typeof useAdminGeoTourListSuspenseQuery>;
export type AdminGeoTourListQueryResult = Apollo.QueryResult<AdminGeoTourListQuery, AdminGeoTourListQueryVariables>;
export const GeoTourDocument = gql`
    query geoTour($id: ID!) {
  geoTour(id: $id) {
    ...geoTour
  }
}
    ${GeoTourFragmentDoc}`;

/**
 * __useGeoTourQuery__
 *
 * To run a query within a React component, call `useGeoTourQuery` and pass it any options that fit your needs.
 * When your component renders, `useGeoTourQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGeoTourQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGeoTourQuery(baseOptions: Apollo.QueryHookOptions<GeoTourQuery, GeoTourQueryVariables> & ({ variables: GeoTourQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GeoTourQuery, GeoTourQueryVariables>(GeoTourDocument, options);
      }
export function useGeoTourLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GeoTourQuery, GeoTourQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GeoTourQuery, GeoTourQueryVariables>(GeoTourDocument, options);
        }
// @ts-ignore
export function useGeoTourSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GeoTourQuery, GeoTourQueryVariables>): Apollo.UseSuspenseQueryResult<GeoTourQuery, GeoTourQueryVariables>;
export function useGeoTourSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GeoTourQuery, GeoTourQueryVariables>): Apollo.UseSuspenseQueryResult<GeoTourQuery | undefined, GeoTourQueryVariables>;
export function useGeoTourSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GeoTourQuery, GeoTourQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GeoTourQuery, GeoTourQueryVariables>(GeoTourDocument, options);
        }
export type GeoTourQueryHookResult = ReturnType<typeof useGeoTourQuery>;
export type GeoTourLazyQueryHookResult = ReturnType<typeof useGeoTourLazyQuery>;
export type GeoTourSuspenseQueryHookResult = ReturnType<typeof useGeoTourSuspenseQuery>;
export type GeoTourQueryResult = Apollo.QueryResult<GeoTourQuery, GeoTourQueryVariables>;
export const UpdateGeoTourDocument = gql`
    mutation updateGeoTour($id: ID!, $input: GeoTourInput!) {
  updateGeoTour(id: $id, input: $input) {
    updated
  }
}
    `;
export type UpdateGeoTourMutationFn = Apollo.MutationFunction<UpdateGeoTourMutation, UpdateGeoTourMutationVariables>;

/**
 * __useUpdateGeoTourMutation__
 *
 * To run a mutation, you first call `useUpdateGeoTourMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGeoTourMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGeoTourMutation, { data, loading, error }] = useUpdateGeoTourMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateGeoTourMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGeoTourMutation, UpdateGeoTourMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGeoTourMutation, UpdateGeoTourMutationVariables>(UpdateGeoTourDocument, options);
      }
export type UpdateGeoTourMutationHookResult = ReturnType<typeof useUpdateGeoTourMutation>;
export type UpdateGeoTourMutationResult = Apollo.MutationResult<UpdateGeoTourMutation>;
export type UpdateGeoTourMutationOptions = Apollo.BaseMutationOptions<UpdateGeoTourMutation, UpdateGeoTourMutationVariables>;
export const CreateGeoTourDocument = gql`
    mutation createGeoTour($input: GeoTourInput!) {
  createGeoTour(input: $input) {
    id
  }
}
    `;
export type CreateGeoTourMutationFn = Apollo.MutationFunction<CreateGeoTourMutation, CreateGeoTourMutationVariables>;

/**
 * __useCreateGeoTourMutation__
 *
 * To run a mutation, you first call `useCreateGeoTourMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGeoTourMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGeoTourMutation, { data, loading, error }] = useCreateGeoTourMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateGeoTourMutation(baseOptions?: Apollo.MutationHookOptions<CreateGeoTourMutation, CreateGeoTourMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateGeoTourMutation, CreateGeoTourMutationVariables>(CreateGeoTourDocument, options);
      }
export type CreateGeoTourMutationHookResult = ReturnType<typeof useCreateGeoTourMutation>;
export type CreateGeoTourMutationResult = Apollo.MutationResult<CreateGeoTourMutation>;
export type CreateGeoTourMutationOptions = Apollo.BaseMutationOptions<CreateGeoTourMutation, CreateGeoTourMutationVariables>;
export const DeleteGeoTourDocument = gql`
    mutation deleteGeoTour($id: ID!) {
  deleteGeoTour(id: $id)
}
    `;
export type DeleteGeoTourMutationFn = Apollo.MutationFunction<DeleteGeoTourMutation, DeleteGeoTourMutationVariables>;

/**
 * __useDeleteGeoTourMutation__
 *
 * To run a mutation, you first call `useDeleteGeoTourMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGeoTourMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteGeoTourMutation, { data, loading, error }] = useDeleteGeoTourMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteGeoTourMutation(baseOptions?: Apollo.MutationHookOptions<DeleteGeoTourMutation, DeleteGeoTourMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteGeoTourMutation, DeleteGeoTourMutationVariables>(DeleteGeoTourDocument, options);
      }
export type DeleteGeoTourMutationHookResult = ReturnType<typeof useDeleteGeoTourMutation>;
export type DeleteGeoTourMutationResult = Apollo.MutationResult<DeleteGeoTourMutation>;
export type DeleteGeoTourMutationOptions = Apollo.BaseMutationOptions<DeleteGeoTourMutation, DeleteGeoTourMutationVariables>;
export const GetGuisDocument = gql`
    query getGuis {
  guis {
    id
    name
    url
    description
  }
}
    `;

/**
 * __useGetGuisQuery__
 *
 * To run a query within a React component, call `useGetGuisQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGuisQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGuisQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetGuisQuery(baseOptions?: Apollo.QueryHookOptions<GetGuisQuery, GetGuisQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGuisQuery, GetGuisQueryVariables>(GetGuisDocument, options);
      }
export function useGetGuisLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGuisQuery, GetGuisQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGuisQuery, GetGuisQueryVariables>(GetGuisDocument, options);
        }
// @ts-ignore
export function useGetGuisSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetGuisQuery, GetGuisQueryVariables>): Apollo.UseSuspenseQueryResult<GetGuisQuery, GetGuisQueryVariables>;
export function useGetGuisSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGuisQuery, GetGuisQueryVariables>): Apollo.UseSuspenseQueryResult<GetGuisQuery | undefined, GetGuisQueryVariables>;
export function useGetGuisSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGuisQuery, GetGuisQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGuisQuery, GetGuisQueryVariables>(GetGuisDocument, options);
        }
export type GetGuisQueryHookResult = ReturnType<typeof useGetGuisQuery>;
export type GetGuisLazyQueryHookResult = ReturnType<typeof useGetGuisLazyQuery>;
export type GetGuisSuspenseQueryHookResult = ReturnType<typeof useGetGuisSuspenseQuery>;
export type GetGuisQueryResult = Apollo.QueryResult<GetGuisQuery, GetGuisQueryVariables>;
export const LabelsDocument = gql`
    query labels {
  labels {
    ...LabelFields
  }
}
    ${LabelFieldsFragmentDoc}`;

/**
 * __useLabelsQuery__
 *
 * To run a query within a React component, call `useLabelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLabelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLabelsQuery({
 *   variables: {
 *   },
 * });
 */
export function useLabelsQuery(baseOptions?: Apollo.QueryHookOptions<LabelsQuery, LabelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LabelsQuery, LabelsQueryVariables>(LabelsDocument, options);
      }
export function useLabelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LabelsQuery, LabelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LabelsQuery, LabelsQueryVariables>(LabelsDocument, options);
        }
// @ts-ignore
export function useLabelsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LabelsQuery, LabelsQueryVariables>): Apollo.UseSuspenseQueryResult<LabelsQuery, LabelsQueryVariables>;
export function useLabelsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LabelsQuery, LabelsQueryVariables>): Apollo.UseSuspenseQueryResult<LabelsQuery | undefined, LabelsQueryVariables>;
export function useLabelsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LabelsQuery, LabelsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LabelsQuery, LabelsQueryVariables>(LabelsDocument, options);
        }
export type LabelsQueryHookResult = ReturnType<typeof useLabelsQuery>;
export type LabelsLazyQueryHookResult = ReturnType<typeof useLabelsLazyQuery>;
export type LabelsSuspenseQueryHookResult = ReturnType<typeof useLabelsSuspenseQuery>;
export type LabelsQueryResult = Apollo.QueryResult<LabelsQuery, LabelsQueryVariables>;
export const LabelDocument = gql`
    query label($id: ID!) {
  label(id: $id) {
    ...LabelFields
  }
}
    ${LabelFieldsFragmentDoc}`;

/**
 * __useLabelQuery__
 *
 * To run a query within a React component, call `useLabelQuery` and pass it any options that fit your needs.
 * When your component renders, `useLabelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLabelQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLabelQuery(baseOptions: Apollo.QueryHookOptions<LabelQuery, LabelQueryVariables> & ({ variables: LabelQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LabelQuery, LabelQueryVariables>(LabelDocument, options);
      }
export function useLabelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LabelQuery, LabelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LabelQuery, LabelQueryVariables>(LabelDocument, options);
        }
// @ts-ignore
export function useLabelSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LabelQuery, LabelQueryVariables>): Apollo.UseSuspenseQueryResult<LabelQuery, LabelQueryVariables>;
export function useLabelSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LabelQuery, LabelQueryVariables>): Apollo.UseSuspenseQueryResult<LabelQuery | undefined, LabelQueryVariables>;
export function useLabelSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LabelQuery, LabelQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LabelQuery, LabelQueryVariables>(LabelDocument, options);
        }
export type LabelQueryHookResult = ReturnType<typeof useLabelQuery>;
export type LabelLazyQueryHookResult = ReturnType<typeof useLabelLazyQuery>;
export type LabelSuspenseQueryHookResult = ReturnType<typeof useLabelSuspenseQuery>;
export type LabelQueryResult = Apollo.QueryResult<LabelQuery, LabelQueryVariables>;
export const LabelsForObjectDocument = gql`
    query labelsForObject($objectId: ID!) {
  labelsForObject(objectId: $objectId) {
    ...LabelFields
  }
}
    ${LabelFieldsFragmentDoc}`;

/**
 * __useLabelsForObjectQuery__
 *
 * To run a query within a React component, call `useLabelsForObjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useLabelsForObjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLabelsForObjectQuery({
 *   variables: {
 *      objectId: // value for 'objectId'
 *   },
 * });
 */
export function useLabelsForObjectQuery(baseOptions: Apollo.QueryHookOptions<LabelsForObjectQuery, LabelsForObjectQueryVariables> & ({ variables: LabelsForObjectQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LabelsForObjectQuery, LabelsForObjectQueryVariables>(LabelsForObjectDocument, options);
      }
export function useLabelsForObjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LabelsForObjectQuery, LabelsForObjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LabelsForObjectQuery, LabelsForObjectQueryVariables>(LabelsForObjectDocument, options);
        }
// @ts-ignore
export function useLabelsForObjectSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LabelsForObjectQuery, LabelsForObjectQueryVariables>): Apollo.UseSuspenseQueryResult<LabelsForObjectQuery, LabelsForObjectQueryVariables>;
export function useLabelsForObjectSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LabelsForObjectQuery, LabelsForObjectQueryVariables>): Apollo.UseSuspenseQueryResult<LabelsForObjectQuery | undefined, LabelsForObjectQueryVariables>;
export function useLabelsForObjectSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LabelsForObjectQuery, LabelsForObjectQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LabelsForObjectQuery, LabelsForObjectQueryVariables>(LabelsForObjectDocument, options);
        }
export type LabelsForObjectQueryHookResult = ReturnType<typeof useLabelsForObjectQuery>;
export type LabelsForObjectLazyQueryHookResult = ReturnType<typeof useLabelsForObjectLazyQuery>;
export type LabelsForObjectSuspenseQueryHookResult = ReturnType<typeof useLabelsForObjectSuspenseQuery>;
export type LabelsForObjectQueryResult = Apollo.QueryResult<LabelsForObjectQuery, LabelsForObjectQueryVariables>;
export const HierarchiesDocument = gql`
    query hierarchies {
  hierarchies {
    ...HierarchyFields
  }
}
    ${HierarchyFieldsFragmentDoc}`;

/**
 * __useHierarchiesQuery__
 *
 * To run a query within a React component, call `useHierarchiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useHierarchiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHierarchiesQuery({
 *   variables: {
 *   },
 * });
 */
export function useHierarchiesQuery(baseOptions?: Apollo.QueryHookOptions<HierarchiesQuery, HierarchiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HierarchiesQuery, HierarchiesQueryVariables>(HierarchiesDocument, options);
      }
export function useHierarchiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HierarchiesQuery, HierarchiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HierarchiesQuery, HierarchiesQueryVariables>(HierarchiesDocument, options);
        }
// @ts-ignore
export function useHierarchiesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<HierarchiesQuery, HierarchiesQueryVariables>): Apollo.UseSuspenseQueryResult<HierarchiesQuery, HierarchiesQueryVariables>;
export function useHierarchiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HierarchiesQuery, HierarchiesQueryVariables>): Apollo.UseSuspenseQueryResult<HierarchiesQuery | undefined, HierarchiesQueryVariables>;
export function useHierarchiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HierarchiesQuery, HierarchiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HierarchiesQuery, HierarchiesQueryVariables>(HierarchiesDocument, options);
        }
export type HierarchiesQueryHookResult = ReturnType<typeof useHierarchiesQuery>;
export type HierarchiesLazyQueryHookResult = ReturnType<typeof useHierarchiesLazyQuery>;
export type HierarchiesSuspenseQueryHookResult = ReturnType<typeof useHierarchiesSuspenseQuery>;
export type HierarchiesQueryResult = Apollo.QueryResult<HierarchiesQuery, HierarchiesQueryVariables>;
export const HierarchyDocument = gql`
    query hierarchy($id: ID!) {
  hierarchy(id: $id) {
    ...HierarchyFields
  }
}
    ${HierarchyFieldsFragmentDoc}`;

/**
 * __useHierarchyQuery__
 *
 * To run a query within a React component, call `useHierarchyQuery` and pass it any options that fit your needs.
 * When your component renders, `useHierarchyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHierarchyQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useHierarchyQuery(baseOptions: Apollo.QueryHookOptions<HierarchyQuery, HierarchyQueryVariables> & ({ variables: HierarchyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HierarchyQuery, HierarchyQueryVariables>(HierarchyDocument, options);
      }
export function useHierarchyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HierarchyQuery, HierarchyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HierarchyQuery, HierarchyQueryVariables>(HierarchyDocument, options);
        }
// @ts-ignore
export function useHierarchySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<HierarchyQuery, HierarchyQueryVariables>): Apollo.UseSuspenseQueryResult<HierarchyQuery, HierarchyQueryVariables>;
export function useHierarchySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HierarchyQuery, HierarchyQueryVariables>): Apollo.UseSuspenseQueryResult<HierarchyQuery | undefined, HierarchyQueryVariables>;
export function useHierarchySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HierarchyQuery, HierarchyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HierarchyQuery, HierarchyQueryVariables>(HierarchyDocument, options);
        }
export type HierarchyQueryHookResult = ReturnType<typeof useHierarchyQuery>;
export type HierarchyLazyQueryHookResult = ReturnType<typeof useHierarchyLazyQuery>;
export type HierarchySuspenseQueryHookResult = ReturnType<typeof useHierarchySuspenseQuery>;
export type HierarchyQueryResult = Apollo.QueryResult<HierarchyQuery, HierarchyQueryVariables>;
export const InsertLabelsDocument = gql`
    mutation insertLabels($labels: [LabelInput!]!) {
  insertLabels(labels: $labels) {
    ...LabelFields
  }
}
    ${LabelFieldsFragmentDoc}`;
export type InsertLabelsMutationFn = Apollo.MutationFunction<InsertLabelsMutation, InsertLabelsMutationVariables>;

/**
 * __useInsertLabelsMutation__
 *
 * To run a mutation, you first call `useInsertLabelsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertLabelsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertLabelsMutation, { data, loading, error }] = useInsertLabelsMutation({
 *   variables: {
 *      labels: // value for 'labels'
 *   },
 * });
 */
export function useInsertLabelsMutation(baseOptions?: Apollo.MutationHookOptions<InsertLabelsMutation, InsertLabelsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertLabelsMutation, InsertLabelsMutationVariables>(InsertLabelsDocument, options);
      }
export type InsertLabelsMutationHookResult = ReturnType<typeof useInsertLabelsMutation>;
export type InsertLabelsMutationResult = Apollo.MutationResult<InsertLabelsMutation>;
export type InsertLabelsMutationOptions = Apollo.BaseMutationOptions<InsertLabelsMutation, InsertLabelsMutationVariables>;
export const UpdateLabelDocument = gql`
    mutation updateLabel($label: LabelInput!) {
  updateLabel(label: $label)
}
    `;
export type UpdateLabelMutationFn = Apollo.MutationFunction<UpdateLabelMutation, UpdateLabelMutationVariables>;

/**
 * __useUpdateLabelMutation__
 *
 * To run a mutation, you first call `useUpdateLabelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLabelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLabelMutation, { data, loading, error }] = useUpdateLabelMutation({
 *   variables: {
 *      label: // value for 'label'
 *   },
 * });
 */
export function useUpdateLabelMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLabelMutation, UpdateLabelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLabelMutation, UpdateLabelMutationVariables>(UpdateLabelDocument, options);
      }
export type UpdateLabelMutationHookResult = ReturnType<typeof useUpdateLabelMutation>;
export type UpdateLabelMutationResult = Apollo.MutationResult<UpdateLabelMutation>;
export type UpdateLabelMutationOptions = Apollo.BaseMutationOptions<UpdateLabelMutation, UpdateLabelMutationVariables>;
export const DeleteLabelDocument = gql`
    mutation deleteLabel($id: ID!) {
  deleteLabel(id: $id)
}
    `;
export type DeleteLabelMutationFn = Apollo.MutationFunction<DeleteLabelMutation, DeleteLabelMutationVariables>;

/**
 * __useDeleteLabelMutation__
 *
 * To run a mutation, you first call `useDeleteLabelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLabelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLabelMutation, { data, loading, error }] = useDeleteLabelMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteLabelMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLabelMutation, DeleteLabelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLabelMutation, DeleteLabelMutationVariables>(DeleteLabelDocument, options);
      }
export type DeleteLabelMutationHookResult = ReturnType<typeof useDeleteLabelMutation>;
export type DeleteLabelMutationResult = Apollo.MutationResult<DeleteLabelMutation>;
export type DeleteLabelMutationOptions = Apollo.BaseMutationOptions<DeleteLabelMutation, DeleteLabelMutationVariables>;
export const AssignLabelsDocument = gql`
    mutation assignLabels($objectId: ID!, $ids: [ID!]!) {
  assignLabels(objectId: $objectId, ids: $ids)
}
    `;
export type AssignLabelsMutationFn = Apollo.MutationFunction<AssignLabelsMutation, AssignLabelsMutationVariables>;

/**
 * __useAssignLabelsMutation__
 *
 * To run a mutation, you first call `useAssignLabelsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignLabelsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignLabelsMutation, { data, loading, error }] = useAssignLabelsMutation({
 *   variables: {
 *      objectId: // value for 'objectId'
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useAssignLabelsMutation(baseOptions?: Apollo.MutationHookOptions<AssignLabelsMutation, AssignLabelsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignLabelsMutation, AssignLabelsMutationVariables>(AssignLabelsDocument, options);
      }
export type AssignLabelsMutationHookResult = ReturnType<typeof useAssignLabelsMutation>;
export type AssignLabelsMutationResult = Apollo.MutationResult<AssignLabelsMutation>;
export type AssignLabelsMutationOptions = Apollo.BaseMutationOptions<AssignLabelsMutation, AssignLabelsMutationVariables>;
export const RemoveLabelsDocument = gql`
    mutation removeLabels($objectId: ID!, $ids: [ID!]!) {
  removeLabels(objectId: $objectId, ids: $ids)
}
    `;
export type RemoveLabelsMutationFn = Apollo.MutationFunction<RemoveLabelsMutation, RemoveLabelsMutationVariables>;

/**
 * __useRemoveLabelsMutation__
 *
 * To run a mutation, you first call `useRemoveLabelsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveLabelsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeLabelsMutation, { data, loading, error }] = useRemoveLabelsMutation({
 *   variables: {
 *      objectId: // value for 'objectId'
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useRemoveLabelsMutation(baseOptions?: Apollo.MutationHookOptions<RemoveLabelsMutation, RemoveLabelsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveLabelsMutation, RemoveLabelsMutationVariables>(RemoveLabelsDocument, options);
      }
export type RemoveLabelsMutationHookResult = ReturnType<typeof useRemoveLabelsMutation>;
export type RemoveLabelsMutationResult = Apollo.MutationResult<RemoveLabelsMutation>;
export type RemoveLabelsMutationOptions = Apollo.BaseMutationOptions<RemoveLabelsMutation, RemoveLabelsMutationVariables>;
export const InsertHierarchyDocument = gql`
    mutation insertHierarchy($hierarchy: HierarchyInput!) {
  insertHierarchy(hierarchy: $hierarchy) {
    ...HierarchyFields
  }
}
    ${HierarchyFieldsFragmentDoc}`;
export type InsertHierarchyMutationFn = Apollo.MutationFunction<InsertHierarchyMutation, InsertHierarchyMutationVariables>;

/**
 * __useInsertHierarchyMutation__
 *
 * To run a mutation, you first call `useInsertHierarchyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertHierarchyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertHierarchyMutation, { data, loading, error }] = useInsertHierarchyMutation({
 *   variables: {
 *      hierarchy: // value for 'hierarchy'
 *   },
 * });
 */
export function useInsertHierarchyMutation(baseOptions?: Apollo.MutationHookOptions<InsertHierarchyMutation, InsertHierarchyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertHierarchyMutation, InsertHierarchyMutationVariables>(InsertHierarchyDocument, options);
      }
export type InsertHierarchyMutationHookResult = ReturnType<typeof useInsertHierarchyMutation>;
export type InsertHierarchyMutationResult = Apollo.MutationResult<InsertHierarchyMutation>;
export type InsertHierarchyMutationOptions = Apollo.BaseMutationOptions<InsertHierarchyMutation, InsertHierarchyMutationVariables>;
export const UpdateHierarchyDocument = gql`
    mutation updateHierarchy($hierarchy: HierarchyInput!) {
  updateHierarchy(hierarchy: $hierarchy)
}
    `;
export type UpdateHierarchyMutationFn = Apollo.MutationFunction<UpdateHierarchyMutation, UpdateHierarchyMutationVariables>;

/**
 * __useUpdateHierarchyMutation__
 *
 * To run a mutation, you first call `useUpdateHierarchyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateHierarchyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateHierarchyMutation, { data, loading, error }] = useUpdateHierarchyMutation({
 *   variables: {
 *      hierarchy: // value for 'hierarchy'
 *   },
 * });
 */
export function useUpdateHierarchyMutation(baseOptions?: Apollo.MutationHookOptions<UpdateHierarchyMutation, UpdateHierarchyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateHierarchyMutation, UpdateHierarchyMutationVariables>(UpdateHierarchyDocument, options);
      }
export type UpdateHierarchyMutationHookResult = ReturnType<typeof useUpdateHierarchyMutation>;
export type UpdateHierarchyMutationResult = Apollo.MutationResult<UpdateHierarchyMutation>;
export type UpdateHierarchyMutationOptions = Apollo.BaseMutationOptions<UpdateHierarchyMutation, UpdateHierarchyMutationVariables>;
export const DeleteHierarchyDocument = gql`
    mutation deleteHierarchy($id: ID!) {
  deleteHierarchy(id: $id)
}
    `;
export type DeleteHierarchyMutationFn = Apollo.MutationFunction<DeleteHierarchyMutation, DeleteHierarchyMutationVariables>;

/**
 * __useDeleteHierarchyMutation__
 *
 * To run a mutation, you first call `useDeleteHierarchyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteHierarchyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteHierarchyMutation, { data, loading, error }] = useDeleteHierarchyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteHierarchyMutation(baseOptions?: Apollo.MutationHookOptions<DeleteHierarchyMutation, DeleteHierarchyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteHierarchyMutation, DeleteHierarchyMutationVariables>(DeleteHierarchyDocument, options);
      }
export type DeleteHierarchyMutationHookResult = ReturnType<typeof useDeleteHierarchyMutation>;
export type DeleteHierarchyMutationResult = Apollo.MutationResult<DeleteHierarchyMutation>;
export type DeleteHierarchyMutationOptions = Apollo.BaseMutationOptions<DeleteHierarchyMutation, DeleteHierarchyMutationVariables>;
export const LabelUpdateDocument = gql`
    subscription labelUpdate {
  labelUpdate {
    ...LabelOrHierarchyUpdateFields
  }
}
    ${LabelOrHierarchyUpdateFieldsFragmentDoc}`;

/**
 * __useLabelUpdateSubscription__
 *
 * To run a query within a React component, call `useLabelUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useLabelUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLabelUpdateSubscription({
 *   variables: {
 *   },
 * });
 */
export function useLabelUpdateSubscription(baseOptions?: Apollo.SubscriptionHookOptions<LabelUpdateSubscription, LabelUpdateSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<LabelUpdateSubscription, LabelUpdateSubscriptionVariables>(LabelUpdateDocument, options);
      }
export type LabelUpdateSubscriptionHookResult = ReturnType<typeof useLabelUpdateSubscription>;
export type LabelUpdateSubscriptionResult = Apollo.SubscriptionResult<LabelUpdateSubscription>;
export const HierarchyUpdateDocument = gql`
    subscription hierarchyUpdate {
  hierarchyUpdate {
    ...LabelOrHierarchyUpdateFields
  }
}
    ${LabelOrHierarchyUpdateFieldsFragmentDoc}`;

/**
 * __useHierarchyUpdateSubscription__
 *
 * To run a query within a React component, call `useHierarchyUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useHierarchyUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHierarchyUpdateSubscription({
 *   variables: {
 *   },
 * });
 */
export function useHierarchyUpdateSubscription(baseOptions?: Apollo.SubscriptionHookOptions<HierarchyUpdateSubscription, HierarchyUpdateSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<HierarchyUpdateSubscription, HierarchyUpdateSubscriptionVariables>(HierarchyUpdateDocument, options);
      }
export type HierarchyUpdateSubscriptionHookResult = ReturnType<typeof useHierarchyUpdateSubscription>;
export type HierarchyUpdateSubscriptionResult = Apollo.SubscriptionResult<HierarchyUpdateSubscription>;
export const LicenseTextDocument = gql`
    query licenseText {
  license {
    text
  }
}
    `;

/**
 * __useLicenseTextQuery__
 *
 * To run a query within a React component, call `useLicenseTextQuery` and pass it any options that fit your needs.
 * When your component renders, `useLicenseTextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLicenseTextQuery({
 *   variables: {
 *   },
 * });
 */
export function useLicenseTextQuery(baseOptions?: Apollo.QueryHookOptions<LicenseTextQuery, LicenseTextQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LicenseTextQuery, LicenseTextQueryVariables>(LicenseTextDocument, options);
      }
export function useLicenseTextLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LicenseTextQuery, LicenseTextQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LicenseTextQuery, LicenseTextQueryVariables>(LicenseTextDocument, options);
        }
// @ts-ignore
export function useLicenseTextSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LicenseTextQuery, LicenseTextQueryVariables>): Apollo.UseSuspenseQueryResult<LicenseTextQuery, LicenseTextQueryVariables>;
export function useLicenseTextSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LicenseTextQuery, LicenseTextQueryVariables>): Apollo.UseSuspenseQueryResult<LicenseTextQuery | undefined, LicenseTextQueryVariables>;
export function useLicenseTextSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LicenseTextQuery, LicenseTextQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LicenseTextQuery, LicenseTextQueryVariables>(LicenseTextDocument, options);
        }
export type LicenseTextQueryHookResult = ReturnType<typeof useLicenseTextQuery>;
export type LicenseTextLazyQueryHookResult = ReturnType<typeof useLicenseTextLazyQuery>;
export type LicenseTextSuspenseQueryHookResult = ReturnType<typeof useLicenseTextSuspenseQuery>;
export type LicenseTextQueryResult = Apollo.QueryResult<LicenseTextQuery, LicenseTextQueryVariables>;
export const LicenseAcceptedDocument = gql`
    query licenseAccepted {
  license {
    isAccepted
  }
}
    `;

/**
 * __useLicenseAcceptedQuery__
 *
 * To run a query within a React component, call `useLicenseAcceptedQuery` and pass it any options that fit your needs.
 * When your component renders, `useLicenseAcceptedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLicenseAcceptedQuery({
 *   variables: {
 *   },
 * });
 */
export function useLicenseAcceptedQuery(baseOptions?: Apollo.QueryHookOptions<LicenseAcceptedQuery, LicenseAcceptedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LicenseAcceptedQuery, LicenseAcceptedQueryVariables>(LicenseAcceptedDocument, options);
      }
export function useLicenseAcceptedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LicenseAcceptedQuery, LicenseAcceptedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LicenseAcceptedQuery, LicenseAcceptedQueryVariables>(LicenseAcceptedDocument, options);
        }
// @ts-ignore
export function useLicenseAcceptedSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LicenseAcceptedQuery, LicenseAcceptedQueryVariables>): Apollo.UseSuspenseQueryResult<LicenseAcceptedQuery, LicenseAcceptedQueryVariables>;
export function useLicenseAcceptedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LicenseAcceptedQuery, LicenseAcceptedQueryVariables>): Apollo.UseSuspenseQueryResult<LicenseAcceptedQuery | undefined, LicenseAcceptedQueryVariables>;
export function useLicenseAcceptedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LicenseAcceptedQuery, LicenseAcceptedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LicenseAcceptedQuery, LicenseAcceptedQueryVariables>(LicenseAcceptedDocument, options);
        }
export type LicenseAcceptedQueryHookResult = ReturnType<typeof useLicenseAcceptedQuery>;
export type LicenseAcceptedLazyQueryHookResult = ReturnType<typeof useLicenseAcceptedLazyQuery>;
export type LicenseAcceptedSuspenseQueryHookResult = ReturnType<typeof useLicenseAcceptedSuspenseQuery>;
export type LicenseAcceptedQueryResult = Apollo.QueryResult<LicenseAcceptedQuery, LicenseAcceptedQueryVariables>;
export const AcceptLicenseDocument = gql`
    mutation acceptLicense {
  acceptLicense
}
    `;
export type AcceptLicenseMutationFn = Apollo.MutationFunction<AcceptLicenseMutation, AcceptLicenseMutationVariables>;

/**
 * __useAcceptLicenseMutation__
 *
 * To run a mutation, you first call `useAcceptLicenseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptLicenseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptLicenseMutation, { data, loading, error }] = useAcceptLicenseMutation({
 *   variables: {
 *   },
 * });
 */
export function useAcceptLicenseMutation(baseOptions?: Apollo.MutationHookOptions<AcceptLicenseMutation, AcceptLicenseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptLicenseMutation, AcceptLicenseMutationVariables>(AcceptLicenseDocument, options);
      }
export type AcceptLicenseMutationHookResult = ReturnType<typeof useAcceptLicenseMutation>;
export type AcceptLicenseMutationResult = Apollo.MutationResult<AcceptLicenseMutation>;
export type AcceptLicenseMutationOptions = Apollo.BaseMutationOptions<AcceptLicenseMutation, AcceptLicenseMutationVariables>;
export const StoreDocument = gql`
    query store {
  store @client {
    session {
      isAdmin
      isLoggedIn
      info {
        ...userInfoFields
      }
    }
    workspace {
      creatingViews {
        viewId
        name
        template
        layout
        widgets {
          widgetId
          index
          propsJSON
        }
        selectedWidget {
          widgetId
          index
          propsJSON
        }
        layoutJSON
      }
      solidConfigJSON
      localViewsJSON
      sharedViewsJSON
    }
    socketEvent {
      type
      timeStamp
    }
    branding {
      CRM_REGISTRATION_URL
      ICON_PATH
      LOGIN_BACKGROUND_PATH
      LOGIN_HEADER_COLOR
      LOGIN_FOOTER_COLOR
      LOGIN_BANNER_TEXT_PATH
      LOGO_PATH
      SOLID_LOGO_VISIBLE
      OEM_BRAND
      OEM_BRAND_NAME
      OEM_COMPANY_LONG
      OEM_COMPANY_PHONE
      OEM_COMPANY_PHONE_INTERNATIONAL
      OEM_COMPANY_QUICKSTART
      OEM_COMPANY_SHORT
      OEM_COMPANY_SUPPORT_PHONE
      OEM_COMPANY_SUPPORT_URL
      OEM_COMPANY_URL
      OEM_COPYRIGHT
      OEM_COPYRIGHT_MATRIX
      OEM_STYLE
      OEM_SUPPORT_EMAIL
      OEM_TRADEMARKS
      QUICK_START_GUIDE_PATH
    }
  }
}
    ${UserInfoFieldsFragmentDoc}`;

/**
 * __useStoreQuery__
 *
 * To run a query within a React component, call `useStoreQuery` and pass it any options that fit your needs.
 * When your component renders, `useStoreQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStoreQuery({
 *   variables: {
 *   },
 * });
 */
export function useStoreQuery(baseOptions?: Apollo.QueryHookOptions<StoreQuery, StoreQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StoreQuery, StoreQueryVariables>(StoreDocument, options);
      }
export function useStoreLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StoreQuery, StoreQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StoreQuery, StoreQueryVariables>(StoreDocument, options);
        }
// @ts-ignore
export function useStoreSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<StoreQuery, StoreQueryVariables>): Apollo.UseSuspenseQueryResult<StoreQuery, StoreQueryVariables>;
export function useStoreSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StoreQuery, StoreQueryVariables>): Apollo.UseSuspenseQueryResult<StoreQuery | undefined, StoreQueryVariables>;
export function useStoreSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StoreQuery, StoreQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StoreQuery, StoreQueryVariables>(StoreDocument, options);
        }
export type StoreQueryHookResult = ReturnType<typeof useStoreQuery>;
export type StoreLazyQueryHookResult = ReturnType<typeof useStoreLazyQuery>;
export type StoreSuspenseQueryHookResult = ReturnType<typeof useStoreSuspenseQuery>;
export type StoreQueryResult = Apollo.QueryResult<StoreQuery, StoreQueryVariables>;
export const SetStoreDocument = gql`
    mutation setStore($store: AppStoreInput!) {
  setStore(store: $store) @client
}
    `;
export type SetStoreMutationFn = Apollo.MutationFunction<SetStoreMutation, SetStoreMutationVariables>;

/**
 * __useSetStoreMutation__
 *
 * To run a mutation, you first call `useSetStoreMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetStoreMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setStoreMutation, { data, loading, error }] = useSetStoreMutation({
 *   variables: {
 *      store: // value for 'store'
 *   },
 * });
 */
export function useSetStoreMutation(baseOptions?: Apollo.MutationHookOptions<SetStoreMutation, SetStoreMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetStoreMutation, SetStoreMutationVariables>(SetStoreDocument, options);
      }
export type SetStoreMutationHookResult = ReturnType<typeof useSetStoreMutation>;
export type SetStoreMutationResult = Apollo.MutationResult<SetStoreMutation>;
export type SetStoreMutationOptions = Apollo.BaseMutationOptions<SetStoreMutation, SetStoreMutationVariables>;
export const GeoLayersDocument = gql`
    query geoLayers {
  geoLayers {
    geoLayers {
      name
      mime
      id
      path
      uploadDate
      enabled
    }
  }
}
    `;

/**
 * __useGeoLayersQuery__
 *
 * To run a query within a React component, call `useGeoLayersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGeoLayersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGeoLayersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGeoLayersQuery(baseOptions?: Apollo.QueryHookOptions<GeoLayersQuery, GeoLayersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GeoLayersQuery, GeoLayersQueryVariables>(GeoLayersDocument, options);
      }
export function useGeoLayersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GeoLayersQuery, GeoLayersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GeoLayersQuery, GeoLayersQueryVariables>(GeoLayersDocument, options);
        }
// @ts-ignore
export function useGeoLayersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GeoLayersQuery, GeoLayersQueryVariables>): Apollo.UseSuspenseQueryResult<GeoLayersQuery, GeoLayersQueryVariables>;
export function useGeoLayersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GeoLayersQuery, GeoLayersQueryVariables>): Apollo.UseSuspenseQueryResult<GeoLayersQuery | undefined, GeoLayersQueryVariables>;
export function useGeoLayersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GeoLayersQuery, GeoLayersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GeoLayersQuery, GeoLayersQueryVariables>(GeoLayersDocument, options);
        }
export type GeoLayersQueryHookResult = ReturnType<typeof useGeoLayersQuery>;
export type GeoLayersLazyQueryHookResult = ReturnType<typeof useGeoLayersLazyQuery>;
export type GeoLayersSuspenseQueryHookResult = ReturnType<typeof useGeoLayersSuspenseQuery>;
export type GeoLayersQueryResult = Apollo.QueryResult<GeoLayersQuery, GeoLayersQueryVariables>;
export const ImageMapConfigDocument = gql`
    query imageMapConfig($version: String!, $lazyLoadImages: Boolean) {
  imageMapConfig(version: $version, lazyLoadImages: $lazyLoadImages) {
    sets {
      ...ImageMapSetFields
    }
  }
}
    ${ImageMapSetFieldsFragmentDoc}`;

/**
 * __useImageMapConfigQuery__
 *
 * To run a query within a React component, call `useImageMapConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useImageMapConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImageMapConfigQuery({
 *   variables: {
 *      version: // value for 'version'
 *      lazyLoadImages: // value for 'lazyLoadImages'
 *   },
 * });
 */
export function useImageMapConfigQuery(baseOptions: Apollo.QueryHookOptions<ImageMapConfigQuery, ImageMapConfigQueryVariables> & ({ variables: ImageMapConfigQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ImageMapConfigQuery, ImageMapConfigQueryVariables>(ImageMapConfigDocument, options);
      }
export function useImageMapConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ImageMapConfigQuery, ImageMapConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ImageMapConfigQuery, ImageMapConfigQueryVariables>(ImageMapConfigDocument, options);
        }
// @ts-ignore
export function useImageMapConfigSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ImageMapConfigQuery, ImageMapConfigQueryVariables>): Apollo.UseSuspenseQueryResult<ImageMapConfigQuery, ImageMapConfigQueryVariables>;
export function useImageMapConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ImageMapConfigQuery, ImageMapConfigQueryVariables>): Apollo.UseSuspenseQueryResult<ImageMapConfigQuery | undefined, ImageMapConfigQueryVariables>;
export function useImageMapConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ImageMapConfigQuery, ImageMapConfigQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ImageMapConfigQuery, ImageMapConfigQueryVariables>(ImageMapConfigDocument, options);
        }
export type ImageMapConfigQueryHookResult = ReturnType<typeof useImageMapConfigQuery>;
export type ImageMapConfigLazyQueryHookResult = ReturnType<typeof useImageMapConfigLazyQuery>;
export type ImageMapConfigSuspenseQueryHookResult = ReturnType<typeof useImageMapConfigSuspenseQuery>;
export type ImageMapConfigQueryResult = Apollo.QueryResult<ImageMapConfigQuery, ImageMapConfigQueryVariables>;
export const ImageMapImageDocument = gql`
    query imageMapImage($version: String!, $mapId: ID!) {
  imageMapImage(version: $version, mapId: $mapId)
}
    `;

/**
 * __useImageMapImageQuery__
 *
 * To run a query within a React component, call `useImageMapImageQuery` and pass it any options that fit your needs.
 * When your component renders, `useImageMapImageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImageMapImageQuery({
 *   variables: {
 *      version: // value for 'version'
 *      mapId: // value for 'mapId'
 *   },
 * });
 */
export function useImageMapImageQuery(baseOptions: Apollo.QueryHookOptions<ImageMapImageQuery, ImageMapImageQueryVariables> & ({ variables: ImageMapImageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ImageMapImageQuery, ImageMapImageQueryVariables>(ImageMapImageDocument, options);
      }
export function useImageMapImageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ImageMapImageQuery, ImageMapImageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ImageMapImageQuery, ImageMapImageQueryVariables>(ImageMapImageDocument, options);
        }
// @ts-ignore
export function useImageMapImageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ImageMapImageQuery, ImageMapImageQueryVariables>): Apollo.UseSuspenseQueryResult<ImageMapImageQuery, ImageMapImageQueryVariables>;
export function useImageMapImageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ImageMapImageQuery, ImageMapImageQueryVariables>): Apollo.UseSuspenseQueryResult<ImageMapImageQuery | undefined, ImageMapImageQueryVariables>;
export function useImageMapImageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ImageMapImageQuery, ImageMapImageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ImageMapImageQuery, ImageMapImageQueryVariables>(ImageMapImageDocument, options);
        }
export type ImageMapImageQueryHookResult = ReturnType<typeof useImageMapImageQuery>;
export type ImageMapImageLazyQueryHookResult = ReturnType<typeof useImageMapImageLazyQuery>;
export type ImageMapImageSuspenseQueryHookResult = ReturnType<typeof useImageMapImageSuspenseQuery>;
export type ImageMapImageQueryResult = Apollo.QueryResult<ImageMapImageQuery, ImageMapImageQueryVariables>;
export const SlewToPointDocument = gql`
    query slewToPoint($latLng: LatLngInput!) {
  slewToPoint(latLng: $latLng)
}
    `;

/**
 * __useSlewToPointQuery__
 *
 * To run a query within a React component, call `useSlewToPointQuery` and pass it any options that fit your needs.
 * When your component renders, `useSlewToPointQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSlewToPointQuery({
 *   variables: {
 *      latLng: // value for 'latLng'
 *   },
 * });
 */
export function useSlewToPointQuery(baseOptions: Apollo.QueryHookOptions<SlewToPointQuery, SlewToPointQueryVariables> & ({ variables: SlewToPointQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SlewToPointQuery, SlewToPointQueryVariables>(SlewToPointDocument, options);
      }
export function useSlewToPointLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SlewToPointQuery, SlewToPointQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SlewToPointQuery, SlewToPointQueryVariables>(SlewToPointDocument, options);
        }
// @ts-ignore
export function useSlewToPointSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SlewToPointQuery, SlewToPointQueryVariables>): Apollo.UseSuspenseQueryResult<SlewToPointQuery, SlewToPointQueryVariables>;
export function useSlewToPointSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SlewToPointQuery, SlewToPointQueryVariables>): Apollo.UseSuspenseQueryResult<SlewToPointQuery | undefined, SlewToPointQueryVariables>;
export function useSlewToPointSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SlewToPointQuery, SlewToPointQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SlewToPointQuery, SlewToPointQueryVariables>(SlewToPointDocument, options);
        }
export type SlewToPointQueryHookResult = ReturnType<typeof useSlewToPointQuery>;
export type SlewToPointLazyQueryHookResult = ReturnType<typeof useSlewToPointLazyQuery>;
export type SlewToPointSuspenseQueryHookResult = ReturnType<typeof useSlewToPointSuspenseQuery>;
export type SlewToPointQueryResult = Apollo.QueryResult<SlewToPointQuery, SlewToPointQueryVariables>;
export const UpdateGeoLayersDocument = gql`
    mutation updateGeoLayers($input: GEOLayersInput!) {
  updateGeoLayers(input: $input)
}
    `;
export type UpdateGeoLayersMutationFn = Apollo.MutationFunction<UpdateGeoLayersMutation, UpdateGeoLayersMutationVariables>;

/**
 * __useUpdateGeoLayersMutation__
 *
 * To run a mutation, you first call `useUpdateGeoLayersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGeoLayersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGeoLayersMutation, { data, loading, error }] = useUpdateGeoLayersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateGeoLayersMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGeoLayersMutation, UpdateGeoLayersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGeoLayersMutation, UpdateGeoLayersMutationVariables>(UpdateGeoLayersDocument, options);
      }
export type UpdateGeoLayersMutationHookResult = ReturnType<typeof useUpdateGeoLayersMutation>;
export type UpdateGeoLayersMutationResult = Apollo.MutationResult<UpdateGeoLayersMutation>;
export type UpdateGeoLayersMutationOptions = Apollo.BaseMutationOptions<UpdateGeoLayersMutation, UpdateGeoLayersMutationVariables>;
export const InsertImageMapSetDocument = gql`
    mutation insertImageMapSet($version: String!, $set: ImageMapSetInput!, $updateId: ID!) {
  insertImageMapSet(version: $version, set: $set, updateId: $updateId)
}
    `;
export type InsertImageMapSetMutationFn = Apollo.MutationFunction<InsertImageMapSetMutation, InsertImageMapSetMutationVariables>;

/**
 * __useInsertImageMapSetMutation__
 *
 * To run a mutation, you first call `useInsertImageMapSetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertImageMapSetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertImageMapSetMutation, { data, loading, error }] = useInsertImageMapSetMutation({
 *   variables: {
 *      version: // value for 'version'
 *      set: // value for 'set'
 *      updateId: // value for 'updateId'
 *   },
 * });
 */
export function useInsertImageMapSetMutation(baseOptions?: Apollo.MutationHookOptions<InsertImageMapSetMutation, InsertImageMapSetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertImageMapSetMutation, InsertImageMapSetMutationVariables>(InsertImageMapSetDocument, options);
      }
export type InsertImageMapSetMutationHookResult = ReturnType<typeof useInsertImageMapSetMutation>;
export type InsertImageMapSetMutationResult = Apollo.MutationResult<InsertImageMapSetMutation>;
export type InsertImageMapSetMutationOptions = Apollo.BaseMutationOptions<InsertImageMapSetMutation, InsertImageMapSetMutationVariables>;
export const RenameImageMapSetDocument = gql`
    mutation renameImageMapSet($version: String!, $setId: ID!, $name: String!, $updateId: ID!) {
  renameImageMapSet(
    version: $version
    setId: $setId
    name: $name
    updateId: $updateId
  )
}
    `;
export type RenameImageMapSetMutationFn = Apollo.MutationFunction<RenameImageMapSetMutation, RenameImageMapSetMutationVariables>;

/**
 * __useRenameImageMapSetMutation__
 *
 * To run a mutation, you first call `useRenameImageMapSetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenameImageMapSetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renameImageMapSetMutation, { data, loading, error }] = useRenameImageMapSetMutation({
 *   variables: {
 *      version: // value for 'version'
 *      setId: // value for 'setId'
 *      name: // value for 'name'
 *      updateId: // value for 'updateId'
 *   },
 * });
 */
export function useRenameImageMapSetMutation(baseOptions?: Apollo.MutationHookOptions<RenameImageMapSetMutation, RenameImageMapSetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RenameImageMapSetMutation, RenameImageMapSetMutationVariables>(RenameImageMapSetDocument, options);
      }
export type RenameImageMapSetMutationHookResult = ReturnType<typeof useRenameImageMapSetMutation>;
export type RenameImageMapSetMutationResult = Apollo.MutationResult<RenameImageMapSetMutation>;
export type RenameImageMapSetMutationOptions = Apollo.BaseMutationOptions<RenameImageMapSetMutation, RenameImageMapSetMutationVariables>;
export const DeleteImageMapSetDocument = gql`
    mutation deleteImageMapSet($version: String!, $setId: ID!, $updateId: ID!) {
  deleteImageMapSet(version: $version, setId: $setId, updateId: $updateId)
}
    `;
export type DeleteImageMapSetMutationFn = Apollo.MutationFunction<DeleteImageMapSetMutation, DeleteImageMapSetMutationVariables>;

/**
 * __useDeleteImageMapSetMutation__
 *
 * To run a mutation, you first call `useDeleteImageMapSetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteImageMapSetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteImageMapSetMutation, { data, loading, error }] = useDeleteImageMapSetMutation({
 *   variables: {
 *      version: // value for 'version'
 *      setId: // value for 'setId'
 *      updateId: // value for 'updateId'
 *   },
 * });
 */
export function useDeleteImageMapSetMutation(baseOptions?: Apollo.MutationHookOptions<DeleteImageMapSetMutation, DeleteImageMapSetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteImageMapSetMutation, DeleteImageMapSetMutationVariables>(DeleteImageMapSetDocument, options);
      }
export type DeleteImageMapSetMutationHookResult = ReturnType<typeof useDeleteImageMapSetMutation>;
export type DeleteImageMapSetMutationResult = Apollo.MutationResult<DeleteImageMapSetMutation>;
export type DeleteImageMapSetMutationOptions = Apollo.BaseMutationOptions<DeleteImageMapSetMutation, DeleteImageMapSetMutationVariables>;
export const InsertImageMapLayerDocument = gql`
    mutation insertImageMapLayer($version: String!, $setId: ID!, $layer: ImageMapLayerInput!, $updateId: ID!) {
  insertImageMapLayer(
    version: $version
    setId: $setId
    layer: $layer
    updateId: $updateId
  )
}
    `;
export type InsertImageMapLayerMutationFn = Apollo.MutationFunction<InsertImageMapLayerMutation, InsertImageMapLayerMutationVariables>;

/**
 * __useInsertImageMapLayerMutation__
 *
 * To run a mutation, you first call `useInsertImageMapLayerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertImageMapLayerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertImageMapLayerMutation, { data, loading, error }] = useInsertImageMapLayerMutation({
 *   variables: {
 *      version: // value for 'version'
 *      setId: // value for 'setId'
 *      layer: // value for 'layer'
 *      updateId: // value for 'updateId'
 *   },
 * });
 */
export function useInsertImageMapLayerMutation(baseOptions?: Apollo.MutationHookOptions<InsertImageMapLayerMutation, InsertImageMapLayerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertImageMapLayerMutation, InsertImageMapLayerMutationVariables>(InsertImageMapLayerDocument, options);
      }
export type InsertImageMapLayerMutationHookResult = ReturnType<typeof useInsertImageMapLayerMutation>;
export type InsertImageMapLayerMutationResult = Apollo.MutationResult<InsertImageMapLayerMutation>;
export type InsertImageMapLayerMutationOptions = Apollo.BaseMutationOptions<InsertImageMapLayerMutation, InsertImageMapLayerMutationVariables>;
export const RenameImageMapLayerDocument = gql`
    mutation renameImageMapLayer($version: String!, $layerId: ID!, $name: String!, $updateId: ID!) {
  renameImageMapLayer(
    version: $version
    layerId: $layerId
    name: $name
    updateId: $updateId
  )
}
    `;
export type RenameImageMapLayerMutationFn = Apollo.MutationFunction<RenameImageMapLayerMutation, RenameImageMapLayerMutationVariables>;

/**
 * __useRenameImageMapLayerMutation__
 *
 * To run a mutation, you first call `useRenameImageMapLayerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenameImageMapLayerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renameImageMapLayerMutation, { data, loading, error }] = useRenameImageMapLayerMutation({
 *   variables: {
 *      version: // value for 'version'
 *      layerId: // value for 'layerId'
 *      name: // value for 'name'
 *      updateId: // value for 'updateId'
 *   },
 * });
 */
export function useRenameImageMapLayerMutation(baseOptions?: Apollo.MutationHookOptions<RenameImageMapLayerMutation, RenameImageMapLayerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RenameImageMapLayerMutation, RenameImageMapLayerMutationVariables>(RenameImageMapLayerDocument, options);
      }
export type RenameImageMapLayerMutationHookResult = ReturnType<typeof useRenameImageMapLayerMutation>;
export type RenameImageMapLayerMutationResult = Apollo.MutationResult<RenameImageMapLayerMutation>;
export type RenameImageMapLayerMutationOptions = Apollo.BaseMutationOptions<RenameImageMapLayerMutation, RenameImageMapLayerMutationVariables>;
export const DeleteImageMapLayerDocument = gql`
    mutation deleteImageMapLayer($version: String!, $layerId: ID!, $updateId: ID!) {
  deleteImageMapLayer(version: $version, layerId: $layerId, updateId: $updateId)
}
    `;
export type DeleteImageMapLayerMutationFn = Apollo.MutationFunction<DeleteImageMapLayerMutation, DeleteImageMapLayerMutationVariables>;

/**
 * __useDeleteImageMapLayerMutation__
 *
 * To run a mutation, you first call `useDeleteImageMapLayerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteImageMapLayerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteImageMapLayerMutation, { data, loading, error }] = useDeleteImageMapLayerMutation({
 *   variables: {
 *      version: // value for 'version'
 *      layerId: // value for 'layerId'
 *      updateId: // value for 'updateId'
 *   },
 * });
 */
export function useDeleteImageMapLayerMutation(baseOptions?: Apollo.MutationHookOptions<DeleteImageMapLayerMutation, DeleteImageMapLayerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteImageMapLayerMutation, DeleteImageMapLayerMutationVariables>(DeleteImageMapLayerDocument, options);
      }
export type DeleteImageMapLayerMutationHookResult = ReturnType<typeof useDeleteImageMapLayerMutation>;
export type DeleteImageMapLayerMutationResult = Apollo.MutationResult<DeleteImageMapLayerMutation>;
export type DeleteImageMapLayerMutationOptions = Apollo.BaseMutationOptions<DeleteImageMapLayerMutation, DeleteImageMapLayerMutationVariables>;
export const UpdateImageMapDocument = gql`
    mutation updateImageMap($version: String!, $map: ImageMapInput!, $updateId: ID!) {
  updateImageMap(version: $version, map: $map, updateId: $updateId)
}
    `;
export type UpdateImageMapMutationFn = Apollo.MutationFunction<UpdateImageMapMutation, UpdateImageMapMutationVariables>;

/**
 * __useUpdateImageMapMutation__
 *
 * To run a mutation, you first call `useUpdateImageMapMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateImageMapMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateImageMapMutation, { data, loading, error }] = useUpdateImageMapMutation({
 *   variables: {
 *      version: // value for 'version'
 *      map: // value for 'map'
 *      updateId: // value for 'updateId'
 *   },
 * });
 */
export function useUpdateImageMapMutation(baseOptions?: Apollo.MutationHookOptions<UpdateImageMapMutation, UpdateImageMapMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateImageMapMutation, UpdateImageMapMutationVariables>(UpdateImageMapDocument, options);
      }
export type UpdateImageMapMutationHookResult = ReturnType<typeof useUpdateImageMapMutation>;
export type UpdateImageMapMutationResult = Apollo.MutationResult<UpdateImageMapMutation>;
export type UpdateImageMapMutationOptions = Apollo.BaseMutationOptions<UpdateImageMapMutation, UpdateImageMapMutationVariables>;
export const InsertImageMapObjectDocument = gql`
    mutation insertImageMapObject($version: String!, $mapId: ID!, $object: ImageMapObjectInput!, $updateId: ID!) {
  insertImageMapObject(
    version: $version
    mapId: $mapId
    object: $object
    updateId: $updateId
  )
}
    `;
export type InsertImageMapObjectMutationFn = Apollo.MutationFunction<InsertImageMapObjectMutation, InsertImageMapObjectMutationVariables>;

/**
 * __useInsertImageMapObjectMutation__
 *
 * To run a mutation, you first call `useInsertImageMapObjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertImageMapObjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertImageMapObjectMutation, { data, loading, error }] = useInsertImageMapObjectMutation({
 *   variables: {
 *      version: // value for 'version'
 *      mapId: // value for 'mapId'
 *      object: // value for 'object'
 *      updateId: // value for 'updateId'
 *   },
 * });
 */
export function useInsertImageMapObjectMutation(baseOptions?: Apollo.MutationHookOptions<InsertImageMapObjectMutation, InsertImageMapObjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertImageMapObjectMutation, InsertImageMapObjectMutationVariables>(InsertImageMapObjectDocument, options);
      }
export type InsertImageMapObjectMutationHookResult = ReturnType<typeof useInsertImageMapObjectMutation>;
export type InsertImageMapObjectMutationResult = Apollo.MutationResult<InsertImageMapObjectMutation>;
export type InsertImageMapObjectMutationOptions = Apollo.BaseMutationOptions<InsertImageMapObjectMutation, InsertImageMapObjectMutationVariables>;
export const UpdateImageMapObjectDocument = gql`
    mutation updateImageMapObject($version: String!, $object: ImageMapObjectInput!, $updateId: ID!) {
  updateImageMapObject(version: $version, object: $object, updateId: $updateId)
}
    `;
export type UpdateImageMapObjectMutationFn = Apollo.MutationFunction<UpdateImageMapObjectMutation, UpdateImageMapObjectMutationVariables>;

/**
 * __useUpdateImageMapObjectMutation__
 *
 * To run a mutation, you first call `useUpdateImageMapObjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateImageMapObjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateImageMapObjectMutation, { data, loading, error }] = useUpdateImageMapObjectMutation({
 *   variables: {
 *      version: // value for 'version'
 *      object: // value for 'object'
 *      updateId: // value for 'updateId'
 *   },
 * });
 */
export function useUpdateImageMapObjectMutation(baseOptions?: Apollo.MutationHookOptions<UpdateImageMapObjectMutation, UpdateImageMapObjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateImageMapObjectMutation, UpdateImageMapObjectMutationVariables>(UpdateImageMapObjectDocument, options);
      }
export type UpdateImageMapObjectMutationHookResult = ReturnType<typeof useUpdateImageMapObjectMutation>;
export type UpdateImageMapObjectMutationResult = Apollo.MutationResult<UpdateImageMapObjectMutation>;
export type UpdateImageMapObjectMutationOptions = Apollo.BaseMutationOptions<UpdateImageMapObjectMutation, UpdateImageMapObjectMutationVariables>;
export const DeleteImageMapObjectDocument = gql`
    mutation deleteImageMapObject($version: String!, $objectId: ID!, $updateId: ID!) {
  deleteImageMapObject(
    version: $version
    objectId: $objectId
    updateId: $updateId
  )
}
    `;
export type DeleteImageMapObjectMutationFn = Apollo.MutationFunction<DeleteImageMapObjectMutation, DeleteImageMapObjectMutationVariables>;

/**
 * __useDeleteImageMapObjectMutation__
 *
 * To run a mutation, you first call `useDeleteImageMapObjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteImageMapObjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteImageMapObjectMutation, { data, loading, error }] = useDeleteImageMapObjectMutation({
 *   variables: {
 *      version: // value for 'version'
 *      objectId: // value for 'objectId'
 *      updateId: // value for 'updateId'
 *   },
 * });
 */
export function useDeleteImageMapObjectMutation(baseOptions?: Apollo.MutationHookOptions<DeleteImageMapObjectMutation, DeleteImageMapObjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteImageMapObjectMutation, DeleteImageMapObjectMutationVariables>(DeleteImageMapObjectDocument, options);
      }
export type DeleteImageMapObjectMutationHookResult = ReturnType<typeof useDeleteImageMapObjectMutation>;
export type DeleteImageMapObjectMutationResult = Apollo.MutationResult<DeleteImageMapObjectMutation>;
export type DeleteImageMapObjectMutationOptions = Apollo.BaseMutationOptions<DeleteImageMapObjectMutation, DeleteImageMapObjectMutationVariables>;
export const DeleteGeoLayerDocument = gql`
    mutation deleteGeoLayer($id: ID!) {
  deleteGeoLayer(id: $id)
}
    `;
export type DeleteGeoLayerMutationFn = Apollo.MutationFunction<DeleteGeoLayerMutation, DeleteGeoLayerMutationVariables>;

/**
 * __useDeleteGeoLayerMutation__
 *
 * To run a mutation, you first call `useDeleteGeoLayerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGeoLayerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteGeoLayerMutation, { data, loading, error }] = useDeleteGeoLayerMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteGeoLayerMutation(baseOptions?: Apollo.MutationHookOptions<DeleteGeoLayerMutation, DeleteGeoLayerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteGeoLayerMutation, DeleteGeoLayerMutationVariables>(DeleteGeoLayerDocument, options);
      }
export type DeleteGeoLayerMutationHookResult = ReturnType<typeof useDeleteGeoLayerMutation>;
export type DeleteGeoLayerMutationResult = Apollo.MutationResult<DeleteGeoLayerMutation>;
export type DeleteGeoLayerMutationOptions = Apollo.BaseMutationOptions<DeleteGeoLayerMutation, DeleteGeoLayerMutationVariables>;
export const ImageMapUpdateDocument = gql`
    subscription imageMapUpdate($version: String!) {
  imageMapUpdate(version: $version) {
    action
    updateId
    set {
      ...ImageMapSetFields
    }
    layer {
      ...ImageMapLayerFields
    }
    map {
      ...ImageMapFields
    }
    object {
      ...ImageMapObjectFields
    }
    setName
    layerName
    setId
    layerId
    mapId
    objectId
  }
}
    ${ImageMapSetFieldsFragmentDoc}
${ImageMapLayerFieldsFragmentDoc}
${ImageMapFieldsFragmentDoc}
${ImageMapObjectFieldsFragmentDoc}`;

/**
 * __useImageMapUpdateSubscription__
 *
 * To run a query within a React component, call `useImageMapUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useImageMapUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImageMapUpdateSubscription({
 *   variables: {
 *      version: // value for 'version'
 *   },
 * });
 */
export function useImageMapUpdateSubscription(baseOptions: Apollo.SubscriptionHookOptions<ImageMapUpdateSubscription, ImageMapUpdateSubscriptionVariables> & ({ variables: ImageMapUpdateSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ImageMapUpdateSubscription, ImageMapUpdateSubscriptionVariables>(ImageMapUpdateDocument, options);
      }
export type ImageMapUpdateSubscriptionHookResult = ReturnType<typeof useImageMapUpdateSubscription>;
export type ImageMapUpdateSubscriptionResult = Apollo.SubscriptionResult<ImageMapUpdateSubscription>;
export const RealmDocument = gql`
    query realm {
  realm {
    ...realmFields
  }
}
    ${RealmFieldsFragmentDoc}`;

/**
 * __useRealmQuery__
 *
 * To run a query within a React component, call `useRealmQuery` and pass it any options that fit your needs.
 * When your component renders, `useRealmQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRealmQuery({
 *   variables: {
 *   },
 * });
 */
export function useRealmQuery(baseOptions?: Apollo.QueryHookOptions<RealmQuery, RealmQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RealmQuery, RealmQueryVariables>(RealmDocument, options);
      }
export function useRealmLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RealmQuery, RealmQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RealmQuery, RealmQueryVariables>(RealmDocument, options);
        }
// @ts-ignore
export function useRealmSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RealmQuery, RealmQueryVariables>): Apollo.UseSuspenseQueryResult<RealmQuery, RealmQueryVariables>;
export function useRealmSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RealmQuery, RealmQueryVariables>): Apollo.UseSuspenseQueryResult<RealmQuery | undefined, RealmQueryVariables>;
export function useRealmSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RealmQuery, RealmQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RealmQuery, RealmQueryVariables>(RealmDocument, options);
        }
export type RealmQueryHookResult = ReturnType<typeof useRealmQuery>;
export type RealmLazyQueryHookResult = ReturnType<typeof useRealmLazyQuery>;
export type RealmSuspenseQueryHookResult = ReturnType<typeof useRealmSuspenseQuery>;
export type RealmQueryResult = Apollo.QueryResult<RealmQuery, RealmQueryVariables>;
export const RealmForPlayerDocument = gql`
    query realmForPlayer {
  realm {
    jitterBufferLength
    playerIdleTimeout
  }
}
    `;

/**
 * __useRealmForPlayerQuery__
 *
 * To run a query within a React component, call `useRealmForPlayerQuery` and pass it any options that fit your needs.
 * When your component renders, `useRealmForPlayerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRealmForPlayerQuery({
 *   variables: {
 *   },
 * });
 */
export function useRealmForPlayerQuery(baseOptions?: Apollo.QueryHookOptions<RealmForPlayerQuery, RealmForPlayerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RealmForPlayerQuery, RealmForPlayerQueryVariables>(RealmForPlayerDocument, options);
      }
export function useRealmForPlayerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RealmForPlayerQuery, RealmForPlayerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RealmForPlayerQuery, RealmForPlayerQueryVariables>(RealmForPlayerDocument, options);
        }
// @ts-ignore
export function useRealmForPlayerSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RealmForPlayerQuery, RealmForPlayerQueryVariables>): Apollo.UseSuspenseQueryResult<RealmForPlayerQuery, RealmForPlayerQueryVariables>;
export function useRealmForPlayerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RealmForPlayerQuery, RealmForPlayerQueryVariables>): Apollo.UseSuspenseQueryResult<RealmForPlayerQuery | undefined, RealmForPlayerQueryVariables>;
export function useRealmForPlayerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RealmForPlayerQuery, RealmForPlayerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RealmForPlayerQuery, RealmForPlayerQueryVariables>(RealmForPlayerDocument, options);
        }
export type RealmForPlayerQueryHookResult = ReturnType<typeof useRealmForPlayerQuery>;
export type RealmForPlayerLazyQueryHookResult = ReturnType<typeof useRealmForPlayerLazyQuery>;
export type RealmForPlayerSuspenseQueryHookResult = ReturnType<typeof useRealmForPlayerSuspenseQuery>;
export type RealmForPlayerQueryResult = Apollo.QueryResult<RealmForPlayerQuery, RealmForPlayerQueryVariables>;
export const IdentityAttributeDocument = gql`
    query identityAttribute {
  identityAttribute {
    contactUs
  }
}
    `;

/**
 * __useIdentityAttributeQuery__
 *
 * To run a query within a React component, call `useIdentityAttributeQuery` and pass it any options that fit your needs.
 * When your component renders, `useIdentityAttributeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIdentityAttributeQuery({
 *   variables: {
 *   },
 * });
 */
export function useIdentityAttributeQuery(baseOptions?: Apollo.QueryHookOptions<IdentityAttributeQuery, IdentityAttributeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IdentityAttributeQuery, IdentityAttributeQueryVariables>(IdentityAttributeDocument, options);
      }
export function useIdentityAttributeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IdentityAttributeQuery, IdentityAttributeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IdentityAttributeQuery, IdentityAttributeQueryVariables>(IdentityAttributeDocument, options);
        }
// @ts-ignore
export function useIdentityAttributeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<IdentityAttributeQuery, IdentityAttributeQueryVariables>): Apollo.UseSuspenseQueryResult<IdentityAttributeQuery, IdentityAttributeQueryVariables>;
export function useIdentityAttributeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IdentityAttributeQuery, IdentityAttributeQueryVariables>): Apollo.UseSuspenseQueryResult<IdentityAttributeQuery | undefined, IdentityAttributeQueryVariables>;
export function useIdentityAttributeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IdentityAttributeQuery, IdentityAttributeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IdentityAttributeQuery, IdentityAttributeQueryVariables>(IdentityAttributeDocument, options);
        }
export type IdentityAttributeQueryHookResult = ReturnType<typeof useIdentityAttributeQuery>;
export type IdentityAttributeLazyQueryHookResult = ReturnType<typeof useIdentityAttributeLazyQuery>;
export type IdentityAttributeSuspenseQueryHookResult = ReturnType<typeof useIdentityAttributeSuspenseQuery>;
export type IdentityAttributeQueryResult = Apollo.QueryResult<IdentityAttributeQuery, IdentityAttributeQueryVariables>;
export const SessionInfoDocument = gql`
    query sessionInfo {
  sessionInfo
}
    `;

/**
 * __useSessionInfoQuery__
 *
 * To run a query within a React component, call `useSessionInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useSessionInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSessionInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useSessionInfoQuery(baseOptions?: Apollo.QueryHookOptions<SessionInfoQuery, SessionInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SessionInfoQuery, SessionInfoQueryVariables>(SessionInfoDocument, options);
      }
export function useSessionInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SessionInfoQuery, SessionInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SessionInfoQuery, SessionInfoQueryVariables>(SessionInfoDocument, options);
        }
// @ts-ignore
export function useSessionInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SessionInfoQuery, SessionInfoQueryVariables>): Apollo.UseSuspenseQueryResult<SessionInfoQuery, SessionInfoQueryVariables>;
export function useSessionInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SessionInfoQuery, SessionInfoQueryVariables>): Apollo.UseSuspenseQueryResult<SessionInfoQuery | undefined, SessionInfoQueryVariables>;
export function useSessionInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SessionInfoQuery, SessionInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SessionInfoQuery, SessionInfoQueryVariables>(SessionInfoDocument, options);
        }
export type SessionInfoQueryHookResult = ReturnType<typeof useSessionInfoQuery>;
export type SessionInfoLazyQueryHookResult = ReturnType<typeof useSessionInfoLazyQuery>;
export type SessionInfoSuspenseQueryHookResult = ReturnType<typeof useSessionInfoSuspenseQuery>;
export type SessionInfoQueryResult = Apollo.QueryResult<SessionInfoQuery, SessionInfoQueryVariables>;
export const BrandingDocument = gql`
    query branding {
  branding {
    crmRegistrationUrl
    iconPath
    loginBackgroundPath
    loginFooterColor
    logoPath
    oemBrand
    oemBrandName
    oemCompanyLong
    oemCompanyPhone
    oemCompanyPhoneInternational
    oemCompanyQuickstart
    oemCompanyShort
    oemCompanySupportPhone
    oemCompanySupportUrl
    oemCompanyUrl
    oemCopyright
    oemCopyrightMatrix
    oemStyle
    oemSupportEmail
    oemTrademarks
    quickStartGuidePath
  }
}
    `;

/**
 * __useBrandingQuery__
 *
 * To run a query within a React component, call `useBrandingQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandingQuery({
 *   variables: {
 *   },
 * });
 */
export function useBrandingQuery(baseOptions?: Apollo.QueryHookOptions<BrandingQuery, BrandingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrandingQuery, BrandingQueryVariables>(BrandingDocument, options);
      }
export function useBrandingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrandingQuery, BrandingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrandingQuery, BrandingQueryVariables>(BrandingDocument, options);
        }
// @ts-ignore
export function useBrandingSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BrandingQuery, BrandingQueryVariables>): Apollo.UseSuspenseQueryResult<BrandingQuery, BrandingQueryVariables>;
export function useBrandingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BrandingQuery, BrandingQueryVariables>): Apollo.UseSuspenseQueryResult<BrandingQuery | undefined, BrandingQueryVariables>;
export function useBrandingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BrandingQuery, BrandingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BrandingQuery, BrandingQueryVariables>(BrandingDocument, options);
        }
export type BrandingQueryHookResult = ReturnType<typeof useBrandingQuery>;
export type BrandingLazyQueryHookResult = ReturnType<typeof useBrandingLazyQuery>;
export type BrandingSuspenseQueryHookResult = ReturnType<typeof useBrandingSuspenseQuery>;
export type BrandingQueryResult = Apollo.QueryResult<BrandingQuery, BrandingQueryVariables>;
export const LanguagesDocument = gql`
    query languages {
  languages {
    languages {
      tag
      description
      direction
    }
  }
}
    `;

/**
 * __useLanguagesQuery__
 *
 * To run a query within a React component, call `useLanguagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useLanguagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLanguagesQuery({
 *   variables: {
 *   },
 * });
 */
export function useLanguagesQuery(baseOptions?: Apollo.QueryHookOptions<LanguagesQuery, LanguagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LanguagesQuery, LanguagesQueryVariables>(LanguagesDocument, options);
      }
export function useLanguagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LanguagesQuery, LanguagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LanguagesQuery, LanguagesQueryVariables>(LanguagesDocument, options);
        }
// @ts-ignore
export function useLanguagesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LanguagesQuery, LanguagesQueryVariables>): Apollo.UseSuspenseQueryResult<LanguagesQuery, LanguagesQueryVariables>;
export function useLanguagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LanguagesQuery, LanguagesQueryVariables>): Apollo.UseSuspenseQueryResult<LanguagesQuery | undefined, LanguagesQueryVariables>;
export function useLanguagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LanguagesQuery, LanguagesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LanguagesQuery, LanguagesQueryVariables>(LanguagesDocument, options);
        }
export type LanguagesQueryHookResult = ReturnType<typeof useLanguagesQuery>;
export type LanguagesLazyQueryHookResult = ReturnType<typeof useLanguagesLazyQuery>;
export type LanguagesSuspenseQueryHookResult = ReturnType<typeof useLanguagesSuspenseQuery>;
export type LanguagesQueryResult = Apollo.QueryResult<LanguagesQuery, LanguagesQueryVariables>;
export const EmailCanBeSendDocument = gql`
    query emailCanBeSend {
  emailCanBeSend
}
    `;

/**
 * __useEmailCanBeSendQuery__
 *
 * To run a query within a React component, call `useEmailCanBeSendQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmailCanBeSendQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmailCanBeSendQuery({
 *   variables: {
 *   },
 * });
 */
export function useEmailCanBeSendQuery(baseOptions?: Apollo.QueryHookOptions<EmailCanBeSendQuery, EmailCanBeSendQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmailCanBeSendQuery, EmailCanBeSendQueryVariables>(EmailCanBeSendDocument, options);
      }
export function useEmailCanBeSendLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmailCanBeSendQuery, EmailCanBeSendQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmailCanBeSendQuery, EmailCanBeSendQueryVariables>(EmailCanBeSendDocument, options);
        }
// @ts-ignore
export function useEmailCanBeSendSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EmailCanBeSendQuery, EmailCanBeSendQueryVariables>): Apollo.UseSuspenseQueryResult<EmailCanBeSendQuery, EmailCanBeSendQueryVariables>;
export function useEmailCanBeSendSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmailCanBeSendQuery, EmailCanBeSendQueryVariables>): Apollo.UseSuspenseQueryResult<EmailCanBeSendQuery | undefined, EmailCanBeSendQueryVariables>;
export function useEmailCanBeSendSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmailCanBeSendQuery, EmailCanBeSendQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EmailCanBeSendQuery, EmailCanBeSendQueryVariables>(EmailCanBeSendDocument, options);
        }
export type EmailCanBeSendQueryHookResult = ReturnType<typeof useEmailCanBeSendQuery>;
export type EmailCanBeSendLazyQueryHookResult = ReturnType<typeof useEmailCanBeSendLazyQuery>;
export type EmailCanBeSendSuspenseQueryHookResult = ReturnType<typeof useEmailCanBeSendSuspenseQuery>;
export type EmailCanBeSendQueryResult = Apollo.QueryResult<EmailCanBeSendQuery, EmailCanBeSendQueryVariables>;
export const SystemParametersDocument = gql`
    query systemParameters {
  systemParameters {
    updatesHost
    solidAppVersion
    googleYouTubeApiKey
    googleYouTubePlaylistId
    geoDefaultPosition {
      lat
      lng
    }
  }
}
    `;

/**
 * __useSystemParametersQuery__
 *
 * To run a query within a React component, call `useSystemParametersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSystemParametersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSystemParametersQuery({
 *   variables: {
 *   },
 * });
 */
export function useSystemParametersQuery(baseOptions?: Apollo.QueryHookOptions<SystemParametersQuery, SystemParametersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SystemParametersQuery, SystemParametersQueryVariables>(SystemParametersDocument, options);
      }
export function useSystemParametersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SystemParametersQuery, SystemParametersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SystemParametersQuery, SystemParametersQueryVariables>(SystemParametersDocument, options);
        }
// @ts-ignore
export function useSystemParametersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SystemParametersQuery, SystemParametersQueryVariables>): Apollo.UseSuspenseQueryResult<SystemParametersQuery, SystemParametersQueryVariables>;
export function useSystemParametersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SystemParametersQuery, SystemParametersQueryVariables>): Apollo.UseSuspenseQueryResult<SystemParametersQuery | undefined, SystemParametersQueryVariables>;
export function useSystemParametersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SystemParametersQuery, SystemParametersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SystemParametersQuery, SystemParametersQueryVariables>(SystemParametersDocument, options);
        }
export type SystemParametersQueryHookResult = ReturnType<typeof useSystemParametersQuery>;
export type SystemParametersLazyQueryHookResult = ReturnType<typeof useSystemParametersLazyQuery>;
export type SystemParametersSuspenseQueryHookResult = ReturnType<typeof useSystemParametersSuspenseQuery>;
export type SystemParametersQueryResult = Apollo.QueryResult<SystemParametersQuery, SystemParametersQueryVariables>;
export const RealmGeoZoneDocument = gql`
    query realmGeoZone {
  realm {
    id
    name
    geoZone
  }
}
    `;

/**
 * __useRealmGeoZoneQuery__
 *
 * To run a query within a React component, call `useRealmGeoZoneQuery` and pass it any options that fit your needs.
 * When your component renders, `useRealmGeoZoneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRealmGeoZoneQuery({
 *   variables: {
 *   },
 * });
 */
export function useRealmGeoZoneQuery(baseOptions?: Apollo.QueryHookOptions<RealmGeoZoneQuery, RealmGeoZoneQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RealmGeoZoneQuery, RealmGeoZoneQueryVariables>(RealmGeoZoneDocument, options);
      }
export function useRealmGeoZoneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RealmGeoZoneQuery, RealmGeoZoneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RealmGeoZoneQuery, RealmGeoZoneQueryVariables>(RealmGeoZoneDocument, options);
        }
// @ts-ignore
export function useRealmGeoZoneSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RealmGeoZoneQuery, RealmGeoZoneQueryVariables>): Apollo.UseSuspenseQueryResult<RealmGeoZoneQuery, RealmGeoZoneQueryVariables>;
export function useRealmGeoZoneSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RealmGeoZoneQuery, RealmGeoZoneQueryVariables>): Apollo.UseSuspenseQueryResult<RealmGeoZoneQuery | undefined, RealmGeoZoneQueryVariables>;
export function useRealmGeoZoneSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RealmGeoZoneQuery, RealmGeoZoneQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RealmGeoZoneQuery, RealmGeoZoneQueryVariables>(RealmGeoZoneDocument, options);
        }
export type RealmGeoZoneQueryHookResult = ReturnType<typeof useRealmGeoZoneQuery>;
export type RealmGeoZoneLazyQueryHookResult = ReturnType<typeof useRealmGeoZoneLazyQuery>;
export type RealmGeoZoneSuspenseQueryHookResult = ReturnType<typeof useRealmGeoZoneSuspenseQuery>;
export type RealmGeoZoneQueryResult = Apollo.QueryResult<RealmGeoZoneQuery, RealmGeoZoneQueryVariables>;
export const RealmClusterConfigDocument = gql`
    query realmClusterConfig {
  realm {
    id
    name
    geoMarkerClusterConfig {
      disableClusteringAtZoom
      enabled
      mapType
      maxClusterRadius
    }
  }
}
    `;

/**
 * __useRealmClusterConfigQuery__
 *
 * To run a query within a React component, call `useRealmClusterConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useRealmClusterConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRealmClusterConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useRealmClusterConfigQuery(baseOptions?: Apollo.QueryHookOptions<RealmClusterConfigQuery, RealmClusterConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RealmClusterConfigQuery, RealmClusterConfigQueryVariables>(RealmClusterConfigDocument, options);
      }
export function useRealmClusterConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RealmClusterConfigQuery, RealmClusterConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RealmClusterConfigQuery, RealmClusterConfigQueryVariables>(RealmClusterConfigDocument, options);
        }
// @ts-ignore
export function useRealmClusterConfigSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RealmClusterConfigQuery, RealmClusterConfigQueryVariables>): Apollo.UseSuspenseQueryResult<RealmClusterConfigQuery, RealmClusterConfigQueryVariables>;
export function useRealmClusterConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RealmClusterConfigQuery, RealmClusterConfigQueryVariables>): Apollo.UseSuspenseQueryResult<RealmClusterConfigQuery | undefined, RealmClusterConfigQueryVariables>;
export function useRealmClusterConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RealmClusterConfigQuery, RealmClusterConfigQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RealmClusterConfigQuery, RealmClusterConfigQueryVariables>(RealmClusterConfigDocument, options);
        }
export type RealmClusterConfigQueryHookResult = ReturnType<typeof useRealmClusterConfigQuery>;
export type RealmClusterConfigLazyQueryHookResult = ReturnType<typeof useRealmClusterConfigLazyQuery>;
export type RealmClusterConfigSuspenseQueryHookResult = ReturnType<typeof useRealmClusterConfigSuspenseQuery>;
export type RealmClusterConfigQueryResult = Apollo.QueryResult<RealmClusterConfigQuery, RealmClusterConfigQueryVariables>;
export const GetGrafanaDashboardsDocument = gql`
    query getGrafanaDashboards($folderId: String!) {
  grafanaDashboards(folderId: $folderId) {
    title
    url
  }
}
    `;

/**
 * __useGetGrafanaDashboardsQuery__
 *
 * To run a query within a React component, call `useGetGrafanaDashboardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGrafanaDashboardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGrafanaDashboardsQuery({
 *   variables: {
 *      folderId: // value for 'folderId'
 *   },
 * });
 */
export function useGetGrafanaDashboardsQuery(baseOptions: Apollo.QueryHookOptions<GetGrafanaDashboardsQuery, GetGrafanaDashboardsQueryVariables> & ({ variables: GetGrafanaDashboardsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGrafanaDashboardsQuery, GetGrafanaDashboardsQueryVariables>(GetGrafanaDashboardsDocument, options);
      }
export function useGetGrafanaDashboardsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGrafanaDashboardsQuery, GetGrafanaDashboardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGrafanaDashboardsQuery, GetGrafanaDashboardsQueryVariables>(GetGrafanaDashboardsDocument, options);
        }
// @ts-ignore
export function useGetGrafanaDashboardsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetGrafanaDashboardsQuery, GetGrafanaDashboardsQueryVariables>): Apollo.UseSuspenseQueryResult<GetGrafanaDashboardsQuery, GetGrafanaDashboardsQueryVariables>;
export function useGetGrafanaDashboardsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGrafanaDashboardsQuery, GetGrafanaDashboardsQueryVariables>): Apollo.UseSuspenseQueryResult<GetGrafanaDashboardsQuery | undefined, GetGrafanaDashboardsQueryVariables>;
export function useGetGrafanaDashboardsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGrafanaDashboardsQuery, GetGrafanaDashboardsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGrafanaDashboardsQuery, GetGrafanaDashboardsQueryVariables>(GetGrafanaDashboardsDocument, options);
        }
export type GetGrafanaDashboardsQueryHookResult = ReturnType<typeof useGetGrafanaDashboardsQuery>;
export type GetGrafanaDashboardsLazyQueryHookResult = ReturnType<typeof useGetGrafanaDashboardsLazyQuery>;
export type GetGrafanaDashboardsSuspenseQueryHookResult = ReturnType<typeof useGetGrafanaDashboardsSuspenseQuery>;
export type GetGrafanaDashboardsQueryResult = Apollo.QueryResult<GetGrafanaDashboardsQuery, GetGrafanaDashboardsQueryVariables>;
export const ActivateAvatarDocument = gql`
    mutation activateAvatar($avatarId: ID!) {
  activateAvatar(avatarId: $avatarId)
}
    `;
export type ActivateAvatarMutationFn = Apollo.MutationFunction<ActivateAvatarMutation, ActivateAvatarMutationVariables>;

/**
 * __useActivateAvatarMutation__
 *
 * To run a mutation, you first call `useActivateAvatarMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateAvatarMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateAvatarMutation, { data, loading, error }] = useActivateAvatarMutation({
 *   variables: {
 *      avatarId: // value for 'avatarId'
 *   },
 * });
 */
export function useActivateAvatarMutation(baseOptions?: Apollo.MutationHookOptions<ActivateAvatarMutation, ActivateAvatarMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActivateAvatarMutation, ActivateAvatarMutationVariables>(ActivateAvatarDocument, options);
      }
export type ActivateAvatarMutationHookResult = ReturnType<typeof useActivateAvatarMutation>;
export type ActivateAvatarMutationResult = Apollo.MutationResult<ActivateAvatarMutation>;
export type ActivateAvatarMutationOptions = Apollo.BaseMutationOptions<ActivateAvatarMutation, ActivateAvatarMutationVariables>;
export const VerifyCodeDocument = gql`
    mutation verifyCode($code: String!) {
  verifyCode(code: $code)
}
    `;
export type VerifyCodeMutationFn = Apollo.MutationFunction<VerifyCodeMutation, VerifyCodeMutationVariables>;

/**
 * __useVerifyCodeMutation__
 *
 * To run a mutation, you first call `useVerifyCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyCodeMutation, { data, loading, error }] = useVerifyCodeMutation({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useVerifyCodeMutation(baseOptions?: Apollo.MutationHookOptions<VerifyCodeMutation, VerifyCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyCodeMutation, VerifyCodeMutationVariables>(VerifyCodeDocument, options);
      }
export type VerifyCodeMutationHookResult = ReturnType<typeof useVerifyCodeMutation>;
export type VerifyCodeMutationResult = Apollo.MutationResult<VerifyCodeMutation>;
export type VerifyCodeMutationOptions = Apollo.BaseMutationOptions<VerifyCodeMutation, VerifyCodeMutationVariables>;
export const ActivateEmailDocument = gql`
    mutation activateEmail($input: SecretPassword!) {
  activateEmail(input: $input)
}
    `;
export type ActivateEmailMutationFn = Apollo.MutationFunction<ActivateEmailMutation, ActivateEmailMutationVariables>;

/**
 * __useActivateEmailMutation__
 *
 * To run a mutation, you first call `useActivateEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateEmailMutation, { data, loading, error }] = useActivateEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useActivateEmailMutation(baseOptions?: Apollo.MutationHookOptions<ActivateEmailMutation, ActivateEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActivateEmailMutation, ActivateEmailMutationVariables>(ActivateEmailDocument, options);
      }
export type ActivateEmailMutationHookResult = ReturnType<typeof useActivateEmailMutation>;
export type ActivateEmailMutationResult = Apollo.MutationResult<ActivateEmailMutation>;
export type ActivateEmailMutationOptions = Apollo.BaseMutationOptions<ActivateEmailMutation, ActivateEmailMutationVariables>;
export const RestorePasswordDocument = gql`
    mutation restorePassword($input: SecretPassword!) {
  restorePassword(input: $input)
}
    `;
export type RestorePasswordMutationFn = Apollo.MutationFunction<RestorePasswordMutation, RestorePasswordMutationVariables>;

/**
 * __useRestorePasswordMutation__
 *
 * To run a mutation, you first call `useRestorePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestorePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restorePasswordMutation, { data, loading, error }] = useRestorePasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRestorePasswordMutation(baseOptions?: Apollo.MutationHookOptions<RestorePasswordMutation, RestorePasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestorePasswordMutation, RestorePasswordMutationVariables>(RestorePasswordDocument, options);
      }
export type RestorePasswordMutationHookResult = ReturnType<typeof useRestorePasswordMutation>;
export type RestorePasswordMutationResult = Apollo.MutationResult<RestorePasswordMutation>;
export type RestorePasswordMutationOptions = Apollo.BaseMutationOptions<RestorePasswordMutation, RestorePasswordMutationVariables>;
export const ChangeCurrentPasswordDocument = gql`
    mutation changeCurrentPassword($input: ChangeCurrentPasswordInput!) {
  changeCurrentPassword(input: $input)
}
    `;
export type ChangeCurrentPasswordMutationFn = Apollo.MutationFunction<ChangeCurrentPasswordMutation, ChangeCurrentPasswordMutationVariables>;

/**
 * __useChangeCurrentPasswordMutation__
 *
 * To run a mutation, you first call `useChangeCurrentPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeCurrentPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeCurrentPasswordMutation, { data, loading, error }] = useChangeCurrentPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangeCurrentPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ChangeCurrentPasswordMutation, ChangeCurrentPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeCurrentPasswordMutation, ChangeCurrentPasswordMutationVariables>(ChangeCurrentPasswordDocument, options);
      }
export type ChangeCurrentPasswordMutationHookResult = ReturnType<typeof useChangeCurrentPasswordMutation>;
export type ChangeCurrentPasswordMutationResult = Apollo.MutationResult<ChangeCurrentPasswordMutation>;
export type ChangeCurrentPasswordMutationOptions = Apollo.BaseMutationOptions<ChangeCurrentPasswordMutation, ChangeCurrentPasswordMutationVariables>;
export const UpdateRealmDocument = gql`
    mutation updateRealm($realm: RealmInput!) {
  updateRealm(realmInput: $realm)
}
    `;
export type UpdateRealmMutationFn = Apollo.MutationFunction<UpdateRealmMutation, UpdateRealmMutationVariables>;

/**
 * __useUpdateRealmMutation__
 *
 * To run a mutation, you first call `useUpdateRealmMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRealmMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRealmMutation, { data, loading, error }] = useUpdateRealmMutation({
 *   variables: {
 *      realm: // value for 'realm'
 *   },
 * });
 */
export function useUpdateRealmMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRealmMutation, UpdateRealmMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRealmMutation, UpdateRealmMutationVariables>(UpdateRealmDocument, options);
      }
export type UpdateRealmMutationHookResult = ReturnType<typeof useUpdateRealmMutation>;
export type UpdateRealmMutationResult = Apollo.MutationResult<UpdateRealmMutation>;
export type UpdateRealmMutationOptions = Apollo.BaseMutationOptions<UpdateRealmMutation, UpdateRealmMutationVariables>;
export const ValidateEmailDocument = gql`
    mutation validateEmail($addresses: EmailAddresses!) {
  validateEmail(addresses: $addresses)
}
    `;
export type ValidateEmailMutationFn = Apollo.MutationFunction<ValidateEmailMutation, ValidateEmailMutationVariables>;

/**
 * __useValidateEmailMutation__
 *
 * To run a mutation, you first call `useValidateEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateEmailMutation, { data, loading, error }] = useValidateEmailMutation({
 *   variables: {
 *      addresses: // value for 'addresses'
 *   },
 * });
 */
export function useValidateEmailMutation(baseOptions?: Apollo.MutationHookOptions<ValidateEmailMutation, ValidateEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ValidateEmailMutation, ValidateEmailMutationVariables>(ValidateEmailDocument, options);
      }
export type ValidateEmailMutationHookResult = ReturnType<typeof useValidateEmailMutation>;
export type ValidateEmailMutationResult = Apollo.MutationResult<ValidateEmailMutation>;
export type ValidateEmailMutationOptions = Apollo.BaseMutationOptions<ValidateEmailMutation, ValidateEmailMutationVariables>;
export const RealmObjectsDocument = gql`
    query realmObjects {
  realmObjects {
    id
    name
  }
}
    `;

/**
 * __useRealmObjectsQuery__
 *
 * To run a query within a React component, call `useRealmObjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRealmObjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRealmObjectsQuery({
 *   variables: {
 *   },
 * });
 */
export function useRealmObjectsQuery(baseOptions?: Apollo.QueryHookOptions<RealmObjectsQuery, RealmObjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RealmObjectsQuery, RealmObjectsQueryVariables>(RealmObjectsDocument, options);
      }
export function useRealmObjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RealmObjectsQuery, RealmObjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RealmObjectsQuery, RealmObjectsQueryVariables>(RealmObjectsDocument, options);
        }
// @ts-ignore
export function useRealmObjectsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RealmObjectsQuery, RealmObjectsQueryVariables>): Apollo.UseSuspenseQueryResult<RealmObjectsQuery, RealmObjectsQueryVariables>;
export function useRealmObjectsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RealmObjectsQuery, RealmObjectsQueryVariables>): Apollo.UseSuspenseQueryResult<RealmObjectsQuery | undefined, RealmObjectsQueryVariables>;
export function useRealmObjectsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RealmObjectsQuery, RealmObjectsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RealmObjectsQuery, RealmObjectsQueryVariables>(RealmObjectsDocument, options);
        }
export type RealmObjectsQueryHookResult = ReturnType<typeof useRealmObjectsQuery>;
export type RealmObjectsLazyQueryHookResult = ReturnType<typeof useRealmObjectsLazyQuery>;
export type RealmObjectsSuspenseQueryHookResult = ReturnType<typeof useRealmObjectsSuspenseQuery>;
export type RealmObjectsQueryResult = Apollo.QueryResult<RealmObjectsQuery, RealmObjectsQueryVariables>;
export const ObjectUpdateDocument = gql`
    subscription objectUpdate($filter: ObjectUpdateFilter) {
  objectUpdate(filter: $filter) {
    id
    type
    action
    healthStatus
    ptzStatus {
      position {
        pan
        tilt
        hfov
      }
      lock {
        userId
        userName
        category
        expire
        explicit
      }
    }
    ptzLockProlongation {
      userId
      token
      createdAt
    }
    vaeStatus {
      reason
      status
      vae
    }
  }
}
    `;

/**
 * __useObjectUpdateSubscription__
 *
 * To run a query within a React component, call `useObjectUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useObjectUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useObjectUpdateSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useObjectUpdateSubscription(baseOptions?: Apollo.SubscriptionHookOptions<ObjectUpdateSubscription, ObjectUpdateSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ObjectUpdateSubscription, ObjectUpdateSubscriptionVariables>(ObjectUpdateDocument, options);
      }
export type ObjectUpdateSubscriptionHookResult = ReturnType<typeof useObjectUpdateSubscription>;
export type ObjectUpdateSubscriptionResult = Apollo.SubscriptionResult<ObjectUpdateSubscription>;
export const AvatarReportDocument = gql`
    query avatarReport($id: ID!, $from: DateTime!, $to: DateTime!, $metricName: AvatarMetricName!) {
  avatarReport(id: $id, from: $from, to: $to, metricName: $metricName) {
    time
    value
  }
}
    `;

/**
 * __useAvatarReportQuery__
 *
 * To run a query within a React component, call `useAvatarReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvatarReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvatarReportQuery({
 *   variables: {
 *      id: // value for 'id'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      metricName: // value for 'metricName'
 *   },
 * });
 */
export function useAvatarReportQuery(baseOptions: Apollo.QueryHookOptions<AvatarReportQuery, AvatarReportQueryVariables> & ({ variables: AvatarReportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AvatarReportQuery, AvatarReportQueryVariables>(AvatarReportDocument, options);
      }
export function useAvatarReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AvatarReportQuery, AvatarReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AvatarReportQuery, AvatarReportQueryVariables>(AvatarReportDocument, options);
        }
// @ts-ignore
export function useAvatarReportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AvatarReportQuery, AvatarReportQueryVariables>): Apollo.UseSuspenseQueryResult<AvatarReportQuery, AvatarReportQueryVariables>;
export function useAvatarReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AvatarReportQuery, AvatarReportQueryVariables>): Apollo.UseSuspenseQueryResult<AvatarReportQuery | undefined, AvatarReportQueryVariables>;
export function useAvatarReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AvatarReportQuery, AvatarReportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AvatarReportQuery, AvatarReportQueryVariables>(AvatarReportDocument, options);
        }
export type AvatarReportQueryHookResult = ReturnType<typeof useAvatarReportQuery>;
export type AvatarReportLazyQueryHookResult = ReturnType<typeof useAvatarReportLazyQuery>;
export type AvatarReportSuspenseQueryHookResult = ReturnType<typeof useAvatarReportSuspenseQuery>;
export type AvatarReportQueryResult = Apollo.QueryResult<AvatarReportQuery, AvatarReportQueryVariables>;
export const CameraReportDocument = gql`
    query cameraReport($id: ID!, $from: DateTime!, $to: DateTime!, $metricName: CameraMetricName!, $dfaId: Int!) {
  numeric: cameraReport(
    id: $id
    from: $from
    to: $to
    metricName: $metricName
    dfaId: $dfaId
  ) {
    ... on NumericReport {
      time
      value
    }
  }
  status: cameraReport(
    id: $id
    from: $from
    to: $to
    metricName: $metricName
    dfaId: $dfaId
  ) {
    ... on StatusReport {
      time
      value
    }
  }
}
    `;

/**
 * __useCameraReportQuery__
 *
 * To run a query within a React component, call `useCameraReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useCameraReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCameraReportQuery({
 *   variables: {
 *      id: // value for 'id'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      metricName: // value for 'metricName'
 *      dfaId: // value for 'dfaId'
 *   },
 * });
 */
export function useCameraReportQuery(baseOptions: Apollo.QueryHookOptions<CameraReportQuery, CameraReportQueryVariables> & ({ variables: CameraReportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CameraReportQuery, CameraReportQueryVariables>(CameraReportDocument, options);
      }
export function useCameraReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CameraReportQuery, CameraReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CameraReportQuery, CameraReportQueryVariables>(CameraReportDocument, options);
        }
// @ts-ignore
export function useCameraReportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CameraReportQuery, CameraReportQueryVariables>): Apollo.UseSuspenseQueryResult<CameraReportQuery, CameraReportQueryVariables>;
export function useCameraReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CameraReportQuery, CameraReportQueryVariables>): Apollo.UseSuspenseQueryResult<CameraReportQuery | undefined, CameraReportQueryVariables>;
export function useCameraReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CameraReportQuery, CameraReportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CameraReportQuery, CameraReportQueryVariables>(CameraReportDocument, options);
        }
export type CameraReportQueryHookResult = ReturnType<typeof useCameraReportQuery>;
export type CameraReportLazyQueryHookResult = ReturnType<typeof useCameraReportLazyQuery>;
export type CameraReportSuspenseQueryHookResult = ReturnType<typeof useCameraReportSuspenseQuery>;
export type CameraReportQueryResult = Apollo.QueryResult<CameraReportQuery, CameraReportQueryVariables>;
export const AvatarMetricsDocument = gql`
    query avatarMetrics {
  avatarMetrics {
    key
    name
    dimension
  }
}
    `;

/**
 * __useAvatarMetricsQuery__
 *
 * To run a query within a React component, call `useAvatarMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvatarMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvatarMetricsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAvatarMetricsQuery(baseOptions?: Apollo.QueryHookOptions<AvatarMetricsQuery, AvatarMetricsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AvatarMetricsQuery, AvatarMetricsQueryVariables>(AvatarMetricsDocument, options);
      }
export function useAvatarMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AvatarMetricsQuery, AvatarMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AvatarMetricsQuery, AvatarMetricsQueryVariables>(AvatarMetricsDocument, options);
        }
// @ts-ignore
export function useAvatarMetricsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AvatarMetricsQuery, AvatarMetricsQueryVariables>): Apollo.UseSuspenseQueryResult<AvatarMetricsQuery, AvatarMetricsQueryVariables>;
export function useAvatarMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AvatarMetricsQuery, AvatarMetricsQueryVariables>): Apollo.UseSuspenseQueryResult<AvatarMetricsQuery | undefined, AvatarMetricsQueryVariables>;
export function useAvatarMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AvatarMetricsQuery, AvatarMetricsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AvatarMetricsQuery, AvatarMetricsQueryVariables>(AvatarMetricsDocument, options);
        }
export type AvatarMetricsQueryHookResult = ReturnType<typeof useAvatarMetricsQuery>;
export type AvatarMetricsLazyQueryHookResult = ReturnType<typeof useAvatarMetricsLazyQuery>;
export type AvatarMetricsSuspenseQueryHookResult = ReturnType<typeof useAvatarMetricsSuspenseQuery>;
export type AvatarMetricsQueryResult = Apollo.QueryResult<AvatarMetricsQuery, AvatarMetricsQueryVariables>;
export const CameraMetricsDocument = gql`
    query cameraMetrics($id: ID!, $from: DateTime, $to: DateTime) {
  cameraMetrics(id: $id, from: $from, to: $to) {
    key
    name
    dimension
    dfaId
  }
}
    `;

/**
 * __useCameraMetricsQuery__
 *
 * To run a query within a React component, call `useCameraMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCameraMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCameraMetricsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useCameraMetricsQuery(baseOptions: Apollo.QueryHookOptions<CameraMetricsQuery, CameraMetricsQueryVariables> & ({ variables: CameraMetricsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CameraMetricsQuery, CameraMetricsQueryVariables>(CameraMetricsDocument, options);
      }
export function useCameraMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CameraMetricsQuery, CameraMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CameraMetricsQuery, CameraMetricsQueryVariables>(CameraMetricsDocument, options);
        }
// @ts-ignore
export function useCameraMetricsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CameraMetricsQuery, CameraMetricsQueryVariables>): Apollo.UseSuspenseQueryResult<CameraMetricsQuery, CameraMetricsQueryVariables>;
export function useCameraMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CameraMetricsQuery, CameraMetricsQueryVariables>): Apollo.UseSuspenseQueryResult<CameraMetricsQuery | undefined, CameraMetricsQueryVariables>;
export function useCameraMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CameraMetricsQuery, CameraMetricsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CameraMetricsQuery, CameraMetricsQueryVariables>(CameraMetricsDocument, options);
        }
export type CameraMetricsQueryHookResult = ReturnType<typeof useCameraMetricsQuery>;
export type CameraMetricsLazyQueryHookResult = ReturnType<typeof useCameraMetricsLazyQuery>;
export type CameraMetricsSuspenseQueryHookResult = ReturnType<typeof useCameraMetricsSuspenseQuery>;
export type CameraMetricsQueryResult = Apollo.QueryResult<CameraMetricsQuery, CameraMetricsQueryVariables>;
export const AdminScheduleListDocument = gql`
    query adminScheduleList {
  schedules {
    ...adminScheduleListFields
  }
}
    ${AdminScheduleListFieldsFragmentDoc}`;

/**
 * __useAdminScheduleListQuery__
 *
 * To run a query within a React component, call `useAdminScheduleListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminScheduleListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminScheduleListQuery({
 *   variables: {
 *   },
 * });
 */
export function useAdminScheduleListQuery(baseOptions?: Apollo.QueryHookOptions<AdminScheduleListQuery, AdminScheduleListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminScheduleListQuery, AdminScheduleListQueryVariables>(AdminScheduleListDocument, options);
      }
export function useAdminScheduleListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminScheduleListQuery, AdminScheduleListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminScheduleListQuery, AdminScheduleListQueryVariables>(AdminScheduleListDocument, options);
        }
// @ts-ignore
export function useAdminScheduleListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AdminScheduleListQuery, AdminScheduleListQueryVariables>): Apollo.UseSuspenseQueryResult<AdminScheduleListQuery, AdminScheduleListQueryVariables>;
export function useAdminScheduleListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminScheduleListQuery, AdminScheduleListQueryVariables>): Apollo.UseSuspenseQueryResult<AdminScheduleListQuery | undefined, AdminScheduleListQueryVariables>;
export function useAdminScheduleListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminScheduleListQuery, AdminScheduleListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminScheduleListQuery, AdminScheduleListQueryVariables>(AdminScheduleListDocument, options);
        }
export type AdminScheduleListQueryHookResult = ReturnType<typeof useAdminScheduleListQuery>;
export type AdminScheduleListLazyQueryHookResult = ReturnType<typeof useAdminScheduleListLazyQuery>;
export type AdminScheduleListSuspenseQueryHookResult = ReturnType<typeof useAdminScheduleListSuspenseQuery>;
export type AdminScheduleListQueryResult = Apollo.QueryResult<AdminScheduleListQuery, AdminScheduleListQueryVariables>;
export const ScheduleByIdDocument = gql`
    query scheduleById($id: ID!) {
  schedule(id: $id) {
    ...scheduleFields
  }
}
    ${ScheduleFieldsFragmentDoc}`;

/**
 * __useScheduleByIdQuery__
 *
 * To run a query within a React component, call `useScheduleByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useScheduleByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScheduleByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useScheduleByIdQuery(baseOptions: Apollo.QueryHookOptions<ScheduleByIdQuery, ScheduleByIdQueryVariables> & ({ variables: ScheduleByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ScheduleByIdQuery, ScheduleByIdQueryVariables>(ScheduleByIdDocument, options);
      }
export function useScheduleByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ScheduleByIdQuery, ScheduleByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ScheduleByIdQuery, ScheduleByIdQueryVariables>(ScheduleByIdDocument, options);
        }
// @ts-ignore
export function useScheduleByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ScheduleByIdQuery, ScheduleByIdQueryVariables>): Apollo.UseSuspenseQueryResult<ScheduleByIdQuery, ScheduleByIdQueryVariables>;
export function useScheduleByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ScheduleByIdQuery, ScheduleByIdQueryVariables>): Apollo.UseSuspenseQueryResult<ScheduleByIdQuery | undefined, ScheduleByIdQueryVariables>;
export function useScheduleByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ScheduleByIdQuery, ScheduleByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ScheduleByIdQuery, ScheduleByIdQueryVariables>(ScheduleByIdDocument, options);
        }
export type ScheduleByIdQueryHookResult = ReturnType<typeof useScheduleByIdQuery>;
export type ScheduleByIdLazyQueryHookResult = ReturnType<typeof useScheduleByIdLazyQuery>;
export type ScheduleByIdSuspenseQueryHookResult = ReturnType<typeof useScheduleByIdSuspenseQuery>;
export type ScheduleByIdQueryResult = Apollo.QueryResult<ScheduleByIdQuery, ScheduleByIdQueryVariables>;
export const ScheduleActionTemplatesDocument = gql`
    query scheduleActionTemplates {
  scheduleActionTemplates {
    action
    description
    deviceTypes
    values
    labels
  }
}
    `;

/**
 * __useScheduleActionTemplatesQuery__
 *
 * To run a query within a React component, call `useScheduleActionTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useScheduleActionTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScheduleActionTemplatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useScheduleActionTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<ScheduleActionTemplatesQuery, ScheduleActionTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ScheduleActionTemplatesQuery, ScheduleActionTemplatesQueryVariables>(ScheduleActionTemplatesDocument, options);
      }
export function useScheduleActionTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ScheduleActionTemplatesQuery, ScheduleActionTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ScheduleActionTemplatesQuery, ScheduleActionTemplatesQueryVariables>(ScheduleActionTemplatesDocument, options);
        }
// @ts-ignore
export function useScheduleActionTemplatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ScheduleActionTemplatesQuery, ScheduleActionTemplatesQueryVariables>): Apollo.UseSuspenseQueryResult<ScheduleActionTemplatesQuery, ScheduleActionTemplatesQueryVariables>;
export function useScheduleActionTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ScheduleActionTemplatesQuery, ScheduleActionTemplatesQueryVariables>): Apollo.UseSuspenseQueryResult<ScheduleActionTemplatesQuery | undefined, ScheduleActionTemplatesQueryVariables>;
export function useScheduleActionTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ScheduleActionTemplatesQuery, ScheduleActionTemplatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ScheduleActionTemplatesQuery, ScheduleActionTemplatesQueryVariables>(ScheduleActionTemplatesDocument, options);
        }
export type ScheduleActionTemplatesQueryHookResult = ReturnType<typeof useScheduleActionTemplatesQuery>;
export type ScheduleActionTemplatesLazyQueryHookResult = ReturnType<typeof useScheduleActionTemplatesLazyQuery>;
export type ScheduleActionTemplatesSuspenseQueryHookResult = ReturnType<typeof useScheduleActionTemplatesSuspenseQuery>;
export type ScheduleActionTemplatesQueryResult = Apollo.QueryResult<ScheduleActionTemplatesQuery, ScheduleActionTemplatesQueryVariables>;
export const CreateScheduleDocument = gql`
    mutation createSchedule($schedule: ScheduleInput!) {
  createSchedule(schedule: $schedule) {
    id
    warning
    warningFields {
      field
      value
    }
  }
}
    `;
export type CreateScheduleMutationFn = Apollo.MutationFunction<CreateScheduleMutation, CreateScheduleMutationVariables>;

/**
 * __useCreateScheduleMutation__
 *
 * To run a mutation, you first call `useCreateScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createScheduleMutation, { data, loading, error }] = useCreateScheduleMutation({
 *   variables: {
 *      schedule: // value for 'schedule'
 *   },
 * });
 */
export function useCreateScheduleMutation(baseOptions?: Apollo.MutationHookOptions<CreateScheduleMutation, CreateScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateScheduleMutation, CreateScheduleMutationVariables>(CreateScheduleDocument, options);
      }
export type CreateScheduleMutationHookResult = ReturnType<typeof useCreateScheduleMutation>;
export type CreateScheduleMutationResult = Apollo.MutationResult<CreateScheduleMutation>;
export type CreateScheduleMutationOptions = Apollo.BaseMutationOptions<CreateScheduleMutation, CreateScheduleMutationVariables>;
export const UpdateScheduleDocument = gql`
    mutation updateSchedule($id: ID!, $schedule: ScheduleUpdateInput!) {
  updateSchedule(id: $id, schedule: $schedule) {
    updated
    warning
    warningFields {
      field
      value
    }
  }
}
    `;
export type UpdateScheduleMutationFn = Apollo.MutationFunction<UpdateScheduleMutation, UpdateScheduleMutationVariables>;

/**
 * __useUpdateScheduleMutation__
 *
 * To run a mutation, you first call `useUpdateScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateScheduleMutation, { data, loading, error }] = useUpdateScheduleMutation({
 *   variables: {
 *      id: // value for 'id'
 *      schedule: // value for 'schedule'
 *   },
 * });
 */
export function useUpdateScheduleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateScheduleMutation, UpdateScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateScheduleMutation, UpdateScheduleMutationVariables>(UpdateScheduleDocument, options);
      }
export type UpdateScheduleMutationHookResult = ReturnType<typeof useUpdateScheduleMutation>;
export type UpdateScheduleMutationResult = Apollo.MutationResult<UpdateScheduleMutation>;
export type UpdateScheduleMutationOptions = Apollo.BaseMutationOptions<UpdateScheduleMutation, UpdateScheduleMutationVariables>;
export const DeleteScheduleDocument = gql`
    mutation deleteSchedule($id: ID!) {
  deleteSchedule(id: $id)
}
    `;
export type DeleteScheduleMutationFn = Apollo.MutationFunction<DeleteScheduleMutation, DeleteScheduleMutationVariables>;

/**
 * __useDeleteScheduleMutation__
 *
 * To run a mutation, you first call `useDeleteScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteScheduleMutation, { data, loading, error }] = useDeleteScheduleMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteScheduleMutation(baseOptions?: Apollo.MutationHookOptions<DeleteScheduleMutation, DeleteScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteScheduleMutation, DeleteScheduleMutationVariables>(DeleteScheduleDocument, options);
      }
export type DeleteScheduleMutationHookResult = ReturnType<typeof useDeleteScheduleMutation>;
export type DeleteScheduleMutationResult = Apollo.MutationResult<DeleteScheduleMutation>;
export type DeleteScheduleMutationOptions = Apollo.BaseMutationOptions<DeleteScheduleMutation, DeleteScheduleMutationVariables>;
export const AddSharedViewDocument = gql`
    mutation addSharedView($input: AddSharedViewInput!) {
  addSharedView(input: $input)
}
    `;
export type AddSharedViewMutationFn = Apollo.MutationFunction<AddSharedViewMutation, AddSharedViewMutationVariables>;

/**
 * __useAddSharedViewMutation__
 *
 * To run a mutation, you first call `useAddSharedViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSharedViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSharedViewMutation, { data, loading, error }] = useAddSharedViewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddSharedViewMutation(baseOptions?: Apollo.MutationHookOptions<AddSharedViewMutation, AddSharedViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddSharedViewMutation, AddSharedViewMutationVariables>(AddSharedViewDocument, options);
      }
export type AddSharedViewMutationHookResult = ReturnType<typeof useAddSharedViewMutation>;
export type AddSharedViewMutationResult = Apollo.MutationResult<AddSharedViewMutation>;
export type AddSharedViewMutationOptions = Apollo.BaseMutationOptions<AddSharedViewMutation, AddSharedViewMutationVariables>;
export const DeleteSharedViewDocument = gql`
    mutation deleteSharedView($input: DeleteSharedViewInput!) {
  deleteSharedView(input: $input)
}
    `;
export type DeleteSharedViewMutationFn = Apollo.MutationFunction<DeleteSharedViewMutation, DeleteSharedViewMutationVariables>;

/**
 * __useDeleteSharedViewMutation__
 *
 * To run a mutation, you first call `useDeleteSharedViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSharedViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSharedViewMutation, { data, loading, error }] = useDeleteSharedViewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteSharedViewMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSharedViewMutation, DeleteSharedViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSharedViewMutation, DeleteSharedViewMutationVariables>(DeleteSharedViewDocument, options);
      }
export type DeleteSharedViewMutationHookResult = ReturnType<typeof useDeleteSharedViewMutation>;
export type DeleteSharedViewMutationResult = Apollo.MutationResult<DeleteSharedViewMutation>;
export type DeleteSharedViewMutationOptions = Apollo.BaseMutationOptions<DeleteSharedViewMutation, DeleteSharedViewMutationVariables>;
export const SystemStatusDocument = gql`
    query systemStatus {
  systemStatus {
    status
    description
    reasons {
      message
      options
      object {
        id
        name
        type
      }
    }
  }
  serverTime
}
    `;

/**
 * __useSystemStatusQuery__
 *
 * To run a query within a React component, call `useSystemStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useSystemStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSystemStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useSystemStatusQuery(baseOptions?: Apollo.QueryHookOptions<SystemStatusQuery, SystemStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SystemStatusQuery, SystemStatusQueryVariables>(SystemStatusDocument, options);
      }
export function useSystemStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SystemStatusQuery, SystemStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SystemStatusQuery, SystemStatusQueryVariables>(SystemStatusDocument, options);
        }
// @ts-ignore
export function useSystemStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SystemStatusQuery, SystemStatusQueryVariables>): Apollo.UseSuspenseQueryResult<SystemStatusQuery, SystemStatusQueryVariables>;
export function useSystemStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SystemStatusQuery, SystemStatusQueryVariables>): Apollo.UseSuspenseQueryResult<SystemStatusQuery | undefined, SystemStatusQueryVariables>;
export function useSystemStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SystemStatusQuery, SystemStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SystemStatusQuery, SystemStatusQueryVariables>(SystemStatusDocument, options);
        }
export type SystemStatusQueryHookResult = ReturnType<typeof useSystemStatusQuery>;
export type SystemStatusLazyQueryHookResult = ReturnType<typeof useSystemStatusLazyQuery>;
export type SystemStatusSuspenseQueryHookResult = ReturnType<typeof useSystemStatusSuspenseQuery>;
export type SystemStatusQueryResult = Apollo.QueryResult<SystemStatusQuery, SystemStatusQueryVariables>;
export const TargetDocument = gql`
    query target($id: ID!) {
  target(id: $id) {
    ...targetFields
  }
}
    ${TargetFieldsFragmentDoc}`;

/**
 * __useTargetQuery__
 *
 * To run a query within a React component, call `useTargetQuery` and pass it any options that fit your needs.
 * When your component renders, `useTargetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTargetQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTargetQuery(baseOptions: Apollo.QueryHookOptions<TargetQuery, TargetQueryVariables> & ({ variables: TargetQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TargetQuery, TargetQueryVariables>(TargetDocument, options);
      }
export function useTargetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TargetQuery, TargetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TargetQuery, TargetQueryVariables>(TargetDocument, options);
        }
// @ts-ignore
export function useTargetSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TargetQuery, TargetQueryVariables>): Apollo.UseSuspenseQueryResult<TargetQuery, TargetQueryVariables>;
export function useTargetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TargetQuery, TargetQueryVariables>): Apollo.UseSuspenseQueryResult<TargetQuery | undefined, TargetQueryVariables>;
export function useTargetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TargetQuery, TargetQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TargetQuery, TargetQueryVariables>(TargetDocument, options);
        }
export type TargetQueryHookResult = ReturnType<typeof useTargetQuery>;
export type TargetLazyQueryHookResult = ReturnType<typeof useTargetLazyQuery>;
export type TargetSuspenseQueryHookResult = ReturnType<typeof useTargetSuspenseQuery>;
export type TargetQueryResult = Apollo.QueryResult<TargetQuery, TargetQueryVariables>;
export const TargetsDocument = gql`
    query targets($filter: TargetFilter!) {
  targets(filter: $filter) {
    ...targetFields
  }
}
    ${TargetFieldsFragmentDoc}`;

/**
 * __useTargetsQuery__
 *
 * To run a query within a React component, call `useTargetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTargetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTargetsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useTargetsQuery(baseOptions: Apollo.QueryHookOptions<TargetsQuery, TargetsQueryVariables> & ({ variables: TargetsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TargetsQuery, TargetsQueryVariables>(TargetsDocument, options);
      }
export function useTargetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TargetsQuery, TargetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TargetsQuery, TargetsQueryVariables>(TargetsDocument, options);
        }
// @ts-ignore
export function useTargetsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TargetsQuery, TargetsQueryVariables>): Apollo.UseSuspenseQueryResult<TargetsQuery, TargetsQueryVariables>;
export function useTargetsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TargetsQuery, TargetsQueryVariables>): Apollo.UseSuspenseQueryResult<TargetsQuery | undefined, TargetsQueryVariables>;
export function useTargetsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TargetsQuery, TargetsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TargetsQuery, TargetsQueryVariables>(TargetsDocument, options);
        }
export type TargetsQueryHookResult = ReturnType<typeof useTargetsQuery>;
export type TargetsLazyQueryHookResult = ReturnType<typeof useTargetsLazyQuery>;
export type TargetsSuspenseQueryHookResult = ReturnType<typeof useTargetsSuspenseQuery>;
export type TargetsQueryResult = Apollo.QueryResult<TargetsQuery, TargetsQueryVariables>;
export const FollowTargetDocument = gql`
    query followTarget($id: ID!) {
  followTarget(targetId: $id)
}
    `;

/**
 * __useFollowTargetQuery__
 *
 * To run a query within a React component, call `useFollowTargetQuery` and pass it any options that fit your needs.
 * When your component renders, `useFollowTargetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFollowTargetQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFollowTargetQuery(baseOptions: Apollo.QueryHookOptions<FollowTargetQuery, FollowTargetQueryVariables> & ({ variables: FollowTargetQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FollowTargetQuery, FollowTargetQueryVariables>(FollowTargetDocument, options);
      }
export function useFollowTargetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FollowTargetQuery, FollowTargetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FollowTargetQuery, FollowTargetQueryVariables>(FollowTargetDocument, options);
        }
// @ts-ignore
export function useFollowTargetSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FollowTargetQuery, FollowTargetQueryVariables>): Apollo.UseSuspenseQueryResult<FollowTargetQuery, FollowTargetQueryVariables>;
export function useFollowTargetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FollowTargetQuery, FollowTargetQueryVariables>): Apollo.UseSuspenseQueryResult<FollowTargetQuery | undefined, FollowTargetQueryVariables>;
export function useFollowTargetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FollowTargetQuery, FollowTargetQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FollowTargetQuery, FollowTargetQueryVariables>(FollowTargetDocument, options);
        }
export type FollowTargetQueryHookResult = ReturnType<typeof useFollowTargetQuery>;
export type FollowTargetLazyQueryHookResult = ReturnType<typeof useFollowTargetLazyQuery>;
export type FollowTargetSuspenseQueryHookResult = ReturnType<typeof useFollowTargetSuspenseQuery>;
export type FollowTargetQueryResult = Apollo.QueryResult<FollowTargetQuery, FollowTargetQueryVariables>;
export const UnfollowTargetDocument = gql`
    query unfollowTarget($id: ID!) {
  unfollowTarget(targetId: $id)
}
    `;

/**
 * __useUnfollowTargetQuery__
 *
 * To run a query within a React component, call `useUnfollowTargetQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnfollowTargetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnfollowTargetQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUnfollowTargetQuery(baseOptions: Apollo.QueryHookOptions<UnfollowTargetQuery, UnfollowTargetQueryVariables> & ({ variables: UnfollowTargetQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UnfollowTargetQuery, UnfollowTargetQueryVariables>(UnfollowTargetDocument, options);
      }
export function useUnfollowTargetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UnfollowTargetQuery, UnfollowTargetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UnfollowTargetQuery, UnfollowTargetQueryVariables>(UnfollowTargetDocument, options);
        }
// @ts-ignore
export function useUnfollowTargetSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UnfollowTargetQuery, UnfollowTargetQueryVariables>): Apollo.UseSuspenseQueryResult<UnfollowTargetQuery, UnfollowTargetQueryVariables>;
export function useUnfollowTargetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UnfollowTargetQuery, UnfollowTargetQueryVariables>): Apollo.UseSuspenseQueryResult<UnfollowTargetQuery | undefined, UnfollowTargetQueryVariables>;
export function useUnfollowTargetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UnfollowTargetQuery, UnfollowTargetQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UnfollowTargetQuery, UnfollowTargetQueryVariables>(UnfollowTargetDocument, options);
        }
export type UnfollowTargetQueryHookResult = ReturnType<typeof useUnfollowTargetQuery>;
export type UnfollowTargetLazyQueryHookResult = ReturnType<typeof useUnfollowTargetLazyQuery>;
export type UnfollowTargetSuspenseQueryHookResult = ReturnType<typeof useUnfollowTargetSuspenseQuery>;
export type UnfollowTargetQueryResult = Apollo.QueryResult<UnfollowTargetQuery, UnfollowTargetQueryVariables>;
export const ArchiveTargetsDocument = gql`
    query archiveTargets($filter: TargetFilter!) {
  archiveTargets(filter: $filter) {
    ...targetFields
  }
}
    ${TargetFieldsFragmentDoc}`;

/**
 * __useArchiveTargetsQuery__
 *
 * To run a query within a React component, call `useArchiveTargetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useArchiveTargetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArchiveTargetsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useArchiveTargetsQuery(baseOptions: Apollo.QueryHookOptions<ArchiveTargetsQuery, ArchiveTargetsQueryVariables> & ({ variables: ArchiveTargetsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ArchiveTargetsQuery, ArchiveTargetsQueryVariables>(ArchiveTargetsDocument, options);
      }
export function useArchiveTargetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ArchiveTargetsQuery, ArchiveTargetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ArchiveTargetsQuery, ArchiveTargetsQueryVariables>(ArchiveTargetsDocument, options);
        }
// @ts-ignore
export function useArchiveTargetsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ArchiveTargetsQuery, ArchiveTargetsQueryVariables>): Apollo.UseSuspenseQueryResult<ArchiveTargetsQuery, ArchiveTargetsQueryVariables>;
export function useArchiveTargetsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ArchiveTargetsQuery, ArchiveTargetsQueryVariables>): Apollo.UseSuspenseQueryResult<ArchiveTargetsQuery | undefined, ArchiveTargetsQueryVariables>;
export function useArchiveTargetsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ArchiveTargetsQuery, ArchiveTargetsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ArchiveTargetsQuery, ArchiveTargetsQueryVariables>(ArchiveTargetsDocument, options);
        }
export type ArchiveTargetsQueryHookResult = ReturnType<typeof useArchiveTargetsQuery>;
export type ArchiveTargetsLazyQueryHookResult = ReturnType<typeof useArchiveTargetsLazyQuery>;
export type ArchiveTargetsSuspenseQueryHookResult = ReturnType<typeof useArchiveTargetsSuspenseQuery>;
export type ArchiveTargetsQueryResult = Apollo.QueryResult<ArchiveTargetsQuery, ArchiveTargetsQueryVariables>;
export const CreateTargetDocument = gql`
    mutation createTarget($input: TargetInput!) {
  createTarget(input: $input) {
    ...targetFields
  }
}
    ${TargetFieldsFragmentDoc}`;
export type CreateTargetMutationFn = Apollo.MutationFunction<CreateTargetMutation, CreateTargetMutationVariables>;

/**
 * __useCreateTargetMutation__
 *
 * To run a mutation, you first call `useCreateTargetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTargetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTargetMutation, { data, loading, error }] = useCreateTargetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTargetMutation(baseOptions?: Apollo.MutationHookOptions<CreateTargetMutation, CreateTargetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTargetMutation, CreateTargetMutationVariables>(CreateTargetDocument, options);
      }
export type CreateTargetMutationHookResult = ReturnType<typeof useCreateTargetMutation>;
export type CreateTargetMutationResult = Apollo.MutationResult<CreateTargetMutation>;
export type CreateTargetMutationOptions = Apollo.BaseMutationOptions<CreateTargetMutation, CreateTargetMutationVariables>;
export const TargetUpdateDocument = gql`
    subscription targetUpdate($filter: TargetUpdateFilter!) {
  targetUpdate(filter: $filter) {
    createdAt
    modifiedAt
    realmId
    witnesses
    targetId
    type
    description
    risk
    classification
    position {
      ...positionFields
    }
    classification
    risk
  }
}
    ${PositionFieldsFragmentDoc}`;

/**
 * __useTargetUpdateSubscription__
 *
 * To run a query within a React component, call `useTargetUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useTargetUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTargetUpdateSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useTargetUpdateSubscription(baseOptions: Apollo.SubscriptionHookOptions<TargetUpdateSubscription, TargetUpdateSubscriptionVariables> & ({ variables: TargetUpdateSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<TargetUpdateSubscription, TargetUpdateSubscriptionVariables>(TargetUpdateDocument, options);
      }
export type TargetUpdateSubscriptionHookResult = ReturnType<typeof useTargetUpdateSubscription>;
export type TargetUpdateSubscriptionResult = Apollo.SubscriptionResult<TargetUpdateSubscription>;
export const SolidConfigDocument = gql`
    query solidConfig($userId: ID!) {
  solidConfig(userId: $userId)
}
    `;

/**
 * __useSolidConfigQuery__
 *
 * To run a query within a React component, call `useSolidConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useSolidConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSolidConfigQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useSolidConfigQuery(baseOptions: Apollo.QueryHookOptions<SolidConfigQuery, SolidConfigQueryVariables> & ({ variables: SolidConfigQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SolidConfigQuery, SolidConfigQueryVariables>(SolidConfigDocument, options);
      }
export function useSolidConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SolidConfigQuery, SolidConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SolidConfigQuery, SolidConfigQueryVariables>(SolidConfigDocument, options);
        }
// @ts-ignore
export function useSolidConfigSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SolidConfigQuery, SolidConfigQueryVariables>): Apollo.UseSuspenseQueryResult<SolidConfigQuery, SolidConfigQueryVariables>;
export function useSolidConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SolidConfigQuery, SolidConfigQueryVariables>): Apollo.UseSuspenseQueryResult<SolidConfigQuery | undefined, SolidConfigQueryVariables>;
export function useSolidConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SolidConfigQuery, SolidConfigQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SolidConfigQuery, SolidConfigQueryVariables>(SolidConfigDocument, options);
        }
export type SolidConfigQueryHookResult = ReturnType<typeof useSolidConfigQuery>;
export type SolidConfigLazyQueryHookResult = ReturnType<typeof useSolidConfigLazyQuery>;
export type SolidConfigSuspenseQueryHookResult = ReturnType<typeof useSolidConfigSuspenseQuery>;
export type SolidConfigQueryResult = Apollo.QueryResult<SolidConfigQuery, SolidConfigQueryVariables>;
export const UpdateSolidConfigDocument = gql`
    mutation updateSolidConfig($solidConfig: String) {
  updateSolidConfig(solidConfig: $solidConfig)
}
    `;
export type UpdateSolidConfigMutationFn = Apollo.MutationFunction<UpdateSolidConfigMutation, UpdateSolidConfigMutationVariables>;

/**
 * __useUpdateSolidConfigMutation__
 *
 * To run a mutation, you first call `useUpdateSolidConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSolidConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSolidConfigMutation, { data, loading, error }] = useUpdateSolidConfigMutation({
 *   variables: {
 *      solidConfig: // value for 'solidConfig'
 *   },
 * });
 */
export function useUpdateSolidConfigMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSolidConfigMutation, UpdateSolidConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSolidConfigMutation, UpdateSolidConfigMutationVariables>(UpdateSolidConfigDocument, options);
      }
export type UpdateSolidConfigMutationHookResult = ReturnType<typeof useUpdateSolidConfigMutation>;
export type UpdateSolidConfigMutationResult = Apollo.MutationResult<UpdateSolidConfigMutation>;
export type UpdateSolidConfigMutationOptions = Apollo.BaseMutationOptions<UpdateSolidConfigMutation, UpdateSolidConfigMutationVariables>;
export const UpdateSolidConfigCurrentViewDocument = gql`
    mutation updateSolidConfigCurrentView($input: SolidConfigCurrentViewInput!) {
  updateSolidConfigCurrentView(input: $input)
}
    `;
export type UpdateSolidConfigCurrentViewMutationFn = Apollo.MutationFunction<UpdateSolidConfigCurrentViewMutation, UpdateSolidConfigCurrentViewMutationVariables>;

/**
 * __useUpdateSolidConfigCurrentViewMutation__
 *
 * To run a mutation, you first call `useUpdateSolidConfigCurrentViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSolidConfigCurrentViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSolidConfigCurrentViewMutation, { data, loading, error }] = useUpdateSolidConfigCurrentViewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSolidConfigCurrentViewMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSolidConfigCurrentViewMutation, UpdateSolidConfigCurrentViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSolidConfigCurrentViewMutation, UpdateSolidConfigCurrentViewMutationVariables>(UpdateSolidConfigCurrentViewDocument, options);
      }
export type UpdateSolidConfigCurrentViewMutationHookResult = ReturnType<typeof useUpdateSolidConfigCurrentViewMutation>;
export type UpdateSolidConfigCurrentViewMutationResult = Apollo.MutationResult<UpdateSolidConfigCurrentViewMutation>;
export type UpdateSolidConfigCurrentViewMutationOptions = Apollo.BaseMutationOptions<UpdateSolidConfigCurrentViewMutation, UpdateSolidConfigCurrentViewMutationVariables>;
export const SetCurrentViewDocument = gql`
    mutation setCurrentView($viewId: ID!) {
  setCurrentView(viewId: $viewId)
}
    `;
export type SetCurrentViewMutationFn = Apollo.MutationFunction<SetCurrentViewMutation, SetCurrentViewMutationVariables>;

/**
 * __useSetCurrentViewMutation__
 *
 * To run a mutation, you first call `useSetCurrentViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCurrentViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCurrentViewMutation, { data, loading, error }] = useSetCurrentViewMutation({
 *   variables: {
 *      viewId: // value for 'viewId'
 *   },
 * });
 */
export function useSetCurrentViewMutation(baseOptions?: Apollo.MutationHookOptions<SetCurrentViewMutation, SetCurrentViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetCurrentViewMutation, SetCurrentViewMutationVariables>(SetCurrentViewDocument, options);
      }
export type SetCurrentViewMutationHookResult = ReturnType<typeof useSetCurrentViewMutation>;
export type SetCurrentViewMutationResult = Apollo.MutationResult<SetCurrentViewMutation>;
export type SetCurrentViewMutationOptions = Apollo.BaseMutationOptions<SetCurrentViewMutation, SetCurrentViewMutationVariables>;
export const ClearRecentViewsDocument = gql`
    mutation clearRecentViews {
  clearRecentViews
}
    `;
export type ClearRecentViewsMutationFn = Apollo.MutationFunction<ClearRecentViewsMutation, ClearRecentViewsMutationVariables>;

/**
 * __useClearRecentViewsMutation__
 *
 * To run a mutation, you first call `useClearRecentViewsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearRecentViewsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearRecentViewsMutation, { data, loading, error }] = useClearRecentViewsMutation({
 *   variables: {
 *   },
 * });
 */
export function useClearRecentViewsMutation(baseOptions?: Apollo.MutationHookOptions<ClearRecentViewsMutation, ClearRecentViewsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClearRecentViewsMutation, ClearRecentViewsMutationVariables>(ClearRecentViewsDocument, options);
      }
export type ClearRecentViewsMutationHookResult = ReturnType<typeof useClearRecentViewsMutation>;
export type ClearRecentViewsMutationResult = Apollo.MutationResult<ClearRecentViewsMutation>;
export type ClearRecentViewsMutationOptions = Apollo.BaseMutationOptions<ClearRecentViewsMutation, ClearRecentViewsMutationVariables>;
export const SolidConfigUpdateDocument = gql`
    subscription solidConfigUpdate {
  solidConfigUpdate {
    userId
    solidConfig
  }
}
    `;

/**
 * __useSolidConfigUpdateSubscription__
 *
 * To run a query within a React component, call `useSolidConfigUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSolidConfigUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSolidConfigUpdateSubscription({
 *   variables: {
 *   },
 * });
 */
export function useSolidConfigUpdateSubscription(baseOptions?: Apollo.SubscriptionHookOptions<SolidConfigUpdateSubscription, SolidConfigUpdateSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SolidConfigUpdateSubscription, SolidConfigUpdateSubscriptionVariables>(SolidConfigUpdateDocument, options);
      }
export type SolidConfigUpdateSubscriptionHookResult = ReturnType<typeof useSolidConfigUpdateSubscription>;
export type SolidConfigUpdateSubscriptionResult = Apollo.SubscriptionResult<SolidConfigUpdateSubscription>;
export const UserIdsDocument = gql`
    query userIds {
  users {
    id
  }
}
    `;

/**
 * __useUserIdsQuery__
 *
 * To run a query within a React component, call `useUserIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserIdsQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserIdsQuery(baseOptions?: Apollo.QueryHookOptions<UserIdsQuery, UserIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserIdsQuery, UserIdsQueryVariables>(UserIdsDocument, options);
      }
export function useUserIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserIdsQuery, UserIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserIdsQuery, UserIdsQueryVariables>(UserIdsDocument, options);
        }
// @ts-ignore
export function useUserIdsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserIdsQuery, UserIdsQueryVariables>): Apollo.UseSuspenseQueryResult<UserIdsQuery, UserIdsQueryVariables>;
export function useUserIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserIdsQuery, UserIdsQueryVariables>): Apollo.UseSuspenseQueryResult<UserIdsQuery | undefined, UserIdsQueryVariables>;
export function useUserIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserIdsQuery, UserIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserIdsQuery, UserIdsQueryVariables>(UserIdsDocument, options);
        }
export type UserIdsQueryHookResult = ReturnType<typeof useUserIdsQuery>;
export type UserIdsLazyQueryHookResult = ReturnType<typeof useUserIdsLazyQuery>;
export type UserIdsSuspenseQueryHookResult = ReturnType<typeof useUserIdsSuspenseQuery>;
export type UserIdsQueryResult = Apollo.QueryResult<UserIdsQuery, UserIdsQueryVariables>;
export const UserWitnessesDocument = gql`
    query userWitnesses {
  users {
    id
    name
  }
}
    `;

/**
 * __useUserWitnessesQuery__
 *
 * To run a query within a React component, call `useUserWitnessesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserWitnessesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserWitnessesQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserWitnessesQuery(baseOptions?: Apollo.QueryHookOptions<UserWitnessesQuery, UserWitnessesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserWitnessesQuery, UserWitnessesQueryVariables>(UserWitnessesDocument, options);
      }
export function useUserWitnessesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserWitnessesQuery, UserWitnessesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserWitnessesQuery, UserWitnessesQueryVariables>(UserWitnessesDocument, options);
        }
// @ts-ignore
export function useUserWitnessesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserWitnessesQuery, UserWitnessesQueryVariables>): Apollo.UseSuspenseQueryResult<UserWitnessesQuery, UserWitnessesQueryVariables>;
export function useUserWitnessesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserWitnessesQuery, UserWitnessesQueryVariables>): Apollo.UseSuspenseQueryResult<UserWitnessesQuery | undefined, UserWitnessesQueryVariables>;
export function useUserWitnessesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserWitnessesQuery, UserWitnessesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserWitnessesQuery, UserWitnessesQueryVariables>(UserWitnessesDocument, options);
        }
export type UserWitnessesQueryHookResult = ReturnType<typeof useUserWitnessesQuery>;
export type UserWitnessesLazyQueryHookResult = ReturnType<typeof useUserWitnessesLazyQuery>;
export type UserWitnessesSuspenseQueryHookResult = ReturnType<typeof useUserWitnessesSuspenseQuery>;
export type UserWitnessesQueryResult = Apollo.QueryResult<UserWitnessesQuery, UserWitnessesQueryVariables>;
export const UserDocument = gql`
    query user($id: ID!) {
  user(id: $id) {
    ...userFields
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useUserQuery__
 *
 * To run a query within a React component, call `useUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserQuery(baseOptions: Apollo.QueryHookOptions<UserQuery, UserQueryVariables> & ({ variables: UserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserQuery, UserQueryVariables>(UserDocument, options);
      }
export function useUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserQuery, UserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserQuery, UserQueryVariables>(UserDocument, options);
        }
// @ts-ignore
export function useUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserQuery, UserQueryVariables>): Apollo.UseSuspenseQueryResult<UserQuery, UserQueryVariables>;
export function useUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserQuery, UserQueryVariables>): Apollo.UseSuspenseQueryResult<UserQuery | undefined, UserQueryVariables>;
export function useUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserQuery, UserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserQuery, UserQueryVariables>(UserDocument, options);
        }
export type UserQueryHookResult = ReturnType<typeof useUserQuery>;
export type UserLazyQueryHookResult = ReturnType<typeof useUserLazyQuery>;
export type UserSuspenseQueryHookResult = ReturnType<typeof useUserSuspenseQuery>;
export type UserQueryResult = Apollo.QueryResult<UserQuery, UserQueryVariables>;
export const UserInfoDocument = gql`
    query userInfo {
  userInfo {
    ...userInfoFields
  }
}
    ${UserInfoFieldsFragmentDoc}`;

/**
 * __useUserInfoQuery__
 *
 * To run a query within a React component, call `useUserInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserInfoQuery(baseOptions?: Apollo.QueryHookOptions<UserInfoQuery, UserInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserInfoQuery, UserInfoQueryVariables>(UserInfoDocument, options);
      }
export function useUserInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserInfoQuery, UserInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserInfoQuery, UserInfoQueryVariables>(UserInfoDocument, options);
        }
// @ts-ignore
export function useUserInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserInfoQuery, UserInfoQueryVariables>): Apollo.UseSuspenseQueryResult<UserInfoQuery, UserInfoQueryVariables>;
export function useUserInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserInfoQuery, UserInfoQueryVariables>): Apollo.UseSuspenseQueryResult<UserInfoQuery | undefined, UserInfoQueryVariables>;
export function useUserInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserInfoQuery, UserInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserInfoQuery, UserInfoQueryVariables>(UserInfoDocument, options);
        }
export type UserInfoQueryHookResult = ReturnType<typeof useUserInfoQuery>;
export type UserInfoLazyQueryHookResult = ReturnType<typeof useUserInfoLazyQuery>;
export type UserInfoSuspenseQueryHookResult = ReturnType<typeof useUserInfoSuspenseQuery>;
export type UserInfoQueryResult = Apollo.QueryResult<UserInfoQuery, UserInfoQueryVariables>;
export const UsersDocument = gql`
    query users {
  users {
    ...userFields
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useUsersQuery__
 *
 * To run a query within a React component, call `useUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useUsersQuery(baseOptions?: Apollo.QueryHookOptions<UsersQuery, UsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
      }
export function useUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UsersQuery, UsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
        }
// @ts-ignore
export function useUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UsersQuery, UsersQueryVariables>): Apollo.UseSuspenseQueryResult<UsersQuery, UsersQueryVariables>;
export function useUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UsersQuery, UsersQueryVariables>): Apollo.UseSuspenseQueryResult<UsersQuery | undefined, UsersQueryVariables>;
export function useUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UsersQuery, UsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
        }
export type UsersQueryHookResult = ReturnType<typeof useUsersQuery>;
export type UsersLazyQueryHookResult = ReturnType<typeof useUsersLazyQuery>;
export type UsersSuspenseQueryHookResult = ReturnType<typeof useUsersSuspenseQuery>;
export type UsersQueryResult = Apollo.QueryResult<UsersQuery, UsersQueryVariables>;
export const CreateUserDocument = gql`
    mutation createUser($user: UserInput!) {
  createUser(user: $user) {
    id
    warning
  }
}
    `;
export type CreateUserMutationFn = Apollo.MutationFunction<CreateUserMutation, CreateUserMutationVariables>;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      user: // value for 'user'
 *   },
 * });
 */
export function useCreateUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserMutation, CreateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserMutation, CreateUserMutationVariables>(CreateUserDocument, options);
      }
export type CreateUserMutationHookResult = ReturnType<typeof useCreateUserMutation>;
export type CreateUserMutationResult = Apollo.MutationResult<CreateUserMutation>;
export type CreateUserMutationOptions = Apollo.BaseMutationOptions<CreateUserMutation, CreateUserMutationVariables>;
export const UpdateUserDocument = gql`
    mutation updateUser($id: ID!, $user: UserInput!) {
  updateUser(id: $id, user: $user)
}
    `;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *      user: // value for 'user'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const DeleteUserDocument = gql`
    mutation deleteUser($id: ID!) {
  deleteUser(id: $id)
}
    `;
export type DeleteUserMutationFn = Apollo.MutationFunction<DeleteUserMutation, DeleteUserMutationVariables>;

/**
 * __useDeleteUserMutation__
 *
 * To run a mutation, you first call `useDeleteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserMutation, { data, loading, error }] = useDeleteUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteUserMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserMutation, DeleteUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserMutation, DeleteUserMutationVariables>(DeleteUserDocument, options);
      }
export type DeleteUserMutationHookResult = ReturnType<typeof useDeleteUserMutation>;
export type DeleteUserMutationResult = Apollo.MutationResult<DeleteUserMutation>;
export type DeleteUserMutationOptions = Apollo.BaseMutationOptions<DeleteUserMutation, DeleteUserMutationVariables>;
export const BlockUserDocument = gql`
    mutation blockUser($id: ID!) {
  blockUser(id: $id)
}
    `;
export type BlockUserMutationFn = Apollo.MutationFunction<BlockUserMutation, BlockUserMutationVariables>;

/**
 * __useBlockUserMutation__
 *
 * To run a mutation, you first call `useBlockUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBlockUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [blockUserMutation, { data, loading, error }] = useBlockUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBlockUserMutation(baseOptions?: Apollo.MutationHookOptions<BlockUserMutation, BlockUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BlockUserMutation, BlockUserMutationVariables>(BlockUserDocument, options);
      }
export type BlockUserMutationHookResult = ReturnType<typeof useBlockUserMutation>;
export type BlockUserMutationResult = Apollo.MutationResult<BlockUserMutation>;
export type BlockUserMutationOptions = Apollo.BaseMutationOptions<BlockUserMutation, BlockUserMutationVariables>;
export const UnblockUserDocument = gql`
    mutation unblockUser($id: ID!) {
  unblockUser(id: $id)
}
    `;
export type UnblockUserMutationFn = Apollo.MutationFunction<UnblockUserMutation, UnblockUserMutationVariables>;

/**
 * __useUnblockUserMutation__
 *
 * To run a mutation, you first call `useUnblockUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnblockUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unblockUserMutation, { data, loading, error }] = useUnblockUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUnblockUserMutation(baseOptions?: Apollo.MutationHookOptions<UnblockUserMutation, UnblockUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnblockUserMutation, UnblockUserMutationVariables>(UnblockUserDocument, options);
      }
export type UnblockUserMutationHookResult = ReturnType<typeof useUnblockUserMutation>;
export type UnblockUserMutationResult = Apollo.MutationResult<UnblockUserMutation>;
export type UnblockUserMutationOptions = Apollo.BaseMutationOptions<UnblockUserMutation, UnblockUserMutationVariables>;
export const ChangePasswordDocument = gql`
    mutation changePassword($input: ChangePasswordInput!) {
  changePassword(input: $input)
}
    `;
export type ChangePasswordMutationFn = Apollo.MutationFunction<ChangePasswordMutation, ChangePasswordMutationVariables>;

/**
 * __useChangePasswordMutation__
 *
 * To run a mutation, you first call `useChangePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changePasswordMutation, { data, loading, error }] = useChangePasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangePasswordMutation(baseOptions?: Apollo.MutationHookOptions<ChangePasswordMutation, ChangePasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangePasswordMutation, ChangePasswordMutationVariables>(ChangePasswordDocument, options);
      }
export type ChangePasswordMutationHookResult = ReturnType<typeof useChangePasswordMutation>;
export type ChangePasswordMutationResult = Apollo.MutationResult<ChangePasswordMutation>;
export type ChangePasswordMutationOptions = Apollo.BaseMutationOptions<ChangePasswordMutation, ChangePasswordMutationVariables>;
export const SetPasswordDocument = gql`
    mutation setPassword($input: SetPasswordInput!) {
  setPassword(input: $input)
}
    `;
export type SetPasswordMutationFn = Apollo.MutationFunction<SetPasswordMutation, SetPasswordMutationVariables>;

/**
 * __useSetPasswordMutation__
 *
 * To run a mutation, you first call `useSetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPasswordMutation, { data, loading, error }] = useSetPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<SetPasswordMutation, SetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetPasswordMutation, SetPasswordMutationVariables>(SetPasswordDocument, options);
      }
export type SetPasswordMutationHookResult = ReturnType<typeof useSetPasswordMutation>;
export type SetPasswordMutationResult = Apollo.MutationResult<SetPasswordMutation>;
export type SetPasswordMutationOptions = Apollo.BaseMutationOptions<SetPasswordMutation, SetPasswordMutationVariables>;
export const GroupsDocument = gql`
    query groups {
  groups {
    id
    name
    isSystemManaged
    users {
      id
      name
    }
    policies {
      id
      name
      isSystemManaged
    }
  }
}
    `;

/**
 * __useGroupsQuery__
 *
 * To run a query within a React component, call `useGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGroupsQuery(baseOptions?: Apollo.QueryHookOptions<GroupsQuery, GroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GroupsQuery, GroupsQueryVariables>(GroupsDocument, options);
      }
export function useGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GroupsQuery, GroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GroupsQuery, GroupsQueryVariables>(GroupsDocument, options);
        }
// @ts-ignore
export function useGroupsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GroupsQuery, GroupsQueryVariables>): Apollo.UseSuspenseQueryResult<GroupsQuery, GroupsQueryVariables>;
export function useGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GroupsQuery, GroupsQueryVariables>): Apollo.UseSuspenseQueryResult<GroupsQuery | undefined, GroupsQueryVariables>;
export function useGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GroupsQuery, GroupsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GroupsQuery, GroupsQueryVariables>(GroupsDocument, options);
        }
export type GroupsQueryHookResult = ReturnType<typeof useGroupsQuery>;
export type GroupsLazyQueryHookResult = ReturnType<typeof useGroupsLazyQuery>;
export type GroupsSuspenseQueryHookResult = ReturnType<typeof useGroupsSuspenseQuery>;
export type GroupsQueryResult = Apollo.QueryResult<GroupsQuery, GroupsQueryVariables>;
export const CreateGroupDocument = gql`
    mutation createGroup($group: GroupInput!) {
  createGroup(group: $group) {
    id
    warning
  }
}
    `;
export type CreateGroupMutationFn = Apollo.MutationFunction<CreateGroupMutation, CreateGroupMutationVariables>;

/**
 * __useCreateGroupMutation__
 *
 * To run a mutation, you first call `useCreateGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGroupMutation, { data, loading, error }] = useCreateGroupMutation({
 *   variables: {
 *      group: // value for 'group'
 *   },
 * });
 */
export function useCreateGroupMutation(baseOptions?: Apollo.MutationHookOptions<CreateGroupMutation, CreateGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateGroupMutation, CreateGroupMutationVariables>(CreateGroupDocument, options);
      }
export type CreateGroupMutationHookResult = ReturnType<typeof useCreateGroupMutation>;
export type CreateGroupMutationResult = Apollo.MutationResult<CreateGroupMutation>;
export type CreateGroupMutationOptions = Apollo.BaseMutationOptions<CreateGroupMutation, CreateGroupMutationVariables>;
export const UpdateGroupDocument = gql`
    mutation updateGroup($id: ID!, $group: GroupInput!) {
  updateGroup(id: $id, group: $group)
}
    `;
export type UpdateGroupMutationFn = Apollo.MutationFunction<UpdateGroupMutation, UpdateGroupMutationVariables>;

/**
 * __useUpdateGroupMutation__
 *
 * To run a mutation, you first call `useUpdateGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGroupMutation, { data, loading, error }] = useUpdateGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *      group: // value for 'group'
 *   },
 * });
 */
export function useUpdateGroupMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGroupMutation, UpdateGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGroupMutation, UpdateGroupMutationVariables>(UpdateGroupDocument, options);
      }
export type UpdateGroupMutationHookResult = ReturnType<typeof useUpdateGroupMutation>;
export type UpdateGroupMutationResult = Apollo.MutationResult<UpdateGroupMutation>;
export type UpdateGroupMutationOptions = Apollo.BaseMutationOptions<UpdateGroupMutation, UpdateGroupMutationVariables>;
export const DeleteGroupDocument = gql`
    mutation deleteGroup($id: ID!) {
  deleteGroup(id: $id)
}
    `;
export type DeleteGroupMutationFn = Apollo.MutationFunction<DeleteGroupMutation, DeleteGroupMutationVariables>;

/**
 * __useDeleteGroupMutation__
 *
 * To run a mutation, you first call `useDeleteGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteGroupMutation, { data, loading, error }] = useDeleteGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteGroupMutation(baseOptions?: Apollo.MutationHookOptions<DeleteGroupMutation, DeleteGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteGroupMutation, DeleteGroupMutationVariables>(DeleteGroupDocument, options);
      }
export type DeleteGroupMutationHookResult = ReturnType<typeof useDeleteGroupMutation>;
export type DeleteGroupMutationResult = Apollo.MutationResult<DeleteGroupMutation>;
export type DeleteGroupMutationOptions = Apollo.BaseMutationOptions<DeleteGroupMutation, DeleteGroupMutationVariables>;
export const PoliciesDocument = gql`
    query policies {
  policies {
    id
    name
    isSystemManaged
    statements {
      id
      name
      effect
      actions
      resources {
        id
        name
        type
      }
      allResources
    }
  }
}
    `;

/**
 * __usePoliciesQuery__
 *
 * To run a query within a React component, call `usePoliciesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePoliciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePoliciesQuery({
 *   variables: {
 *   },
 * });
 */
export function usePoliciesQuery(baseOptions?: Apollo.QueryHookOptions<PoliciesQuery, PoliciesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PoliciesQuery, PoliciesQueryVariables>(PoliciesDocument, options);
      }
export function usePoliciesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PoliciesQuery, PoliciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PoliciesQuery, PoliciesQueryVariables>(PoliciesDocument, options);
        }
// @ts-ignore
export function usePoliciesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PoliciesQuery, PoliciesQueryVariables>): Apollo.UseSuspenseQueryResult<PoliciesQuery, PoliciesQueryVariables>;
export function usePoliciesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PoliciesQuery, PoliciesQueryVariables>): Apollo.UseSuspenseQueryResult<PoliciesQuery | undefined, PoliciesQueryVariables>;
export function usePoliciesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PoliciesQuery, PoliciesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PoliciesQuery, PoliciesQueryVariables>(PoliciesDocument, options);
        }
export type PoliciesQueryHookResult = ReturnType<typeof usePoliciesQuery>;
export type PoliciesLazyQueryHookResult = ReturnType<typeof usePoliciesLazyQuery>;
export type PoliciesSuspenseQueryHookResult = ReturnType<typeof usePoliciesSuspenseQuery>;
export type PoliciesQueryResult = Apollo.QueryResult<PoliciesQuery, PoliciesQueryVariables>;
export const CreatePolicyDocument = gql`
    mutation createPolicy($policy: PolicyInput!) {
  createPolicy(policy: $policy) {
    id
    warning
  }
}
    `;
export type CreatePolicyMutationFn = Apollo.MutationFunction<CreatePolicyMutation, CreatePolicyMutationVariables>;

/**
 * __useCreatePolicyMutation__
 *
 * To run a mutation, you first call `useCreatePolicyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePolicyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPolicyMutation, { data, loading, error }] = useCreatePolicyMutation({
 *   variables: {
 *      policy: // value for 'policy'
 *   },
 * });
 */
export function useCreatePolicyMutation(baseOptions?: Apollo.MutationHookOptions<CreatePolicyMutation, CreatePolicyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePolicyMutation, CreatePolicyMutationVariables>(CreatePolicyDocument, options);
      }
export type CreatePolicyMutationHookResult = ReturnType<typeof useCreatePolicyMutation>;
export type CreatePolicyMutationResult = Apollo.MutationResult<CreatePolicyMutation>;
export type CreatePolicyMutationOptions = Apollo.BaseMutationOptions<CreatePolicyMutation, CreatePolicyMutationVariables>;
export const UpdatePolicyDocument = gql`
    mutation updatePolicy($id: ID!, $policy: PolicyInput!) {
  updatePolicy(id: $id, policy: $policy)
}
    `;
export type UpdatePolicyMutationFn = Apollo.MutationFunction<UpdatePolicyMutation, UpdatePolicyMutationVariables>;

/**
 * __useUpdatePolicyMutation__
 *
 * To run a mutation, you first call `useUpdatePolicyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePolicyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePolicyMutation, { data, loading, error }] = useUpdatePolicyMutation({
 *   variables: {
 *      id: // value for 'id'
 *      policy: // value for 'policy'
 *   },
 * });
 */
export function useUpdatePolicyMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePolicyMutation, UpdatePolicyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePolicyMutation, UpdatePolicyMutationVariables>(UpdatePolicyDocument, options);
      }
export type UpdatePolicyMutationHookResult = ReturnType<typeof useUpdatePolicyMutation>;
export type UpdatePolicyMutationResult = Apollo.MutationResult<UpdatePolicyMutation>;
export type UpdatePolicyMutationOptions = Apollo.BaseMutationOptions<UpdatePolicyMutation, UpdatePolicyMutationVariables>;
export const DeletePolicyDocument = gql`
    mutation deletePolicy($id: ID!) {
  deletePolicy(id: $id)
}
    `;
export type DeletePolicyMutationFn = Apollo.MutationFunction<DeletePolicyMutation, DeletePolicyMutationVariables>;

/**
 * __useDeletePolicyMutation__
 *
 * To run a mutation, you first call `useDeletePolicyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePolicyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePolicyMutation, { data, loading, error }] = useDeletePolicyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePolicyMutation(baseOptions?: Apollo.MutationHookOptions<DeletePolicyMutation, DeletePolicyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePolicyMutation, DeletePolicyMutationVariables>(DeletePolicyDocument, options);
      }
export type DeletePolicyMutationHookResult = ReturnType<typeof useDeletePolicyMutation>;
export type DeletePolicyMutationResult = Apollo.MutationResult<DeletePolicyMutation>;
export type DeletePolicyMutationOptions = Apollo.BaseMutationOptions<DeletePolicyMutation, DeletePolicyMutationVariables>;
export const CreatePolicyStatementDocument = gql`
    mutation createPolicyStatement($policyId: ID!, $statement: PolicyStatementInput!) {
  createPolicyStatement(policyId: $policyId, statement: $statement) {
    id
    warning
  }
}
    `;
export type CreatePolicyStatementMutationFn = Apollo.MutationFunction<CreatePolicyStatementMutation, CreatePolicyStatementMutationVariables>;

/**
 * __useCreatePolicyStatementMutation__
 *
 * To run a mutation, you first call `useCreatePolicyStatementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePolicyStatementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPolicyStatementMutation, { data, loading, error }] = useCreatePolicyStatementMutation({
 *   variables: {
 *      policyId: // value for 'policyId'
 *      statement: // value for 'statement'
 *   },
 * });
 */
export function useCreatePolicyStatementMutation(baseOptions?: Apollo.MutationHookOptions<CreatePolicyStatementMutation, CreatePolicyStatementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePolicyStatementMutation, CreatePolicyStatementMutationVariables>(CreatePolicyStatementDocument, options);
      }
export type CreatePolicyStatementMutationHookResult = ReturnType<typeof useCreatePolicyStatementMutation>;
export type CreatePolicyStatementMutationResult = Apollo.MutationResult<CreatePolicyStatementMutation>;
export type CreatePolicyStatementMutationOptions = Apollo.BaseMutationOptions<CreatePolicyStatementMutation, CreatePolicyStatementMutationVariables>;
export const UpdatePolicyStatementDocument = gql`
    mutation updatePolicyStatement($statementId: ID!, $statement: PolicyStatementInput!) {
  updatePolicyStatement(statementId: $statementId, statement: $statement)
}
    `;
export type UpdatePolicyStatementMutationFn = Apollo.MutationFunction<UpdatePolicyStatementMutation, UpdatePolicyStatementMutationVariables>;

/**
 * __useUpdatePolicyStatementMutation__
 *
 * To run a mutation, you first call `useUpdatePolicyStatementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePolicyStatementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePolicyStatementMutation, { data, loading, error }] = useUpdatePolicyStatementMutation({
 *   variables: {
 *      statementId: // value for 'statementId'
 *      statement: // value for 'statement'
 *   },
 * });
 */
export function useUpdatePolicyStatementMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePolicyStatementMutation, UpdatePolicyStatementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePolicyStatementMutation, UpdatePolicyStatementMutationVariables>(UpdatePolicyStatementDocument, options);
      }
export type UpdatePolicyStatementMutationHookResult = ReturnType<typeof useUpdatePolicyStatementMutation>;
export type UpdatePolicyStatementMutationResult = Apollo.MutationResult<UpdatePolicyStatementMutation>;
export type UpdatePolicyStatementMutationOptions = Apollo.BaseMutationOptions<UpdatePolicyStatementMutation, UpdatePolicyStatementMutationVariables>;
export const DeletePolicyStatementDocument = gql`
    mutation deletePolicyStatement($statementId: ID!) {
  deletePolicyStatement(statementId: $statementId)
}
    `;
export type DeletePolicyStatementMutationFn = Apollo.MutationFunction<DeletePolicyStatementMutation, DeletePolicyStatementMutationVariables>;

/**
 * __useDeletePolicyStatementMutation__
 *
 * To run a mutation, you first call `useDeletePolicyStatementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePolicyStatementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePolicyStatementMutation, { data, loading, error }] = useDeletePolicyStatementMutation({
 *   variables: {
 *      statementId: // value for 'statementId'
 *   },
 * });
 */
export function useDeletePolicyStatementMutation(baseOptions?: Apollo.MutationHookOptions<DeletePolicyStatementMutation, DeletePolicyStatementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePolicyStatementMutation, DeletePolicyStatementMutationVariables>(DeletePolicyStatementDocument, options);
      }
export type DeletePolicyStatementMutationHookResult = ReturnType<typeof useDeletePolicyStatementMutation>;
export type DeletePolicyStatementMutationResult = Apollo.MutationResult<DeletePolicyStatementMutation>;
export type DeletePolicyStatementMutationOptions = Apollo.BaseMutationOptions<DeletePolicyStatementMutation, DeletePolicyStatementMutationVariables>;
export const ActionsDocument = gql`
    query actions {
  actions {
    action
    description
    resourceTypes
    deviceFunctionalAspectTypes
    accessLevel {
      level
      description
      order
    }
  }
}
    `;

/**
 * __useActionsQuery__
 *
 * To run a query within a React component, call `useActionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useActionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useActionsQuery(baseOptions?: Apollo.QueryHookOptions<ActionsQuery, ActionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActionsQuery, ActionsQueryVariables>(ActionsDocument, options);
      }
export function useActionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActionsQuery, ActionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActionsQuery, ActionsQueryVariables>(ActionsDocument, options);
        }
// @ts-ignore
export function useActionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ActionsQuery, ActionsQueryVariables>): Apollo.UseSuspenseQueryResult<ActionsQuery, ActionsQueryVariables>;
export function useActionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ActionsQuery, ActionsQueryVariables>): Apollo.UseSuspenseQueryResult<ActionsQuery | undefined, ActionsQueryVariables>;
export function useActionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ActionsQuery, ActionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ActionsQuery, ActionsQueryVariables>(ActionsDocument, options);
        }
export type ActionsQueryHookResult = ReturnType<typeof useActionsQuery>;
export type ActionsLazyQueryHookResult = ReturnType<typeof useActionsLazyQuery>;
export type ActionsSuspenseQueryHookResult = ReturnType<typeof useActionsSuspenseQuery>;
export type ActionsQueryResult = Apollo.QueryResult<ActionsQuery, ActionsQueryVariables>;
export const AccessLevelsDocument = gql`
    query accessLevels {
  accessLevels {
    level
    description
    order
  }
}
    `;

/**
 * __useAccessLevelsQuery__
 *
 * To run a query within a React component, call `useAccessLevelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccessLevelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccessLevelsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAccessLevelsQuery(baseOptions?: Apollo.QueryHookOptions<AccessLevelsQuery, AccessLevelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccessLevelsQuery, AccessLevelsQueryVariables>(AccessLevelsDocument, options);
      }
export function useAccessLevelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccessLevelsQuery, AccessLevelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccessLevelsQuery, AccessLevelsQueryVariables>(AccessLevelsDocument, options);
        }
// @ts-ignore
export function useAccessLevelsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AccessLevelsQuery, AccessLevelsQueryVariables>): Apollo.UseSuspenseQueryResult<AccessLevelsQuery, AccessLevelsQueryVariables>;
export function useAccessLevelsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AccessLevelsQuery, AccessLevelsQueryVariables>): Apollo.UseSuspenseQueryResult<AccessLevelsQuery | undefined, AccessLevelsQueryVariables>;
export function useAccessLevelsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AccessLevelsQuery, AccessLevelsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AccessLevelsQuery, AccessLevelsQueryVariables>(AccessLevelsDocument, options);
        }
export type AccessLevelsQueryHookResult = ReturnType<typeof useAccessLevelsQuery>;
export type AccessLevelsLazyQueryHookResult = ReturnType<typeof useAccessLevelsLazyQuery>;
export type AccessLevelsSuspenseQueryHookResult = ReturnType<typeof useAccessLevelsSuspenseQuery>;
export type AccessLevelsQueryResult = Apollo.QueryResult<AccessLevelsQuery, AccessLevelsQueryVariables>;
export const ZonesDocument = gql`
    query zones {
  zones {
    id
    name
    devices {
      id
      name
    }
  }
}
    `;

/**
 * __useZonesQuery__
 *
 * To run a query within a React component, call `useZonesQuery` and pass it any options that fit your needs.
 * When your component renders, `useZonesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useZonesQuery({
 *   variables: {
 *   },
 * });
 */
export function useZonesQuery(baseOptions?: Apollo.QueryHookOptions<ZonesQuery, ZonesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ZonesQuery, ZonesQueryVariables>(ZonesDocument, options);
      }
export function useZonesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ZonesQuery, ZonesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ZonesQuery, ZonesQueryVariables>(ZonesDocument, options);
        }
// @ts-ignore
export function useZonesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ZonesQuery, ZonesQueryVariables>): Apollo.UseSuspenseQueryResult<ZonesQuery, ZonesQueryVariables>;
export function useZonesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ZonesQuery, ZonesQueryVariables>): Apollo.UseSuspenseQueryResult<ZonesQuery | undefined, ZonesQueryVariables>;
export function useZonesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ZonesQuery, ZonesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ZonesQuery, ZonesQueryVariables>(ZonesDocument, options);
        }
export type ZonesQueryHookResult = ReturnType<typeof useZonesQuery>;
export type ZonesLazyQueryHookResult = ReturnType<typeof useZonesLazyQuery>;
export type ZonesSuspenseQueryHookResult = ReturnType<typeof useZonesSuspenseQuery>;
export type ZonesQueryResult = Apollo.QueryResult<ZonesQuery, ZonesQueryVariables>;
export const SetsDocument = gql`
    query sets {
  sets {
    id
    name
    isSystemManaged
    devices {
      id
      name
    }
  }
}
    `;

/**
 * __useSetsQuery__
 *
 * To run a query within a React component, call `useSetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSetsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSetsQuery(baseOptions?: Apollo.QueryHookOptions<SetsQuery, SetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SetsQuery, SetsQueryVariables>(SetsDocument, options);
      }
export function useSetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SetsQuery, SetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SetsQuery, SetsQueryVariables>(SetsDocument, options);
        }
// @ts-ignore
export function useSetsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SetsQuery, SetsQueryVariables>): Apollo.UseSuspenseQueryResult<SetsQuery, SetsQueryVariables>;
export function useSetsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SetsQuery, SetsQueryVariables>): Apollo.UseSuspenseQueryResult<SetsQuery | undefined, SetsQueryVariables>;
export function useSetsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SetsQuery, SetsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SetsQuery, SetsQueryVariables>(SetsDocument, options);
        }
export type SetsQueryHookResult = ReturnType<typeof useSetsQuery>;
export type SetsLazyQueryHookResult = ReturnType<typeof useSetsLazyQuery>;
export type SetsSuspenseQueryHookResult = ReturnType<typeof useSetsSuspenseQuery>;
export type SetsQueryResult = Apollo.QueryResult<SetsQuery, SetsQueryVariables>;
export const GuisDocument = gql`
    query guis {
  guis {
    id
    name
  }
}
    `;

/**
 * __useGuisQuery__
 *
 * To run a query within a React component, call `useGuisQuery` and pass it any options that fit your needs.
 * When your component renders, `useGuisQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGuisQuery({
 *   variables: {
 *   },
 * });
 */
export function useGuisQuery(baseOptions?: Apollo.QueryHookOptions<GuisQuery, GuisQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GuisQuery, GuisQueryVariables>(GuisDocument, options);
      }
export function useGuisLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GuisQuery, GuisQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GuisQuery, GuisQueryVariables>(GuisDocument, options);
        }
// @ts-ignore
export function useGuisSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GuisQuery, GuisQueryVariables>): Apollo.UseSuspenseQueryResult<GuisQuery, GuisQueryVariables>;
export function useGuisSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GuisQuery, GuisQueryVariables>): Apollo.UseSuspenseQueryResult<GuisQuery | undefined, GuisQueryVariables>;
export function useGuisSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GuisQuery, GuisQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GuisQuery, GuisQueryVariables>(GuisDocument, options);
        }
export type GuisQueryHookResult = ReturnType<typeof useGuisQuery>;
export type GuisLazyQueryHookResult = ReturnType<typeof useGuisLazyQuery>;
export type GuisSuspenseQueryHookResult = ReturnType<typeof useGuisSuspenseQuery>;
export type GuisQueryResult = Apollo.QueryResult<GuisQuery, GuisQueryVariables>;
export const UserRealmsDocument = gql`
    query userRealms {
  userRealms {
    id
    name
    type
  }
}
    `;

/**
 * __useUserRealmsQuery__
 *
 * To run a query within a React component, call `useUserRealmsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserRealmsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserRealmsQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserRealmsQuery(baseOptions?: Apollo.QueryHookOptions<UserRealmsQuery, UserRealmsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserRealmsQuery, UserRealmsQueryVariables>(UserRealmsDocument, options);
      }
export function useUserRealmsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserRealmsQuery, UserRealmsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserRealmsQuery, UserRealmsQueryVariables>(UserRealmsDocument, options);
        }
// @ts-ignore
export function useUserRealmsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserRealmsQuery, UserRealmsQueryVariables>): Apollo.UseSuspenseQueryResult<UserRealmsQuery, UserRealmsQueryVariables>;
export function useUserRealmsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserRealmsQuery, UserRealmsQueryVariables>): Apollo.UseSuspenseQueryResult<UserRealmsQuery | undefined, UserRealmsQueryVariables>;
export function useUserRealmsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserRealmsQuery, UserRealmsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserRealmsQuery, UserRealmsQueryVariables>(UserRealmsDocument, options);
        }
export type UserRealmsQueryHookResult = ReturnType<typeof useUserRealmsQuery>;
export type UserRealmsLazyQueryHookResult = ReturnType<typeof useUserRealmsLazyQuery>;
export type UserRealmsSuspenseQueryHookResult = ReturnType<typeof useUserRealmsSuspenseQuery>;
export type UserRealmsQueryResult = Apollo.QueryResult<UserRealmsQuery, UserRealmsQueryVariables>;
export const SetUserRealmDocument = gql`
    mutation setUserRealm($userName: String!, $realmId: ID!) {
  setUserRealm(userName: $userName, realmId: $realmId)
}
    `;
export type SetUserRealmMutationFn = Apollo.MutationFunction<SetUserRealmMutation, SetUserRealmMutationVariables>;

/**
 * __useSetUserRealmMutation__
 *
 * To run a mutation, you first call `useSetUserRealmMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetUserRealmMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setUserRealmMutation, { data, loading, error }] = useSetUserRealmMutation({
 *   variables: {
 *      userName: // value for 'userName'
 *      realmId: // value for 'realmId'
 *   },
 * });
 */
export function useSetUserRealmMutation(baseOptions?: Apollo.MutationHookOptions<SetUserRealmMutation, SetUserRealmMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetUserRealmMutation, SetUserRealmMutationVariables>(SetUserRealmDocument, options);
      }
export type SetUserRealmMutationHookResult = ReturnType<typeof useSetUserRealmMutation>;
export type SetUserRealmMutationResult = Apollo.MutationResult<SetUserRealmMutation>;
export type SetUserRealmMutationOptions = Apollo.BaseMutationOptions<SetUserRealmMutation, SetUserRealmMutationVariables>;
export const CreateZoneDocument = gql`
    mutation createZone($zone: ZoneInput!) {
  createZone(zone: $zone) {
    id
    warning
  }
}
    `;
export type CreateZoneMutationFn = Apollo.MutationFunction<CreateZoneMutation, CreateZoneMutationVariables>;

/**
 * __useCreateZoneMutation__
 *
 * To run a mutation, you first call `useCreateZoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateZoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createZoneMutation, { data, loading, error }] = useCreateZoneMutation({
 *   variables: {
 *      zone: // value for 'zone'
 *   },
 * });
 */
export function useCreateZoneMutation(baseOptions?: Apollo.MutationHookOptions<CreateZoneMutation, CreateZoneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateZoneMutation, CreateZoneMutationVariables>(CreateZoneDocument, options);
      }
export type CreateZoneMutationHookResult = ReturnType<typeof useCreateZoneMutation>;
export type CreateZoneMutationResult = Apollo.MutationResult<CreateZoneMutation>;
export type CreateZoneMutationOptions = Apollo.BaseMutationOptions<CreateZoneMutation, CreateZoneMutationVariables>;
export const UpdateZoneDocument = gql`
    mutation updateZone($id: ID!, $zone: ZoneInput!) {
  updateZone(id: $id, zone: $zone)
}
    `;
export type UpdateZoneMutationFn = Apollo.MutationFunction<UpdateZoneMutation, UpdateZoneMutationVariables>;

/**
 * __useUpdateZoneMutation__
 *
 * To run a mutation, you first call `useUpdateZoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateZoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateZoneMutation, { data, loading, error }] = useUpdateZoneMutation({
 *   variables: {
 *      id: // value for 'id'
 *      zone: // value for 'zone'
 *   },
 * });
 */
export function useUpdateZoneMutation(baseOptions?: Apollo.MutationHookOptions<UpdateZoneMutation, UpdateZoneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateZoneMutation, UpdateZoneMutationVariables>(UpdateZoneDocument, options);
      }
export type UpdateZoneMutationHookResult = ReturnType<typeof useUpdateZoneMutation>;
export type UpdateZoneMutationResult = Apollo.MutationResult<UpdateZoneMutation>;
export type UpdateZoneMutationOptions = Apollo.BaseMutationOptions<UpdateZoneMutation, UpdateZoneMutationVariables>;
export const DeleteZoneDocument = gql`
    mutation deleteZone($id: ID!) {
  deleteZone(id: $id)
}
    `;
export type DeleteZoneMutationFn = Apollo.MutationFunction<DeleteZoneMutation, DeleteZoneMutationVariables>;

/**
 * __useDeleteZoneMutation__
 *
 * To run a mutation, you first call `useDeleteZoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteZoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteZoneMutation, { data, loading, error }] = useDeleteZoneMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteZoneMutation(baseOptions?: Apollo.MutationHookOptions<DeleteZoneMutation, DeleteZoneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteZoneMutation, DeleteZoneMutationVariables>(DeleteZoneDocument, options);
      }
export type DeleteZoneMutationHookResult = ReturnType<typeof useDeleteZoneMutation>;
export type DeleteZoneMutationResult = Apollo.MutationResult<DeleteZoneMutation>;
export type DeleteZoneMutationOptions = Apollo.BaseMutationOptions<DeleteZoneMutation, DeleteZoneMutationVariables>;
export const CreateSetDocument = gql`
    mutation createSet($set: SetInput!) {
  createSet(set: $set) {
    id
    warning
  }
}
    `;
export type CreateSetMutationFn = Apollo.MutationFunction<CreateSetMutation, CreateSetMutationVariables>;

/**
 * __useCreateSetMutation__
 *
 * To run a mutation, you first call `useCreateSetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSetMutation, { data, loading, error }] = useCreateSetMutation({
 *   variables: {
 *      set: // value for 'set'
 *   },
 * });
 */
export function useCreateSetMutation(baseOptions?: Apollo.MutationHookOptions<CreateSetMutation, CreateSetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSetMutation, CreateSetMutationVariables>(CreateSetDocument, options);
      }
export type CreateSetMutationHookResult = ReturnType<typeof useCreateSetMutation>;
export type CreateSetMutationResult = Apollo.MutationResult<CreateSetMutation>;
export type CreateSetMutationOptions = Apollo.BaseMutationOptions<CreateSetMutation, CreateSetMutationVariables>;
export const UpdateSetDocument = gql`
    mutation updateSet($id: ID!, $set: SetInput!) {
  updateSet(id: $id, set: $set)
}
    `;
export type UpdateSetMutationFn = Apollo.MutationFunction<UpdateSetMutation, UpdateSetMutationVariables>;

/**
 * __useUpdateSetMutation__
 *
 * To run a mutation, you first call `useUpdateSetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSetMutation, { data, loading, error }] = useUpdateSetMutation({
 *   variables: {
 *      id: // value for 'id'
 *      set: // value for 'set'
 *   },
 * });
 */
export function useUpdateSetMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSetMutation, UpdateSetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSetMutation, UpdateSetMutationVariables>(UpdateSetDocument, options);
      }
export type UpdateSetMutationHookResult = ReturnType<typeof useUpdateSetMutation>;
export type UpdateSetMutationResult = Apollo.MutationResult<UpdateSetMutation>;
export type UpdateSetMutationOptions = Apollo.BaseMutationOptions<UpdateSetMutation, UpdateSetMutationVariables>;
export const DeleteSetDocument = gql`
    mutation deleteSet($id: ID!) {
  deleteSet(id: $id)
}
    `;
export type DeleteSetMutationFn = Apollo.MutationFunction<DeleteSetMutation, DeleteSetMutationVariables>;

/**
 * __useDeleteSetMutation__
 *
 * To run a mutation, you first call `useDeleteSetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSetMutation, { data, loading, error }] = useDeleteSetMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSetMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSetMutation, DeleteSetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSetMutation, DeleteSetMutationVariables>(DeleteSetDocument, options);
      }
export type DeleteSetMutationHookResult = ReturnType<typeof useDeleteSetMutation>;
export type DeleteSetMutationResult = Apollo.MutationResult<DeleteSetMutation>;
export type DeleteSetMutationOptions = Apollo.BaseMutationOptions<DeleteSetMutation, DeleteSetMutationVariables>;

      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "AuditEntryEvent": [
      "AuditEntry",
      "ErrorInfo"
    ],
    "DeviceFunctionalAspect": [
      "DFA_Avatar",
      "DFA_Gateway",
      "DFA_Media",
      "DFA_PTZ",
      "DFA_Sensor",
      "DFA_VAE"
    ],
    "RealmObject": [
      "CameraTour",
      "CurrentRealm",
      "Device",
      "GenericObject",
      "GeoTour",
      "Group",
      "Policy",
      "Realm",
      "Schedule",
      "Set",
      "User",
      "Zone"
    ],
    "Report": [
      "NumericReport",
      "StatusReport"
    ]
  }
};
      export default result;
    
export type WithIndex<TObject> = TObject & Record<string, any>;
export type ResolversObject<TObject> = WithIndex<TObject>;

export type ResolverTypeWrapper<T> = Promise<T> | T;


export type ResolverWithResolve<TResult, TParent, TContext, TArgs> = {
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};
export type Resolver<TResult, TParent = Record<PropertyKey, never>, TContext = Record<PropertyKey, never>, TArgs = Record<PropertyKey, never>> = ResolverFn<TResult, TParent, TContext, TArgs> | ResolverWithResolve<TResult, TParent, TContext, TArgs>;

export type ResolverFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => Promise<TResult> | TResult;

export type SubscriptionSubscribeFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => AsyncIterable<TResult> | Promise<AsyncIterable<TResult>>;

export type SubscriptionResolveFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

export interface SubscriptionSubscriberObject<TResult, TKey extends string, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<{ [key in TKey]: TResult }, TParent, TContext, TArgs>;
  resolve?: SubscriptionResolveFn<TResult, { [key in TKey]: TResult }, TContext, TArgs>;
}

export interface SubscriptionResolverObject<TResult, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<any, TParent, TContext, TArgs>;
  resolve: SubscriptionResolveFn<TResult, any, TContext, TArgs>;
}

export type SubscriptionObject<TResult, TKey extends string, TParent, TContext, TArgs> =
  | SubscriptionSubscriberObject<TResult, TKey, TParent, TContext, TArgs>
  | SubscriptionResolverObject<TResult, TParent, TContext, TArgs>;

export type SubscriptionResolver<TResult, TKey extends string, TParent = Record<PropertyKey, never>, TContext = Record<PropertyKey, never>, TArgs = Record<PropertyKey, never>> =
  | ((...args: any[]) => SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>)
  | SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>;

export type TypeResolveFn<TTypes, TParent = Record<PropertyKey, never>, TContext = Record<PropertyKey, never>> = (
  parent: TParent,
  context: TContext,
  info: GraphQLResolveInfo
) => Maybe<TTypes> | Promise<Maybe<TTypes>>;

export type IsTypeOfResolverFn<T = Record<PropertyKey, never>, TContext = Record<PropertyKey, never>> = (obj: T, context: TContext, info: GraphQLResolveInfo) => boolean | Promise<boolean>;

export type NextResolverFn<T> = () => Promise<T>;

export type DirectiveResolverFn<TResult = Record<PropertyKey, never>, TParent = Record<PropertyKey, never>, TContext = Record<PropertyKey, never>, TArgs = Record<PropertyKey, never>> = (
  next: NextResolverFn<TResult>,
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;



/** Mapping of union types */
export type ResolversUnionTypes<_RefType extends Record<string, unknown>> = ResolversObject<{
  AuditEntryEvent:
    | ( Omit<AuditEntry, 'witnesses'> & { witnesses: Array<_RefType['RealmObject']> } )
    | ( ErrorInfo )
  ;
  Report:
    | ( NumericReport )
    | ( StatusReport )
  ;
}>;

/** Mapping of interface types */
export type ResolversInterfaceTypes<_RefType extends Record<string, unknown>> = ResolversObject<{
  DeviceFunctionalAspect:
    | ( Omit<Dfa_Avatar, 'device' | 'inputAspects'> & { device?: Maybe<_RefType['Device']>, inputAspects: Array<_RefType['DeviceFunctionalAspect']> } )
    | ( Omit<Dfa_Gateway, 'device' | 'inputAspects'> & { device?: Maybe<_RefType['Device']>, inputAspects: Array<_RefType['DeviceFunctionalAspect']> } )
    | ( Omit<Dfa_Media, 'device' | 'inputAspects'> & { device?: Maybe<_RefType['Device']>, inputAspects: Array<_RefType['DeviceFunctionalAspect']> } )
    | ( Omit<Dfa_Ptz, 'device' | 'inputAspects'> & { device?: Maybe<_RefType['Device']>, inputAspects: Array<_RefType['DeviceFunctionalAspect']> } )
    | ( Omit<Dfa_Sensor, 'device' | 'inputAspects'> & { device?: Maybe<_RefType['Device']>, inputAspects: Array<_RefType['DeviceFunctionalAspect']> } )
    | ( Omit<Dfa_Vae, 'device' | 'inputAspects'> & { device?: Maybe<_RefType['Device']>, inputAspects: Array<_RefType['DeviceFunctionalAspect']> } )
  ;
  RealmObject:
    | ( CameraTour )
    | ( CurrentRealm )
    | ( Omit<Device, 'alarmPointPosition' | 'aspects' | 'platform' | 'position'> & { alarmPointPosition?: Maybe<_RefType['LatLng']>, aspects: Array<_RefType['DeviceFunctionalAspect']>, platform?: Maybe<_RefType['Device']>, position?: Maybe<_RefType['LatLng']> } )
    | ( GenericObject )
    | ( Omit<GeoTour, 'points'> & { points?: Maybe<Array<_RefType['GeoTourPoint']>> } )
    | ( Group )
    | ( Policy )
    | ( Omit<Realm, 'realmObjects' | 'resellerParent'> & { realmObjects?: Maybe<Array<_RefType['RealmObject']>>, resellerParent?: Maybe<_RefType['Reseller']> } )
    | ( Schedule )
    | ( Set )
    | ( User )
    | ( Zone )
  ;
}>;

/** Mapping between all available schema types and the resolvers types */
export type ResolversTypes = ResolversObject<{
  AccessLevel: ResolverTypeWrapper<AccessLevel>;
  AcknowledgeAuditEntryInput: AcknowledgeAuditEntryInput;
  AcknowledgementEntry: AcknowledgementEntry;
  Action: ResolverTypeWrapper<Action>;
  ActivityId: ActivityId;
  AddSharedViewInput: AddSharedViewInput;
  AodRequest: ResolverTypeWrapper<AodRequest>;
  AodRequestFiles: ResolverTypeWrapper<AodRequestFiles>;
  AodRequestFilesListEntry: ResolverTypeWrapper<AodRequestFilesListEntry>;
  AodRequestFilter: AodRequestFilter;
  AodRequestInput: AodRequestInput;
  AodRequestStatus: AodRequestStatus;
  AodRequestType: AodRequestType;
  AppStore: ResolverTypeWrapper<AppStore>;
  AppStoreInput: AppStoreInput;
  ArchiveBoundary: ResolverTypeWrapper<ArchiveBoundary>;
  ArchiveCoverage: ResolverTypeWrapper<ArchiveCoverage>;
  ArchiveCoverageItem: ResolverTypeWrapper<ArchiveCoverageItem>;
  ArchiveCoverageTTL: ResolverTypeWrapper<ArchiveCoverageTtl>;
  ArchiveLocation: ArchiveLocation;
  AspectHealth: ResolverTypeWrapper<AspectHealth>;
  AspectHealthFilter: AspectHealthFilter;
  AspectSensorCategory: AspectSensorCategory;
  AspectSensorModel: AspectSensorModel;
  AssociatedGatewayDevice: ResolverTypeWrapper<AssociatedGatewayDevice>;
  AssociatedGatewayDeviceInput: AssociatedGatewayDeviceInput;
  AuditCategory: ResolverTypeWrapper<AuditCategory>;
  AuditEntry: ResolverTypeWrapper<Omit<AuditEntry, 'witnesses'> & { witnesses: Array<ResolversTypes['RealmObject']> }>;
  AuditEntryEvent: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['AuditEntryEvent']>;
  AuditEntryFilter: AuditEntryFilter;
  AuditEntryInput: AuditEntryInput;
  AuditEntrySnapshotInput: AuditEntrySnapshotInput;
  AuditSnapshot: ResolverTypeWrapper<AuditSnapshot>;
  AuditSnapshotInput: AuditSnapshotInput;
  AuthType: AuthType;
  AvatarMetric: ResolverTypeWrapper<AvatarMetric>;
  AvatarMetricName: AvatarMetricName;
  BaseDeviceType: BaseDeviceType;
  BasicAccessConfiguration: BasicAccessConfiguration;
  Boolean: ResolverTypeWrapper<Scalars['Boolean']['output']>;
  BoundaryFind: BoundaryFind;
  BrandInfo: ResolverTypeWrapper<BrandInfo>;
  Branding: ResolverTypeWrapper<Branding>;
  BrandingAttribute: ResolverTypeWrapper<BrandingAttribute>;
  BrandingAttributeInput: BrandingAttributeInput;
  BulkDeviceInput: BulkDeviceInput;
  CameraLog: ResolverTypeWrapper<CameraLog>;
  CameraMetric: ResolverTypeWrapper<CameraMetric>;
  CameraMetricName: CameraMetricName;
  CameraTour: ResolverTypeWrapper<CameraTour>;
  CameraTourInput: CameraTourInput;
  CameraTourStep: ResolverTypeWrapper<CameraTourStep>;
  CameraTourStepInput: CameraTourStepInput;
  CameraType: CameraType;
  CameraView: ResolverTypeWrapper<CameraView>;
  CameraViewInput: CameraViewInput;
  ChangeCurrentPasswordInput: ChangeCurrentPasswordInput;
  ChangePasswordInput: ChangePasswordInput;
  ChannelBenchmark: ResolverTypeWrapper<ChannelBenchmark>;
  ChannelStatistics: ResolverTypeWrapper<ChannelStatistics>;
  ChannelStatus: ChannelStatus;
  CreateEventEntry: CreateEventEntry;
  CreateResult: ResolverTypeWrapper<CreateResult>;
  CreatingView: ResolverTypeWrapper<CreatingView>;
  CreatingViewInput: CreatingViewInput;
  Credentials: ResolverTypeWrapper<Credentials>;
  CredentialsInput: CredentialsInput;
  CurrentRealm: ResolverTypeWrapper<CurrentRealm>;
  CurrentRealmInput: CurrentRealmInput;
  DFA_Avatar: ResolverTypeWrapper<Omit<Dfa_Avatar, 'device' | 'inputAspects'> & { device?: Maybe<ResolversTypes['Device']>, inputAspects: Array<ResolversTypes['DeviceFunctionalAspect']> }>;
  DFA_Gateway: ResolverTypeWrapper<Omit<Dfa_Gateway, 'device' | 'inputAspects'> & { device?: Maybe<ResolversTypes['Device']>, inputAspects: Array<ResolversTypes['DeviceFunctionalAspect']> }>;
  DFA_Media: ResolverTypeWrapper<Omit<Dfa_Media, 'device' | 'inputAspects'> & { device?: Maybe<ResolversTypes['Device']>, inputAspects: Array<ResolversTypes['DeviceFunctionalAspect']> }>;
  DFA_PTZ: ResolverTypeWrapper<Omit<Dfa_Ptz, 'device' | 'inputAspects'> & { device?: Maybe<ResolversTypes['Device']>, inputAspects: Array<ResolversTypes['DeviceFunctionalAspect']> }>;
  DFA_Sensor: ResolverTypeWrapper<Omit<Dfa_Sensor, 'device' | 'inputAspects'> & { device?: Maybe<ResolversTypes['Device']>, inputAspects: Array<ResolversTypes['DeviceFunctionalAspect']> }>;
  DFA_VAE: ResolverTypeWrapper<Omit<Dfa_Vae, 'device' | 'inputAspects'> & { device?: Maybe<ResolversTypes['Device']>, inputAspects: Array<ResolversTypes['DeviceFunctionalAspect']> }>;
  DSConfiguredState: DsConfiguredState;
  DSRunningState: DsRunningState;
  DateTime: ResolverTypeWrapper<Scalars['DateTime']['output']>;
  DefaultGeoPosition: ResolverTypeWrapper<DefaultGeoPosition>;
  DeleteSharedViewInput: DeleteSharedViewInput;
  DeliveryPriorityInput: DeliveryPriorityInput;
  Device: ResolverTypeWrapper<Omit<Device, 'alarmPointPosition' | 'aspects' | 'platform' | 'position'> & { alarmPointPosition?: Maybe<ResolversTypes['LatLng']>, aspects: Array<ResolversTypes['DeviceFunctionalAspect']>, platform?: Maybe<ResolversTypes['Device']>, position?: Maybe<ResolversTypes['LatLng']> }>;
  DeviceBaseConfig: ResolverTypeWrapper<DeviceBaseConfig>;
  DeviceBaseConfigInput: DeviceBaseConfigInput;
  DeviceBaseConfigType: DeviceBaseConfigType;
  DeviceCommand: DeviceCommand;
  DeviceEventType: DeviceEventType;
  DeviceFunctionalAspect: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['DeviceFunctionalAspect']>;
  DeviceFunctionalAspectFilter: DeviceFunctionalAspectFilter;
  DeviceFunctionalAspectInput: DeviceFunctionalAspectInput;
  DeviceFunctionalAspectType: DeviceFunctionalAspectType;
  DeviceInput: DeviceInput;
  DeviceProbe: ResolverTypeWrapper<Omit<DeviceProbe, 'aspects'> & { aspects: Array<ResolversTypes['DeviceFunctionalAspect']> }>;
  DeviceProbeInput: DeviceProbeInput;
  DeviceStorageConfig: ResolverTypeWrapper<DeviceStorageConfig>;
  DeviceStorageConfigInput: DeviceStorageConfigInput;
  DeviceTemplate: ResolverTypeWrapper<DeviceTemplate>;
  DeviceTemplateModel: ResolverTypeWrapper<DeviceTemplateModel>;
  EmailAddresses: EmailAddresses;
  EmailAuth: EmailAuth;
  EncryptionKeyInfo: ResolverTypeWrapper<EncryptionKeyInfo>;
  ErrorInfo: ResolverTypeWrapper<ErrorInfo>;
  EventInfo: ResolverTypeWrapper<Omit<EventInfo, 'entry'> & { entry: ResolversTypes['AuditEntry'] }>;
  EventSource: EventSource;
  EventType: EventType;
  FA_HealthGravity: Fa_HealthGravity;
  Feature: ResolverTypeWrapper<Feature>;
  FeatureDesc: ResolverTypeWrapper<FeatureDesc>;
  FeatureInput: FeatureInput;
  FeatureType: FeatureType;
  FileInfo: ResolverTypeWrapper<FileInfo>;
  Filter: Filter;
  Float: ResolverTypeWrapper<Scalars['Float']['output']>;
  FunctionalAspectTemplate: ResolverTypeWrapper<FunctionalAspectTemplate>;
  GEOLayer: ResolverTypeWrapper<GeoLayer>;
  GEOLayerInput: GeoLayerInput;
  GEOLayers: ResolverTypeWrapper<GeoLayers>;
  GEOLayersInput: GeoLayersInput;
  GatewayDeviceInput: GatewayDeviceInput;
  GatewayDirectoriesProbe: ResolverTypeWrapper<Omit<GatewayDirectoriesProbe, 'deviceProbe'> & { deviceProbe: ResolversTypes['DeviceProbe'] }>;
  GatewayDirectoriesProbeInput: GatewayDirectoriesProbeInput;
  GatewayDirectory: ResolverTypeWrapper<GatewayDirectory>;
  GatewayDirectoryInput: GatewayDirectoryInput;
  GatewayEvent: ResolverTypeWrapper<GatewayEvent>;
  GatewayEventInput: GatewayEventInput;
  GatewayModel: GatewayModel;
  GatewayProbe: ResolverTypeWrapper<GatewayProbe>;
  GatewayProbeDevice: ResolverTypeWrapper<GatewayProbeDevice>;
  GatewayProbeEvent: ResolverTypeWrapper<GatewayProbeEvent>;
  GatewayProbeInput: GatewayProbeInput;
  GenericObject: ResolverTypeWrapper<GenericObject>;
  GenericObjectInput: GenericObjectInput;
  GeoIconSet: GeoIconSet;
  GeoMarkerClusterConfig: ResolverTypeWrapper<GeoMarkerClusterConfig>;
  GeoMarkerClusterConfigInput: GeoMarkerClusterConfigInput;
  GeoTour: ResolverTypeWrapper<Omit<GeoTour, 'points'> & { points?: Maybe<Array<ResolversTypes['GeoTourPoint']>> }>;
  GeoTourInput: GeoTourInput;
  GeoTourPoint: ResolverTypeWrapper<Omit<GeoTourPoint, 'position'> & { position: ResolversTypes['LatLng'] }>;
  GeoTourPointInput: GeoTourPointInput;
  GrafanaDashboard: ResolverTypeWrapper<GrafanaDashboard>;
  Group: ResolverTypeWrapper<Group>;
  GroupInput: GroupInput;
  Gui: ResolverTypeWrapper<Gui>;
  HealthStatus: HealthStatus;
  Hierarchy: ResolverTypeWrapper<Hierarchy>;
  HierarchyInput: HierarchyInput;
  HierarchyLevel: ResolverTypeWrapper<HierarchyLevel>;
  HierarchyLevelInput: HierarchyLevelInput;
  ID: ResolverTypeWrapper<Scalars['ID']['output']>;
  IdentityAttribute: ResolverTypeWrapper<IdentityAttribute>;
  ImageMap: ResolverTypeWrapper<ImageMap>;
  ImageMapConfig: ResolverTypeWrapper<ImageMapConfig>;
  ImageMapInput: ImageMapInput;
  ImageMapLayer: ResolverTypeWrapper<ImageMapLayer>;
  ImageMapLayerInput: ImageMapLayerInput;
  ImageMapObject: ResolverTypeWrapper<ImageMapObject>;
  ImageMapObjectInput: ImageMapObjectInput;
  ImageMapSet: ResolverTypeWrapper<ImageMapSet>;
  ImageMapSetInput: ImageMapSetInput;
  ImageMapUpdateAction: ImageMapUpdateAction;
  ImageMapUpdateNotification: ResolverTypeWrapper<ImageMapUpdateNotification>;
  Int: ResolverTypeWrapper<Scalars['Int']['output']>;
  JSON: ResolverTypeWrapper<Scalars['JSON']['output']>;
  JSONObject: ResolverTypeWrapper<Scalars['JSONObject']['output']>;
  KeyValue: ResolverTypeWrapper<KeyValue>;
  KeyValueInput: KeyValueInput;
  Label: ResolverTypeWrapper<Label>;
  LabelInput: LabelInput;
  LabelObject: ResolverTypeWrapper<LabelObject>;
  LabelOrHierarchyUpdate: ResolverTypeWrapper<LabelOrHierarchyUpdate>;
  LabelOrHierarchyUpdateType: LabelOrHierarchyUpdateType;
  LabelType: LabelType;
  Language: ResolverTypeWrapper<Language>;
  Languages: ResolverTypeWrapper<Languages>;
  LatLng: ResolverTypeWrapper<LatLng>;
  LatLngInput: LatLngInput;
  License: ResolverTypeWrapper<License>;
  LocalStorage: ResolverTypeWrapper<LocalStorage>;
  LocalStorageInput: LocalStorageInput;
  LogSeverity: LogSeverity;
  MapType: MapType;
  MediaArchiveOption: MediaArchiveOption;
  MediaStreamSize: MediaStreamSize;
  MediaStreamType: MediaStreamType;
  MetaClassifier: ResolverTypeWrapper<MetaClassifier>;
  MetaClassifierInput: MetaClassifierInput;
  MetaEntry: ResolverTypeWrapper<MetaEntry>;
  MetaEntryInput: MetaEntryInput;
  MetricDimension: MetricDimension;
  MinMax: ResolverTypeWrapper<MinMax>;
  ModifiedByInfo: ResolverTypeWrapper<ModifiedByInfo>;
  Mutation: ResolverTypeWrapper<Record<PropertyKey, never>>;
  NetworkConnectDescriptor: ResolverTypeWrapper<NetworkConnectDescriptor>;
  NetworkConnectDescriptorInput: NetworkConnectDescriptorInput;
  NumericReport: ResolverTypeWrapper<NumericReport>;
  ObjUUID: ResolverTypeWrapper<ObjUuid>;
  ObjUUIDAndName: ResolverTypeWrapper<ObjUuidAndName>;
  ObjUUIDAndNameInput: ObjUuidAndNameInput;
  ObjUUIDInput: ObjUuidInput;
  ObjectAction: ObjectAction;
  ObjectDescriptor: ResolverTypeWrapper<ObjectDescriptor>;
  ObjectUpdateEvent: ResolverTypeWrapper<ObjectUpdateEvent>;
  ObjectUpdateFilter: ObjectUpdateFilter;
  OnvifServiceConfig: ResolverTypeWrapper<OnvifServiceConfig>;
  OnvifServiceConfigInput: OnvifServiceConfigInput;
  OnvifServiceStatus: ResolverTypeWrapper<OnvifServiceStatus>;
  Owner: ResolverTypeWrapper<Owner>;
  OwnerInput: OwnerInput;
  PTZ_AbsInput: Ptz_AbsInput;
  PTZ_Class: Ptz_Class;
  PTZ_HardwareDo: Ptz_HardwareDo;
  PTZ_HardwareInput: Ptz_HardwareInput;
  PTZ_PresetInput: Ptz_PresetInput;
  PTZ_RelInput: Ptz_RelInput;
  PTZ_RelSizeInput: Ptz_RelSizeInput;
  PTZ_SettingsInput: Ptz_SettingsInput;
  PTZ_SettingsPolarity: Ptz_SettingsPolarity;
  PTZ_SettingsSwitch: Ptz_SettingsSwitch;
  PTZ_SpeedInput: Ptz_SpeedInput;
  PTZ_StepFocus: Ptz_StepFocus;
  PTZ_StepGain: Ptz_StepGain;
  PTZ_StepInput: Ptz_StepInput;
  PTZ_StepIris: Ptz_StepIris;
  PTZ_StepMove: Ptz_StepMove;
  PTZ_StepZoom: Ptz_StepZoom;
  Policy: ResolverTypeWrapper<Policy>;
  PolicyInput: PolicyInput;
  PolicyStatement: ResolverTypeWrapper<PolicyStatement>;
  PolicyStatementInput: PolicyStatementInput;
  PoolLocalStorage: ResolverTypeWrapper<PoolLocalStorage>;
  PoolLocalStorageInput: PoolLocalStorageInput;
  Position: ResolverTypeWrapper<Position>;
  PositionInput: PositionInput;
  ProtocolType: ProtocolType;
  PtzAbsArgs: ResolverTypeWrapper<PtzAbsArgs>;
  PtzAttachedBaudRate: PtzAttachedBaudRate;
  PtzAttachedCameraModel: PtzAttachedCameraModel;
  PtzAttachedSerialMode: PtzAttachedSerialMode;
  PtzLock: ResolverTypeWrapper<PtzLock>;
  PtzLockCategory: PtzLockCategory;
  PtzLockProlongation: ResolverTypeWrapper<PtzLockProlongation>;
  PtzLockResult: ResolverTypeWrapper<PtzLockResult>;
  PtzLockType: PtzLockType;
  PtzPosition: ResolverTypeWrapper<PtzPosition>;
  PtzStatus: ResolverTypeWrapper<PtzStatus>;
  PtzTcpAddress: ResolverTypeWrapper<PtzTcpAddress>;
  PtzTcpAddressInput: PtzTcpAddressInput;
  PtzType: PtzType;
  PtzUpdateAction: PtzUpdateAction;
  QortexMappedZone: ResolverTypeWrapper<QortexMappedZone>;
  QortexMappedZoneInput: QortexMappedZoneInput;
  QortexZone: ResolverTypeWrapper<QortexZone>;
  QortexZoneInput: QortexZoneInput;
  QortexZonePoint: ResolverTypeWrapper<QortexZonePoint>;
  QortexZonePointInput: QortexZonePointInput;
  Query: ResolverTypeWrapper<Record<PropertyKey, never>>;
  Realm: ResolverTypeWrapper<Omit<Realm, 'realmObjects' | 'resellerParent'> & { realmObjects?: Maybe<Array<ResolversTypes['RealmObject']>>, resellerParent?: Maybe<ResolversTypes['Reseller']> }>;
  RealmInput: RealmInput;
  RealmObject: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['RealmObject']>;
  RealmObjectInput: RealmObjectInput;
  RealmObjectType: RealmObjectType;
  RealmSubscription: ResolverTypeWrapper<RealmSubscription>;
  RealmSubscriptionInput: RealmSubscriptionInput;
  RealmSubscriptionType: RealmSubscriptionType;
  RecordingArchive: RecordingArchive;
  Report: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['Report']>;
  Reseller: ResolverTypeWrapper<Omit<Reseller, 'brandInfo' | 'children' | 'parent' | 'realms'> & { brandInfo?: Maybe<ResolversTypes['BrandInfo']>, children: Array<ResolversTypes['Reseller']>, parent?: Maybe<ResolversTypes['Reseller']>, realms: Array<ResolversTypes['Realm']> }>;
  Schedule: ResolverTypeWrapper<Schedule>;
  ScheduleAction: ResolverTypeWrapper<ScheduleAction>;
  ScheduleActionInput: ScheduleActionInput;
  ScheduleActionTemplate: ResolverTypeWrapper<ScheduleActionTemplate>;
  ScheduleDeviceType: ScheduleDeviceType;
  ScheduleInput: ScheduleInput;
  ScheduleTask: ResolverTypeWrapper<ScheduleTask>;
  ScheduleTaskInput: ScheduleTaskInput;
  ScheduleUpdateInput: ScheduleUpdateInput;
  SecretPassword: SecretPassword;
  SensorEvent: ResolverTypeWrapper<SensorEvent>;
  SensorEventInput: SensorEventInput;
  Session: ResolverTypeWrapper<Session>;
  SessionCloseEvent: ResolverTypeWrapper<SessionCloseEvent>;
  SessionCloseReason: SessionCloseReason;
  SessionInfo: ResolverTypeWrapper<SessionInfo>;
  SessionInfoInput: SessionInfoInput;
  SessionInput: SessionInput;
  Set: ResolverTypeWrapper<Set>;
  SetInput: SetInput;
  SetPasswordInput: SetPasswordInput;
  SharedViewInput: SharedViewInput;
  SharedViewLayoutCellInput: SharedViewLayoutCellInput;
  SharedViewLayoutInput: SharedViewLayoutInput;
  SharedViewLayoutItemInput: SharedViewLayoutItemInput;
  SharedViewLayoutLeafInput: SharedViewLayoutLeafInput;
  SharedViewLayoutOrientation: SharedViewLayoutOrientation;
  SharedViewLayoutType: SharedViewLayoutType;
  SharedViewWidgetInput: SharedViewWidgetInput;
  SharedViewsUpdateEvent: ResolverTypeWrapper<SharedViewsUpdateEvent>;
  SocketEvent: ResolverTypeWrapper<SocketEvent>;
  SocketEventInput: SocketEventInput;
  SocketEventType: SocketEventType;
  SoftwareInfo: ResolverTypeWrapper<SoftwareInfo>;
  SolidConfigCurrentViewInput: SolidConfigCurrentViewInput;
  SolidConfigUpdateEvent: ResolverTypeWrapper<SolidConfigUpdateEvent>;
  SolidConfiguration: ResolverTypeWrapper<SolidConfiguration>;
  SolidConfigurationInput: SolidConfigurationInput;
  SolidVisualConfig: ResolverTypeWrapper<SolidVisualConfig>;
  StatTime: ResolverTypeWrapper<StatTime>;
  StatementEffect: StatementEffect;
  StatsInput: StatsInput;
  StatusMetric: StatusMetric;
  StatusReport: ResolverTypeWrapper<StatusReport>;
  StoragePool: ResolverTypeWrapper<StoragePool>;
  StorageUsage: ResolverTypeWrapper<StorageUsage>;
  StreamShare: ResolverTypeWrapper<StreamShare>;
  StreamShareInput: StreamShareInput;
  StreamUsagePeriod: StreamUsagePeriod;
  String: ResolverTypeWrapper<Scalars['String']['output']>;
  SubStoragePool: ResolverTypeWrapper<SubStoragePool>;
  SubStoragePoolInput: SubStoragePoolInput;
  SubscribedGatewayEventInput: SubscribedGatewayEventInput;
  Subscription: ResolverTypeWrapper<Record<PropertyKey, never>>;
  SubscriptionStatus: SubscriptionStatus;
  SystemParameters: ResolverTypeWrapper<SystemParameters>;
  SystemStatus: SystemStatus;
  SystemStatusInfo: ResolverTypeWrapper<SystemStatusInfo>;
  SystemStatusReason: ResolverTypeWrapper<SystemStatusReason>;
  SystemStatusReasonObject: ResolverTypeWrapper<SystemStatusReasonObject>;
  Target: ResolverTypeWrapper<Omit<Target, 'position' | 'track'> & { position: ResolversTypes['LatLng'], track?: Maybe<Array<ResolversTypes['LatLng']>> }>;
  TargetClassification: TargetClassification;
  TargetFilter: TargetFilter;
  TargetInput: TargetInput;
  TargetNotification: ResolverTypeWrapper<Omit<TargetNotification, 'position'> & { position: ResolversTypes['LatLng'] }>;
  TargetRisk: TargetRisk;
  TargetType: TargetType;
  TargetUpdateFilter: TargetUpdateFilter;
  UUID: ResolverTypeWrapper<Scalars['UUID']['output']>;
  UnitType: UnitType;
  UpdateResult: ResolverTypeWrapper<UpdateResult>;
  Upload: ResolverTypeWrapper<Scalars['Upload']['output']>;
  User: ResolverTypeWrapper<User>;
  UserData: ResolverTypeWrapper<UserData>;
  UserDataInput: UserDataInput;
  UserInfo: ResolverTypeWrapper<UserInfo>;
  UserInfoInput: UserInfoInput;
  UserInput: UserInput;
  VMXVideoStreamingMode: VmxVideoStreamingMode;
  VaeConfigBrief: ResolverTypeWrapper<VaeConfigBrief>;
  VaeConfigFull: ResolverTypeWrapper<VaeConfigFull>;
  VaeFeature: ResolverTypeWrapper<VaeFeature>;
  VaeFps: ResolverTypeWrapper<VaeFps>;
  VaeFpsInput: VaeFpsInput;
  VaeReasonStatus: ResolverTypeWrapper<VaeReasonStatus>;
  VaeStatFps: ResolverTypeWrapper<VaeStatFps>;
  VaeStatistic: ResolverTypeWrapper<VaeStatistic>;
  VaeStatus: VaeStatus;
  VaeUpdate: ResolverTypeWrapper<VaeUpdate>;
  VaeUpdateStatus: VaeUpdateStatus;
  ViewConfig: ResolverTypeWrapper<ViewConfig>;
  ViewConfigInput: ViewConfigInput;
  ViewId: ViewId;
  WarningField: ResolverTypeWrapper<WarningField>;
  WeekDay: WeekDay;
  WidgetConfig: ResolverTypeWrapper<WidgetConfig>;
  WidgetConfigInput: WidgetConfigInput;
  WidgetId: null;
  WidgetInfo: ResolverTypeWrapper<WidgetInfo>;
  WidgetInfoInput: WidgetInfoInput;
  Workspace: ResolverTypeWrapper<Workspace>;
  WorkspaceInput: WorkspaceInput;
  Zone: ResolverTypeWrapper<Zone>;
  ZoneInput: ZoneInput;
}>;

/** Mapping between all available schema types and the resolvers parents */
export type ResolversParentTypes = ResolversObject<{
  AccessLevel: AccessLevel;
  AcknowledgeAuditEntryInput: AcknowledgeAuditEntryInput;
  AcknowledgementEntry: AcknowledgementEntry;
  Action: Action;
  AddSharedViewInput: AddSharedViewInput;
  AodRequest: AodRequest;
  AodRequestFiles: AodRequestFiles;
  AodRequestFilesListEntry: AodRequestFilesListEntry;
  AodRequestFilter: AodRequestFilter;
  AodRequestInput: AodRequestInput;
  AppStore: AppStore;
  AppStoreInput: AppStoreInput;
  ArchiveBoundary: ArchiveBoundary;
  ArchiveCoverage: ArchiveCoverage;
  ArchiveCoverageItem: ArchiveCoverageItem;
  ArchiveCoverageTTL: ArchiveCoverageTtl;
  AspectHealth: AspectHealth;
  AspectHealthFilter: AspectHealthFilter;
  AssociatedGatewayDevice: AssociatedGatewayDevice;
  AssociatedGatewayDeviceInput: AssociatedGatewayDeviceInput;
  AuditCategory: AuditCategory;
  AuditEntry: Omit<AuditEntry, 'witnesses'> & { witnesses: Array<ResolversParentTypes['RealmObject']> };
  AuditEntryEvent: ResolversUnionTypes<ResolversParentTypes>['AuditEntryEvent'];
  AuditEntryFilter: AuditEntryFilter;
  AuditEntryInput: AuditEntryInput;
  AuditEntrySnapshotInput: AuditEntrySnapshotInput;
  AuditSnapshot: AuditSnapshot;
  AuditSnapshotInput: AuditSnapshotInput;
  AvatarMetric: AvatarMetric;
  Boolean: Scalars['Boolean']['output'];
  BrandInfo: BrandInfo;
  Branding: Branding;
  BrandingAttribute: BrandingAttribute;
  BrandingAttributeInput: BrandingAttributeInput;
  BulkDeviceInput: BulkDeviceInput;
  CameraLog: CameraLog;
  CameraMetric: CameraMetric;
  CameraTour: CameraTour;
  CameraTourInput: CameraTourInput;
  CameraTourStep: CameraTourStep;
  CameraTourStepInput: CameraTourStepInput;
  CameraView: CameraView;
  CameraViewInput: CameraViewInput;
  ChangeCurrentPasswordInput: ChangeCurrentPasswordInput;
  ChangePasswordInput: ChangePasswordInput;
  ChannelBenchmark: ChannelBenchmark;
  ChannelStatistics: ChannelStatistics;
  CreateEventEntry: CreateEventEntry;
  CreateResult: CreateResult;
  CreatingView: CreatingView;
  CreatingViewInput: CreatingViewInput;
  Credentials: Credentials;
  CredentialsInput: CredentialsInput;
  CurrentRealm: CurrentRealm;
  CurrentRealmInput: CurrentRealmInput;
  DFA_Avatar: Omit<Dfa_Avatar, 'device' | 'inputAspects'> & { device?: Maybe<ResolversParentTypes['Device']>, inputAspects: Array<ResolversParentTypes['DeviceFunctionalAspect']> };
  DFA_Gateway: Omit<Dfa_Gateway, 'device' | 'inputAspects'> & { device?: Maybe<ResolversParentTypes['Device']>, inputAspects: Array<ResolversParentTypes['DeviceFunctionalAspect']> };
  DFA_Media: Omit<Dfa_Media, 'device' | 'inputAspects'> & { device?: Maybe<ResolversParentTypes['Device']>, inputAspects: Array<ResolversParentTypes['DeviceFunctionalAspect']> };
  DFA_PTZ: Omit<Dfa_Ptz, 'device' | 'inputAspects'> & { device?: Maybe<ResolversParentTypes['Device']>, inputAspects: Array<ResolversParentTypes['DeviceFunctionalAspect']> };
  DFA_Sensor: Omit<Dfa_Sensor, 'device' | 'inputAspects'> & { device?: Maybe<ResolversParentTypes['Device']>, inputAspects: Array<ResolversParentTypes['DeviceFunctionalAspect']> };
  DFA_VAE: Omit<Dfa_Vae, 'device' | 'inputAspects'> & { device?: Maybe<ResolversParentTypes['Device']>, inputAspects: Array<ResolversParentTypes['DeviceFunctionalAspect']> };
  DateTime: Scalars['DateTime']['output'];
  DefaultGeoPosition: DefaultGeoPosition;
  DeleteSharedViewInput: DeleteSharedViewInput;
  DeliveryPriorityInput: DeliveryPriorityInput;
  Device: Omit<Device, 'alarmPointPosition' | 'aspects' | 'platform' | 'position'> & { alarmPointPosition?: Maybe<ResolversParentTypes['LatLng']>, aspects: Array<ResolversParentTypes['DeviceFunctionalAspect']>, platform?: Maybe<ResolversParentTypes['Device']>, position?: Maybe<ResolversParentTypes['LatLng']> };
  DeviceBaseConfig: DeviceBaseConfig;
  DeviceBaseConfigInput: DeviceBaseConfigInput;
  DeviceFunctionalAspect: ResolversInterfaceTypes<ResolversParentTypes>['DeviceFunctionalAspect'];
  DeviceFunctionalAspectFilter: DeviceFunctionalAspectFilter;
  DeviceFunctionalAspectInput: DeviceFunctionalAspectInput;
  DeviceInput: DeviceInput;
  DeviceProbe: Omit<DeviceProbe, 'aspects'> & { aspects: Array<ResolversParentTypes['DeviceFunctionalAspect']> };
  DeviceProbeInput: DeviceProbeInput;
  DeviceStorageConfig: DeviceStorageConfig;
  DeviceStorageConfigInput: DeviceStorageConfigInput;
  DeviceTemplate: DeviceTemplate;
  DeviceTemplateModel: DeviceTemplateModel;
  EmailAddresses: EmailAddresses;
  EncryptionKeyInfo: EncryptionKeyInfo;
  ErrorInfo: ErrorInfo;
  EventInfo: Omit<EventInfo, 'entry'> & { entry: ResolversParentTypes['AuditEntry'] };
  Feature: Feature;
  FeatureDesc: FeatureDesc;
  FeatureInput: FeatureInput;
  FileInfo: FileInfo;
  Filter: Filter;
  Float: Scalars['Float']['output'];
  FunctionalAspectTemplate: FunctionalAspectTemplate;
  GEOLayer: GeoLayer;
  GEOLayerInput: GeoLayerInput;
  GEOLayers: GeoLayers;
  GEOLayersInput: GeoLayersInput;
  GatewayDeviceInput: GatewayDeviceInput;
  GatewayDirectoriesProbe: Omit<GatewayDirectoriesProbe, 'deviceProbe'> & { deviceProbe: ResolversParentTypes['DeviceProbe'] };
  GatewayDirectoriesProbeInput: GatewayDirectoriesProbeInput;
  GatewayDirectory: GatewayDirectory;
  GatewayDirectoryInput: GatewayDirectoryInput;
  GatewayEvent: GatewayEvent;
  GatewayEventInput: GatewayEventInput;
  GatewayProbe: GatewayProbe;
  GatewayProbeDevice: GatewayProbeDevice;
  GatewayProbeEvent: GatewayProbeEvent;
  GatewayProbeInput: GatewayProbeInput;
  GenericObject: GenericObject;
  GenericObjectInput: GenericObjectInput;
  GeoMarkerClusterConfig: GeoMarkerClusterConfig;
  GeoMarkerClusterConfigInput: GeoMarkerClusterConfigInput;
  GeoTour: Omit<GeoTour, 'points'> & { points?: Maybe<Array<ResolversParentTypes['GeoTourPoint']>> };
  GeoTourInput: GeoTourInput;
  GeoTourPoint: Omit<GeoTourPoint, 'position'> & { position: ResolversParentTypes['LatLng'] };
  GeoTourPointInput: GeoTourPointInput;
  GrafanaDashboard: GrafanaDashboard;
  Group: Group;
  GroupInput: GroupInput;
  Gui: Gui;
  Hierarchy: Hierarchy;
  HierarchyInput: HierarchyInput;
  HierarchyLevel: HierarchyLevel;
  HierarchyLevelInput: HierarchyLevelInput;
  ID: Scalars['ID']['output'];
  IdentityAttribute: IdentityAttribute;
  ImageMap: ImageMap;
  ImageMapConfig: ImageMapConfig;
  ImageMapInput: ImageMapInput;
  ImageMapLayer: ImageMapLayer;
  ImageMapLayerInput: ImageMapLayerInput;
  ImageMapObject: ImageMapObject;
  ImageMapObjectInput: ImageMapObjectInput;
  ImageMapSet: ImageMapSet;
  ImageMapSetInput: ImageMapSetInput;
  ImageMapUpdateNotification: ImageMapUpdateNotification;
  Int: Scalars['Int']['output'];
  JSON: Scalars['JSON']['output'];
  JSONObject: Scalars['JSONObject']['output'];
  KeyValue: KeyValue;
  KeyValueInput: KeyValueInput;
  Label: Label;
  LabelInput: LabelInput;
  LabelObject: LabelObject;
  LabelOrHierarchyUpdate: LabelOrHierarchyUpdate;
  Language: Language;
  Languages: Languages;
  LatLng: LatLng;
  LatLngInput: LatLngInput;
  License: License;
  LocalStorage: LocalStorage;
  LocalStorageInput: LocalStorageInput;
  MetaClassifier: MetaClassifier;
  MetaClassifierInput: MetaClassifierInput;
  MetaEntry: MetaEntry;
  MetaEntryInput: MetaEntryInput;
  MinMax: MinMax;
  ModifiedByInfo: ModifiedByInfo;
  Mutation: Record<PropertyKey, never>;
  NetworkConnectDescriptor: NetworkConnectDescriptor;
  NetworkConnectDescriptorInput: NetworkConnectDescriptorInput;
  NumericReport: NumericReport;
  ObjUUID: ObjUuid;
  ObjUUIDAndName: ObjUuidAndName;
  ObjUUIDAndNameInput: ObjUuidAndNameInput;
  ObjUUIDInput: ObjUuidInput;
  ObjectDescriptor: ObjectDescriptor;
  ObjectUpdateEvent: ObjectUpdateEvent;
  ObjectUpdateFilter: ObjectUpdateFilter;
  OnvifServiceConfig: OnvifServiceConfig;
  OnvifServiceConfigInput: OnvifServiceConfigInput;
  OnvifServiceStatus: OnvifServiceStatus;
  Owner: Owner;
  OwnerInput: OwnerInput;
  PTZ_AbsInput: Ptz_AbsInput;
  PTZ_HardwareInput: Ptz_HardwareInput;
  PTZ_PresetInput: Ptz_PresetInput;
  PTZ_RelInput: Ptz_RelInput;
  PTZ_RelSizeInput: Ptz_RelSizeInput;
  PTZ_SettingsInput: Ptz_SettingsInput;
  PTZ_SpeedInput: Ptz_SpeedInput;
  PTZ_StepInput: Ptz_StepInput;
  Policy: Policy;
  PolicyInput: PolicyInput;
  PolicyStatement: PolicyStatement;
  PolicyStatementInput: PolicyStatementInput;
  PoolLocalStorage: PoolLocalStorage;
  PoolLocalStorageInput: PoolLocalStorageInput;
  Position: Position;
  PositionInput: PositionInput;
  PtzAbsArgs: PtzAbsArgs;
  PtzLock: PtzLock;
  PtzLockProlongation: PtzLockProlongation;
  PtzLockResult: PtzLockResult;
  PtzPosition: PtzPosition;
  PtzStatus: PtzStatus;
  PtzTcpAddress: PtzTcpAddress;
  PtzTcpAddressInput: PtzTcpAddressInput;
  QortexMappedZone: QortexMappedZone;
  QortexMappedZoneInput: QortexMappedZoneInput;
  QortexZone: QortexZone;
  QortexZoneInput: QortexZoneInput;
  QortexZonePoint: QortexZonePoint;
  QortexZonePointInput: QortexZonePointInput;
  Query: Record<PropertyKey, never>;
  Realm: Omit<Realm, 'realmObjects' | 'resellerParent'> & { realmObjects?: Maybe<Array<ResolversParentTypes['RealmObject']>>, resellerParent?: Maybe<ResolversParentTypes['Reseller']> };
  RealmInput: RealmInput;
  RealmObject: ResolversInterfaceTypes<ResolversParentTypes>['RealmObject'];
  RealmObjectInput: RealmObjectInput;
  RealmSubscription: RealmSubscription;
  RealmSubscriptionInput: RealmSubscriptionInput;
  Report: ResolversUnionTypes<ResolversParentTypes>['Report'];
  Reseller: Omit<Reseller, 'brandInfo' | 'children' | 'parent' | 'realms'> & { brandInfo?: Maybe<ResolversParentTypes['BrandInfo']>, children: Array<ResolversParentTypes['Reseller']>, parent?: Maybe<ResolversParentTypes['Reseller']>, realms: Array<ResolversParentTypes['Realm']> };
  Schedule: Schedule;
  ScheduleAction: ScheduleAction;
  ScheduleActionInput: ScheduleActionInput;
  ScheduleActionTemplate: ScheduleActionTemplate;
  ScheduleInput: ScheduleInput;
  ScheduleTask: ScheduleTask;
  ScheduleTaskInput: ScheduleTaskInput;
  ScheduleUpdateInput: ScheduleUpdateInput;
  SecretPassword: SecretPassword;
  SensorEvent: SensorEvent;
  SensorEventInput: SensorEventInput;
  Session: Session;
  SessionCloseEvent: SessionCloseEvent;
  SessionInfo: SessionInfo;
  SessionInfoInput: SessionInfoInput;
  SessionInput: SessionInput;
  Set: Set;
  SetInput: SetInput;
  SetPasswordInput: SetPasswordInput;
  SharedViewInput: SharedViewInput;
  SharedViewLayoutCellInput: SharedViewLayoutCellInput;
  SharedViewLayoutInput: SharedViewLayoutInput;
  SharedViewLayoutItemInput: SharedViewLayoutItemInput;
  SharedViewLayoutLeafInput: SharedViewLayoutLeafInput;
  SharedViewWidgetInput: SharedViewWidgetInput;
  SharedViewsUpdateEvent: SharedViewsUpdateEvent;
  SocketEvent: SocketEvent;
  SocketEventInput: SocketEventInput;
  SoftwareInfo: SoftwareInfo;
  SolidConfigCurrentViewInput: SolidConfigCurrentViewInput;
  SolidConfigUpdateEvent: SolidConfigUpdateEvent;
  SolidConfiguration: SolidConfiguration;
  SolidConfigurationInput: SolidConfigurationInput;
  SolidVisualConfig: SolidVisualConfig;
  StatTime: StatTime;
  StatsInput: StatsInput;
  StatusReport: StatusReport;
  StoragePool: StoragePool;
  StorageUsage: StorageUsage;
  StreamShare: StreamShare;
  StreamShareInput: StreamShareInput;
  StreamUsagePeriod: StreamUsagePeriod;
  String: Scalars['String']['output'];
  SubStoragePool: SubStoragePool;
  SubStoragePoolInput: SubStoragePoolInput;
  SubscribedGatewayEventInput: SubscribedGatewayEventInput;
  Subscription: Record<PropertyKey, never>;
  SystemParameters: SystemParameters;
  SystemStatusInfo: SystemStatusInfo;
  SystemStatusReason: SystemStatusReason;
  SystemStatusReasonObject: SystemStatusReasonObject;
  Target: Omit<Target, 'position' | 'track'> & { position: ResolversParentTypes['LatLng'], track?: Maybe<Array<ResolversParentTypes['LatLng']>> };
  TargetFilter: TargetFilter;
  TargetInput: TargetInput;
  TargetNotification: Omit<TargetNotification, 'position'> & { position: ResolversParentTypes['LatLng'] };
  TargetUpdateFilter: TargetUpdateFilter;
  UUID: Scalars['UUID']['output'];
  UpdateResult: UpdateResult;
  Upload: Scalars['Upload']['output'];
  User: User;
  UserData: UserData;
  UserDataInput: UserDataInput;
  UserInfo: UserInfo;
  UserInfoInput: UserInfoInput;
  UserInput: UserInput;
  VaeConfigBrief: VaeConfigBrief;
  VaeConfigFull: VaeConfigFull;
  VaeFeature: VaeFeature;
  VaeFps: VaeFps;
  VaeFpsInput: VaeFpsInput;
  VaeReasonStatus: VaeReasonStatus;
  VaeStatFps: VaeStatFps;
  VaeStatistic: VaeStatistic;
  VaeUpdate: VaeUpdate;
  ViewConfig: ViewConfig;
  ViewConfigInput: ViewConfigInput;
  WarningField: WarningField;
  WidgetConfig: WidgetConfig;
  WidgetConfigInput: WidgetConfigInput;
  WidgetInfo: WidgetInfo;
  WidgetInfoInput: WidgetInfoInput;
  Workspace: Workspace;
  WorkspaceInput: WorkspaceInput;
  Zone: Zone;
  ZoneInput: ZoneInput;
}>;

export type AuthDirectiveArgs = { };

export type AuthDirectiveResolver<Result, Parent, ContextType = ClientContext, Args = AuthDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type ClientDirectiveArgs = { };

export type ClientDirectiveResolver<Result, Parent, ContextType = ClientContext, Args = ClientDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type ComplexityDirectiveArgs = {
  multipliers?: Maybe<Array<Scalars['String']['input']>>;
  value: Scalars['Int']['input'];
};

export type ComplexityDirectiveResolver<Result, Parent, ContextType = ClientContext, Args = ComplexityDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type KeyDirectiveArgs = {
  fields?: Maybe<Scalars['String']['input']>;
};

export type KeyDirectiveResolver<Result, Parent, ContextType = ClientContext, Args = KeyDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type ProvidesDirectiveArgs = {
  fields?: Maybe<Scalars['String']['input']>;
};

export type ProvidesDirectiveResolver<Result, Parent, ContextType = ClientContext, Args = ProvidesDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type AccessLevelResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['AccessLevel'] = ResolversParentTypes['AccessLevel']> = ResolversObject<{
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  level?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  order?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
}>;

export type ActionResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['Action'] = ResolversParentTypes['Action']> = ResolversObject<{
  accessLevel?: Resolver<ResolversTypes['AccessLevel'], ParentType, ContextType>;
  action?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  deviceFunctionalAspectTypes?: Resolver<Array<ResolversTypes['DeviceFunctionalAspectType']>, ParentType, ContextType>;
  resourceTypes?: Resolver<Array<ResolversTypes['RealmObjectType']>, ParentType, ContextType>;
}>;

export type AodRequestResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['AodRequest'] = ResolversParentTypes['AodRequest']> = ResolversObject<{
  avatarId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  completedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  deviceId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  downloaded?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  endTime?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  eta?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  eventId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  expiredAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  files?: Resolver<Maybe<ResolversTypes['AodRequestFiles']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  realmId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  size?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  startTime?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['AodRequestStatus'], ParentType, ContextType>;
  streamNumber?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['AodRequestType']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
}>;

export type AodRequestFilesResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['AodRequestFiles'] = ResolversParentTypes['AodRequestFiles']> = ResolversObject<{
  expired?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  list?: Resolver<Array<ResolversTypes['AodRequestFilesListEntry']>, ParentType, ContextType>;
}>;

export type AodRequestFilesListEntryResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['AodRequestFilesListEntry'] = ResolversParentTypes['AodRequestFilesListEntry']> = ResolversObject<{
  endTime?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  href?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  size?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  startTime?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
}>;

export type AppStoreResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['AppStore'] = ResolversParentTypes['AppStore']> = ResolversObject<{
  branding?: Resolver<Maybe<ResolversTypes['BrandingAttribute']>, ParentType, ContextType>;
  select?: Resolver<Maybe<ResolversTypes['ObjUUID']>, ParentType, ContextType>;
  session?: Resolver<ResolversTypes['Session'], ParentType, ContextType>;
  socketEvent?: Resolver<Maybe<ResolversTypes['SocketEvent']>, ParentType, ContextType>;
  workspace?: Resolver<ResolversTypes['Workspace'], ParentType, ContextType>;
}>;

export type ArchiveBoundaryResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['ArchiveBoundary'] = ResolversParentTypes['ArchiveBoundary']> = ResolversObject<{
  boundary?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  timeInsideGap?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
}>;

export type ArchiveCoverageResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['ArchiveCoverage'] = ResolversParentTypes['ArchiveCoverage']> = ResolversObject<{
  coverage?: Resolver<Array<ResolversTypes['ArchiveCoverageItem']>, ParentType, ContextType>;
  partialCoverage?: Resolver<Array<ResolversTypes['ArchiveCoverageItem']>, ParentType, ContextType>;
  ttl?: Resolver<Array<ResolversTypes['ArchiveCoverageTTL']>, ParentType, ContextType>;
}>;

export type ArchiveCoverageItemResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['ArchiveCoverageItem'] = ResolversParentTypes['ArchiveCoverageItem']> = ResolversObject<{
  deviceId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  streamNumber?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  time?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
}>;

export type ArchiveCoverageTtlResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['ArchiveCoverageTTL'] = ResolversParentTypes['ArchiveCoverageTTL']> = ResolversObject<{
  deviceId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  ttl?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
}>;

export type AspectHealthResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['AspectHealth'] = ResolversParentTypes['AspectHealth']> = ResolversObject<{
  gravity?: Resolver<ResolversTypes['FA_HealthGravity'], ParentType, ContextType>;
  healthStatus?: Resolver<ResolversTypes['HealthStatus'], ParentType, ContextType>;
  livenessTimeout?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  readinessTimeout?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
}>;

export type AssociatedGatewayDeviceResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['AssociatedGatewayDevice'] = ResolversParentTypes['AssociatedGatewayDevice']> = ResolversObject<{
  associatedDevices?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
}>;

export type AuditCategoryResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['AuditCategory'] = ResolversParentTypes['AuditCategory']> = ResolversObject<{
  digest?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  parent?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  shortName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
}>;

export type AuditEntryResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['AuditEntry'] = ResolversParentTypes['AuditEntry']> = ResolversObject<{
  category?: Resolver<ResolversTypes['AuditCategory'], ParentType, ContextType>;
  context?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isAcknowledged?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  metadata?: Resolver<Array<ResolversTypes['MetaEntry']>, ParentType, ContextType>;
  modifiedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  snapshots?: Resolver<Array<ResolversTypes['AuditSnapshot']>, ParentType, ContextType>;
  triggeredAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  witnesses?: Resolver<Array<ResolversTypes['RealmObject']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AuditEntryEventResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['AuditEntryEvent'] = ResolversParentTypes['AuditEntryEvent']> = ResolversObject<{
  __resolveType: TypeResolveFn<'AuditEntry' | 'ErrorInfo', ParentType, ContextType>;
}>;

export type AuditSnapshotResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['AuditSnapshot'] = ResolversParentTypes['AuditSnapshot']> = ResolversObject<{
  default?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  snapshot?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tags?: Resolver<Array<ResolversTypes['KeyValue']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
}>;

export type AvatarMetricResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['AvatarMetric'] = ResolversParentTypes['AvatarMetric']> = ResolversObject<{
  dimension?: Resolver<ResolversTypes['MetricDimension'], ParentType, ContextType>;
  key?: Resolver<ResolversTypes['AvatarMetricName'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
}>;

export type BrandInfoResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['BrandInfo'] = ResolversParentTypes['BrandInfo']> = ResolversObject<{
  iconUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  logoUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  shortName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  website?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
}>;

export type BrandingResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['Branding'] = ResolversParentTypes['Branding']> = ResolversObject<{
  crmRegistrationUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  iconPath?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  loginBackgroundPath?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  loginFooterColor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  logoPath?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  oemBrand?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  oemBrandName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  oemCompanyLong?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  oemCompanyPhone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  oemCompanyPhoneInternational?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  oemCompanyQuickstart?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  oemCompanyShort?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  oemCompanySupportPhone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  oemCompanySupportUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  oemCompanyUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  oemCopyright?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  oemCopyrightMatrix?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  oemStyle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  oemSupportEmail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  oemTrademarks?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  quickStartGuidePath?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
}>;

export type BrandingAttributeResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['BrandingAttribute'] = ResolversParentTypes['BrandingAttribute']> = ResolversObject<{
  CRM_REGISTRATION_URL?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  ICON_PATH?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  LOGIN_BACKGROUND_PATH?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  LOGIN_BANNER_TEXT_PATH?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  LOGIN_FOOTER_COLOR?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  LOGIN_HEADER_COLOR?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  LOGO_PATH?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  OEM_BRAND?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  OEM_BRAND_NAME?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  OEM_COMPANY_LONG?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  OEM_COMPANY_PHONE?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  OEM_COMPANY_PHONE_INTERNATIONAL?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  OEM_COMPANY_QUICKSTART?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  OEM_COMPANY_SHORT?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  OEM_COMPANY_SUPPORT_PHONE?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  OEM_COMPANY_SUPPORT_URL?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  OEM_COMPANY_URL?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  OEM_COPYRIGHT?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  OEM_COPYRIGHT_MATRIX?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  OEM_STYLE?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  OEM_SUPPORT_EMAIL?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  OEM_TRADEMARKS?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  QUICK_START_GUIDE_PATH?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  SOLID_LOGO_VISIBLE?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
}>;

export type CameraLogResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['CameraLog'] = ResolversParentTypes['CameraLog']> = ResolversObject<{
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  severity?: Resolver<ResolversTypes['LogSeverity'], ParentType, ContextType>;
  time?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
}>;

export type CameraMetricResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['CameraMetric'] = ResolversParentTypes['CameraMetric']> = ResolversObject<{
  dfaId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  dimension?: Resolver<ResolversTypes['MetricDimension'], ParentType, ContextType>;
  key?: Resolver<ResolversTypes['CameraMetricName'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
}>;

export type CameraTourResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['CameraTour'] = ResolversParentTypes['CameraTour']> = ResolversObject<{
  createdAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  enabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  modifiedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  steps?: Resolver<Maybe<Array<ResolversTypes['CameraTourStep']>>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['RealmObjectType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CameraTourStepResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['CameraTourStep'] = ResolversParentTypes['CameraTourStep']> = ResolversObject<{
  cameraId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  cameraPreset?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  delay?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
}>;

export type CameraViewResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['CameraView'] = ResolversParentTypes['CameraView']> = ResolversObject<{
  fieldOfView?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  northOffsetAngle?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  ptzLockProlongation?: Resolver<Maybe<ResolversTypes['PtzLockProlongation']>, ParentType, ContextType>;
  ptzStatus?: Resolver<Maybe<ResolversTypes['PtzStatus']>, ParentType, ContextType>;
  viewDistance?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type ChannelBenchmarkResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['ChannelBenchmark'] = ResolversParentTypes['ChannelBenchmark']> = ResolversObject<{
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  startedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  tcpDown?: Resolver<Maybe<ResolversTypes['ChannelStatistics']>, ParentType, ContextType>;
  tcpUp?: Resolver<Maybe<ResolversTypes['ChannelStatistics']>, ParentType, ContextType>;
}>;

export type ChannelStatisticsResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['ChannelStatistics'] = ResolversParentTypes['ChannelStatistics']> = ResolversObject<{
  bitsPerSecond?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  bytes?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  maxRtt?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  maxSndCwnd?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  meanRtt?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  minRtt?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  retransmits?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
}>;

export type CreateResultResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['CreateResult'] = ResolversParentTypes['CreateResult']> = ResolversObject<{
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  warning?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  warningFields?: Resolver<Maybe<Array<ResolversTypes['WarningField']>>, ParentType, ContextType>;
}>;

export type CreatingViewResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['CreatingView'] = ResolversParentTypes['CreatingView']> = ResolversObject<{
  layout?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  layoutJSON?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  selectedWidget?: Resolver<Maybe<ResolversTypes['WidgetInfo']>, ParentType, ContextType>;
  template?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  viewId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  widgets?: Resolver<Maybe<Array<ResolversTypes['WidgetInfo']>>, ParentType, ContextType>;
}>;

export type CredentialsResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['Credentials'] = ResolversParentTypes['Credentials']> = ResolversObject<{
  certificate?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  privatekey?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
}>;

export type CurrentRealmResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['CurrentRealm'] = ResolversParentTypes['CurrentRealm']> = ResolversObject<{
  createdAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  imageMapConfig?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  maxDownloadLength?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  modifiedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  sharedViews?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['RealmObjectType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type Dfa_AvatarResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['DFA_Avatar'] = ResolversParentTypes['DFA_Avatar']> = ResolversObject<{
  apiKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  avatarLoad?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  channelBenchmark?: Resolver<Maybe<ResolversTypes['ChannelBenchmark']>, ParentType, ContextType>;
  channelStatus?: Resolver<Maybe<ResolversTypes['ChannelStatus']>, ParentType, ContextType>;
  channelTurnaroundTime?: Resolver<Maybe<ResolversTypes['StatTime']>, ParentType, ContextType>;
  deliveryQueue?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  deliveryQueueUploadTime?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  device?: Resolver<Maybe<ResolversTypes['Device']>, ParentType, ContextType>;
  dsConfiguredState?: Resolver<Maybe<ResolversTypes['DSConfiguredState']>, ParentType, ContextType>;
  dsRunningState?: Resolver<Maybe<ResolversTypes['DSRunningState']>, ParentType, ContextType>;
  enabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  encryptionKey?: Resolver<Maybe<ResolversTypes['EncryptionKeyInfo']>, ParentType, ContextType>;
  extended?: Resolver<Maybe<ResolversTypes['JSONObject']>, ParentType, ContextType>;
  health?: Resolver<ResolversTypes['AspectHealth'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  inputAspects?: Resolver<Array<ResolversTypes['DeviceFunctionalAspect']>, ParentType, ContextType>;
  isLink?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  lastStatusUpdate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  localStorage?: Resolver<Maybe<ResolversTypes['LocalStorage']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  onvifServiceConf?: Resolver<ResolversTypes['OnvifServiceConfig'], ParentType, ContextType>;
  packetArrivalJitterTime?: Resolver<Maybe<ResolversTypes['StatTime']>, ParentType, ContextType>;
  platform?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pushEventEndPoint?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  software?: Resolver<Maybe<ResolversTypes['SoftwareInfo']>, ParentType, ContextType>;
  statusUpdateInterval?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  storageUsage?: Resolver<Maybe<ResolversTypes['StorageUsage']>, ParentType, ContextType>;
  supportsReboot?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  template?: Resolver<ResolversTypes['FunctionalAspectTemplate'], ParentType, ContextType>;
  turnaroundTime?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['DeviceFunctionalAspectType'], ParentType, ContextType>;
  upTime?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  uploadBandwidthCap?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  vaeImageUpdate?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  vaeUpdates?: Resolver<Maybe<Array<ResolversTypes['VaeUpdate']>>, ParentType, ContextType>;
  vmxVideoStreamingMode?: Resolver<Maybe<ResolversTypes['VMXVideoStreamingMode']>, ParentType, ContextType>;
  webRtcEnabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type Dfa_GatewayResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['DFA_Gateway'] = ResolversParentTypes['DFA_Gateway']> = ResolversObject<{
  associatedGatewayDevices?: Resolver<Array<ResolversTypes['AssociatedGatewayDevice']>, ParentType, ContextType>;
  device?: Resolver<Maybe<ResolversTypes['Device']>, ParentType, ContextType>;
  devices?: Resolver<Array<ResolversTypes['GatewayProbeDevice']>, ParentType, ContextType>;
  directories?: Resolver<Array<ResolversTypes['GatewayDirectory']>, ParentType, ContextType>;
  directory?: Resolver<ResolversTypes['GatewayDirectory'], ParentType, ContextType>;
  enabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  events?: Resolver<Array<ResolversTypes['GatewayProbeEvent']>, ParentType, ContextType>;
  health?: Resolver<ResolversTypes['AspectHealth'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  inputAspects?: Resolver<Array<ResolversTypes['DeviceFunctionalAspect']>, ParentType, ContextType>;
  lenelVersion?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  oidcToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subscribedEvents?: Resolver<Array<ResolversTypes['GatewayEvent']>, ParentType, ContextType>;
  template?: Resolver<ResolversTypes['FunctionalAspectTemplate'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['DeviceFunctionalAspectType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type Dfa_MediaResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['DFA_Media'] = ResolversParentTypes['DFA_Media']> = ResolversObject<{
  FPS?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  URL?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  audioCodec?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  averageFPS?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  averageGOP?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  averageInterArrivalJitter?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  cloudArchive?: Resolver<ResolversTypes['MediaArchiveOption'], ParentType, ContextType>;
  codec?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  consumedSpace?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  device?: Resolver<Maybe<ResolversTypes['Device']>, ParentType, ContextType>;
  edgeArchive?: Resolver<ResolversTypes['MediaArchiveOption'], ParentType, ContextType>;
  enabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  frameRate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  health?: Resolver<ResolversTypes['AspectHealth'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  inputAspects?: Resolver<Array<ResolversTypes['DeviceFunctionalAspect']>, ParentType, ContextType>;
  liveBitrate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  onvifProfile?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  onvifProfiles?: Resolver<Maybe<ResolversTypes['JSONObject']>, ParentType, ContextType>;
  recordingArchive?: Resolver<ResolversTypes['RecordingArchive'], ParentType, ContextType>;
  rtpPacketLost?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sharedStream?: Resolver<Maybe<Array<ResolversTypes['StreamShare']>>, ParentType, ContextType>;
  spaceUsageDay?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  spaceUsageHour?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  streamSize?: Resolver<Maybe<ResolversTypes['MediaStreamSize']>, ParentType, ContextType>;
  streamType?: Resolver<ResolversTypes['MediaStreamType'], ParentType, ContextType>;
  template?: Resolver<ResolversTypes['FunctionalAspectTemplate'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['DeviceFunctionalAspectType'], ParentType, ContextType>;
  uptime?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  videoCodec?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  videoHeight?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  videoSize?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  videoWidth?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type Dfa_PtzResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['DFA_PTZ'] = ResolversParentTypes['DFA_PTZ']> = ResolversObject<{
  cameraType?: Resolver<ResolversTypes['CameraType'], ParentType, ContextType>;
  cmdClassSupport?: Resolver<Maybe<Array<ResolversTypes['PTZ_Class']>>, ParentType, ContextType>;
  device?: Resolver<Maybe<ResolversTypes['Device']>, ParentType, ContextType>;
  enabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  health?: Resolver<ResolversTypes['AspectHealth'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  inputAspects?: Resolver<Array<ResolversTypes['DeviceFunctionalAspect']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  ptzAttachedCamera1Address?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  ptzAttachedCamera1BaudRate?: Resolver<Maybe<ResolversTypes['PtzAttachedBaudRate']>, ParentType, ContextType>;
  ptzAttachedCamera1Model?: Resolver<Maybe<ResolversTypes['PtzAttachedCameraModel']>, ParentType, ContextType>;
  ptzAttachedCamera1SerialMode?: Resolver<Maybe<ResolversTypes['PtzAttachedSerialMode']>, ParentType, ContextType>;
  ptzAttachedCamera2Address?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  ptzAttachedCamera2BaudRate?: Resolver<Maybe<ResolversTypes['PtzAttachedBaudRate']>, ParentType, ContextType>;
  ptzAttachedCamera2Model?: Resolver<Maybe<ResolversTypes['PtzAttachedCameraModel']>, ParentType, ContextType>;
  ptzAttachedCamera2SerialMode?: Resolver<Maybe<ResolversTypes['PtzAttachedSerialMode']>, ParentType, ContextType>;
  ptzConfig?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ptzId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  ptzPanInverted?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  ptzTcpAddress?: Resolver<Maybe<ResolversTypes['PtzTcpAddress']>, ParentType, ContextType>;
  ptzTiltInverted?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  ptzType?: Resolver<ResolversTypes['PtzType'], ParentType, ContextType>;
  template?: Resolver<ResolversTypes['FunctionalAspectTemplate'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['DeviceFunctionalAspectType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type Dfa_SensorResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['DFA_Sensor'] = ResolversParentTypes['DFA_Sensor']> = ResolversObject<{
  associatedDevices?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  category?: Resolver<Maybe<ResolversTypes['AspectSensorCategory']>, ParentType, ContextType>;
  device?: Resolver<Maybe<ResolversTypes['Device']>, ParentType, ContextType>;
  eltaFrequencyControlCenter?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  eltaNorthOffset?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  enabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  health?: Resolver<ResolversTypes['AspectHealth'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  inputAspects?: Resolver<Array<ResolversTypes['DeviceFunctionalAspect']>, ParentType, ContextType>;
  model?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  qortexMappedZones?: Resolver<Maybe<Array<ResolversTypes['QortexMappedZone']>>, ParentType, ContextType>;
  qortexZones?: Resolver<Maybe<Array<ResolversTypes['QortexZone']>>, ParentType, ContextType>;
  sensorEvents?: Resolver<Maybe<Array<ResolversTypes['SensorEvent']>>, ParentType, ContextType>;
  serial?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  template?: Resolver<ResolversTypes['FunctionalAspectTemplate'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['DeviceFunctionalAspectType'], ParentType, ContextType>;
  userEvents?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type Dfa_VaeResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['DFA_VAE'] = ResolversParentTypes['DFA_VAE']> = ResolversObject<{
  device?: Resolver<Maybe<ResolversTypes['Device']>, ParentType, ContextType>;
  enabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  eventType?: Resolver<Maybe<ResolversTypes['DeviceEventType']>, ParentType, ContextType>;
  health?: Resolver<ResolversTypes['AspectHealth'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  inputAspects?: Resolver<Array<ResolversTypes['DeviceFunctionalAspect']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  streamSize?: Resolver<Maybe<ResolversTypes['MediaStreamSize']>, ParentType, ContextType>;
  template?: Resolver<ResolversTypes['FunctionalAspectTemplate'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['DeviceFunctionalAspectType'], ParentType, ContextType>;
  vaeConfig?: Resolver<Maybe<ResolversTypes['VaeConfigFull']>, ParentType, ContextType>;
  vaeFeatures?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  vaeFps?: Resolver<Maybe<ResolversTypes['VaeFps']>, ParentType, ContextType>;
  vaeStatistic?: Resolver<Maybe<ResolversTypes['VaeStatistic']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export interface DateTimeScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['DateTime'], any> {
  name: 'DateTime';
}

export type DefaultGeoPositionResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['DefaultGeoPosition'] = ResolversParentTypes['DefaultGeoPosition']> = ResolversObject<{
  lat?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  lng?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
}>;

export type DeviceResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['Device'] = ResolversParentTypes['Device']> = ResolversObject<{
  acknowledgeRequired?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  alarmPointPosition?: Resolver<Maybe<ResolversTypes['LatLng']>, ParentType, ContextType>;
  aspects?: Resolver<Array<ResolversTypes['DeviceFunctionalAspect']>, ParentType, ContextType>;
  cameraView?: Resolver<Maybe<ResolversTypes['CameraView']>, ParentType, ContextType>;
  cloudDirect?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  config?: Resolver<ResolversTypes['DeviceBaseConfig'], ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  delivery?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deliveryPriority?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  deviceType?: Resolver<Maybe<ResolversTypes['BaseDeviceType']>, ParentType, ContextType>;
  enabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  eventTimeFromRealm?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  eventType?: Resolver<Maybe<ResolversTypes['DeviceEventType']>, ParentType, ContextType>;
  geoZone?: Resolver<Maybe<ResolversTypes['JSONObject']>, ParentType, ContextType>;
  healthStatus?: Resolver<ResolversTypes['HealthStatus'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  location?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  modifiedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  platform?: Resolver<Maybe<ResolversTypes['Device']>, ParentType, ContextType>;
  position?: Resolver<Maybe<ResolversTypes['LatLng']>, ParentType, ContextType>;
  postEventTime?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  preEventTime?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rtpOverTcp?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  rtpTime?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  set?: Resolver<Maybe<Array<ResolversTypes['ObjectDescriptor']>>, ParentType, ContextType>;
  sharedStream?: Resolver<Maybe<Array<ResolversTypes['StreamShare']>>, ParentType, ContextType>;
  storageConfig?: Resolver<Maybe<ResolversTypes['DeviceStorageConfig']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['RealmObjectType'], ParentType, ContextType>;
  version?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  zone?: Resolver<Maybe<ResolversTypes['ObjectDescriptor']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DeviceBaseConfigResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['DeviceBaseConfig'] = ResolversParentTypes['DeviceBaseConfig']> = ResolversObject<{
  cameraType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  configType?: Resolver<ResolversTypes['DeviceBaseConfigType'], ParentType, ContextType>;
  connect?: Resolver<ResolversTypes['NetworkConnectDescriptor'], ParentType, ContextType>;
  firmware?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  make?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  model?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  onvifServices?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stratusObjId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
}>;

export type DeviceFunctionalAspectResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['DeviceFunctionalAspect'] = ResolversParentTypes['DeviceFunctionalAspect']> = ResolversObject<{
  __resolveType: TypeResolveFn<'DFA_Avatar' | 'DFA_Gateway' | 'DFA_Media' | 'DFA_PTZ' | 'DFA_Sensor' | 'DFA_VAE', ParentType, ContextType>;
}>;

export type DeviceProbeResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['DeviceProbe'] = ResolversParentTypes['DeviceProbe']> = ResolversObject<{
  aspects?: Resolver<Array<ResolversTypes['DeviceFunctionalAspect']>, ParentType, ContextType>;
  config?: Resolver<ResolversTypes['DeviceBaseConfig'], ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rtpTime?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  snapshots?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
}>;

export type DeviceStorageConfigResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['DeviceStorageConfig'] = ResolversParentTypes['DeviceStorageConfig']> = ResolversObject<{
  storagePool?: Resolver<ResolversTypes['StoragePool'], ParentType, ContextType>;
}>;

export type DeviceTemplateResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['DeviceTemplate'] = ResolversParentTypes['DeviceTemplate']> = ResolversObject<{
  make?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  models?: Resolver<Array<ResolversTypes['DeviceTemplateModel']>, ParentType, ContextType>;
}>;

export type DeviceTemplateModelResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['DeviceTemplateModel'] = ResolversParentTypes['DeviceTemplateModel']> = ResolversObject<{
  model?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
}>;

export type EncryptionKeyInfoResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['EncryptionKeyInfo'] = ResolversParentTypes['EncryptionKeyInfo']> = ResolversObject<{
  isValid?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  issuedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
}>;

export type ErrorInfoResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['ErrorInfo'] = ResolversParentTypes['ErrorInfo']> = ResolversObject<{
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  error?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type EventInfoResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['EventInfo'] = ResolversParentTypes['EventInfo']> = ResolversObject<{
  entry?: Resolver<ResolversTypes['AuditEntry'], ParentType, ContextType>;
  hasSnapshots?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
}>;

export type FeatureResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['Feature'] = ResolversParentTypes['Feature']> = ResolversObject<{
  desc?: Resolver<ResolversTypes['FeatureDesc'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  unitsSubscribed?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  unitsUsed?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
}>;

export type FeatureDescResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['FeatureDesc'] = ResolversParentTypes['FeatureDesc']> = ResolversObject<{
  displayName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['FeatureType'], ParentType, ContextType>;
  unitType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
}>;

export type FileInfoResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['FileInfo'] = ResolversParentTypes['FileInfo']> = ResolversObject<{
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  mime?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  path?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  uploadDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
}>;

export type FunctionalAspectTemplateResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['FunctionalAspectTemplate'] = ResolversParentTypes['FunctionalAspectTemplate']> = ResolversObject<{
  baseFeature?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  defaultFeature?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  engine?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  features?: Resolver<Maybe<Array<ResolversTypes['VaeFeature']>>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  order?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['DeviceFunctionalAspectType'], ParentType, ContextType>;
}>;

export type GeoLayerResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['GEOLayer'] = ResolversParentTypes['GEOLayer']> = ResolversObject<{
  data?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  enabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  mime?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  path?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  uploadDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
}>;

export type GeoLayersResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['GEOLayers'] = ResolversParentTypes['GEOLayers']> = ResolversObject<{
  geoLayers?: Resolver<Array<ResolversTypes['GEOLayer']>, ParentType, ContextType>;
}>;

export type GatewayDirectoriesProbeResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['GatewayDirectoriesProbe'] = ResolversParentTypes['GatewayDirectoriesProbe']> = ResolversObject<{
  deviceProbe?: Resolver<ResolversTypes['DeviceProbe'], ParentType, ContextType>;
  directories?: Resolver<Array<ResolversTypes['GatewayDirectory']>, ParentType, ContextType>;
}>;

export type GatewayDirectoryResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['GatewayDirectory'] = ResolversParentTypes['GatewayDirectory']> = ResolversObject<{
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
}>;

export type GatewayEventResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['GatewayEvent'] = ResolversParentTypes['GatewayEvent']> = ResolversObject<{
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
}>;

export type GatewayProbeResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['GatewayProbe'] = ResolversParentTypes['GatewayProbe']> = ResolversObject<{
  devices?: Resolver<Array<ResolversTypes['GatewayProbeDevice']>, ParentType, ContextType>;
  events?: Resolver<Array<ResolversTypes['GatewayProbeEvent']>, ParentType, ContextType>;
}>;

export type GatewayProbeDeviceResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['GatewayProbeDevice'] = ResolversParentTypes['GatewayProbeDevice']> = ResolversObject<{
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
}>;

export type GatewayProbeEventResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['GatewayProbeEvent'] = ResolversParentTypes['GatewayProbeEvent']> = ResolversObject<{
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
}>;

export type GenericObjectResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['GenericObject'] = ResolversParentTypes['GenericObject']> = ResolversObject<{
  createdAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  modifiedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['RealmObjectType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type GeoMarkerClusterConfigResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['GeoMarkerClusterConfig'] = ResolversParentTypes['GeoMarkerClusterConfig']> = ResolversObject<{
  disableClusteringAtZoom?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  enabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  mapType?: Resolver<ResolversTypes['MapType'], ParentType, ContextType>;
  maxClusterRadius?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
}>;

export type GeoTourResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['GeoTour'] = ResolversParentTypes['GeoTour']> = ResolversObject<{
  createdAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  devices?: Resolver<Maybe<Array<ResolversTypes['ID']>>, ParentType, ContextType>;
  enabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  modifiedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  points?: Resolver<Maybe<Array<ResolversTypes['GeoTourPoint']>>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['RealmObjectType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type GeoTourPointResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['GeoTourPoint'] = ResolversParentTypes['GeoTourPoint']> = ResolversObject<{
  duration?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  position?: Resolver<ResolversTypes['LatLng'], ParentType, ContextType>;
}>;

export type GrafanaDashboardResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['GrafanaDashboard'] = ResolversParentTypes['GrafanaDashboard']> = ResolversObject<{
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
}>;

export type GroupResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['Group'] = ResolversParentTypes['Group']> = ResolversObject<{
  createdAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isSystemManaged?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  modifiedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  policies?: Resolver<Array<ResolversTypes['Policy']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['RealmObjectType'], ParentType, ContextType>;
  users?: Resolver<Array<ResolversTypes['User']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type GuiResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['Gui'] = ResolversParentTypes['Gui']> = ResolversObject<{
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
}>;

export type HierarchyResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['Hierarchy'] = ResolversParentTypes['Hierarchy']> = ResolversObject<{
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  level?: Resolver<ResolversTypes['HierarchyLevel'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
}>;

export type HierarchyLevelResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['HierarchyLevel'] = ResolversParentTypes['HierarchyLevel']> = ResolversObject<{
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  labelIds?: Resolver<Array<ResolversTypes['ID']>, ParentType, ContextType>;
  levels?: Resolver<Maybe<Array<ResolversTypes['HierarchyLevel']>>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
}>;

export type IdentityAttributeResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['IdentityAttribute'] = ResolversParentTypes['IdentityAttribute']> = ResolversObject<{
  contactUs?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
}>;

export type ImageMapResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['ImageMap'] = ResolversParentTypes['ImageMap']> = ResolversObject<{
  base64?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  objects?: Resolver<Array<ResolversTypes['ImageMapObject']>, ParentType, ContextType>;
  order?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
}>;

export type ImageMapConfigResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['ImageMapConfig'] = ResolversParentTypes['ImageMapConfig']> = ResolversObject<{
  sets?: Resolver<Array<ResolversTypes['ImageMapSet']>, ParentType, ContextType>;
}>;

export type ImageMapLayerResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['ImageMapLayer'] = ResolversParentTypes['ImageMapLayer']> = ResolversObject<{
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  maps?: Resolver<Array<ResolversTypes['ImageMap']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
}>;

export type ImageMapObjectResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['ImageMapObject'] = ResolversParentTypes['ImageMapObject']> = ResolversObject<{
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  objectId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  position?: Resolver<ResolversTypes['Position'], ParentType, ContextType>;
}>;

export type ImageMapSetResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['ImageMapSet'] = ResolversParentTypes['ImageMapSet']> = ResolversObject<{
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  layers?: Resolver<Array<ResolversTypes['ImageMapLayer']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
}>;

export type ImageMapUpdateNotificationResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['ImageMapUpdateNotification'] = ResolversParentTypes['ImageMapUpdateNotification']> = ResolversObject<{
  action?: Resolver<ResolversTypes['ImageMapUpdateAction'], ParentType, ContextType>;
  layer?: Resolver<Maybe<ResolversTypes['ImageMapLayer']>, ParentType, ContextType>;
  layerId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  layerName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  map?: Resolver<Maybe<ResolversTypes['ImageMap']>, ParentType, ContextType>;
  mapId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  object?: Resolver<Maybe<ResolversTypes['ImageMapObject']>, ParentType, ContextType>;
  objectId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  realmId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  set?: Resolver<Maybe<ResolversTypes['ImageMapSet']>, ParentType, ContextType>;
  setId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  setName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updateId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  version?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
}>;

export interface JsonScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['JSON'], any> {
  name: 'JSON';
}

export interface JsonObjectScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['JSONObject'], any> {
  name: 'JSONObject';
}

export type KeyValueResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['KeyValue'] = ResolversParentTypes['KeyValue']> = ResolversObject<{
  key?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
}>;

export type LabelResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['Label'] = ResolversParentTypes['Label']> = ResolversObject<{
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  objects?: Resolver<Array<ResolversTypes['LabelObject']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['LabelType'], ParentType, ContextType>;
}>;

export type LabelObjectResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['LabelObject'] = ResolversParentTypes['LabelObject']> = ResolversObject<{
  objectId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['RealmObjectType'], ParentType, ContextType>;
}>;

export type LabelOrHierarchyUpdateResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['LabelOrHierarchyUpdate'] = ResolversParentTypes['LabelOrHierarchyUpdate']> = ResolversObject<{
  itemIds?: Resolver<Array<ResolversTypes['ID']>, ParentType, ContextType>;
  realmId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['LabelOrHierarchyUpdateType'], ParentType, ContextType>;
}>;

export type LanguageResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['Language'] = ResolversParentTypes['Language']> = ResolversObject<{
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  direction?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tag?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
}>;

export type LanguagesResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['Languages'] = ResolversParentTypes['Languages']> = ResolversObject<{
  languages?: Resolver<Maybe<Array<ResolversTypes['Language']>>, ParentType, ContextType>;
}>;

export type LatLngResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['LatLng'] = ResolversParentTypes['LatLng']> = ResolversObject<{
  alt?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  lat?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  lng?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
}>;

export type LicenseResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['License'] = ResolversParentTypes['License']> = ResolversObject<{
  isAccepted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  text?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
}>;

export type LocalStorageResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['LocalStorage'] = ResolversParentTypes['LocalStorage']> = ResolversObject<{
  enabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  pool?: Resolver<ResolversTypes['PoolLocalStorage'], ParentType, ContextType>;
  strategy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  ver?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
}>;

export type MetaClassifierResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['MetaClassifier'] = ResolversParentTypes['MetaClassifier']> = ResolversObject<{
  attributes?: Resolver<Array<ResolversTypes['KeyValue']>, ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
}>;

export type MetaEntryResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['MetaEntry'] = ResolversParentTypes['MetaEntry']> = ResolversObject<{
  key?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  metaClass?: Resolver<ResolversTypes['MetaClassifier'], ParentType, ContextType>;
}>;

export type MinMaxResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['MinMax'] = ResolversParentTypes['MinMax']> = ResolversObject<{
  maxFps?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  minFps?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
}>;

export type ModifiedByInfoResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['ModifiedByInfo'] = ResolversParentTypes['ModifiedByInfo']> = ResolversObject<{
  realmId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
}>;

export type MutationResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['Mutation'] = ResolversParentTypes['Mutation']> = ResolversObject<{
  acceptLicense?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  acknowledgeAuditEntry?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationAcknowledgeAuditEntryArgs, 'entry'>>;
  acknowledgeEvent?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationAcknowledgeEventArgs, 'context' | 'triggeredAt'>>;
  activateAvatar?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationActivateAvatarArgs, 'avatarId'>>;
  activateEmail?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationActivateEmailArgs, 'input'>>;
  addSharedView?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationAddSharedViewArgs, 'input'>>;
  addSubscription?: Resolver<Maybe<ResolversTypes['RealmSubscription']>, ParentType, ContextType, RequireFields<MutationAddSubscriptionArgs, 'realmSubscription'>>;
  aodCancel?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationAodCancelArgs, 'requestIds'>>;
  aodPause?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationAodPauseArgs, 'requestId'>>;
  aodResume?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationAodResumeArgs, 'requestId'>>;
  aodSubmit?: Resolver<Array<ResolversTypes['AodRequest']>, ParentType, ContextType, RequireFields<MutationAodSubmitArgs, 'input'>>;
  assignLabels?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationAssignLabelsArgs, 'ids' | 'objectId'>>;
  auditEntriesAcknowledgment?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationAuditEntriesAcknowledgmentArgs, 'entries'>>;
  blockUser?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationBlockUserArgs, 'id'>>;
  changeCurrentPassword?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationChangeCurrentPasswordArgs, 'input'>>;
  changeDeliveryPriority?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationChangeDeliveryPriorityArgs, 'devices'>>;
  changeLocalStorage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationChangeLocalStorageArgs, 'id' | 'input'>>;
  changePassword?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationChangePasswordArgs, 'input'>>;
  clearRecentViews?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  createAuditEntryEvent?: Resolver<ResolversTypes['AuditEntryEvent'], ParentType, ContextType, RequireFields<MutationCreateAuditEntryEventArgs, 'entry'>>;
  createAvatarApiKey?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationCreateAvatarApiKeyArgs, 'id'>>;
  createCameraTour?: Resolver<ResolversTypes['CreateResult'], ParentType, ContextType, RequireFields<MutationCreateCameraTourArgs, 'input'>>;
  createDevice?: Resolver<ResolversTypes['CreateResult'], ParentType, ContextType, RequireFields<MutationCreateDeviceArgs, 'device'>>;
  createEvent?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationCreateEventArgs, 'entry'>>;
  createGatewayDevice?: Resolver<ResolversTypes['CreateResult'], ParentType, ContextType, RequireFields<MutationCreateGatewayDeviceArgs, 'device'>>;
  createGeoTour?: Resolver<ResolversTypes['CreateResult'], ParentType, ContextType, RequireFields<MutationCreateGeoTourArgs, 'input'>>;
  createGroup?: Resolver<ResolversTypes['CreateResult'], ParentType, ContextType, RequireFields<MutationCreateGroupArgs, 'group'>>;
  createPolicy?: Resolver<ResolversTypes['CreateResult'], ParentType, ContextType, RequireFields<MutationCreatePolicyArgs, 'policy'>>;
  createPolicyStatement?: Resolver<ResolversTypes['CreateResult'], ParentType, ContextType, RequireFields<MutationCreatePolicyStatementArgs, 'policyId' | 'statement'>>;
  createSchedule?: Resolver<ResolversTypes['CreateResult'], ParentType, ContextType, RequireFields<MutationCreateScheduleArgs, 'schedule'>>;
  createSensorDevice?: Resolver<ResolversTypes['CreateResult'], ParentType, ContextType, RequireFields<MutationCreateSensorDeviceArgs, 'device'>>;
  createSet?: Resolver<ResolversTypes['CreateResult'], ParentType, ContextType, RequireFields<MutationCreateSetArgs, 'set'>>;
  createTarget?: Resolver<ResolversTypes['Target'], ParentType, ContextType, RequireFields<MutationCreateTargetArgs, 'input'>>;
  createUser?: Resolver<ResolversTypes['CreateResult'], ParentType, ContextType, RequireFields<MutationCreateUserArgs, 'user'>>;
  createVaeConfig?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationCreateVaeConfigArgs, 'deviceId' | 'engine' | 'name'>>;
  createZone?: Resolver<ResolversTypes['CreateResult'], ParentType, ContextType, RequireFields<MutationCreateZoneArgs, 'zone'>>;
  deleteCameraTour?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationDeleteCameraTourArgs, 'id'>>;
  deleteDevice?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationDeleteDeviceArgs, 'id'>>;
  deleteDevices?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationDeleteDevicesArgs, 'ids'>>;
  deleteGeoLayer?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationDeleteGeoLayerArgs, 'id'>>;
  deleteGeoTour?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationDeleteGeoTourArgs, 'id'>>;
  deleteGroup?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationDeleteGroupArgs, 'id'>>;
  deleteHierarchy?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationDeleteHierarchyArgs, 'id'>>;
  deleteImageMapLayer?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationDeleteImageMapLayerArgs, 'layerId' | 'updateId' | 'version'>>;
  deleteImageMapObject?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationDeleteImageMapObjectArgs, 'objectId' | 'updateId' | 'version'>>;
  deleteImageMapSet?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationDeleteImageMapSetArgs, 'setId' | 'updateId' | 'version'>>;
  deleteLabel?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationDeleteLabelArgs, 'id'>>;
  deletePolicy?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationDeletePolicyArgs, 'id'>>;
  deletePolicyStatement?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationDeletePolicyStatementArgs, 'statementId'>>;
  deleteSchedule?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationDeleteScheduleArgs, 'id'>>;
  deleteSet?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationDeleteSetArgs, 'id'>>;
  deleteSharedView?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationDeleteSharedViewArgs, 'input'>>;
  deleteSubscription?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, RequireFields<MutationDeleteSubscriptionArgs, 'id'>>;
  deleteUser?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationDeleteUserArgs, 'id'>>;
  deleteVaeConfig?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationDeleteVaeConfigArgs, 'deviceId' | 'engine' | 'name'>>;
  deleteZone?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationDeleteZoneArgs, 'id'>>;
  deviceCommand?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationDeviceCommandArgs, 'command' | 'id'>>;
  eventsAcknowledgement?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationEventsAcknowledgementArgs, 'entries'>>;
  followTarget?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationFollowTargetArgs, 'targetId'>>;
  insertHierarchy?: Resolver<ResolversTypes['Hierarchy'], ParentType, ContextType, RequireFields<MutationInsertHierarchyArgs, 'hierarchy'>>;
  insertImageMapLayer?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationInsertImageMapLayerArgs, 'layer' | 'setId' | 'updateId' | 'version'>>;
  insertImageMapObject?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationInsertImageMapObjectArgs, 'mapId' | 'object' | 'updateId' | 'version'>>;
  insertImageMapSet?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationInsertImageMapSetArgs, 'set' | 'updateId' | 'version'>>;
  insertLabels?: Resolver<Array<ResolversTypes['Label']>, ParentType, ContextType, RequireFields<MutationInsertLabelsArgs, 'labels'>>;
  modifySubscription?: Resolver<Maybe<ResolversTypes['RealmSubscription']>, ParentType, ContextType, RequireFields<MutationModifySubscriptionArgs, 'realmSubscription'>>;
  ptzAbs?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationPtzAbsArgs, 'id' | 'input'>>;
  ptzHardware?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationPtzHardwareArgs, 'id' | 'input'>>;
  ptzLock?: Resolver<ResolversTypes['PtzLockResult'], ParentType, ContextType, RequireFields<MutationPtzLockArgs, 'id'>>;
  ptzPreset?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationPtzPresetArgs, 'id' | 'input'>>;
  ptzRel?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationPtzRelArgs, 'id' | 'input'>>;
  ptzSettings?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationPtzSettingsArgs, 'id' | 'input'>>;
  ptzSpeed?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationPtzSpeedArgs, 'id' | 'input'>>;
  ptzStep?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationPtzStepArgs, 'id' | 'input'>>;
  ptzUnlock?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationPtzUnlockArgs, 'id'>>;
  purgeAvatarQueue?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationPurgeAvatarQueueArgs, 'id'>>;
  regenerateAvatarApiKey?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationRegenerateAvatarApiKeyArgs, 'id'>>;
  removeAvatarApiKey?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationRemoveAvatarApiKeyArgs, 'id'>>;
  removeLabels?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationRemoveLabelsArgs, 'ids' | 'objectId'>>;
  renameImageMapLayer?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationRenameImageMapLayerArgs, 'layerId' | 'name' | 'updateId' | 'version'>>;
  renameImageMapSet?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationRenameImageMapSetArgs, 'name' | 'setId' | 'updateId' | 'version'>>;
  renameVaeConfig?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationRenameVaeConfigArgs, 'deviceId' | 'engine' | 'name' | 'newName'>>;
  restorePassword?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationRestorePasswordArgs, 'input'>>;
  setCurrentView?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationSetCurrentViewArgs, 'viewId'>>;
  setPassword?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationSetPasswordArgs, 'input'>>;
  setStore?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationSetStoreArgs, 'store'>>;
  setUserRealm?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationSetUserRealmArgs, 'realmId' | 'userName'>>;
  slewToPoint?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationSlewToPointArgs, 'latLng'>>;
  unblockUser?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationUnblockUserArgs, 'id'>>;
  unfollowTarget?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationUnfollowTargetArgs, 'targetId'>>;
  updateCameraTour?: Resolver<ResolversTypes['UpdateResult'], ParentType, ContextType, RequireFields<MutationUpdateCameraTourArgs, 'id' | 'input'>>;
  updateCurrentRealm?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationUpdateCurrentRealmArgs, 'realm'>>;
  updateDevice?: Resolver<ResolversTypes['UpdateResult'], ParentType, ContextType, RequireFields<MutationUpdateDeviceArgs, 'device' | 'id'>>;
  updateDevices?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationUpdateDevicesArgs, 'list'>>;
  updateGeoLayers?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationUpdateGeoLayersArgs, 'input'>>;
  updateGeoTour?: Resolver<ResolversTypes['UpdateResult'], ParentType, ContextType, RequireFields<MutationUpdateGeoTourArgs, 'id' | 'input'>>;
  updateGroup?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationUpdateGroupArgs, 'group' | 'id'>>;
  updateHierarchy?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationUpdateHierarchyArgs, 'hierarchy'>>;
  updateImageMap?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationUpdateImageMapArgs, 'map' | 'updateId' | 'version'>>;
  updateImageMapLayer?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationUpdateImageMapLayerArgs, 'layer' | 'updateId' | 'version'>>;
  updateImageMapObject?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationUpdateImageMapObjectArgs, 'object' | 'updateId' | 'version'>>;
  updateImageMapSet?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationUpdateImageMapSetArgs, 'set' | 'updateId' | 'version'>>;
  updateLabel?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationUpdateLabelArgs, 'label'>>;
  updatePolicy?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationUpdatePolicyArgs, 'id' | 'policy'>>;
  updatePolicyStatement?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationUpdatePolicyStatementArgs, 'statement' | 'statementId'>>;
  updateRealm?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationUpdateRealmArgs, 'realmInput'>>;
  updateSchedule?: Resolver<ResolversTypes['UpdateResult'], ParentType, ContextType, RequireFields<MutationUpdateScheduleArgs, 'id' | 'schedule'>>;
  updateSet?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationUpdateSetArgs, 'id' | 'set'>>;
  updateSolidConfig?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, Partial<MutationUpdateSolidConfigArgs>>;
  updateSolidConfigCurrentView?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationUpdateSolidConfigCurrentViewArgs, 'input'>>;
  updateStats?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationUpdateStatsArgs, 'id' | 'stats'>>;
  updateUser?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationUpdateUserArgs, 'id' | 'user'>>;
  updateZone?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationUpdateZoneArgs, 'id' | 'zone'>>;
  validateAddSubscription?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, RequireFields<MutationValidateAddSubscriptionArgs, 'realmSubscription'>>;
  validateEmail?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationValidateEmailArgs, 'addresses'>>;
  validateModifySubscription?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, RequireFields<MutationValidateModifySubscriptionArgs, 'realmSubscription'>>;
  verifyCode?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationVerifyCodeArgs, 'code'>>;
}>;

export type NetworkConnectDescriptorResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['NetworkConnectDescriptor'] = ResolversParentTypes['NetworkConnectDescriptor']> = ResolversObject<{
  URL?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  authType?: Resolver<ResolversTypes['AuthType'], ParentType, ContextType>;
  credentials?: Resolver<Maybe<ResolversTypes['Credentials']>, ParentType, ContextType>;
  host?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hosts?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  pass?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  port?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  protocol?: Resolver<Maybe<ResolversTypes['ProtocolType']>, ParentType, ContextType>;
  rtspPort?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  udpPort?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
}>;

export type NumericReportResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['NumericReport'] = ResolversParentTypes['NumericReport']> = ResolversObject<{
  time?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ObjUuidResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['ObjUUID'] = ResolversParentTypes['ObjUUID']> = ResolversObject<{
  obj?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type ObjUuidAndNameResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['ObjUUIDAndName'] = ResolversParentTypes['ObjUUIDAndName']> = ResolversObject<{
  isAdmin?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  obj?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type ObjectDescriptorResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['ObjectDescriptor'] = ResolversParentTypes['ObjectDescriptor']> = ResolversObject<{
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isSystemManaged?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['RealmObjectType'], ParentType, ContextType>;
}>;

export type ObjectUpdateEventResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['ObjectUpdateEvent'] = ResolversParentTypes['ObjectUpdateEvent']> = ResolversObject<{
  action?: Resolver<ResolversTypes['ObjectAction'], ParentType, ContextType>;
  childObjects?: Resolver<Maybe<Array<ResolversTypes['ID']>>, ParentType, ContextType>;
  healthStatus?: Resolver<Maybe<ResolversTypes['HealthStatus']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  ptzLockProlongation?: Resolver<Maybe<ResolversTypes['PtzLockProlongation']>, ParentType, ContextType>;
  ptzStatus?: Resolver<Maybe<ResolversTypes['PtzStatus']>, ParentType, ContextType>;
  realmId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  systemStatus?: Resolver<Maybe<ResolversTypes['SystemStatus']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  vaeStatus?: Resolver<Maybe<Array<ResolversTypes['VaeReasonStatus']>>, ParentType, ContextType>;
}>;

export type OnvifServiceConfigResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['OnvifServiceConfig'] = ResolversParentTypes['OnvifServiceConfig']> = ResolversObject<{
  bindIp?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  enableDiscovery?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  enabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  httpPort?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  pass?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['OnvifServiceStatus']>, ParentType, ContextType>;
  user?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
}>;

export type OnvifServiceStatusResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['OnvifServiceStatus'] = ResolversParentTypes['OnvifServiceStatus']> = ResolversObject<{
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  running?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
}>;

export type OwnerResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['Owner'] = ResolversParentTypes['Owner']> = ResolversObject<{
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  displayName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
}>;

export type PolicyResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['Policy'] = ResolversParentTypes['Policy']> = ResolversObject<{
  createdAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  groups?: Resolver<Array<ResolversTypes['Group']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isSystemManaged?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  modifiedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  statements?: Resolver<Array<ResolversTypes['PolicyStatement']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['RealmObjectType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PolicyStatementResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['PolicyStatement'] = ResolversParentTypes['PolicyStatement']> = ResolversObject<{
  actions?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  allResources?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  effect?: Resolver<ResolversTypes['StatementEffect'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  resources?: Resolver<Array<ResolversTypes['ObjectDescriptor']>, ParentType, ContextType>;
}>;

export type PoolLocalStorageResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['PoolLocalStorage'] = ResolversParentTypes['PoolLocalStorage']> = ResolversObject<{
  enforce?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  path?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  size?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
}>;

export type PositionResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['Position'] = ResolversParentTypes['Position']> = ResolversObject<{
  x?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  y?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
}>;

export type PtzAbsArgsResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['PtzAbsArgs'] = ResolversParentTypes['PtzAbsArgs']> = ResolversObject<{
  pan?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  tilt?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  zoom?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
}>;

export type PtzLockResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['PtzLock'] = ResolversParentTypes['PtzLock']> = ResolversObject<{
  category?: Resolver<ResolversTypes['PtzLockCategory'], ParentType, ContextType>;
  expire?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  explicit?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
}>;

export type PtzLockProlongationResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['PtzLockProlongation'] = ResolversParentTypes['PtzLockProlongation']> = ResolversObject<{
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  token?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
}>;

export type PtzLockResultResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['PtzLockResult'] = ResolversParentTypes['PtzLockResult']> = ResolversObject<{
  token?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
}>;

export type PtzPositionResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['PtzPosition'] = ResolversParentTypes['PtzPosition']> = ResolversObject<{
  hfov?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  pan?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  tilt?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
}>;

export type PtzStatusResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['PtzStatus'] = ResolversParentTypes['PtzStatus']> = ResolversObject<{
  lock?: Resolver<Maybe<ResolversTypes['PtzLock']>, ParentType, ContextType>;
  lockProlongation?: Resolver<Maybe<ResolversTypes['PtzLockProlongation']>, ParentType, ContextType>;
  position?: Resolver<Maybe<ResolversTypes['PtzPosition']>, ParentType, ContextType>;
}>;

export type PtzTcpAddressResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['PtzTcpAddress'] = ResolversParentTypes['PtzTcpAddress']> = ResolversObject<{
  ip?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  port?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
}>;

export type QortexMappedZoneResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['QortexMappedZone'] = ResolversParentTypes['QortexMappedZone']> = ResolversObject<{
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  witness?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
}>;

export type QortexZoneResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['QortexZone'] = ResolversParentTypes['QortexZone']> = ResolversObject<{
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  points?: Resolver<Array<ResolversTypes['QortexZonePoint']>, ParentType, ContextType>;
  witness?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  zMax?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  zMin?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
}>;

export type QortexZonePointResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['QortexZonePoint'] = ResolversParentTypes['QortexZonePoint']> = ResolversObject<{
  x?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  y?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
}>;

export type QueryResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['Query'] = ResolversParentTypes['Query']> = ResolversObject<{
  accessLevels?: Resolver<Array<ResolversTypes['AccessLevel']>, ParentType, ContextType>;
  actions?: Resolver<Array<ResolversTypes['Action']>, ParentType, ContextType>;
  aodGet?: Resolver<Array<ResolversTypes['AodRequest']>, ParentType, ContextType, RequireFields<QueryAodGetArgs, 'endTime' | 'ids' | 'startTime'>>;
  aodGetList?: Resolver<Array<ResolversTypes['AodRequest']>, ParentType, ContextType, RequireFields<QueryAodGetListArgs, 'endTime' | 'startTime'>>;
  aodGetUpdatedList?: Resolver<Array<ResolversTypes['AodRequest']>, ParentType, ContextType, RequireFields<QueryAodGetUpdatedListArgs, 'updatedFrom'>>;
  archiveBoundary?: Resolver<ResolversTypes['ArchiveBoundary'], ParentType, ContextType, RequireFields<QueryArchiveBoundaryArgs, 'find' | 'ids' | 'startTime' | 'streamNumbers'>>;
  archiveCoverage?: Resolver<ResolversTypes['ArchiveCoverage'], ParentType, ContextType, RequireFields<QueryArchiveCoverageArgs, 'endTime' | 'ids' | 'startTime'>>;
  archiveTargets?: Resolver<Array<ResolversTypes['Target']>, ParentType, ContextType, RequireFields<QueryArchiveTargetsArgs, 'filter'>>;
  aspectTemplates?: Resolver<Array<ResolversTypes['FunctionalAspectTemplate']>, ParentType, ContextType>;
  auditCategories?: Resolver<Array<ResolversTypes['AuditCategory']>, ParentType, ContextType>;
  auditEntries?: Resolver<Array<ResolversTypes['AuditEntry']>, ParentType, ContextType, RequireFields<QueryAuditEntriesArgs, 'filter'>>;
  auditEntry?: Resolver<Maybe<ResolversTypes['AuditEntry']>, ParentType, ContextType, RequireFields<QueryAuditEntryArgs, 'id'>>;
  availableFeatures?: Resolver<Maybe<Array<ResolversTypes['FeatureDesc']>>, ParentType, ContextType>;
  avatarMetrics?: Resolver<Array<ResolversTypes['AvatarMetric']>, ParentType, ContextType>;
  avatarReport?: Resolver<Array<ResolversTypes['NumericReport']>, ParentType, ContextType, RequireFields<QueryAvatarReportArgs, 'from' | 'id' | 'metricName' | 'to'>>;
  branding?: Resolver<Maybe<ResolversTypes['Branding']>, ParentType, ContextType>;
  cameraLog?: Resolver<Array<ResolversTypes['CameraLog']>, ParentType, ContextType, RequireFields<QueryCameraLogArgs, 'deviceId'>>;
  cameraMetrics?: Resolver<Array<ResolversTypes['CameraMetric']>, ParentType, ContextType, RequireFields<QueryCameraMetricsArgs, 'id'>>;
  cameraReport?: Resolver<Array<ResolversTypes['Report']>, ParentType, ContextType, RequireFields<QueryCameraReportArgs, 'dfaId' | 'from' | 'id' | 'metricName' | 'to'>>;
  cameraTour?: Resolver<Maybe<ResolversTypes['CameraTour']>, ParentType, ContextType, RequireFields<QueryCameraTourArgs, 'id'>>;
  cameraTours?: Resolver<Array<ResolversTypes['CameraTour']>, ParentType, ContextType>;
  currentRealm?: Resolver<ResolversTypes['CurrentRealm'], ParentType, ContextType>;
  device?: Resolver<Maybe<ResolversTypes['Device']>, ParentType, ContextType, RequireFields<QueryDeviceArgs, 'id'>>;
  deviceFunctionalAspectsByAspectTypes?: Resolver<Array<ResolversTypes['DeviceFunctionalAspect']>, ParentType, ContextType, RequireFields<QueryDeviceFunctionalAspectsByAspectTypesArgs, 'types'>>;
  deviceTemplates?: Resolver<Array<ResolversTypes['DeviceTemplate']>, ParentType, ContextType>;
  devices?: Resolver<Array<ResolversTypes['Device']>, ParentType, ContextType>;
  devicesByAspectTypes?: Resolver<Array<ResolversTypes['Device']>, ParentType, ContextType, RequireFields<QueryDevicesByAspectTypesArgs, 'types'>>;
  devicesByIds?: Resolver<Array<ResolversTypes['Device']>, ParentType, ContextType, RequireFields<QueryDevicesByIdsArgs, 'ids'>>;
  discoverDevices?: Resolver<Array<ResolversTypes['DeviceProbe']>, ParentType, ContextType, RequireFields<QueryDiscoverDevicesArgs, 'platformId'>>;
  emailCanBeSend?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  followTarget?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<QueryFollowTargetArgs, 'targetId'>>;
  geoLayers?: Resolver<Maybe<ResolversTypes['GEOLayers']>, ParentType, ContextType>;
  geoTour?: Resolver<Maybe<ResolversTypes['GeoTour']>, ParentType, ContextType, RequireFields<QueryGeoTourArgs, 'id'>>;
  geoTours?: Resolver<Array<ResolversTypes['GeoTour']>, ParentType, ContextType>;
  grafanaDashboards?: Resolver<Array<ResolversTypes['GrafanaDashboard']>, ParentType, ContextType, RequireFields<QueryGrafanaDashboardsArgs, 'folderId'>>;
  group?: Resolver<Maybe<ResolversTypes['Group']>, ParentType, ContextType, RequireFields<QueryGroupArgs, 'id'>>;
  groups?: Resolver<Array<ResolversTypes['Group']>, ParentType, ContextType>;
  guis?: Resolver<Array<ResolversTypes['Gui']>, ParentType, ContextType>;
  hierarchies?: Resolver<Array<ResolversTypes['Hierarchy']>, ParentType, ContextType>;
  hierarchy?: Resolver<Maybe<ResolversTypes['Hierarchy']>, ParentType, ContextType, RequireFields<QueryHierarchyArgs, 'id'>>;
  identityAttribute?: Resolver<Maybe<ResolversTypes['IdentityAttribute']>, ParentType, ContextType>;
  imageMapConfig?: Resolver<ResolversTypes['ImageMapConfig'], ParentType, ContextType, RequireFields<QueryImageMapConfigArgs, 'version'>>;
  imageMapImage?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<QueryImageMapImageArgs, 'mapId' | 'version'>>;
  label?: Resolver<Maybe<ResolversTypes['Label']>, ParentType, ContextType, RequireFields<QueryLabelArgs, 'id'>>;
  labels?: Resolver<Array<ResolversTypes['Label']>, ParentType, ContextType>;
  labelsForObject?: Resolver<Array<ResolversTypes['Label']>, ParentType, ContextType, RequireFields<QueryLabelsForObjectArgs, 'objectId'>>;
  languages?: Resolver<Maybe<ResolversTypes['Languages']>, ParentType, ContextType>;
  license?: Resolver<ResolversTypes['License'], ParentType, ContextType>;
  localStorage?: Resolver<Maybe<ResolversTypes['LocalStorage']>, ParentType, ContextType, RequireFields<QueryLocalStorageArgs, 'deviceId'>>;
  policies?: Resolver<Array<ResolversTypes['Policy']>, ParentType, ContextType>;
  policy?: Resolver<Maybe<ResolversTypes['Policy']>, ParentType, ContextType, RequireFields<QueryPolicyArgs, 'id'>>;
  probeDevice?: Resolver<ResolversTypes['DeviceProbe'], ParentType, ContextType, RequireFields<QueryProbeDeviceArgs, 'input'>>;
  probeGateway?: Resolver<ResolversTypes['GatewayProbe'], ParentType, ContextType, RequireFields<QueryProbeGatewayArgs, 'input'>>;
  probeGatewayDirectories?: Resolver<ResolversTypes['GatewayDirectoriesProbe'], ParentType, ContextType, RequireFields<QueryProbeGatewayDirectoriesArgs, 'input'>>;
  probeSensorDevice?: Resolver<ResolversTypes['DeviceProbe'], ParentType, ContextType, RequireFields<QueryProbeSensorDeviceArgs, 'input'>>;
  realm?: Resolver<Maybe<ResolversTypes['Realm']>, ParentType, ContextType>;
  realmObject?: Resolver<Maybe<ResolversTypes['RealmObject']>, ParentType, ContextType, RequireFields<QueryRealmObjectArgs, 'id'>>;
  realmObjects?: Resolver<Array<ResolversTypes['RealmObject']>, ParentType, ContextType>;
  realmSubscription?: Resolver<ResolversTypes['RealmSubscription'], ParentType, ContextType, Partial<QueryRealmSubscriptionArgs>>;
  realmSubscriptions?: Resolver<Maybe<Array<ResolversTypes['RealmSubscription']>>, ParentType, ContextType, Partial<QueryRealmSubscriptionsArgs>>;
  requireAcknowledgeEntries?: Resolver<Array<ResolversTypes['AuditEntry']>, ParentType, ContextType, RequireFields<QueryRequireAcknowledgeEntriesArgs, 'filter'>>;
  schedule?: Resolver<Maybe<ResolversTypes['Schedule']>, ParentType, ContextType, RequireFields<QueryScheduleArgs, 'id'>>;
  scheduleActionTemplates?: Resolver<Array<ResolversTypes['ScheduleActionTemplate']>, ParentType, ContextType>;
  schedules?: Resolver<Array<ResolversTypes['Schedule']>, ParentType, ContextType>;
  serverTime?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  sessionInfo?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  set?: Resolver<Maybe<ResolversTypes['Set']>, ParentType, ContextType, RequireFields<QuerySetArgs, 'id'>>;
  sets?: Resolver<Array<ResolversTypes['Set']>, ParentType, ContextType>;
  slewToPoint?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<QuerySlewToPointArgs, 'latLng'>>;
  solidConfig?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, RequireFields<QuerySolidConfigArgs, 'userId'>>;
  storagePools?: Resolver<Array<ResolversTypes['StoragePool']>, ParentType, ContextType>;
  storageUsage?: Resolver<Maybe<ResolversTypes['StorageUsage']>, ParentType, ContextType, RequireFields<QueryStorageUsageArgs, 'deviceId'>>;
  store?: Resolver<ResolversTypes['AppStore'], ParentType, ContextType>;
  systemParameters?: Resolver<Maybe<ResolversTypes['SystemParameters']>, ParentType, ContextType>;
  systemStatus?: Resolver<ResolversTypes['SystemStatusInfo'], ParentType, ContextType>;
  target?: Resolver<Maybe<ResolversTypes['Target']>, ParentType, ContextType, RequireFields<QueryTargetArgs, 'id'>>;
  targets?: Resolver<Array<ResolversTypes['Target']>, ParentType, ContextType, RequireFields<QueryTargetsArgs, 'filter'>>;
  unfollowTarget?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<QueryUnfollowTargetArgs, 'targetId'>>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType, RequireFields<QueryUserArgs, 'id'>>;
  userInfo?: Resolver<ResolversTypes['UserInfo'], ParentType, ContextType>;
  userRealms?: Resolver<Array<ResolversTypes['Realm']>, ParentType, ContextType>;
  users?: Resolver<Array<ResolversTypes['User']>, ParentType, ContextType>;
  vaeConfigs?: Resolver<Array<ResolversTypes['VaeConfigBrief']>, ParentType, ContextType, RequireFields<QueryVaeConfigsArgs, 'deviceId' | 'engine'>>;
  vaeTemplates?: Resolver<Array<ResolversTypes['FunctionalAspectTemplate']>, ParentType, ContextType, RequireFields<QueryVaeTemplatesArgs, 'deviceId'>>;
  zone?: Resolver<Maybe<ResolversTypes['Zone']>, ParentType, ContextType, RequireFields<QueryZoneArgs, 'id'>>;
  zones?: Resolver<Array<ResolversTypes['Zone']>, ParentType, ContextType>;
}>;

export type RealmResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['Realm'] = ResolversParentTypes['Realm']> = ResolversObject<{
  adminEmail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  alarmTargetsClear?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  alarmTargetsClearTime?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  auditTtl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  avatarLocalStreaming?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  defaultMapLayer?: Resolver<Maybe<ResolversTypes['MapType']>, ParentType, ContextType>;
  emailAuth?: Resolver<Maybe<ResolversTypes['EmailAuth']>, ParentType, ContextType>;
  emailEnabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  emailFrom?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  emailHost?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  emailPass?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  emailPort?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  emailTls?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  emailUser?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  emailValidated?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  esriAccessToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  esriMapTileUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  geoIconSet?: Resolver<Maybe<ResolversTypes['GeoIconSet']>, ParentType, ContextType>;
  geoMarkerClusterConfig?: Resolver<Maybe<Array<ResolversTypes['GeoMarkerClusterConfig']>>, ParentType, ContextType>;
  geoZone?: Resolver<ResolversTypes['JSONObject'], ParentType, ContextType>;
  googleMapsApiKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  jitterBufferLength?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  maxDownloadTime?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  maxScheduledDeliveryDelay?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  maxVideoPlayers?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  mfAuth?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  modifiedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  normalTargetsClearTime?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  playerIdleTimeout?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  postEventTime?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  preEventTime?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  realmObjects?: Resolver<Maybe<Array<ResolversTypes['RealmObject']>>, ParentType, ContextType>;
  resellerParent?: Resolver<Maybe<ResolversTypes['Reseller']>, ParentType, ContextType>;
  trackerMinTrackingTime?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  trackerStaleTimeout?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['RealmObjectType'], ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  warnVideoPlayers?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type RealmObjectResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['RealmObject'] = ResolversParentTypes['RealmObject']> = ResolversObject<{
  __resolveType: TypeResolveFn<'CameraTour' | 'CurrentRealm' | 'Device' | 'GenericObject' | 'GeoTour' | 'Group' | 'Policy' | 'Realm' | 'Schedule' | 'Set' | 'User' | 'Zone', ParentType, ContextType>;
}>;

export type RealmSubscriptionResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['RealmSubscription'] = ResolversParentTypes['RealmSubscription']> = ResolversObject<{
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  features?: Resolver<Array<ResolversTypes['Feature']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  owner?: Resolver<ResolversTypes['Owner'], ParentType, ContextType>;
  periodExpiresAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  periodStartedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  simpleui?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['SubscriptionStatus'], ParentType, ContextType>;
  storagePools?: Resolver<Array<ResolversTypes['SubStoragePool']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['RealmSubscriptionType']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
}>;

export type ReportResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['Report'] = ResolversParentTypes['Report']> = ResolversObject<{
  __resolveType: TypeResolveFn<'NumericReport' | 'StatusReport', ParentType, ContextType>;
}>;

export type ResellerResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['Reseller'] = ResolversParentTypes['Reseller']> = ResolversObject<{
  brandInfo?: Resolver<Maybe<ResolversTypes['BrandInfo']>, ParentType, ContextType>;
  children?: Resolver<Array<ResolversTypes['Reseller']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  displayName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  owner?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  parent?: Resolver<Maybe<ResolversTypes['Reseller']>, ParentType, ContextType>;
  realms?: Resolver<Array<ResolversTypes['Realm']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
}>;

export type ScheduleResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['Schedule'] = ResolversParentTypes['Schedule']> = ResolversObject<{
  createdAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  devices?: Resolver<Maybe<Array<ResolversTypes['ObjectDescriptor']>>, ParentType, ContextType>;
  enabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  modifiedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  sets?: Resolver<Maybe<Array<ResolversTypes['ObjectDescriptor']>>, ParentType, ContextType>;
  tasks?: Resolver<Maybe<Array<ResolversTypes['ScheduleTask']>>, ParentType, ContextType>;
  timezone?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['RealmObjectType'], ParentType, ContextType>;
  zones?: Resolver<Maybe<Array<ResolversTypes['ObjectDescriptor']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ScheduleActionResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['ScheduleAction'] = ResolversParentTypes['ScheduleAction']> = ResolversObject<{
  action?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  deviceTypes?: Resolver<Array<ResolversTypes['ScheduleDeviceType']>, ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
}>;

export type ScheduleActionTemplateResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['ScheduleActionTemplate'] = ResolversParentTypes['ScheduleActionTemplate']> = ResolversObject<{
  action?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  deviceTypes?: Resolver<Array<ResolversTypes['ScheduleDeviceType']>, ParentType, ContextType>;
  labels?: Resolver<ResolversTypes['JSON'], ParentType, ContextType>;
  values?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
}>;

export type ScheduleTaskResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['ScheduleTask'] = ResolversParentTypes['ScheduleTask']> = ResolversObject<{
  actions?: Resolver<Maybe<Array<ResolversTypes['ScheduleAction']>>, ParentType, ContextType>;
  byDay?: Resolver<Maybe<Array<ResolversTypes['WeekDay']>>, ParentType, ContextType>;
  endTime?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  startTime?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
}>;

export type SensorEventResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['SensorEvent'] = ResolversParentTypes['SensorEvent']> = ResolversObject<{
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  enabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  innerProps?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  source?: Resolver<Maybe<ResolversTypes['EventSource']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
}>;

export type SessionResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['Session'] = ResolversParentTypes['Session']> = ResolversObject<{
  info?: Resolver<Maybe<ResolversTypes['UserInfo']>, ParentType, ContextType>;
  isAdmin?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isLoggedIn?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
}>;

export type SessionCloseEventResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['SessionCloseEvent'] = ResolversParentTypes['SessionCloseEvent']> = ResolversObject<{
  reason?: Resolver<ResolversTypes['SessionCloseReason'], ParentType, ContextType>;
  sessionId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
}>;

export type SessionInfoResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['SessionInfo'] = ResolversParentTypes['SessionInfo']> = ResolversObject<{
  realm?: Resolver<ResolversTypes['ObjUUIDAndName'], ParentType, ContextType>;
  role?: Resolver<ResolversTypes['ObjUUIDAndName'], ParentType, ContextType>;
  user?: Resolver<ResolversTypes['ObjUUIDAndName'], ParentType, ContextType>;
}>;

export type SetResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['Set'] = ResolversParentTypes['Set']> = ResolversObject<{
  createdAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  devices?: Resolver<Array<ResolversTypes['ObjectDescriptor']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isSystemManaged?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  modifiedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['RealmObjectType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SharedViewsUpdateEventResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['SharedViewsUpdateEvent'] = ResolversParentTypes['SharedViewsUpdateEvent']> = ResolversObject<{
  modifiedBy?: Resolver<ResolversTypes['ModifiedByInfo'], ParentType, ContextType>;
  sharedViews?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
}>;

export type SocketEventResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['SocketEvent'] = ResolversParentTypes['SocketEvent']> = ResolversObject<{
  timeStamp?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['SocketEventType'], ParentType, ContextType>;
}>;

export type SoftwareInfoResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['SoftwareInfo'] = ResolversParentTypes['SoftwareInfo']> = ResolversObject<{
  lastUpdateSucceeded?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  lastUpdateTime?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  updateAvailable?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  version?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
}>;

export type SolidConfigUpdateEventResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['SolidConfigUpdateEvent'] = ResolversParentTypes['SolidConfigUpdateEvent']> = ResolversObject<{
  solidConfig?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
}>;

export type SolidConfigurationResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['SolidConfiguration'] = ResolversParentTypes['SolidConfiguration']> = ResolversObject<{
  activities?: Resolver<Array<ResolversTypes['ActivityId']>, ParentType, ContextType>;
  config?: Resolver<ResolversTypes['JSON'], ParentType, ContextType>;
  views?: Resolver<Array<ResolversTypes['ViewConfig']>, ParentType, ContextType>;
  widgets?: Resolver<Array<ResolversTypes['WidgetConfig']>, ParentType, ContextType>;
}>;

export type SolidVisualConfigResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['SolidVisualConfig'] = ResolversParentTypes['SolidVisualConfig']> = ResolversObject<{
  activities?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  config?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  views?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  widgets?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
}>;

export type StatTimeResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['StatTime'] = ResolversParentTypes['StatTime']> = ResolversObject<{
  avg?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  max?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  min?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
}>;

export type StatusReportResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['StatusReport'] = ResolversParentTypes['StatusReport']> = ResolversObject<{
  time?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['StatusMetric'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type StoragePoolResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['StoragePool'] = ResolversParentTypes['StoragePool']> = ResolversObject<{
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  ttlHours?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
}>;

export type StorageUsageResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['StorageUsage'] = ResolversParentTypes['StorageUsage']> = ResolversObject<{
  free?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  localStorageVolume?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  requiredVolume?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type StreamShareResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['StreamShare'] = ResolversParentTypes['StreamShare']> = ResolversObject<{
  enabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['HealthStatus']>, ParentType, ContextType>;
  streamSize?: Resolver<Maybe<ResolversTypes['MediaStreamSize']>, ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
}>;

export type SubStoragePoolResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['SubStoragePool'] = ResolversParentTypes['SubStoragePool']> = ResolversObject<{
  features?: Resolver<Array<ResolversTypes['Feature']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  ttlHrs?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
}>;

export type SubscriptionResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['Subscription'] = ResolversParentTypes['Subscription']> = ResolversObject<{
  aodUpdate?: SubscriptionResolver<Maybe<Array<ResolversTypes['AodRequest']>>, "aodUpdate", ParentType, ContextType, RequireFields<SubscriptionAodUpdateArgs, 'filter'>>;
  auditEntries?: SubscriptionResolver<ResolversTypes['AuditEntryEvent'], "auditEntries", ParentType, ContextType, RequireFields<SubscriptionAuditEntriesArgs, 'filter'>>;
  hierarchyUpdate?: SubscriptionResolver<ResolversTypes['LabelOrHierarchyUpdate'], "hierarchyUpdate", ParentType, ContextType>;
  imageMapUpdate?: SubscriptionResolver<ResolversTypes['ImageMapUpdateNotification'], "imageMapUpdate", ParentType, ContextType, RequireFields<SubscriptionImageMapUpdateArgs, 'version'>>;
  labelUpdate?: SubscriptionResolver<ResolversTypes['LabelOrHierarchyUpdate'], "labelUpdate", ParentType, ContextType>;
  objectUpdate?: SubscriptionResolver<ResolversTypes['ObjectUpdateEvent'], "objectUpdate", ParentType, ContextType, Partial<SubscriptionObjectUpdateArgs>>;
  sessionClose?: SubscriptionResolver<ResolversTypes['SessionCloseEvent'], "sessionClose", ParentType, ContextType>;
  sharedViewsUpdate?: SubscriptionResolver<ResolversTypes['SharedViewsUpdateEvent'], "sharedViewsUpdate", ParentType, ContextType>;
  solidConfigUpdate?: SubscriptionResolver<ResolversTypes['SolidConfigUpdateEvent'], "solidConfigUpdate", ParentType, ContextType>;
  targetUpdate?: SubscriptionResolver<ResolversTypes['TargetNotification'], "targetUpdate", ParentType, ContextType, RequireFields<SubscriptionTargetUpdateArgs, 'filter'>>;
}>;

export type SystemParametersResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['SystemParameters'] = ResolversParentTypes['SystemParameters']> = ResolversObject<{
  geoDefaultPosition?: Resolver<Maybe<ResolversTypes['DefaultGeoPosition']>, ParentType, ContextType>;
  googleMapsApiKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  googleYouTubeApiKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  googleYouTubePlaylistId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mapDefaultLayer?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  solidAppVersion?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatesHost?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
}>;

export type SystemStatusInfoResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['SystemStatusInfo'] = ResolversParentTypes['SystemStatusInfo']> = ResolversObject<{
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  reasons?: Resolver<Array<ResolversTypes['SystemStatusReason']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['SystemStatus'], ParentType, ContextType>;
}>;

export type SystemStatusReasonResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['SystemStatusReason'] = ResolversParentTypes['SystemStatusReason']> = ResolversObject<{
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  object?: Resolver<Maybe<ResolversTypes['SystemStatusReasonObject']>, ParentType, ContextType>;
  options?: Resolver<Maybe<ResolversTypes['JSONObject']>, ParentType, ContextType>;
}>;

export type SystemStatusReasonObjectResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['SystemStatusReasonObject'] = ResolversParentTypes['SystemStatusReasonObject']> = ResolversObject<{
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
}>;

export type TargetResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['Target'] = ResolversParentTypes['Target']> = ResolversObject<{
  classification?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['JSONObject']>, ParentType, ContextType>;
  modifiedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  position?: Resolver<ResolversTypes['LatLng'], ParentType, ContextType>;
  realmId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  risk?: Resolver<Maybe<ResolversTypes['TargetRisk']>, ParentType, ContextType>;
  targetId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  track?: Resolver<Maybe<Array<ResolversTypes['LatLng']>>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['TargetType']>, ParentType, ContextType>;
  witnesses?: Resolver<Array<ResolversTypes['ID']>, ParentType, ContextType>;
}>;

export type TargetNotificationResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['TargetNotification'] = ResolversParentTypes['TargetNotification']> = ResolversObject<{
  classification?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['JSONObject']>, ParentType, ContextType>;
  modifiedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  position?: Resolver<ResolversTypes['LatLng'], ParentType, ContextType>;
  realmId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  risk?: Resolver<Maybe<ResolversTypes['TargetRisk']>, ParentType, ContextType>;
  targetId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['TargetType']>, ParentType, ContextType>;
  witnesses?: Resolver<Array<ResolversTypes['ID']>, ParentType, ContextType>;
}>;

export interface UuidScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['UUID'], any> {
  name: 'UUID';
}

export type UpdateResultResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['UpdateResult'] = ResolversParentTypes['UpdateResult']> = ResolversObject<{
  updated?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  warning?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  warningFields?: Resolver<Maybe<Array<ResolversTypes['WarningField']>>, ParentType, ContextType>;
}>;

export interface UploadScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Upload'], any> {
  name: 'Upload';
}

export type UserResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['User'] = ResolversParentTypes['User']> = ResolversObject<{
  createdAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  emailConfirmed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  groups?: Resolver<Array<ResolversTypes['Group']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  loggedOnAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  modifiedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  sendNotification?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['RealmObjectType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UserDataResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['UserData'] = ResolversParentTypes['UserData']> = ResolversObject<{
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  isAdmin?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  solidConfiguration?: Resolver<ResolversTypes['SolidConfiguration'], ParentType, ContextType>;
  solidVisualConfig?: Resolver<ResolversTypes['SolidVisualConfig'], ParentType, ContextType>;
}>;

export type UserInfoResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['UserInfo'] = ResolversParentTypes['UserInfo']> = ResolversObject<{
  realm?: Resolver<ResolversTypes['CurrentRealm'], ParentType, ContextType>;
  user?: Resolver<ResolversTypes['UserData'], ParentType, ContextType>;
}>;

export type VaeConfigBriefResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['VaeConfigBrief'] = ResolversParentTypes['VaeConfigBrief']> = ResolversObject<{
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
}>;

export type VaeConfigFullResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['VaeConfigFull'] = ResolversParentTypes['VaeConfigFull']> = ResolversObject<{
  configuration?: Resolver<ResolversTypes['JSONObject'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
}>;

export type VaeFeatureResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['VaeFeature'] = ResolversParentTypes['VaeFeature']> = ResolversObject<{
  exclusive?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  order?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
}>;

export type VaeFpsResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['VaeFps'] = ResolversParentTypes['VaeFps']> = ResolversObject<{
  engineFps?: Resolver<ResolversTypes['MinMax'], ParentType, ContextType>;
  requestedFps?: Resolver<ResolversTypes['MinMax'], ParentType, ContextType>;
}>;

export type VaeReasonStatusResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['VaeReasonStatus'] = ResolversParentTypes['VaeReasonStatus']> = ResolversObject<{
  reason?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['VaeStatus'], ParentType, ContextType>;
  vae?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
}>;

export type VaeStatFpsResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['VaeStatFps'] = ResolversParentTypes['VaeStatFps']> = ResolversObject<{
  avg?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  max?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  min?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  range?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
}>;

export type VaeStatisticResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['VaeStatistic'] = ResolversParentTypes['VaeStatistic']> = ResolversObject<{
  avgLatency?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  eps?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  fps?: Resolver<Maybe<Array<ResolversTypes['VaeStatFps']>>, ParentType, ContextType>;
  metadataBps?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  reason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  restarts?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['VaeStatus']>, ParentType, ContextType>;
  uptime?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
}>;

export type VaeUpdateResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['VaeUpdate'] = ResolversParentTypes['VaeUpdate']> = ResolversObject<{
  log?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['VaeUpdateStatus'], ParentType, ContextType>;
  version?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
}>;

export type ViewConfigResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['ViewConfig'] = ResolversParentTypes['ViewConfig']> = ResolversObject<{
  config?: Resolver<ResolversTypes['JSON'], ParentType, ContextType>;
  viewId?: Resolver<ResolversTypes['ViewId'], ParentType, ContextType>;
}>;

export type WarningFieldResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['WarningField'] = ResolversParentTypes['WarningField']> = ResolversObject<{
  field?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
}>;

export type WidgetConfigResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['WidgetConfig'] = ResolversParentTypes['WidgetConfig']> = ResolversObject<{
  config?: Resolver<ResolversTypes['JSON'], ParentType, ContextType>;
  widgetId?: Resolver<ResolversTypes['WidgetId'], ParentType, ContextType>;
}>;

export type WidgetIdResolvers = { AdminAnalyticsDashboard?: 'AdminAnalyticsDashboard', AdminAvatars?: 'AdminAvatars', AdminDevices?: 'AdminDevices', AdminGateways?: 'AdminGateways', AdminSensors?: 'AdminSensors', ArchiveEventList?: 'ArchiveEventList', ArchiveTargetLog?: 'ArchiveTargetLog', ArchiveViewer?: 'ArchiveViewer', AvatarProvision?: 'AvatarProvision', CameraLive?: 'CameraLive', CameraLiveDebugger?: 'CameraLiveDebugger', CameraTours?: 'CameraTours', DeviceList?: 'DeviceList', DeviceStatus?: 'DeviceStatus', DownloadManager?: 'DownloadManager', EventDetails?: 'EventDetails', EventList?: 'EventList', EventVideo?: 'EventVideo', GeoMap: 'GEOMap', GeoTours?: 'GeoTours', Groups?: 'Groups', HierarchyEdit?: 'HierarchyEdit', ImageMap?: 'ImageMap', LabelEdit?: 'LabelEdit', LinkProvision?: 'LinkProvision', LiveTargetLog?: 'LiveTargetLog', ManageAvatars?: 'ManageAvatars', NotificationPolicies?: 'NotificationPolicies', Policies?: 'Policies', QuickStart?: 'QuickStart', RealmSettings?: 'RealmSettings', Reports?: 'Reports', Schedules?: 'Schedules', Sets?: 'Sets', Subscription?: 'Subscription', Timeline?: 'Timeline', TrainingVideos?: 'TrainingVideos', URL?: 'URL', Users?: 'Users', VideoTouring?: 'VideoTouring', VideoWalls?: 'VideoWalls', Vmx: 'VMX', WatchlistFacial?: 'WatchlistFacial', WatchlistLPR?: 'WatchlistLPR', Zones?: 'Zones' };

export type WidgetInfoResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['WidgetInfo'] = ResolversParentTypes['WidgetInfo']> = ResolversObject<{
  index?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  propsJSON?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  widgetId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
}>;

export type WorkspaceResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['Workspace'] = ResolversParentTypes['Workspace']> = ResolversObject<{
  creatingViews?: Resolver<Maybe<Array<ResolversTypes['CreatingView']>>, ParentType, ContextType>;
  localViewsJSON?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sharedViewsJSON?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  solidConfigJSON?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
}>;

export type ZoneResolvers<ContextType = ClientContext, ParentType extends ResolversParentTypes['Zone'] = ResolversParentTypes['Zone']> = ResolversObject<{
  createdAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  devices?: Resolver<Array<ResolversTypes['ObjectDescriptor']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  modifiedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['RealmObjectType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type Resolvers<ContextType = ClientContext> = ResolversObject<{
  AccessLevel?: AccessLevelResolvers<ContextType>;
  Action?: ActionResolvers<ContextType>;
  AodRequest?: AodRequestResolvers<ContextType>;
  AodRequestFiles?: AodRequestFilesResolvers<ContextType>;
  AodRequestFilesListEntry?: AodRequestFilesListEntryResolvers<ContextType>;
  AppStore?: AppStoreResolvers<ContextType>;
  ArchiveBoundary?: ArchiveBoundaryResolvers<ContextType>;
  ArchiveCoverage?: ArchiveCoverageResolvers<ContextType>;
  ArchiveCoverageItem?: ArchiveCoverageItemResolvers<ContextType>;
  ArchiveCoverageTTL?: ArchiveCoverageTtlResolvers<ContextType>;
  AspectHealth?: AspectHealthResolvers<ContextType>;
  AssociatedGatewayDevice?: AssociatedGatewayDeviceResolvers<ContextType>;
  AuditCategory?: AuditCategoryResolvers<ContextType>;
  AuditEntry?: AuditEntryResolvers<ContextType>;
  AuditEntryEvent?: AuditEntryEventResolvers<ContextType>;
  AuditSnapshot?: AuditSnapshotResolvers<ContextType>;
  AvatarMetric?: AvatarMetricResolvers<ContextType>;
  BrandInfo?: BrandInfoResolvers<ContextType>;
  Branding?: BrandingResolvers<ContextType>;
  BrandingAttribute?: BrandingAttributeResolvers<ContextType>;
  CameraLog?: CameraLogResolvers<ContextType>;
  CameraMetric?: CameraMetricResolvers<ContextType>;
  CameraTour?: CameraTourResolvers<ContextType>;
  CameraTourStep?: CameraTourStepResolvers<ContextType>;
  CameraView?: CameraViewResolvers<ContextType>;
  ChannelBenchmark?: ChannelBenchmarkResolvers<ContextType>;
  ChannelStatistics?: ChannelStatisticsResolvers<ContextType>;
  CreateResult?: CreateResultResolvers<ContextType>;
  CreatingView?: CreatingViewResolvers<ContextType>;
  Credentials?: CredentialsResolvers<ContextType>;
  CurrentRealm?: CurrentRealmResolvers<ContextType>;
  DFA_Avatar?: Dfa_AvatarResolvers<ContextType>;
  DFA_Gateway?: Dfa_GatewayResolvers<ContextType>;
  DFA_Media?: Dfa_MediaResolvers<ContextType>;
  DFA_PTZ?: Dfa_PtzResolvers<ContextType>;
  DFA_Sensor?: Dfa_SensorResolvers<ContextType>;
  DFA_VAE?: Dfa_VaeResolvers<ContextType>;
  DateTime?: GraphQLScalarType;
  DefaultGeoPosition?: DefaultGeoPositionResolvers<ContextType>;
  Device?: DeviceResolvers<ContextType>;
  DeviceBaseConfig?: DeviceBaseConfigResolvers<ContextType>;
  DeviceFunctionalAspect?: DeviceFunctionalAspectResolvers<ContextType>;
  DeviceProbe?: DeviceProbeResolvers<ContextType>;
  DeviceStorageConfig?: DeviceStorageConfigResolvers<ContextType>;
  DeviceTemplate?: DeviceTemplateResolvers<ContextType>;
  DeviceTemplateModel?: DeviceTemplateModelResolvers<ContextType>;
  EncryptionKeyInfo?: EncryptionKeyInfoResolvers<ContextType>;
  ErrorInfo?: ErrorInfoResolvers<ContextType>;
  EventInfo?: EventInfoResolvers<ContextType>;
  Feature?: FeatureResolvers<ContextType>;
  FeatureDesc?: FeatureDescResolvers<ContextType>;
  FileInfo?: FileInfoResolvers<ContextType>;
  FunctionalAspectTemplate?: FunctionalAspectTemplateResolvers<ContextType>;
  GEOLayer?: GeoLayerResolvers<ContextType>;
  GEOLayers?: GeoLayersResolvers<ContextType>;
  GatewayDirectoriesProbe?: GatewayDirectoriesProbeResolvers<ContextType>;
  GatewayDirectory?: GatewayDirectoryResolvers<ContextType>;
  GatewayEvent?: GatewayEventResolvers<ContextType>;
  GatewayProbe?: GatewayProbeResolvers<ContextType>;
  GatewayProbeDevice?: GatewayProbeDeviceResolvers<ContextType>;
  GatewayProbeEvent?: GatewayProbeEventResolvers<ContextType>;
  GenericObject?: GenericObjectResolvers<ContextType>;
  GeoMarkerClusterConfig?: GeoMarkerClusterConfigResolvers<ContextType>;
  GeoTour?: GeoTourResolvers<ContextType>;
  GeoTourPoint?: GeoTourPointResolvers<ContextType>;
  GrafanaDashboard?: GrafanaDashboardResolvers<ContextType>;
  Group?: GroupResolvers<ContextType>;
  Gui?: GuiResolvers<ContextType>;
  Hierarchy?: HierarchyResolvers<ContextType>;
  HierarchyLevel?: HierarchyLevelResolvers<ContextType>;
  IdentityAttribute?: IdentityAttributeResolvers<ContextType>;
  ImageMap?: ImageMapResolvers<ContextType>;
  ImageMapConfig?: ImageMapConfigResolvers<ContextType>;
  ImageMapLayer?: ImageMapLayerResolvers<ContextType>;
  ImageMapObject?: ImageMapObjectResolvers<ContextType>;
  ImageMapSet?: ImageMapSetResolvers<ContextType>;
  ImageMapUpdateNotification?: ImageMapUpdateNotificationResolvers<ContextType>;
  JSON?: GraphQLScalarType;
  JSONObject?: GraphQLScalarType;
  KeyValue?: KeyValueResolvers<ContextType>;
  Label?: LabelResolvers<ContextType>;
  LabelObject?: LabelObjectResolvers<ContextType>;
  LabelOrHierarchyUpdate?: LabelOrHierarchyUpdateResolvers<ContextType>;
  Language?: LanguageResolvers<ContextType>;
  Languages?: LanguagesResolvers<ContextType>;
  LatLng?: LatLngResolvers<ContextType>;
  License?: LicenseResolvers<ContextType>;
  LocalStorage?: LocalStorageResolvers<ContextType>;
  MetaClassifier?: MetaClassifierResolvers<ContextType>;
  MetaEntry?: MetaEntryResolvers<ContextType>;
  MinMax?: MinMaxResolvers<ContextType>;
  ModifiedByInfo?: ModifiedByInfoResolvers<ContextType>;
  Mutation?: MutationResolvers<ContextType>;
  NetworkConnectDescriptor?: NetworkConnectDescriptorResolvers<ContextType>;
  NumericReport?: NumericReportResolvers<ContextType>;
  ObjUUID?: ObjUuidResolvers<ContextType>;
  ObjUUIDAndName?: ObjUuidAndNameResolvers<ContextType>;
  ObjectDescriptor?: ObjectDescriptorResolvers<ContextType>;
  ObjectUpdateEvent?: ObjectUpdateEventResolvers<ContextType>;
  OnvifServiceConfig?: OnvifServiceConfigResolvers<ContextType>;
  OnvifServiceStatus?: OnvifServiceStatusResolvers<ContextType>;
  Owner?: OwnerResolvers<ContextType>;
  Policy?: PolicyResolvers<ContextType>;
  PolicyStatement?: PolicyStatementResolvers<ContextType>;
  PoolLocalStorage?: PoolLocalStorageResolvers<ContextType>;
  Position?: PositionResolvers<ContextType>;
  PtzAbsArgs?: PtzAbsArgsResolvers<ContextType>;
  PtzLock?: PtzLockResolvers<ContextType>;
  PtzLockProlongation?: PtzLockProlongationResolvers<ContextType>;
  PtzLockResult?: PtzLockResultResolvers<ContextType>;
  PtzPosition?: PtzPositionResolvers<ContextType>;
  PtzStatus?: PtzStatusResolvers<ContextType>;
  PtzTcpAddress?: PtzTcpAddressResolvers<ContextType>;
  QortexMappedZone?: QortexMappedZoneResolvers<ContextType>;
  QortexZone?: QortexZoneResolvers<ContextType>;
  QortexZonePoint?: QortexZonePointResolvers<ContextType>;
  Query?: QueryResolvers<ContextType>;
  Realm?: RealmResolvers<ContextType>;
  RealmObject?: RealmObjectResolvers<ContextType>;
  RealmSubscription?: RealmSubscriptionResolvers<ContextType>;
  Report?: ReportResolvers<ContextType>;
  Reseller?: ResellerResolvers<ContextType>;
  Schedule?: ScheduleResolvers<ContextType>;
  ScheduleAction?: ScheduleActionResolvers<ContextType>;
  ScheduleActionTemplate?: ScheduleActionTemplateResolvers<ContextType>;
  ScheduleTask?: ScheduleTaskResolvers<ContextType>;
  SensorEvent?: SensorEventResolvers<ContextType>;
  Session?: SessionResolvers<ContextType>;
  SessionCloseEvent?: SessionCloseEventResolvers<ContextType>;
  SessionInfo?: SessionInfoResolvers<ContextType>;
  Set?: SetResolvers<ContextType>;
  SharedViewsUpdateEvent?: SharedViewsUpdateEventResolvers<ContextType>;
  SocketEvent?: SocketEventResolvers<ContextType>;
  SoftwareInfo?: SoftwareInfoResolvers<ContextType>;
  SolidConfigUpdateEvent?: SolidConfigUpdateEventResolvers<ContextType>;
  SolidConfiguration?: SolidConfigurationResolvers<ContextType>;
  SolidVisualConfig?: SolidVisualConfigResolvers<ContextType>;
  StatTime?: StatTimeResolvers<ContextType>;
  StatusReport?: StatusReportResolvers<ContextType>;
  StoragePool?: StoragePoolResolvers<ContextType>;
  StorageUsage?: StorageUsageResolvers<ContextType>;
  StreamShare?: StreamShareResolvers<ContextType>;
  SubStoragePool?: SubStoragePoolResolvers<ContextType>;
  Subscription?: SubscriptionResolvers<ContextType>;
  SystemParameters?: SystemParametersResolvers<ContextType>;
  SystemStatusInfo?: SystemStatusInfoResolvers<ContextType>;
  SystemStatusReason?: SystemStatusReasonResolvers<ContextType>;
  SystemStatusReasonObject?: SystemStatusReasonObjectResolvers<ContextType>;
  Target?: TargetResolvers<ContextType>;
  TargetNotification?: TargetNotificationResolvers<ContextType>;
  UUID?: GraphQLScalarType;
  UpdateResult?: UpdateResultResolvers<ContextType>;
  Upload?: GraphQLScalarType;
  User?: UserResolvers<ContextType>;
  UserData?: UserDataResolvers<ContextType>;
  UserInfo?: UserInfoResolvers<ContextType>;
  VaeConfigBrief?: VaeConfigBriefResolvers<ContextType>;
  VaeConfigFull?: VaeConfigFullResolvers<ContextType>;
  VaeFeature?: VaeFeatureResolvers<ContextType>;
  VaeFps?: VaeFpsResolvers<ContextType>;
  VaeReasonStatus?: VaeReasonStatusResolvers<ContextType>;
  VaeStatFps?: VaeStatFpsResolvers<ContextType>;
  VaeStatistic?: VaeStatisticResolvers<ContextType>;
  VaeUpdate?: VaeUpdateResolvers<ContextType>;
  ViewConfig?: ViewConfigResolvers<ContextType>;
  WarningField?: WarningFieldResolvers<ContextType>;
  WidgetConfig?: WidgetConfigResolvers<ContextType>;
  WidgetId?: WidgetIdResolvers;
  WidgetInfo?: WidgetInfoResolvers<ContextType>;
  Workspace?: WorkspaceResolvers<ContextType>;
  Zone?: ZoneResolvers<ContextType>;
}>;

export type DirectiveResolvers<ContextType = ClientContext> = ResolversObject<{
  auth?: AuthDirectiveResolver<any, any, ContextType>;
  client?: ClientDirectiveResolver<any, any, ContextType>;
  complexity?: ComplexityDirectiveResolver<any, any, ContextType>;
  key?: KeyDirectiveResolver<any, any, ContextType>;
  provides?: ProvidesDirectiveResolver<any, any, ContextType>;
}>;
